
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("3sora", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $24737abaf730fa97$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("3avtZ");

var $jD5no = parcelRequire("jD5no");

var $lf2Au = parcelRequire("lf2Au");

var $lL5b5 = parcelRequire("lL5b5");

var $8J6rn = parcelRequire("8J6rn");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $pa9q9 = parcelRequire("pa9q9");

var $cfDZ3 = parcelRequire("cfDZ3");

var $5rqex = parcelRequire("5rqex");

var $14XJw = parcelRequire("14XJw");

var $kkNtb = parcelRequire("kkNtb");

var $95LwL = parcelRequire("95LwL");

var $6juLJ = parcelRequire("6juLJ");

var $cf7yQ = parcelRequire("cf7yQ");

var $lXCei = parcelRequire("lXCei");

var $4dRjY = parcelRequire("4dRjY");

var $6XsPQ = parcelRequire("6XsPQ");

var $dZw8H = parcelRequire("dZw8H");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");

var $2tT7R = parcelRequire("2tT7R");

var $DVljb = parcelRequire("DVljb");

var $l8ruj = parcelRequire("l8ruj");

var $bPvna = parcelRequire("bPvna");

var $c9lD2 = parcelRequire("c9lD2");

var $fnaRp = parcelRequire("fnaRp");

var $2kVZn = parcelRequire("2kVZn");
const $24737abaf730fa97$var$PeopleProfilesShell = ({ history: history })=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const [{ data: gspData }, { fetchState: fetchState }] = (0, $6juLJ.useGettingStartedPanelState)();
    (0, $5uXOq.useEffect)(()=>{
        if (gspData === undefined) fetchState();
    }, [
        gspData,
        fetchState
    ]);
    const gspProjectId = gspData?.properties?.user?.projectId;
    const { isFirstProject: isFirstProject, isFirstProjectItsm: isFirstProjectItsm } = (0, $95LwL.useIsFirstProjectITSM)(gspProjectId);
    /**
   * Initializes the active tab to 'alerts' within the Getting Started Panel
   * specifically for NPLE for ITSM experiment.
   */ (0, $lXCei.useInitializeActiveTab)('alerts', gspProjectId);
    const addFlag = (0, $5uXOq.useMemo)(()=>(0, $c9lD2.createShowFlagHandler)(showFlag, dismissFlag), [
        showFlag,
        dismissFlag
    ]);
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const atlassianAccountId = (0, $90yGq.useAccountId)();
    const cloudId = (0, $koeKL.useCloudId)();
    const environment = (0, $2tT7R.useEnvironment)();
    const locale = (0, $DVljb.useLocale)();
    const previousSubProduct = (0, $cfDZ3.getPreviousSubProduct)();
    // legacy invite people modal requirements
    const invitePeopleExperimentalFeatures = {
        inviteThirdPartyTeams: 'variation'
    };
    const { openModal: openModal } = (0, $2kVZn.useInvitePeopleModal)({
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        continueUrl: window.location.href,
        enableThirdParty: true,
        experimentalFeatures: invitePeopleExperimentalFeatures,
        displayInfiSpotlight: true,
        resourceAri: `ari:cloud:jira::site/${cloudId}`,
        showFlag: addFlag,
        source: 'peopleDirectory',
        subProduct: previousSubProduct === 'unknown' || previousSubProduct === null ? undefined : previousSubProduct
    });
    const invitePeopleHandlers = (0, $5uXOq.useMemo)(()=>({
            handleOpenDialog: openModal
        }), [
        openModal
    ]);
    const { shouldUseJSM: shouldUseJSM } = (0, $8J6rn.useOgTenantInfo)();
    const { data: rovoEntitlement } = (0, $kkNtb.useRovoEntitlementResource)();
    const isRovoEnabled = rovoEntitlement?.isRovoLLMEnabled;
    if (!atlassianAccountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lL5b5.default), null);
    const { push: push, replace: replace } = history;
    const productFeatureFlags = {
        'event-on-call-consolidation_s97c8': true,
        'event-on-call-consolidation-state': shouldUseJSM
    };
    const isNpleForItsmEnabled = isFirstProject && isFirstProjectItsm && (0, $6s1PB.expValEquals)('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "people-profiles"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4dRjY.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
        id: "people-profiles"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lf2Au.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bPvna.default), {
        appName: "jira-directory",
        contextSpaPaths: [
            '/browse',
            '/jira',
            '/projects'
        ],
        contextEntryPoint: "/jira/people",
        env: environment === 'prod' ? 'prod' : 'stg',
        locale: locale,
        // @ts-expect-error - TS2322 - Type '(flagFromPTC: FlagFromPTC) => void' is not assignable to type '(props: FlagProps) => void'.
        addFlag: addFlag,
        push: push,
        replace: replace,
        docTitle: {
            end: 'Jira'
        },
        history: history,
        cloudId: cloudId,
        orgId: orgId,
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'JiraSubProduct | undefined'.
        subProduct: previousSubProduct,
        invitePeopleHandlers: invitePeopleHandlers,
        productFeatureFlags: productFeatureFlags,
        isAIEnabled: !!isRovoEnabled
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5rqex.default), {
        appName: "people-profiles",
        isExpectedToHaveSsr: false,
        // @ts-expect-error - TS2769 - No overload matches this call.
        metric: (0, $fnaRp.peopleProfilesPageLoad)
    }), (0, $4R6GH.fg)('set-embedded-directory-spa-ready') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReady), null))), isNpleForItsmEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cf7yQ.JsdGettingStartedPanelShouldRender), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cf7yQ.JsdGettingStartedPanelOpenButton), null)));
};
const $24737abaf730fa97$var$PeopleProfiles = ()=>{
    return(// @ts-expect-error - TS2739 - Type '{ children: (history: any) => Element; }' is missing the following properties from type 'RouteContext': location, query, route, match, action
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6XsPQ.HistoryAdapter), null, (history)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2kVZn.InvitePeopleModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($24737abaf730fa97$var$PeopleProfilesShell, {
            history: history
        }))));
};
var $24737abaf730fa97$export$2e2bcd8739ae039 = $24737abaf730fa97$var$PeopleProfiles;

});
parcelRegister("lL5b5", function(module, exports) {

$parcel$export(module.exports, "default", () => $07c2532655d93687$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $j0xEB = parcelRequire("j0xEB");

var $j2Jlg = parcelRequire("j2Jlg");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$07c2532655d93687$export$2e2bcd8739ae039 = ()=>{
    const { href: href = null } = (0, $j0xEB.default)() || {};
    if (href && !href.includes('login.jsp')) {
        const encodedRedirectUrl = encodeURIComponent(href);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j2Jlg.default), {
            url: `/login.jsp?os_destination=${encodedRedirectUrl}`
        });
    }
    return null;
};

});
parcelRegister("j2Jlg", function(module, exports) {

$parcel$export(module.exports, "default", () => $773e6f988af77e5c$export$2e2bcd8739ae039);

var $gKZoD = parcelRequire("gKZoD");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$773e6f988af77e5c$export$2e2bcd8739ae039 = ({ url: url })=>{
    (0, $gKZoD.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.assign(url);
    return null;
};

});


parcelRegister("5rqex", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $ab527e70454bab7e$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $ab527e70454bab7e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $ab527e70454bab7e$export$9b3029ee6188a41f);

var $5uXOq = parcelRequire("5uXOq");

var $99gkn = parcelRequire("99gkn");

var $aOr3t = parcelRequire("aOr3t");

var $1u4q7 = parcelRequire("1u4q7");

var $1AZST = parcelRequire("1AZST");

var $6G6w0 = parcelRequire("6G6w0");

var $3wLoG = parcelRequire("3wLoG");

var $gtdbK = parcelRequire("gtdbK");

var $zbAs4 = parcelRequire("zbAs4");

var $3B7oW = parcelRequire("3B7oW");
const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $zbAs4.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $gtdbK.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $3B7oW.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99gkn.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOr3t.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3wLoG.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $1u4q7.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6G6w0.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("aOr3t", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $a3e67858f0c2f8da$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$d93d677ef2f33c5c);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $1tcYS.default));
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    (0, $5uXOq.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
        (0, $bFU4G.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("6G6w0", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $84d0d168ebb35c8a$export$575e93c0f9905999);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $21pfT = parcelRequire("21pfT");

var $x9xyg = parcelRequire("x9xyg");

var $7N30e = parcelRequire("7N30e");

var $4dRjY = parcelRequire("4dRjY");

var $2SVPM = parcelRequire("2SVPM");

var $6b6Tk = parcelRequire("6b6Tk");

const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.stopLowPriorityEventDelay)();
};
class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $21pfT.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_END');
        (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("4dRjY", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $9953c23a4f71adac$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $9953c23a4f71adac$export$2a999c5f84501025);

var $x9xyg = parcelRequire("x9xyg");
const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
        (0, $x9xyg.setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("3wLoG", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $bc9c50f4292c4530$export$d91154f099475c5);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1AZST = parcelRequire("1AZST");
class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $1AZST.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("gtdbK", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $9088c71f7c9189f4$export$bf239ac2bfb04967);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("zbAs4", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $30d390cd1767d57f$export$e63862cd888fe05a);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $1AZST = parcelRequire("1AZST");
var $49z18 = parcelRequire("49z18");
async function $30d390cd1767d57f$export$e63862cd888fe05a() {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $1AZST.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $49z18.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("3B7oW", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $afa764d83f81f55e$export$f00f1e874ce869e9);

var $1u4q7 = parcelRequire("1u4q7");

var $y7eb2 = parcelRequire("y7eb2");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $y7eb2.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
            $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


parcelRegister("95LwL", function(module, exports) {

$parcel$export(module.exports, "useIsFirstProjectITSM", () => $695acf2ddfa70d4a$export$852fe39748ba826d);

var $5uXOq = parcelRequire("5uXOq");

var $dAfqg = parcelRequire("dAfqg");

var $58GFP = parcelRequire("58GFP");

var $6s1PB = parcelRequire("6s1PB");

var $3HwlS = parcelRequire("3HwlS");

var $iVfVP = parcelRequire("iVfVP");
const $695acf2ddfa70d4a$var$useIsFirstProjectITSMOld = (inputProjectId)=>{
    const { data: containerContext, loading: loading } = (0, $dAfqg.useProjectContext)();
    const currentProjectId = inputProjectId || containerContext?.projectId;
    const [isFirstProject, setIsFirstProject] = (0, $5uXOq.useState)(false);
    const [isFirstProjectItsm, setIsFirstProjectItsm] = (0, $5uXOq.useState)(false);
    const [isStateLoading, setStateLoading] = (0, $5uXOq.useState)(true);
    const { error: isFirstProjectError, firstProject: firstProject } = (0, $iVfVP.useFirstProjectDetails)();
    (0, $5uXOq.useEffect)(()=>{
        if (currentProjectId && !isFirstProjectError && firstProject) {
            setIsFirstProject(firstProject.projectId === `${currentProjectId}`);
            setIsFirstProjectItsm(firstProject.projectTemplateKey === (0, $58GFP.IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY));
            setStateLoading(false);
        } else if (isFirstProjectError) setStateLoading(false);
    }, [
        currentProjectId,
        firstProject,
        isFirstProjectError,
        setStateLoading
    ]);
    const memoizedValue = (0, $5uXOq.useMemo)(()=>({
            isLoading: loading || isStateLoading,
            isFirstProject: isFirstProject,
            isFirstProjectItsm: isFirstProjectItsm,
            isFirstProjectError: isFirstProjectError
        }), [
        isFirstProject,
        isFirstProjectItsm,
        isFirstProjectError,
        loading,
        isStateLoading
    ]);
    return memoizedValue;
};
const $695acf2ddfa70d4a$var$useIsFirstProjectITSMNew = (inputProjectId)=>{
    const { data: containerContext, loading: loading } = (0, $dAfqg.useProjectContext)();
    const currentProjectId = inputProjectId || containerContext?.projectId;
    const { data: { error: isFirstProjectError, firstProject: firstProject }, loading: isFirstProjectDetailsLoading } = (0, $iVfVP.useFirstProjectDetailsNew)();
    const memoizedValue = (0, $5uXOq.useMemo)(()=>({
            isLoading: loading || isFirstProjectDetailsLoading,
            isFirstProject: firstProject?.projectId === `${currentProjectId}`,
            isFirstProjectItsm: firstProject?.projectTemplateKey === (0, $58GFP.IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY),
            isFirstProjectError: isFirstProjectError
        }), [
        loading,
        firstProject,
        isFirstProjectDetailsLoading,
        isFirstProjectError,
        currentProjectId
    ]);
    return memoizedValue;
};
const $695acf2ddfa70d4a$export$852fe39748ba826d = (inputProjectId)=>{
    return (0, $3HwlS.getWillShowNav4)() && (0, $6s1PB.expVal)('hot-113350-ssr-jsm-project-menu-fix', 'isEnabled', false) ? $695acf2ddfa70d4a$var$useIsFirstProjectITSMNew(inputProjectId) : $695acf2ddfa70d4a$var$useIsFirstProjectITSMOld(inputProjectId);
};

});
parcelRegister("iVfVP", function(module, exports) {

$parcel$export(module.exports, "useFirstProjectDetails", () => $77a73518021e5726$export$a2dd21ca7232bc34);
$parcel$export(module.exports, "useFirstProjectDetailsNew", () => $77a73518021e5726$export$16beb41ec08bf629);

var $5uXOq = parcelRequire("5uXOq");


var $9OXo1 = parcelRequire("9OXo1");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $2YP9W = parcelRequire("2YP9W");

var $lbaDt = parcelRequire("lbaDt");

var $KbkKO = parcelRequire("KbkKO");
const $77a73518021e5726$var$initialState = {
    error: false,
    firstProject: undefined
};
const $77a73518021e5726$var$setError = (error)=>({ setState: setState })=>{
        setState({
            error: error
        });
    };
const $77a73518021e5726$var$setFirstProject = (firstProject)=>({ setState: setState })=>{
        setState({
            firstProject: firstProject
        });
    };
const $77a73518021e5726$export$e324594224ef24da = {
    setError: $77a73518021e5726$var$setError,
    setFirstProject: $77a73518021e5726$var$setFirstProject
};
const $77a73518021e5726$var$store = (0, $iXqE5.createStore)({
    name: 'getting-started-page-is-first-project',
    initialState: $77a73518021e5726$var$initialState,
    actions: $77a73518021e5726$export$e324594224ef24da
});
const $77a73518021e5726$export$a47f6b1a99a5e57f = (0, $3sQ5x.createHook)($77a73518021e5726$var$store);
const $77a73518021e5726$export$a2dd21ca7232bc34 = ()=>{
    const [data, { setError: setErrorState, setFirstProject: setFirstProjectDetails }] = $77a73518021e5726$export$a47f6b1a99a5e57f();
    const { licensedProducts: licensedProducts } = (0, $9OXo1.useTenantContext)() || {};
    const hasJsmLicense = licensedProducts && licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61];
    (0, $5uXOq.useEffect)(()=>{
        if (!hasJsmLicense || data.firstProject || data.error) return;
        (0, $KbkKO.default)().then((response)=>{
            setFirstProjectDetails(response);
        }).catch(()=>{
            setErrorState(true);
        });
    }, [
        hasJsmLicense,
        setErrorState,
        setFirstProjectDetails,
        data.firstProject,
        data.error
    ]);
    return data;
};
const $77a73518021e5726$export$16beb41ec08bf629 = ()=>{
    const [data, { setError: setErrorState, setFirstProject: setFirstProjectDetails }] = $77a73518021e5726$export$a47f6b1a99a5e57f();
    const { licensedProducts: licensedProducts } = (0, $9OXo1.useTenantContext)() || {};
    const hasJsmLicense = licensedProducts && licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61];
    const { data: resourceData, error: error, loading: loading } = (0, $2YP9W.useResource)((0, $lbaDt.firstProjectResource));
    (0, $5uXOq.useEffect)(()=>{
        if (!hasJsmLicense || data.firstProject || data.error) return;
        if (error) setErrorState(true);
        else if (resourceData) setFirstProjectDetails(resourceData);
    }, [
        hasJsmLicense,
        resourceData,
        error,
        setErrorState,
        setFirstProjectDetails,
        data.firstProject,
        data.error
    ]);
    return {
        data: data,
        loading: loading
    };
};

});
const $c06e1abca7c13910$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $c06e1abca7c13910$export$e9c56aa3b027d98f = 'jira-customer-service';
const $c06e1abca7c13910$export$1346c9aa3cbb477d = 'jira-software';
const $c06e1abca7c13910$export$202f50ee62667e32 = 'jira-product-discovery';
const $c06e1abca7c13910$export$db515c8cec1e6f79 = 'jira-core';
const $c06e1abca7c13910$export$c811f21c9ad05dc2 = 'confluence';
const $c06e1abca7c13910$export$961148c98d198270 = 'opsgenie';

parcelRegister("KbkKO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $746c95604cc49d58$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $bFU4G = parcelRequire("bFU4G");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $746c95604cc49d58$var$getFirstProject = async ()=>{
    try {
        const fetchStartTime = performance.now();
        const response = await (0, $eusud.performGetRequest)('/rest/servicedesk/latest/xflow/getFirstProject?type=service_desk');
        (0, $bFU4G.addSpanToAll)('fetch', 'rest/servicedesk/latest/xflow/getFirstProject?type=service_desk', [
            {
                name: 'network'
            }
        ], fetchStartTime, performance.now());
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode !== 404) (0, $jcw0u.default)({
            meta: {
                id: 'getFirstProject',
                packageName: '@atlassian/jira-router-resources-service-desk-project-getting-started',
                teamName: 'itops-mithril'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
var // named export does not work with Bifrost templates CI build: 'index.tsx does not export 'then'`. Also, `getDataLoader:` in router works only with default exports
$746c95604cc49d58$export$2e2bcd8739ae039 = $746c95604cc49d58$var$getFirstProject;

});



parcelRegister("6juLJ", function(module, exports) {

$parcel$export(module.exports, "useOpsTeamMode", () => $3726f54bfa1691c8$export$97247be508d7d058);
$parcel$export(module.exports, "useGettingStartedPanelState", () => $3726f54bfa1691c8$export$50f195e39d82318);
$parcel$export(module.exports, "useGettingStartedPanelActions", () => $3726f54bfa1691c8$export$bb089b373d239cdd);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $2NMNM = parcelRequire("2NMNM");

var $8J6rn = parcelRequire("8J6rn");

var $4DPZY = parcelRequire("4DPZY");

var $aNLeB = parcelRequire("aNLeB");


var $hO5fm = parcelRequire("hO5fm");

var $7HThi = parcelRequire("7HThi");

var $g5X3G = parcelRequire("g5X3G");

var $9OXo1 = parcelRequire("9OXo1");

var $aeeX4 = parcelRequire("aeeX4");

var $bmKPg = parcelRequire("bmKPg");
var $doZTA = parcelRequire("doZTA");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $9TJvQ = parcelRequire("9TJvQ");
const $3726f54bfa1691c8$var$initialState = {
    data: undefined,
    isGspInitialized: true,
    isSaving: false,
    shouldRecordPerformanceExperiences: true
};
const $3726f54bfa1691c8$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'GettingStartedPanelState',
    initialState: $3726f54bfa1691c8$var$initialState,
    actions: (0, $9TJvQ.actions)
});
const $3726f54bfa1691c8$var$useGettingStartedPanelStoreState = (0, $3sQ5x.createHook)($3726f54bfa1691c8$export$6f57813fe9f31bf9, {
    selector: ({ data: data, isGspInitialized: isGspInitialized, shouldRecordPerformanceExperiences: shouldRecordPerformanceExperiences })=>{
        const canRender = isGspInitialized && data?.properties.user.activeState === (0, $aeeX4.ActiveState).On;
        const canRenderPanel = canRender && data?.properties.user.visualState === (0, $aeeX4.VisualState).FullPanel;
        const canRenderOpenButton = canRender && data?.properties.user.visualState === (0, $aeeX4.VisualState).Lozenge;
        const canRenderReopenButton = isGspInitialized && data?.properties.user.activeState === (0, $aeeX4.ActiveState).Off;
        const canRenderReopenSpotlight = canRenderReopenButton && data?.properties.user.hasSeenReopenSpotlight === (0, $aeeX4.HasSeenReopenSpotlight).No;
        const canPollPanelState = data?.properties.user.activeState === (0, $aeeX4.ActiveState).On;
        return {
            data: data,
            canRenderPanel: canRenderPanel,
            canRenderOpenButton: canRenderOpenButton,
            canRenderReopenButton: canRenderReopenButton,
            canRenderReopenSpotlight: canRenderReopenSpotlight,
            canPollPanelState: canPollPanelState,
            shouldRecordPerformanceExperiences: shouldRecordPerformanceExperiences
        };
    }
});
const $3726f54bfa1691c8$var$useGettingStartedPanelStoreActions = (0, $3sQ5x.createHook)($3726f54bfa1691c8$export$6f57813fe9f31bf9, {
    selector: null
});
/**
 * Hook returns if FSF tour is seen
 */ const $3726f54bfa1691c8$var$useIsProjectTourSeen = ()=>{
    const [{ data: data, isLoading: isLoading, error: error }, { getTourState: getTourState }] = (0, $hO5fm.useTourState)();
    const isError = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(error);
    const hasData = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(data);
    (0, $5uXOq.useEffect)(()=>{
        if (!hasData && !isLoading && !isError) getTourState();
    }, [
        hasData,
        isLoading,
        isError,
        getTourState
    ]);
    return data?.seenProjectTour === (0, $87b6a84c4fa7f907$export$e47bc222770d5cfd);
};
/**
 * Hook returns if ITSM sample project
 */ const $3726f54bfa1691c8$var$useIsSampleProject = ()=>{
    const { data: isItsmSampleProject } = (0, $7HThi.useIsItsmSampleProject)();
    const [{ data: containerContext }] = (0, $4DPZY.useContainerContext)();
    if (isItsmSampleProject != null) return isItsmSampleProject;
    /*
    When isItsmSampleProject is null or undefined - return null/undefined, but only if we are in project context
    (this is to identify that this var has not been initialized yet, see isItsmSampleProject usages, where we check for null/isNil);
    return false otherwise
 */ return containerContext?.contextType === 'project' ? isItsmSampleProject : false;
};
const $3726f54bfa1691c8$export$2486eddc1a0bc021 = ()=>{
    const { data: isItsmProject } = (0, $aNLeB.useIsItsmTemplateProject)();
    const [{ data: containerContext }] = (0, $4DPZY.useContainerContext)();
    const projectId = containerContext?.contextType === 'project' && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(containerContext.project) ? (0, $g5X3G.toProjectId)(String(containerContext.project.id)) : undefined;
    return {
        isItsmProject: !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(projectId) && isItsmProject === true,
        projectId: projectId
    };
};
const $3726f54bfa1691c8$export$97247be508d7d058 = ()=>{
    const [{ location: { pathname: pathname } }] = (0, $doZTA.useRouter)();
    const { shouldUseJSM: shouldUseJSM } = (0, $8J6rn.useOgTenantInfo)();
    const isOpsPage = pathname.startsWith('/jira/ops/teams/');
    const [teamId] = (0, $bmKPg.usePathParam)('teamId');
    const enableOpsTeamMode = isOpsPage && teamId !== undefined && !!shouldUseJSM;
    return {
        teamId: teamId,
        enableOpsTeamMode: enableOpsTeamMode
    };
};
const $3726f54bfa1691c8$export$678a38a9dc2d3a0 = ()=>{
    const { isItsmProject: isItsmProject } = $3726f54bfa1691c8$export$2486eddc1a0bc021();
    const { shouldUseJSM: shouldUseJSM } = (0, $8J6rn.useOgTenantInfo)();
    const enableUserCentricMode = isItsmProject && !!shouldUseJSM;
    return enableUserCentricMode;
};
const $3726f54bfa1691c8$var$useActionsMemo = ({ baseUrl: baseUrl, cloudId: cloudId, accountId: accountId, initializeState: initializeState, reopenGettingStartedPanel: reopenGettingStartedPanel, markReopenSpotlightAsSeen: markReopenSpotlightAsSeen, fetchState: fetchState, savePanelState: savePanelState, resolveTask: resolveTask, saveProperty: saveProperty, stopRecordingPerformanceExperiences: stopRecordingPerformanceExperiences, setOpsAdminTaskVisibility: setOpsAdminTaskVisibility })=>{
    const gatewayBaseUrl = (0, $g5X3G.toBaseUrl)(`${baseUrl}/gateway/api`);
    const isItsmSampleProject = $3726f54bfa1691c8$var$useIsSampleProject();
    const { isItsmProject: isItsmProject, projectId: projectId } = $3726f54bfa1691c8$export$2486eddc1a0bc021();
    const isProjectTourSeen = $3726f54bfa1691c8$var$useIsProjectTourSeen();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { teamId: teamId, enableOpsTeamMode: enableOpsTeamMode } = $3726f54bfa1691c8$export$97247be508d7d058();
    const enableUserCentricMode = $3726f54bfa1691c8$export$678a38a9dc2d3a0();
    return (0, $5uXOq.useMemo)(()=>{
        const actionProps = {
            createAnalyticsEvent: createAnalyticsEvent,
            baseUrl: gatewayBaseUrl,
            cloudId: cloudId,
            accountId: accountId,
            isItsmSampleProject: isItsmSampleProject,
            isProjectTourSeen: isProjectTourSeen,
            isItsmProject: isItsmProject,
            projectId: projectId,
            ...enableOpsTeamMode && {
                teamId: teamId,
                enableOpsTeamMode: enableOpsTeamMode
            },
            ...enableUserCentricMode && {
                enableUserCentricMode: enableUserCentricMode
            }
        };
        return {
            initializeState: initializeState(actionProps),
            reopenGettingStartedPanel: reopenGettingStartedPanel(actionProps),
            markReopenSpotlightAsSeen: markReopenSpotlightAsSeen(actionProps),
            fetchState: fetchState(actionProps),
            savePanelState: savePanelState(actionProps),
            resolveTask: resolveTask(actionProps),
            saveProperty: saveProperty(actionProps),
            stopRecordingPerformanceExperiences: stopRecordingPerformanceExperiences(),
            setOpsAdminTaskVisibility: setOpsAdminTaskVisibility(actionProps)
        };
    }, [
        createAnalyticsEvent,
        gatewayBaseUrl,
        cloudId,
        accountId,
        isItsmSampleProject,
        isProjectTourSeen,
        isItsmProject,
        projectId,
        enableOpsTeamMode,
        teamId,
        enableUserCentricMode,
        initializeState,
        reopenGettingStartedPanel,
        markReopenSpotlightAsSeen,
        fetchState,
        savePanelState,
        resolveTask,
        saveProperty,
        stopRecordingPerformanceExperiences,
        setOpsAdminTaskVisibility
    ]);
};
const $3726f54bfa1691c8$var$useStateMemo = ({ data: data, canRenderPanel: canRenderPanel, canRenderOpenButton: canRenderOpenButton, canRenderReopenButton: canRenderReopenButton, canRenderReopenSpotlight: canRenderReopenSpotlight, canPollPanelState: canPollPanelState, shouldRecordPerformanceExperiences: shouldRecordPerformanceExperiences })=>(0, $5uXOq.useMemo)(()=>({
            data: data,
            canRenderPanel: canRenderPanel,
            canRenderOpenButton: canRenderOpenButton,
            canRenderReopenButton: canRenderReopenButton,
            canRenderReopenSpotlight: canRenderReopenSpotlight,
            canPollPanelState: canPollPanelState,
            shouldRecordPerformanceExperiences: shouldRecordPerformanceExperiences
        }), [
        data,
        canRenderPanel,
        canRenderOpenButton,
        canRenderReopenButton,
        canRenderReopenSpotlight,
        canPollPanelState,
        shouldRecordPerformanceExperiences
    ]);
const $3726f54bfa1691c8$export$50f195e39d82318 = ()=>{
    const { cloudId: cloudId, atlassianAccountId: accountId, baseUrl: baseUrl } = (0, $9OXo1.useTenantContext)();
    const [state, actions] = $3726f54bfa1691c8$var$useGettingStartedPanelStoreState();
    const memoizedActions = $3726f54bfa1691c8$var$useActionsMemo({
        ...actions,
        baseUrl: baseUrl,
        cloudId: cloudId,
        accountId: accountId
    });
    const memoizedState = $3726f54bfa1691c8$var$useStateMemo(state);
    return (0, $5uXOq.useMemo)(()=>[
            memoizedState,
            memoizedActions
        ], [
        memoizedActions,
        memoizedState
    ]);
};
const $3726f54bfa1691c8$export$bb089b373d239cdd = ()=>{
    const { cloudId: cloudId, atlassianAccountId: accountId, baseUrl: baseUrl } = (0, $9OXo1.useTenantContext)();
    const [, actions] = $3726f54bfa1691c8$var$useGettingStartedPanelStoreActions();
    const memoizedActions = $3726f54bfa1691c8$var$useActionsMemo({
        ...actions,
        baseUrl: baseUrl,
        cloudId: cloudId,
        accountId: accountId
    });
    return (0, $5uXOq.useMemo)(()=>[
            undefined,
            memoizedActions
        ], [
        memoizedActions
    ]);
};

});
const $87b6a84c4fa7f907$export$17227441e89ee693 = 'INITIAL';
const $87b6a84c4fa7f907$export$23324e66dcb20cea = 'NOTSEEN';
const $87b6a84c4fa7f907$export$e47bc222770d5cfd = 'SEEN';
const $87b6a84c4fa7f907$export$103bedf43ba882db = 'ERROR';
const $87b6a84c4fa7f907$export$b8b9d90f9e5bd72b = 'jiraServicedeskItsmFirstSessionFlow';
const $87b6a84c4fa7f907$export$d57b6b390e78d90f = 'itops-mithril';

parcelRegister("hO5fm", function(module, exports) {

$parcel$export(module.exports, "useTourState", () => $6d8bca487172cfe1$export$4aecabf781c5d857);

var $5uXOq = parcelRequire("5uXOq");

var $g5X3G = parcelRequire("g5X3G");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $7tQNr = parcelRequire("7tQNr");
const $6d8bca487172cfe1$export$d4c72bab9d6cc13a = {
    data: undefined,
    isLoading: false,
    error: undefined
};
const $6d8bca487172cfe1$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'ItsmFirstSessionFlowTourState',
    initialState: $6d8bca487172cfe1$export$d4c72bab9d6cc13a,
    actions: (0, $7tQNr.actions)
});
const $6d8bca487172cfe1$var$useStore = (0, $3sQ5x.createHook)($6d8bca487172cfe1$export$6f57813fe9f31bf9);
// @ts-expect-error - TS7031 - Binding element 'baseUrl' implicitly has an 'any' type. | TS7031 - Binding element 'getTourState' implicitly has an 'any' type. | TS7031 - Binding element 'setTourState' implicitly has an 'any' type.
const $6d8bca487172cfe1$var$useActionsMemo = ({ baseUrl: baseUrl, getTourState: getTourState, setTourState: setTourState })=>(0, $5uXOq.useMemo)(()=>({
            getTourState: getTourState({
                baseUrl: baseUrl
            }),
            setTourState: setTourState({
                baseUrl: baseUrl
            })
        }), [
        baseUrl,
        getTourState,
        setTourState
    ]);
const $6d8bca487172cfe1$var$useStateMemo = ({ data: data, isLoading: isLoading, error: error })=>(0, $5uXOq.useMemo)(()=>({
            data: data,
            isLoading: isLoading,
            error: error
        }), [
        data,
        isLoading,
        error
    ]);
const $6d8bca487172cfe1$export$4aecabf781c5d857 = ()=>{
    const baseUrl = (0, $g5X3G.toBaseUrl)('');
    const [state, actions] = $6d8bca487172cfe1$var$useStore();
    const memoizedActions = $6d8bca487172cfe1$var$useActionsMemo({
        ...actions,
        baseUrl: baseUrl
    });
    const memoizedState = $6d8bca487172cfe1$var$useStateMemo(state);
    return (0, $5uXOq.useMemo)(()=>[
            memoizedState,
            memoizedActions
        ], [
        memoizedActions,
        memoizedState
    ]);
};

});
parcelRegister("7tQNr", function(module, exports) {

$parcel$export(module.exports, "actions", () => $e522e9db5e833423$export$e324594224ef24da);

var $bXTMr = parcelRequire("bXTMr");

var $2SNiB = parcelRequire("2SNiB");
const $e522e9db5e833423$export$e324594224ef24da = {
    getTourState: $bXTMr.getTourState,
    setTourState: $2SNiB.setTourState
};

});
parcelRegister("bXTMr", function(module, exports) {

$parcel$export(module.exports, "getTourState", () => $eed4e52cff30c013$export$a758fd93ae41dde5);

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $5HnTq = parcelRequire("5HnTq");

var $fZneA = parcelRequire("fZneA");

var $g5X3G = parcelRequire("g5X3G");

const $eed4e52cff30c013$var$getUrl = (baseUrl)=>`${baseUrl}/rest/servicedesk/onboarding/latest/fsf`;
const $eed4e52cff30c013$var$fetchTourState = async (baseUrl)=>{
    const url = $eed4e52cff30c013$var$getUrl(baseUrl);
    const response = await fetch(url, (0, $5HnTq.getDefaultOptions)(url));
    if (!response.ok) {
        const text = await response.text();
        const error = new (0, $jJZqs.default)(response.status, text);
        // Still throw the error even if it's a client fetch error,
        // so we get the error path in the handling code.
        // We only want to skip analytics firing.
        if (!(0, $fZneA.isClientFetchError)(error)) (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'getTourState_responseNotOK',
                packageName: (0, $87b6a84c4fa7f907$export$b8b9d90f9e5bd72b),
                teamName: (0, $87b6a84c4fa7f907$export$d57b6b390e78d90f)
            },
            attributes: {
                message: error.message
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
    return response.json();
};
const $eed4e52cff30c013$export$a758fd93ae41dde5 = ({ baseUrl: baseUrl })=>({ getState: getState, setState: setState })=>async ()=>{
            const { data: data, isLoading: isLoading } = getState();
            if (data || isLoading) return;
            setState({
                error: undefined,
                isLoading: true
            });
            try {
                const result = await $eed4e52cff30c013$var$fetchTourState(baseUrl);
                const { seenProjectTour: seenProjectTour, projectId: projectId } = result;
                setState({
                    data: {
                        seenProjectTour: seenProjectTour,
                        projectId: projectId === null ? null : (0, $g5X3G.toProjectId)(projectId)
                    },
                    isLoading: false
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                if (!(0, $fZneA.isClientFetchError)(error)) (0, $jcw0u.default)({
                    error: error,
                    meta: {
                        id: 'getTourState',
                        packageName: (0, $87b6a84c4fa7f907$export$b8b9d90f9e5bd72b),
                        teamName: (0, $87b6a84c4fa7f907$export$d57b6b390e78d90f)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    error: error,
                    isLoading: false
                });
                if (!(0, $fZneA.isClientFetchError)(error)) throw error;
            }
        };

});

parcelRegister("2SNiB", function(module, exports) {

$parcel$export(module.exports, "setTourState", () => $e6283e07e269c047$export$35f9649c739aaca3);

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $5HnTq = parcelRequire("5HnTq");

const $e6283e07e269c047$var$getUrl = (baseUrl)=>`${baseUrl}/rest/servicedesk/onboarding/latest/fsf`;
const $e6283e07e269c047$var$putTourState = async (baseUrl, tourState)=>{
    const url = $e6283e07e269c047$var$getUrl(baseUrl);
    const response = await fetch(url, {
        ...(0, $5HnTq.getDefaultOptions)(url),
        method: 'PUT',
        body: JSON.stringify(tourState)
    });
    if (!response.ok) {
        const text = await response.text();
        const error = new (0, $jJZqs.default)(response.status, text);
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'setTourState_responseNotOK',
                packageName: (0, $87b6a84c4fa7f907$export$b8b9d90f9e5bd72b),
                teamName: (0, $87b6a84c4fa7f907$export$d57b6b390e78d90f)
            },
            attributes: {
                message: error.message
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $e6283e07e269c047$export$35f9649c739aaca3 = ({ baseUrl: baseUrl })=>({ setState: setState })=>// @ts-expect-error - TS2322 - Type 'SetTourState' is not assignable to type 'void | Promise<void>'.
        async (tourState)=>{
            setState({
                error: undefined,
                data: tourState,
                isLoading: true
            });
            try {
                await $e6283e07e269c047$var$putTourState(baseUrl, tourState);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $jcw0u.default)({
                    error: error,
                    meta: {
                        id: 'setTourState',
                        packageName: (0, $87b6a84c4fa7f907$export$b8b9d90f9e5bd72b),
                        teamName: (0, $87b6a84c4fa7f907$export$d57b6b390e78d90f)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    error: error
                });
                throw error;
            } finally{
                setState({
                    isLoading: false
                });
            }
        };

});



parcelRegister("7HThi", function(module, exports) {

$parcel$export(module.exports, "useIsItsmSampleProject", () => $1bd32a46a0882e8f$export$b8afdaba4bd6f483);

var $hGgHi = parcelRequire("hGgHi");

var $aNLeB = parcelRequire("aNLeB");

var $g4ge5 = parcelRequire("g4ge5");
const $1bd32a46a0882e8f$export$b8afdaba4bd6f483 = ()=>{
    const { data: isDemoProject, loading: loadingIsDemoProject, error: errorIsDemoProject } = (0, $g4ge5.useIsDemoProject)();
    const { data: isItsmProject, loading: loadingIsItsmProject, error: errorIsItsmProject } = (0, $aNLeB.useIsItsmTemplateProject)();
    return {
        data: !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(isDemoProject) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(isItsmProject) ? isDemoProject === true && isItsmProject === true : null,
        loading: loadingIsDemoProject || loadingIsItsmProject,
        error: errorIsDemoProject || errorIsItsmProject
    };
};

});
parcelRegister("g4ge5", function(module, exports) {

$parcel$export(module.exports, "useIsDemoProject", () => $09e24bc2f005ce6a$export$9b4078600f2ad4d2);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $4DPZY = parcelRequire("4DPZY");

var $g5X3G = parcelRequire("g5X3G");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $dciEf = parcelRequire("dciEf");

var $6LFnT = parcelRequire("6LFnT");
const $09e24bc2f005ce6a$export$d4c72bab9d6cc13a = {};
const $09e24bc2f005ce6a$export$bf108b10a3a0ab90 = (0, $iXqE5.createStore)({
    name: 'IsDemoProject',
    initialState: $09e24bc2f005ce6a$export$d4c72bab9d6cc13a,
    actions: (0, $dciEf.actions)
});
const $09e24bc2f005ce6a$var$useIsDemoProjectStore = (0, $3sQ5x.createHook)($09e24bc2f005ce6a$export$bf108b10a3a0ab90);
// @ts-expect-error - TS7031 - Binding element 'data' implicitly has an 'any' type. | TS7031 - Binding element 'loading' implicitly has an 'any' type. | TS7031 - Binding element 'error' implicitly has an 'any' type.
const $09e24bc2f005ce6a$var$useStateMemo = ({ data: data, loading: loading, error: error })=>(0, $5uXOq.useMemo)(()=>({
            data: data,
            loading: loading,
            error: error
        }), [
        data,
        loading,
        error
    ]);
const $09e24bc2f005ce6a$export$9b4078600f2ad4d2 = ()=>{
    const [{ data: contextData }] = (0, $4DPZY.useContainerContext)();
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'. | TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    const numProjectId = contextData && contextData.project && contextData.project.id;
    const projectId = (0, $g5X3G.toProjectId)(String(numProjectId));
    const baseUrl = (0, $g5X3G.toBaseUrl)('');
    const [state, { fetchIsDemoProject: fetchIsDemoProject }] = $09e24bc2f005ce6a$var$useIsDemoProjectStore();
    const memoizedState = $09e24bc2f005ce6a$var$useStateMemo({
        ...state[projectId] ?? (0, $6LFnT.initialIsDemoProjectState)
    });
    const { data: data } = memoizedState;
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(numProjectId) && (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(data)) // @ts-expect-error - TS2349 - This expression is not callable.
        fetchIsDemoProject({
            baseUrl: baseUrl,
            projectId: projectId
        })();
    }, [
        fetchIsDemoProject,
        baseUrl,
        numProjectId,
        projectId,
        data
    ]);
    return memoizedState;
};

});
parcelRegister("dciEf", function(module, exports) {

$parcel$export(module.exports, "actions", () => $ffc7e95937855e49$export$e324594224ef24da);

var $4MUdY = parcelRequire("4MUdY");
const $ffc7e95937855e49$export$e324594224ef24da = {
    fetchIsDemoProject: $4MUdY.fetchIsDemoProject
};

});
parcelRegister("4MUdY", function(module, exports) {

$parcel$export(module.exports, "fetchIsDemoProject", () => $19341c0fa64f8930$export$feaee63a215b34da);

var $hGgHi = parcelRequire("hGgHi");

var $i8xPd = parcelRequire("i8xPd");

var $6LFnT = parcelRequire("6LFnT");
const $19341c0fa64f8930$export$feaee63a215b34da = ({ baseUrl: baseUrl, projectId: projectId })=>// @ts-expect-error - TS2322 - Type '({ getState, setState }: StoreActionApi<Partial<Record<string, DataState<boolean>>>>) => () => Promise<void>' is not assignable to type 'Action<Partial<Record<string, DataState<boolean>>>, void, void | Promise<void>>'.
    ({ getState: getState, setState: setState })=>async ()=>{
            const projectState = getState()[projectId] ?? (0, $6LFnT.initialIsDemoProjectState);
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(projectState.data) || projectState.loading) return;
            setState({
                ...getState(),
                [String(projectId)]: {
                    ...projectState,
                    loading: true
                }
            });
            try {
                const isDemo = await (0, $i8xPd.isDemoProject)({
                    baseUrl: baseUrl,
                    projectId: projectId
                });
                setState({
                    ...getState(),
                    [String(projectId)]: {
                        ...projectState,
                        data: isDemo,
                        error: null,
                        loading: false
                    }
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    ...getState(),
                    [String(projectId)]: {
                        ...projectState,
                        error: error,
                        loading: false
                    }
                });
                throw error;
            }
        };

});
parcelRegister("i8xPd", function(module, exports) {

$parcel$export(module.exports, "isDemoProject", () => $aef4f72f73469a32$export$cf7813449d38d4ac);
$parcel$export(module.exports, "getItsmSampleProject", () => $aef4f72f73469a32$export$c498e29d716efe7a);

var $38QcJ = parcelRequire("38QcJ");

var $6s1PB = parcelRequire("6s1PB");

var $eusud = parcelRequire("eusud");
const $aef4f72f73469a32$var$onFetchErrorCacheHandler = (error)=>{
    if (error.statusCode === 404) return {
        value: false
    };
    throw error;
};
const $aef4f72f73469a32$export$cf7813449d38d4ac = async ({ baseUrl: baseUrl, projectId: projectId })=>{
    try {
        if ((0, $6s1PB.expValEquals)('jira_caching_layer_milestone_1_exp', 'cohort', 'variation')) {
            const response = await (0, $38QcJ.performGetRequestWithCache)(`${baseUrl}/rest/api/3/project/${projectId}/properties/isDemo`, $aef4f72f73469a32$var$onFetchErrorCacheHandler);
            return !!response && !!response.value;
        }
        const response = await (0, $eusud.performGetRequest)(`${baseUrl}/rest/api/3/project/${projectId}/properties/isDemo`);
        return !!response && !!response.value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === 404) /**
			 * Expected when project property is not found.
			 * Demo project has project property "isDemo = true",
			 * otherwise property does not exist
			 * and response status will be 404
			 */ return false;
        throw error;
    }
};
const $aef4f72f73469a32$export$c498e29d716efe7a = async ({ baseUrl: baseUrl })=>{
    try {
        const response = await (0, $eusud.performGetRequest)(`${baseUrl}/rest/servicedesk/onboarding/1/itsm/sample-project`);
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === 404) return undefined;
        throw error;
    }
};

});
parcelRegister("38QcJ", function(module, exports) {

$parcel$export(module.exports, "performGetRequestWithCache", () => $babbea8c3a621dad$export$2df9cfe22532d245);

var $eusud = parcelRequire("eusud");

var $aDezs = parcelRequire("aDezs");
const $babbea8c3a621dad$export$2df9cfe22532d245 = (0, $aDezs.withCache)((0, $eusud.performGetRequest));

});
parcelRegister("aDezs", function(module, exports) {

$parcel$export(module.exports, "withCache", () => $807c4ec3ea856331$export$33b32b3abf8170f0);

var $x9xyg = parcelRequire("x9xyg");

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $4ZYuM = parcelRequire("4ZYuM");

var $4sfTg = parcelRequire("4sfTg");

var $6JHHz = parcelRequire("6JHHz");

var $dw7IP = parcelRequire("dw7IP");
const $807c4ec3ea856331$export$33b32b3abf8170f0 = (fn)=>async (url, onFnErrorCacheHandler, maxAge = (0, $4ZYuM.SEVEN_DAYS_IN_MILLIS), options = {})=>{
        if (false) return fn(url, options);
        try {
            if (!(0, $6s1PB.expValEquals)('jira_caching_layer_milestone_1_exp', 'cohort', 'variation')) return fn(url, options);
            const cachedKey = (0, $4sfTg.createCacheKey)(url);
            const readMeasureName = 'indexed-db-cache-read';
            const readStartMark = `${readMeasureName}:start`;
            const readEndMark = `${readMeasureName}:end`;
            (0, $x9xyg.setMark)(readStartMark);
            const cachedData = await (0, $dw7IP.jiraCache).get(cachedKey);
            (0, $x9xyg.setMark)(readEndMark);
            (0, $x9xyg.setMeasure)(readMeasureName, readStartMark, readEndMark);
            if (cachedData !== undefined && Date.now() < cachedData.expiresAt) return cachedData.data;
            let data;
            try {
                data = await fn(url, options);
            } catch (error) {
                if (onFnErrorCacheHandler) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                data = onFnErrorCacheHandler(error);
                else throw error;
            }
            const writeMeasureName = 'indexed-db-cache-write';
            const writeStartMark = `${writeMeasureName}:start`;
            const writeEndMark = `${writeMeasureName}:end`;
            (0, $x9xyg.setMark)(writeStartMark);
            (0, $dw7IP.jiraCache).set(cachedKey, {
                data: data,
                expiresAt: Date.now() + maxAge
            }).then(()=>{
                (0, $x9xyg.setMark)(writeEndMark);
                (0, $x9xyg.setMeasure)(writeMeasureName, writeStartMark, writeEndMark);
            });
            return data;
        } catch (error) {
            if ((0, $4R6GH.fg)('jcl_error_handling_and_conditional_skip_sentry')) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $6JHHz.errorHandler)(error, 'withCache');
            else (0, $jcw0u.default)({
                meta: {
                    id: 'withCache',
                    packageName: (0, $4ZYuM.PACKAGE_NAME),
                    teamName: (0, $4ZYuM.TEAM_NAME)
                },
                error: new Error('Error in JCL withCache'),
                attributes: {
                    cause: error instanceof Error ? error.message : 'Not known'
                },
                sendToPrivacyUnsafeSplunk: true,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                skipSentry: (0, $jcw0u.isNetworkError)(error)
            });
            return fn(url, options);
        }
    };

});
parcelRegister("4ZYuM", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $14fef84cc1d179c0$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $14fef84cc1d179c0$export$d57b6b390e78d90f);
$parcel$export(module.exports, "SEVEN_DAYS_IN_MILLIS", () => $14fef84cc1d179c0$export$b14f1fa28090cb18);
$parcel$export(module.exports, "CACHE_NAME_PREFIX", () => $14fef84cc1d179c0$export$7c8c9e2fd09cd6cd);
const $14fef84cc1d179c0$export$b8b9d90f9e5bd72b = 'jiraCachingLayer';
const $14fef84cc1d179c0$export$d57b6b390e78d90f = 'aurum';
const $14fef84cc1d179c0$export$b14f1fa28090cb18 = 604800000;
const $14fef84cc1d179c0$export$7c8c9e2fd09cd6cd = 'jira-cache';

});

parcelRegister("4sfTg", function(module, exports) {

$parcel$export(module.exports, "createCacheKey", () => $ae7ce70bbd907415$export$aa68fd26e593cc7e);

var $4Pf62 = parcelRequire("4Pf62");
const $ae7ce70bbd907415$export$aa68fd26e593cc7e = (endpoint)=>{
    const { atlassianAccountId: atlassianAccountId, cloudId: cloudId } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const url = new URL(endpoint, window.location.origin);
    const searchParams = new URLSearchParams(url.search);
    const sortedParams = new URLSearchParams([
        ...searchParams.entries()
    ].sort());
    url.search = sortedParams.toString();
    const prefix = (atlassianAccountId + cloudId).replace(/-/g, '');
    const endpointWithSearch = prefix + url.pathname + url.search;
    return endpointWithSearch.replace(/[/?&=]/g, '-').substring(1);
};

});

parcelRegister("6JHHz", function(module, exports) {

$parcel$export(module.exports, "errorHandler", () => $17322007fa00b48f$export$cc3fdd528b56c4a9);

var $jcw0u = parcelRequire("jcw0u");

var $4ZYuM = parcelRequire("4ZYuM");
const $17322007fa00b48f$export$3b21ec5932035f63 = [
    'Internal error.',
    'Internal error opening backing store for indexedDB.open.',
    "Can't find variable: indexedDB",
    'Error looking up record in object store by key range',
    "IDBDatabase.transaction: 'keyval' is not a known object store name",
    'A mutation operation was attempted on a database that did not allow mutations.',
    'Encountered full disk while opening backing store for indexedDB.open.',
    "Failed to execute 'transaction' on 'IDBDatabase': One of the specified object stores was not found.",
    'Internal error retrieving bucket data directory.',
    'Connection to Indexed Database server lost. Refresh the page to try again',
    'The current transaction exceeded its quota limitations.',
    'The operation failed for reasons unrelated to the database itself and not covered by any other error code.',
    'Attempt to get a record from database without an in-progress transaction'
];
const $17322007fa00b48f$var$shouldSkipSentry = (error)=>(0, $jcw0u.isNetworkError)(error) || $17322007fa00b48f$export$3b21ec5932035f63.includes(error?.message);
const $17322007fa00b48f$export$cc3fdd528b56c4a9 = (error, source)=>{
    const cause = error instanceof Error ? error.message : 'Not known';
    (0, $jcw0u.default)({
        meta: {
            id: source,
            packageName: (0, $4ZYuM.PACKAGE_NAME),
            teamName: (0, $4ZYuM.TEAM_NAME)
        },
        error: new Error(`JCL ${source} - ${cause}`, {
            cause: error
        }),
        attributes: {
            cause: cause
        },
        sendToPrivacyUnsafeSplunk: true,
        skipSentry: $17322007fa00b48f$var$shouldSkipSentry(error)
    });
};

});

parcelRegister("dw7IP", function(module, exports) {

$parcel$export(module.exports, "jiraCache", () => $646f3c3ba9013057$export$8b9e5c9ea3bf5aac);

var $sn9QA = parcelRequire("sn9QA");

var $4ZYuM = parcelRequire("4ZYuM");
const $646f3c3ba9013057$export$8b9e5c9ea3bf5aac = (0, $sn9QA.createIndexedDBStorageProvider)((0, $4ZYuM.CACHE_NAME_PREFIX), {
    shouldAutoReconnect: true
});

});
parcelRegister("sn9QA", function(module, exports) {

$parcel$export(module.exports, "createIndexedDBStorageProvider", () => $cf3437e9474a0e2b$export$6ba36c4f5fb8919d);

var $gJBT6 = parcelRequire("gJBT6");

var $8vEj7 = parcelRequire("8vEj7");
const $cf3437e9474a0e2b$export$6ba36c4f5fb8919d = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((appPrefix, options)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const provider = (0, $8vEj7.createStorageProvider)(appPrefix);
    if (options?.shouldAutoReconnect) return (0, $8vEj7.withAutoReconnect)(provider);
    return provider;
});

});
parcelRegister("8vEj7", function(module, exports) {

$parcel$export(module.exports, "createStorageProvider", () => $33b8db71261fb346$export$8441605555fbd60c);
$parcel$export(module.exports, "withAutoReconnect", () => $33b8db71261fb346$export$8432fe49db7d8865);

var $jIIX7 = parcelRequire("jIIX7");
const $33b8db71261fb346$export$7382f85ef4ff4314 = (prefix, key)=>`${prefix.replace(/_*$/, '')}__${key || ''}`;
const $33b8db71261fb346$var$createCustomStore = ()=>(0, $jIIX7.createStore)('keyval-store', 'keyval');
let $33b8db71261fb346$var$customStore;
const $33b8db71261fb346$var$getStore = ()=>{
    let store = $33b8db71261fb346$var$customStore;
    if (!store) {
        $33b8db71261fb346$var$customStore = $33b8db71261fb346$var$createCustomStore();
        store = $33b8db71261fb346$var$customStore;
    }
    return store;
};
const $33b8db71261fb346$export$8441605555fbd60c = (appPrefix)=>{
    const KEYS_STORE_PREFIX = $33b8db71261fb346$export$7382f85ef4ff4314(appPrefix);
    const prefix = (key)=>$33b8db71261fb346$export$7382f85ef4ff4314(appPrefix, key);
    // Runtime check to ensure a key is provided as the prefix without a key
    // holds an array of all the keys that are prefixed by this store
    const assertKey = (key)=>{
        if (!key) throw Error('You must provide a key');
    };
    // Calling `clearAll` would require us to iterate over every key in the
    // indexed-db, filtering by this instance's prefix and subsequently deleting
    // all the filtered keys. As indexed-db gains traction within Jira, this
    // will quickly become an expensive operation. To counteract this, we
    // instead store all the keys that this instance has created so that when it
    // comes time to clear them all, we simply just have to clear every key in
    // this store. This removes the need for iterating and filtering all
    // together.
    const updateStoreKeys = async (key, remove = false)=>(0, $jIIX7.update)(KEYS_STORE_PREFIX, (currentKeys)=>{
            const storeKeys = new Set(currentKeys);
            if (remove) {
                storeKeys.delete(key);
                return Array.from(storeKeys.values());
            }
            storeKeys.add(key);
            return Array.from(storeKeys.values());
        }, $33b8db71261fb346$var$getStore());
    return {
        async get (key) {
            assertKey(key);
            return (0, $jIIX7.get)(prefix(key), $33b8db71261fb346$var$getStore());
        },
        async remove (key) {
            assertKey(key);
            const prefixedKey = prefix(key);
            await (0, $jIIX7.del)(prefixedKey, $33b8db71261fb346$var$getStore());
            return updateStoreKeys(prefixedKey, true);
        },
        async clearAll () {
            const prefixedKeys = await (0, $jIIX7.get)(KEYS_STORE_PREFIX, $33b8db71261fb346$var$getStore());
            if (!prefixedKeys || prefixedKeys.length === 0) return undefined;
            return (0, $jIIX7.delMany)(prefixedKeys.concat(KEYS_STORE_PREFIX));
        },
        async set (key, value) {
            assertKey(key);
            const prefixedKey = prefix(key);
            if (typeof value === 'function') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            (0, $jIIX7.update)(prefixedKey, value);
            else (0, $jIIX7.set)(prefixedKey, value, $33b8db71261fb346$var$getStore());
            return updateStoreKeys(prefixedKey);
        },
        async reconnect () {
            $33b8db71261fb346$var$customStore = $33b8db71261fb346$var$createCustomStore();
        }
    };
};
const $33b8db71261fb346$export$8432fe49db7d8865 = (storageProvider)=>({
        async get (...args) {
            try {
                return await storageProvider.get(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.get(...args);
                }
                throw e;
            }
        },
        async set (...args) {
            try {
                return await storageProvider.set(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.set(...args);
                }
                throw e;
            }
        },
        async remove (...args) {
            try {
                return await storageProvider.remove(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.remove(...args);
                }
                throw e;
            }
        },
        async clearAll (...args) {
            try {
                return await storageProvider.clearAll(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.clearAll(...args);
                }
                throw e;
            }
        },
        async reconnect () {
            await storageProvider.reconnect?.();
        }
    });

});
parcelRegister("jIIX7", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $e5b4ff07e835609c$export$f51a9068ac82ea43);
$parcel$export(module.exports, "get", () => $e5b4ff07e835609c$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $e5b4ff07e835609c$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "update", () => $e5b4ff07e835609c$export$722fbec263ad908a);
$parcel$export(module.exports, "del", () => $e5b4ff07e835609c$export$1d2f21e549771e67);
$parcel$export(module.exports, "delMany", () => $e5b4ff07e835609c$export$c8aa84257229cac8);
function $e5b4ff07e835609c$export$b327150396135fe7(request) {
    return new Promise((resolve, reject)=>{
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = ()=>resolve(request.result);
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = ()=>reject(request.error);
    });
}
function $e5b4ff07e835609c$export$f51a9068ac82ea43(dbName, storeName) {
    const request = indexedDB.open(dbName);
    request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
    const dbp = $e5b4ff07e835609c$export$b327150396135fe7(request);
    return (txMode, callback)=>dbp.then((db)=>callback(db.transaction(storeName, txMode).objectStore(storeName)));
}
let $e5b4ff07e835609c$var$defaultGetStoreFunc;
function $e5b4ff07e835609c$var$defaultGetStore() {
    if (!$e5b4ff07e835609c$var$defaultGetStoreFunc) $e5b4ff07e835609c$var$defaultGetStoreFunc = $e5b4ff07e835609c$export$f51a9068ac82ea43('keyval-store', 'keyval');
    return $e5b4ff07e835609c$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$3988ae62b71be9a3(key, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>$e5b4ff07e835609c$export$b327150396135fe7(store.get(key)));
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$adaa4cf7ef1b65be(key, value, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.put(value, key);
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$daa0a5170277c7a8(entries, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        entries.forEach((entry)=>store.put(entry[1], entry[0]));
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$5df405cccea42673(keys, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>Promise.all(keys.map((key)=>$e5b4ff07e835609c$export$b327150396135fe7(store.get(key)))));
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$722fbec263ad908a(key, updater, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>// Need to create the promise manually.
        // If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise((resolve, reject)=>{
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($e5b4ff07e835609c$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$1d2f21e549771e67(key, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.delete(key);
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$c8aa84257229cac8(keys, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        keys.forEach((key)=>store.delete(key));
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$42ffd38884aecdac(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.clear();
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
function $e5b4ff07e835609c$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$ed97f33186d4b816(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAllKeys) return $e5b4ff07e835609c$export$b327150396135fe7(store.getAllKeys());
        const items = [];
        return $e5b4ff07e835609c$var$eachCursor(store, (cursor)=>items.push(cursor.key)).then(()=>items);
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$68c286be0e7e55b7(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAll) return $e5b4ff07e835609c$export$b327150396135fe7(store.getAll());
        const items = [];
        return $e5b4ff07e835609c$var$eachCursor(store, (cursor)=>items.push(cursor.value)).then(()=>items);
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$3e9f948b41964866(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $e5b4ff07e835609c$export$b327150396135fe7(store.getAllKeys()),
            $e5b4ff07e835609c$export$b327150396135fe7(store.getAll())
        ]).then(([keys, values])=>keys.map((key, i)=>[
                    key,
                    values[i]
                ]));
        const items = [];
        return customStore('readonly', (store)=>$e5b4ff07e835609c$var$eachCursor(store, (cursor)=>items.push([
                    cursor.key,
                    cursor.value
                ])).then(()=>items));
    });
}

});







parcelRegister("6LFnT", function(module, exports) {

$parcel$export(module.exports, "initialIsDemoProjectState", () => $21d88e1743f1ae3e$export$f6365b0f25aeae62);
const $21d88e1743f1ae3e$export$f6365b0f25aeae62 = {
    data: null,
    loading: false,
    error: null
};

});





parcelRegister("aeeX4", function(module, exports) {

$parcel$export(module.exports, "ActiveState", () => $599e4b79be7e97d2$export$2f27df41e8b7edbb);
$parcel$export(module.exports, "VisualState", () => $599e4b79be7e97d2$export$285eeaa5f468cfb6);
$parcel$export(module.exports, "Product", () => $599e4b79be7e97d2$export$264ad599d7cef668);
$parcel$export(module.exports, "Environment", () => $599e4b79be7e97d2$export$7dc6752a22ab011a);
$parcel$export(module.exports, "GspSectionKey", () => $599e4b79be7e97d2$export$f4906a03a7a2d0af);
$parcel$export(module.exports, "ChecklistTabKey", () => $599e4b79be7e97d2$export$4f1a05ccc35315c6);
$parcel$export(module.exports, "ProductTourKey", () => $599e4b79be7e97d2$export$aa90cbc80c330872);
$parcel$export(module.exports, "HeaderState", () => $599e4b79be7e97d2$export$38aab4015a34ead);
$parcel$export(module.exports, "TaskId", () => $599e4b79be7e97d2$export$10cc267f702fbadd);
$parcel$export(module.exports, "BasicsTaskIdsProductionised", () => $599e4b79be7e97d2$export$fe6666d729b0d637);
$parcel$export(module.exports, "TeamEfficiencyTaskIds", () => $599e4b79be7e97d2$export$ed4dcaac45c6a484);
$parcel$export(module.exports, "ChangesTaskIds", () => $599e4b79be7e97d2$export$3de0dd66b0de4cdc);
$parcel$export(module.exports, "IncidentsTaskIds", () => $599e4b79be7e97d2$export$2852680309cf5a68);
$parcel$export(module.exports, "AlertsTaskIds", () => $599e4b79be7e97d2$export$4f537e3bd8843f30);
$parcel$export(module.exports, "CompassAlertsTaskIds", () => $599e4b79be7e97d2$export$62a4b5d6ebfd53e9);
$parcel$export(module.exports, "HasSeenReopenSpotlight", () => $599e4b79be7e97d2$export$72401d057976d548);
$parcel$export(module.exports, "ContainerType", () => $599e4b79be7e97d2$export$7d7a98f44861e6f7);
$parcel$export(module.exports, "ExplicitStringBoolean", () => $599e4b79be7e97d2$export$d7341fa10d264a87);
$parcel$export(module.exports, "PropertyKey", () => $599e4b79be7e97d2$export$e6bec6a1026bf0b4);
var $599e4b79be7e97d2$export$2f27df41e8b7edbb = /*#__PURE__*/ function(ActiveState) {
    ActiveState["On"] = "on";
    ActiveState["Off"] = "off";
    return ActiveState;
}({});
var $599e4b79be7e97d2$export$285eeaa5f468cfb6 = /*#__PURE__*/ function(VisualState) {
    VisualState["Lozenge"] = "lozenge";
    VisualState["FullPanel"] = "full-panel";
    return VisualState;
}({});
var $599e4b79be7e97d2$export$264ad599d7cef668 = /*#__PURE__*/ function(Product) {
    Product["ServiceDesk"] = "serviceDesk";
    Product["Opsgenie"] = "opsgenie";
    Product["Compass"] = "compass";
    return Product;
}({});
var $599e4b79be7e97d2$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["Local"] = "local";
    Environment["Dev"] = "dev";
    Environment["Staging"] = "staging";
    Environment["Prod"] = "prod";
    return Environment;
}({});
var $599e4b79be7e97d2$export$f4906a03a7a2d0af = /*#__PURE__*/ function(GspSectionKey) {
    GspSectionKey["Checklist"] = "checklist";
    GspSectionKey["ProductTours"] = "productTours";
    GspSectionKey["Home"] = "home";
    return GspSectionKey;
}({});
var $599e4b79be7e97d2$export$4f1a05ccc35315c6 = /*#__PURE__*/ function(ChecklistTabKey) {
    ChecklistTabKey["Basics"] = "basics";
    ChecklistTabKey["TeamEfficiency"] = "teamEfficiency";
    ChecklistTabKey["Incidents"] = "incidents";
    ChecklistTabKey["Changes"] = "changes";
    ChecklistTabKey["Alerts"] = "alerts";
    ChecklistTabKey["CompassAlerts"] = "compassAlerts";
    return ChecklistTabKey;
}({});
var $599e4b79be7e97d2$export$aa90cbc80c330872 = /*#__PURE__*/ function(ProductTourKey) {
    ProductTourKey["Welcome"] = "welcome";
    ProductTourKey["IncidentManagement"] = "incident-management";
    ProductTourKey["ChangeManagement"] = "change-management";
    ProductTourKey["AlertManagement"] = "alert-management";
    return ProductTourKey;
}({});
var $599e4b79be7e97d2$export$38aab4015a34ead = /*#__PURE__*/ function(HeaderState) {
    HeaderState["Minimized"] = "minimized";
    HeaderState["Expanded"] = "expanded";
    return HeaderState;
}({});
var $599e4b79be7e97d2$export$10cc267f702fbadd = /*#__PURE__*/ function(TaskId) {
    TaskId["CreateItsmProject"] = "servicedesk-itsm-project-created";
    TaskId["CustomizePortal"] = "servicedesk-portal-name-customized";
    TaskId["AddPortalLogo"] = "servicedesk-logo-added-to-portal";
    TaskId["SetupEmailRequests"] = "servicedesk-email-requests-setup";
    TaskId["SetupChatRequests"] = "servicedesk-chat-requests-setup";
    TaskId["SetupServices"] = "servicedesk-services-setup";
    TaskId["AddTeamMember"] = "servicedesk-team-member-added";
    TaskId["GoBeyondBasics"] = "servicedesk-basics-documentation-accessed";
    TaskId["AutomateYourWork"] = "servicedesk-team-efficiency-automate-your-work";
    TaskId["SetupKnowledgeBase"] = "servicedesk-team-efficiency-setup-knowledge-base";
    TaskId["ConnectCiCdPipeline"] = "servicedesk-change-management-pipeline-connected";
    TaskId["AddChangeApprovers"] = "servicedesk-change-management-change-approvers-added";
    TaskId["TurnOnAutomationRules"] = "servicedesk-change-management-automation-rules-on";
    TaskId["MakeTheMostOfChangeManagement"] = "servicedesk-change-management-documentation-accessed";
    TaskId["SetupProfileForNotifications"] = "opsgenie-user-profile-notifications-setup";
    TaskId["SetupTeam"] = "opsgenie-response-team-setup";
    TaskId["AssignOwnerTeamToServices"] = "opsgenie-owner-team-assigned-to-service";
    TaskId["LevelUpIncidentManagement"] = "opsgenie-incident-management-documentation-accessed";
    TaskId["CustomizeRequestChannels"] = "servicedesk-request-channels-email-portal-requests-customised";
    TaskId["CustomizeRequestTypes"] = "servicedesk-request-types-customised";
    TaskId["ReviewQueueConfigurations"] = "servicedesk-queue-configurations-reviewed";
    TaskId["EnableOpsForTeam"] = "opsgenie-enable-ops-for-team";
    TaskId["ReviewOnCallSetup"] = "opsgenie-review-oncall-setup";
    TaskId["AddIntegration"] = "opsgenie-add-integration";
    TaskId["SetupOpsNotifications"] = "opsgenie-setup-ops-notifications";
    TaskId["ReviewAlerts"] = "opsgenie-review-alerts";
    TaskId["ExploreAlertsCompass"] = "compass-explore-alerts";
    TaskId["OnCallSetupCompass"] = "compass-oncall-setup";
    TaskId["SetupIntegrationCompass"] = "compass-setup-integrations";
    TaskId["SetupOpsNotificationsCompass"] = "compass-setup-ops-notifications";
    TaskId["SetupTeamOperationsCompass"] = "compass-setup-operations";
    return TaskId;
}({});
const $599e4b79be7e97d2$export$9846214c9c3411dc = [
    "servicedesk-itsm-project-created",
    "servicedesk-portal-name-customized",
    "servicedesk-logo-added-to-portal",
    "servicedesk-email-requests-setup",
    "servicedesk-services-setup",
    "servicedesk-team-member-added",
    "servicedesk-basics-documentation-accessed"
];
const $599e4b79be7e97d2$export$fe6666d729b0d637 = [
    "servicedesk-itsm-project-created",
    "servicedesk-portal-name-customized",
    "servicedesk-email-requests-setup",
    "servicedesk-chat-requests-setup",
    "servicedesk-services-setup",
    "servicedesk-team-member-added"
];
const $599e4b79be7e97d2$export$ed4dcaac45c6a484 = [
    "servicedesk-team-efficiency-automate-your-work",
    "servicedesk-team-efficiency-setup-knowledge-base"
];
const $599e4b79be7e97d2$export$3de0dd66b0de4cdc = [
    "servicedesk-change-management-pipeline-connected",
    "servicedesk-change-management-change-approvers-added",
    "servicedesk-change-management-documentation-accessed"
];
const $599e4b79be7e97d2$export$2852680309cf5a68 = [
    "opsgenie-user-profile-notifications-setup",
    "opsgenie-response-team-setup",
    "opsgenie-owner-team-assigned-to-service",
    "opsgenie-incident-management-documentation-accessed"
];
const $599e4b79be7e97d2$export$4f537e3bd8843f30 = [
    "opsgenie-enable-ops-for-team",
    "opsgenie-review-oncall-setup",
    "opsgenie-add-integration",
    "opsgenie-setup-ops-notifications",
    "opsgenie-review-alerts"
];
const $599e4b79be7e97d2$export$62a4b5d6ebfd53e9 = [
    "compass-setup-operations",
    "compass-oncall-setup",
    "compass-setup-integrations",
    "compass-setup-ops-notifications",
    "compass-explore-alerts"
];
var $599e4b79be7e97d2$export$72401d057976d548 = /*#__PURE__*/ function(HasSeenReopenSpotlight) {
    HasSeenReopenSpotlight["Yes"] = "yes";
    HasSeenReopenSpotlight["No"] = "no";
    return HasSeenReopenSpotlight;
}({});
var $599e4b79be7e97d2$export$7d7a98f44861e6f7 = /*#__PURE__*/ function(ContainerType) {
    ContainerType["Project"] = "project";
    return ContainerType;
}({});
var $599e4b79be7e97d2$export$d7341fa10d264a87 = /*#__PURE__*/ function(ExplicitStringBoolean) {
    ExplicitStringBoolean["Yes"] = "yes";
    ExplicitStringBoolean["No"] = "no";
    return ExplicitStringBoolean;
}({});
var $599e4b79be7e97d2$export$e6bec6a1026bf0b4 = /*#__PURE__*/ function(PropertyKey) {
    PropertyKey["VisualState"] = "visualState";
    PropertyKey["ActiveState"] = "activeState";
    PropertyKey["SectionState"] = "sectionState";
    PropertyKey["HasSeenReopenSpotlight"] = "hasSeenReopenSpotlight";
    return PropertyKey;
}({});

});

parcelRegister("9TJvQ", function(module, exports) {

$parcel$export(module.exports, "actions", () => $5b9ea72599cc2c41$export$e324594224ef24da);

var $fnccg = parcelRequire("fnccg");

var $5lmbj = parcelRequire("5lmbj");

var $WkJdq = parcelRequire("WkJdq");

var $aLRn2 = parcelRequire("aLRn2");

var $6g0vj = parcelRequire("6g0vj");

var $jVCdW = parcelRequire("jVCdW");

var $kTf1j = parcelRequire("kTf1j");

var $01F1V = parcelRequire("01F1V");

var $9FflN = parcelRequire("9FflN");
const $5b9ea72599cc2c41$export$e324594224ef24da = {
    initializeState: $5lmbj.initializeState,
    fetchState: $fnccg.fetchState,
    savePanelState: $jVCdW.savePanelState,
    reopenGettingStartedPanel: $aLRn2.reopenGettingStartedPanel,
    markReopenSpotlightAsSeen: $WkJdq.markReopenSpotlightAsSeen,
    resolveTask: $6g0vj.resolveTask,
    saveProperty: $kTf1j.saveProperty,
    stopRecordingPerformanceExperiences: $9FflN.stopRecordingPerformanceExperiences,
    setOpsAdminTaskVisibility: $01F1V.setOpsAdminTaskVisibility
};

});
parcelRegister("fnccg", function(module, exports) {

$parcel$export(module.exports, "fetchState", () => $5cbeba9ce380e24a$export$f3df9013f2b58bce);

var $8LQ84 = parcelRequire("8LQ84");

var $ajpes = parcelRequire("ajpes");

var $hGgHi = parcelRequire("hGgHi");

var $k0qYG = parcelRequire("k0qYG");

var $agVdz = parcelRequire("agVdz");

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $7f4tk = parcelRequire("7f4tk");

var $8zOmE = parcelRequire("8zOmE");


var $gcBmk = parcelRequire("gcBmk");

var $j25Gb = parcelRequire("j25Gb");

var $eRXyM = parcelRequire("eRXyM");

var $5lmbj = parcelRequire("5lmbj");
const $5cbeba9ce380e24a$export$e15c3a0c2c6f7c69 = {
    RESPONSE_NOT_OBJECT: 'response is not an object',
    RESPONSE_COMPLETED_ITEMS_NOT_ARRAY: 'response.completedItems is not an array',
    RESPONSE_PROPERTIES_NOT_OBJECT: 'response.properties is not an object',
    RESPONSE_PROPERTIES_USER_NOT_OBJECT: 'response.properties.user is not an object',
    RESPONSE_PROPERTIES_USER_SECTION_STATE_NOT_STRING: 'response.properties.user.sectionState is not a string',
    FAILED_PANEL_STATE_JSON_PARSE: 'Failed to parse panelState as JSON'
};
const $5cbeba9ce380e24a$var$tryInitializeState = async ({ dispatch: dispatch, ...actionProps })=>{
    const { isProjectTourSeen: isProjectTourSeen, isItsmProject: isItsmProject, projectId: projectId, isItsmSampleProject: isItsmSampleProject, enableOpsTeamMode: enableOpsTeamMode } = actionProps;
    const hasProject = ((0, $6s1PB.expValEquals)('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation') || isProjectTourSeen) && isItsmProject && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(projectId) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(isItsmSampleProject);
    if (hasProject || // We will show the alert tab regardless of the project conditions.
    enableOpsTeamMode) await dispatch((0, $5lmbj.initializeState)(actionProps))({
        projectId: projectId
    });
};
const $5cbeba9ce380e24a$export$8f32748afb26c81d = (response)=>{
    try {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($k0qYG)))(response)) throw new Error($5cbeba9ce380e24a$export$e15c3a0c2c6f7c69.RESPONSE_NOT_OBJECT);
        const completedTasks = response?.completedItems;
        const properties = response?.properties;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8LQ84)))(completedTasks)) throw new Error($5cbeba9ce380e24a$export$e15c3a0c2c6f7c69.RESPONSE_COMPLETED_ITEMS_NOT_ARRAY);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($k0qYG)))(properties)) throw new Error($5cbeba9ce380e24a$export$e15c3a0c2c6f7c69.RESPONSE_PROPERTIES_NOT_OBJECT);
        const userProperties = properties.user;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($k0qYG)))(userProperties)) throw new Error($5cbeba9ce380e24a$export$e15c3a0c2c6f7c69.RESPONSE_PROPERTIES_USER_NOT_OBJECT);
        const sectionStateString = userProperties.sectionState;
        if (sectionStateString === undefined) return undefined;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($agVdz)))(sectionStateString)) throw new Error($5cbeba9ce380e24a$export$e15c3a0c2c6f7c69.RESPONSE_PROPERTIES_USER_SECTION_STATE_NOT_STRING);
        try {
            // further validation on this object to be done within the GSP component
            JSON.parse(sectionStateString);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (parseError) {
            throw new Error($5cbeba9ce380e24a$export$e15c3a0c2c6f7c69.FAILED_PANEL_STATE_JSON_PARSE);
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'fetchState_constructDataFromResponse',
                packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                teamName: 'itops-mithril'
            },
            attributes: {
                message: error.message
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $5cbeba9ce380e24a$export$f3df9013f2b58bce = (actionProps)=>({ getState: getState, setState: setState, dispatch: dispatch })=>async ()=>{
            const { isGspInitialized: isGspInitialized, isSaving: isSaving, data: currentData } = getState();
            const { baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent, enableOpsTeamMode: enableOpsTeamMode, teamId: teamId, enableUserCentricMode: enableUserCentricMode } = actionProps;
            // If state is being saved, do not fetch, as it could fetch old state before it has been saved.
            if (isSaving) return;
            // If state is initialized, fetch the state
            if (isGspInitialized) try {
                let response;
                try {
                    response = await (0, $7f4tk.default)((0, $5lmbj.getUrl)({
                        baseUrl: baseUrl,
                        cloudId: cloudId
                    }), {
                        method: 'GET',
                        mode: 'cors',
                        credentials: 'include'
                    });
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    // 404 indicates that the checklist is not yet initialized for the user
                    if (error.statusCode !== 404) throw error;
                }
                // If state is being saved, do not save fetched state,
                // as it will override current state that is being saved.
                if (isSaving) return;
                let data = response ? $5cbeba9ce380e24a$export$8f32748afb26c81d(response) : undefined;
                if (enableUserCentricMode && data) data = await (0, $eRXyM.handleUserCentricMode)(data, cloudId);
                else if (enableOpsTeamMode && teamId && data) {
                    const opsAdminTaskVisibility = currentData?.properties.user['ops-admin-tasks-visibility'];
                    data.properties.user['ops-admin-tasks-visibility'] = opsAdminTaskVisibility;
                    data = await (0, $j25Gb.handleOpsTeamMode)(data, teamId, cloudId);
                }
                // Skip unnecessary re-renders caused by the data reference changing
                if (!!data && (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(data, currentData)) return;
                setState({
                    data: data,
                    isGspInitialized: !!data
                });
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b)}.fetchState succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                if ((0, $gcBmk.isExpectedError)(error)) return;
                (0, $jcw0u.default)({
                    error: error,
                    meta: {
                        id: 'fetchState',
                        packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
            /**
		 * If state is not initialized - try to initialize it
		 * Re-getting isGspInitialized from the getState(), because it might be changed (to false) by the code above
		 */ const { isGspInitialized: currentIsGspInitialized } = getState();
            if (!currentIsGspInitialized) $5cbeba9ce380e24a$var$tryInitializeState({
                ...actionProps,
                dispatch: dispatch
            });
        };

});
const $fb1b8c66ae3d9468$export$a72c07e4474ec8ca = 'jiraServicedeskGettingStartedPanel';
const $fb1b8c66ae3d9468$export$47712c7937145142 = 320;
const $fb1b8c66ae3d9468$export$1cad4f611a1c0229 = 220;
const $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b = 'jiraServicedeskGettingStartedPanel';
const $fb1b8c66ae3d9468$export$bc8b984358922f81 = 'team';
const $fb1b8c66ae3d9468$export$d59a8243d815f2eb = 'jsm-getting-started-panel';
const $fb1b8c66ae3d9468$export$cbbd90bf5df877bd = 'cloudid';

parcelRegister("gcBmk", function(module, exports) {

$parcel$export(module.exports, "isInClassicSettingsPage", () => $7864772e348f8c72$export$a6e1eca03e2de987);
$parcel$export(module.exports, "getCurrentPageName", () => $7864772e348f8c72$export$e2c4f60e8cad01fb);
$parcel$export(module.exports, "isExpectedError", () => $7864772e348f8c72$export$8715824c16ceeca0);
$parcel$export(module.exports, "shouldIncludePathname", () => $7864772e348f8c72$export$83501d9ba065ef89);
$parcel$export(module.exports, "shouldExcludePathname", () => $7864772e348f8c72$export$8752a3c4a740bd52);
$parcel$export(module.exports, "shouldExcludeRouteName", () => $7864772e348f8c72$export$5d52a100c70d4375);
// TODO once all pages that checklist cover are in SPA, we should change this to use matchedRoute instead of pathname

var $9UgXz = parcelRequire("9UgXz");

var $fZneA = parcelRequire("fZneA");
const $7864772e348f8c72$export$d7638addf23014e7 = (pathname)=>/\/projects\/[\w\d]+\/queues\/custom\/[\d]+$/.test(pathname);
const $7864772e348f8c72$export$1b685dac913c7026 = (pathname)=>/\/projects\/[\w\d]+\/queues\/custom\/[\d]+\/[\w\W]+$/.test(pathname) || /\/browse\/[\w\W]+$/.test(pathname);
const $7864772e348f8c72$export$a05100bbf8bc68c3 = (pathname)=>/\/projects\/[\w\d]+\/reports/.test(pathname);
const $7864772e348f8c72$export$e75cc3ec1f686973 = (pathname)=>/\/projects\/[\w\d]+\/knowledge/.test(pathname);
const $7864772e348f8c72$export$6292763547421a38 = (pathname)=>/\/projects\/[\w\d]+\/customers$/.test(pathname);
const $7864772e348f8c72$export$35dc6022d31ad167 = (pathname)=>/\/projects\/[\w\d]+\/organization\/[\d]+$/.test(pathname);
const $7864772e348f8c72$export$f8f0d4e52d7e9716 = (pathname)=>$7864772e348f8c72$export$a05100bbf8bc68c3(pathname) && (pathname.endsWith('edit') || pathname.endsWith('new'));
const $7864772e348f8c72$export$753a23d2a857eec = (pathname)=>/\/projects\/[\w\d]+\/queues\/custom\/[\d]+\/edit$/.test(pathname) || /\/projects\/[\w\d]+\/queues\/custom\/new$/.test(pathname);
const $7864772e348f8c72$export$66d002c194bc72aa = (pathname)=>/\/projects\/[\w\d]+\/services\b\/*.*/.test(pathname);
const $7864772e348f8c72$export$430089990bd4af09 = (pathname)=>/\/projects\/[\w\d]+\/on-call-schedule\b\/*.*/.test(pathname);
const $7864772e348f8c72$export$a655a298d384c316 = (pathname)=>/\/projects\/[\w\d]+\/section\/incidents\b\/*.*/.test(pathname);
const $7864772e348f8c72$export$1c5f444b718144b7 = (pathname)=>/\/projects\/[\w\d]+\/section\/problems\b\/*.*/.test(pathname);
const $7864772e348f8c72$export$42dd8a49c7fa462c = (pathname)=>/\/projects\/[\w\d]+\/section\/changes\b\/*.*/.test(pathname);
const $7864772e348f8c72$export$5c77a7ea15a04e63 = (pathname)=>/\/projects\/[\w\d]+\/section\/service-requests\b\/*.*/.test(pathname);
const $7864772e348f8c72$export$dbf902576403f80e = (pathname)=>/\/secure\/project\/EditProject!default.jspa/.test(pathname);
const $7864772e348f8c72$export$458d0b4237ae1dad = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/people/.test(pathname);
const $7864772e348f8c72$export$3b5fbfd2bca32dde = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/summary/.test(pathname);
const $7864772e348f8c72$export$aeffbab88b3257bb = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/issuetypes/.test(pathname);
const $7864772e348f8c72$export$7e3236de8c2c8fcb = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/request-types\/category\/[\w]+/.test(pathname);
const $7864772e348f8c72$export$908f99db4c2098a0 = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/change-management/.test(pathname);
const $7864772e348f8c72$export$c5b9a5ba6b3e9b66 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/customer-permissions/.test(pathname);
const $7864772e348f8c72$export$f4e3d864ce1a2f74 = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/language/.test(pathname);
const $7864772e348f8c72$export$21361d1ad00e769e = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/portal-settings/.test(pathname);
const $7864772e348f8c72$export$6208845cb364d4de = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/email-settings/.test(pathname);
const $7864772e348f8c72$export$16978d524c086b4 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/email/.test(pathname);
const $7864772e348f8c72$export$b6d6b41b75346458 = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/customer-notifications/.test(pathname);
const $7864772e348f8c72$export$5b2153f9a7427657 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/widget/.test(pathname);
const $7864772e348f8c72$export$c5434c69e9b50e81 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/feedback-settings/.test(pathname);
const $7864772e348f8c72$export$3a7002667b72e8d7 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/confluence-kb/.test(pathname);
const $7864772e348f8c72$export$542a1f79f5837827 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/sla/.test(pathname);
const $7864772e348f8c72$export$b748c9dbd5996d34 = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/automation/.test(pathname);
const $7864772e348f8c72$export$455a6199a321423 = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/apps/.test(pathname);
const $7864772e348f8c72$export$fa426b2da28e4ae2 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/workflows/.test(pathname);
const $7864772e348f8c72$export$fc0fba46b7584812 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/screens/.test(pathname);
const $7864772e348f8c72$export$882325faa1a194c6 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/fields/.test(pathname);
const $7864772e348f8c72$export$8bb0073f55baf38b = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/administer-versions/.test(pathname);
const $7864772e348f8c72$export$1b69f3aa169f179 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/administer-components/.test(pathname);
const $7864772e348f8c72$export$1c47b1cb87da237 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/permissions/.test(pathname);
const $7864772e348f8c72$export$ee56a66aa8efb6da = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/issuesecurity/.test(pathname);
const $7864772e348f8c72$export$6256b4d737fa56f2 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/notifications/.test(pathname);
const $7864772e348f8c72$export$3f77d24f8de610a0 = (pathname)=>/\/secure\/ViewCollectors!default.jspa/.test(pathname);
const $7864772e348f8c72$export$a6e1eca03e2de987 = (pathname)=>$7864772e348f8c72$export$dbf902576403f80e(pathname) || $7864772e348f8c72$export$458d0b4237ae1dad(pathname) || $7864772e348f8c72$export$3b5fbfd2bca32dde(pathname) || $7864772e348f8c72$export$aeffbab88b3257bb(pathname) || $7864772e348f8c72$export$7e3236de8c2c8fcb(pathname) || $7864772e348f8c72$export$908f99db4c2098a0(pathname) || $7864772e348f8c72$export$c5b9a5ba6b3e9b66(pathname) || $7864772e348f8c72$export$f4e3d864ce1a2f74(pathname) || $7864772e348f8c72$export$21361d1ad00e769e(pathname) || $7864772e348f8c72$export$6208845cb364d4de(pathname) || $7864772e348f8c72$export$16978d524c086b4(pathname) || $7864772e348f8c72$export$b6d6b41b75346458(pathname) || $7864772e348f8c72$export$5b2153f9a7427657(pathname) || $7864772e348f8c72$export$c5434c69e9b50e81(pathname) || $7864772e348f8c72$export$3a7002667b72e8d7(pathname) || $7864772e348f8c72$export$542a1f79f5837827(pathname) || $7864772e348f8c72$export$b748c9dbd5996d34(pathname) || $7864772e348f8c72$export$455a6199a321423(pathname) || $7864772e348f8c72$export$fa426b2da28e4ae2(pathname) || $7864772e348f8c72$export$fc0fba46b7584812(pathname) || $7864772e348f8c72$export$882325faa1a194c6(pathname) || $7864772e348f8c72$export$8bb0073f55baf38b(pathname) || $7864772e348f8c72$export$1b69f3aa169f179(pathname) || $7864772e348f8c72$export$1c47b1cb87da237(pathname) || $7864772e348f8c72$export$ee56a66aa8efb6da(pathname) || $7864772e348f8c72$export$6256b4d737fa56f2(pathname) || $7864772e348f8c72$export$3f77d24f8de610a0(pathname);
const $7864772e348f8c72$var$screenNameMap = {
    queues: $7864772e348f8c72$export$d7638addf23014e7,
    issues: $7864772e348f8c72$export$1b685dac913c7026,
    customers: $7864772e348f8c72$export$6292763547421a38,
    reports: $7864772e348f8c72$export$a05100bbf8bc68c3,
    knowledge: $7864772e348f8c72$export$e75cc3ec1f686973,
    services: $7864772e348f8c72$export$66d002c194bc72aa,
    onCall: $7864772e348f8c72$export$430089990bd4af09,
    incidents: $7864772e348f8c72$export$a655a298d384c316,
    problems: $7864772e348f8c72$export$1c5f444b718144b7,
    changes: $7864772e348f8c72$export$42dd8a49c7fa462c,
    serviceRequests: $7864772e348f8c72$export$5c77a7ea15a04e63,
    classicSettingsDetails: $7864772e348f8c72$export$dbf902576403f80e,
    classicSettingsPeople: $7864772e348f8c72$export$458d0b4237ae1dad,
    classicSettingsSummary: $7864772e348f8c72$export$3b5fbfd2bca32dde,
    classicSettingsIssueTypes: $7864772e348f8c72$export$aeffbab88b3257bb,
    classicSettingsRequestTypes: $7864772e348f8c72$export$7e3236de8c2c8fcb,
    classicSettingsChangeManagement: $7864772e348f8c72$export$908f99db4c2098a0,
    classicSettingsCustomerPermissions: $7864772e348f8c72$export$c5b9a5ba6b3e9b66,
    classicSettingsLanguage: $7864772e348f8c72$export$f4e3d864ce1a2f74,
    classicSettingsPortal: $7864772e348f8c72$export$21361d1ad00e769e,
    classicSettingsEmail: $7864772e348f8c72$export$6208845cb364d4de,
    classicSettingsEmailAlias: $7864772e348f8c72$export$16978d524c086b4,
    classicSettingsCustomerNotifications: $7864772e348f8c72$export$b6d6b41b75346458,
    classicSettingsWidget: $7864772e348f8c72$export$5b2153f9a7427657,
    classicSettingsFeedback: $7864772e348f8c72$export$c5434c69e9b50e81,
    classicSettingsConfluence: $7864772e348f8c72$export$3a7002667b72e8d7,
    classicSettingsSla: $7864772e348f8c72$export$542a1f79f5837827,
    classicSettingsAutomation: $7864772e348f8c72$export$b748c9dbd5996d34,
    classicSettingsApps: $7864772e348f8c72$export$455a6199a321423,
    classicSettingsWorkflows: $7864772e348f8c72$export$fa426b2da28e4ae2,
    classicSettingsScreens: $7864772e348f8c72$export$fc0fba46b7584812,
    classicSettingsFields: $7864772e348f8c72$export$882325faa1a194c6,
    classicSettingsVersions: $7864772e348f8c72$export$8bb0073f55baf38b,
    classicSettingsComponents: $7864772e348f8c72$export$1b69f3aa169f179,
    classicSettingsPermissions: $7864772e348f8c72$export$1c47b1cb87da237,
    classicSettingsIssueSecurity: $7864772e348f8c72$export$ee56a66aa8efb6da,
    classicSettingsNotifications: $7864772e348f8c72$export$6256b4d737fa56f2,
    classicSettingsIssueCollectors: $7864772e348f8c72$export$3f77d24f8de610a0
};
const $7864772e348f8c72$export$e2c4f60e8cad01fb = (pathname)=>(0, (/*@__PURE__*/$parcel$interopDefault($9UgXz)))($7864772e348f8c72$var$screenNameMap, (isCurrentScreen)=>isCurrentScreen(pathname)) || '';
const $7864772e348f8c72$export$8715824c16ceeca0 = (error)=>// these are out of our control so treat them as expected
    (0, $fZneA.isClientFetchError)(error);
const $7864772e348f8c72$var$GSP_EXCLUDED_PAGES_FILTER = {
    pathnameRegexes: [
        // 'Classic Settings Customer Notifications',
        '/servicedesk/admin/[\\w\\d]+/customer-notifications'
    ],
    pathnameRegexesForNple: [
        // 'Classic Settings Customer Notifications',
        '/servicedesk/admin/[\\w\\d]+/customer-notifications',
        // 'Portal Settings Page'
        '/jira/servicedesk/projects/[\\w\\d]+/settings/portal-settings',
        // 'People Page'
        '/plugins/servlet/project-config/[\\w\\d]+/people',
        // 'Getting Started Page'
        '/jira/servicedesk/projects/[\\w\\d]+/getting-started'
    ],
    routeNames: [
        // 'Reports',
        'servicedesk-reports',
        // 'Reports - Custom',
        'servicedesk-reports-custom',
        // 'Reports - Create',
        'servicedesk-reports-custom-create',
        // 'Reports - Edit',
        'servicedesk-reports-custom-edit',
        // 'Reports - Time Scale Issue',
        'servicedesk-reports-custom-time-scale-issue',
        // 'Reports - Time Scale',
        'servicedesk-reports-custom-time-scale',
        // 'Reports - Satisfaction',
        'servicedesk-reports-satisfaction',
        // 'Reports - Satisfaction Time Scale Issue',
        'servicedesk-reports-satisfaction-time-scale-issue',
        // 'Reports - Satisfaction TIme Scale',
        'servicedesk-reports-satisfaction-time-scale',
        // 'Reports - Type',
        'servicedesk-reports-type',
        // 'Reports - Workload',
        'servicedesk-reports-workload',
        // 'Queues - New',
        'servicedesk-queues-new',
        // 'Queues - Edit',
        'servicedesk-queues-edit'
    ]
};
const $7864772e348f8c72$var$GSP_INCLUDED_PAGES_FILTER = {
    pathnameRegexes: [
        '/jira/people/search'
    ]
};
const $7864772e348f8c72$export$83501d9ba065ef89 = (pathname)=>$7864772e348f8c72$var$GSP_INCLUDED_PAGES_FILTER.pathnameRegexes.some((regex)=>new RegExp(regex).test(pathname));
const $7864772e348f8c72$export$8752a3c4a740bd52 = (pathname, isNpleForItsmEnabled)=>isNpleForItsmEnabled ? $7864772e348f8c72$var$GSP_EXCLUDED_PAGES_FILTER.pathnameRegexesForNple.some((regex)=>new RegExp(regex).test(pathname)) : $7864772e348f8c72$var$GSP_EXCLUDED_PAGES_FILTER.pathnameRegexes.some((regex)=>new RegExp(regex).test(pathname));
const $7864772e348f8c72$export$5d52a100c70d4375 = (currentRouteName)=>$7864772e348f8c72$var$GSP_EXCLUDED_PAGES_FILTER.routeNames.some((routeName)=>routeName === currentRouteName);

});
parcelRegister("9UgXz", function(module, exports) {

var $fR2dZ = parcelRequire("fR2dZ");

var $hDnyx = parcelRequire("hDnyx");

var $bxDef = parcelRequire("bxDef");
/**
 * This method is like `_.find` except that it returns the key of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {string|undefined} Returns the key of the matched element,
 *  else `undefined`.
 * @example
 *
 * var users = {
 *   'barney':  { 'age': 36, 'active': true },
 *   'fred':    { 'age': 40, 'active': false },
 *   'pebbles': { 'age': 1,  'active': true }
 * };
 *
 * _.findKey(users, function(o) { return o.age < 40; });
 * // => 'barney' (iteration order is not guaranteed)
 *
 * // The `_.matches` iteratee shorthand.
 * _.findKey(users, { 'age': 1, 'active': true });
 * // => 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findKey(users, ['active', false]);
 * // => 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.findKey(users, 'active');
 * // => 'barney'
 */ function $73667fdf8c12f2c8$var$findKey(object, predicate) {
    return $fR2dZ(object, $bxDef(predicate, 3), $hDnyx);
}
module.exports = $73667fdf8c12f2c8$var$findKey;

});
parcelRegister("fR2dZ", function(module, exports) {
/**
 * The base implementation of methods like `_.findKey` and `_.findLastKey`,
 * without support for iteratee shorthands, which iterates over `collection`
 * using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the found element or its key, else `undefined`.
 */ function $b8ad880aaae778a0$var$baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
        if (predicate(value, key, collection)) {
            result = key;
            return false;
        }
    });
    return result;
}
module.exports = $b8ad880aaae778a0$var$baseFindKey;

});



parcelRegister("j25Gb", function(module, exports) {

$parcel$export(module.exports, "handleOpsTeamMode", () => $3e2c1b76a45e5e3a$export$b05151222ac96edd);

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");


var $aeeX4 = parcelRequire("aeeX4");
var $bx4nw = parcelRequire("bx4nw");
async function $3e2c1b76a45e5e3a$export$b05151222ac96edd(data, teamId, cloudId) {
    const mutatedData = {
        ...data
    };
    // we need to unset team centric items if they are set in the project page for the user
    mutatedData.completedItems = mutatedData.completedItems.filter((item)=>{
        if (item === (0, $aeeX4.TaskId).ReviewOnCallSetup || item === (0, $aeeX4.TaskId).AddIntegration) return false;
        return true;
    });
    // If user has not have right to see those items, we don't need to fetch them.
    if (mutatedData.properties.user['ops-admin-tasks-visibility'] === (0, $bx4nw.VisibilityValues).Visible) try {
        const teamCentricResponse = await (0, $7f4tk.default)(`/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/team/${teamId}/list/jsm-getting-started-panel`, {
            method: 'GET',
            mode: 'cors'
        });
        // we will override completed items by setting team-centric items
        mutatedData.completedItems = [
            ...mutatedData?.completedItems,
            ...teamCentricResponse?.completedItems
        ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // The list is not initialized yet
        if (error.statusCode !== 404) {
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'handleOpsTeamMode-TeamCentricResponse',
                    packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                    teamName: 'Alexstrasza'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
    return mutatedData;
}

});
parcelRegister("bx4nw", function(module, exports) {

$parcel$export(module.exports, "OpsVisibilityKeys", () => $a2143fca26914ad3$export$3cae6a891a2fb0c1);
$parcel$export(module.exports, "CompassOpsVisibilityKeys", () => $a2143fca26914ad3$export$2a53d231696f66e9);
$parcel$export(module.exports, "SdVisibilityKeys", () => $a2143fca26914ad3$export$9ffa2df2d13a51e4);
$parcel$export(module.exports, "OgVisibilityKeys", () => $a2143fca26914ad3$export$37aa46ee833f23f2);
$parcel$export(module.exports, "VisibilityValues", () => $a2143fca26914ad3$export$b715b908ae0969fa);
$parcel$export(module.exports, "SdVisibilityRoles", () => $a2143fca26914ad3$export$47a23917fcedd235);
var $a2143fca26914ad3$export$3cae6a891a2fb0c1 = /*#__PURE__*/ function(OpsVisibilityKeys) {
    OpsVisibilityKeys["OpsTasksVisibility"] = "ops-tasks-visibility";
    OpsVisibilityKeys["OpsAdminTasksVisibility"] = "ops-admin-tasks-visibility";
    return OpsVisibilityKeys;
}({});
var $a2143fca26914ad3$export$2a53d231696f66e9 = /*#__PURE__*/ function(CompassOpsVisibilityKeys) {
    CompassOpsVisibilityKeys["CompassOpsTasksVisibility"] = "compass-ops-tasks-visibility";
    CompassOpsVisibilityKeys["CompassOpsAdminTasksVisibility"] = "compass-ops-admin-tasks-visibility";
    return CompassOpsVisibilityKeys;
}({});
var $a2143fca26914ad3$export$9ffa2df2d13a51e4 = /*#__PURE__*/ function(SdVisibilityKeys) {
    SdVisibilityKeys["SdStandardTasksVisibility"] = "servicedesk-standard-tasks-visibility";
    SdVisibilityKeys["SdAdvancedTasksVisibility"] = "servicedesk-advanced-tasks-visibility";
    return SdVisibilityKeys;
}({});
var $a2143fca26914ad3$export$37aa46ee833f23f2 = /*#__PURE__*/ function(OgVisibilityKeys) {
    OgVisibilityKeys["OgSetupProfileForNotificationsTaskVisibility"] = "opsgenie-user-profile-notifications-setup-task-visibility";
    OgVisibilityKeys["OgSetupTeamTaskVisibility"] = "opsgenie-response-team-setup-task-visibility";
    OgVisibilityKeys["OgAssignOwnerTeamToServicesTaskVisibility"] = "opsgenie-owner-team-assigned-to-service-task-visibility";
    OgVisibilityKeys["OgLevelUpIncidentManagementTaskVisibility"] = "opsgenie-incident-management-documentation-accessed-task-visibility";
    return OgVisibilityKeys;
}({});
var $a2143fca26914ad3$export$b715b908ae0969fa = /*#__PURE__*/ function(VisibilityValues) {
    VisibilityValues["Hidden"] = "hidden";
    VisibilityValues["Visible"] = "visible";
    VisibilityValues["Unset"] = "unset";
    return VisibilityValues;
}({});
var $a2143fca26914ad3$export$47a23917fcedd235 = /*#__PURE__*/ function(SdVisibilityRoles) {
    SdVisibilityRoles["Advanced"] = "advanced";
    SdVisibilityRoles["Standard"] = "standard";
    return SdVisibilityRoles;
}({});

});


parcelRegister("eRXyM", function(module, exports) {

$parcel$export(module.exports, "handleUserCentricMode", () => $d050cf1516f8f999$export$10caa25085bdca55);

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");


var $aeeX4 = parcelRequire("aeeX4");
async function $d050cf1516f8f999$export$10caa25085bdca55(data, cloudId) {
    const mutatedData = {
        ...data
    };
    // we need to unset user centric items if they are set in the ops team page for that user
    mutatedData.completedItems = mutatedData.completedItems.filter((item)=>{
        if (item === (0, $aeeX4.TaskId).ReviewOnCallSetup || item === (0, $aeeX4.TaskId).AddIntegration) return false;
        return true;
    });
    try {
        const userCentricResponse = await (0, $7f4tk.default)(`/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/user/list/jsm-getting-started-panel`, {
            method: 'GET',
            mode: 'cors'
        });
        // we will override completed items by getting/setting user-centric endpoint
        const userCentricCompletedItems = userCentricResponse.completedItems.filter((item)=>{
            if (item === (0, $aeeX4.TaskId).ReviewOnCallSetup || item === (0, $aeeX4.TaskId).AddIntegration) return true;
            return false;
        });
        mutatedData.completedItems = [
            ...mutatedData.completedItems,
            ...userCentricCompletedItems
        ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // The list is not initialized yet
        if (error.statusCode !== 404) {
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'handleUserCentricMode-UserCentricResponse',
                    packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                    teamName: 'Alexstrasza'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
    return mutatedData;
}

});

parcelRegister("5lmbj", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $9d35edf9adbf7852$export$94df0e59ebebf4a7);
$parcel$export(module.exports, "initializeState", () => $9d35edf9adbf7852$export$3ee49b4c70c0ec29);

var $hGgHi = parcelRequire("hGgHi");

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $8zOmE = parcelRequire("8zOmE");


var $7aw4m = parcelRequire("7aw4m");

var $kwNTl = parcelRequire("kwNTl");
var $bx4nw = parcelRequire("bx4nw");

var $j25Gb = parcelRequire("j25Gb");

var $eRXyM = parcelRequire("eRXyM");

var $jVCdW = parcelRequire("jVCdW");
const $9d35edf9adbf7852$export$94df0e59ebebf4a7 = ({ baseUrl: baseUrl, cloudId: cloudId })=>`${baseUrl}/jsm/onboarding/checklist/v1/cloudid/${cloudId}/aggregate/list/jsm-getting-started-panel`;
const $9d35edf9adbf7852$export$3ee49b4c70c0ec29 = (actionProps)=>({ setState: setState, getState: getState, dispatch: dispatch })=>async ({ projectId: projectId })=>{
            const { baseUrl: baseUrl, cloudId: cloudId, isItsmSampleProject: isItsmSampleProject, createAnalyticsEvent: createAnalyticsEvent, enableOpsTeamMode: enableOpsTeamMode, teamId: teamId, enableUserCentricMode: enableUserCentricMode } = actionProps;
            // Do not initialize unless it's known that project is not sample ITSM project
            if (isItsmSampleProject !== false) {
                if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(isItsmSampleProject)) (0, $jcw0u.default)({
                    meta: {
                        id: 'initializeState_isItsmSampleProject_unknown',
                        packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    }
                });
                return;
            }
            const initializeStateOnce = async (attemptIndex, totalAttempts)=>{
                const isFinalAttempt = attemptIndex === totalAttempts - 1;
                // Stop any other updates to the state that might occur
                setState({
                    isSaving: true
                });
                // Fetch any existing data from ST (this will include any task visibility keys)
                let response;
                try {
                    response = await (0, $7f4tk.default)($9d35edf9adbf7852$export$94df0e59ebebf4a7({
                        baseUrl: baseUrl,
                        cloudId: cloudId
                    }), {
                        method: 'GET',
                        mode: 'cors',
                        credentials: 'include'
                    });
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    // 404 indicates that the checklist is not yet initialized for the user
                    if (error.statusCode === 404) {
                        setState({
                            isSaving: false,
                            isGspInitialized: false
                        });
                        return;
                    }
                    setState({
                        isSaving: false
                    });
                    if (isFinalAttempt) (0, $jcw0u.default)({
                        error: error,
                        meta: {
                            id: 'initializeState_fetch',
                            packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                            teamName: 'itops-mithril'
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                    throw error;
                }
                // TODO: validate properly https://jdog.jira-dev.com/browse/JIG-392
                // We can't use constructDataFromResponse because initial server data only
                // contains a subset of the full GSP state (just task visiblity keys)
                const serverData = response;
                /* Merge in server values and defaults, according to the following:
			 *  - completedItems from default state, to allow for reset behaviour with FSF override flag
			 *  - properties comes from server values first, to add task visibility and non-user properties
			 *  - default state user properties are merged in over the top of server properties to reset
			 *    things like sectionState, activeState, visualState, hasSeenReopenSpotlight in the
			 *    case of FSF override flag where server state already exists.
			 *    Assumption: the only properties contained in the default state are user properties
			 *  - projectId from current project
			 */ let data = {
                    completedItems: (0, $kwNTl.defaultGspState).completedItems,
                    properties: {
                        ...serverData.properties,
                        user: {
                            ...serverData.properties.user,
                            ...(0, $kwNTl.defaultGspState).properties.user,
                            projectId: projectId
                        }
                    }
                };
                if (enableUserCentricMode && data) data = await (0, $eRXyM.handleUserCentricMode)(data, cloudId);
                else if (enableOpsTeamMode && teamId && data) {
                    const opsAdminTaskVisibility = getState().data?.properties.user['ops-admin-tasks-visibility'] ?? (0, $bx4nw.VisibilityValues).Hidden;
                    data.properties.user['ops-admin-tasks-visibility'] = opsAdminTaskVisibility;
                    data = await (0, $j25Gb.handleOpsTeamMode)(data, teamId, cloudId);
                }
                // Save our newly merged state
                try {
                    setState({
                        data: data,
                        isGspInitialized: true,
                        isSaving: false
                    });
                    await dispatch((0, $jVCdW.savePanelState)(actionProps))(data);
                    (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b)}.initializeState succeeded`);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    setState({
                        isGspInitialized: true,
                        isSaving: false
                    });
                    if (isFinalAttempt) (0, $jcw0u.default)({
                        error: error,
                        meta: {
                            id: 'initializeState',
                            packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                            teamName: 'itops-mithril'
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            };
            await (0, $7aw4m.withExponentialBackoffRetries)({
                callback: initializeStateOnce,
                totalAttempts: 5,
                baseIntervalMs: 500
            });
        };

});
parcelRegister("7aw4m", function(module, exports) {

$parcel$export(module.exports, "withExponentialBackoffRetries", () => $2286d0a3de3201e1$export$344601bd15a7b6d);
const $2286d0a3de3201e1$var$waitTimeMs = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
const $2286d0a3de3201e1$export$344601bd15a7b6d = async ({ callback: callback, totalAttempts: totalAttempts, baseIntervalMs: baseIntervalMs })=>{
    for(let attemptIndex = 0; attemptIndex < totalAttempts; attemptIndex += 1)/* eslint-disable no-await-in-loop */ try {
        return await callback(attemptIndex, totalAttempts);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (attemptIndex + 1 < totalAttempts) // if retry attempts remain, wait time before trying again
        await $2286d0a3de3201e1$var$waitTimeMs(baseIntervalMs * Math.pow(2, attemptIndex));
        else // else if no more attempts, throw the error
        throw error;
    }
    throw Error('withExponentialBackoffRetries should not reach');
};

});

parcelRegister("kwNTl", function(module, exports) {

$parcel$export(module.exports, "defaultGspState", () => $4b9c4470b77dfabd$export$4db8363977bdf2d4);
$parcel$export(module.exports, "GSP", () => $4b9c4470b77dfabd$export$1cb8c028028700ec);

var $aeeX4 = parcelRequire("aeeX4");
// This is duplicated to avoid importing from section-state
// to attempt to keep bundle size down.
// These values must be manually kept in sync.
const $4b9c4470b77dfabd$var$defaultSectionStateV2 = {
    version: 2,
    activeSection: (0, $aeeX4.GspSectionKey).Home,
    sections: {
        checklist: {
            headerState: (0, $aeeX4.HeaderState).Expanded,
            activeTab: (0, $aeeX4.ChecklistTabKey).Basics,
            tabs: {
                basics: {
                    activeTask: undefined
                },
                teamEfficiency: {
                    activeTask: undefined
                },
                incidents: {
                    activeTask: undefined
                },
                changes: {
                    activeTask: undefined
                },
                alerts: {
                    activeTask: undefined
                },
                compassAlerts: {
                    activeTask: undefined
                }
            }
        },
        productTours: {
            headerState: (0, $aeeX4.HeaderState).Expanded,
            activeTour: (0, $aeeX4.ProductTourKey).Welcome
        }
    }
};
const $4b9c4470b77dfabd$export$4db8363977bdf2d4 = {
    completedItems: [
        (0, $aeeX4.TaskId).CreateItsmProject
    ],
    properties: {
        containers: [],
        user: {
            activeState: (0, $aeeX4.ActiveState).On,
            visualState: (0, $aeeX4.VisualState).FullPanel,
            sectionState: JSON.stringify($4b9c4470b77dfabd$var$defaultSectionStateV2),
            hasSeenReopenSpotlight: (0, $aeeX4.HasSeenReopenSpotlight).No
        }
    }
};
const $4b9c4470b77dfabd$export$1cb8c028028700ec = 'GettingStartedPanel';

});

parcelRegister("jVCdW", function(module, exports) {

$parcel$export(module.exports, "savePanelState", () => $8308a60f9f5d610a$export$8756ef0989d9dd58);

var $jcw0u = parcelRequire("jcw0u");

var $7zmUm = parcelRequire("7zmUm");

var $8zOmE = parcelRequire("8zOmE");


var $7aw4m = parcelRequire("7aw4m");
const $8308a60f9f5d610a$var$getUrl = ({ baseUrl: baseUrl, cloudId: cloudId })=>`${baseUrl}/jsm/onboarding/checklist/v1/cloudid/${cloudId}/user/list/jsm-getting-started-panel/properties`;
const $8308a60f9f5d610a$export$8756ef0989d9dd58 = ({ baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState })=>async (state)=>{
            const { data: data } = getState();
            try {
                if (!data) throw new Error('Trying to save panel state without current GSP state.');
                // Set the state locally without waiting for the API call
                setState({
                    data: state,
                    isSaving: true
                });
                const { sectionState: sectionState, activeState: activeState, visualState: visualState, projectId: projectId, hasSeenReopenSpotlight: hasSeenReopenSpotlight } = state.properties.user;
                await (0, $7aw4m.withExponentialBackoffRetries)({
                    callback: ()=>(0, $7zmUm.default)($8308a60f9f5d610a$var$getUrl({
                            baseUrl: baseUrl,
                            cloudId: cloudId
                        }), {
                            method: 'POST',
                            credentials: 'include',
                            body: JSON.stringify({
                                sectionState: sectionState,
                                activeState: activeState,
                                visualState: visualState,
                                projectId: projectId,
                                hasSeenReopenSpotlight: hasSeenReopenSpotlight
                            })
                        }).toPromise(),
                    totalAttempts: 5,
                    baseIntervalMs: 500
                });
                setState({
                    isSaving: false
                });
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b)}.savePanelState succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    isSaving: false
                });
                (0, $jcw0u.default)({
                    error: error,
                    meta: {
                        id: 'savePanelState',
                        packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        };

});
parcelRegister("7zmUm", function(module, exports) {

$parcel$export(module.exports, "default", () => $198ed207dec01cca$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $5HnTq = parcelRequire("5HnTq");

var $fnyT4 = parcelRequire("fnyT4");

var $jJZqs = parcelRequire("jJZqs");

var $8KpGl = parcelRequire("8KpGl");

var $51xpa = parcelRequire("51xpa");
const $198ed207dec01cca$var$noContentStatus = 204;
var // This function returns a stream which emits a single string value on success, and throws
// an error on failure
// eslint-disable-next-line jira/import/no-anonymous-default-export
$198ed207dec01cca$export$2e2bcd8739ae039 = (url, options = {})=>(0, $kVLXA.Observable).of(url).mergeMap(()=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $7uUwQ.merge)((0, $7uUwQ.merge)((0, $5HnTq.defaultOptions), options), (0, $51xpa.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (!response.ok) {
            const { status: status } = response;
            const traceId = response.headers.get((0, $fnyT4.TRACE_ID_HEADER));
            if (traceId != null && traceId !== '') throw new (0, $jJZqs.default)(status, `Fetch call failed with status code: ${response.status}`, traceId);
            else throw new (0, $jJZqs.default)(status);
        }
        if (response.status === $198ed207dec01cca$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $kVLXA.Observable).of(null);
        // @ts-expect-error - TS2339 - Property 'responseText' does not exist on type 'Response'.
        return (0, $kVLXA.Observable).of(response.responseText || 'OK');
    });

});




parcelRegister("WkJdq", function(module, exports) {

$parcel$export(module.exports, "markReopenSpotlightAsSeen", () => $8fcd1eec0dfcfd09$export$e6838fe71dc9c3f5);

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");


var $aeeX4 = parcelRequire("aeeX4");

var $jVCdW = parcelRequire("jVCdW");
const $8fcd1eec0dfcfd09$export$e6838fe71dc9c3f5 = (actionProps)=>({ getState: getState, dispatch: dispatch })=>async ()=>{
            const { data: data } = getState();
            try {
                if (!data) throw new Error('Trying to mark reopen spotlight as seen without current state');
                await dispatch((0, $jVCdW.savePanelState)(actionProps))({
                    ...data,
                    properties: {
                        ...data.properties,
                        user: {
                            ...data.properties.user,
                            hasSeenReopenSpotlight: (0, $aeeX4.HasSeenReopenSpotlight).Yes
                        }
                    }
                });
                (0, $8zOmE.fireTrackAnalytics)(actionProps.createAnalyticsEvent({}), `${(0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b)}.markReopenSpotlightAsSeen succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $jcw0u.default)({
                    error: error,
                    meta: {
                        id: 'markReopenSpotlightAsSeen',
                        packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        };

});

parcelRegister("aLRn2", function(module, exports) {

$parcel$export(module.exports, "reopenGettingStartedPanel", () => $8b8ba476581e4096$export$3f8a23b1578c0a37);

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");


var $7aw4m = parcelRequire("7aw4m");

var $aeeX4 = parcelRequire("aeeX4");

var $5lmbj = parcelRequire("5lmbj");

var $kTf1j = parcelRequire("kTf1j");
const $8b8ba476581e4096$export$3f8a23b1578c0a37 = (actionProps)=>({ getState: getState, dispatch: dispatch })=>async ({ projectId: projectId } = {})=>{
            const getStateIfLoaded = async ()=>{
                const state = getState();
                const dataNotYetLoaded = state.isGspInitialized && state.data === undefined;
                if (dataNotYetLoaded) throw new Error('GSP data not yet loaded when trying to reopen');
                return state;
            };
            try {
                // a user can exit a tour and call `reopenGettingStartedPanel` before the GSP
                // state has loaded so retry a few times and hopefully the data will be there.
                // This will only log the final error that is thrown after the retries are exhausted.
                // 6 attempts at 500ms base interval gives us a ~15 second window. We could wait longer
                // but then the GSP reopening would be so far removed from closing the tour that it
                // probably isn't the user experience that we want
                const { data: data, isGspInitialized: isGspInitialized } = await (0, $7aw4m.withExponentialBackoffRetries)({
                    callback: getStateIfLoaded,
                    totalAttempts: 6,
                    baseIntervalMs: 500
                });
                if (!isGspInitialized) {
                    if (projectId !== undefined) {
                        await dispatch((0, $5lmbj.initializeState)(actionProps))({
                            projectId: projectId
                        });
                        return;
                    }
                    throw new Error('No projectId to initialize GSP with');
                }
                if (!data) throw new Error('Trying to reopen GSP without current state');
                await dispatch((0, $kTf1j.saveProperty)(actionProps))({
                    key: (0, $aeeX4.PropertyKey).VisualState,
                    value: (0, $aeeX4.VisualState).FullPanel
                });
                await dispatch((0, $kTf1j.saveProperty)(actionProps))({
                    key: (0, $aeeX4.PropertyKey).ActiveState,
                    value: (0, $aeeX4.ActiveState).On
                });
                (0, $8zOmE.fireTrackAnalytics)(actionProps.createAnalyticsEvent({}), `${(0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b)}.reopenGettingStartedPanel succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $jcw0u.default)({
                    error: error,
                    meta: {
                        id: 'reopenGettingStartedPanel',
                        packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        };

});
parcelRegister("kTf1j", function(module, exports) {

$parcel$export(module.exports, "saveProperty", () => $424bc97a870986cf$export$3d751d226e9d1512);

var $jcw0u = parcelRequire("jcw0u");

var $7zmUm = parcelRequire("7zmUm");

var $8zOmE = parcelRequire("8zOmE");


var $7aw4m = parcelRequire("7aw4m");
const $424bc97a870986cf$var$getUrl = ({ baseUrl: baseUrl, cloudId: cloudId })=>`${baseUrl}/jsm/onboarding/checklist/v1/cloudid/${cloudId}/user/list/jsm-getting-started-panel/properties`;
const $424bc97a870986cf$export$3d751d226e9d1512 = ({ baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState })=>async ({ key: key, value: value })=>{
            const { data: data } = getState();
            try {
                if (!data) throw new Error('Trying to save property without current GSP state.');
                // Set the state locally without waiting for the API call
                setState({
                    data: {
                        ...data,
                        properties: {
                            ...data.properties,
                            user: {
                                ...data.properties.user,
                                [key.toString()]: value
                            }
                        }
                    },
                    isSaving: true
                });
                await (0, $7aw4m.withExponentialBackoffRetries)({
                    callback: ()=>(0, $7zmUm.default)($424bc97a870986cf$var$getUrl({
                            baseUrl: baseUrl,
                            cloudId: cloudId
                        }), {
                            method: 'POST',
                            credentials: 'include',
                            body: JSON.stringify({
                                [key.toString()]: value
                            })
                        }).toPromise(),
                    totalAttempts: 5,
                    baseIntervalMs: 500
                });
                setState({
                    isSaving: false
                });
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b)}.saveProperty succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    isSaving: false
                });
                (0, $jcw0u.default)({
                    error: error,
                    meta: {
                        id: 'saveProperty',
                        packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };

});


parcelRegister("6g0vj", function(module, exports) {

$parcel$export(module.exports, "resolveTask", () => $111c5eed0cfc16aa$export$7c43f246bcca61d3);

var $jcw0u = parcelRequire("jcw0u");

var $7zmUm = parcelRequire("7zmUm");

var $8zOmE = parcelRequire("8zOmE");


var $7aw4m = parcelRequire("7aw4m");

var $g5X3G = parcelRequire("g5X3G");
// Data taken from https://hello.atlassian.net/wiki/spaces/VPORT/pages/808505558/Checklist+Item+Scope+Auto+API+for+Completion
// where 'project' === 'container', 'user' === 'user' and 'instance' === 'workspace'
const $111c5eed0cfc16aa$var$getScopeFromTaskId = (taskId)=>{
    switch(taskId){
        // String literals used instead of `TaskId.<task>` for flow to acknowledge
        // that this is an exhaustive switch statement
        case 'servicedesk-itsm-project-created':
        case 'servicedesk-portal-name-customized':
        case 'servicedesk-logo-added-to-portal':
        case 'servicedesk-email-requests-setup':
        case 'servicedesk-team-member-added':
            return 'container';
        case 'servicedesk-change-management-documentation-accessed':
        case 'servicedesk-basics-documentation-accessed':
        case 'servicedesk-queue-configurations-reviewed':
        case 'servicedesk-request-types-customised':
        case 'servicedesk-request-channels-email-portal-requests-customised':
        case 'servicedesk-chat-requests-setup':
            return 'user';
        case 'servicedesk-services-setup':
        case 'servicedesk-change-management-pipeline-connected':
        case 'servicedesk-change-management-change-approvers-added':
        case 'servicedesk-change-management-automation-rules-on':
            return 'workspace';
        // Note that the following should only ever be completed in
        // Opsgenie but they are included here for type completeness
        case 'opsgenie-user-profile-notifications-setup':
        case 'opsgenie-incident-management-documentation-accessed':
            return 'user';
        case 'opsgenie-response-team-setup':
        case 'opsgenie-owner-team-assigned-to-service':
            return 'workspace';
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            taskId; // type level assertion that we have an exhaustive switch
            throw new Error(`Unknown scope for task ${taskId}`); // runtime assertion
    }
};
const $111c5eed0cfc16aa$export$94df0e59ebebf4a7 = ({ baseUrl: baseUrl, cloudId: cloudId, scope: scope, projectId: projectId, taskId: taskId })=>{
    let scopePath = ''; // scope === 'workspace'
    if (scope === 'container') scopePath = `project/${projectId}/`;
    if (scope === 'user') scopePath = 'user/';
    return `${baseUrl}/jsm/onboarding/checklist/v1/cloudid/${cloudId}/${scopePath}list/jsm-getting-started-panel/item/${taskId}`;
};
const $111c5eed0cfc16aa$export$7c43f246bcca61d3 = ({ baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState })=>async (taskId)=>{
            const { data: data } = getState();
            try {
                if (!data) return;
                const { completedItems: completedItems, properties: properties } = data;
                const isTaskAlreadyCompleted = completedItems.includes(taskId);
                if (!isTaskAlreadyCompleted) {
                    const updatedTasks = [
                        ...completedItems,
                        taskId
                    ];
                    // Set the state locally without waiting for the API call
                    setState({
                        data: {
                            ...data,
                            completedItems: updatedTasks
                        },
                        isSaving: true
                    });
                    // Hit the appropriate checklist scope endpoint to add the newly completed task
                    const scope = $111c5eed0cfc16aa$var$getScopeFromTaskId(taskId);
                    const projectId = (0, $g5X3G.toProjectId)(properties.user.projectId || '');
                    await (0, $7aw4m.withExponentialBackoffRetries)({
                        callback: ()=>(0, $7zmUm.default)($111c5eed0cfc16aa$export$94df0e59ebebf4a7({
                                baseUrl: baseUrl,
                                cloudId: cloudId,
                                scope: scope,
                                projectId: projectId,
                                taskId: taskId
                            }), {
                                method: 'POST',
                                credentials: 'include'
                            }).toPromise(),
                        totalAttempts: 5,
                        baseIntervalMs: 500
                    });
                    // Resume polling for GSP state
                    setState({
                        isSaving: false
                    });
                }
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b)}.resolveTask succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    isSaving: false
                });
                (0, $jcw0u.default)({
                    error: error,
                    meta: {
                        id: 'resolveTask',
                        packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        };

});

parcelRegister("01F1V", function(module, exports) {

$parcel$export(module.exports, "setOpsAdminTaskVisibility", () => $3b1848fd2fed3e69$export$b9e7846826f1ebfd);

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");


var $bx4nw = parcelRequire("bx4nw");
const $3b1848fd2fed3e69$export$b9e7846826f1ebfd = ({ teamId: teamId, cloudId: cloudId })=>({ getState: getState, setState: setState })=>async ()=>{
            const { data: data } = getState();
            if (!data) throw new Error('Trying to set ops admin task visibility without current GSP state.');
            try {
                const adminTaskVisibilityResponse = await (0, $7f4tk.default)(`/gateway/api/jsm/ops/web/${cloudId}/v1/onboarding/full-panel-access?platformTeamId=${teamId}
            `, {
                    method: 'GET'
                });
                const visibility = adminTaskVisibilityResponse.embeddedValue ? (0, $bx4nw.VisibilityValues).Visible : (0, $bx4nw.VisibilityValues).Hidden;
                setState({
                    data: {
                        ...data,
                        properties: {
                            ...data.properties,
                            user: {
                                ...data.properties.user,
                                'ops-admin-tasks-visibility': visibility
                            }
                        }
                    }
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    data: {
                        ...data,
                        properties: {
                            ...data.properties,
                            user: {
                                ...data.properties.user,
                                'ops-admin-tasks-visibility': (0, $bx4nw.VisibilityValues).Hidden
                            }
                        }
                    }
                });
                (0, $jcw0u.default)({
                    error: error,
                    meta: {
                        id: 'setOpsAdminTaskVisibility',
                        packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                        teamName: 'Alexstrasza'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };

});

parcelRegister("9FflN", function(module, exports) {

$parcel$export(module.exports, "stopRecordingPerformanceExperiences", () => $0ed29e6b515a7853$export$3566fd94709fa84a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $0ed29e6b515a7853$export$3566fd94709fa84a = ()=>({ setState: setState })=>()=>{
            setState({
                shouldRecordPerformanceExperiences: false
            });
        };

});



parcelRegister("cf7yQ", function(module, exports) {

$parcel$export(module.exports, "JsdGettingStartedPanelShouldRender", () => $8aa55ef5824c4e4d$export$46976e0f90edfcfe);
$parcel$export(module.exports, "JsdGettingStartedPanel", () => $8aa55ef5824c4e4d$export$6f9913539cfb4ab6);
$parcel$export(module.exports, "JsdGettingStartedPanelOpenButton", () => $8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad);
$parcel$export(module.exports, "JsdGettingStartedPanelReopenSpotlight", () => $8aa55ef5824c4e4d$export$c7732c55900cf0b9);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelShouldRender = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("5DTXc")).then(({ JsdGettingStartedPanelShouldRender: JsdGettingStartedPanelShouldRender })=>JsdGettingStartedPanelShouldRender), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/should-render/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanel = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("1Gae1")).then(({ JsdGettingStartedPanel: JsdGettingStartedPanel })=>JsdGettingStartedPanel), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/panel/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelOpenButton = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("8Jf7e")).then(({ JsdGettingStartedPanelOpenButton: JsdGettingStartedPanelOpenButton })=>JsdGettingStartedPanelOpenButton), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/open-button/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelReopenSpotlight = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("41w1E")).then(({ JsdGettingStartedPanelReopenSpotlight: JsdGettingStartedPanelReopenSpotlight })=>JsdGettingStartedPanelReopenSpotlight), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/reopen-spotlight/async.tsx"
});
const $8aa55ef5824c4e4d$export$46976e0f90edfcfe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-should-render",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelShouldRender, null));
$8aa55ef5824c4e4d$export$46976e0f90edfcfe.displayName = 'AsyncJsdGettingStartedPanelShouldRender';
const $8aa55ef5824c4e4d$export$6f9913539cfb4ab6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-panel",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanel, null));
$8aa55ef5824c4e4d$export$6f9913539cfb4ab6.displayName = 'AsyncJsdGettingStartedPanel';
const $8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-open-button",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelOpenButton, null));
$8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad.displayName = 'AsyncJsdGettingStartedPanelOpenButton';
const $8aa55ef5824c4e4d$export$c7732c55900cf0b9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-reopen-spotlight",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelReopenSpotlight, null));
$8aa55ef5824c4e4d$export$c7732c55900cf0b9.displayName = 'AsyncJsdGettingStartedPanelReopenSpotlight';

});
parcelRegister("5DTXc", function(module, exports) {

let $41bbff89fe37fc18$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $41bbff89fe37fc18$var$load("kVX56"),
    $41bbff89fe37fc18$var$load("it614")
]).then(()=>parcelRequire('hZyYK'));

});

parcelRegister("1Gae1", function(module, exports) {

let $1391a53316aa0a08$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $1391a53316aa0a08$var$load("kVX56"),
    $1391a53316aa0a08$var$load("76n7a"),
    $1391a53316aa0a08$var$load("l253H"),
    $1391a53316aa0a08$var$load("bET2R")
]).then(()=>parcelRequire('2NciN'));

});

parcelRegister("8Jf7e", function(module, exports) {

let $65ae405bb0a885ec$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $65ae405bb0a885ec$var$load("kVX56"),
    $65ae405bb0a885ec$var$load("76n7a"),
    $65ae405bb0a885ec$var$load("l253H"),
    $65ae405bb0a885ec$var$load("7yzag")
]).then(()=>parcelRequire('4F6ZA'));

});

parcelRegister("41w1E", function(module, exports) {

let $2ee0190d7637d443$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $2ee0190d7637d443$var$load("kVX56"),
    $2ee0190d7637d443$var$load("76n7a"),
    $2ee0190d7637d443$var$load("l253H"),
    $2ee0190d7637d443$var$load("2vlLl")
]).then(()=>parcelRequire('6Wput'));

});


parcelRegister("lXCei", function(module, exports) {

$parcel$export(module.exports, "useInitializeActiveTab", () => $5c30285de08a922f$export$b0f185249c3d08fd);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $95LwL = parcelRequire("95LwL");

var $6juLJ = parcelRequire("6juLJ");

var $kwNTl = parcelRequire("kwNTl");
var $aeeX4 = parcelRequire("aeeX4");
const $5c30285de08a922f$export$b0f185249c3d08fd = (activeTabName, gspProjectId)=>{
    const { isFirstProject: isFirstProject, isFirstProjectItsm: isFirstProjectItsm } = (0, $95LwL.useIsFirstProjectITSM)(gspProjectId);
    const isNpleForItsmEnabled = isFirstProject && isFirstProjectItsm && (0, $6s1PB.expValEquals)('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation');
    const [{ data: gspStateData }, { saveProperty: saveProperty }] = (0, $6juLJ.useGettingStartedPanelState)();
    const [isInitializedActiveTab, setIsInitializedActiveTab] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (activeTabName === '') return;
        if (!isInitializedActiveTab && isNpleForItsmEnabled && gspStateData) {
            const sectionStateJSON = gspStateData.properties?.user?.sectionState ?? (0, $kwNTl.defaultGspState).properties.user.sectionState;
            const sectionState = JSON.parse(sectionStateJSON);
            if (sectionState.sections.checklist.activeTab !== activeTabName) {
                sectionState.sections.checklist.activeTab = activeTabName;
                saveProperty({
                    key: (0, $aeeX4.PropertyKey).SectionState,
                    value: JSON.stringify(sectionState)
                });
            }
            setIsInitializedActiveTab(true);
        }
    }, [
        isNpleForItsmEnabled,
        gspStateData,
        saveProperty,
        activeTabName,
        isInitializedActiveTab
    ]);
    const resetInitialization = ()=>setIsInitializedActiveTab(false);
    return {
        resetInitialization: resetInitialization
    };
};

});

parcelRegister("6XsPQ", function(module, exports) {

$parcel$export(module.exports, "HistoryAdapter", () => $c364a1ba7d823379$export$d852f51b8427aefc);

var $5uXOq = parcelRequire("5uXOq");

var $1bQGJ = parcelRequire("1bQGJ");

var $8oKIZ = parcelRequire("8oKIZ");
// eslint-disable-next-line jira/react/no-class-components
class $c364a1ba7d823379$var$HistoryAdapterComponent extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
        this.compatibleHistory = (0, $8oKIZ.createReactRouterCompatibleHistory)(props.history);
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.children !== this.props.children;
    }
    componentWillUnmount() {
        this.compatibleHistory.destroy && this.compatibleHistory.destroy();
    }
    render() {
        const { children: children } = this.props;
        return children(this.compatibleHistory);
    }
}
const $c364a1ba7d823379$export$d852f51b8427aefc = (0, $1bQGJ.withRouter)($c364a1ba7d823379$var$HistoryAdapterComponent);

});
parcelRegister("8oKIZ", function(module, exports) {

$parcel$export(module.exports, "createReactRouterCompatibleHistory", () => $e043da36553b4806$export$2df73cd79c2401bf);

var $bxYf9 = parcelRequire("bxYf9");
const $e043da36553b4806$export$2df73cd79c2401bf = (history)=>{
    let cleaned = false;
    let listeners = [];
    // @ts-expect-error - TS2304 - Cannot find name 'HistoryAction'.
    const listen = (callback)=>{
        if (cleaned) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        const unsubscribe = (0, (/*@__PURE__*/$parcel$interopDefault($bxYf9)))(history.listen(callback));
        const listener = {
            unsubscribe: unsubscribe
        };
        listeners.push(listener);
        return (0, (/*@__PURE__*/$parcel$interopDefault($bxYf9)))(()=>{
            listener.unsubscribe();
        });
    };
    const cleanup = ()=>{
        listeners.forEach(({ unsubscribe: unsubscribe })=>{
            unsubscribe();
        });
        cleaned = true;
        listeners = [];
    };
    return {
        get length () {
            return history.length;
        },
        get location () {
            return history.location;
        },
        get action () {
            return history.action;
        },
        get index () {
            return history.index;
        },
        get entries () {
            return history.entries;
        },
        // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
        push: (path, state)=>history.push(path, state),
        // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
        replace: (path, state)=>history.replace(path, state),
        // @ts-expect-error - TS7006 - Parameter 'n' implicitly has an 'any' type.
        go: (n)=>history.go(n),
        goBack: ()=>history.goBack(),
        goForward: ()=>history.goForward(),
        // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
        createHref: (...args)=>history.createHref(...args),
        // Memory only
        // @ts-expect-error - TS7006 - Parameter 'n' implicitly has an 'any' type.
        canGo: (n)=>{
            if (history.canGo) return history.canGo(n);
            return true;
        },
        listen: listen,
        // @ts-expect-error - TS7006 - Parameter 'blocker' implicitly has an 'any' type.
        block: (blocker)=>history.block(blocker),
        destroy: cleanup
    };
};

});


parcelRegister("bPvna", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee44373ada01d76d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $hsGgw = parcelRequire("hsGgw");

var $7OSF3 = parcelRequire("7OSF3");

var $8gRFs = parcelRequire("8gRFs");

const $ee44373ada01d76d$var$EmbeddableDirectory = (props)=>{
    const { addFlag: addFlag, appName: appName, contextSpaPaths: contextSpaPaths, contextEntryPoint: contextEntryPoint, locale: locale, push: push, replace: replace, docTitle: docTitle, statusCodeHandlers: statusCodeHandlers, env: env, history: history, isSentryEnabled: isSentryEnabled = true, cloudId: cloudId, orgId: orgId, teamCentralHandlers: teamCentralHandlers, subProduct: subProduct, productFeatureFlags: productFeatureFlags, invitePeopleHandlers: invitePeopleHandlers, isAIEnabled: isAIEnabled, enableNewFormUI: enableNewFormUI = false } = props;
    if (env) (0, $7OSF3.setEnv)(env);
    const analyticsClient = (0, $hsGgw.useSetupAnalyticsClient)(cloudId, appName, subProduct);
    if (!analyticsClient) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8gRFs.default), {
        analytics: analyticsClient,
        appName: appName,
        contextSpaPaths: contextSpaPaths,
        contextEntryPoint: contextEntryPoint,
        env: env,
        push: push,
        replace: replace,
        addFlag: addFlag,
        locale: locale,
        docTitle: docTitle,
        statusCodeHandlers: statusCodeHandlers,
        history: history,
        cloudId: cloudId,
        orgId: orgId,
        teamCentralHandlers: teamCentralHandlers,
        skipI18nProvider: false,
        productFeatureFlags: productFeatureFlags,
        invitePeopleHandlers: invitePeopleHandlers,
        isSentryEnabled: isSentryEnabled,
        isAIEnabled: isAIEnabled,
        enableNewFormUI: enableNewFormUI
    });
};
var $ee44373ada01d76d$export$2e2bcd8739ae039 = $ee44373ada01d76d$var$EmbeddableDirectory;

});
parcelRegister("hsGgw", function(module, exports) {

$parcel$export(module.exports, "useSetupAnalyticsClient", () => $37fa556ffc78c6ed$export$bcd55e98e7c6e45e);

var $5uXOq = parcelRequire("5uXOq");

var $1loTp = parcelRequire("1loTp");
function $37fa556ffc78c6ed$var$getAnalyticsSubproduct(appName, subProduct) {
    if (!subProduct) return appName;
    return `jira-${subProduct}-directory`;
}
function $37fa556ffc78c6ed$export$bcd55e98e7c6e45e(cloudId, appName, subProduct) {
    const analyticsSubProduct = (0, $5uXOq.useMemo)(()=>$37fa556ffc78c6ed$var$getAnalyticsSubproduct(appName, subProduct), [
        appName,
        subProduct
    ]);
    const [analyticsClient, setAnalyticsClient] = (0, $5uXOq.useState)((0, $1loTp.getAnalyticsClient)({
        mode: appName,
        subproduct: analyticsSubProduct,
        cloudId: cloudId
    }));
    // setup analytics object
    (0, $5uXOq.useEffect)(()=>{
        if (!cloudId) return;
        const analytics = (0, $1loTp.getAnalyticsClient)({
            mode: appName,
            subproduct: analyticsSubProduct,
            cloudId: cloudId
        });
        setAnalyticsClient(analytics);
    }, [
        cloudId,
        analyticsSubProduct,
        appName
    ]);
    // TODO: fix-me - currently, cloudId is required to render People app.
    // When analytics client without cloud id is used, Cypress test `dev-packages/cypress/src/specs/analytics.spec.ts` is flaky.
    // It seems that the analytics client without cloud id used first, then analytics client with cloud is replaced, but the app does not re-render in Cypress tests.
    return cloudId ? analyticsClient : undefined;
}

});
parcelRegister("1loTp", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsClient", () => $5074461f430a0df8$export$fde53e78fd93a54d);

var $buAWB = parcelRequire("buAWB");
var $iZhen = parcelRequire("iZhen");

var $kc6Iv = parcelRequire("kc6Iv");
var $jCvwN = parcelRequire("jCvwN");
var $7OSF3 = parcelRequire("7OSF3");

var $49z18 = parcelRequire("49z18");

var $fyzT1 = parcelRequire("fyzT1");

var $5kouT = parcelRequire("5kouT");

var $65ws1 = parcelRequire("65ws1");
function $5074461f430a0df8$var$getServerName() {
    return window.location.hostname;
}
const { LOCAL: $5074461f430a0df8$var$LOCAL, DEV: $5074461f430a0df8$var$DEV, STAGING: $5074461f430a0df8$var$STAGING, PROD: $5074461f430a0df8$var$PROD } = (0, $iZhen.envType);
const $5074461f430a0df8$var$ENV_MAP = {
    local: $5074461f430a0df8$var$LOCAL,
    test: $5074461f430a0df8$var$LOCAL,
    adev: $5074461f430a0df8$var$DEV,
    'stg-east': $5074461f430a0df8$var$STAGING,
    stg: $5074461f430a0df8$var$STAGING
};
const $5074461f430a0df8$var$getEnvType = (env)=>{
    return $5074461f430a0df8$var$ENV_MAP[env] || $5074461f430a0df8$var$PROD;
};
const $5074461f430a0df8$var$analyticsConfig = (0, $jCvwN.getConfig)().analytics;
const $5074461f430a0df8$var$SUB_PRODUCT_DEFAULT = 'siteDirectory';
const $5074461f430a0df8$var$PRODUCT_DEFAULT = 'people';
class $5074461f430a0df8$var$AnalyticsClient {
    constructor(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    options = {}, { commonProperties: commonProperties = {}, eventPrefix: eventPrefix = 'atlassian.people', subproduct: subproduct = $5074461f430a0df8$var$SUB_PRODUCT_DEFAULT, cloudId: cloudId = '' } = {}){
        const customOptions = {
            commonProperties: commonProperties,
            eventPrefix: eventPrefix
        };
        this.cloudId = cloudId;
        this.commonProperties = customOptions.commonProperties;
        this.eventPrefix = customOptions.eventPrefix;
        this.state = {
            analyticsscheme: $5074461f430a0df8$var$analyticsConfig.scheme,
            analyticsserver: $5074461f430a0df8$var$analyticsConfig.server,
            server: $5074461f430a0df8$var$getServerName(),
            product: $5074461f430a0df8$var$PRODUCT_DEFAULT,
            isReadyToSend: false,
            pendingEventsQueue: [],
            storage_key: 'atlassian.people.analytics',
            ...options
        };
        // New GAS pipeline client
        this.analyticsWebClient = new (0, $buAWB.default)({
            env: $5074461f430a0df8$var$getEnvType((0, $7OSF3.getEnv)()),
            product: 'people',
            subproduct: subproduct
        }, {});
        this.initUFO();
        this._expTracker = (0, $5kouT.configureNewTracker)(this);
    }
    setTeamId(teamId) {
        this.teamId = teamId;
    }
    initUFO() {
        if ((0, $kc6Iv.getAppName)() !== (0, $kc6Iv.AppNames).STANDALONE_DIRECTORY) return;
        (0, $49z18.payloadPublisher).setup({
            gasv3: this.analyticsWebClient,
            product: 'people',
            app: {
                // @ts-ignore
                version: {
                    web: __VERSION__
                }
            },
            region: (0, $7OSF3.getEnv)()
        });
    // import { ufologger } from @atlassian/ufo and uncomment the following line to see UFO logs:
    // ufologger.enable();
    }
    getAnalyticsWebClient() {
        return this.analyticsWebClient;
    }
    expTracker() {
        return this._expTracker;
    }
    sendTrackEvent(eventData) {
        this.analyticsWebClient.sendTrackEvent(eventData);
    }
    /**
	 * Checks whether the library has been initialized and decides whether the event should be sent or cached
	 * @param {*} eventType Values could be 'track', 'screen', 'operation, 'ui'
	 * @param {*} eventData Data of the event
	 * @param {Function} cb Callback is called when the event is sent successfully.
	 */ canEventBeSent(eventType, eventData, cb) {
        if (this.state.isReadyToSend) return true;
        // add to `pendingEventsQueue` in order to send the event later
        this.state.pendingEventsQueue.push({
            eventType: eventType,
            eventData: eventData,
            // `eventCallback` is called when `pendingEventsQueue` is processed and eventData is sent
            eventCallback: cb
        });
        return false;
    }
    pushTrackEvent(eventData, cb) {
        if (this.canEventBeSent('track', eventData, cb)) {
            const event = this.buildEventPayload(eventData);
            this.analyticsWebClient.sendTrackEvent(event, cb);
        }
    }
    pushUIEvent(eventData, cb) {
        if (this.canEventBeSent('ui', eventData, cb)) {
            const event = this.buildEventPayload(eventData);
            this.analyticsWebClient.sendUIEvent(event, cb);
        }
    }
    pushOperationalEvent(eventData, cb) {
        if (this.canEventBeSent('operation', eventData, cb)) {
            const event = this.buildEventPayload(eventData);
            this.analyticsWebClient.sendOperationalEvent(event, cb);
        }
    }
    pushScreenEvent(eventData, cb) {
        const additionalAttributes = (0, $65ws1.default).get();
        (0, $65ws1.default).markUsed();
        if (eventData && additionalAttributes) eventData = {
            ...eventData,
            attributes: {
                ...additionalAttributes,
                ...eventData.attributes
            }
        };
        if (this.canEventBeSent('screen', eventData, cb)) this.analyticsWebClient.sendScreenEvent(eventData, cb);
    }
    buildEventPayload(eventData) {
        const attributes = this.teamId || eventData.attributes ? {
            ...this.teamId && {
                teamId: this.teamId
            },
            ...eventData.attributes
        } : null;
        return {
            containerType: null,
            containerId: null,
            objectType: null,
            objectId: null,
            source: null,
            actionSubject: null,
            action: null,
            actionSubjectId: null,
            tags: [],
            ...eventData,
            attributes: attributes
        };
    }
    mapAnalyticsKeyToEvent(analyticsKey) {
        return (0, $fyzT1.analyticsKeyToEventMap)[analyticsKey] || null;
    }
    /**
	 *  Start up E-MAU events in the new analytics pipeline (GAS v3)
	 *  See: https://extranet.atlassian.com/display/BPO/DACI%3A+E-MAU+Definition
	 */ async startUIViewedEvent(principalUserId) {
        if (!principalUserId) return;
        this.analyticsWebClient.setTenantInfo((0, $iZhen.tenantType).CLOUD_ID, this.cloudId || '');
        this.analyticsWebClient.setUserInfo((0, $iZhen.userType).ATLASSIAN_ACCOUNT, principalUserId);
        this.analyticsWebClient.startUIViewedEvent();
        this.state.isReadyToSend = true;
        this.flushPendingEventsQueue();
    }
    /**
	 * Flush all the pending events in the queue
	 */ flushPendingEventsQueue() {
        this.state.pendingEventsQueue.forEach((element)=>{
            const { eventType: eventType, eventData: eventData, eventCallback: eventCallback } = element;
            switch(eventType){
                case 'track':
                    this.pushTrackEvent(eventData, eventCallback);
                    break;
                case 'ui':
                    this.pushUIEvent(eventData, eventCallback);
                    break;
                case 'screen':
                    this.pushScreenEvent(eventData, eventCallback);
                    break;
                case 'operation':
                    this.pushOperationalEvent(eventData, eventCallback);
                    break;
                default:
                    // eslint-disable-next-line no-console
                    console.error('Invalide Event :', element);
                    break;
            }
        });
    }
}
var $5074461f430a0df8$export$2e2bcd8739ae039 = $5074461f430a0df8$var$AnalyticsClient;
let $5074461f430a0df8$var$preservedAnaylticsClient;
const $5074461f430a0df8$export$fde53e78fd93a54d = ({ mode: mode, subproduct: subproduct, cloudId: cloudId })=>{
    if (!cloudId) return;
    if ($5074461f430a0df8$var$preservedAnaylticsClient) return $5074461f430a0df8$var$preservedAnaylticsClient;
    $5074461f430a0df8$var$preservedAnaylticsClient = new $5074461f430a0df8$var$AnalyticsClient({}, {
        commonProperties: {
            mode: mode
        },
        subproduct: subproduct,
        cloudId: cloudId
    });
    return $5074461f430a0df8$var$preservedAnaylticsClient;
};

});
parcelRegister("kc6Iv", function(module, exports) {

$parcel$export(module.exports, "AppNames", () => $9dcbdd613bb2ce35$export$b767e803e7ca9563);
$parcel$export(module.exports, "getAppName", () => $9dcbdd613bb2ce35$export$dcecb2dbc7fe753c);
var $9dcbdd613bb2ce35$export$b767e803e7ca9563 = /*#__PURE__*/ function(AppNames) {
    AppNames["EMBEDDABLE_DIRECTORY"] = "embeddableDirectory";
    AppNames["STANDALONE_DIRECTORY"] = "standaloneDirectory";
    return AppNames;
}({});
function $9dcbdd613bb2ce35$export$dcecb2dbc7fe753c() {
    // @ts-ignore
    return window.__app_name__ || "embeddableDirectory";
}

});

parcelRegister("jCvwN", function(module, exports) {

$parcel$export(module.exports, "isFedramp", () => $ef83275710befcd7$export$634ecc602a6871aa);
$parcel$export(module.exports, "getConfig", () => $ef83275710befcd7$export$44487a86467333c3);

var $dyczo = parcelRequire("dyczo");

var $c04PQ = parcelRequire("c04PQ");

var $kc6Iv = parcelRequire("kc6Iv");

var $7OSF3 = parcelRequire("7OSF3");

var $2sqTC = parcelRequire("2sqTC");
// default configs is also config for production env
const $ef83275710befcd7$var$productionConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'https',
        server: 'analytics.atlassian.com'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.atlassian.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralUrl: 'https://team.atlassian.com'
};
const $ef83275710befcd7$var$devAndStagingConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'https',
        server: 'analytics.atlassian.com'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.stg.internal.atlassian.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralUrl: 'https://team.stg.atlassian.com'
};
const $ef83275710befcd7$var$localAndTestConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'http',
        server: 'localhost:3000'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.stg.internal.atlassian.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralUrl: 'https://team.stg.atlassian.com'
};
const $ef83275710befcd7$var$fedrampConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'https',
        server: 'analytics.atlassian.com'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.atlassian-us-gov-mod.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralDisabled: true
};
const $ef83275710befcd7$var$EnvOverrideKeys = [
    'adev',
    'stg-east',
    'local',
    'test',
    'fedramp',
    'prod-east'
];
const $ef83275710befcd7$var$environmentOverrides = {
    'prod-east': $ef83275710befcd7$var$productionConfig,
    local: {
        ...(0, $2sqTC.LOCAL_PRODUCTION_BACKEND) ? $ef83275710befcd7$var$productionConfig : $ef83275710befcd7$var$localAndTestConfig,
        analytics: {
            scheme: 'http',
            server: `${(0, (/*@__PURE__*/$parcel$interopDefault($dyczo))).location.hostname}:3000`
        }
    },
    test: {
        ...$ef83275710befcd7$var$localAndTestConfig
    },
    adev: $ef83275710befcd7$var$devAndStagingConfig,
    'stg-east': $ef83275710befcd7$var$devAndStagingConfig,
    fedramp: $ef83275710befcd7$var$fedrampConfig
};
const $ef83275710befcd7$var$cachedConfig = {};
function $ef83275710befcd7$export$634ecc602a6871aa() {
    return (0, $c04PQ.isFedRamp)();
}
function $ef83275710befcd7$export$44487a86467333c3() {
    const env = $ef83275710befcd7$export$634ecc602a6871aa() ? 'fedramp' : (0, $7OSF3.getEnv)();
    const appName = (0, $kc6Iv.getAppName)();
    const key = `${env}_${appName}`;
    if (!$ef83275710befcd7$var$cachedConfig[key]) {
        if ($ef83275710befcd7$var$EnvOverrideKeys.includes(env)) $ef83275710befcd7$var$cachedConfig[key] = {
            ...$ef83275710befcd7$var$environmentOverrides[env]
        };
        else // fallback to prod as customers can have custom domains.
        $ef83275710befcd7$var$cachedConfig[key] = {
            ...$ef83275710befcd7$var$environmentOverrides['prod-east']
        };
    }
    return $ef83275710befcd7$var$cachedConfig[key];
}

});
parcelRegister("7OSF3", function(module, exports) {

$parcel$export(module.exports, "setEnv", () => $d72845fc4b3a6bd4$export$84bc02d3c7a6b55f);
$parcel$export(module.exports, "getEnv", () => $d72845fc4b3a6bd4$export$4bd44a2aa29d3d6e);

var $dyczo = parcelRequire("dyczo");

var $2sqTC = parcelRequire("2sqTC");
var $d72845fc4b3a6bd4$export$e7dfafc24fab792e = /*#__PURE__*/ function(MicrosEnv) {
    MicrosEnv["ADEV"] = "adev";
    MicrosEnv["STG_EAST"] = "stg-east";
    MicrosEnv["PROD_EAST"] = "prod-east";
    return MicrosEnv;
}({});
const $d72845fc4b3a6bd4$export$d76bdf9f4281ae1b = {
    local: 'local',
    test: 'test',
    prod: 'prod',
    stg: 'staging',
    ["adev"]: 'staging',
    ["stg-east"]: 'staging',
    ["prod-east"]: 'production'
};
const $d72845fc4b3a6bd4$var$SIMPLE_TO_DAMN_COMPLEX_ENV = {
    prod: 'prod-east',
    stg: 'stg-east'
};
let $d72845fc4b3a6bd4$var$presetEnv;
const $d72845fc4b3a6bd4$export$84bc02d3c7a6b55f = (env)=>{
    const envOverride = $d72845fc4b3a6bd4$var$SIMPLE_TO_DAMN_COMPLEX_ENV[env];
    if (envOverride) $d72845fc4b3a6bd4$var$presetEnv = envOverride;
};
function $d72845fc4b3a6bd4$export$4bd44a2aa29d3d6e() {
    if ($d72845fc4b3a6bd4$var$presetEnv) return $d72845fc4b3a6bd4$var$presetEnv;
    if (0, $2sqTC.DEV) return 'local';
    // @ts-ignore
    return (0, (/*@__PURE__*/$parcel$interopDefault($dyczo))).__env__;
}
function $d72845fc4b3a6bd4$export$15b8d8b1ba394f55() {
    return $d72845fc4b3a6bd4$export$d76bdf9f4281ae1b[$d72845fc4b3a6bd4$export$4bd44a2aa29d3d6e()];
}

});
parcelRegister("2sqTC", function(module, exports) {

$parcel$export(module.exports, "DEV", () => $934cf0f7b2df335c$export$404582bc18fe4d9e);
$parcel$export(module.exports, "LOCAL_PRODUCTION_BACKEND", () => $934cf0f7b2df335c$export$771a63345d182ddd);
// @ts-ignore
const $934cf0f7b2df335c$export$404582bc18fe4d9e = typeof __DEV__ !== 'undefined' && __DEV__;
const $934cf0f7b2df335c$export$771a63345d182ddd = // @ts-ignore
typeof __LOCAL_PRODUCTION_BACKEND__ !== 'undefined' && // @ts-ignore
__LOCAL_PRODUCTION_BACKEND__;

});



parcelRegister("fyzT1", function(module, exports) {

$parcel$export(module.exports, "AnalyticsKeys", () => $49573e686daf38b9$export$e8d1ded05852e864);
$parcel$export(module.exports, "analyticsKeyToEventMap", () => $49573e686daf38b9$export$6430c2bbc66a6fa);
$parcel$export(module.exports, "AnalyticsEventSource", () => $49573e686daf38b9$export$2102531865f3e90e);
$parcel$export(module.exports, "AnalyticsEventActions", () => $49573e686daf38b9$export$74eee170ad238aae);
$parcel$export(module.exports, "AnalyticsEventSubjects", () => $49573e686daf38b9$export$670f80b77450980d);
const $49573e686daf38b9$export$e8d1ded05852e864 = {
    ACTIVITY_ALL_VIEW: 'activity.all.view',
    ACTIVITY_WATCHING_VIEW: 'activity.watching.view',
    HISTORY_VIEW: 'history.view',
    PEOPLE_VIEW: 'people-search.view',
    PROFILE_PAGE_VIEW: 'profile-page.view',
    AGENT_PROFILE_PAGE_VIEW: 'agent-profile-page.view',
    PROFILE_WORKED_ON_PAGE_VIEW: 'profile-worked-on-page.view',
    PROFILE_SETTINGS_CLOSE_ACCOUNT_VIEW: 'profile-settings.close-account.view',
    PROFILE_SETTINGS_EMAIL_VIEW: 'profile-settings.email.view',
    PROFILE_SETTINGS_GENERAL_VIEW: 'profile-settings.general.view',
    PROFILE_SETTINGS_PROFILE_AND_VISIBILITY_VIEW: 'profile-settings.profile-and-visibility.view',
    PROFILE_SETTINGS_PRIVACY_VIEW: 'profile-settings.privacy.view',
    PROFILE_SETTINGS_PRODUCT_VIEW: 'profile-settings.product.view',
    PROFILE_SETTINGS_SECURITY_VIEW: 'profile-settings.security.view',
    PROFILE_SETTINGS_TWO_STEP_VERIFICATION_VIEW: 'profile-settings.security.two-step-verification.view',
    PROFILE_SETTINGS_API_TOKENS_VIEW: 'profile-settings.security.api-tokens.view',
    PROFILE_SETTINGS_RECENT_DEVICES_VIEW: 'profile-settings.security.recent-devices.view',
    PROFILE_SETTINGS_CONNECTED_APPS_VIEW: 'profile-settings.connected-apps.view',
    TEAM_PROFILE_VIEW: 'team-profile.view',
    KUDOS_PAGE_VIEW: 'kudos-page.view',
    TEAM_PROFILE_BROWSE_ALL: 'team-profile.browse-all',
    ALL_TEAMS_DISABLED: 'profile-search.view.all-teams.disabled',
    // TODO: remove these once we move to a new analytics platform
    LEGACY_ACTIVITY_ALL_VIEW: 'newsfeed.view'
};
const $49573e686daf38b9$export$6430c2bbc66a6fa = {
    [$49573e686daf38b9$export$e8d1ded05852e864.PROFILE_PAGE_VIEW]: 'userProfile',
    [$49573e686daf38b9$export$e8d1ded05852e864.TEAM_PROFILE_BROWSE_ALL]: 'teamsPage'
};
var $49573e686daf38b9$export$2102531865f3e90e = /*#__PURE__*/ function(AnalyticsEventSource) {
    // `/people/<userId>` page
    AnalyticsEventSource["USER_PROFILE_SCREEN"] = "userProfileScreen";
    AnalyticsEventSource["USER_PROFILE_ABOUT"] = "userProfileAbout";
    // `/people/<userId>/work` page
    AnalyticsEventSource["USER_WORK_SCREEN"] = "userWorkScreen";
    // `/people/agent/<agentId>` page
    AnalyticsEventSource["AGENT_PROFILE_SCREEN"] = "agentProfileScreen";
    AnalyticsEventSource["AGENT_DELETE_SUCCESS_FLAG"] = "agentDeletedSuccessflag";
    AnalyticsEventSource["AGENT_DELETE_ERROR_FLAG"] = "agentDeletedErrorflag";
    // `/people/team/<teamId>` page
    AnalyticsEventSource["TEAM_PROFILE_SCREEN"] = "teamProfileScreen";
    AnalyticsEventSource["TEAM_PROFILE_ABOUT"] = "teamProfileAbout";
    AnalyticsEventSource["TEAM_RESTORE_SCREEN"] = "teamRestoreScreen";
    AnalyticsEventSource["TEAM_RESTORE_SUCCESS_FLAG"] = "teamReactivatedSuccessflag";
    AnalyticsEventSource["TEAM_RESTORE_ERROR_FLAG"] = "teamReactivatedErrorflag";
    AnalyticsEventSource["CREATE_TEAM_MODAL"] = "createTeamModal";
    // `/people/search` page
    AnalyticsEventSource["DIRECTORY_SCREEN"] = "directoryScreen";
    // new `/people/search` page
    AnalyticsEventSource["PEOPLE_HOME"] = "peopleHome";
    AnalyticsEventSource["PEOPLE_DRAWER"] = "peopleDrawer";
    // inside avatar menu
    AnalyticsEventSource["USER_MENU"] = "userMenu";
    // experimentLeaf */
    AnalyticsEventSource["ADD_PEOPLE_MODAL"] = "addPeopleModal";
    // generic metrics
    AnalyticsEventSource["CLIENT_METRICS"] = "clientMetrics";
    // generic metrics
    AnalyticsEventSource["DIRECTORY_APP"] = "directoryApp";
    AnalyticsEventSource["INITIALS_DIALOG"] = "avatarInitialsPicker";
    // /people/kudos/:uuid
    AnalyticsEventSource["KUDOS_SCREEN"] = "kudos";
    AnalyticsEventSource["PROFILE_CARD"] = "profilecard";
    // new `/people/search/teams` page
    AnalyticsEventSource["TEAMS_PAGE"] = "teamsPage";
    return AnalyticsEventSource;
}({});
var $49573e686daf38b9$export$74eee170ad238aae = /*#__PURE__*/ function(AnalyticsEventActions) {
    AnalyticsEventActions["ACCEPTED"] = "accepted";
    AnalyticsEventActions["CLICKED"] = "clicked";
    AnalyticsEventActions["CLOSED"] = "closed";
    AnalyticsEventActions["COLLAPSED"] = "collapsed";
    AnalyticsEventActions["CREATED"] = "created";
    AnalyticsEventActions["DECLINED"] = "declined";
    AnalyticsEventActions["DELETED"] = "deleted";
    AnalyticsEventActions["EDITED"] = "edited";
    AnalyticsEventActions["EXPANDED"] = "expanded";
    AnalyticsEventActions["EXPOSED"] = "exposed";
    AnalyticsEventActions["FAILED"] = "failed";
    AnalyticsEventActions["JOINED"] = "joined";
    AnalyticsEventActions["REDIRECTED"] = "redirected";
    AnalyticsEventActions["REMOVED"] = "removed";
    AnalyticsEventActions["SENT"] = "sent";
    AnalyticsEventActions["SORTED"] = "sorted";
    AnalyticsEventActions["STARTED"] = "started";
    AnalyticsEventActions["OPENED"] = "opened";
    AnalyticsEventActions["SHOWN"] = "shown";
    AnalyticsEventActions["SUBMITTED"] = "submitted";
    AnalyticsEventActions["SUCCEEDED"] = "succeeded";
    AnalyticsEventActions["TRIGGERED"] = "triggered";
    AnalyticsEventActions["TYPED"] = "typed";
    AnalyticsEventActions["VIEWED"] = "viewed";
    AnalyticsEventActions["MOUNTED"] = "mounted";
    AnalyticsEventActions["MOVED"] = "moved";
    AnalyticsEventActions["DRAGGED"] = "dragged";
    AnalyticsEventActions["SELECTED"] = "selected";
    return AnalyticsEventActions;
}({});
var $49573e686daf38b9$export$670f80b77450980d = /*#__PURE__*/ function(AnalyticsEventSubjects) {
    AnalyticsEventSubjects["TEAM_LINK"] = "teamLink";
    AnalyticsEventSubjects["BUTTON"] = "button";
    AnalyticsEventSubjects["MODAL_DIALOG"] = "modalDialog";
    AnalyticsEventSubjects["FORM"] = "form";
    AnalyticsEventSubjects["ERROR"] = "error";
    return AnalyticsEventSubjects;
}({});

});

parcelRegister("5kouT", function(module, exports) {

$parcel$export(module.exports, "configureNewTracker", () => $39e29a6d1a764883$export$54c7ecd74762af6a);
$parcel$export(module.exports, "isNetworkError", () => $39e29a6d1a764883$export$476aa014e2fd89d5);

var $ha42n = parcelRequire("ha42n");

var $kc6Iv = parcelRequire("kc6Iv");

var $fyzT1 = parcelRequire("fyzT1");

var $jJaNd = parcelRequire("jJaNd");

var $4BpOs = parcelRequire("4BpOs");
function $39e29a6d1a764883$export$54c7ecd74762af6a(analytics) {
    const tracker = new $39e29a6d1a764883$var$DirectoryExperienceTracker({
        isNetworkOfflineError: $39e29a6d1a764883$export$476aa014e2fd89d5
    });
    tracker.subscribe((event)=>{
        if (event.action === 'taskStart' || event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail') {
            const performanceAttributes = $39e29a6d1a764883$var$computePerformanceAttributes(event);
            const errorAttributes = $39e29a6d1a764883$var$computeErrorAttributes(event);
            const finalErrorDetails = Object.assign(errorAttributes, performanceAttributes, event.attributes, {
                // Because standalone app is deployed to prod quickly,
                // we will use this attribute to query in Splunk sooner.
                isStandalone: (0, $kc6Iv.getAppName)() === (0, $kc6Iv.AppNames).STANDALONE_DIRECTORY,
                hasBrowseUsersPermission: (0, $jJaNd.isFlagEnabled)((0, $733e11e3c62664e2$export$28456d095a642fd))
            });
            const actionSubject = $39e29a6d1a764883$var$sanitiseExperienceName(event.name);
            analytics.pushOperationalEvent({
                source: (0, $fyzT1.AnalyticsEventSource).CLIENT_METRICS,
                actionSubject: actionSubject,
                action: event.action,
                attributes: finalErrorDetails
            });
        }
    });
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('unload', ()=>{
        tracker.abort({
            reason: 'Abort due to Window unloading',
            attributes: {
                cause: 'WINDOW_UNLOAD'
            }
        });
    });
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('pagehide', ()=>{
        tracker.abort({
            reason: 'Window unloading',
            attributes: {
                cause: 'PAGE_HIDE'
            }
        });
    });
    return tracker;
}
function $39e29a6d1a764883$var$sanitiseExperienceName(name) {
    return name.replace(/[\/-]/g, '_');
}
function $39e29a6d1a764883$var$computeErrorAttributes(event) {
    const attributes = {};
    if (event.action === 'taskFail' && event.error) {
        attributes.failError = event.error.message;
        attributes.traceId = event.error.traceId ?? null;
    }
    if (event.action === 'taskAbort' && event.reason) attributes.abortReason = event.reason;
    return attributes;
}
// compute sloSatisfied: true/false based on the latencySlo attribute
// for monitoring in SignalFx
function $39e29a6d1a764883$var$computePerformanceAttributes(event) {
    if (event.action === 'taskStart') return {};
    const duration = event.duration;
    const latencySlo = event.attributes && event.attributes['latencySlo'];
    if (typeof duration !== 'number' || typeof latencySlo !== 'number') return {};
    return {
        sloSatisfied: duration <= latencySlo,
        taskDuration: duration,
        latencySlo: latencySlo
    };
}
class $39e29a6d1a764883$var$DirectoryExperienceTracker extends (0, $ha42n.ExperienceTracker) {
    constructor(options){
        super(options);
    }
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if ((0, $4BpOs.isAuthError)(error)) {
            this.abort({
                name: name,
                reason: 'Abort due to user unauthenticated',
                attributes: {
                    cause: 'USER_UNAUTHENTICATED',
                    error: error,
                    ...attributes
                },
                checkForTimeout: false
            });
            return;
        }
        if ((0, $4BpOs.isErrorStatusCode)((0, $4BpOs.StatusCode).GONE, error)) {
            this.abort({
                name: name,
                reason: 'Abort due to unavailable resource',
                attributes: {
                    cause: 'GONE',
                    error: error,
                    ...attributes
                },
                checkForTimeout: false
            });
            return;
        }
        const reason = (0, $4BpOs.ignoredErrorReason)(error);
        if (reason) {
            this.abort({
                name: name,
                reason: 'Abort due to an error in ignore list',
                attributes: {
                    cause: reason,
                    ...attributes
                },
                checkForTimeout: false
            });
            return;
        }
        super.stopOnError({
            name: name,
            error: error,
            attributes: attributes
        });
    }
}
function $39e29a6d1a764883$export$476aa014e2fd89d5(error) {
    return error && !!error.message && // Firefox
    (error.message.includes('NetworkError') || // Chrome
    error.message.startsWith('Failed to fetch') || error.message.includes('GraphQL error: Failed to fetch') || // cancel by users or unknown reason
    error.message.includes('GraphQL error: The operation was aborted') || error.message.includes('GraphQL error: cancelled') || error.message.includes('Abgebrochen') || error.message.includes("\u043E\u0442\u043C\u0435\u043D\u0435\u043D\u043E") || error.message.includes("\u0421\u0435\u0442\u0435\u0432\u043E\u0435 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043F\u043E\u0442\u0435\u0440\u044F\u043D\u043E.") || error.message.includes('anulowane') || error.message.includes("annul\xe9") || error.message.includes("\u5DF2\u53D6\u6D88") || error.message.includes('cancelado') || error.message.includes("\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3057\u305F") || error.message.includes('cancelled') || error.message.includes('Network error') || // GraphQL-wrapping network error
    // @ts-ignore
    !!(error['graphQLErrors'] && error['networkError']));
}

});
const $733e11e3c62664e2$export$28456d095a642fd = 'internal.browse-users-allowed';

parcelRegister("jJaNd", function(module, exports) {

$parcel$export(module.exports, "FeatureFlag", () => $7b68a7a6fc78be2f$export$df35587a8f95f16f);
$parcel$export(module.exports, "isFlagEnabled", () => $7b68a7a6fc78be2f$export$ba72073d757a1bc2);

var $04Mso = parcelRequire("04Mso");

var $7OSF3 = parcelRequire("7OSF3");

var $6cAn5 = parcelRequire("6cAn5");
var $7b68a7a6fc78be2f$export$df35587a8f95f16f = /*#__PURE__*/ function(FeatureFlag) {
    //Teams in JSM Ops productFeatureFlags
    FeatureFlag["EVENT_ON_CALL_EFF"] = "event-on-call-consolidation_s97c8";
    FeatureFlag["EVENT_ON_CALL_CONSOLIDATION_STATE"] = "event-on-call-consolidation-state";
    // Control for Open Sites permissions check
    FeatureFlag["ENABLE_MOCK_OPEN_SITES_FAIL"] = "ptc-directory-ui.deny-open-sites-in-fe";
    // Atlas
    FeatureFlag["DISABLE_ATLAS_CROSSWFLOW_ADS"] = "disable_atlas_crossflow_ads";
    return FeatureFlag;
}({});
// All feature flags must be listed here so that they can be selectively fetched from LaunchDarkly
// For real execution environments, configure flags in https://app.launchdarkly.com/ppl-teams-collective/test/features
// The default values here are used as the fallback when everything else (LD, local storage cache, local overrides) fails
const $7b68a7a6fc78be2f$var$DEFAULT_FEATURE_FLAGS = {
    ["ptc-directory-ui.deny-open-sites-in-fe"]: false,
    ["disable_atlas_crossflow_ads"]: false,
    ["event-on-call-consolidation_s97c8"]: false,
    ["event-on-call-consolidation-state"]: false
};
// Overrides only for local/CI environments
const $7b68a7a6fc78be2f$var$LOCAL_OVERRIDE_FEATURE_FLAGS = {
};
const $7b68a7a6fc78be2f$export$7101ae34ef1f53be = ()=>$6cAn5?.env?.NODE_ENV === 'development' || (0, $7OSF3.getEnv)() === 'local' ? {
        ...$7b68a7a6fc78be2f$var$DEFAULT_FEATURE_FLAGS,
        ...$7b68a7a6fc78be2f$var$LOCAL_OVERRIDE_FEATURE_FLAGS
    } : {
        ...$7b68a7a6fc78be2f$var$DEFAULT_FEATURE_FLAGS
    };
function $7b68a7a6fc78be2f$export$ba72073d757a1bc2(flag) {
    return (0, $04Mso.isFlagEnabled)(flag);
}

});
parcelRegister("04Mso", function(module, exports) {

$parcel$export(module.exports, "getSettingsFromStorage", () => $bb2890e44c75956c$export$b40bc67e97afc0ed);
$parcel$export(module.exports, "isFlagEnabled", () => $bb2890e44c75956c$export$ba72073d757a1bc2);

var $2bf04 = parcelRequire("2bf04");

var $62DdI = parcelRequire("62DdI");

var $2jlP9 = parcelRequire("2jlP9");
const $bb2890e44c75956c$var$STORAGE_KEY_SETTINGS = 'atlassian.ptc-directory.settings';
function $bb2890e44c75956c$export$d9d01ff109db30f0(settings) {
    (0, $62DdI.default).setItem($bb2890e44c75956c$var$STORAGE_KEY_SETTINGS, JSON.stringify(settings));
    $bb2890e44c75956c$export$455c5cbefb010abd(settings);
}
function $bb2890e44c75956c$export$b40bc67e97afc0ed() {
    const settingsString = (0, $62DdI.default).getItem($bb2890e44c75956c$var$STORAGE_KEY_SETTINGS);
    try {
        const parsed = settingsString ? JSON.parse(settingsString) : null;
        if ($bb2890e44c75956c$var$isStringBooleanDictionary(parsed)) return parsed;
        return null;
    } catch (e) {
        (0, $2bf04.logException)(e, 'Could not get settings from storage', {
            locallyStoredSettings: settingsString
        });
        return null;
    }
}
const $bb2890e44c75956c$var$effectiveFlags = {
    ...(0, $2jlP9.DEFAULT_FEATURE_FLAGS),
    ...$bb2890e44c75956c$export$b40bc67e97afc0ed() || {}
};
function $bb2890e44c75956c$export$455c5cbefb010abd(newFlags) {
    Object.assign($bb2890e44c75956c$var$effectiveFlags, newFlags);
}
/**
 * We use this function to validate that the settings retrieved from local storage are of the correct shape.
 * We intentionally don't check against explicit keys, as keys may have changed since being stored.
 */ function $bb2890e44c75956c$var$isStringBooleanDictionary(result) {
    return result !== null && Object.keys(result).every((resultKey)=>typeof resultKey === 'string' && typeof result[resultKey] === 'boolean');
}
function $bb2890e44c75956c$export$2f63519103163252(featureFlag) {
    return Object.keys((0, $2jlP9.PRODUCT_FEATURE_FLAGS)).includes(featureFlag);
}
function $bb2890e44c75956c$export$ba72073d757a1bc2(flag) {
    return $bb2890e44c75956c$var$effectiveFlags[flag];
}

});
parcelRegister("2bf04", function(module, exports) {

$parcel$export(module.exports, "logException", () => $fe9042edcf886c67$export$f86b2a1a2ce291b3);
$parcel$export(module.exports, "logErrorMessage", () => $fe9042edcf886c67$export$ece28f5cfa04608);
$parcel$export(module.exports, "logInfoMessage", () => $fe9042edcf886c67$export$386587bcf05ee8ea);

var $6laLp = parcelRequire("6laLp");
const $fe9042edcf886c67$var$packageContext = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $fe9042edcf886c67$export$f86b2a1a2ce291b3 = (0, $6laLp.logExceptionWithPackageContext)($fe9042edcf886c67$var$packageContext);
const $fe9042edcf886c67$export$ece28f5cfa04608 = (0, $6laLp.logErrorMessageWithPackageContext)($fe9042edcf886c67$var$packageContext);
const $fe9042edcf886c67$export$386587bcf05ee8ea = (0, $6laLp.logInfoMessageWithPackageContext)($fe9042edcf886c67$var$packageContext);
const $fe9042edcf886c67$export$9edc7d6f1c33ddc = (0, $6laLp.createErrorHandlerWithPackageContext)($fe9042edcf886c67$var$packageContext);

});

parcelRegister("62DdI", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d849357ee9aa4ad$export$2e2bcd8739ae039);

var $2bf04 = parcelRequire("2bf04");
const $4d849357ee9aa4ad$var$PREFIX = 'ptc-dir-ui.';
const $4d849357ee9aa4ad$var$memoryLocalStorage = {
    data: {},
    setItem: (key, value)=>{
        $4d849357ee9aa4ad$var$memoryLocalStorage.data[key] = value;
    },
    getItem: (key)=>{
        return $4d849357ee9aa4ad$var$memoryLocalStorage.data[key];
    },
    removeItem: (key)=>{
        delete $4d849357ee9aa4ad$var$memoryLocalStorage.data[key];
    }
};
const $4d849357ee9aa4ad$var$localStorage = window.localStorage || $4d849357ee9aa4ad$var$memoryLocalStorage;
var // A facade for browser localstorage.
$4d849357ee9aa4ad$export$2e2bcd8739ae039 = {
    isQuotaExceeded () {
        const key = `${$4d849357ee9aa4ad$var$PREFIX}:${Date.now()}`;
        try {
            $4d849357ee9aa4ad$var$localStorage.setItem(key, 'test');
        } catch (e) {
            return true;
        } finally{
            $4d849357ee9aa4ad$var$localStorage.removeItem(key);
        }
        return false;
    },
    setItem (key, value) {
        try {
            $4d849357ee9aa4ad$var$localStorage.setItem($4d849357ee9aa4ad$var$PREFIX + key, value);
            return true;
        } catch (error) {
            // maybe we can use cookie as alternative storage
            (0, $2bf04.logInfoMessage)('Cannot read into localstorage', {
                error: error
            });
        }
        return false;
    },
    getItem (key) {
        try {
            return $4d849357ee9aa4ad$var$localStorage.getItem($4d849357ee9aa4ad$var$PREFIX + key);
        } catch (error) {
            (0, $2bf04.logInfoMessage)('Cannot read into localstorage', {
                error: error
            });
        }
        return null;
    },
    getItemSafely (key, defaultValue, fallback) {
        try {
            const storedValue = $4d849357ee9aa4ad$var$localStorage.getItem($4d849357ee9aa4ad$var$PREFIX + key);
            if (storedValue) return storedValue;
            if (this.setItem(key, defaultValue)) return defaultValue;
        } catch (error) {
            (0, $2bf04.logInfoMessage)('Cannot read into localstorage', {
                error: error
            });
        }
        return fallback;
    }
};

});

parcelRegister("2jlP9", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_FEATURE_FLAGS", () => $54ec26d0e515404f$export$f55f538942f87030);
$parcel$export(module.exports, "DEFAULT_FEATURE_FLAGS", () => $54ec26d0e515404f$export$f38af5fc86a6e665);
// All feature flags must be listed here so that they can be selectively fetched from LaunchDarkly
// For real execution environments, configure flags in https://app.launchdarkly.com/ppl-teams-collective/test/features
// The default values here are used as the fallback when everything else (LD, local storage cache, local overrides) fails
// This is a list of feature flags that are overwritable by products. The defaults are still loaded from the client
const $54ec26d0e515404f$export$f55f538942f87030 = {};
const $54ec26d0e515404f$export$f38af5fc86a6e665 = {
    'ptc-directory-ui.enable.cancel-join-requests-silently': false,
    'ptc-directory-ui.deny-open-sites-in-fe': false,
    'ptc-directory-ui.enable.atlas-team-health-monitor': false,
    ...$54ec26d0e515404f$export$f55f538942f87030
};

});



parcelRegister("4BpOs", function(module, exports) {

$parcel$export(module.exports, "ErrorCategory", () => $7b0026b0a0fc608a$export$fe4bb20808298551);
$parcel$export(module.exports, "StatusCode", () => $7b0026b0a0fc608a$export$f66f92b8741acd5b);
$parcel$export(module.exports, "isAuthError", () => $7b0026b0a0fc608a$export$cde1786a482f9a1c);
$parcel$export(module.exports, "isErrorStatusCode", () => $7b0026b0a0fc608a$export$9677d7c364ada66c);
$parcel$export(module.exports, "ignoredErrorReason", () => $7b0026b0a0fc608a$export$ece443678e6cc3f5);
$parcel$export(module.exports, "is4xxError", () => $7b0026b0a0fc608a$export$94c4b26e937da69);
$parcel$export(module.exports, "doesErrorContainStatus", () => $7b0026b0a0fc608a$export$7c7624f23566b6ff);
$parcel$export(module.exports, "DirectoryErrorCode", () => $7b0026b0a0fc608a$export$b19e812222b57630);
$parcel$export(module.exports, "isUseQueryLightError", () => $7b0026b0a0fc608a$export$c5975066c735ef7e);
var $7b0026b0a0fc608a$export$fe4bb20808298551 = /*#__PURE__*/ function(ErrorCategory) {
    ErrorCategory["NotFound"] = "NotFound";
    ErrorCategory["NotPermitted"] = "NotPermitted";
    ErrorCategory["MalformedInput"] = "MalformedInput";
    ErrorCategory["Internal"] = "Internal";
    return ErrorCategory;
}({});
var $7b0026b0a0fc608a$export$f66f92b8741acd5b = /*#__PURE__*/ function(StatusCode) {
    StatusCode[StatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    StatusCode[StatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    StatusCode[StatusCode["TIMEOUT"] = 408] = "TIMEOUT";
    StatusCode[StatusCode["GONE"] = 410] = "GONE";
    StatusCode[StatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    return StatusCode;
}({});
function $7b0026b0a0fc608a$export$cde1786a482f9a1c(error) {
    return $7b0026b0a0fc608a$export$9677d7c364ada66c(401, error) || $7b0026b0a0fc608a$export$9677d7c364ada66c(403, error);
}
const $7b0026b0a0fc608a$export$c27af9588f06f6fc = [
    'SentryIgnoreError'
];
const $7b0026b0a0fc608a$export$f4c3d57f2f41ffe2 = {
    'Could not verify accountId from header': 'AccountIdMismatch'
};
function $7b0026b0a0fc608a$export$ece443678e6cc3f5(error) {
    const constructor = error?.constructor.name;
    if (constructor && $7b0026b0a0fc608a$export$c27af9588f06f6fc.includes(constructor)) return constructor;
    const message = error?.message || '';
    const containedReason = message && Object.keys($7b0026b0a0fc608a$export$f4c3d57f2f41ffe2).find((ignoredMessage)=>message.includes(ignoredMessage));
    if (containedReason) return $7b0026b0a0fc608a$export$f4c3d57f2f41ffe2[containedReason];
}
function $7b0026b0a0fc608a$export$9677d7c364ada66c(statusCode, error) {
    if (!error) return false;
    if (error['status'] === statusCode || // error can be `ProperNetworkError` from `packages/graphql-client/src/links/error.ts`
    error['statusCode'] === statusCode) return true;
    const reg = new RegExp(`status (code)?.*(${statusCode})`);
    return !!error?.message?.match(reg);
}
function $7b0026b0a0fc608a$export$94c4b26e937da69(error) {
    if (!error) return false;
    const statusCode = error['status'] || error['statusCode'];
    // We want to log 429 errors to understand rate limiting
    if (parseInt(statusCode, 10) >= 400 && parseInt(statusCode, 10) < 500 && parseInt(statusCode, 10) !== 429) return true;
    const reg = new RegExp(/status (code)?.*(4\d\d)/g);
    return !!error.message?.match(reg);
}
function $7b0026b0a0fc608a$export$7c7624f23566b6ff(statusCode, message) {
    const reg = new RegExp(`status .*(${statusCode})`);
    return reg.test(message);
}
var $7b0026b0a0fc608a$export$b19e812222b57630 = /*#__PURE__*/ function(DirectoryErrorCode) {
    DirectoryErrorCode["MISSING_ERROR_MESSAGE"] = "MissingErrorMessage";
    return DirectoryErrorCode;
}({});
var $7b0026b0a0fc608a$export$c33cd4757598521c = /*#__PURE__*/ function(TeamErrorType) {
    TeamErrorType["TEAM_NOT_ACTIVE"] = "Team must be active";
    return TeamErrorType;
}({});
function $7b0026b0a0fc608a$export$76843b239f07f80a(error, field) {
    return error instanceof Error && field in error;
}
function $7b0026b0a0fc608a$export$c5975066c735ef7e(err) {
    return typeof err === 'object' && err !== null && 'graphQLErrors' in err;
}

});


parcelRegister("65ws1", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca7d138070beba16$export$2e2bcd8739ae039);
/**
 * A singleton module that will store a referrer data in a closure
 * and retrieve that data in an analytics client untill the app has
 * a route transition happened.
 *
 * How it works:
 * 1. whenever we init our app with `src` or `ref` in the URL we gonna preserve them here
 * 2. in every screen event we gonna retrieve `src` and `ref` and add them to event attributes
 * 3. as soon as app transitions to any other route we gonna cleanup the stored referrer data
 *    to stop tracking it further.
 *
 * Notes:
 *  Due to how `referrerInfo` is used to store data temporarily, now it is used only at 2 places:
 * - Analytic Client `packages/common/src/clients/analytics-client.ts`
 * - RecordTransition `packages/embeddable-directory/src/components/RecordTransition/RecordTransition.tsx`
 * If other codes try to access value inside `referrerInfo`, they may access old/empty data.
 */ 
var $6l1dD = parcelRequire("6l1dD");
// the storage for our referrer info;
let $ca7d138070beba16$var$data = null;
const $ca7d138070beba16$var$referrerInfo = {
    // as we preserving the data, we should at least get it once to record in analytics before allowing cleanup
    isUsed: false,
    markUsed () {
        $ca7d138070beba16$var$referrerInfo.isUsed = true;
    },
    get () {
        return $ca7d138070beba16$var$data;
    },
    set ({ src: src = '', ref: ref = '' }) {
        // clean up strings
        $ca7d138070beba16$var$data = {
            src: (0, $6l1dD.sanitiseValue)(src || '', {
                shouldHaveSafeCharsOnly: true,
                shouldEncode: true
            }),
            ref: (0, $6l1dD.sanitiseValue)(ref, {
                shouldHaveSafeCharsOnly: true,
                shouldEncode: true
            })
        };
    },
    cleanup (force) {
        if (!$ca7d138070beba16$var$referrerInfo.isUsed && !force) return;
        $ca7d138070beba16$var$data = null;
    }
};
var $ca7d138070beba16$export$2e2bcd8739ae039 = $ca7d138070beba16$var$referrerInfo;

});
parcelRegister("6l1dD", function(module, exports) {

$parcel$export(module.exports, "sanitiseValue", () => $94d6cd98d33d7505$export$b66eb39ba856053f);
const $94d6cd98d33d7505$var$FORBIDDEN_CODE_CHARS = [
    8207
];
function $94d6cd98d33d7505$export$b66eb39ba856053f(value, options = {}) {
    let trimmedStr = value.trim();
    $94d6cd98d33d7505$var$FORBIDDEN_CODE_CHARS.forEach((codeChar)=>{
        const char = String.fromCharCode(codeChar);
        const re = new RegExp(char, 'gm');
        trimmedStr = trimmedStr.replace(re, '');
    });
    if (options.shouldHaveSafeCharsOnly) {
        trimmedStr = trimmedStr.replace(/[^a-z0-9_-]/gim, '');
        trimmedStr = trimmedStr.trim();
    }
    if (options.shouldEncode) trimmedStr = encodeURIComponent(trimmedStr);
    return trimmedStr;
}

});




parcelRegister("8gRFs", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b3e4dbc7b87f932$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $6laLp = parcelRequire("6laLp");

var $bSOOm = parcelRequire("bSOOm");

var $gWLfS = parcelRequire("gWLfS");
var $hp0Uy = parcelRequire("hp0Uy");
var $cIr29 = parcelRequire("cIr29");
var $03Q1P = parcelRequire("03Q1P");
var $c5gm9 = parcelRequire("c5gm9");
var $5WmsO = parcelRequire("5WmsO");
var $4ArtL = parcelRequire("4ArtL");

var $gaG9X = parcelRequire("gaG9X");

var $hNjFi = parcelRequire("hNjFi");

var $jCvwN = parcelRequire("jCvwN");

var $4i1Yb = parcelRequire("4i1Yb");

var $it4ti = parcelRequire("it4ti");

var $fNJQT = parcelRequire("fNJQT");

var $bmfV0 = parcelRequire("bmfV0");

var $b8wBX = parcelRequire("b8wBX");

var $3UaSs = parcelRequire("3UaSs");

var $bCUYQ = parcelRequire("bCUYQ");
function $3b3e4dbc7b87f932$export$2e2bcd8739ae039(props) {
    const { appName: appName, analytics: analytics, contextSpaPaths: contextSpaPaths, contextEntryPoint: contextEntryPoint, replace: replace, push: push, locale: locale, skipI18nProvider: skipI18nProvider, addFlag: addFlag, docTitle: docTitle, env: env, history: history, statusCodeHandlers: statusCodeHandlers, cloudId: cloudId, orgId: orgId, teamCentralHandlers: teamCentralHandlers, productFeatureFlags: productFeatureFlags, invitePeopleHandlers: invitePeopleHandlers, isAIEnabled: isAIEnabled, enableNewFormUI: enableNewFormUI = false } = props;
    const [, { setCloudId: setCloudId }] = (0, $5WmsO.useSite)();
    const [, { setOrgId: setOrgId }] = (0, $c5gm9.useOrg)();
    const [, { initTeamCentral: initTeamCentral }] = (0, $4ArtL.useTeamCentralStoreApi)();
    const orgIdLoadingTimer = (0, $5uXOq.useRef)(null);
    const cloudIdLoadingTimer = (0, $5uXOq.useRef)(null);
    const { isJiraAvailable: isJiraAvailable } = (0, $gaG9X.useJiraCheckService)(cloudId);
    // when FG off, set cloud id to empty string to skip api call
    const { data: licenseCheckResult } = (0, $4i1Yb.useLicenseCheck)((0, $VSDnB.fg)('enable_site_url_context_in_teams') ? cloudId : '');
    const expTracker = analytics.expTracker();
    const analyticsClient = analytics.getAnalyticsWebClient();
    (0, $5uXOq.useEffect)(()=>{
        if (orgId) // @ts-expect-error - Property 'setOrgInfo' does not exist on type 'Promise<AnalyticsWebClient>'
        analyticsClient?.setOrgInfo(orgId);
    }, [
        analyticsClient,
        orgId
    ]);
    const appConfig = (0, $5uXOq.useMemo)(()=>({
            env: env,
            appName: appName,
            contextSpaPaths: contextSpaPaths,
            contextEntryPoint: contextEntryPoint,
            push: push,
            replace: replace,
            addFlag: addFlag,
            locale: locale,
            docTitle: docTitle,
            cloudId: cloudId,
            orgId: orgId,
            productFeatureFlags: productFeatureFlags,
            stargateRoot: (0, $jCvwN.getConfig)().stargateRoot,
            isJiraAvailable: isJiraAvailable,
            isAIEnabled: isAIEnabled,
            siteUrl: licenseCheckResult?.hostname,
            enableNewFormUI: enableNewFormUI
        }), [
        env,
        appName,
        contextSpaPaths,
        contextEntryPoint,
        isJiraAvailable,
        push,
        replace,
        addFlag,
        locale,
        docTitle,
        cloudId,
        orgId,
        productFeatureFlags,
        isAIEnabled,
        licenseCheckResult?.hostname,
        enableNewFormUI
    ]);
    // init statusCodeHandlersProvider
    (0, $5uXOq.useEffect)(()=>{
        if (statusCodeHandlers) (0, $03Q1P.statusCodeHandlersProvider).setHandlers(statusCodeHandlers);
    }, [
        statusCodeHandlers
    ]);
    // save cloud id passed from consumers to a remote state management.
    (0, $5uXOq.useEffect)(()=>{
        setCloudId(cloudId);
        if (!cloudId) cloudIdLoadingTimer.current = setTimeout(()=>{
            (0, $6laLp.logErrorMessage)('No cloudId set - App.tsx');
        }, 3000);
        else if (cloudIdLoadingTimer.current) clearInterval(cloudIdLoadingTimer.current);
    }, [
        cloudId,
        setCloudId
    ]);
    // save org id passed from consumers to a remote state management.
    (0, $5uXOq.useEffect)(()=>{
        setOrgId(orgId);
        if (!orgId) orgIdLoadingTimer.current = setTimeout(()=>{
            (0, $6laLp.logErrorMessage)('No orgId set - App.tsx');
        }, 3000);
        else if (orgIdLoadingTimer.current) clearInterval(orgIdLoadingTimer.current);
    }, [
        orgId,
        setOrgId
    ]);
    // Init and save various team central related data and preconditions
    (0, $5uXOq.useEffect)(()=>{
        initTeamCentral(appName, cloudId, teamCentralHandlers);
    }, [
        appName,
        cloudId,
        teamCentralHandlers,
        initTeamCentral
    ]);
    const handleTransition = (0, $5uXOq.useCallback)((pathname)=>{
        if (expTracker) expTracker.abort({
            reason: 'Route changes.'
        });
        (0, $6laLp.addBreadcrumb)(pathname);
    }, [
        expTracker
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cIr29.default), {
        messagesConfig: (0, $it4ti.default),
        skip: typeof skipI18nProvider !== 'undefined' ? skipI18nProvider : !locale,
        locale: locale,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b8wBX.default), {
            analytics: analytics,
            appName: appName,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hNjFi.TeamsWrapper), {
                appConfig: appConfig,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bmfV0.default), {
                    env: env,
                    contextSpaPaths: contextSpaPaths,
                    contextEntryPoint: contextEntryPoint,
                    docTitle: docTitle,
                    appName: appName,
                    addFlag: addFlag,
                    push: push,
                    locale: locale,
                    replace: replace,
                    history: history,
                    cloudId: cloudId,
                    orgId: orgId,
                    isJiraAvailable: isJiraAvailable,
                    teamCentralHandlers: teamCentralHandlers,
                    productFeatureFlags: productFeatureFlags,
                    invitePeopleHandlers: invitePeopleHandlers,
                    isAIEnabled: isAIEnabled,
                    siteUrl: licenseCheckResult?.hostname,
                    enableNewFormUI: enableNewFormUI,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gWLfS.default), {
                        analytics: analytics,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bSOOm.ExperienceTrackerContext).Provider, {
                            value: analytics.expTracker(),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)($3UaSs.RelativeWrapperOfHeaderImage, {
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hp0Uy.default), {
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bCUYQ.default), {
                                        appName: appName,
                                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fNJQT.default), {
                                            contextEntryPoint: contextEntryPoint,
                                            history: history,
                                            onTransition: handleTransition
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
}

});
parcelRegister("gWLfS", function(module, exports) {

$parcel$export(module.exports, "default", () => $ace605a0fda56a58$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7vgP9 = parcelRequire("7vgP9");
class $ace605a0fda56a58$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7vgP9.AnalyticsContext).Provider, {
            value: this.state,
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args), this.state = {
            analytics: this.props.analytics
        };
    }
}

});
parcelRegister("7vgP9", function(module, exports) {

$parcel$export(module.exports, "defaultAnalyticsClient", () => $3737225ef4ce92db$export$7fa70eb12a96b7d1);
$parcel$export(module.exports, "AnalyticsContext", () => $3737225ef4ce92db$export$83cd6c3eba7d8d9e);

var $5uXOq = parcelRequire("5uXOq");

var $a2luh = parcelRequire("a2luh");
const $3737225ef4ce92db$var$defaultAnalyticsMethod = ()=>{
    // tslint:disable-next-line no-console
    // eslint-disable-next-line no-console
    console.warn('No analytics client has been provided.');
    (0, $a2luh.logInfoMessage)('Analytics Context accessed before AnalyticsClient was loaded');
};
const $3737225ef4ce92db$export$7fa70eb12a96b7d1 = {
    getAnalyticsWebClient: ()=>{
        $3737225ef4ce92db$var$defaultAnalyticsMethod();
        return;
    },
    pushTrackEvent: $3737225ef4ce92db$var$defaultAnalyticsMethod,
    pushScreenEvent: $3737225ef4ce92db$var$defaultAnalyticsMethod,
    pushUIEvent: $3737225ef4ce92db$var$defaultAnalyticsMethod,
    pushOperationalEvent: $3737225ef4ce92db$var$defaultAnalyticsMethod,
    startUIViewedEvent: $3737225ef4ce92db$var$defaultAnalyticsMethod,
    expTracker: ()=>{
        throw new Error('No analytics client has been provided');
    },
    setTeamId: ()=>{
        throw new Error('No analytics client has been provided');
    }
};
const $3737225ef4ce92db$var$AnalyticsContextState = {
    analytics: $3737225ef4ce92db$export$7fa70eb12a96b7d1
};
const $3737225ef4ce92db$export$83cd6c3eba7d8d9e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext($3737225ef4ce92db$var$AnalyticsContextState);

});
parcelRegister("a2luh", function(module, exports) {

$parcel$export(module.exports, "logException", () => $37ee1557f838d13e$export$f86b2a1a2ce291b3);
$parcel$export(module.exports, "logErrorMessage", () => $37ee1557f838d13e$export$ece28f5cfa04608);
$parcel$export(module.exports, "logInfoMessage", () => $37ee1557f838d13e$export$386587bcf05ee8ea);
$parcel$export(module.exports, "createErrorHandler", () => $37ee1557f838d13e$export$9edc7d6f1c33ddc);

var $6laLp = parcelRequire("6laLp");
const $37ee1557f838d13e$var$packageContext = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $37ee1557f838d13e$export$f86b2a1a2ce291b3 = (0, $6laLp.logExceptionWithPackageContext)($37ee1557f838d13e$var$packageContext);
const $37ee1557f838d13e$export$ece28f5cfa04608 = (0, $6laLp.logErrorMessageWithPackageContext)($37ee1557f838d13e$var$packageContext);
const $37ee1557f838d13e$export$386587bcf05ee8ea = (0, $6laLp.logInfoMessageWithPackageContext)($37ee1557f838d13e$var$packageContext);
const $37ee1557f838d13e$export$9edc7d6f1c33ddc = (0, $6laLp.createErrorHandlerWithPackageContext)($37ee1557f838d13e$var$packageContext);

});



parcelRegister("hp0Uy", function(module, exports) {

$parcel$export(module.exports, "default", () => $608b62e0f12beeea$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5v4Ut = parcelRequire("5v4Ut");

var $jEb7N = parcelRequire("jEb7N");
const $608b62e0f12beeea$var$initialStates = {
    DialogComponent: null,
    dialogProps: null,
    isOpen: false
};
function $608b62e0f12beeea$var$dialogReducer(state, action) {
    switch(action.type){
        case 'open':
            return {
                ...state,
                DialogComponent: action.payload?.DialogComponent || null,
                dialogProps: action.payload?.dialogProps || null,
                isOpen: true
            };
        case 'close':
            return {
                ...state,
                DialogComponent: null,
                dialogProps: null,
                isOpen: false
            };
        default:
            throw new Error();
    }
}
function $608b62e0f12beeea$export$2e2bcd8739ae039(props) {
    const { children: children } = props;
    const [stateDialogProvider, dispatch] = (0, $5uXOq.useReducer)($608b62e0f12beeea$var$dialogReducer, $608b62e0f12beeea$var$initialStates);
    const valueProvider = (0, $5uXOq.useMemo)(()=>({
            openDialog: (DialogComponent, dialogProps = null)=>dispatch({
                    type: 'open',
                    payload: {
                        DialogComponent: DialogComponent,
                        dialogProps: dialogProps
                    }
                }),
            closeDialog: ()=>dispatch({
                    type: 'close'
                })
        }), []);
    return(// @ts-ignore
    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $jEb7N.DialogsContext).Provider, {
        value: valueProvider,
        children: [
            children,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5v4Ut.default), {
                ...stateDialogProvider
            })
        ]
    }));
}

});
parcelRegister("5v4Ut", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7bcdd061a77cbb4$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i8Qvm = parcelRequire("i8Qvm");

var $jEb7N = parcelRequire("jEb7N");
function $f7bcdd061a77cbb4$export$2e2bcd8739ae039(props) {
    const { DialogComponent: DialogComponent, isOpen: isOpen, onClose: onClose, dialogProps: dialogProps } = props;
    const { closeDialog: closeDialog } = (0, $5uXOq.useContext)((0, $jEb7N.DialogsContext));
    if (!DialogComponent) return null;
    const handleCloseDialog = ()=>{
        closeDialog();
        if (onClose) onClose();
        if (dialogProps?.onClose) dialogProps.onClose();
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i8Qvm.default), {
        children: isOpen && /*#__PURE__*/ (0, $2OMIu.jsx)(DialogComponent, {
            ...dialogProps,
            onClose: handleCloseDialog
        })
    });
}

});
parcelRegister("jEb7N", function(module, exports) {

$parcel$export(module.exports, "DialogsContext", () => $2f7aa3668b03ace3$export$412f7f691e39b0da);

var $5uXOq = parcelRequire("5uXOq");
const $2f7aa3668b03ace3$var$dialogsContextState = {
    openDialog: ()=>null,
    closeDialog: ()=>null
};
const $2f7aa3668b03ace3$export$412f7f691e39b0da = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext($2f7aa3668b03ace3$var$dialogsContextState);

});



parcelRegister("cIr29", function(module, exports) {

$parcel$export(module.exports, "default", () => $939256824ae02946$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");

var $a2luh = parcelRequire("a2luh");

var $71zQI = parcelRequire("71zQI");
/**
 * Sets up the react-intl IntlProvider for its children, blocking until translations are loaded
 */ const $939256824ae02946$var$NO_MESSAGES = {};
class $939256824ae02946$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    componentDidMount() {
        if (this.props.skip !== true) this.loadData();
    }
    async loadData() {
        const { messagesConfig: messagesConfig, locale: predefinedLocale } = this.props;
        const locale = await (0, $71zQI.getEffectiveLocale)(predefinedLocale);
        if (locale === (0, $71zQI.DEFAULT_LOCALE)) {
            // Everything is already loaded for English
            this.setState({
                locale: (0, $71zQI.DEFAULT_LOCALE),
                messages: {}
            });
            return;
        }
        try {
            const messages = await (0, $71zQI.loadIntlData)(messagesConfig, locale);
            this.setState({
                locale: locale,
                messages: messages || $939256824ae02946$var$NO_MESSAGES
            });
        } catch (error) {
            // @ts-ignore
            (0, $a2luh.logException)(error, 'Error loading translations.', {
                locale: locale
            });
            // show english on error
            this.setState({
                locale: (0, $71zQI.DEFAULT_LOCALE),
                messages: $939256824ae02946$var$NO_MESSAGES
            });
        }
    }
    render() {
        const { skip: skip } = this.props;
        // TODO: [PTC-4968] Long term 'skip' prop to be removed in favour being skipped by
        //       default and `embeddable-directory` to rely on parent product i18n provider.
        //       The idea is to merge package i18n files into product ones, and ship that
        //       one global product i18n translation rather than packages fetching their own.
        if (skip) return this.props.children;
        const { locale: locale, messages: messages } = this.state;
        // Idea for improvement we should not block rendering UI while fetching messages
        // https://product-fabric.atlassian.net/browse/PTC-2176
        if (!messages) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
            "data-test-language": locale,
            locale: locale,
            defaultLocale: (0, $71zQI.DEFAULT_LOCALE),
            messages: messages,
            children: this.props.children
        }, `intl-provider-5-${locale}`);
    }
    constructor(...args){
        super(...args), this.state = {
            locale: (0, $71zQI.DEFAULT_LOCALE),
            messages: undefined
        };
    }
}

});
parcelRegister("71zQI", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LOCALE", () => $3675bcd7e4fae498$export$1af4c7e47ad72f44);
$parcel$export(module.exports, "getEffectiveLocale", () => $3675bcd7e4fae498$export$5211f28df9ef284a);
$parcel$export(module.exports, "loadIntlData", () => $3675bcd7e4fae498$export$d225990554fb28f7);

var $8mCW3 = parcelRequire("8mCW3");

var $dyczo = parcelRequire("dyczo");

var $ctZPp = parcelRequire("ctZPp");
const $3675bcd7e4fae498$export$1af4c7e47ad72f44 = 'en';
const $3675bcd7e4fae498$export$b6a046f0eef1bb2 = [
    'cs',
    'cs-CZ',
    'da',
    'da-DK',
    'de',
    'de-DE',
    'en',
    'en-GB',
    'en-US',
    'en-ZZ',
    'es',
    'es-ES',
    'et',
    'et-EE',
    'fi',
    'fi-FI',
    'fr',
    'fr-FR',
    'hu',
    'hu-HU',
    'is',
    'is-IS',
    'it',
    'it-IT',
    'ja',
    'ja-JP',
    'ko',
    'ko-KR',
    'nb',
    'nb-NO',
    'nl',
    'nl-NL',
    'pl',
    'pl-PL',
    'pt',
    'pt-BR',
    'pt-PT',
    'ro',
    'ro-RO',
    'ru',
    'ru-RU',
    'sk',
    'sk-SK',
    'sv',
    'sv-SE',
    'tr',
    'tr-TR',
    'th',
    'th-TH',
    'uk',
    'uk-UA',
    'vi',
    'vi-VN',
    'zh',
    'zh-TW',
    'zh-HK',
    'zh-ZH',
    'zh-CN'
];
// In URL, a tester can pass lang code or locale into URL, e.g `?locale=fr` or `?locale=cs-CZ`
const $3675bcd7e4fae498$var$getLocaleFromUrl = ()=>{
    const { locale: locale } = (0, (/*@__PURE__*/$parcel$interopDefault($8mCW3))).parse((0, (/*@__PURE__*/$parcel$interopDefault($dyczo))).location.search);
    const localeFromUrl = Array.isArray(locale) ? locale[0] : locale;
    return localeFromUrl;
};
function $3675bcd7e4fae498$var$getSupportedLocale(locale) {
    if (typeof locale !== 'string') return null;
    locale = locale.replace('_', '-');
    if ($3675bcd7e4fae498$export$b6a046f0eef1bb2.includes(locale)) return locale;
    // If we don't have the exact locale available, attempt to match just the language
    const languageCode = locale.substring(0, 2);
    if ($3675bcd7e4fae498$export$b6a046f0eef1bb2.includes(languageCode)) return languageCode;
}
const $3675bcd7e4fae498$export$5211f28df9ef284a = async (predefinedLocale)=>{
    // locale that we can manually pass to intl provider
    const receivedLocale = $3675bcd7e4fae498$var$getSupportedLocale(predefinedLocale);
    if (receivedLocale) return receivedLocale;
    // locale that we can pass to intl provider via `locale` GET param
    const localeInUrl = $3675bcd7e4fae498$var$getSupportedLocale($3675bcd7e4fae498$var$getLocaleFromUrl());
    if (localeInUrl) return localeInUrl;
    let userLocale;
    try {
        userLocale = (await (0, $ctZPp.userInfoProvider).get()).locale;
    } catch (e) {
        userLocale = $3675bcd7e4fae498$export$1af4c7e47ad72f44;
    }
    return $3675bcd7e4fae498$var$getSupportedLocale(userLocale) || $3675bcd7e4fae498$export$1af4c7e47ad72f44;
};
const $3675bcd7e4fae498$export$d225990554fb28f7 = (localesConfig, locale)=>{
    const pickedConfig = localesConfig.find((config)=>config.locales.includes(locale));
    const loader = pickedConfig?.loader;
    if (!loader) return Promise.resolve(null);
    return new Promise((resolve, reject)=>{
        // Fails if we haven't loaded/resolved after 30 seconds
        const rejectTimer = setTimeout(reject, 30000);
        loader().then((res)=>{
            clearTimeout(rejectTimer);
            // depending on a builder and config used in a project the result of dynamic imports could be behind `default`
            // this way we'll cover both cases
            resolve(res && res.default || res);
        });
    });
};

});
parcelRegister("8mCW3", function(module, exports) {

$parcel$export(module.exports, "extract", () => $616e948c9a94d77d$export$f9380c9a627682d3, (v) => $616e948c9a94d77d$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $616e948c9a94d77d$export$98e6a39c04603d36, (v) => $616e948c9a94d77d$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $616e948c9a94d77d$export$fac44ee5b035f737, (v) => $616e948c9a94d77d$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $616e948c9a94d77d$export$7a5253c0f62e0150, (v) => $616e948c9a94d77d$export$7a5253c0f62e0150 = v);
$parcel$export(module.exports, "stringifyUrl", () => $616e948c9a94d77d$export$a8c1621ea79325d3, (v) => $616e948c9a94d77d$export$a8c1621ea79325d3 = v);
$parcel$export(module.exports, "pick", () => $616e948c9a94d77d$export$357523c63a2253b9, (v) => $616e948c9a94d77d$export$357523c63a2253b9 = v);
$parcel$export(module.exports, "exclude", () => $616e948c9a94d77d$export$44c361b8ec72ef7f, (v) => $616e948c9a94d77d$export$44c361b8ec72ef7f = v);
var $616e948c9a94d77d$export$f9380c9a627682d3;
var $616e948c9a94d77d$export$98e6a39c04603d36;
var $616e948c9a94d77d$export$fac44ee5b035f737;
var $616e948c9a94d77d$export$7a5253c0f62e0150;
var $616e948c9a94d77d$export$a8c1621ea79325d3;
var $616e948c9a94d77d$export$357523c63a2253b9;
var $616e948c9a94d77d$export$44c361b8ec72ef7f;
'use strict';

var $hlggt = parcelRequire("hlggt");

var $aCrRe = parcelRequire("aCrRe");

var $gjKya = parcelRequire("gjKya");

var $cNVkY = parcelRequire("cNVkY");
const $616e948c9a94d77d$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $616e948c9a94d77d$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function $616e948c9a94d77d$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $616e948c9a94d77d$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $616e948c9a94d77d$var$encode(key, options),
                            '[',
                            $616e948c9a94d77d$var$encode(index, options),
                            ']=',
                            $616e948c9a94d77d$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $616e948c9a94d77d$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $616e948c9a94d77d$var$encode(key, options),
                            '[]=',
                            $616e948c9a94d77d$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $616e948c9a94d77d$var$encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $616e948c9a94d77d$var$encode(key, options),
                            ':list=',
                            $616e948c9a94d77d$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                $616e948c9a94d77d$var$encode(key, options),
                                keyValueSep,
                                $616e948c9a94d77d$var$encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                $616e948c9a94d77d$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $616e948c9a94d77d$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $616e948c9a94d77d$var$encode(key, options),
                            '=',
                            $616e948c9a94d77d$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $616e948c9a94d77d$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $616e948c9a94d77d$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $616e948c9a94d77d$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$616e948c9a94d77d$var$decode(item, options)) : value === null ? value : $616e948c9a94d77d$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? $616e948c9a94d77d$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$616e948c9a94d77d$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $616e948c9a94d77d$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $616e948c9a94d77d$var$encode(value, options) {
    if (options.encode) return options.strict ? $hlggt(value) : encodeURIComponent(value);
    return value;
}
function $616e948c9a94d77d$var$decode(value, options) {
    if (options.decode) return $aCrRe(value);
    return value;
}
function $616e948c9a94d77d$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $616e948c9a94d77d$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $616e948c9a94d77d$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $616e948c9a94d77d$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $616e948c9a94d77d$var$extract(input) {
    input = $616e948c9a94d77d$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $616e948c9a94d77d$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $616e948c9a94d77d$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $616e948c9a94d77d$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $616e948c9a94d77d$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $gjKya(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : $616e948c9a94d77d$var$decode(value, options);
        formatter($616e948c9a94d77d$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $616e948c9a94d77d$var$parseValue(value[k], options);
        else ret[key] = $616e948c9a94d77d$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $616e948c9a94d77d$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$616e948c9a94d77d$export$f9380c9a627682d3 = $616e948c9a94d77d$var$extract;
$616e948c9a94d77d$export$98e6a39c04603d36 = $616e948c9a94d77d$var$parse;
$616e948c9a94d77d$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $616e948c9a94d77d$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $616e948c9a94d77d$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $616e948c9a94d77d$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $616e948c9a94d77d$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $616e948c9a94d77d$var$encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return $616e948c9a94d77d$var$encode(key, options) + '=' + $616e948c9a94d77d$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$616e948c9a94d77d$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $gjKya(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $616e948c9a94d77d$var$parse($616e948c9a94d77d$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $616e948c9a94d77d$var$decode(hash, options)
    } : {});
};
$616e948c9a94d77d$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$616e948c9a94d77d$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $616e948c9a94d77d$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $616e948c9a94d77d$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $616e948c9a94d77d$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $616e948c9a94d77d$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $616e948c9a94d77d$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$616e948c9a94d77d$var$encodeFragmentIdentifier] ? $616e948c9a94d77d$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$616e948c9a94d77d$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$616e948c9a94d77d$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $616e948c9a94d77d$export$7a5253c0f62e0150(input, options);
    return $616e948c9a94d77d$export$a8c1621ea79325d3({
        url: url,
        query: $cNVkY(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$616e948c9a94d77d$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $616e948c9a94d77d$export$357523c63a2253b9(input, exclusionFilter, options);
};

});

parcelRegister("ctZPp", function(module, exports) {

$parcel$export(module.exports, "userInfoProvider", () => $873f8fc415d06144$export$30a852ca4cb27370);

var $jCvwN = parcelRequire("jCvwN");
// Needs to be declared here to avoid blowing up this earlyInit bundle
class $873f8fc415d06144$var$FetchError extends Error {
    constructor(response){
        super(`Request failed with status ${response.status}`);
        this.response = response;
        this.name = this.constructor.name;
    }
}
class $873f8fc415d06144$export$dc10e400a1189789 {
    get(fetchOp = fetch) {
        if (this.promise) return this.promise;
        const getJson = (url)=>fetchOp(url, {
                method: 'GET',
                mode: 'cors',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then((response)=>{
                if (!response.ok) throw new $873f8fc415d06144$var$FetchError(response);
                return response.json();
            });
        this.promise = getJson(`${(0, $jCvwN.getConfig)().stargateRoot}/me`).then((me)=>{
            return {
                userId: me.account_id,
                locale: me.locale,
                fullName: me.name,
                avatarUrl: me.picture,
                email: me.email,
                title: me.extended_profile?.job_title
            };
        });
        return this.promise;
    }
}
const $873f8fc415d06144$export$30a852ca4cb27370 = new $873f8fc415d06144$export$dc10e400a1189789();

});



parcelRegister("03Q1P", function(module, exports) {

$parcel$export(module.exports, "statusCodeHandlersProvider", () => $4ac67c876d5328b4$export$8c005e458e12d501);
$parcel$export(module.exports, "handleResponse", () => $4ac67c876d5328b4$export$c113a67a6762ad2e);
/**
 * Our REST clients are initialised when their module loads which makes it tricky for them to consume the `statusCodeHandlers` prop passed to App from the host application.
 * This is a temporary measure to enable the clients to consume `statusCodeHandlers`.
 * The long term solution is to replace our REST clients with Apollo client custom resolvers
 * This will unify all remote data handling under the apollo-client module which is able to easily receive `statusCodeHandlers` as it is initialised within the React portion of our app.
 */ const $4ac67c876d5328b4$export$8c005e458e12d501 = {
    handlers: {},
    get () {
        return $4ac67c876d5328b4$export$8c005e458e12d501.handlers;
    },
    setHandlers (handlers) {
        $4ac67c876d5328b4$export$8c005e458e12d501.handlers = handlers;
    }
};
function $4ac67c876d5328b4$export$c113a67a6762ad2e(response) {
    const { status: status } = response;
    const handler = $4ac67c876d5328b4$export$8c005e458e12d501.get()[status];
    if (typeof handler === 'function') handler(response);
}

});

parcelRegister("c5gm9", function(module, exports) {

$parcel$export(module.exports, "useOrg", () => $11a92b2a8aefe8e7$export$7f785727a26e156);

var $3sQ5x = parcelRequire("3sQ5x");

var $woaYX = parcelRequire("woaYX");
const $11a92b2a8aefe8e7$export$7f785727a26e156 = (0, $3sQ5x.createHook)((0, $woaYX.Store));

});
parcelRegister("woaYX", function(module, exports) {

$parcel$export(module.exports, "Store", () => $07b7dde0a7e966ee$export$390f32400eaf98c9);

var $iXqE5 = parcelRequire("iXqE5");
const $07b7dde0a7e966ee$var$actions = {
    setOrgId: (orgId)=>({ setState: setState })=>{
            setState({
                orgId: orgId
            });
        }
};
const $07b7dde0a7e966ee$var$initialState = {
    orgId: undefined
};
const $07b7dde0a7e966ee$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    initialState: $07b7dde0a7e966ee$var$initialState,
    actions: $07b7dde0a7e966ee$var$actions,
    name: 'Org'
});

});


parcelRegister("5WmsO", function(module, exports) {

$parcel$export(module.exports, "useSite", () => $2334f40708093356$export$7870fa8e7cdd59f8);
$parcel$export(module.exports, "useCloudId", () => $2334f40708093356$export$9da0f7c65f28ed16);

var $3sQ5x = parcelRequire("3sQ5x");

var $9X1pV = parcelRequire("9X1pV");
const $2334f40708093356$export$7870fa8e7cdd59f8 = (0, $3sQ5x.createHook)((0, $9X1pV.Store));
const $2334f40708093356$export$9da0f7c65f28ed16 = ()=>$2334f40708093356$export$7870fa8e7cdd59f8()[0].cloudId;

});
parcelRegister("9X1pV", function(module, exports) {

$parcel$export(module.exports, "Store", () => $2c6a7fe3c9c74788$export$390f32400eaf98c9);

var $iXqE5 = parcelRequire("iXqE5");
const $2c6a7fe3c9c74788$var$actions = {
    // This action is used by EmbeddedDirectory to get Cloud Id in a remote store.
    setCloudId: (cloudId)=>({ setState: setState })=>{
            setState({
                cloudId: cloudId
            });
        }
};
const $2c6a7fe3c9c74788$var$initialState = {
    cloudId: ''
};
const $2c6a7fe3c9c74788$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    initialState: $2c6a7fe3c9c74788$var$initialState,
    actions: $2c6a7fe3c9c74788$var$actions,
    name: 'Site'
});

});


parcelRegister("4ArtL", function(module, exports) {

$parcel$export(module.exports, "useTeamCentralStore", () => $ed1928058adb05a8$export$39314e672c06693f);
$parcel$export(module.exports, "useTeamCentralStoreApi", () => $ed1928058adb05a8$export$7c58a39ba496932b);
$parcel$export(module.exports, "useIsTeamCentral", () => $ed1928058adb05a8$export$9da989c55553d02d);
$parcel$export(module.exports, "useTeamCentralPresent", () => $ed1928058adb05a8$export$20f07b26e9a56b9);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $5euJh = parcelRequire("5euJh");

var $jCvwN = parcelRequire("jCvwN");

var $65HPA = parcelRequire("65HPA");
const $ed1928058adb05a8$var$initialState = {
    isTeamCentral: false,
    hasWorkspace: false,
    orgHasWorkspace: false,
    teamCentralHandlers: {},
    teamCentralUrl: undefined
};
const $ed1928058adb05a8$var$actions = {
    initTeamCentral: (appName, cloudId, teamCentralHandlers = {})=>({ setState: setState })=>{
            const isTeamCentral = appName === 'teamcentral-directory';
            let teamCentralUrlPromise;
            if ((0, $jCvwN.getConfig)().teamCentralDisabled === true) teamCentralUrlPromise = Promise.resolve(undefined);
            else teamCentralUrlPromise = (0, $65HPA.default).isGlobalExperienceWorkspaceForCloudId(cloudId).then((isGlobalExperience)=>{
                return isGlobalExperience ? (0, $5euJh.getATLContextUrl)('home') : (0, $5euJh.getATLContextUrl)('team');
            });
            if (isTeamCentral) // Assume site already has a TC workspace if directory is running in TC mode
            teamCentralUrlPromise.then((teamCentralUrl)=>{
                setState({
                    isTeamCentral: isTeamCentral,
                    hasWorkspace: true,
                    orgHasWorkspace: true,
                    teamCentralHandlers: teamCentralHandlers,
                    teamCentralUrl: teamCentralUrl
                });
            });
            else {
                // Otherwise, fetch for workspace information
                const requests = [
                    (0, $65HPA.default).hasWorkspaceForCloudId(cloudId),
                    (0, $65HPA.default).doesOrgContainAnyWorkspace(cloudId),
                    teamCentralUrlPromise
                ];
                Promise.all(requests).then(([hasWorkspace, orgHasWorkspace, teamCentralUrl])=>{
                    setState({
                        isTeamCentral: false,
                        hasWorkspace: hasWorkspace,
                        orgHasWorkspace: orgHasWorkspace,
                        teamCentralHandlers: teamCentralHandlers,
                        teamCentralUrl: teamCentralUrl
                    });
                });
            }
        }
};
/**
 * Manage states of searching People and Teams in search home page.
 */ const $ed1928058adb05a8$var$Store = (0, $iXqE5.createStore)({
    initialState: $ed1928058adb05a8$var$initialState,
    actions: $ed1928058adb05a8$var$actions,
    name: 'SearchHomePage'
});
const $ed1928058adb05a8$export$39314e672c06693f = (0, $3sQ5x.createHook)($ed1928058adb05a8$var$Store);
const $ed1928058adb05a8$export$7c58a39ba496932b = (0, $3sQ5x.createHook)($ed1928058adb05a8$var$Store, {
    selector: null
});
const $ed1928058adb05a8$export$9da989c55553d02d = (0, $3sQ5x.createHook)($ed1928058adb05a8$var$Store, {
    selector: (s)=>s.isTeamCentral
});
const $ed1928058adb05a8$export$20f07b26e9a56b9 = (0, $3sQ5x.createHook)($ed1928058adb05a8$var$Store, {
    selector: (s)=>s.isTeamCentral || s.hasWorkspace || s.orgHasWorkspace
});

});
parcelRegister("65HPA", function(module, exports) {

$parcel$export(module.exports, "default", () => $11304638e828f937$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");

var $jCvwN = parcelRequire("jCvwN");

var $csox3 = parcelRequire("csox3");
const $11304638e828f937$var$UNSHARDED_PREFIX = '/watermelon';
class $11304638e828f937$export$424050aeba67e883 extends (0, $csox3.default) {
    constructor(){
        super({
            serviceUrl: (0, $jCvwN.getConfig)().stargateRoot
        });
    }
    async hasWorkspaceForCloudId(cloudId) {
        try {
            await this.getResource(`${this.buildShardedPrefix(cloudId)}/workspace/exists?cloudId=${cloudId}`);
            return true;
        } catch (err) {
            return false;
        }
    }
    async doesOrgContainAnyWorkspace(cloudId) {
        try {
            await this.getResource(((0, $VSDnB.fg)('enable_ptc_townsquare_reporting_lines_unsharded') ? $11304638e828f937$var$UNSHARDED_PREFIX : this.buildShardedPrefix(cloudId)) + `/organization/containsAnyWorkspace?cloudId=${cloudId}`);
            return true;
        } catch (err) {
            return false;
        }
    }
    async isGlobalExperienceWorkspaceForCloudId(cloudId) {
        try {
            const res = await this.makeRequest(`${this.buildShardedPrefix(cloudId)}/workspace/existsWithWorkspaceType?cloudId=${cloudId}`, {
                headers: {
                    Accept: 'text/plain'
                }
            });
            return Promise.resolve(res === 'GLOBAL_EXPERIENCE');
        } catch (err) {
            return Promise.resolve(false);
        }
    }
    buildShardedPrefix(cloudId) {
        return `/townsquare/s/${cloudId}`;
    }
}
var /**
 * REST Client to make calls to resources on the team central service.
 *
 * Note: You probably don't want to use this directly. Use the centralised store instead where these values
 * have already been fetched. See useTeamCentralStore().
 *
 * @type {RestClient}
 */ // eslint-disable-next-line import/no-anonymous-default-export
$11304638e828f937$export$2e2bcd8739ae039 = new $11304638e828f937$export$424050aeba67e883();

});
parcelRegister("csox3", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dc819ac862569b6$export$2e2bcd8739ae039);

var $1UikQ = parcelRequire("1UikQ");

var $bxYf9 = parcelRequire("bxYf9");

var $jjM7Z = parcelRequire("jjM7Z");

var $4Y6oo = parcelRequire("4Y6oo");

var $4BpOs = parcelRequire("4BpOs");

var $f5deG = parcelRequire("f5deG");

var $03Q1P = parcelRequire("03Q1P");
const $4dc819ac862569b6$var$defaultFetchOptions = {
    credentials: 'include',
    headers: {
        Accept: 'application/json'
    },
    mode: 'cors'
};
const $4dc819ac862569b6$var$fetchWithExponentialBackoff = (0, $f5deG.withDefaultExponentialBackoff)(fetch);
// tslint:disable-next-line no-any
function $4dc819ac862569b6$var$parseResponse(response) {
    const responseStatusCode = response.status;
    if (responseStatusCode === 204 || responseStatusCode === 202) return null;
    const contentType = response.headers.get('content-type');
    if (!contentType || contentType.includes('text/html') || contentType.includes('text/plain')) return response.text();
    if (contentType.includes('application/json')) return response.json();
    return null;
}
async function $4dc819ac862569b6$export$91c32f1b22d29b2d(response) {
    let json;
    const text = await response.text();
    try {
        json = JSON.parse(text);
    } catch (err) {
        return text;
    }
    delete json.timestamp; // to dedupe sentry, scrub non-unique 'timestamp' field from the error body
    if (json.errors) {
        const errs = json.errors.map((error)=>typeof error === 'string' ? error : error.code || error.message || (0, $4BpOs.DirectoryErrorCode).MISSING_ERROR_MESSAGE);
        return errs.join('\n - ');
    }
    return JSON.stringify(json);
}
let $4dc819ac862569b6$var$incrementRedirectCount;
let $4dc819ac862569b6$var$clearRedirectCount;
$4dc819ac862569b6$export$7a0fc52d8c359feb();
function $4dc819ac862569b6$export$7a0fc52d8c359feb() {
    $4dc819ac862569b6$var$incrementRedirectCount = (0, (/*@__PURE__*/$parcel$interopDefault($bxYf9)))(()=>(0, $4Y6oo.setCookie)((0, $4Y6oo.REDIRECT_COUNT), (0, $4Y6oo.getCookieAsInteger)((0, $4Y6oo.REDIRECT_COUNT)) + 1));
    $4dc819ac862569b6$var$clearRedirectCount = (0, (/*@__PURE__*/$parcel$interopDefault($bxYf9)))(()=>(0, $4Y6oo.clearCookie)((0, $4Y6oo.REDIRECT_COUNT)));
}
class $4dc819ac862569b6$var$RestClient {
    constructor({ serviceUrl: serviceUrl = '' } = {}){
        /**
	 * This function is necessary for if `statusCodeHandler` prescribes a login
	 * redirect upon a 401 response.
	 * While the default redirect behaviour may be overriden, this function has
	 * been kept separate to ensure it cannot be overriden, lest a host
	 * application supply embeddable-directory with a custom handler that suffers
	 * the infinite redirect bug.
	 */ this.preventInfiniteRedirectLoop = (response)=>{
            if (!response.ok) {
                const responseStatusCode = response.status;
                if (responseStatusCode === 401) $4dc819ac862569b6$var$incrementRedirectCount();
            } else $4dc819ac862569b6$var$clearRedirectCount();
        };
        this.serviceUrl = serviceUrl;
    }
    async getResource(path) {
        return this.makeRequest(path);
    }
    async postResource(path, data, fetchOptions = {}) {
        return this.postResourceRaw(path, JSON.stringify(data), fetchOptions);
    }
    async postResourceRaw(path, data, fetchOptions = {}) {
        fetchOptions = {
            method: 'post',
            headers: {},
            ...fetchOptions
        };
        if (data) fetchOptions = {
            body: data,
            ...fetchOptions,
            headers: {
                'Content-Type': 'application/json',
                ...fetchOptions.headers
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async patchResource(path, data) {
        let fetchOptions = {
            /**
			 * PATCH must be uppercase as per fetch spec only
			 * DELETE, GET, HEAD, OPTIONS, POST, and PUT methods
			 * are normalised to uppercase.
			 *
			 * https://github.com/github/fetch/issues/37
			 * https://fetch.spec.whatwg.org/#methods
			 */ method: 'PATCH'
        };
        if (data) fetchOptions = {
            ...fetchOptions,
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async putResource(path, data, additionalFetchOptions = {}) {
        const fetchOptions = {
            method: 'put'
        };
        if (data) Object.assign(fetchOptions, {
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return this.makeRequest(path, {
            ...fetchOptions,
            ...additionalFetchOptions
        });
    }
    async deleteResource(path, options = {}) {
        const fetchOptions = {
            ...options,
            method: 'delete'
        };
        return this.makeRequest(path, fetchOptions);
    }
    async makeRequest(path, additionalFetchOptions = {}) {
        const url = this.serviceUrl + path;
        const options = (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, $4dc819ac862569b6$var$defaultFetchOptions, additionalFetchOptions);
        const response = await $4dc819ac862569b6$var$fetchWithExponentialBackoff(url, options);
        this.preventInfiniteRedirectLoop(response);
        (0, $03Q1P.handleResponse)(response);
        const responseStatusCode = response.status;
        const traceId = response.headers.get('atl-traceid');
        if (!response.ok) {
            if (responseStatusCode === 401) throw new (0, $jjM7Z.SentryIgnoreError)({
                message: 'Unauthorized Request - incrementing redirect count'
            });
            else {
                const message = await $4dc819ac862569b6$export$91c32f1b22d29b2d(response);
                throw new (0, $jjM7Z.HttpError)({
                    message: message,
                    status: responseStatusCode,
                    traceId: traceId ?? undefined
                });
            }
        }
        return additionalFetchOptions.ignoreResponse ? null : $4dc819ac862569b6$var$parseResponse(response);
    }
}
var $4dc819ac862569b6$export$2e2bcd8739ae039 = $4dc819ac862569b6$var$RestClient;

});
parcelRegister("jjM7Z", function(module, exports) {

$parcel$export(module.exports, "SentryIgnoreError", () => $0468019abd35294d$export$20de9a0e470e95aa);
$parcel$export(module.exports, "HttpError", () => $0468019abd35294d$export$65bd6083489bd8bb);
// Extending new custom Error types with `Object.setPrototypeOf`
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/setPrototypeOf
class $0468019abd35294d$var$CommonError extends Error {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        this.message = message;
        this.stack = new Error(message).stack || '';
    }
}
class $0468019abd35294d$export$c73ca302efeda3b4 extends $0468019abd35294d$var$CommonError {
    constructor({ message: message }){
        super(message || 'UnknownError');
        Object.setPrototypeOf(this, $0468019abd35294d$export$c73ca302efeda3b4.prototype);
    }
}
class $0468019abd35294d$export$20de9a0e470e95aa extends $0468019abd35294d$var$CommonError {
    constructor({ message: message }){
        super(`SentryIgnore: ${message || 'UnknownError'}`);
        Object.setPrototypeOf(this, $0468019abd35294d$export$20de9a0e470e95aa.prototype);
    }
}
class $0468019abd35294d$export$65bd6083489bd8bb extends $0468019abd35294d$var$CommonError {
    constructor({ message: message, status: status, traceId: traceId }){
        super(message);
        Object.setPrototypeOf(this, $0468019abd35294d$export$65bd6083489bd8bb.prototype);
        this.status = status;
        this.traceId = traceId;
    }
}
class $0468019abd35294d$export$92d6ed0888e7cb7f extends $0468019abd35294d$var$CommonError {
    constructor({ message: message, category: category = 'default', fields: fields }){
        super(message);
        Object.setPrototypeOf(this, $0468019abd35294d$export$92d6ed0888e7cb7f.prototype);
        this.category = category;
        if (fields) this.fields = fields;
    }
    static{
        this.from = (rawErrors)=>{
            const firstError = rawErrors[0];
            const errorData = {
                category: firstError.category,
                message: firstError.message
            };
            if (firstError.fields) errorData.fields = firstError.fields.reduce((obj, item)=>{
                obj[item.field] = item.message;
                return obj;
            }, {});
            return new $0468019abd35294d$export$92d6ed0888e7cb7f(errorData);
        };
    }
}

});

parcelRegister("4Y6oo", function(module, exports) {

$parcel$export(module.exports, "REDIRECT_COUNT", () => $a67eb8f909662980$export$f6101897f0230549);
$parcel$export(module.exports, "setCookie", () => $a67eb8f909662980$export$110700823644f4a6);
$parcel$export(module.exports, "getCookieAsInteger", () => $a67eb8f909662980$export$6a289e5003f59269);
$parcel$export(module.exports, "clearCookie", () => $a67eb8f909662980$export$ad3506281d5a5e5d);
const $a67eb8f909662980$export$f6101897f0230549 = 'redirectCount';
const $a67eb8f909662980$export$5a7d8afb87170e45 = 'avatar.csrf.token';
function $a67eb8f909662980$export$110700823644f4a6(key, value) {
    document.cookie = `${key}=${value};path=/;max-age=30`;
}
function $a67eb8f909662980$export$6a289e5003f59269(key, defaultValue = 0) {
    const regex = new RegExp(`${key}=(\\d+)`);
    const result = document.cookie.match(regex);
    return result ? parseInt(result[1], 10) : defaultValue;
}
function $a67eb8f909662980$export$ad3506281d5a5e5d(key) {
    document.cookie = `${key}=doesntmatter;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
}

});

parcelRegister("f5deG", function(module, exports) {

$parcel$export(module.exports, "withDefaultExponentialBackoff", () => $fe882ca8e63df7d3$export$455df4c93665fa4a);
const $fe882ca8e63df7d3$export$8f4286bf21155381 = {
    INITIAL_DELAY: 200,
    MAX_RETRIES: 5,
    JITTER: true
};
function $fe882ca8e63df7d3$export$55b2fbd5d4a32495(status) {
    return 500 <= status && status <= 599;
}
// tslint:disable-next-line no-any
const $fe882ca8e63df7d3$var$defaultRetryIfCallback = (a)=>!a;
const $fe882ca8e63df7d3$var$defaultOptions = {
    initial: 200,
    jitter: false,
    max: 5,
    retryIf: $fe882ca8e63df7d3$var$defaultRetryIfCallback
};
function $fe882ca8e63df7d3$export$20eaa22f2295996f(toTry, hofOptions = $fe882ca8e63df7d3$var$defaultOptions) {
    const { initial: initial, jitter: jitter, max: max, retryIf: retryIf } = hofOptions;
    // Initialize max retry decrementing counter (range of max...0)
    let attemptsRemaining = max;
    // Initialize delay. This will exponentially increase each retry (delay = intial * 2^n)
    let delay = initial;
    /**
	 * This function calls itself recursively until `retryIf` evaluates false or the retry limit is reached.
	 * The functioned-to-be-retried is called on each recursion.
	 */ return async function tryWithExponentialBackoff(...args) {
        // "An attempt was made"
        const result = await toTry(...args);
        --attemptsRemaining;
        // If tried function was unsuccessful and there are still retries remaining, retry!
        if (retryIf && retryIf(result) && attemptsRemaining > 0) {
            // Wait for delay
            await new Promise((resolve)=>setTimeout(resolve, jitter ? Math.random() * delay : delay));
            // Exponentially increase delay
            delay *= 2;
            // Initiate retry
            return tryWithExponentialBackoff(...args);
        }
        // Return result of tried function if it is successful or if the retry limit
        // was reached regardless of success.
        return result;
    };
}
function $fe882ca8e63df7d3$export$455df4c93665fa4a(fetchOp) {
    return $fe882ca8e63df7d3$export$20eaa22f2295996f(fetchOp, {
        initial: $fe882ca8e63df7d3$export$8f4286bf21155381.INITIAL_DELAY,
        jitter: $fe882ca8e63df7d3$export$8f4286bf21155381.JITTER,
        max: $fe882ca8e63df7d3$export$8f4286bf21155381.MAX_RETRIES,
        retryIf: (response)=>$fe882ca8e63df7d3$export$55b2fbd5d4a32495(response.status)
    });
}

});




parcelRegister("gaG9X", function(module, exports) {

$parcel$export(module.exports, "useJiraCheckService", () => $b67c9a626cb8466f$export$b998d6ed276aaffa);

var $5uXOq = parcelRequire("5uXOq");

var $k3Vai = parcelRequire("k3Vai");

var $dRejs = parcelRequire("dRejs");
const $b67c9a626cb8466f$export$3847702755d66eb8 = (cloudId, options)=>{
    const [request, controller] = (0, $5uXOq.useMemo)(()=>(0, $dRejs.defaultRequestAbort)(cloudId), [
        cloudId
    ]);
    const [getJiraCheck, result] = (0, $k3Vai.useLazyService)(request, controller, {
        initialState: {
            ...options?.initialState
        }
    });
    return [
        getJiraCheck,
        {
            ...result,
            isJiraAvailable: Boolean(result.data?.permitted)
        }
    ];
};
const $b67c9a626cb8466f$export$b998d6ed276aaffa = (...[cloudId, options])=>{
    const [getJiraCheck, result] = $b67c9a626cb8466f$export$3847702755d66eb8(cloudId, options);
    (0, $5uXOq.useEffect)(()=>{
        if (cloudId) getJiraCheck();
    }, [
        cloudId,
        getJiraCheck
    ]);
    return result;
};

});
parcelRegister("k3Vai", function(module, exports) {

$parcel$export(module.exports, "useLazyService", () => $cdb6ee0683636986$export$1a85343b4dbf3bf5);
$parcel$export(module.exports, "useService", () => $cdb6ee0683636986$export$6de4685a6c88b4e9);
$parcel$export(module.exports, "useServiceLight", () => $cdb6ee0683636986$export$fb699d9076441ae7);

var $5uXOq = parcelRequire("5uXOq");

var $6L4IE = parcelRequire("6L4IE");
const $cdb6ee0683636986$export$1a85343b4dbf3bf5 = (...[request, controller, options])=>{
    const [state, setState] = (0, $5uXOq.useState)({
        loading: false,
        error: undefined,
        data: undefined,
        ...options?.initialState
    });
    const getData = (0, $5uXOq.useCallback)(async ()=>{
        setState((s)=>({
                ...s,
                loading: true
            }));
        try {
            const response = await request();
            const traceId = response?.headers?.get('atl-traceid');
            let jsonResponse;
            let isResponseText = false;
            const resText = await response?.text() || '{}';
            try {
                jsonResponse = JSON.parse(resText);
            } catch  {
                isResponseText = true;
            }
            if (!response?.ok || isResponseText) {
                if (options?.ErrorHandler) throw new options.ErrorHandler({
                    ...jsonResponse,
                    traceId: traceId,
                    status: response?.status,
                    statusText: response?.statusText || resText
                });
                else throw new (0, $6L4IE.HttpError)(response?.status, response?.statusText || resText, traceId);
            }
            setState((s)=>({
                    ...s,
                    loading: false,
                    data: jsonResponse
                }));
            return response;
        } catch (error) {
            setState((s)=>({
                    ...s,
                    loading: false,
                    error: error
                }));
        }
    }, [
        request,
        options?.ErrorHandler
    ]);
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            controller.abort();
        };
    }, [
        controller
    ]);
    return [
        getData,
        state
    ];
};
const $cdb6ee0683636986$export$6de4685a6c88b4e9 = (...[request, controller, options])=>{
    const [getData, state] = $cdb6ee0683636986$export$1a85343b4dbf3bf5(request, controller, {
        ...options,
        initialState: {
            ...options?.initialState,
            loading: true
        }
    });
    (0, $5uXOq.useEffect)(()=>{
        getData();
    }, [
        getData
    ]);
    return state;
};
const $cdb6ee0683636986$export$fb699d9076441ae7 = (request, initialState = {})=>{
    const [state, setStateRaw] = (0, $5uXOq.useState)({
        loading: false,
        ...initialState
    });
    const isMounted = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    });
    const setState = (0, $5uXOq.useCallback)((state)=>{
        if (isMounted.current) setStateRaw(state);
    }, []);
    const fetchData = (0, $5uXOq.useCallback)(async ()=>{
        setState({
            loading: true,
            error: undefined,
            data: undefined
        });
        try {
            const data = await request();
            setState({
                loading: false,
                error: undefined,
                data: data
            });
        } catch (error) {
            setState({
                loading: false,
                error: error,
                data: undefined
            });
        }
    }, [
        request,
        setState
    ]);
    return {
        ...state,
        fetchData: fetchData
    };
};

});
parcelRegister("6L4IE", function(module, exports) {

$parcel$export(module.exports, "requestWithAbort", () => $2e31c1e967db2964$export$970d18814fa0cb04);
$parcel$export(module.exports, "HttpError", () => $2e31c1e967db2964$export$65bd6083489bd8bb);

var $7qHT9 = parcelRequire("7qHT9");
const $2e31c1e967db2964$export$b5fe3f66a567bec0 = (url, options = {})=>()=>fetch(url, {
            method: 'POST',
            credentials: 'include',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            ...options
        });
const $2e31c1e967db2964$export$970d18814fa0cb04 = (url, options = {})=>{
    const controller = new (0, $7qHT9.AbortControllerFacade)();
    return [
        $2e31c1e967db2964$export$b5fe3f66a567bec0(url, {
            signal: controller.signal,
            ...options
        }),
        controller
    ];
};
class $2e31c1e967db2964$export$65bd6083489bd8bb extends Error {
    constructor(code, reason, traceId){
        super(reason);
        this.code = code;
        this.traceId = traceId;
    }
}

});
parcelRegister("7qHT9", function(module, exports) {

$parcel$export(module.exports, "AbortControllerFacade", () => $ccaa19bf10bf39e9$export$f5cffffa581a7d2c);
class $ccaa19bf10bf39e9$var$AbortSignalFacade {
    constructor(){
        this.aborted = false;
        this.reason = '';
        this.onabort = ()=>{};
        this.throwIfAborted = ()=>{};
        this.addEventListener = ()=>{};
        this.removeEventListener = ()=>{};
        this.dispatchEvent = ()=>false;
    }
}
class $ccaa19bf10bf39e9$export$f5cffffa581a7d2c {
    abort() {}
    constructor(){
        this.signal = new $ccaa19bf10bf39e9$var$AbortSignalFacade();
        if (typeof window === 'object' && window.AbortController) {
            const controller = new AbortController();
            this.abort = controller.abort.bind(controller);
            this.signal = controller.signal;
        }
    }
}

});



parcelRegister("dRejs", function(module, exports) {

$parcel$export(module.exports, "defaultRequestAbort", () => $408d0402e79d4487$export$46f584bffbc74fe);

var $6L4IE = parcelRequire("6L4IE");
const $408d0402e79d4487$export$5cf469f83bcf3f9e = '/gateway/api/permissions/permitted';
const $408d0402e79d4487$export$fcd6a587480f569c = (cloudId)=>({
        permissionId: 'write',
        resourceId: `ari:cloud:jira-software::site/${cloudId}`
    });
const $408d0402e79d4487$export$46f584bffbc74fe = (cloudId)=>cloudId ? (0, $6L4IE.requestWithAbort)($408d0402e79d4487$export$5cf469f83bcf3f9e, {
        body: JSON.stringify($408d0402e79d4487$export$fcd6a587480f569c(cloudId))
    }) : [
        ()=>Promise.resolve(new Response()),
        new AbortController()
    ];

});


parcelRegister("hNjFi", function(module, exports) {

$parcel$export(module.exports, "TeamsWrapper", () => $e875d248d53e26f2$export$7d5cea3023a4360c);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $aT5ju = parcelRequire("aT5ju");

var $3VSOD = parcelRequire("3VSOD");

var $f0K80 = parcelRequire("f0K80");

var $lRyV6 = parcelRequire("lRyV6");

var $8VfUC = parcelRequire("8VfUC");

var $ffeEQ = parcelRequire("ffeEQ");
const $e875d248d53e26f2$var$IS_LOCAL = false;
function $e875d248d53e26f2$export$7d5cea3023a4360c({ children: children, appConfig: appConfig }) {
    (0, $3VSOD.useTeamsSentryClientSetup)(!$e875d248d53e26f2$var$IS_LOCAL, {
        env: appConfig.env,
        appName: appConfig.appName ? `${appConfig.appName}` : undefined
    });
    (0, $lRyV6.useSetAppConfig)(appConfig);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8VfUC.AppConfigProvider), {
        ...appConfig,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ffeEQ.ProfileCardClientConfigProvider), {
            ...appConfig,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aT5ju.PeopleTeamsAnalyticsProvider), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f0K80.DialogProvider), {
                    children: children
                })
            })
        })
    });
}

});
parcelRegister("aT5ju", function(module, exports) {

$parcel$export(module.exports, "PeopleTeamsAnalyticsProvider", () => $4bb6a60ec445fb38$export$2776b3e0720ed6df);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1PVpv = parcelRequire("1PVpv");
const $4bb6a60ec445fb38$var$defaultAnalyticsContextData = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
function $4bb6a60ec445fb38$export$2776b3e0720ed6df({ analyticsContextData: analyticsContextData, children: children }) {
    const data = (0, $5uXOq.useMemo)(()=>{
        if (typeof analyticsContextData === 'object') return {
            ...$4bb6a60ec445fb38$var$defaultAnalyticsContextData,
            ...analyticsContextData
        };
        return $4bb6a60ec445fb38$var$defaultAnalyticsContextData;
    }, [
        analyticsContextData
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1PVpv.PeopleTeamsAnalyticsContext), {
        data: data,
        children: children
    });
}

});

parcelRegister("3VSOD", function(module, exports) {

$parcel$export(module.exports, "useTeamsSentryClientSetup", () => $d5d9cf45ee09d769$export$e30f49f36a0eeaeb);

var $5uXOq = parcelRequire("5uXOq");

var $6jQUd = parcelRequire("6jQUd");
const $d5d9cf45ee09d769$export$e30f49f36a0eeaeb = (isSentryEnabled, config)=>{
    const [sentryInitialised, setSentryInitialised] = (0, $5uXOq.useState)(false);
    const setupSentry = (0, $5uXOq.useCallback)(async ()=>{
        if (!sentryInitialised && isSentryEnabled && !(0, $6jQUd.sentryClient)) await (0, $6jQUd.setupSentryClient)(config);
    }, [
        config,
        isSentryEnabled,
        sentryInitialised
    ]);
    (0, $5uXOq.useEffect)(()=>{
        setupSentry().then(()=>setSentryInitialised(true));
    }, [
        setupSentry
    ]);
    return 0, $6jQUd.sentryClient;
};

});

parcelRegister("f0K80", function(module, exports) {

$parcel$export(module.exports, "DialogProvider", () => $3685775d51863c8a$export$7ab5cfe96fae86d3);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i8Qvm = parcelRequire("i8Qvm");

var $doKCe = parcelRequire("doKCe");
const $3685775d51863c8a$var$dialogProviderReducer = (state, action)=>{
    switch(action.type){
        case 'open':
            return {
                ...state,
                DialogComponent: action.payload?.DialogComponent || null,
                isOpen: true
            };
        case 'close':
            return {
                ...state,
                DialogComponent: null,
                dialogProps: null,
                isOpen: false
            };
        default:
            throw new Error(`Unhandled type for dialogReducer: ${action.type}`);
    }
};
const $3685775d51863c8a$export$b52337b35cd3c980 = (props)=>{
    const { DialogComponent: DialogComponent, isOpen: isOpen, onClose: onClose } = props;
    const { closeDialog: closeDialog } = (0, $5uXOq.useContext)((0, $doKCe.DialogContext));
    if (!DialogComponent) return null;
    const handleCloseDialog = ()=>{
        closeDialog();
        if (onClose) onClose();
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i8Qvm.default), {
        children: isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(DialogComponent, {
            onClose: handleCloseDialog
        })
    });
};
const $3685775d51863c8a$export$7ab5cfe96fae86d3 = ({ children: children })=>{
    const [dialogProviderState, dispatch] = (0, $5uXOq.useReducer)($3685775d51863c8a$var$dialogProviderReducer, {
        DialogComponent: null,
        isOpen: false
    });
    const value = (0, $5uXOq.useMemo)(()=>({
            openDialog: (DialogComponent)=>dispatch({
                    type: 'open',
                    payload: {
                        DialogComponent: DialogComponent
                    }
                }),
            closeDialog: ()=>dispatch({
                    type: 'close'
                })
        }), []);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $doKCe.DialogContext).Provider, {
        value: value,
        children: [
            children,
            /*#__PURE__*/ (0, $2OMIu.jsx)($3685775d51863c8a$export$b52337b35cd3c980, {
                ...dialogProviderState
            })
        ]
    });
};

});
parcelRegister("doKCe", function(module, exports) {

$parcel$export(module.exports, "DialogContext", () => $90f232376a728add$export$8b93a07348a7730c);

var $5uXOq = parcelRequire("5uXOq");
const $90f232376a728add$export$8b93a07348a7730c = (0, $5uXOq.createContext)({
    openDialog: ()=>null,
    closeDialog: ()=>null
});

});


parcelRegister("lRyV6", function(module, exports) {

$parcel$export(module.exports, "useSetAppConfig", () => $aff9d2f176575204$export$338e93cfada2e9d7);

var $4Cv4w = parcelRequire("4Cv4w");

var $Zt6ds = parcelRequire("Zt6ds");

var $lkPoa = parcelRequire("lkPoa");
const $aff9d2f176575204$export$338e93cfada2e9d7 = (appConfig)=>{
    (0, $4Cv4w.useSetClientConfig)({
        cloudId: appConfig.cloudId,
        stargateRoot: appConfig.stargateRoot,
        env: appConfig.env,
        orgId: appConfig.orgId,
        principalUserId: appConfig.principalUserId
    });
    (0, $lkPoa.useSetTeamsProductConfig)({
        appName: appConfig.appName,
        productName: appConfig.productName,
        isJiraAvailable: appConfig.isJiraAvailable,
        subProduct: appConfig.subProduct,
        locale: appConfig.locale,
        productFeatureFlags: appConfig.productFeatureFlags
    });
    (0, $Zt6ds.useSetTeamsNavigationConfig)({
        contextSpaPaths: appConfig.contextSpaPaths,
        contextEntryPoint: appConfig.contextEntryPoint
    });
};

});
parcelRegister("4Cv4w", function(module, exports) {

$parcel$export(module.exports, "useSetClientConfig", () => $7f60e8ba3749bb71$export$2f68760d90a1443f);

var $5uXOq = parcelRequire("5uXOq");

var $1ldwM = parcelRequire("1ldwM");

var $3WNaH = parcelRequire("3WNaH");
const $7f60e8ba3749bb71$export$2f68760d90a1443f = (clientConfig)=>{
    const { setClientConfig: setClientConfig } = (0, $3WNaH.useSetTeamsConfigActions)();
    (0, $1ldwM.useTeamsClientSetupNext)({
        stargateRoot: clientConfig.stargateRoot,
        cloudId: clientConfig.cloudId,
        orgId: clientConfig.orgId,
        principalUserId: clientConfig.principalUserId
    });
    (0, $5uXOq.useEffect)(()=>{
        setClientConfig(clientConfig);
    }, [
        setClientConfig,
        clientConfig
    ]);
};

});
parcelRegister("1ldwM", function(module, exports) {

$parcel$export(module.exports, "useTeamsClientSetupNext", () => $fbe216300c0f5fd0$export$5eae9f59196893ac);

var $5uXOq = parcelRequire("5uXOq");

var $dmOdc = parcelRequire("dmOdc");

var $6laLp = parcelRequire("6laLp");
const $fbe216300c0f5fd0$export$50a3d4f5c944b117 = (stargateRoot, cloudId, orgId, principalUserId)=>{
    $fbe216300c0f5fd0$export$5eae9f59196893ac({
        stargateRoot: stargateRoot,
        cloudId: cloudId,
        orgId: orgId,
        principalUserId: principalUserId
    });
};
const $fbe216300c0f5fd0$export$5eae9f59196893ac = ({ stargateRoot: stargateRoot, cloudId: cloudId, orgId: orgId, principalUserId: principalUserId })=>{
    (0, $5uXOq.useEffect)(()=>{
        if (!stargateRoot) return;
        (0, $dmOdc.teamsClient).setBaseUrl(stargateRoot);
    }, [
        stargateRoot
    ]);
    (0, $5uXOq.useEffect)(()=>{
        (0, $dmOdc.teamsClient).setContext({
            cloudId: cloudId,
            orgId: orgId,
            userId: principalUserId
        });
        if (!orgId) (0, $6laLp.logInfoMessage)(`No orgId set - useTeamsClientSetup`, {
            cloudId: cloudId
        });
    }, [
        cloudId,
        orgId,
        principalUserId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!stargateRoot) return;
        (0, $dmOdc.teamsClient).setTeamCentralContext(stargateRoot, {
            cloudId: cloudId,
            orgId: orgId,
            userId: principalUserId
        });
    }, [
        cloudId,
        orgId,
        principalUserId,
        stargateRoot
    ]);
};

});

parcelRegister("3WNaH", function(module, exports) {

$parcel$export(module.exports, "useAppConfigStoreState", () => $5f2ed7b62647a462$export$ace1f350f4f044c0);
$parcel$export(module.exports, "useSetTeamsConfigActions", () => $5f2ed7b62647a462$export$b652cf4936246835);
$parcel$export(module.exports, "useNavigationState", () => $5f2ed7b62647a462$export$e482f4662aebc4a0);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $5f2ed7b62647a462$var$defaultNavigationState = {
    contextSpaPaths: [],
    contextEntryPoint: null
};
const $5f2ed7b62647a462$var$defaultClientConfigState = {
    cloudId: null,
    stargateRoot: '',
    env: undefined
};
const $5f2ed7b62647a462$var$defaultTeamsProductConfigState = {
    appName: null,
    productName: null,
    isJiraAvailable: false
};
const $5f2ed7b62647a462$var$defaultState = {
    ...$5f2ed7b62647a462$var$defaultNavigationState,
    ...$5f2ed7b62647a462$var$defaultClientConfigState,
    ...$5f2ed7b62647a462$var$defaultTeamsProductConfigState,
    docTitle: {}
};
const $5f2ed7b62647a462$var$actions = {
    setNavigationConfig: (navigationConfig)=>({ setState: setState })=>{
            setState({
                ...navigationConfig
            });
        },
    setClientConfig: (clientConfig)=>({ setState: setState })=>{
            setState({
                ...clientConfig
            });
        },
    setTeamsProductConfig: (teamsProductConfig)=>({ setState: setState })=>{
            setState({
                ...teamsProductConfig
            });
        },
    // Set all config at once
    setAppConfig: (appConfig)=>({ setState: setState })=>{
            setState({
                ...appConfig
            });
        }
};
const $5f2ed7b62647a462$var$AppConfigStore = (0, $iXqE5.createStore)({
    initialState: $5f2ed7b62647a462$var$defaultState,
    actions: $5f2ed7b62647a462$var$actions
});
const $5f2ed7b62647a462$export$61884cfbde7fd829 = (0, $3sQ5x.createHook)($5f2ed7b62647a462$var$AppConfigStore);
const $5f2ed7b62647a462$var$useAppConfigActions = (0, $3sQ5x.createHook)($5f2ed7b62647a462$var$AppConfigStore, {
    selector: null
});
const $5f2ed7b62647a462$export$ace1f350f4f044c0 = ()=>$5f2ed7b62647a462$export$61884cfbde7fd829()[0];
const $5f2ed7b62647a462$export$b652cf4936246835 = ()=>{
    return $5f2ed7b62647a462$var$useAppConfigActions()[1];
};
const $5f2ed7b62647a462$export$7b278989f04c1040 = ()=>$5f2ed7b62647a462$export$ace1f350f4f044c0().appName;
const $5f2ed7b62647a462$export$e482f4662aebc4a0 = ()=>{
    const { contextSpaPaths: contextSpaPaths, contextEntryPoint: contextEntryPoint } = $5f2ed7b62647a462$export$ace1f350f4f044c0();
    return {
        contextSpaPaths: contextSpaPaths,
        contextEntryPoint: contextEntryPoint
    };
};

});


parcelRegister("Zt6ds", function(module, exports) {

$parcel$export(module.exports, "useSetTeamsNavigationConfig", () => $230024e91a993ec4$export$254030771a907fca);

var $5uXOq = parcelRequire("5uXOq");

var $3WNaH = parcelRequire("3WNaH");
const $230024e91a993ec4$export$254030771a907fca = (config)=>{
    const { setNavigationConfig: setNavigationConfig } = (0, $3WNaH.useSetTeamsConfigActions)();
    (0, $5uXOq.useEffect)(()=>{
        setNavigationConfig(config);
    }, [
        setNavigationConfig,
        config
    ]);
};

});

parcelRegister("lkPoa", function(module, exports) {

$parcel$export(module.exports, "useSetTeamsProductConfig", () => $981daa1620d2012d$export$f8296902b02e4ba1);

var $5uXOq = parcelRequire("5uXOq");

var $3WNaH = parcelRequire("3WNaH");
const $981daa1620d2012d$export$f8296902b02e4ba1 = (teamsProductConfig)=>{
    const { setTeamsProductConfig: setTeamsProductConfig } = (0, $3WNaH.useSetTeamsConfigActions)();
    (0, $5uXOq.useEffect)(()=>{
        setTeamsProductConfig(teamsProductConfig);
    }, [
        setTeamsProductConfig,
        teamsProductConfig
    ]);
};

});


parcelRegister("8VfUC", function(module, exports) {

$parcel$export(module.exports, "AppConfigProvider", () => $b64948f6a4087dd8$export$42f491f31057ae78);
$parcel$export(module.exports, "useNavigationActions", () => $b64948f6a4087dd8$export$d52b0df9de5d0e40);
$parcel$export(module.exports, "useAddFlag", () => $b64948f6a4087dd8$export$6d75236f0e3dc17e);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwXrd = parcelRequire("bwXrd");

var $4GZE5 = parcelRequire("4GZE5");

var $3WNaH = parcelRequire("3WNaH");
const $b64948f6a4087dd8$var$error = new Error('AppConfig is not setup in RSS');
const $b64948f6a4087dd8$var$defaultValue = {
    push: ()=>{
        throw $b64948f6a4087dd8$var$error;
    },
    replace: ()=>{
        throw $b64948f6a4087dd8$var$error;
    },
    addFlag: ()=>{
        throw $b64948f6a4087dd8$var$error;
    }
};
const $b64948f6a4087dd8$var$AppConfigContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext($b64948f6a4087dd8$var$defaultValue);
function $b64948f6a4087dd8$export$42f491f31057ae78({ children: children, push: pushProp, replace: replaceProp, addFlag: addFlagProp }) {
    const { contextEntryPoint: contextEntryPoint } = (0, $3WNaH.useNavigationState)();
    const addFlag = (0, $5uXOq.useCallback)((props)=>{
        const { type: type, ...rest } = props;
        addFlagProp({
            ...rest,
            id: rest.id ? `${rest.id}.${Date.now()}` : Date.now(),
            type: type,
            appearance: 'normal',
            icon: (0, $bwXrd.getTypeIcon)(type)
        });
    }, [
        addFlagProp
    ]);
    const push = (0, $5uXOq.useCallback)((path)=>{
        const finalPath = (0, $4GZE5.prefixWithContextEntryPoint)(path, contextEntryPoint);
        return pushProp(finalPath);
    }, [
        pushProp,
        contextEntryPoint
    ]);
    const replace = (0, $5uXOq.useCallback)((path)=>{
        const finalPath = (0, $4GZE5.prefixWithContextEntryPoint)(path, contextEntryPoint);
        return replaceProp(finalPath);
    }, [
        contextEntryPoint,
        replaceProp
    ]);
    const configValue = (0, $5uXOq.useMemo)(()=>({
            addFlag: addFlag,
            push: push,
            replace: replace
        }), [
        addFlag,
        push,
        replace
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($b64948f6a4087dd8$var$AppConfigContext.Provider, {
        value: configValue,
        children: children
    });
}
const $b64948f6a4087dd8$var$useAppConfigProvider = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($b64948f6a4087dd8$var$AppConfigContext);
const $b64948f6a4087dd8$export$d52b0df9de5d0e40 = ()=>{
    const { push: push, replace: replace } = $b64948f6a4087dd8$var$useAppConfigProvider();
    return {
        push: push,
        replace: replace
    };
};
const $b64948f6a4087dd8$export$6d75236f0e3dc17e = ()=>{
    const { addFlag: addFlag } = $b64948f6a4087dd8$var$useAppConfigProvider();
    return addFlag;
};

});
parcelRegister("bwXrd", function(module, exports) {

$parcel$export(module.exports, "getTypeIcon", () => $bedc8f0d150e3169$export$672f92b0d52b7cfe);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dD7Zc = parcelRequire("dD7Zc");

var $c2i4s = parcelRequire("c2i4s");

var $bU3PY = parcelRequire("bU3PY");

const $bedc8f0d150e3169$var$flagIconByType = {
    error: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        spacing: "spacious",
        label: "",
        color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`
    }),
    warning: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
        spacing: "spacious",
        label: "",
        color: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$c6930421db9fa514)})`
    })
};
const $bedc8f0d150e3169$var$DefaultIcon = /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))), {
    spacing: "spacious",
    label: "",
    color: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$940e1f69e873f202)})`
});
const $bedc8f0d150e3169$export$672f92b0d52b7cfe = (type = 'normal')=>$bedc8f0d150e3169$var$flagIconByType[type] || $bedc8f0d150e3169$var$DefaultIcon;

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';


parcelRegister("4GZE5", function(module, exports) {

$parcel$export(module.exports, "isAbsoluteLink", () => $4b3484dc00e942f2$export$895d6838d29edd02);
$parcel$export(module.exports, "prefixWithContextEntryPoint", () => $4b3484dc00e942f2$export$715c8f9057ac0c01);
$parcel$export(module.exports, "getRelativeUrl", () => $4b3484dc00e942f2$export$d614758658023fd);
$parcel$export(module.exports, "EXTERNAL_LINKS", () => $4b3484dc00e942f2$export$4cf71c31cd7fa836);

var $bJMK1 = parcelRequire("bJMK1");

var $2bf04 = parcelRequire("2bf04");
const $4b3484dc00e942f2$export$895d6838d29edd02 = (url)=>{
    return url.startsWith('http') || url.startsWith('www');
};
const $4b3484dc00e942f2$export$715c8f9057ac0c01 = (path, contextEntryPoint = null)=>{
    if ($4b3484dc00e942f2$export$895d6838d29edd02(path) || // do not prefix for absolute URL
    contextEntryPoint && path.startsWith(contextEntryPoint) || // do not prefix if the link already has product context path
    path.startsWith('/')) return path;
    return `${contextEntryPoint}/${path}`;
};
const $4b3484dc00e942f2$export$d614758658023fd = (url)=>{
    if (!$4b3484dc00e942f2$export$895d6838d29edd02(url)) return url;
    try {
        const { pathname: pathname, search: search, hash: hash } = new URL(url);
        return `${pathname}${search}${hash}`;
    } catch (error) {
        (0, $2bf04.logException)(error, 'Cannot parse URL in getRelativeUrl', {
            url: url
        });
    }
    return url;
};
const $4b3484dc00e942f2$export$4cf71c31cd7fa836 = {
    TEAM_INVITE_LEARN_MORE: `${(0, $bJMK1.getAtlassianContextUrl)('support')}/atlassian-account/docs/start-an-atlassian-team/#Add-or-remove-members-of-a-team`
};

});
parcelRegister("bJMK1", function(module, exports) {

$parcel$export(module.exports, "getAtlassianContextUrl", () => $8008ce60aa2556c9$export$9986ff99701c314f);
$parcel$export(module.exports, "getAtlassianContextDomain", () => $8008ce60aa2556c9$export$50f0d77e468746eb);

var $5euJh = parcelRequire("5euJh");

var $jCvwN = parcelRequire("jCvwN");
function $8008ce60aa2556c9$export$9986ff99701c314f(domainKey) {
    if ((0, $jCvwN.isFedramp)()) return (0, $5euJh.getATLContextUrl)(domainKey);
    else return `https://${domainKey}.atlassian.com`;
}
function $8008ce60aa2556c9$export$50f0d77e468746eb(domainKey) {
    if ((0, $jCvwN.isFedramp)()) return (0, $5euJh.getATLContextDomain)(domainKey);
    else return `${domainKey}.atlassian.com`;
}

});



parcelRegister("ffeEQ", function(module, exports) {

$parcel$export(module.exports, "ProfileCardClientConfigProvider", () => $49410c66d97e848d$export$47bd48f80e3bc7b3);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9d8RB = parcelRequire("9d8RB");

var $1EY90 = parcelRequire("1EY90");
function $49410c66d97e848d$export$47bd48f80e3bc7b3({ children: children, ...props }) {
    const profileCardClient = (0, $1EY90.useProfileClient)();
    const config = (0, $5uXOq.useMemo)(()=>({
            ...props,
            profileCardClient: profileCardClient
        }), [
        props,
        profileCardClient
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9d8RB.ProfileCardClientConfigContext).Provider, {
        value: config,
        children: children
    });
}

});
parcelRegister("9d8RB", function(module, exports) {

$parcel$export(module.exports, "ProfileCardClientConfigContext", () => $ae07aa3da9b5b704$export$c804cb3b184b670f);
$parcel$export(module.exports, "useProfileCardClientConfig", () => $ae07aa3da9b5b704$export$a3c560c84e5d436d);

var $5uXOq = parcelRequire("5uXOq");
const $ae07aa3da9b5b704$var$error = new Error('ProfileCardClientConfigProvider is not found in higher components');
const $ae07aa3da9b5b704$var$defaultState = {
    addFlag: ()=>{
        // eslint-disable-next-line no-console
        console.error($ae07aa3da9b5b704$var$error);
    },
    push: ()=>{
        // eslint-disable-next-line no-console
        console.error($ae07aa3da9b5b704$var$error);
    },
    contextEntryPoint: null,
    cloudId: null
};
const $ae07aa3da9b5b704$export$c804cb3b184b670f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext($ae07aa3da9b5b704$var$defaultState);
const $ae07aa3da9b5b704$export$a3c560c84e5d436d = ()=>(0, $5uXOq.useContext)($ae07aa3da9b5b704$export$c804cb3b184b670f);

});

parcelRegister("1EY90", function(module, exports) {

$parcel$export(module.exports, "useProfileClient", () => $dda16fc33e0d8aa1$export$d43dc22a8337ee9f);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $VSDnB = parcelRequire("VSDnB");

var $blw2B = parcelRequire("blw2B");

var $mw4O5 = parcelRequire("mw4O5");

var $5WmsO = parcelRequire("5WmsO");
const $dda16fc33e0d8aa1$var$CACHE_MAX_AGE = 60000;
const $dda16fc33e0d8aa1$var$actions = {
    createClient: (stargateRoot, enableTeamCentral = false, cloudId)=>({ setState: setState })=>{
            const profileClient = new (0, $blw2B.default)({
                gatewayGraphqlUrl: `${stargateRoot}/graphql`,
                url: `${stargateRoot}/directory/graphql`,
                teamCentralDisabled: !enableTeamCentral,
                // teamCentralBaseUrl: enableTeamCentral
                //   ? getConfig().teamCentralUrl
                //   : undefined,
                cacheSize: 20,
                cacheMaxAge: $dda16fc33e0d8aa1$var$CACHE_MAX_AGE,
                ...(0, $VSDnB.fg)('bug_fix_agent_card') && {
                    cloudId: cloudId
                }
            });
            setState({
                profileClient: profileClient
            });
            return profileClient;
        }
};
const $dda16fc33e0d8aa1$var$ProfileClientStore = (0, $iXqE5.createStore)({
    initialState: {},
    actions: $dda16fc33e0d8aa1$var$actions
});
const $dda16fc33e0d8aa1$var$useProfileClientState = (0, $3sQ5x.createHook)($dda16fc33e0d8aa1$var$ProfileClientStore);
const $dda16fc33e0d8aa1$export$d43dc22a8337ee9f = ()=>{
    // const [teamCentralStore] = useTeamCentralStore();
    const [{ profileClient: profileClient }, { createClient: createClient }] = $dda16fc33e0d8aa1$var$useProfileClientState();
    const { stargateRoot: stargateRoot } = (0, $mw4O5.useAppConfig)();
    const cloudId = (0, $5WmsO.useCloudId)();
    (0, $5uXOq.useEffect)(()=>{
        createClient(stargateRoot, false, cloudId);
    }, [
        createClient,
        stargateRoot,
        cloudId
    ]);
    // TODO: enable team central
    // useEffect(() => {
    //   if (teamCentralStore.hasWorkspace || teamCentralStore.orgHasWorkspace) {
    //     // re-create the client and enable team central features
    //     createClient(true);
    //   }
    // }, [teamCentralStore.hasWorkspace, teamCentralStore.orgHasWorkspace]);
    return profileClient;
};

});
parcelRegister("blw2B", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b628efa3a075dd4$export$2e2bcd8739ae039);


var $bp5g1 = parcelRequire("bp5g1");


var $dFLsP = parcelRequire("dFLsP");
var $2b628efa3a075dd4$export$2e2bcd8739ae039 = (0, $bp5g1.default);

});
parcelRegister("bp5g1", function(module, exports) {

$parcel$export(module.exports, "default", () => $35fb800f6bdcf84a$export$2e2bcd8739ae039);

var $5euJh = parcelRequire("5euJh");
var $c04PQ = parcelRequire("c04PQ");

var $4zh20 = parcelRequire("4zh20");

var $4mT2s = parcelRequire("4mT2s");

var $fjEAi = parcelRequire("fjEAi");

var $dFLsP = parcelRequire("dFLsP");
const $35fb800f6bdcf84a$var$defaultConfig = {
    gatewayGraphqlUrl: '/gateway/api/graphql'
};
class $35fb800f6bdcf84a$var$ProfileCardClient {
    constructor(config, clients){
        //This default can be removed once all the clients are updated to pass the gatewayGraphqlUrl
        const withDefaultConfig = {
            ...$35fb800f6bdcf84a$var$defaultConfig,
            ...config,
            gatewayGraphqlUrl: config.gatewayGraphqlUrl ?? $35fb800f6bdcf84a$var$defaultConfig.gatewayGraphqlUrl
        };
        this.userClient = clients?.userClient || new (0, $dFLsP.default)(withDefaultConfig);
        this.teamClient = clients?.teamClient || new (0, $fjEAi.default)(withDefaultConfig);
        this.rovoAgentClient = clients?.rovoAgentClient || new (0, $4zh20.default)(withDefaultConfig);
        this.tcClient = $35fb800f6bdcf84a$var$maybeCreateTeamCentralClient(withDefaultConfig, clients);
    }
    flushCache() {
        this.userClient.flushCache();
        this.teamClient.flushCache();
        this.tcClient?.flushCache();
        this.rovoAgentClient?.flushCache();
    }
    getProfile(cloudId, userId, analytics) {
        return this.userClient.getProfile(cloudId, userId, analytics);
    }
    getTeamProfile(teamId, orgId, analytics) {
        return this.teamClient.getProfile(teamId, orgId, analytics);
    }
    getReportingLines(userId) {
        return this.tcClient?.getReportingLines(userId) || Promise.resolve({
            managers: [],
            reports: []
        });
    }
    async getTeamCentralBaseUrl(teamCentralScopes) {
        if (this.tcClient === undefined) return Promise.resolve(undefined);
        const isGlobalExperienceWorkspace = await this.tcClient.getIsGlobalExperienceWorkspace();
        if (!isGlobalExperienceWorkspace) return Promise.resolve((0, $5euJh.getATLContextUrl)('team'));
        let suffix = '';
        if (teamCentralScopes !== undefined) {
            const orgId = await this.tcClient.getOrgId();
            if (orgId === null) return Promise.resolve(undefined);
            suffix += `/o/${orgId}`;
            if (teamCentralScopes.withSiteContext) suffix += `/s/${this.tcClient.options.cloudId}`;
        }
        return Promise.resolve(`${(0, $5euJh.getATLContextUrl)('home')}${suffix}`);
    }
    async shouldShowGiveKudos() {
        if (!this.tcClient || !await this.getTeamCentralBaseUrl()) return Promise.resolve(false);
        return this.tcClient.checkWorkspaceExists();
    }
    getRovoAgentProfile(id, analytics) {
        return this.rovoAgentClient?.getProfile(id, analytics);
    }
    getRovoAgentPermissions(id, fireAnalytics) {
        return this.rovoAgentClient?.getPermissions(id, fireAnalytics);
    }
    deleteAgent(id, analytics) {
        return this.rovoAgentClient?.deleteAgent(id, analytics);
    }
    setFavouriteAgent(id, isFavourite, analytics) {
        return this.rovoAgentClient?.setFavouriteAgent(id, isFavourite, analytics);
    }
}
function $35fb800f6bdcf84a$var$maybeCreateTeamCentralClient(config, clients) {
    if ((0, $c04PQ.isFedRamp)()) return undefined;
    if (clients?.teamCentralClient) return clients.teamCentralClient;
    const teamCentralEnabled = config.teamCentralDisabled !== true;
    return teamCentralEnabled ? new (0, $4mT2s.default)({
        ...config
    }) : undefined;
}
var $35fb800f6bdcf84a$export$2e2bcd8739ae039 = $35fb800f6bdcf84a$var$ProfileCardClient;

});
parcelRegister("4zh20", function(module, exports) {

$parcel$export(module.exports, "default", () => $23b1bd6752a000ab$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");

var $ivXTE = parcelRequire("ivXTE");

var $6TKEY = parcelRequire("6TKEY");

var $cZg4V = parcelRequire("cZg4V");

var $f3Zb8 = parcelRequire("f3Zb8");
const $23b1bd6752a000ab$var$createHeaders = (product, cloudId, isBodyJson)=>{
    const headers = new Headers({
        'X-Product': product,
        'X-Experience-Id': 'profile-card',
        'X-Cloudid': cloudId || ''
    });
    if (isBodyJson) headers.set('Content-Type', 'application/json');
    return headers;
};
class $23b1bd6752a000ab$export$2e2bcd8739ae039 extends (0, $cZg4V.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    basePath() {
        return (0, $VSDnB.fg)('pt-deprecate-assistance-service') ? '/gateway/api/assist/rovo/v1/agents' : '/gateway/api/assist/agents/v1';
    }
    makeRequest(id, cloudId) {
        const product = this.options.productIdentifier || 'rovo';
        const headers = $23b1bd6752a000ab$var$createHeaders(product, this.options.cloudId);
        if (id.type === 'identity') return fetch(new Request(`${this.basePath()}/accountid/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>response.json());
        return fetch(new Request(`${this.basePath()}/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>response.json());
    }
    getProfile(id, analytics) {
        if (!id.value) return Promise.reject(new Error('Id is missing'));
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        const cache = this.getCachedProfile(id.value);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $6TKEY.getPageTime)();
            if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('triggered'));
            this.makeRequest(id, this.options.cloudId || '').then((data)=>{
                if (this.cache) this.setCachedProfile(id.value, data);
                if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('succeeded', 'request', {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('failed', 'request', {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    ...(0, $f3Zb8.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    deleteAgent(agentId, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $6TKEY.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('triggered'));
            const headers = $23b1bd6752a000ab$var$createHeaders(product, this.options.cloudId);
            fetch(new Request(`${this.basePath()}/${agentId}`, {
                method: 'DELETE',
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('succeeded', 'deleteAgent', {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve();
            }).catch((error)=>{
                if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('failed', 'deleteAgent', {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    ...(0, $f3Zb8.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    setFavouriteAgent(agentId, isFavourite, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise(async (resolve, reject)=>{
            const startTime = (0, $6TKEY.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            const actionSubjectId = isFavourite ? 'favourite' : 'unfavourite';
            const requestMethod = isFavourite ? 'POST' : 'DELETE';
            if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('triggered', 'actionSubjectId'));
            const headers = $23b1bd6752a000ab$var$createHeaders(product, this.options.cloudId);
            await fetch(new Request(`${this.basePath()}/${agentId}/favourite`, {
                method: requestMethod,
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('succeeded', actionSubjectId, {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve();
            }).catch((error)=>{
                if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('failed', actionSubjectId, {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    ...(0, $f3Zb8.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    getPermissions(id, fireAnalytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $6TKEY.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if (fireAnalytics) fireAnalytics((0, $ivXTE.agentRequestAnalytics)('triggered'));
            const headers = $23b1bd6752a000ab$var$createHeaders(product, this.options.cloudId, true);
            fetch(new Request(`/gateway/api/assist/api/rovo/v2/permissions/agents/${id}`, {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: headers,
                body: JSON.stringify({
                    permission_ids: [
                        'AGENT_CREATE',
                        'AGENT_UPDATE',
                        'AGENT_DELETE',
                        'AGENT_DEACTIVATE',
                        'AGENT_READ'
                    ]
                })
            })).then((response)=>response.json()).then((data)=>{
                if (fireAnalytics) fireAnalytics((0, $ivXTE.agentRequestAnalytics)('succeeded', 'getAgentPermissions', {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (fireAnalytics) fireAnalytics((0, $ivXTE.agentRequestAnalytics)('failed', 'getAgentPermissions', {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    ...(0, $f3Zb8.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("ivXTE", function(module, exports) {

$parcel$export(module.exports, "fireEvent", () => $533bc31bb6af10e0$export$43835e9acf248a15);
$parcel$export(module.exports, "cardTriggered", () => $533bc31bb6af10e0$export$d50ab8a3b6975c);
$parcel$export(module.exports, "teamRequestAnalytics", () => $533bc31bb6af10e0$export$c9b0e37b229a297b);
$parcel$export(module.exports, "userRequestAnalytics", () => $533bc31bb6af10e0$export$12dae48763368ac9);
$parcel$export(module.exports, "profileCardRendered", () => $533bc31bb6af10e0$export$41816a317479160b);
$parcel$export(module.exports, "actionClicked", () => $533bc31bb6af10e0$export$fdcd134fbeb1f921);
$parcel$export(module.exports, "reportingLinesClicked", () => $533bc31bb6af10e0$export$93260987012593be);
$parcel$export(module.exports, "moreActionsClicked", () => $533bc31bb6af10e0$export$79befd155063a6a7);
$parcel$export(module.exports, "teamAvatarClicked", () => $533bc31bb6af10e0$export$2703289b35687fde);
$parcel$export(module.exports, "moreMembersClicked", () => $533bc31bb6af10e0$export$b4411a7661cf2d3f);
$parcel$export(module.exports, "errorRetryClicked", () => $533bc31bb6af10e0$export$c86679da702d560e);
$parcel$export(module.exports, "agentRequestAnalytics", () => $533bc31bb6af10e0$export$a9f8c9f412cf5664);

var $6TKEY = parcelRequire("6TKEY");
/** Below lines are copied from teams common analytics */ const $533bc31bb6af10e0$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $533bc31bb6af10e0$var$runItLater = (cb)=>{
    const requestIdleCallback = window.requestIdleCallback;
    if (typeof requestIdleCallback === 'function') return requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $533bc31bb6af10e0$export$43835e9acf248a15 = (createAnalyticsEvent, body)=>{
    if (!createAnalyticsEvent) return;
    $533bc31bb6af10e0$var$runItLater(()=>{
        createAnalyticsEvent(body).fire($533bc31bb6af10e0$var$ANALYTICS_CHANNEL);
    });
};
/** Above lines are copied from teams common analytics */ const $533bc31bb6af10e0$var$TEAM_SUBJECT = 'teamProfileCard';
const $533bc31bb6af10e0$var$USER_SUBJECT = 'profilecard';
const $533bc31bb6af10e0$var$AGENT_SUBJECT = 'rovoAgentProfilecard';
const $533bc31bb6af10e0$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes,
            firedAt: Math.round((0, $6TKEY.getPageTime)())
        }
    });
const $533bc31bb6af10e0$var$getActionSubject = (type)=>{
    switch(type){
        case 'user':
            return $533bc31bb6af10e0$var$USER_SUBJECT;
        case 'team':
            return $533bc31bb6af10e0$var$TEAM_SUBJECT;
        case 'agent':
            return $533bc31bb6af10e0$var$AGENT_SUBJECT;
        default:
            return 'user';
    }
};
const $533bc31bb6af10e0$export$d50ab8a3b6975c = (type, method, teamId)=>{
    return $533bc31bb6af10e0$var$createEvent('ui', 'triggered', $533bc31bb6af10e0$var$getActionSubject(type), undefined, {
        method: method,
        ...type === 'team' && teamId ? {
            teamId: teamId
        } : {}
    });
};
const $533bc31bb6af10e0$export$c9b0e37b229a297b = (action, attributes)=>$533bc31bb6af10e0$var$createEvent('operational', action, $533bc31bb6af10e0$var$TEAM_SUBJECT, 'request', attributes);
const $533bc31bb6af10e0$export$12dae48763368ac9 = (action, attributes)=>$533bc31bb6af10e0$var$createEvent('operational', action, $533bc31bb6af10e0$var$USER_SUBJECT, 'request', attributes);
const $533bc31bb6af10e0$export$41816a317479160b = (type, actionSubjectId, attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'rendered', $533bc31bb6af10e0$var$getActionSubject(type), actionSubjectId, attributes);
const $533bc31bb6af10e0$export$fdcd134fbeb1f921 = (type, attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$getActionSubject(type), 'action', attributes);
const $533bc31bb6af10e0$export$93260987012593be = (attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$USER_SUBJECT, 'reportingLines', attributes);
const $533bc31bb6af10e0$export$79befd155063a6a7 = (type, attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$getActionSubject(type), 'moreActions', attributes);
const $533bc31bb6af10e0$export$2703289b35687fde = (attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$TEAM_SUBJECT, 'avatar', attributes);
const $533bc31bb6af10e0$export$b4411a7661cf2d3f = (attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$TEAM_SUBJECT, 'moreMembers', attributes);
const $533bc31bb6af10e0$export$c86679da702d560e = (attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$TEAM_SUBJECT, 'errorRetry', attributes);
const $533bc31bb6af10e0$export$a9f8c9f412cf5664 = (action, actionSubjectId, attributes)=>$533bc31bb6af10e0$var$createEvent('operational', action, $533bc31bb6af10e0$var$AGENT_SUBJECT, actionSubjectId || 'request', attributes);

});
parcelRegister("6TKEY", function(module, exports) {

$parcel$export(module.exports, "getPageTime", () => $83ec369559ddc36d$export$e9faea7c41053334);
const $83ec369559ddc36d$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $83ec369559ddc36d$var$performanceAvailable = $83ec369559ddc36d$var$isPerformanceAvailable();
const $83ec369559ddc36d$var$initialPageTime = Date.now();
const $83ec369559ddc36d$export$e9faea7c41053334 = ()=>{
    if ($83ec369559ddc36d$var$performanceAvailable) return performance.now();
    return Date.now() - $83ec369559ddc36d$var$initialPageTime;
};

});


parcelRegister("cZg4V", function(module, exports) {

$parcel$export(module.exports, "default", () => $e76084040147eae1$export$2e2bcd8739ae039);

var $iwKVT = parcelRequire("iwKVT");
class $e76084040147eae1$export$2e2bcd8739ae039 {
    constructor(config){
        const defaults = {
            cacheSize: 10,
            cacheMaxAge: 0
        };
        this.config = {
            ...defaults,
            ...config
        };
        // never set cacheSize or cacheMaxAge to negative numbers
        this.config.cacheSize = Math.max(this.config.cacheSize || 0, 0);
        this.config.cacheMaxAge = Math.max(this.config.cacheMaxAge || 0, 0);
        // DIR-474: cap cache at 30 days.
        if (this.config.cacheMaxAge) this.config.cacheMaxAge = Math.min(this.config.cacheMaxAge, 2592000000);
        // Only set cache if maxCacheAge and cacheSize are set
        this.cache = !this.config.cacheMaxAge || !this.config.cacheSize ? null : new (0, $iwKVT.LRUMap)(this.config.cacheSize);
    }
    setCachedProfile(cacheIdentifier, profile) {
        this.cache && this.cache.set(cacheIdentifier, {
            expire: Date.now() + this.config.cacheMaxAge,
            profile: profile
        });
    }
    getCachedProfile(cacheIdentifier) {
        if (!this.cache) return null;
        const cached = this.cache.get(cacheIdentifier);
        if (!cached) return null;
        if (cached.expire < Date.now()) {
            this.cache.delete(cacheIdentifier);
            return null;
        }
        // Extend expiry "date"
        this.setCachedProfile(cacheIdentifier, cached.profile);
        return cached.profile;
    }
    flushCache() {
        if (this.cache) this.cache.clear();
    }
}

});

parcelRegister("f3Zb8", function(module, exports) {

$parcel$export(module.exports, "getErrorAttributes", () => $b5fa858d1f1072ea$export$6ad9e7706a4ee0f8);
$parcel$export(module.exports, "handleDirectoryGraphQLErrors", () => $b5fa858d1f1072ea$export$7642af465ceb7f05);
$parcel$export(module.exports, "handleAGGErrors", () => $b5fa858d1f1072ea$export$d9ad65d422ee3f8c);

var $fcA5f = parcelRequire("fcA5f");
const $b5fa858d1f1072ea$var$IGNORED_ERROR_REASONS_DIRECTORY = [
    // Error categories from pf-directory
    'NotPermitted',
    'Gone',
    'IdentityUserNotFoundError'
];
const $b5fa858d1f1072ea$var$IGNORE_ERROR_TYPES_AGG = [
    'IdentityUserNotFoundError',
    'TEAMS_FORBIDDEN',
    'TEAMS_TEAM_DELETED'
];
const $b5fa858d1f1072ea$var$IGNORE_ERROR_CLASSIFICATIONS_AGG = [
    'Gone'
];
function $b5fa858d1f1072ea$var$isIgnoredError(error) {
    if (!error) return false;
    if (error instanceof (0, $fcA5f.DirectoryGraphQLError)) return !!error && $b5fa858d1f1072ea$var$IGNORED_ERROR_REASONS_DIRECTORY.includes(error.type);
    else if (error instanceof (0, $fcA5f.AGGError)) return !!error.errorType && $b5fa858d1f1072ea$var$IGNORE_ERROR_TYPES_AGG.includes(error.errorType) || !!error.classification && $b5fa858d1f1072ea$var$IGNORE_ERROR_CLASSIFICATIONS_AGG.includes(error.classification);
    return false;
}
const $b5fa858d1f1072ea$export$6ad9e7706a4ee0f8 = (error)=>{
    if (error instanceof (0, $fcA5f.DirectoryGraphQLErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($b5fa858d1f1072ea$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($b5fa858d1f1072ea$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $fcA5f.DirectoryGraphQLError)) return {
        errorMessage: error.message,
        errorCategory: error.category,
        errorType: error.type,
        errorPath: error.path,
        errorNumber: error.errorNumber,
        isSLOFailure: !$b5fa858d1f1072ea$var$isIgnoredError(error)
    };
    else if (error instanceof (0, $fcA5f.AGGErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($b5fa858d1f1072ea$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($b5fa858d1f1072ea$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $fcA5f.AGGError)) return {
        errorMessage: error.message,
        errorType: error.errorType,
        errorStatusCode: error.statusCode,
        isSLOFailure: !$b5fa858d1f1072ea$var$isIgnoredError(error),
        errorCategory: error.classification
    };
    else if (error instanceof Error) {
        // Jira custom profile card client error, they wrap the error & put the underlying error in the cause property
        if (error.message.startsWith('Unable to fetch user:')) {
            if (error.hasOwnProperty('cause')) {
                const causeError = error.cause;
                if (causeError instanceof (0, $fcA5f.DirectoryGraphQLErrors) || causeError instanceof (0, $fcA5f.AGGErrors)) return $b5fa858d1f1072ea$export$6ad9e7706a4ee0f8(causeError);
            }
            return {
                errorMessage: error.message,
                isSLOFailure: false
            };
        }
        return {
            errorMessage: error.message,
            isSLOFailure: true
        };
    }
    // Unknown
    return {
        errorMessage: 'Unknown error',
        isSLOFailure: true
    };
};
const $b5fa858d1f1072ea$export$7642af465ceb7f05 = (errors, traceId)=>{
    throw new (0, $fcA5f.DirectoryGraphQLErrors)(errors, traceId);
};
const $b5fa858d1f1072ea$export$d9ad65d422ee3f8c = (errors, traceId)=>{
    throw new (0, $fcA5f.AGGErrors)(errors, traceId);
};

});
parcelRegister("fcA5f", function(module, exports) {

$parcel$export(module.exports, "HttpError", () => $7db90b14dd6e48a6$export$65bd6083489bd8bb);
$parcel$export(module.exports, "DirectoryGraphQLError", () => $7db90b14dd6e48a6$export$c1e4d0de940c06a2);
$parcel$export(module.exports, "DirectoryGraphQLErrors", () => $7db90b14dd6e48a6$export$5a5fbfed34a590a1);
$parcel$export(module.exports, "AGGError", () => $7db90b14dd6e48a6$export$4a696f048dcc929);
$parcel$export(module.exports, "AGGErrors", () => $7db90b14dd6e48a6$export$60d8267243755b9c);
class $7db90b14dd6e48a6$export$65bd6083489bd8bb extends Error {
    constructor(code, reason, traceId){
        super(reason);
        this.code = code;
        this.traceId = traceId;
    }
}
class $7db90b14dd6e48a6$export$c1e4d0de940c06a2 extends Error {
    constructor(message, category, type, extensions = {}, path = []){
        super(message);
        this.category = category;
        this.type = type;
        this.path = path.join('.');
        const { errorNumber: errorNumber, ...unknownExtension } = extensions;
        this.errorNumber = extensions.errorNumber;
        this.extensions = unknownExtension;
    }
}
class $7db90b14dd6e48a6$export$5a5fbfed34a590a1 extends Error {
    constructor(errors, traceId){
        super('DirectoryGraphQLErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $7db90b14dd6e48a6$export$c1e4d0de940c06a2(error.message, error.category, error.type, error.extensions, error.path));
        else this.errors = [];
    }
}
class $7db90b14dd6e48a6$export$4a696f048dcc929 extends Error {
    constructor(message, extensions, path = []){
        super(message);
        this.path = path?.join('.');
        const { statusCode: statusCode, errorType: errorType, classification: classification, ...unknownExtension } = extensions;
        this.statusCode = statusCode;
        this.errorType = errorType;
        this.classification = classification;
        this.extensions = unknownExtension;
    }
}
class $7db90b14dd6e48a6$export$60d8267243755b9c extends Error {
    constructor(errors, traceId){
        super('AGGErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $7db90b14dd6e48a6$export$4a696f048dcc929(error.message, error.extensions, error.path));
        else this.errors = [];
    }
}

});



parcelRegister("4mT2s", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8d68ade6ab7f448$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");

var $cZg4V = parcelRequire("cZg4V");

var $a6hGK = parcelRequire("a6hGK");

var $hnIbm = parcelRequire("hnIbm");
const $b8d68ade6ab7f448$var$UNSHARDED_PREFIX = '/gateway/api/watermelon';
const $b8d68ade6ab7f448$export$1862ef0c3880ca8d = (aaid)=>({
        query: `
    fragment ReportingLinesUserPII on UserPII {
      name
      picture
    }

    fragment ReportingLinesUserFragment on ReportingLinesUser {
      accountIdentifier
      identifierType
      pii {
        ...ReportingLinesUserPII
      }
    }

    query ReportingLines($aaid: String) {
      reportingLines(aaidOrHash: $aaid) {
        managers {
          ...ReportingLinesUserFragment
        }
        reports {
          ...ReportingLinesUserFragment
        }
      }
    }
  `,
        variables: {
            aaid: aaid
        }
    });
const $b8d68ade6ab7f448$var$orgContainsAnyWorkspacePromiseCache = new Map();
const $b8d68ade6ab7f448$var$orgIdPromiseCache = new Map();
const $b8d68ade6ab7f448$var$workspaceExistsWithTypePromiseCache = new Map();
class $b8d68ade6ab7f448$var$TeamCentralCardClient extends (0, $cZg4V.default) {
    constructor(options){
        super(options);
        this.options = options;
        this.bypassOnFailure = false;
        this.orgContainsAnyWorkspacePromise = this.createOrgContainsAnyWorkspacePromise(options);
        this.workspaceExistsWithTypePromise = this.preloadWorkspaceExistsWithType(options.cloudId);
        this.orgIdPromise = this.preloadOrgId(options.gatewayGraphqlUrl, options.cloudId, options.orgId);
    }
    createOrgContainsAnyWorkspacePromise(config) {
        if (config.cloudId) {
            let promise = $b8d68ade6ab7f448$var$orgContainsAnyWorkspacePromiseCache.get(config.cloudId);
            if (!promise) {
                promise = this.getOrgContainsAnyWorkspace(config.cloudId);
                $b8d68ade6ab7f448$var$orgContainsAnyWorkspacePromiseCache.set(config.cloudId, promise);
            }
            return promise;
        }
        return Promise.resolve(true);
    }
    getReportingLines(userId) {
        return this.orgContainsAnyWorkspacePromise.then((orgContainsAnyWorkspace)=>{
            if (orgContainsAnyWorkspace) {
                if (!userId) return Promise.reject(new Error('userId missing'));
                const cache = this.getCachedProfile(userId);
                if (cache) return Promise.resolve(cache);
                if (this.bypassOnFailure) return Promise.resolve({});
                return new Promise((resolve)=>{
                    this.makeRequest(userId).then((data)=>{
                        const enhancedData = {
                            managers: this.filterReportingLinesUser(data?.managers),
                            reports: this.filterReportingLinesUser(data?.reports)
                        };
                        if (this.cache) this.setCachedProfile(userId, enhancedData);
                        resolve(enhancedData);
                    }).catch((error)=>{
                        if (error?.status === 401 || error?.status === 403) // Trigger circuit breaker
                        this.bypassOnFailure = true;
                        /**
								 * Reporting lines aren't part of the critical path of profile card.
								 * Just resolve with empty values instead of bubbling up the error.
								 */ resolve({});
                    });
                });
            }
            return Promise.resolve({
                managers: [],
                reports: []
            });
        }, ()=>Promise.resolve({
                managers: [],
                reports: []
            }));
    }
    /**
	 * `public` so that mock client can override it; do not use it otherwise!
	 */ async makeRequest(userId) {
        if (this.options.teamCentralDisabled === true) throw new Error('makeRequest cannot be called when the client has been disabled');
        const query = $b8d68ade6ab7f448$export$1862ef0c3880ca8d(userId);
        const response = await (0, $hnIbm.directoryGraphqlQuery)('/gateway/api/watermelon/graphql?operationName=ReportingLines', query);
        return response.reportingLines;
    }
    async checkWorkspaceExists() {
        const workspaceExistsPromise = (0, $VSDnB.fg)('enable_ptc_townsquare_reporting_lines_unsharded') ? this.workspaceExistsWithTypePromise.then((workspaceExistsWithType)=>workspaceExistsWithType !== undefined) : this.orgContainsAnyWorkspacePromise;
        return workspaceExistsPromise.then((workspaceExistsWithType)=>{
            if (workspaceExistsWithType) return Promise.resolve(true);
            return Promise.resolve(false);
        }, ()=>Promise.resolve(false));
    }
    async getIsGlobalExperienceWorkspace() {
        return await this.workspaceExistsWithTypePromise === 'GLOBAL_EXPERIENCE';
    }
    getOrgId() {
        return this.orgIdPromise;
    }
    preloadWorkspaceExistsWithType(cloudId) {
        if (cloudId === undefined) return Promise.resolve(undefined);
        const maybeWorkspaceExistsWithTypePromise = $b8d68ade6ab7f448$var$workspaceExistsWithTypePromiseCache.get(cloudId);
        if (maybeWorkspaceExistsWithTypePromise !== undefined) return maybeWorkspaceExistsWithTypePromise;
        const workspaceExistsWithTypePromise = this.getWorkspaceExistsWithType(cloudId);
        $b8d68ade6ab7f448$var$workspaceExistsWithTypePromiseCache.set(cloudId, workspaceExistsWithTypePromise);
        return workspaceExistsWithTypePromise;
    }
    getOrgContainsAnyWorkspace(cloudId) {
        if (cloudId) return fetch(((0, $VSDnB.fg)('enable_ptc_townsquare_reporting_lines_unsharded') ? $b8d68ade6ab7f448$var$UNSHARDED_PREFIX : this.getShardedApiPath(cloudId)) + `/organization/containsAnyWorkspace?cloudId=${cloudId}`).then((res)=>{
            return !res || res && res.ok;
        });
        else return Promise.resolve(false);
    }
    async getWorkspaceExistsWithType(cloudId) {
        try {
            const response = await fetch(`${this.getShardedApiPath(cloudId)}/workspace/existsWithWorkspaceType?cloudId=${cloudId}`, {
                credentials: 'include'
            });
            if (response.ok) {
                const workspaceType = await response.text();
                return Promise.resolve(workspaceType);
            }
        } catch (err) {
            return Promise.resolve(undefined);
        }
    }
    preloadOrgId(gatewayGraphqlUrl, cloudId, orgId) {
        if (cloudId === undefined) return Promise.resolve(null);
        if (orgId !== undefined) return Promise.resolve(orgId);
        const maybeOrgIdForCloudIdPromise = $b8d68ade6ab7f448$var$orgIdPromiseCache.get(cloudId);
        if (maybeOrgIdForCloudIdPromise !== undefined) return maybeOrgIdForCloudIdPromise;
        const orgIdForCloudIdPromise = (0, $a6hGK.getOrgIdForCloudIdFromAGG)(gatewayGraphqlUrl, cloudId);
        $b8d68ade6ab7f448$var$orgIdPromiseCache.set(cloudId, orgIdForCloudIdPromise);
        return orgIdForCloudIdPromise;
    }
    getShardedApiPath(cloudId) {
        return `/gateway/api/townsquare/s/${cloudId}`;
    }
    filterReportingLinesUser(users = []) {
        return users.filter((user)=>user.identifierType === 'ATLASSIAN_ID');
    }
}
var $b8d68ade6ab7f448$export$2e2bcd8739ae039 = $b8d68ade6ab7f448$var$TeamCentralCardClient;

});
parcelRegister("a6hGK", function(module, exports) {

$parcel$export(module.exports, "getOrgIdForCloudIdFromAGG", () => $9b806d5a2251e5d5$export$d38a536fd806c68f);

var $hnIbm = parcelRequire("hnIbm");
const $9b806d5a2251e5d5$var$ORG_ID_FROM_CLOUD_ID_QUERY = `query OrgIdFromCloudId($cloudId: ID!) {
	tenantContexts(cloudIds: [$cloudId]) {
		orgId
	}
}`;
const $9b806d5a2251e5d5$var$addHeaders = (headers)=>{
    headers.append('atl-client-name', "platform-pkg");
    headers.append('atl-client-version', "0.0.0-use.local");
    return headers;
};
async function $9b806d5a2251e5d5$export$d38a536fd806c68f(url, cloudId) {
    const query = {
        query: $9b806d5a2251e5d5$var$ORG_ID_FROM_CLOUD_ID_QUERY,
        variables: {
            cloudId: cloudId
        }
    };
    try {
        const { tenantContexts: tenantContexts } = await (0, $hnIbm.AGGQuery)(url, query, $9b806d5a2251e5d5$var$addHeaders);
        if (!tenantContexts || tenantContexts.length === 0 || tenantContexts[0] === null) return null;
        return tenantContexts[0].orgId;
    } catch (err) {
        // don't bubble up the error, and let consumers handle it as if the cloud ID
        // doesn't resolve to an org ID
        return null;
    }
}

});
parcelRegister("hnIbm", function(module, exports) {

$parcel$export(module.exports, "directoryGraphqlQuery", () => $7fa677c30fceb004$export$a5b5995619d4fe36);
$parcel$export(module.exports, "AGGQuery", () => $7fa677c30fceb004$export$a14afb5f82fe705);

var $fcA5f = parcelRequire("fcA5f");

var $f3Zb8 = parcelRequire("f3Zb8");
const $7fa677c30fceb004$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
const $7fa677c30fceb004$var$id = (headers)=>headers;
async function $7fa677c30fceb004$export$a5b5995619d4fe36(serviceUrl, query, processHeaders = $7fa677c30fceb004$var$id) {
    return $7fa677c30fceb004$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $f3Zb8.handleDirectoryGraphQLErrors));
}
async function $7fa677c30fceb004$export$a14afb5f82fe705(serviceUrl, query, processHeaders = $7fa677c30fceb004$var$id) {
    return $7fa677c30fceb004$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $f3Zb8.handleAGGErrors));
}
async function $7fa677c30fceb004$var$graphQLQuery(serviceUrl, query, processHeaders = $7fa677c30fceb004$var$id, handleErrors) {
    const headers = processHeaders($7fa677c30fceb004$var$buildHeaders());
    const response = await fetch(new Request(serviceUrl, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    }));
    const traceIdFromHeaders = response?.headers?.get('atl-traceid');
    if (!response.ok) throw new (0, $fcA5f.HttpError)(response.status, response.statusText, traceIdFromHeaders);
    const json = await response.json();
    if (json.errors) handleErrors(json.errors, json.extensions?.gateway?.request_id ?? traceIdFromHeaders);
    return json.data;
}

});



parcelRegister("fjEAi", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb2f761841b49fec$export$2e2bcd8739ae039);

var $ivXTE = parcelRequire("ivXTE");

var $6TKEY = parcelRequire("6TKEY");

var $cZg4V = parcelRequire("cZg4V");

var $f3Zb8 = parcelRequire("f3Zb8");

var $5Uw6l = parcelRequire("5Uw6l");
class $fb2f761841b49fec$export$2e2bcd8739ae039 extends (0, $cZg4V.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    makeRequest(teamId, _orgId) {
        if (!this.options.gatewayGraphqlUrl) throw new Error('Trying to fetch via gateway with no specified config.gatewayGraphqlUrl');
        return (0, $5Uw6l.getTeamFromAGG)(this.options.gatewayGraphqlUrl, teamId, this.options.cloudId);
    }
    getProfile(teamId, orgId, analytics) {
        if (!teamId) return Promise.reject(new Error('teamId is missing'));
        const cache = this.getCachedProfile(teamId);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $6TKEY.getPageTime)();
            if (analytics) analytics((0, $ivXTE.teamRequestAnalytics)('triggered'));
            this.makeRequest(teamId, orgId).then((data)=>{
                if (this.cache) this.setCachedProfile(teamId, data);
                if (analytics) analytics((0, $ivXTE.teamRequestAnalytics)('succeeded', {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $ivXTE.teamRequestAnalytics)('failed', {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    ...(0, $f3Zb8.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("5Uw6l", function(module, exports) {

$parcel$export(module.exports, "extractIdFromAri", () => $c02eddc07333bc73$export$5816a09dbb711691);
$parcel$export(module.exports, "getTeamFromAGG", () => $c02eddc07333bc73$export$26a8aad0c7182dd6);

var $hnIbm = parcelRequire("hnIbm");
const $c02eddc07333bc73$var$ARI_PREFIX = 'ari:cloud:identity::team/';
const $c02eddc07333bc73$export$5816a09dbb711691 = (ari)=>{
    const slashPos = ari.indexOf('/');
    const id = ari.slice(slashPos + 1);
    return id;
};
const $c02eddc07333bc73$export$681597d03c8a0fd2 = (teamId)=>{
    return `ari:cloud:identity::team/${teamId}`;
};
const $c02eddc07333bc73$export$7878e28c136af76 = (teamIdOrTeamAri)=>teamIdOrTeamAri.startsWith($c02eddc07333bc73$var$ARI_PREFIX) ? teamIdOrTeamAri : $c02eddc07333bc73$export$681597d03c8a0fd2(teamIdOrTeamAri);
const $c02eddc07333bc73$export$fce1abb40bf8db94 = (result)=>{
    const { team: team } = result;
    return {
        ...team,
        id: $c02eddc07333bc73$export$5816a09dbb711691(team.id),
        members: team.members?.nodes.map(({ member: member })=>({
                id: member.accountId,
                fullName: member.name,
                avatarUrl: member.picture
            }))
    };
};
// indented so it's
const $c02eddc07333bc73$var$TEAM_FRAGMENT = `
      id
      displayName
      description
      smallHeaderImageUrl
      largeHeaderImageUrl
      smallAvatarImageUrl
      largeAvatarImageUrl
	  isVerified
      members {
        nodes {
          member {
            accountId
            name
            picture
          }
        }
      }
`;
const $c02eddc07333bc73$export$4968f4e0119a5d9c = `query TeamCard($teamId: ID!, $siteId: String!) {
  Team: team {
    team: teamV2(id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
      ${$c02eddc07333bc73$var$TEAM_FRAGMENT}
    }
  }
}`;
const $c02eddc07333bc73$export$695d743d1401e038 = ({ teamId: teamId, siteId: siteId })=>({
        query: $c02eddc07333bc73$export$4968f4e0119a5d9c,
        variables: {
            teamId: $c02eddc07333bc73$export$7878e28c136af76(teamId),
            siteId: siteId || 'None'
        }
    });
const $c02eddc07333bc73$export$1229c72526c01df2 = (headers)=>{
    headers.append('X-ExperimentalApi', 'teams-beta');
    headers.append('X-ExperimentalApi', 'team-members-beta');
    headers.append('atl-client-name', "platform-pkg");
    headers.append('atl-client-version', "0.0.0-use.local");
    return headers;
};
async function $c02eddc07333bc73$export$26a8aad0c7182dd6(url, teamId, siteId) {
    const query = $c02eddc07333bc73$export$695d743d1401e038({
        teamId: teamId,
        siteId: siteId
    });
    const { Team: Team } = await (0, $hnIbm.AGGQuery)(url, query, $c02eddc07333bc73$export$1229c72526c01df2);
    return $c02eddc07333bc73$export$fce1abb40bf8db94(Team);
}

});


parcelRegister("dFLsP", function(module, exports) {

$parcel$export(module.exports, "default", () => $eafd789fd4bdf3ff$export$2e2bcd8739ae039);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");

var $VSDnB = parcelRequire("VSDnB");

var $ivXTE = parcelRequire("ivXTE");

var $2qnn4 = parcelRequire("2qnn4");

var $6TKEY = parcelRequire("6TKEY");

var $cZg4V = parcelRequire("cZg4V");

var $f3Zb8 = parcelRequire("f3Zb8");

var $hnIbm = parcelRequire("hnIbm");
const $eafd789fd4bdf3ff$export$b26b7f9bcf400835 = (response)=>{
    const data = {
        ...response.User
    };
    const localWeekdayIndex = new Date().getDay().toString();
    if (data.remoteWeekdayIndex && data.remoteWeekdayIndex !== localWeekdayIndex) data.remoteTimeString = `${data.remoteWeekdayString} ${data.remoteTimeString}`;
    return {
        isBot: data.isBot,
        isCurrentUser: data.isCurrentUser,
        status: data.status,
        statusModifiedDate: data.statusModifiedDate || undefined,
        avatarUrl: data.avatarUrl || undefined,
        email: data.email || undefined,
        fullName: data.fullName || undefined,
        location: data.location || undefined,
        meta: data.meta || undefined,
        nickname: data.nickname || undefined,
        companyName: data.companyName || undefined,
        timestring: data.remoteTimeString || undefined,
        accountType: data.accountType || undefined
    };
};
const $eafd789fd4bdf3ff$var$aggUserQuery = (0, $5cllN.default)`
	query user($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					location
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				zoneinfo
			}
			... on AppUser {
				appType
			}
		}
	}
`;
const $eafd789fd4bdf3ff$var$aggUserQueryString = `query user($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					location
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				zoneinfo
			}
			... on AppUser {
      			appType
    		}
		}
	}`;
const $eafd789fd4bdf3ff$export$8230f28f7ae567ea = (userId)=>({
        query: (0, $VSDnB.fg)('platform_agg_user_query_doc_change') ? (0, $1c8Um.print)($eafd789fd4bdf3ff$var$aggUserQuery) : $eafd789fd4bdf3ff$var$aggUserQueryString,
        variables: {
            userId: userId
        }
    });
const $eafd789fd4bdf3ff$var$queryAGGUser = async (url, userId)=>{
    const query = $eafd789fd4bdf3ff$export$8230f28f7ae567ea(userId);
    const { user: user } = await (0, $hnIbm.AGGQuery)(url, query);
    return user;
};
class $eafd789fd4bdf3ff$export$2e2bcd8739ae039 extends (0, $cZg4V.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    async makeRequest(cloudId, userId) {
        const gatewayGraphqlUrl = this.options.gatewayGraphqlUrl || '/gateway/api/graphql';
        const urlWithOperationName = `${gatewayGraphqlUrl}?operationName=aggUserQuery`;
        const userQueryPromise = $eafd789fd4bdf3ff$var$queryAGGUser(urlWithOperationName, userId);
        const user = await userQueryPromise;
        let timestring;
        const localWeekdayIndex = new Date().getDay().toString();
        if (user.zoneinfo) {
            if ((0, $2qnn4.localTime)(user.zoneinfo, 'i') === localWeekdayIndex) timestring = (0, $2qnn4.localTime)(user.zoneinfo, 'h:mmbbb') || undefined;
            else timestring = (0, $2qnn4.localTime)(user.zoneinfo, 'eee h:mmbbb') || undefined;
        }
        return {
            ...user,
            isBot: user.__typename === 'AppUser',
            isAgent: user.appType === 'agent',
            status: user.accountStatus,
            statusModifiedDate: user.extendedProfile?.closedDate || user.extendedProfile?.inactiveDate,
            avatarUrl: user.picture,
            email: user.email,
            fullName: user.name,
            location: user.extendedProfile?.location,
            meta: user.extendedProfile?.jobTitle,
            nickname: user.nickname,
            companyName: user.extendedProfile?.organization,
            timestring: timestring
        };
    }
    getProfile(cloudId, userId, analytics) {
        if (!userId) return Promise.reject(new Error('userId missing'));
        const cacheIdentifier = `${cloudId}/${userId}`;
        const cache = this.getCachedProfile(cacheIdentifier);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $6TKEY.getPageTime)();
            if (analytics) analytics((0, $ivXTE.userRequestAnalytics)('triggered'));
            this.makeRequest(cloudId, userId).then((data)=>{
                if (this.cache) this.setCachedProfile(cacheIdentifier, data);
                if (analytics) analytics((0, $ivXTE.userRequestAnalytics)('succeeded', {
                    duration: (0, $6TKEY.getPageTime)() - startTime
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $ivXTE.userRequestAnalytics)('failed', {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    ...(0, $f3Zb8.getErrorAttributes)(error)
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("2qnn4", function(module, exports) {

$parcel$export(module.exports, "localTime", () => $de778707e3f7ab0e$export$f0dfd716e7b023cd);
parcelRequire("7UQ5i");
var $9uIbX = parcelRequire("9uIbX");
const $de778707e3f7ab0e$export$f0dfd716e7b023cd = (timezone, format)=>{
    if (!timezone) return null;
    try {
        return (0, $9uIbX.default)(new Date(), timezone, format);
    } catch (error) {
        return null;
    }
};

});
parcelRegister("7UQ5i", function(module, exports) {

$parcel$export(module.exports, "formatInTimeZone", () => (parcelRequire("9uIbX")).default);
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.


var $9uIbX = parcelRequire("9uIbX");





});
parcelRegister("9uIbX", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e9932008c468ee4$export$2e2bcd8739ae039);

var $fwbX5 = parcelRequire("fwbX5");

var $cmObS = parcelRequire("cmObS");

var $2b4cP = parcelRequire("2b4cP");
function $6e9932008c468ee4$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($fwbX5)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $cmObS.default)((0, $2b4cP.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("cmObS", function(module, exports) {

$parcel$export(module.exports, "default", () => $900e78e49c474eed$export$2e2bcd8739ae039);

var $aR9Qf = parcelRequire("aR9Qf");

var $920RE = parcelRequire("920RE");

var $2q3K8 = parcelRequire("2q3K8");
var $900e78e49c474eed$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $900e78e49c474eed$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($900e78e49c474eed$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $2q3K8.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $920RE.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aR9Qf)))(dirtyDate, formatStr, options);
}

});
parcelRegister("920RE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6934f899b8aefb37$export$2e2bcd8739ae039);

var $927cR = parcelRequire("927cR");

var $6JaJ1 = parcelRequire("6JaJ1");
var $6934f899b8aefb37$var$MILLISECONDS_IN_MINUTE = 60000;
var $6934f899b8aefb37$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $6934f899b8aefb37$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $6934f899b8aefb37$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $6934f899b8aefb37$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $6934f899b8aefb37$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $6934f899b8aefb37$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $6934f899b8aefb37$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $6934f899b8aefb37$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $6934f899b8aefb37$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $6934f899b8aefb37$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $6934f899b8aefb37$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $6934f899b8aefb37$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $927cR.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $927cR.default)('long', date, options);
        }
    }
};
function $6934f899b8aefb37$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $6JaJ1.default)(timeZone, originalDate, true) / $6934f899b8aefb37$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $6934f899b8aefb37$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $6934f899b8aefb37$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $6934f899b8aefb37$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $6934f899b8aefb37$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $6934f899b8aefb37$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $6934f899b8aefb37$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $6934f899b8aefb37$var$formatTimezone(offset, dirtyDelimeter);
}
function $6934f899b8aefb37$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $6934f899b8aefb37$var$addLeadingZeros(minutes, 2);
}
var $6934f899b8aefb37$export$2e2bcd8739ae039 = $6934f899b8aefb37$var$formatters;

});
parcelRegister("927cR", function(module, exports) {

$parcel$export(module.exports, "default", () => $6939e400b4f30595$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $6939e400b4f30595$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $6939e400b4f30595$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $6939e400b4f30595$var$partsTimeZone(dtf, date) : $6939e400b4f30595$var$hackyTimeZone(dtf, date);
}
function $6939e400b4f30595$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $6939e400b4f30595$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $6939e400b4f30595$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("6JaJ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e5f43d4fc19099f$export$2e2bcd8739ae039);

var $gTcao = parcelRequire("gTcao");

var $6Bk9v = parcelRequire("6Bk9v");
var $4e5f43d4fc19099f$var$MILLISECONDS_IN_HOUR = 3600000;
var $4e5f43d4fc19099f$var$MILLISECONDS_IN_MINUTE = 60000;
var $4e5f43d4fc19099f$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $4e5f43d4fc19099f$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $4e5f43d4fc19099f$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $4e5f43d4fc19099f$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$4e5f43d4fc19099f$var$validateTimezone(hours)) return NaN;
        return -(hours * $4e5f43d4fc19099f$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $4e5f43d4fc19099f$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$4e5f43d4fc19099f$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $4e5f43d4fc19099f$var$MILLISECONDS_IN_HOUR + minutes * $4e5f43d4fc19099f$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($4e5f43d4fc19099f$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $4e5f43d4fc19099f$var$toUtcDate(date);
        var offset = $4e5f43d4fc19099f$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $4e5f43d4fc19099f$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $4e5f43d4fc19099f$var$toUtcDate(date) {
    return (0, $6Bk9v.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $4e5f43d4fc19099f$var$calcOffset(date, timezoneString) {
    var tokens = (0, $gTcao.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $6Bk9v.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $4e5f43d4fc19099f$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $4e5f43d4fc19099f$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $4e5f43d4fc19099f$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $4e5f43d4fc19099f$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $4e5f43d4fc19099f$var$validIANATimezoneCache = {};
function $4e5f43d4fc19099f$var$isValidTimezoneIANAString(timeZoneString) {
    if ($4e5f43d4fc19099f$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $4e5f43d4fc19099f$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("gTcao", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4bb38695b1c145f$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $c4bb38695b1c145f$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $c4bb38695b1c145f$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $c4bb38695b1c145f$var$partsOffset(dtf, date) : $c4bb38695b1c145f$var$hackyOffset(dtf, date);
}
var $c4bb38695b1c145f$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $c4bb38695b1c145f$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $c4bb38695b1c145f$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $c4bb38695b1c145f$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $c4bb38695b1c145f$var$dtfCache = {};
function $c4bb38695b1c145f$var$getDateTimeFormat(timeZone) {
    if (!$c4bb38695b1c145f$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $c4bb38695b1c145f$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $c4bb38695b1c145f$var$dtfCache[timeZone];
}

});

parcelRegister("6Bk9v", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ce5d4976aa71227$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $4ce5d4976aa71227$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("2q3K8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c30e9c4205eee83$export$2e2bcd8739ae039);

var $aSksP = parcelRequire("aSksP");

var $jGQTC = parcelRequire("jGQTC");

var $6JaJ1 = parcelRequire("6JaJ1");

var $jxCgc = parcelRequire("jxCgc");
var $1c30e9c4205eee83$var$MILLISECONDS_IN_HOUR = 3600000;
var $1c30e9c4205eee83$var$MILLISECONDS_IN_MINUTE = 60000;
var $1c30e9c4205eee83$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $1c30e9c4205eee83$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $jxCgc.default)
};
function $1c30e9c4205eee83$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $1c30e9c4205eee83$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($aSksP)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $1c30e9c4205eee83$var$splitDateString(argument);
    var parseYearResult = $1c30e9c4205eee83$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $1c30e9c4205eee83$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $1c30e9c4205eee83$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $6JaJ1.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $1c30e9c4205eee83$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $1c30e9c4205eee83$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $1c30e9c4205eee83$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $1c30e9c4205eee83$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $1c30e9c4205eee83$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $1c30e9c4205eee83$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $1c30e9c4205eee83$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $1c30e9c4205eee83$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $1c30e9c4205eee83$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $1c30e9c4205eee83$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $1c30e9c4205eee83$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$1c30e9c4205eee83$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $1c30e9c4205eee83$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$1c30e9c4205eee83$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $1c30e9c4205eee83$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$1c30e9c4205eee83$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $1c30e9c4205eee83$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$1c30e9c4205eee83$var$validateWeekDate(year, week)) return new Date(NaN);
        return $1c30e9c4205eee83$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $1c30e9c4205eee83$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$1c30e9c4205eee83$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $1c30e9c4205eee83$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $1c30e9c4205eee83$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $1c30e9c4205eee83$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$1c30e9c4205eee83$var$validateTime(hours)) return NaN;
        return hours % 24 * $1c30e9c4205eee83$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $1c30e9c4205eee83$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$1c30e9c4205eee83$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $1c30e9c4205eee83$var$MILLISECONDS_IN_HOUR + minutes * $1c30e9c4205eee83$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $1c30e9c4205eee83$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$1c30e9c4205eee83$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $1c30e9c4205eee83$var$MILLISECONDS_IN_HOUR + minutes * $1c30e9c4205eee83$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $1c30e9c4205eee83$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $1c30e9c4205eee83$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $1c30e9c4205eee83$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $1c30e9c4205eee83$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $1c30e9c4205eee83$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $1c30e9c4205eee83$var$isLeapYearIndex(year);
        if (isLeapYear && date > $1c30e9c4205eee83$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $1c30e9c4205eee83$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $1c30e9c4205eee83$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $1c30e9c4205eee83$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $1c30e9c4205eee83$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $1c30e9c4205eee83$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("jxCgc", function(module, exports) {

$parcel$export(module.exports, "default", () => $e39ec715b89452b2$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $e39ec715b89452b2$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $e39ec715b89452b2$export$2e2bcd8739ae039 = $e39ec715b89452b2$var$tzPattern;

});



parcelRegister("2b4cP", function(module, exports) {

$parcel$export(module.exports, "default", () => $195fdf0d1f4870c0$export$2e2bcd8739ae039);

var $6JaJ1 = parcelRequire("6JaJ1");

var $2q3K8 = parcelRequire("2q3K8");
function $195fdf0d1f4870c0$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $2q3K8.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $6JaJ1.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});







parcelRegister("mw4O5", function(module, exports) {

$parcel$export(module.exports, "useNavigation", () => $d3d9116e20618ad2$export$d0fd4b7106de2769);
$parcel$export(module.exports, "useAppConfig", () => $d3d9116e20618ad2$export$a3e0ece8c3f698d7);

var $8VfUC = parcelRequire("8VfUC");

var $3WNaH = parcelRequire("3WNaH");

var $3WNaH = parcelRequire("3WNaH");
const $d3d9116e20618ad2$export$d0fd4b7106de2769 = ()=>{
    const state = (0, $3WNaH.useNavigationState)();
    const actions = (0, $8VfUC.useNavigationActions)();
    return {
        ...actions,
        ...state
    };
};
const $d3d9116e20618ad2$export$a3e0ece8c3f698d7 = ()=>{
    const storeState = (0, $3WNaH.useAppConfigStoreState)();
    const navigation = $d3d9116e20618ad2$export$d0fd4b7106de2769();
    const addFlag = (0, $8VfUC.useAddFlag)();
    return {
        ...storeState,
        ...navigation,
        addFlag: addFlag
    };
};

});




parcelRegister("4i1Yb", function(module, exports) {

$parcel$export(module.exports, "useLicenseCheck", () => $5761c5b5506f5764$export$710d990c66bc31bc);

var $5uXOq = parcelRequire("5uXOq");

var $6L4IE = parcelRequire("6L4IE");
var $k3Vai = parcelRequire("k3Vai");
const $5761c5b5506f5764$export$710d990c66bc31bc = (cloudId)=>{
    const [request, controller] = (0, $5uXOq.useMemo)(()=>(0, $6L4IE.requestWithAbort)(`/gateway/api/xflow/${cloudId}/license-information`, {
            method: 'GET'
        }), [
        cloudId
    ]);
    const [getLicenseCheck, result] = (0, $k3Vai.useLazyService)(request, controller);
    (0, $5uXOq.useEffect)(()=>{
        if (cloudId) getLicenseCheck();
    }, [
        cloudId,
        getLicenseCheck
    ]);
    return result;
};

});

parcelRegister("it4ti", function(module, exports) {

$parcel$export(module.exports, "default", () => $d65d33568e00a730$export$2e2bcd8739ae039);
// TODO: PTC-2088 - simplify list of locales



























const $d65d33568e00a730$var$messagesConfig = [
    // Czech
    {
        locales: [
            'cs',
            'cs-CZ'
        ],
        loader: ()=>(parcelRequire("1Fnh7"))
    },
    // Danish
    {
        locales: [
            'da',
            'da-DK'
        ],
        loader: ()=>(parcelRequire("9J8pe"))
    },
    // German
    {
        locales: [
            'de',
            'de-DE'
        ],
        loader: ()=>(parcelRequire("3gZtB"))
    },
    // Spain
    {
        locales: [
            'es',
            'es-ES'
        ],
        loader: ()=>(parcelRequire("12tnp"))
    },
    // Finnish
    {
        locales: [
            'fi',
            'fi-FI'
        ],
        loader: ()=>(parcelRequire("khFaQ"))
    },
    // French
    {
        locales: [
            'fr',
            'fr-FR'
        ],
        loader: ()=>(parcelRequire("hD1NY"))
    },
    // Hungarian
    {
        locales: [
            'hu',
            'hu-HU'
        ],
        loader: ()=>(parcelRequire("3opY2"))
    },
    // Icelandic
    {
        locales: [
            'is',
            'is-IS'
        ],
        loader: ()=>(parcelRequire("hRXe9"))
    },
    // Italian
    {
        locales: [
            'it',
            'it-IT'
        ],
        loader: ()=>(parcelRequire("gfy2x"))
    },
    // Japanese
    {
        locales: [
            'ja',
            'ja-JP'
        ],
        loader: ()=>(parcelRequire("7dbob"))
    },
    // Korean
    {
        locales: [
            'ko',
            'ko-KR'
        ],
        loader: ()=>(parcelRequire("jOZNJ"))
    },
    // Dutch
    {
        locales: [
            'nl',
            'nl-NL'
        ],
        loader: ()=>(parcelRequire("1vC2B"))
    },
    // Norwegian (Norway)
    {
        locales: [
            'nb',
            'nb-NO'
        ],
        loader: ()=>(parcelRequire("bxIic"))
    },
    // Polish
    {
        locales: [
            'pl',
            'pl-PL'
        ],
        loader: ()=>(parcelRequire("llWRF"))
    },
    // Portuguese -
    {
        locales: [
            'pt-BR'
        ],
        loader: ()=>(parcelRequire("lmzmS"))
    },
    // Romanian
    {
        locales: [
            'ro',
            'ro-RO'
        ],
        loader: ()=>(parcelRequire("7thYP"))
    },
    // Russian
    {
        locales: [
            'ru',
            'ru-RU'
        ],
        loader: ()=>(parcelRequire("c2lhX"))
    },
    // Swedish
    {
        locales: [
            'sv',
            'sv-SE'
        ],
        loader: ()=>(parcelRequire("8vc63"))
    },
    // China uses Chinese (Simplified)
    {
        locales: [
            'zh',
            'zh-CN',
            'zh-Hans'
        ],
        loader: ()=>(parcelRequire("49dvz"))
    },
    // Taiwan or Hong Kong uses Chinese (Traditional)
    {
        locales: [
            'zh-TW',
            'zh-HK',
            'zh-Hant'
        ],
        loader: ()=>(parcelRequire("4qvRw"))
    },
    // Turkish
    {
        locales: [
            'tr',
            'tr-TR'
        ],
        loader: ()=>(parcelRequire("bRUY2"))
    },
    // Thai
    {
        locales: [
            'th',
            'th-TH'
        ],
        loader: ()=>(parcelRequire("el4rg"))
    },
    // Ukrainian
    {
        locales: [
            'uk',
            'uk-UA'
        ],
        loader: ()=>(parcelRequire("8kfHP"))
    },
    // Vietnamese
    {
        locales: [
            'vi',
            'vi-VN'
        ],
        loader: ()=>(parcelRequire("8QlKs"))
    },
    // English (UK)
    {
        locales: [
            'en-GB'
        ],
        loader: ()=>(parcelRequire("4M7CI"))
    },
    // English (US)
    {
        locales: [
            'en',
            'en-US'
        ],
        loader: ()=>(parcelRequire("8nSsz"))
    },
    // English (Instrumented) used by i18n in staging
    {
        locales: [
            'en-ZZ'
        ],
        loader: ()=>(parcelRequire("3SZC0"))
    }
];
var $d65d33568e00a730$export$2e2bcd8739ae039 = $d65d33568e00a730$var$messagesConfig;

});
parcelRegister("1Fnh7", function(module, exports) {

let $136bacb6c0028c35$var$load = (parcelRequire("28QjX"))(4);
module.exports = $136bacb6c0028c35$var$load("4qdlD").then(()=>parcelRequire('fAhDz'));

});

parcelRegister("9J8pe", function(module, exports) {

let $01d3da2a7f0d6ea7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $01d3da2a7f0d6ea7$var$load("9Mcfb").then(()=>parcelRequire('64grG'));

});

parcelRegister("3gZtB", function(module, exports) {

let $26228da8c5624652$var$load = (parcelRequire("28QjX"))(4);
module.exports = $26228da8c5624652$var$load("gRuUA").then(()=>parcelRequire('hpCQd'));

});

parcelRegister("12tnp", function(module, exports) {

let $0c1cc3f2956890d9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0c1cc3f2956890d9$var$load("6YbR4").then(()=>parcelRequire('l8MeX'));

});

parcelRegister("khFaQ", function(module, exports) {

let $ec455575e36863fd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ec455575e36863fd$var$load("4J8Gb").then(()=>parcelRequire('6Gm5S'));

});

parcelRegister("hD1NY", function(module, exports) {

let $cd577aa6276b9e12$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cd577aa6276b9e12$var$load("9r5fb").then(()=>parcelRequire('kj5nH'));

});

parcelRegister("3opY2", function(module, exports) {

let $2787c194ce00c8b5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2787c194ce00c8b5$var$load("j4yN8").then(()=>parcelRequire('iYn1e'));

});

parcelRegister("hRXe9", function(module, exports) {

let $d025543820ec34cf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d025543820ec34cf$var$load("dqCSy").then(()=>parcelRequire('arfwR'));

});

parcelRegister("gfy2x", function(module, exports) {

let $bd4873af9cf1b3c4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bd4873af9cf1b3c4$var$load("hMzze").then(()=>parcelRequire('ljVDr'));

});

parcelRegister("7dbob", function(module, exports) {

let $540294f456bee161$var$load = (parcelRequire("28QjX"))(4);
module.exports = $540294f456bee161$var$load("2okND").then(()=>parcelRequire('9BxE5'));

});

parcelRegister("jOZNJ", function(module, exports) {

let $e6e2a045e68a8792$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e6e2a045e68a8792$var$load("dsdEO").then(()=>parcelRequire('0vQzK'));

});

parcelRegister("1vC2B", function(module, exports) {

let $119631d4f87febd7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $119631d4f87febd7$var$load("ej1hn").then(()=>parcelRequire('3tF1z'));

});

parcelRegister("bxIic", function(module, exports) {

let $8675225f38331d1c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8675225f38331d1c$var$load("eHLaz").then(()=>parcelRequire('5ovxF'));

});

parcelRegister("llWRF", function(module, exports) {

let $f8b9386ca2df375f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f8b9386ca2df375f$var$load("21qva").then(()=>parcelRequire('e9uUQ'));

});

parcelRegister("lmzmS", function(module, exports) {

let $f8d71661a543bf62$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f8d71661a543bf62$var$load("cFLtT").then(()=>parcelRequire('h843c'));

});

parcelRegister("7thYP", function(module, exports) {

let $5709304d3c38bd7b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5709304d3c38bd7b$var$load("hSfN6").then(()=>parcelRequire('2pAXM'));

});

parcelRegister("c2lhX", function(module, exports) {

let $8c362f6fb01822ba$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8c362f6fb01822ba$var$load("CacEE").then(()=>parcelRequire('csx0J'));

});

parcelRegister("8vc63", function(module, exports) {

let $630a9a1b9343a6de$var$load = (parcelRequire("28QjX"))(4);
module.exports = $630a9a1b9343a6de$var$load("jUjtR").then(()=>parcelRequire('2X5b0'));

});

parcelRegister("49dvz", function(module, exports) {

let $30527b2849b1c22f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $30527b2849b1c22f$var$load("iFo0P").then(()=>parcelRequire('4TJVi'));

});

parcelRegister("4qvRw", function(module, exports) {

let $33924e52ccf942e7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $33924e52ccf942e7$var$load("5YE6j").then(()=>parcelRequire('dmOFJ'));

});

parcelRegister("bRUY2", function(module, exports) {

let $8a40d57f474fcf96$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8a40d57f474fcf96$var$load("gdEHc").then(()=>parcelRequire('13ldR'));

});

parcelRegister("el4rg", function(module, exports) {

let $a70678453ddba7b1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a70678453ddba7b1$var$load("jb6FV").then(()=>parcelRequire('3yAa3'));

});

parcelRegister("8kfHP", function(module, exports) {

let $60fc5fd56ab78b9a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $60fc5fd56ab78b9a$var$load("jORKv").then(()=>parcelRequire('5yNzL'));

});

parcelRegister("8QlKs", function(module, exports) {

let $67040cd36f84faaf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $67040cd36f84faaf$var$load("6rt2v").then(()=>parcelRequire('7yfBB'));

});

parcelRegister("4M7CI", function(module, exports) {

let $37a18efa592c8ec7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $37a18efa592c8ec7$var$load("5PrAT").then(()=>parcelRequire('grA3K'));

});

parcelRegister("8nSsz", function(module, exports) {

let $61aab750aca099d7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $61aab750aca099d7$var$load("bs9f1").then(()=>parcelRequire('hzZHZ'));

});

parcelRegister("3SZC0", function(module, exports) {

let $2d463514cbcea305$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2d463514cbcea305$var$load("sfqY7").then(()=>parcelRequire('ia1WU'));

});


parcelRegister("fNJQT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e70a838d2f4a95a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fCZyz = parcelRequire("fCZyz");
var $heJqE = parcelRequire("heJqE");
var $fj1sb = parcelRequire("fj1sb");

var $5hWov = parcelRequire("5hWov");

var $kxdtg = parcelRequire("kxdtg");

var $9ADns = parcelRequire("9ADns");

var $fiymB = parcelRequire("fiymB");

var $8qmUa = parcelRequire("8qmUa");

var $fj1iI = parcelRequire("fj1iI");

var $aHh7I = parcelRequire("aHh7I");

var $hEEh7 = parcelRequire("hEEh7");

var $9Wt9a = parcelRequire("9Wt9a");

var $jM6Gv = parcelRequire("jM6Gv");

var $9jKbC = parcelRequire("9jKbC");

var $9PUJF = parcelRequire("9PUJF");

var $bVufh = parcelRequire("bVufh");
// Team Profile
// Kudos
const $4e70a838d2f4a95a$var$renderRoutes = (contextEntryPoint, canViewTeams)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $fj1sb.default), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fCZyz.default), {
                exact: true,
                path: `${contextEntryPoint}/`,
                render: (0, $8qmUa.default)
            }),
            !canViewTeams && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fCZyz.default), {
                path: `${contextEntryPoint}/search/teams`,
                render: (0, $hEEh7.default)
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fCZyz.default), {
                path: `${contextEntryPoint}/search`,
                render: (0, $aHh7I.default)
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fCZyz.default), {
                path: `${contextEntryPoint}/kudos/:uuid`,
                render: (0, $9ADns.default)
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fCZyz.default), {
                exact: true,
                path: `${contextEntryPoint}/team`,
                render: (0, $jM6Gv.default)
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fj1iI.RouteWithOrgIdLoading), {
                path: `${contextEntryPoint}/team/:teamId`,
                render: (0, $9Wt9a.default)
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fCZyz.default), {
                path: `${contextEntryPoint}/agent/:agentId`,
                render: (0, $kxdtg.default)
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fCZyz.default), {
                path: `${contextEntryPoint}/:userId/work`,
                render: (0, $bVufh.default)
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fCZyz.default), {
                path: `${contextEntryPoint}/:userId/*`,
                render: (0, $9PUJF.default)
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fCZyz.default), {
                path: `${contextEntryPoint}/me`,
                render: (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $fiymB.default), {
                        ...props,
                        contextEntryPoint: contextEntryPoint
                    })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fCZyz.default), {
                path: `${contextEntryPoint}/:userId`,
                render: (0, $9jKbC.default)
            })
        ]
    });
};
function $4e70a838d2f4a95a$var$AppRoutes(props) {
    const { contextEntryPoint: contextEntryPoint, history: history, onTransition: onTransition } = props;
    const { permissions: { canViewTeams: canViewTeams } } = (0, $5hWov.useTeamVisibility)();
    (0, $5uXOq.useEffect)(()=>{
        if (!onTransition) return;
        let unsubscribeBlockingHistory = ()=>{};
        let unsubscribeListeningHistory = ()=>{};
        if (history) {
            let lastHistoryLocation;
            unsubscribeListeningHistory = history.listen(({ pathname: pathname })=>{
                lastHistoryLocation = pathname;
            });
            // We're using history.block() here instead of history.listen()
            // because we want this to run BEFORE transition happens.
            unsubscribeBlockingHistory = history.block(({ pathname: pathname })=>{
                if (lastHistoryLocation !== pathname) onTransition(pathname);
            });
        }
        return ()=>{
            unsubscribeBlockingHistory();
            unsubscribeListeningHistory();
        };
    }, [
        onTransition,
        history
    ]);
    const routes = $4e70a838d2f4a95a$var$renderRoutes(contextEntryPoint, canViewTeams);
    // If `history` object is not passed to `EmbeddableDirectory`, `EmbeddableDirectory` will use `Router` component from product in higher component tree.
    // If `history` object is passed to `EmbeddableDirectory`, `EmbeddableDirectory` will render its own `Router` component.
    // @ts-ignore - Property 'children' does not exist on type 'IntrinsicAttributes & IntrinsicClassAttributes<Router> & Readonly<RouterProps>'
    // This was added when enrolling `@atlassian/ptc-embeddable-directory` into JFE local consumption
    return history ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $heJqE.default), {
        history: history,
        children: routes
    }) : routes;
}
var $4e70a838d2f4a95a$export$2e2bcd8739ae039 = $4e70a838d2f4a95a$var$AppRoutes;

});
parcelRegister("fCZyz", function(module, exports) {

$parcel$export(module.exports, "default", () => $b60a277c7a1030b5$export$2e2bcd8739ae039);
// Written in this round about way for babel-transform-imports

var $e0XoQ = parcelRequire("e0XoQ");
var $b60a277c7a1030b5$export$2e2bcd8739ae039 = (0, $e0XoQ.default);

});
parcelRegister("e0XoQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a33f2454f0f795a6$export$2e2bcd8739ae039);

var $hBYjV = parcelRequire("hBYjV");

var $aE1Lc = parcelRequire("aE1Lc");

var $5uXOq = parcelRequire("5uXOq");

var $8rCP3 = parcelRequire("8rCP3");

var $70VoX = parcelRequire("70VoX");
var $a33f2454f0f795a6$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $a33f2454f0f795a6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a33f2454f0f795a6$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a33f2454f0f795a6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $a33f2454f0f795a6$var$isEmptyChildren = function isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.count(children) === 0;
};
/**
 * The public API for matching a single path and rendering.
 */ var $a33f2454f0f795a6$var$Route = function(_React$Component) {
    $a33f2454f0f795a6$var$_inherits(Route, _React$Component);
    function Route() {
        var _temp, _this, _ret;
        $a33f2454f0f795a6$var$_classCallCheck(this, Route);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $a33f2454f0f795a6$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.state = {
            match: _this.computeMatch(_this.props, _this.context.router)
        }, _temp), $a33f2454f0f795a6$var$_possibleConstructorReturn(_this, _ret);
    }
    Route.prototype.getChildContext = function getChildContext() {
        return {
            router: $a33f2454f0f795a6$var$_extends({}, this.context.router, {
                route: {
                    location: this.props.location || this.context.router.route.location,
                    match: this.state.match
                }
            })
        };
    };
    Route.prototype.computeMatch = function computeMatch(_ref, router) {
        var computedMatch = _ref.computedMatch, location = _ref.location, path = _ref.path, strict = _ref.strict, exact = _ref.exact, sensitive = _ref.sensitive;
        if (computedMatch) return computedMatch; // <Switch> already computed the match for us
        (0, (/*@__PURE__*/$parcel$interopDefault($aE1Lc)))(router, "You should not use <Route> or withRouter() outside a <Router>");
        var route = router.route;
        var pathname = (location || route.location).pathname;
        return (0, $70VoX.default)(pathname, {
            path: path,
            strict: strict,
            exact: exact,
            sensitive: sensitive
        }, route.match);
    };
    Route.prototype.componentWillMount = function componentWillMount() {
        (0, (/*@__PURE__*/$parcel$interopDefault($hBYjV)))(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");
        (0, (/*@__PURE__*/$parcel$interopDefault($hBYjV)))(!(this.props.component && this.props.children && !$a33f2454f0f795a6$var$isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");
        (0, (/*@__PURE__*/$parcel$interopDefault($hBYjV)))(!(this.props.render && this.props.children && !$a33f2454f0f795a6$var$isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
    };
    Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
        (0, (/*@__PURE__*/$parcel$interopDefault($hBYjV)))(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
        (0, (/*@__PURE__*/$parcel$interopDefault($hBYjV)))(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
        this.setState({
            match: this.computeMatch(nextProps, nextContext.router)
        });
    };
    Route.prototype.render = function render() {
        var match = this.state.match;
        var _props = this.props, children = _props.children, component = _props.component, render = _props.render;
        var _context$router = this.context.router, history = _context$router.history, route = _context$router.route, staticContext = _context$router.staticContext;
        var location = this.props.location || route.location;
        var props = {
            match: match,
            location: location,
            history: history,
            staticContext: staticContext
        };
        if (component) return match ? (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(component, props) : null;
        if (render) return match ? render(props) : null;
        if (typeof children === "function") return children(props);
        if (children && !$a33f2454f0f795a6$var$isEmptyChildren(children)) return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.only(children);
        return null;
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component);
$a33f2454f0f795a6$var$Route.propTypes = {
    computedMatch: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object,
    path: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).string,
    exact: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).bool,
    strict: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).bool,
    sensitive: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).bool,
    component: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func,
    render: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).node
    ]),
    location: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object
};
$a33f2454f0f795a6$var$Route.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).shape({
        history: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object.isRequired,
        route: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object.isRequired,
        staticContext: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object
    })
};
$a33f2454f0f795a6$var$Route.childContextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object.isRequired
};
var $a33f2454f0f795a6$export$2e2bcd8739ae039 = $a33f2454f0f795a6$var$Route;

});
parcelRegister("70VoX", function(module, exports) {

$parcel$export(module.exports, "default", () => $51b50f39010f1f0a$export$2e2bcd8739ae039);

var $d4Ora = parcelRequire("d4Ora");
var $51b50f39010f1f0a$var$patternCache = {};
var $51b50f39010f1f0a$var$cacheLimit = 10000;
var $51b50f39010f1f0a$var$cacheCount = 0;
var $51b50f39010f1f0a$var$compilePath = function compilePath(pattern, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var cache = $51b50f39010f1f0a$var$patternCache[cacheKey] || ($51b50f39010f1f0a$var$patternCache[cacheKey] = {});
    if (cache[pattern]) return cache[pattern];
    var keys = [];
    var re = (0, (/*@__PURE__*/$parcel$interopDefault($d4Ora)))(pattern, keys, options);
    var compiledPattern = {
        re: re,
        keys: keys
    };
    if ($51b50f39010f1f0a$var$cacheCount < $51b50f39010f1f0a$var$cacheLimit) {
        cache[pattern] = compiledPattern;
        $51b50f39010f1f0a$var$cacheCount++;
    }
    return compiledPattern;
};
/**
 * Public API for matching a URL pathname to a path pattern.
 */ var $51b50f39010f1f0a$var$matchPath = function matchPath(pathname) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var parent = arguments[2];
    if (typeof options === "string") options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === undefined ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === undefined ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === undefined ? false : _options$sensitive;
    if (path == null) return parent;
    var _compilePath = $51b50f39010f1f0a$var$compilePath(path, {
        end: exact,
        strict: strict,
        sensitive: sensitive
    }), re = _compilePath.re, keys = _compilePath.keys;
    var match = re.exec(pathname);
    if (!match) return null;
    var url = match[0], values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
        path: path,
        url: path === "/" && url === "" ? "/" : url,
        isExact: isExact,
        params: keys.reduce(function(memo, key, index) {
            memo[key.name] = values[index];
            return memo;
        }, {})
    };
};
var $51b50f39010f1f0a$export$2e2bcd8739ae039 = $51b50f39010f1f0a$var$matchPath;

});
parcelRegister("d4Ora", function(module, exports) {

var $9D6nS = parcelRequire("9D6nS");
/**
 * Expose `pathToRegexp`.
 */ module.exports = $9852c5da38ba91d1$var$pathToRegexp;
module.exports.parse = $9852c5da38ba91d1$var$parse;
module.exports.compile = $9852c5da38ba91d1$var$compile;
module.exports.tokensToFunction = $9852c5da38ba91d1$var$tokensToFunction;
module.exports.tokensToRegExp = $9852c5da38ba91d1$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $9852c5da38ba91d1$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $9852c5da38ba91d1$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $9852c5da38ba91d1$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $9852c5da38ba91d1$var$escapeGroup(pattern) : asterisk ? '.*' : $9852c5da38ba91d1$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $9852c5da38ba91d1$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $9852c5da38ba91d1$var$escapeString(delimiter) + ']+?';
    return $9852c5da38ba91d1$var$escapeString(prevText) + '|(?:(?!' + $9852c5da38ba91d1$var$escapeString(prevText) + ')[^' + $9852c5da38ba91d1$var$escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $9852c5da38ba91d1$var$compile(str, options) {
    return $9852c5da38ba91d1$var$tokensToFunction($9852c5da38ba91d1$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $9852c5da38ba91d1$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $9852c5da38ba91d1$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $9852c5da38ba91d1$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $9852c5da38ba91d1$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $9852c5da38ba91d1$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($9D6nS(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $9852c5da38ba91d1$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $9852c5da38ba91d1$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $9852c5da38ba91d1$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $9852c5da38ba91d1$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $9852c5da38ba91d1$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $9852c5da38ba91d1$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $9852c5da38ba91d1$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $9852c5da38ba91d1$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($9852c5da38ba91d1$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $9852c5da38ba91d1$var$flags(options));
    return $9852c5da38ba91d1$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $9852c5da38ba91d1$var$stringToRegexp(path, keys, options) {
    return $9852c5da38ba91d1$var$tokensToRegExp($9852c5da38ba91d1$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $9852c5da38ba91d1$var$tokensToRegExp(tokens, keys, options) {
    if (!$9D6nS(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $9852c5da38ba91d1$var$escapeString(token);
        else {
            var prefix = $9852c5da38ba91d1$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $9852c5da38ba91d1$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $9852c5da38ba91d1$var$attachKeys(new RegExp('^' + route, $9852c5da38ba91d1$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $9852c5da38ba91d1$var$pathToRegexp(path, keys, options) {
    if (!$9D6nS(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $9852c5da38ba91d1$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($9D6nS(path)) return $9852c5da38ba91d1$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $9852c5da38ba91d1$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

});
parcelRegister("9D6nS", function(module, exports) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};

});





parcelRegister("heJqE", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8c6fbb4471fedde$export$2e2bcd8739ae039);
// Written in this round about way for babel-transform-imports

var $12Lcw = parcelRequire("12Lcw");
var $c8c6fbb4471fedde$export$2e2bcd8739ae039 = (0, $12Lcw.default);

});
parcelRegister("12Lcw", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c2a978068c36407$export$2e2bcd8739ae039);

var $hBYjV = parcelRequire("hBYjV");

var $aE1Lc = parcelRequire("aE1Lc");

var $5uXOq = parcelRequire("5uXOq");

var $8rCP3 = parcelRequire("8rCP3");
var $0c2a978068c36407$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $0c2a978068c36407$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0c2a978068c36407$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $0c2a978068c36407$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for putting history on context.
 */ var $0c2a978068c36407$var$Router = function(_React$Component) {
    $0c2a978068c36407$var$_inherits(Router, _React$Component);
    function Router() {
        var _temp, _this, _ret;
        $0c2a978068c36407$var$_classCallCheck(this, Router);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $0c2a978068c36407$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.state = {
            match: _this.computeMatch(_this.props.history.location.pathname)
        }, _temp), $0c2a978068c36407$var$_possibleConstructorReturn(_this, _ret);
    }
    Router.prototype.getChildContext = function getChildContext() {
        return {
            router: $0c2a978068c36407$var$_extends({}, this.context.router, {
                history: this.props.history,
                route: {
                    location: this.props.history.location,
                    match: this.state.match
                }
            })
        };
    };
    Router.prototype.computeMatch = function computeMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    Router.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;
        var _props = this.props, children = _props.children, history = _props.history;
        (0, (/*@__PURE__*/$parcel$interopDefault($aE1Lc)))(children == null || (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.count(children) === 1, "A <Router> may have only one child element");
        // Do this here so we can setState when a <Redirect> changes the
        // location in componentWillMount. This happens e.g. when doing
        // server rendering using a <StaticRouter>.
        this.unlisten = history.listen(function() {
            _this2.setState({
                match: _this2.computeMatch(history.location.pathname)
            });
        });
    };
    Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        (0, (/*@__PURE__*/$parcel$interopDefault($hBYjV)))(this.props.history === nextProps.history, "You cannot change <Router history>");
    };
    Router.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unlisten();
    };
    Router.prototype.render = function render() {
        var children = this.props.children;
        return children ? (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.only(children) : null;
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component);
$0c2a978068c36407$var$Router.propTypes = {
    history: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).node
};
$0c2a978068c36407$var$Router.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object
};
$0c2a978068c36407$var$Router.childContextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object.isRequired
};
var $0c2a978068c36407$export$2e2bcd8739ae039 = $0c2a978068c36407$var$Router;

});


parcelRegister("fj1sb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b249c201006a228b$export$2e2bcd8739ae039);
// Written in this round about way for babel-transform-imports

var $hd3Qv = parcelRequire("hd3Qv");
var $b249c201006a228b$export$2e2bcd8739ae039 = (0, $hd3Qv.default);

});
parcelRegister("hd3Qv", function(module, exports) {

$parcel$export(module.exports, "default", () => $c876a245a4c7da8b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8rCP3 = parcelRequire("8rCP3");

var $hBYjV = parcelRequire("hBYjV");

var $aE1Lc = parcelRequire("aE1Lc");

var $70VoX = parcelRequire("70VoX");
function $c876a245a4c7da8b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c876a245a4c7da8b$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $c876a245a4c7da8b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for rendering the first <Route> that matches.
 */ var $c876a245a4c7da8b$var$Switch = function(_React$Component) {
    $c876a245a4c7da8b$var$_inherits(Switch, _React$Component);
    function Switch() {
        $c876a245a4c7da8b$var$_classCallCheck(this, Switch);
        return $c876a245a4c7da8b$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    Switch.prototype.componentWillMount = function componentWillMount() {
        (0, (/*@__PURE__*/$parcel$interopDefault($aE1Lc)))(this.context.router, "You should not use <Switch> outside a <Router>");
    };
    Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        (0, (/*@__PURE__*/$parcel$interopDefault($hBYjV)))(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
        (0, (/*@__PURE__*/$parcel$interopDefault($hBYjV)))(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
    };
    Switch.prototype.render = function render() {
        var route = this.context.router.route;
        var children = this.props.children;
        var location = this.props.location || route.location;
        var match = void 0, child = void 0;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.forEach(children, function(element) {
            if (match == null && (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(element)) {
                var _element$props = element.props, pathProp = _element$props.path, exact = _element$props.exact, strict = _element$props.strict, sensitive = _element$props.sensitive, from = _element$props.from;
                var path = pathProp || from;
                child = element;
                match = (0, $70VoX.default)(location.pathname, {
                    path: path,
                    exact: exact,
                    strict: strict,
                    sensitive: sensitive
                }, route.match);
            }
        });
        return match ? (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
            location: location,
            computedMatch: match
        }) : null;
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component);
$c876a245a4c7da8b$var$Switch.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).shape({
        route: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object.isRequired
    }).isRequired
};
$c876a245a4c7da8b$var$Switch.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).node,
    location: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object
};
var $c876a245a4c7da8b$export$2e2bcd8739ae039 = $c876a245a4c7da8b$var$Switch;

});


parcelRegister("5hWov", function(module, exports) {

$parcel$export(module.exports, "useTeamVisibility", () => $92a54380ceb72523$export$acf57ff2f92f51c1);

var $5uXOq = parcelRequire("5uXOq");

var $3FH71 = parcelRequire("3FH71");

var $95nUS = parcelRequire("95nUS");

var $2bf04 = parcelRequire("2bf04");

var $1VnzL = parcelRequire("1VnzL");

var $fff3y = parcelRequire("fff3y");

var $5WmsO = parcelRequire("5WmsO");
const $92a54380ceb72523$export$7d97a022bd09a6fb = ()=>{
    return {
        isTeamsVisiblityEnabled: true,
        failOpenSites: false
    };
};
const $92a54380ceb72523$var$useTeamPermissionsAnalytics = ({ data: data, error: error, permissions: permissions })=>{
    const { fireEvent: fireEvent } = (0, $3FH71.usePeopleTeamAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (error) {
            (0, $2bf04.logException)(error, 'Error loading team permissions in useTeamsPermissionsService');
            const { status: status, path: path } = error instanceof Error ? {
                status: 'unknown',
                path: 'unknown'
            } : error;
            fireEvent('operational.teamsPermissionsRequest.failed', {
                message: error.message,
                status: status,
                path: path
            });
        }
    }, [
        error,
        fireEvent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (data && permissions) fireEvent('operational.teamsPermissionsRequest.succeeded', {
            canCreateTeams: permissions.canCreateTeams,
            canViewTeams: permissions.canViewTeams,
            canAdminTeams: !!permissions.canAdminTeams
        });
    }, [
        data,
        fireEvent,
        permissions
    ]);
};
const $92a54380ceb72523$export$acf57ff2f92f51c1 = ()=>{
    const { orgId: orgId } = (0, $1VnzL.useV3OrgIdStatus)();
    const [{ cloudId: cloudId }] = (0, $5WmsO.useSite)();
    const [{ principalUserId: principalUserId }] = (0, $fff3y.usePrincipalUser)();
    const result = (0, $95nUS.useTeamsPermissionsService)({
        orgId: orgId,
        cloudId: cloudId
    }, {
        // Wait for cloudId to be available before making the request
        enabled: !!cloudId,
        attributes: {
            userId: principalUserId
        }
    });
    $92a54380ceb72523$var$useTeamPermissionsAnalytics(result);
    return {
        isLoading: !cloudId || result.isLoading,
        permissions: result.permissions
    };
};

});
parcelRegister("3FH71", function(module, exports) {

$parcel$export(module.exports, "usePeopleTeamAnalyticsEvents", () => $26f504506e3b41ef$export$48acf7e27d4331f);
$parcel$export(module.exports, "useTeamsExperienceTracker", () => $26f504506e3b41ef$export$5792e6ebc464482e);

var $5uXOq = parcelRequire("5uXOq");

var $jZ6HJ = parcelRequire("jZ6HJ");

var $1URky = parcelRequire("1URky");

var $bwDHF = parcelRequire("bwDHF");

var $jsDzq = parcelRequire("jsDzq");
const $26f504506e3b41ef$export$48acf7e27d4331f = ()=>{
    const [{ eventAttributes: injectedEventAttributes }, { setEventAttributes: setEventAttributes }] = (0, $jZ6HJ.usePeopleTeamsAnalyticsSubcontext)();
    const { fireEvent: fireEvent } = (0, $bwDHF.useAnalyticsEvents)();
    const fireEventWithSubcontextAttributesInjected = (0, $5uXOq.useCallback)((...params)=>{
        const [event, attributes] = params;
        const eventWithSubcontextAttributes = {
            ...attributes,
            ...injectedEventAttributes
        };
        // @ts-ignore allow injecting subcontext attributes
        fireEvent(event, eventWithSubcontextAttributes);
    }, [
        fireEvent,
        injectedEventAttributes
    ]);
    return {
        fireEvent: fireEventWithSubcontextAttributesInjected,
        setInjectedEventAttributes: setEventAttributes
    };
};
const $26f504506e3b41ef$export$b72f2eb2a11f7b8 = ()=>(0, $jsDzq.useAnalyticsEventsWithTags)();
const $26f504506e3b41ef$export$5792e6ebc464482e = ()=>{
    const { fireEvent: fireEvent } = $26f504506e3b41ef$export$48acf7e27d4331f();
    const fireExperienceEvent = (0, $5uXOq.useCallback)((action, subject, attributes)=>{
        // @ts-ignore TODO: we may need to declare the keys to a const in the types file so we can do a check here
        fireEvent(`operational.${subject.replace(/[\/-]/g, '_')}.${action}`, {
            ...attributes,
            source: 'clientMetrics'
        });
    }, [
        fireEvent
    ]);
    const experienceTracker = (0, $5uXOq.useMemo)(()=>(0, $1URky.createTeamsExperienceTracker)(fireExperienceEvent), [
        fireExperienceEvent
    ]);
    return experienceTracker;
};

});
parcelRegister("jZ6HJ", function(module, exports) {

$parcel$export(module.exports, "usePeopleTeamsAnalyticsSubcontext", () => $3a57dd04b5affe69$export$86448e866930ba8d);
$parcel$export(module.exports, "useInjectedEventAttribute", () => $3a57dd04b5affe69$export$831917a198e22e70);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $3a57dd04b5affe69$var$initialState = {
    eventAttributes: {}
};
const $3a57dd04b5affe69$var$actions = {
    setEventAttributes: (eventAttributes)=>({ setState: setState, getState: getState })=>{
            const existingEventAttributes = getState().eventAttributes;
            const newEventAttributes = {
                ...existingEventAttributes,
                ...eventAttributes
            };
            Object.keys(newEventAttributes).forEach((keyString)=>{
                const key = keyString;
                if (newEventAttributes[key] === undefined) delete newEventAttributes[key];
            });
            setState({
                eventAttributes: newEventAttributes
            });
        }
};
const $3a57dd04b5affe69$var$AnalyticsSubcontextStore = (0, $iXqE5.createStore)({
    initialState: $3a57dd04b5affe69$var$initialState,
    actions: $3a57dd04b5affe69$var$actions
});
const $3a57dd04b5affe69$export$86448e866930ba8d = (0, $3sQ5x.createHook)($3a57dd04b5affe69$var$AnalyticsSubcontextStore);
const $3a57dd04b5affe69$export$831917a198e22e70 = (key, value)=>{
    const { setEventAttributes: setEventAttributes } = $3a57dd04b5affe69$export$86448e866930ba8d()[1];
    (0, $5uXOq.useEffect)(()=>{
        setEventAttributes({
            [key]: value
        });
        return ()=>setEventAttributes({
                [key]: undefined
            });
    }, [
        key,
        value,
        setEventAttributes
    ]);
};

});

parcelRegister("1URky", function(module, exports) {

$parcel$export(module.exports, "createTeamsExperienceTracker", () => $f8ce0cd94612cc89$export$c0c885a04612b38d);

var $cBeZP = parcelRequire("cBeZP");

var $7i7RM = parcelRequire("7i7RM");

var $hnAwz = parcelRequire("hnAwz");
function $f8ce0cd94612cc89$export$c0c885a04612b38d(fireExperienceEvent, options) {
    const tracker = new (0, $7i7RM.TeamsExperienceTracker)({
        isNetworkOfflineError: (0, $hnAwz.isNetworkError)
    });
    tracker.subscribe((event)=>{
        if (event.action === 'taskStart' || event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail') {
            const performanceAttributes = (0, $hnAwz.computePerformanceAttributes)(event);
            const errorAttributes = (0, $hnAwz.computeErrorAttributes)(event);
            const finalErrorDetails = Object.assign(errorAttributes, performanceAttributes, event.attributes, {
                // Because standalone app is deployed to prod quickly,
                // we will use this attribute to query in Splunk sooner.
                isStandalone: !!options?.isStandalone,
                hasBrowseUsersPermission: !!options?.hasBrowseUsersPermission
            });
            fireExperienceEvent(event.action, event.name, finalErrorDetails);
            if (event.action === 'taskFail' && options?.logErrorMessage) options.logErrorMessage(`taskFail:${event.name}`, finalErrorDetails);
        }
    });
    (0, $cBeZP.bindAll)(window, [
        {
            type: 'unload',
            listener: ()=>tracker.abort({
                    reason: 'Abort due to Window unloading',
                    attributes: {
                        cause: 'WINDOW_UNLOAD'
                    }
                })
        },
        {
            type: 'pagehide',
            listener: ()=>{
                tracker.abort({
                    reason: 'Window unloading',
                    attributes: {
                        cause: 'PAGE_HIDE'
                    }
                });
            }
        }
    ]);
    return tracker;
}

});
parcelRegister("7i7RM", function(module, exports) {

$parcel$export(module.exports, "TeamsExperienceTracker", () => $df8b2ce13ecbfe34$export$9e9a48cf2c297bd1);

var $ha42n = parcelRequire("ha42n");

var $15mL0 = parcelRequire("15mL0");
class $df8b2ce13ecbfe34$export$9e9a48cf2c297bd1 extends (0, $ha42n.ExperienceTracker) {
    _errorNameInIgnoredList(error) {
        const name = error && error.constructor.name;
        return this._ignoredErrors.includes(name) ? name : undefined;
    }
    constructor(options){
        super(options), // error names here will also be sent in the attribute `cause`
        this._ignoredErrors = [
            'SentryIgnoreError'
        ];
    }
    stopOnError({ name: name, error: error }) {
        if ((0, $15mL0.isAuthError)(error)) {
            this.abort({
                name: name,
                reason: 'Abort due to user unauthenticated',
                attributes: {
                    cause: 'USER_UNAUTHENTICATED',
                    error: error
                },
                checkForTimeout: false
            });
            return;
        }
        if ((0, $15mL0.isErrorStatusCode)((0, $15mL0.StatusCode).GONE, error)) {
            this.abort({
                name: name,
                reason: 'Abort due to unavailable resource',
                attributes: {
                    cause: 'GONE',
                    error: error
                },
                checkForTimeout: false
            });
            return;
        }
        const ignoredErrorName = this._errorNameInIgnoredList(error);
        if (ignoredErrorName) {
            this.abort({
                name: name,
                reason: 'Abort due to an error in ignore list',
                attributes: {
                    cause: ignoredErrorName
                },
                checkForTimeout: false
            });
            return;
        }
        super.stopOnError({
            name: name,
            error: error
        });
    }
}

});
parcelRegister("15mL0", function(module, exports) {

$parcel$export(module.exports, "StatusCode", () => $d52079d97606e8b0$export$f66f92b8741acd5b);
$parcel$export(module.exports, "isAuthError", () => $d52079d97606e8b0$export$cde1786a482f9a1c);
$parcel$export(module.exports, "isErrorStatusCode", () => $d52079d97606e8b0$export$9677d7c364ada66c);
var $d52079d97606e8b0$export$f66f92b8741acd5b = /*#__PURE__*/ function(StatusCode) {
    StatusCode[StatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    StatusCode[StatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    StatusCode[StatusCode["TIMEOUT"] = 408] = "TIMEOUT";
    StatusCode[StatusCode["GONE"] = 410] = "GONE";
    StatusCode[StatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    return StatusCode;
}({});
function $d52079d97606e8b0$export$cde1786a482f9a1c(error) {
    return $d52079d97606e8b0$export$9677d7c364ada66c(401, error) || $d52079d97606e8b0$export$9677d7c364ada66c(403, error);
}
function $d52079d97606e8b0$export$9677d7c364ada66c(statusCode, error) {
    if (!error) return false;
    if (error['status'] === statusCode || error['statusCode'] === statusCode) return true;
    const reg = new RegExp(`status (code)?.*(${statusCode})`);
    return !!error?.message?.match(reg);
}

});


parcelRegister("hnAwz", function(module, exports) {

$parcel$export(module.exports, "isNetworkError", () => $f0235a5352096b37$export$476aa014e2fd89d5);
$parcel$export(module.exports, "computeErrorAttributes", () => $f0235a5352096b37$export$5e7501d1cb9a5aa0);
$parcel$export(module.exports, "computePerformanceAttributes", () => $f0235a5352096b37$export$b978343735080139);

var $hhYjW = parcelRequire("hhYjW");
function $f0235a5352096b37$export$476aa014e2fd89d5(error) {
    return error && !!error.message && // Firefox
    (error.message.includes('NetworkError') || // Chrome
    error.message.startsWith('Failed to fetch') || error.message.includes('GraphQL error: Failed to fetch') || // cancel by users or unknown reason
    error.message.includes('GraphQL error: The operation was aborted') || error.message.includes('GraphQL error: cancelled') || error.message.includes('Abgebrochen') || error.message.includes("\u043E\u0442\u043C\u0435\u043D\u0435\u043D\u043E") || error.message.includes("\u0421\u0435\u0442\u0435\u0432\u043E\u0435 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043F\u043E\u0442\u0435\u0440\u044F\u043D\u043E.") || error.message.includes('anulowane') || error.message.includes("annul\xe9") || error.message.includes("\u5DF2\u53D6\u6D88") || error.message.includes('cancelado') || error.message.includes("\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3057\u305F") || error.message.includes('cancelled') || error.message.includes('Network error') || // GraphQL-wrapping network error
    !!(error['graphQLErrors'] && error['networkError']));
}
function $f0235a5352096b37$export$5e7501d1cb9a5aa0(event) {
    const attributes = {};
    if ($f0235a5352096b37$var$isFailEvent(event)) attributes.failError = event.error;
    if ($f0235a5352096b37$var$isAbortEvent(event)) attributes.abortReason = event.reason;
    return attributes;
}
function $f0235a5352096b37$export$b978343735080139(event) {
    if ($f0235a5352096b37$var$isStopEvent(event)) {
        const duration = event.duration;
        const latencySlo = event.attributes && $f0235a5352096b37$var$hasLatencySLO(event.attributes) && event.attributes['latencySlo'];
        if (typeof duration !== 'number' || typeof latencySlo !== 'number') return {};
        return {
            sloSatisfied: duration <= latencySlo,
            taskDuration: duration,
            latencySlo: latencySlo
        };
    }
    return {};
}
function $f0235a5352096b37$var$isStopEvent(e) {
    return (0, $hhYjW.isStop)(e);
}
function $f0235a5352096b37$var$isFailEvent(e) {
    return e.action === 'taskFail';
}
function $f0235a5352096b37$var$isAbortEvent(e) {
    return e.action === 'taskAbort';
}
function $f0235a5352096b37$var$hasLatencySLO(attributes) {
    return Object(attributes).hasOwnProperty('latencySlo');
}

});
parcelRegister("hhYjW", function(module, exports) {

$parcel$export(module.exports, "isStop", () => $aa0bafdc1aa29e5b$export$16e3f1b03b231b35);
$parcel$export(module.exports, "hasName", () => $aa0bafdc1aa29e5b$export$57069f5b2ecc9128);
const $aa0bafdc1aa29e5b$export$16e3f1b03b231b35 = (event)=>event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail';
const $aa0bafdc1aa29e5b$export$57069f5b2ecc9128 = (event, ...names)=>names.includes(event.name);

});



parcelRegister("bwDHF", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $39c115f9536efeab$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::c3d283871d950ad96ce62ded8c21524b>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen people-teams-ui
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $44uzI = parcelRequire("44uzI");

var $2RmMy = parcelRequire("2RmMy");
const $39c115f9536efeab$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireEvent = (0, $5uXOq.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $2RmMy.default)(...params));
        event.fire((0, $44uzI.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
parcelRegister("44uzI", function(module, exports) {

$parcel$export(module.exports, "EVENT_CHANNEL", () => $ed8690ca9a47d1ea$export$3f072f06b90c3985);

var $dWAZk = parcelRequire("dWAZk");
const $ed8690ca9a47d1ea$export$3f072f06b90c3985 = (0, $dWAZk.FabricChannel).peopleTeams;

});

parcelRegister("2RmMy", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed85a00ce3587d53$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::f6bdf2649443a00944d1014ec7e17d50>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen people-teams-ui
 */ const $ed85a00ce3587d53$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $ed85a00ce3587d53$export$2e2bcd8739ae039 = $ed85a00ce3587d53$var$createEventPayload;

});


parcelRegister("jsDzq", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEventsWithTags", () => $44e55e13c7ee3294$export$e8e0cef07f76dd91);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $44uzI = parcelRequire("44uzI");

var $2RmMy = parcelRequire("2RmMy");
const $44e55e13c7ee3294$export$e8e0cef07f76dd91 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireEventWithTags = (0, $5uXOq.useCallback)((tags, ...params)=>{
        const event = createAnalyticsEvent((0, $2RmMy.default)(...params));
        if (event.payload) event.payload.tags = tags;
        event.fire((0, $44uzI.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEventWithTags: fireEventWithTags
    };
};

});


parcelRegister("1VnzL", function(module, exports) {

$parcel$export(module.exports, "useV3OrgIdStatus", () => $4ffd0c9428c29f08$export$52558c271a487a01);

var $c5gm9 = parcelRequire("c5gm9");
function $4ffd0c9428c29f08$export$52558c271a487a01() {
    const [{ orgId: orgId }] = (0, $c5gm9.useOrg)();
    return {
        orgId: orgId,
        isOrgLoading: !orgId
    };
}

});

parcelRegister("fff3y", function(module, exports) {

$parcel$export(module.exports, "usePrincipalUser", () => $76bb8fd9cfa2a2cd$export$33e3bf16c7530dd4);
$parcel$export(module.exports, "useAvatarUploadedStatus", () => $76bb8fd9cfa2a2cd$export$b26d2c7f264f51a8);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $dmOdc = parcelRequire("dmOdc");
var $l6Kxh = parcelRequire("l6Kxh");
// Private actions:
// It is called by `getPrincipalUserInfo` action
const $76bb8fd9cfa2a2cd$var$getIsSiteAdmin = (cloudId)=>async ({ setState: setState })=>{
        if (!cloudId) {
            setState({
                isSiteAdmin: false
            });
            return;
        }
        let isSiteAdmin = false;
        try {
            isSiteAdmin = await (0, $dmOdc.teamsClient).getIsSiteAdmin(cloudId);
        } catch (e) {
        // do nothing because isSiteAdmin is returned as false
        } finally{
            setState({
                isSiteAdmin: isSiteAdmin
            });
        }
    };
// it is called by `getPrincipalUserInfo` action
const $76bb8fd9cfa2a2cd$var$getMutability = (userId)=>async ({ setState: setState })=>{
        try {
            const data = await (0, $dmOdc.teamsClient).getProfileWithMutability(userId);
            setState({
                mutabilityConstraints: data
            });
        } catch (e) {
        // do nothing because isSiteAdmin is returned as false
        }
    };
const $76bb8fd9cfa2a2cd$var$getAvatarUploadedStatus = (userId)=>async ({ setState: setState })=>{
        try {
            setState({
                avatarUploaded: {
                    isLoading: true,
                    error: undefined,
                    uploaded: undefined
                }
            });
            const data = await (0, $dmOdc.teamsClient).getMyAvatarUploadedStatus(userId);
            setState({
                avatarUploaded: {
                    isLoading: false,
                    uploaded: data.uploaded
                }
            });
        } catch (e) {
            setState({
                avatarUploaded: {
                    isLoading: false,
                    error: e instanceof Error ? e : new Error('Unknown error'),
                    uploaded: undefined
                }
            });
        }
    };
const $76bb8fd9cfa2a2cd$var$actions = {
    /**
	 * Get user information of current logged-in user.
	 * @param cloudId: If Cloud Id is passed, that means People Directory is rendered in a site and we use Cloud Id to check 'isSiteAdmin' info.
	 * If Cloud Id is not passed, `isSiteAdmin` is false by default.
	 */ getPrincipalUserInfo: (cloudId)=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
            // stop fetching when it is already fetched
            if (getState().isFetching || getState().hasLoaded) return;
            setState({
                isFetching: true,
                hasLoaded: false
            });
            try {
                const userBasicData = await (0, $l6Kxh.userInfoProvider).get();
                setState({
                    principalUserId: userBasicData.userId,
                    ...userBasicData
                });
                dispatch($76bb8fd9cfa2a2cd$var$getIsSiteAdmin(cloudId));
                dispatch($76bb8fd9cfa2a2cd$var$getMutability(userBasicData.userId));
                setState({
                    hasLoaded: true
                });
            } catch (e) {
                setState({
                    hasError: true,
                    hasLoaded: false
                });
            } finally{
                setState({
                    isFetching: false
                });
            }
        },
    getAvatarUploadedStatus: $76bb8fd9cfa2a2cd$var$getAvatarUploadedStatus,
    setAvatarUploadedStatus: (uploaded)=>({ setState: setState })=>{
            setState({
                avatarUploaded: {
                    uploaded: uploaded,
                    isLoading: false,
                    isDeleting: false
                }
            });
        },
    deleteUserAvatar: ()=>async ({ getState: getState, dispatch: dispatch, setState: setState })=>{
            try {
                setState({
                    avatarUrl: undefined,
                    avatarUploaded: {
                        isDeleting: true,
                        isLoading: true,
                        error: undefined
                    }
                });
                await (0, $dmOdc.teamsClient).deleteAvatar(getState().principalUserId);
                dispatch($76bb8fd9cfa2a2cd$var$actions.fetchAvatarInfo());
            } catch (e) {
                setState({
                    avatarUploaded: {
                        isLoading: false,
                        isDeleting: false,
                        error: e instanceof Error ? e : new Error('Unknown error')
                    }
                });
            } finally{
                setState({
                    avatarUploaded: {
                        isLoading: false,
                        isDeleting: false
                    }
                });
            }
        },
    fetchAvatarInfo: ()=>async ({ getState: getState, setState: setState })=>{
            const avatarInfo = await (0, $dmOdc.teamsClient).fetchUserAvatarInfo(getState().principalUserId);
            setState({
                avatarUrl: avatarInfo.url,
                avatarUploaded: {
                    uploaded: avatarInfo.uploaded,
                    isLoading: false
                }
            });
        },
    updateUserAvatar: (userId, fileURI)=>async ({ setState: setState })=>{
            setState({
                avatarUrl: undefined,
                avatarUploaded: {
                    isDeleting: false,
                    isLoading: true,
                    isUploading: true,
                    hasUploadedAvatar: false,
                    error: undefined
                }
            });
            try {
                const avatarUrl = await (0, $dmOdc.teamsClient).updateUserAvatar({
                    id: userId,
                    fileURI: fileURI
                });
                setState({
                    avatarUrl: avatarUrl,
                    avatarUploaded: {
                        uploaded: true,
                        isLoading: false,
                        isUploading: false,
                        hasUploadedAvatar: true
                    }
                });
            } catch (error) {
                setState({
                    avatarUploaded: {
                        isLoading: false,
                        isUploading: false,
                        error: error instanceof Error ? error : new Error('Unknown error'),
                        hasUploadedAvatar: undefined
                    }
                });
            }
        },
    setPrincipalUserInfo: (data)=>({ setState: setState })=>{
            setState(data);
        }
};
const $76bb8fd9cfa2a2cd$var$initialState = {
    principalUserId: '',
    avatarUrl: '',
    email: '',
    fullName: '',
    title: '',
    isSiteAdmin: false,
    isFetching: false,
    hasError: false,
    hasLoaded: false,
    avatarUploaded: {
        isLoading: false
    }
};
/**
 * Manage states of a site
 */ const $76bb8fd9cfa2a2cd$var$Store = (0, $iXqE5.createStore)({
    initialState: $76bb8fd9cfa2a2cd$var$initialState,
    actions: $76bb8fd9cfa2a2cd$var$actions,
    name: 'PrincipalUser'
});
const $76bb8fd9cfa2a2cd$export$33e3bf16c7530dd4 = (0, $3sQ5x.createHook)($76bb8fd9cfa2a2cd$var$Store);
const $76bb8fd9cfa2a2cd$export$b26d2c7f264f51a8 = (0, $3sQ5x.createHook)($76bb8fd9cfa2a2cd$var$Store, {
    selector: (state)=>state.avatarUploaded
});

});
parcelRegister("l6Kxh", function(module, exports) {

$parcel$export(module.exports, "userInfoProvider", () => $6f1f375ecfa03356$export$30a852ca4cb27370);

var $aOgFy = parcelRequire("aOgFy");
// Needs to be declared here to avoid blowing up this earlyInit bundle
class $6f1f375ecfa03356$var$FetchError extends Error {
    constructor(response){
        super(`Request failed with status ${response.status}`);
        this.response = response;
        this.name = this.constructor.name;
    }
}
class $6f1f375ecfa03356$export$dc10e400a1189789 {
    get(fetchOp = fetch) {
        if (this.promise) return this.promise;
        const getJson = (url)=>fetchOp(url, {
                method: 'GET',
                mode: 'cors',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then((response)=>{
                if (!response.ok) throw new $6f1f375ecfa03356$var$FetchError(response);
                return response.json();
            });
        this.promise = getJson(`${(0, $aOgFy.DEFAULT_CONFIG).stargateRoot}/me`).then((me)=>{
            return {
                userId: me.account_id,
                locale: me.locale,
                fullName: me.name,
                avatarUrl: me.picture,
                email: me.email,
                title: me.extended_profile?.job_title
            };
        });
        return this.promise;
    }
}
const $6f1f375ecfa03356$export$30a852ca4cb27370 = new $6f1f375ecfa03356$export$dc10e400a1189789();

});



parcelRegister("kxdtg", function(module, exports) {

$parcel$export(module.exports, "default", () => $5508adbbd4a46619$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fyzT1 = parcelRequire("fyzT1");
var $ioKz4 = parcelRequire("ioKz4");

var $yLsiT = parcelRequire("yLsiT");

var $gc5DR = parcelRequire("gc5DR");
const $5508adbbd4a46619$var$AgentProfileRoute = ({ match: match })=>{
    const { agentId: agentId } = match.params;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gc5DR.default), {
                name: (0, $fyzT1.AnalyticsKeys).AGENT_PROFILE_PAGE_VIEW
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ioKz4.default), {
                name: (0, $fyzT1.AnalyticsKeys).AGENT_PROFILE_PAGE_VIEW
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $yLsiT.default), {
                agentId: decodeURIComponent(agentId)
            })
        ]
    });
};
var $5508adbbd4a46619$export$2e2bcd8739ae039 = $5508adbbd4a46619$var$AgentProfileRoute;

});
parcelRegister("ioKz4", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f401b0c783fa617$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fyzT1 = parcelRequire("fyzT1");
var $38ra6 = parcelRequire("38ra6");
const $3f401b0c783fa617$export$430619e48d4c20bb = (props)=>{
    const analytics = (0, $38ra6.default)();
    const { name: name } = props;
    (0, $5uXOq.useEffect)(()=>{
        analytics.pushOperationalEvent({
            source: (0, $fyzT1.AnalyticsEventSource).CLIENT_METRICS,
            actionSubject: name,
            action: (0, $fyzT1.AnalyticsEventActions).MOUNTED
        });
    }, [
        analytics,
        name
    ]);
    return null;
};
var $3f401b0c783fa617$export$2e2bcd8739ae039 = $3f401b0c783fa617$export$430619e48d4c20bb;

});
parcelRegister("38ra6", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc4f8d47e736230d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7vgP9 = parcelRequire("7vgP9");
const $fc4f8d47e736230d$var$useAnalytics = ()=>(0, $5uXOq.useContext)((0, $7vgP9.AnalyticsContext)).analytics;
var $fc4f8d47e736230d$export$2e2bcd8739ae039 = $fc4f8d47e736230d$var$useAnalytics;

});


parcelRegister("yLsiT", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fc2013a5814c03e$export$2e2bcd8739ae039);

var $4qBtX = parcelRequire("4qBtX");

var $9ZX3L = parcelRequire("9ZX3L");

const $9fc2013a5814c03e$var$LazyAgentProfile = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("kSbB7")),
    loading: ()=>null
});
$9fc2013a5814c03e$var$LazyAgentProfile.displayName = 'lazy(AgentProfile)';
var $9fc2013a5814c03e$export$2e2bcd8739ae039 = (0, $9ZX3L.AgentProfilePageComponent);

});
parcelRegister("9ZX3L", function(module, exports) {

$parcel$export(module.exports, "AgentProfilePageComponent", () => $c935d714d2d4e066$export$555f6d88454da0bb);
/* AgentProfilePage.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $414Wj = parcelRequire("414Wj");

var $8S93R = parcelRequire("8S93R");
var $5OOAU = parcelRequire("5OOAU");
var $77Oft = parcelRequire("77Oft");
var $fygPX = parcelRequire("fygPX");

var $eZJjh = parcelRequire("eZJjh");

var $gJlZe = parcelRequire("gJlZe");

var $dkXLT = parcelRequire("dkXLT");
var $jdXUD = parcelRequire("jdXUD");

var $3FH71 = parcelRequire("3FH71");

var $a9Thh = parcelRequire("a9Thh");
var $hI6kz = parcelRequire("hI6kz");
var $kgrc7 = parcelRequire("kgrc7");

var $4BpOs = parcelRequire("4BpOs");
var $7m1xZ = parcelRequire("7m1xZ");
var $aOf1o = parcelRequire("aOf1o");
var $lHKVj = parcelRequire("lHKVj");
var $fff3y = parcelRequire("fff3y");
var $bA8uW = parcelRequire("bA8uW");
var $5WmsO = parcelRequire("5WmsO");

var $7YTpJ = parcelRequire("7YTpJ");

var $8ZB0E = parcelRequire("8ZB0E");

var $3UaSs = parcelRequire("3UaSs");

var $9zycQ = parcelRequire("9zycQ");

var $aKmPs = parcelRequire("aKmPs");

var $eX5cl = parcelRequire("eX5cl");
var $bKeYn = parcelRequire("bKeYn");
var $gujzl = parcelRequire("gujzl");
var $lgzkR = parcelRequire("lgzkR");

var $7zl35 = parcelRequire("7zl35");

var $iegaf = parcelRequire("iegaf");

var $5vaD6 = parcelRequire("5vaD6");

var $6i45Z = parcelRequire("6i45Z");

var $6eD5g = parcelRequire("6eD5g");

var $j9p2O = parcelRequire("j9p2O");

var $l9Oyp = parcelRequire("l9Oyp");

var $i9EPN = parcelRequire("i9EPN");
const $c935d714d2d4e066$var$styles = {
    banner: "_195gukr8 _otyr1jfw",
    avatar: "_otyr1ejb"
};
const $c935d714d2d4e066$var$AGENT_PROFILE_PAGE_LATENCY_TARGET = 1000;
const $c935d714d2d4e066$export$555f6d88454da0bb = (props)=>{
    const { agentId: agentId } = props;
    const [{ cloudId: cloudId }] = (0, $5WmsO.useSite)();
    const [{ agentData: agentData }, { setAgentInfo: setAgentInfo }] = (0, $8ZB0E.useRovoAgentData)();
    const [{ principalUserId: principalUserId }] = (0, $fff3y.usePrincipalUser)();
    const { fireEvent: fireEvent } = (0, $3FH71.usePeopleTeamAnalyticsEvents)();
    const [starCount, setStarCount] = (0, $5uXOq.useState)(0);
    const [isStarred, setIsStarred] = (0, $5uXOq.useState)(false);
    const { setContainerWidth: setContainerWidth } = (0, $kgrc7.useLayoutStoreActions)();
    const assistanceServiceParams = (0, $5uXOq.useMemo)(()=>{
        return {
            experienceId: 'profile-page',
            product: 'rovo',
            siteId: cloudId,
            touchpointSource: 'agent-profile-page'
        };
    }, [
        cloudId
    ]);
    const { data: data, error: error, isFetching: isFetching } = (0, $jdXUD.useAgentDetailsController)({
        agentId: agentId,
        enabled: agentData?.id !== agentId,
        assistanceServiceParams: assistanceServiceParams
    });
    (0, $5uXOq.useEffect)(()=>{
        fireEvent('screen.agentProfile.viewed', {});
    }, [
        fireEvent
    ]);
    (0, $aOf1o.useExpTrackerStart)({
        id: agentId,
        name: (0, $bA8uW.UserExperienceNames).AGENT_PROFILE_PAGE,
        latencySloMs: $c935d714d2d4e066$var$AGENT_PROFILE_PAGE_LATENCY_TARGET
    });
    (0, $lHKVj.useExpTrackerStop)({
        name: (0, $bA8uW.UserExperienceNames).AGENT_PROFILE_PAGE,
        checkShouldAbort: (error)=>{
            if (!(0, $4BpOs.isAuthError)(error)) return;
            return error.message;
        },
        error: error
    });
    const agentIdentityId = (0, $5uXOq.useMemo)(()=>{
        return agentData?.identity_account_id ? (0, $7YTpJ.trimUserARI)(agentData?.identity_account_id) : '';
    }, [
        agentData?.identity_account_id
    ]);
    const isAgentCreatedByCurrentUser = (0, $5uXOq.useMemo)(()=>{
        return agentData?.creator_type === 'CUSTOMER' ? (0, $7YTpJ.trimUserARI)(agentData?.creator || '') === principalUserId : false;
    }, [
        agentData?.creator,
        agentData?.creator_type,
        principalUserId
    ]);
    const { openDialog: openDialog } = (0, $7m1xZ.useDialog)();
    (0, $5uXOq.useEffect)(()=>{
        if (data) {
            setAgentInfo(data);
            setStarCount(data.favourite_count);
            setIsStarred(data.favourite);
        }
    }, [
        data,
        setAgentInfo
    ]);
    const { setFavouriteAgent: setFavouriteAgent, editAgent: editAgent, copyAgent: copyAgent, duplicateAgent: duplicateAgent, deleteAgent: deleteAgent, onChatWithAgent: onChatWithAgent, startConversation: startConversation } = (0, $i9EPN.useAgentActions)({
        agentId: agentData?.id,
        agentIdentityAccountId: agentData?.identity_account_id,
        agentName: agentData?.name,
        assistanceServiceParams: assistanceServiceParams
    });
    const handleOnDeleteAgent = ()=>{
        openDialog((0, $l9Oyp.default), {
            agentName: agentData?.name,
            agentId: agentData?.id,
            onDelete: deleteAgent,
            onClose: ()=>{}
        });
    };
    const isForgeAgent = (0, $5uXOq.useMemo)(()=>agentData?.creator_type === 'THIRD_PARTY' || agentData?.creator_type === 'FORGE', [
        agentData?.creator_type
    ]);
    const handleCopyInstructions = ()=>{
        if (agentData?.system_prompt_template) navigator.clipboard.writeText(agentData?.system_prompt_template.toString());
    };
    if (error) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7zl35.ErrorScreen), {
        error: error
    }, agentId);
    if (isFetching) /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3UaSs.App), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
            size: "medium"
        })
    });
    if (!agentData) return null;
    const handleFavouriteAgent = async ()=>{
        const onSuccessCallBack = ()=>{
            setStarCount(isStarred ? starCount - 1 : starCount + 1);
            setIsStarred(!isStarred);
        };
        setFavouriteAgent(!isStarred, onSuccessCallBack);
    };
    const BodyComponent = (0, $VSDnB.fg)('user-profile-refresh') ? (0, $hI6kz.ProfileContent) : (0, $bKeYn.Body);
    const Aside = (0, $VSDnB.fg)('user-profile-refresh') ? (0, $a9Thh.LeftAside) : (0, $eX5cl.AsideColumn);
    const MaybeResponsiveSection = (0, $VSDnB.fg)('user-profile-refresh') ? (0, $5uXOq.Fragment) : (0, $lgzkR.ResponsiveSection);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aKmPs.default), {
            title: agentData.name,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3UaSs.App), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gJlZe.WidthObserver), {
                        setWidth: setContainerWidth
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                        xcss: $c935d714d2d4e066$var$styles.banner,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5OOAU.AgentBanner), {
                            agentId: agentData.id,
                            agentNamedId: agentData.external_config_reference ?? agentData.named_id,
                            agentIdentityAccountId: agentData.identity_account_id,
                            height: 192
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)(BodyComponent, {
                        children: /*#__PURE__*/ (0, $2OMIu.jsxs)(MaybeResponsiveSection, {
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)(Aside, {
                                    children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
                                        space: "space.300",
                                        children: [
                                            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
                                                space: "space.200",
                                                children: [
                                                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                                                        xcss: $c935d714d2d4e066$var$styles.avatar,
                                                        style: {
                                                            marginTop: '-105px'
                                                        },
                                                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8S93R.AgentAvatar), {
                                                            agentId: agentData.id,
                                                            agentNamedId: agentData.external_config_reference ?? agentData.named_id,
                                                            agentIdentityAccountId: agentData.identity_account_id,
                                                            size: "xxlarge",
                                                            isForgeAgent: agentData.creator_type === 'FORGE' || agentData.creator_type === 'THIRD_PARTY',
                                                            forgeAgentIconUrl: agentData.icon
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $77Oft.AgentProfileInfo), {
                                                        agentName: agentData?.name,
                                                        isStarred: isStarred,
                                                        onStarToggle: ()=>handleFavouriteAgent(),
                                                        creatorRender: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j9p2O.AgentCreator), {
                                                            create_type: agentData.creator_type,
                                                            creator: agentData.creator || undefined
                                                        }),
                                                        starCountRender: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fygPX.AgentStarCount), {
                                                            isLoading: isFetching,
                                                            starCount: starCount
                                                        }),
                                                        agentDescription: agentData.description,
                                                        isHidden: agentData.visibility === 'PRIVATE'
                                                    }),
                                                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6i45Z.AgentActions), {
                                                        agentId: agentData.id,
                                                        isAgentCreatedByUser: isAgentCreatedByCurrentUser,
                                                        onEditAgent: editAgent,
                                                        onCopyAgent: copyAgent,
                                                        onDuplicateAgent: duplicateAgent,
                                                        onDeleteAgent: handleOnDeleteAgent,
                                                        onChatClick: onChatWithAgent,
                                                        isForgeAgent: isForgeAgent,
                                                        assistanceServiceParams: assistanceServiceParams
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5vaD6.AgentAboutPanel), {
                                                agent: agentData,
                                                assistanceServiceParams: assistanceServiceParams
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gujzl.MainColumn), {
                                    children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
                                        space: "space.500",
                                        children: [
                                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6eD5g.AgentConversationStartersSection), {
                                                isAgentDefault: agentData.is_default,
                                                userDefinedConversationStarters: agentData.user_defined_conversation_starters?.map((starter)=>{
                                                    return {
                                                        message: starter,
                                                        type: 'user-defined'
                                                    };
                                                }),
                                                onConversationStarterClick: (conversationStarter)=>{
                                                    startConversation(conversationStarter.message);
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dkXLT.AgentInstructions), {
                                                promptTemplate: agentData.system_prompt_template,
                                                onCopy: handleCopyInstructions,
                                                isForgeAgent: isForgeAgent,
                                                fullHeightText: false
                                            }),
                                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iegaf.default), {
                                                userId: agentIdentityId
                                            }),
                                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9zycQ.default), {
                                                userId: agentIdentityId,
                                                status: agentData.deactivated ? 'inactive' : 'active',
                                                userFullName: agentData.name
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};

});
parcelRegister("8S93R", function(module, exports) {

$parcel$export(module.exports, "AgentAvatar", () => $5b0f0a8770070c77$export$38b71b080e1832c8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $vIiRg = parcelRequire("vIiRg");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $5OOAU = parcelRequire("5OOAU");

var $jidQP = parcelRequire("jidQP");
const $5b0f0a8770070c77$var$styles = {
    agentAvatar: "_1e0c1txw _1bah1h6o _4cvr1h6o _mkrz1k6g",
    image: "_5ral1dfr _4t3i1osq _1bsb1osq",
    avatarContentContainer: "_1bsb1osq _4t3i1osq _1e0c1txw _1bah1h6o _4cvr1h6o"
};
const $5b0f0a8770070c77$var$stylesCompiled = {
    innerShape: "_4t3i1lk2 _1bsb1lk2 _mkrz1k6g"
};
const $5b0f0a8770070c77$export$38b71b080e1832c8 = ({ imageUrl: imageUrl, size: size = 'medium', label: label, name: name, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, agentNamedId: agentNamedId, showBorder: showBorder = true, isForgeAgent: isForgeAgent, forgeAgentIconUrl: forgeAgentIconUrl })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const imgUrl = isForgeAgent && forgeAgentIconUrl ? forgeAgentIconUrl : imageUrl;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        "aria-label": label,
        xcss: $5b0f0a8770070c77$var$styles.agentAvatar,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            height: (0, $vIiRg.AVATAR_SIZES)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            width: (0, $vIiRg.AVATAR_SIZES)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/ensure-design-token-usage
            ...showBorder ? {
                backgroundColor: '#fff'
            } : {},
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...(0, $VSDnB.fg)('rovo_chat_bugfix_agent_avatar_squish') ? {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                minHeight: (0, $vIiRg.AVATAR_SIZES)[size],
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                minWidth: (0, $vIiRg.AVATAR_SIZES)[size]
            } : {}
        },
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $bwpsq.default)([
                $5b0f0a8770070c77$var$stylesCompiled.innerShape
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: $5b0f0a8770070c77$var$styles.avatarContentContainer,
                children: imgUrl ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    as: "img",
                    xcss: $5b0f0a8770070c77$var$styles.image,
                    src: imgUrl,
                    alt: name || label || formatMessage((0, $jidQP.messages).agentAvatarLabel)
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5OOAU.GeneratedAvatar), {
                    agentId: agentId,
                    agentNamedId: agentNamedId,
                    agentIdentityAccountId: agentIdentityAccountId,
                    size: size
                })
            })
        })
    });
};

});
parcelRegister("5OOAU", function(module, exports) {

$parcel$export(module.exports, "AgentBanner", () => $5bf0564183cfbb33$export$6efaefb8ad2fba40);
$parcel$export(module.exports, "GeneratedAvatar", () => $5bf0564183cfbb33$export$96bb253b7de22616);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $vIiRg = parcelRequire("vIiRg");

var $3JT92 = parcelRequire("3JT92");

var $MHKc7 = parcelRequire("MHKc7");
const $5bf0564183cfbb33$var$styles = {
    image: "_5ral1dfr _4t3i1osq _1bsb1osq _1e0c1txw _1bah1h6o _4cvr1h6o",
    banner: "_1bsb1osq",
    bannerFillSpace: "_1bsb1osq _4t3i1osq _5ral1dfr"
};

const $5bf0564183cfbb33$var$AutoDevAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("ebYDx")));

const $5bf0564183cfbb33$var$AutoFixAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("clsL1")));

const $5bf0564183cfbb33$var$AutoReviewAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("enJSB")));

const $5bf0564183cfbb33$var$BacklogBuddyAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("8s2sN")));

const $5bf0564183cfbb33$var$CommsCrafterAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("aSceX")));

const $5bf0564183cfbb33$var$CultureAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("dum6h")));

const $5bf0564183cfbb33$var$CustomerInsightAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("goAX7")));

const $5bf0564183cfbb33$var$DecisionDirectorAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("16FPl")));

const $5bf0564183cfbb33$var$FeatureFlagAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("7tf3M")));

const $5bf0564183cfbb33$var$GenericAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("eVT5O")));

const $5bf0564183cfbb33$var$HireWriterAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("2pXsj")));

const $5bf0564183cfbb33$var$MarketingMessageMaestroAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("ihdBU")));

const $5bf0564183cfbb33$var$MyUserManualAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("lKGQJ")));

const $5bf0564183cfbb33$var$OkrOracleAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("77a7o")));

const $5bf0564183cfbb33$var$OpsAgentAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("7whAK")));

const $5bf0564183cfbb33$var$PitchPerfectorAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("knS67")));

const $5bf0564183cfbb33$var$ProductRequirementAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("fptBL")));

const $5bf0564183cfbb33$var$ReleaseNotesAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("cCJHu")));

const $5bf0564183cfbb33$var$ResearchScoutAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("gCGxk")));

const $5bf0564183cfbb33$var$SocialMediaScribeAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("2yuUw")));

const $5bf0564183cfbb33$var$TeamConnectionAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("jtfXW")));

const $5bf0564183cfbb33$var$WorkflowBuilderAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("C11fi")));
const $5bf0564183cfbb33$export$cf7c9ad03f4a70b2 = {
    primary: '#FCA700',
    secondary: '#FFC716'
};
const $5bf0564183cfbb33$export$3e344798f7855e62 = {
    primary: '#BF63F3',
    secondary: '#D8A0F7'
};
const $5bf0564183cfbb33$export$a3d0897f023251ae = {
    primary: '#82B536',
    secondary: '#B3DF72'
};
const $5bf0564183cfbb33$export$d933daaf7b69e6ee = {
    primary: '#357DE8',
    secondary: '#669DF1'
};
const $5bf0564183cfbb33$var$colorList = [
    $5bf0564183cfbb33$export$cf7c9ad03f4a70b2,
    $5bf0564183cfbb33$export$3e344798f7855e62,
    $5bf0564183cfbb33$export$a3d0897f023251ae,
    $5bf0564183cfbb33$export$d933daaf7b69e6ee
];
const $5bf0564183cfbb33$var$avatarList = [
    $5bf0564183cfbb33$var$CustomerInsightAvatar,
    $5bf0564183cfbb33$var$BacklogBuddyAvatar,
    $5bf0564183cfbb33$var$DecisionDirectorAvatar,
    $5bf0564183cfbb33$var$CommsCrafterAvatar,
    $5bf0564183cfbb33$var$AutoDevAvatar,
    $5bf0564183cfbb33$var$OkrOracleAvatar,
    $5bf0564183cfbb33$var$CultureAvatar,
    $5bf0564183cfbb33$var$SocialMediaScribeAvatar,
    $5bf0564183cfbb33$var$TeamConnectionAvatar,
    $5bf0564183cfbb33$var$HireWriterAvatar,
    $5bf0564183cfbb33$var$OpsAgentAvatar,
    $5bf0564183cfbb33$var$ResearchScoutAvatar,
    $5bf0564183cfbb33$var$ReleaseNotesAvatar,
    $5bf0564183cfbb33$var$MyUserManualAvatar,
    $5bf0564183cfbb33$var$PitchPerfectorAvatar,
    $5bf0564183cfbb33$var$AutoDevAvatar,
    $5bf0564183cfbb33$var$AutoFixAvatar,
    $5bf0564183cfbb33$var$AutoReviewAvatar,
    $5bf0564183cfbb33$var$MarketingMessageMaestroAvatar,
    $5bf0564183cfbb33$var$FeatureFlagAvatar,
    $5bf0564183cfbb33$var$ProductRequirementAvatar
];
const $5bf0564183cfbb33$export$a834793a4d0d739e = $5bf0564183cfbb33$var$avatarList.length * $5bf0564183cfbb33$var$colorList.length;
const $5bf0564183cfbb33$var$outOfTheBoxAgentAvatar = {
    autodev_template_unit_test_creator: {
        getRender: (size)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5bf0564183cfbb33$var$AutoFixAvatar, {
                size: (0, $vIiRg.AVATAR_SIZES)[size],
                primaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.primary,
                secondaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.secondary
            }),
        color: $5bf0564183cfbb33$export$a3d0897f023251ae
    },
    autodev_template_migration_config_changer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5bf0564183cfbb33$var$OpsAgentAvatar, {
                size: (0, $vIiRg.AVATAR_SIZES)[size],
                primaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.primary,
                secondaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.secondary
            }),
        color: $5bf0564183cfbb33$export$a3d0897f023251ae
    },
    autodev_template_vulnerable_dependency_updater_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5bf0564183cfbb33$var$MarketingMessageMaestroAvatar, {
                size: (0, $vIiRg.AVATAR_SIZES)[size],
                primaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.primary,
                secondaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.secondary
            }),
        color: $5bf0564183cfbb33$export$a3d0897f023251ae
    },
    autodev_template_code_standardizer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5bf0564183cfbb33$var$MyUserManualAvatar, {
                size: (0, $vIiRg.AVATAR_SIZES)[size],
                primaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.primary,
                secondaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.secondary
            }),
        color: $5bf0564183cfbb33$export$a3d0897f023251ae
    },
    autodev_template_code_observer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5bf0564183cfbb33$var$ResearchScoutAvatar, {
                size: (0, $vIiRg.AVATAR_SIZES)[size],
                primaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.primary,
                secondaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.secondary
            }),
        color: $5bf0564183cfbb33$export$a3d0897f023251ae
    },
    autodev_template_code_accessibility_checker_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5bf0564183cfbb33$var$HireWriterAvatar, {
                size: (0, $vIiRg.AVATAR_SIZES)[size],
                primaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.primary,
                secondaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.secondary
            }),
        color: $5bf0564183cfbb33$export$a3d0897f023251ae
    },
    autodev_code_documentation_writer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5bf0564183cfbb33$var$SocialMediaScribeAvatar, {
                size: (0, $vIiRg.AVATAR_SIZES)[size],
                primaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.primary,
                secondaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.secondary
            }),
        color: $5bf0564183cfbb33$export$a3d0897f023251ae
    },
    autodev_feature_flag_cleaner_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5bf0564183cfbb33$var$FeatureFlagAvatar, {
                size: (0, $vIiRg.AVATAR_SIZES)[size],
                primaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.primary,
                secondaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.secondary
            }),
        color: $5bf0564183cfbb33$export$a3d0897f023251ae
    },
    decision_director_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5bf0564183cfbb33$var$DecisionDirectorAvatar, {
                size: (0, $vIiRg.AVATAR_SIZES)[size],
                primaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.primary,
                secondaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.secondary
            }),
        color: $5bf0564183cfbb33$export$a3d0897f023251ae
    },
    user_manual_writer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5bf0564183cfbb33$var$MyUserManualAvatar, {
                size: (0, $vIiRg.AVATAR_SIZES)[size],
                primaryColor: $5bf0564183cfbb33$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $5bf0564183cfbb33$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $5bf0564183cfbb33$export$cf7c9ad03f4a70b2
    },
    product_requirements_expert_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5bf0564183cfbb33$var$ProductRequirementAvatar, {
                size: (0, $vIiRg.AVATAR_SIZES)[size],
                primaryColor: $5bf0564183cfbb33$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $5bf0564183cfbb33$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $5bf0564183cfbb33$export$cf7c9ad03f4a70b2
    },
    issue_organizer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5bf0564183cfbb33$var$BacklogBuddyAvatar, {
                size: (0, $vIiRg.AVATAR_SIZES)[size],
                primaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.primary,
                secondaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.secondary
            }),
        color: $5bf0564183cfbb33$export$a3d0897f023251ae
    },
    ops_guide_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5bf0564183cfbb33$var$OpsAgentAvatar, {
                size: (0, $vIiRg.AVATAR_SIZES)[size],
                primaryColor: $5bf0564183cfbb33$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $5bf0564183cfbb33$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $5bf0564183cfbb33$export$cf7c9ad03f4a70b2
    },
    jira_workflow_wizard_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5bf0564183cfbb33$var$WorkflowBuilderAvatar, {
                size: (0, $vIiRg.AVATAR_SIZES)[size],
                primaryColor: $5bf0564183cfbb33$export$d933daaf7b69e6ee.primary,
                secondaryColor: $5bf0564183cfbb33$export$d933daaf7b69e6ee.secondary
            }),
        color: $5bf0564183cfbb33$export$d933daaf7b69e6ee
    },
    itops_rca_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5bf0564183cfbb33$var$AutoReviewAvatar, {
                size: (0, $vIiRg.AVATAR_SIZES)[size],
                primaryColor: $5bf0564183cfbb33$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $5bf0564183cfbb33$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $5bf0564183cfbb33$export$cf7c9ad03f4a70b2
    }
};
const $5bf0564183cfbb33$export$c84eb7708138dd4 = ({ agentIdentityAccountId: agentIdentityAccountId, agentId: agentId })=>{
    // we prioritise agentIdentityAccountId first if it is available
    // this is because agentIdentityAccountId is more widely available (e.g. in ProfilePage)
    const idForAgentAvatar = agentIdentityAccountId || agentId;
    if (idForAgentAvatar) {
        // Take the last 8 characters of the id because JS can't handle 16 digit numbers
        const trimmedId = idForAgentAvatar.slice(-8).replace(/[-:]/g, '');
        const parsedId = parseInt(trimmedId, 16);
        if (isNaN(parsedId)) return 0;
        else return parsedId;
    }
    return null;
};
const $5bf0564183cfbb33$var$getAvatarRender = ({ agentNamedId: agentNamedId, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, size: size })=>{
    if (typeof agentNamedId === 'string' && $5bf0564183cfbb33$var$outOfTheBoxAgentAvatar[agentNamedId]) {
        const ootbAvatarResult = $5bf0564183cfbb33$var$outOfTheBoxAgentAvatar[agentNamedId];
        return {
            render: ootbAvatarResult.getRender(size),
            color: ootbAvatarResult.color
        };
    }
    const numberId = $5bf0564183cfbb33$export$c84eb7708138dd4({
        agentIdentityAccountId: agentIdentityAccountId,
        agentId: agentId
    });
    if (numberId !== null) {
        /**
     * this create all possible combinations of avatars and colors
     * e.g. [[avatar1, color1], [avatar1, color2], [avatar2, color1], [avatar2, color2]]
     * then choose 1 based on agentId
     */ const totalCombinations = $5bf0564183cfbb33$var$avatarList.length * $5bf0564183cfbb33$var$colorList.length;
        const combinationIndex = numberId % totalCombinations;
        const avatarIndex = Math.floor(combinationIndex / $5bf0564183cfbb33$var$colorList.length);
        const colorIndex = combinationIndex % $5bf0564183cfbb33$var$colorList.length;
        const Avatar = $5bf0564183cfbb33$var$avatarList[avatarIndex];
        const color = $5bf0564183cfbb33$var$colorList[colorIndex];
        return {
            render: /*#__PURE__*/ (0, $2OMIu.jsx)(Avatar, {
                size: (0, $vIiRg.AVATAR_SIZES)[size],
                primaryColor: color.primary,
                secondaryColor: color.secondary
            }),
            color: color
        };
    }
    return {
        render: /*#__PURE__*/ (0, $2OMIu.jsx)($5bf0564183cfbb33$var$GenericAvatar, {
            size: (0, $vIiRg.AVATAR_SIZES)[size],
            primaryColor: $5bf0564183cfbb33$export$d933daaf7b69e6ee.primary,
            secondaryColor: $5bf0564183cfbb33$export$d933daaf7b69e6ee.secondary
        }),
        color: $5bf0564183cfbb33$export$d933daaf7b69e6ee
    };
};
const $5bf0564183cfbb33$export$6efaefb8ad2fba40 = ({ agentNamedId: agentNamedId, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, height: height, fillSpace: fillSpace })=>{
    const { color: color } = $5bf0564183cfbb33$var$getAvatarRender({
        agentNamedId: agentNamedId,
        agentId: agentId,
        agentIdentityAccountId: agentIdentityAccountId,
        size: 'medium'
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($5bf0564183cfbb33$var$styles.banner, fillSpace ? $5bf0564183cfbb33$var$styles.bannerFillSpace : undefined),
        style: {
            backgroundColor: color.primary,
            height: height ? `${height}px` : undefined
        }
    });
};
const $5bf0564183cfbb33$export$96bb253b7de22616 = (props)=>{
    const { render: render, color: color } = $5bf0564183cfbb33$var$getAvatarRender(props);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $5bf0564183cfbb33$var$styles.image,
        style: {
            backgroundColor: color.primary
        },
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
            fallback: null,
            children: render
        })
    });
};

});
parcelRegister("ebYDx", function(module, exports) {

let $a55120f20eb3e0d6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a55120f20eb3e0d6$var$load("4JN0P").then(()=>parcelRequire('lOwq3'));

});

parcelRegister("clsL1", function(module, exports) {

let $8fcdc0d5ae9bddd0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8fcdc0d5ae9bddd0$var$load("b8In5").then(()=>parcelRequire('k9HyI'));

});

parcelRegister("enJSB", function(module, exports) {

let $a786cd68520d8a3c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a786cd68520d8a3c$var$load("i8Qu6").then(()=>parcelRequire('7r7QW'));

});

parcelRegister("8s2sN", function(module, exports) {

let $6272d9765c9f3a93$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6272d9765c9f3a93$var$load("eC7og").then(()=>parcelRequire('27sCb'));

});

parcelRegister("aSceX", function(module, exports) {

let $7ea87135783687cd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7ea87135783687cd$var$load("82aZO").then(()=>parcelRequire('k9RFh'));

});

parcelRegister("dum6h", function(module, exports) {

let $9d1f38615a9f22ec$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9d1f38615a9f22ec$var$load("lUywR").then(()=>parcelRequire('dB6SD'));

});

parcelRegister("goAX7", function(module, exports) {

let $befb8d42592673b0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $befb8d42592673b0$var$load("23G1j").then(()=>parcelRequire('kbU5P'));

});

parcelRegister("16FPl", function(module, exports) {

let $0ce6cbfd6d41ba25$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0ce6cbfd6d41ba25$var$load("bpkjs").then(()=>parcelRequire('4Ta6A'));

});

parcelRegister("7tf3M", function(module, exports) {

let $5706ec743eb724b9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5706ec743eb724b9$var$load("2HEXN").then(()=>parcelRequire('cT52Z'));

});

parcelRegister("eVT5O", function(module, exports) {

let $adf11fce8cf998a2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $adf11fce8cf998a2$var$load("59PjM").then(()=>parcelRequire('fvSGg'));

});

parcelRegister("2pXsj", function(module, exports) {

let $1c2c0936443ab303$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1c2c0936443ab303$var$load("euRWW").then(()=>parcelRequire('kOgKS'));

});

parcelRegister("ihdBU", function(module, exports) {

let $d4e45f475472e4ad$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d4e45f475472e4ad$var$load("6eqHi").then(()=>parcelRequire('gDfXS'));

});

parcelRegister("lKGQJ", function(module, exports) {

let $fd5f21dc295d6893$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fd5f21dc295d6893$var$load("kGHPZ").then(()=>parcelRequire('6fzX4'));

});

parcelRegister("77a7o", function(module, exports) {

let $52e109191ca7d73c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $52e109191ca7d73c$var$load("aA6PQ").then(()=>parcelRequire('1sn78'));

});

parcelRegister("7whAK", function(module, exports) {

let $0169b23da7e0493e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0169b23da7e0493e$var$load("ceOJB").then(()=>parcelRequire('ljkz0'));

});

parcelRegister("knS67", function(module, exports) {

let $ed6feb4a918e14cd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ed6feb4a918e14cd$var$load("b2aMO").then(()=>parcelRequire('djrSm'));

});

parcelRegister("fptBL", function(module, exports) {

let $b3802859eb3e77d5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b3802859eb3e77d5$var$load("28cGJ").then(()=>parcelRequire('W7C9N'));

});

parcelRegister("cCJHu", function(module, exports) {

let $930c7bd3006500b2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $930c7bd3006500b2$var$load("jqsqq").then(()=>parcelRequire('3pZFQ'));

});

parcelRegister("gCGxk", function(module, exports) {

let $c1a130d266d7d789$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c1a130d266d7d789$var$load("5lxo7").then(()=>parcelRequire('icyRb'));

});

parcelRegister("2yuUw", function(module, exports) {

let $1dc6bbefa2989483$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1dc6bbefa2989483$var$load("3kEuJ").then(()=>parcelRequire('f4CgX'));

});

parcelRegister("jtfXW", function(module, exports) {

let $e2cd1c3b12b28ad9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e2cd1c3b12b28ad9$var$load("cPRyg").then(()=>parcelRequire('l3PeX'));

});

parcelRegister("C11fi", function(module, exports) {

let $07245718597b6e42$var$load = (parcelRequire("28QjX"))(4);
module.exports = $07245718597b6e42$var$load("835xx").then(()=>parcelRequire('7vi3o'));

});


parcelRegister("jidQP", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0b07736d81cebc8d$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $0b07736d81cebc8d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    agentAvatarLabel: {
        id: 'ai-mate.agent-avatar-label',
        defaultMessage: 'Agent avatar',
        description: 'Accessible label for agent avatar img'
    }
});

});


parcelRegister("77Oft", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCreator", () => $180d99d4c1dac440$export$f35b2eeaa7e3db15);
$parcel$export(module.exports, "AgentProfileInfo", () => $180d99d4c1dac440$export$e02348ba0b01a210);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $l1N8i = parcelRequire("l1N8i");

var $e4yMr = parcelRequire("e4yMr");

var $2pMF0 = parcelRequire("2pMF0");
var $hqZzc = parcelRequire("hqZzc");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
var $414Wj = parcelRequire("414Wj");

var $1DVhQ = parcelRequire("1DVhQ");

var $3bDjY = parcelRequire("3bDjY");

var $f18hZ = parcelRequire("f18hZ");

var $kDYSZ = parcelRequire("kDYSZ");

var $fITvF = parcelRequire("fITvF");
const $180d99d4c1dac440$var$styles = {
    clickableItem: "_zulp1b66 _1e0c1txw _4cvr1h6o",
    name: "_1bah1yb4 _4cvr1y6m",
    description: "_19pkze3t _otyru2gc",
    wrapper: "_otyru2gc",
    tooltipWrapper: "_195gu2gc _1e0c116y _kqswh2mm _94n5v77o",
    headingWrapper: "_kqswh2mm"
};
const $180d99d4c1dac440$export$f35b2eeaa7e3db15 = ({ creator: creator, onCreatorLinkClick: onCreatorLinkClick, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const getCreatorRender = ()=>{
        if (isLoading) return formatMessage((0, $fITvF.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
                testId: "agent-profile-creator-skeleton",
                isShimmering: true,
                height: 18,
                width: 100,
                borderRadius: 3
            })
        });
        if (!creator) return null;
        if (creator.type === 'SYSTEM' || creator.type === 'OOTB') return formatMessage((0, $fITvF.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                alignBlock: "center",
                testId: "atlassian-icon",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2pMF0.AtlassianIcon), {
                        size: "small",
                        appearance: "brand"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                        children: "Atlassian"
                    })
                ]
            })
        });
        if (creator.type === 'CUSTOMER') return formatMessage((0, $fITvF.messages).agentCreatedBy, {
            creatorNameWithLink: (0, $VSDnB.fg)('dst-a11y__replace-anchor-with-link__ai-mate') ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $e4yMr.default), {
                "aria-label": creator.name || formatMessage((0, $fITvF.messages).creatorLabel),
                href: creator.profileLink,
                onClick: ()=>onCreatorLinkClick(),
                target: "_blank",
                children: [
                    creator.name,
                    ' ',
                    creator.status === 'inactive' && formatMessage((0, $fITvF.messages).agentDeactivated)
                ]
            }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
            /*#__PURE__*/ (0, $2OMIu.jsxs)("a", {
                "aria-label": creator.name || formatMessage((0, $fITvF.messages).creatorLabel),
                href: creator.profileLink,
                onClick: ()=>onCreatorLinkClick(),
                target: "_blank",
                children: [
                    creator.name,
                    ' ',
                    creator.status === 'inactive' && formatMessage((0, $fITvF.messages).agentDeactivated)
                ]
            })
        });
        if (creator.type === 'THIRD_PARTY') return formatMessage((0, $fITvF.messages).agentCreatedBy, {
            creatorNameWithLink: creator.name
        });
        return null;
    };
    const creatorRender = getCreatorRender();
    return creatorRender ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $MHKc7.default), {
        xcss: $180d99d4c1dac440$var$styles.clickableItem,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hqZzc.RovoIcon), {
                appearance: "brand",
                size: "small"
            }),
            creatorRender
        ]
    }) : null;
};
const $180d99d4c1dac440$export$e02348ba0b01a210 = ({ agentName: agentName, agentDescription: agentDescription, creatorRender: creatorRender, starCountRender: starCountRender, isStarred: isStarred, isHidden: isHidden, onStarToggle: onStarToggle })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
        space: "space.100",
        xcss: $180d99d4c1dac440$var$styles.wrapper,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                xcss: $180d99d4c1dac440$var$styles.name,
                space: "space.100",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                        xcss: $180d99d4c1dac440$var$styles.headingWrapper,
                        alignBlock: "end",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                                as: "h2",
                                size: "xlarge",
                                children: agentName
                            }),
                            isHidden && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                                xcss: $180d99d4c1dac440$var$styles.tooltipWrapper,
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                                    content: formatMessage((0, $fITvF.messages).hiddenTooltip),
                                    position: "top",
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f18hZ.HiddenIcon), {
                                        label: formatMessage((0, $fITvF.messages).hiddenIcon)
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kDYSZ.StarIconButton), {
                        isStarred: isStarred,
                        handleToggle: onStarToggle
                    })
                ]
            }),
            creatorRender,
            !!agentDescription && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: $180d99d4c1dac440$var$styles.description,
                as: "p",
                children: agentDescription
            }),
            starCountRender
        ]
    });
};

});
parcelRegister("hqZzc", function(module, exports) {

$parcel$export(module.exports, "RovoIcon", () => $1a00d6c2ebe03e6f$export$e23ae35269442b4f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $hxoiH = parcelRequire("hxoiH");

var $lEsIP = parcelRequire("lEsIP");

var $6PPEt = parcelRequire("6PPEt");

var $iVs6J = parcelRequire("iVs6J");
const $1a00d6c2ebe03e6f$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $6PPEt.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">
    <g fill="${colors.iconColor}" fill-rule="evenodd">
      <path d="M17.06 4.246a2.79 2.79 0 0 0-2.736-.026l-.049.033-.002.001c-.605.35-1.048.91-1.256 1.558-.085.268-.13.552-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566a2.77 2.77 0 0 0 1.392-2.407v-9.487c0-.991-.532-1.912-1.392-2.408z"/>
      <path d="m6.058 9 6.176-3.566a3.7 3.7 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155l4.604 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.851.47-1.89.461-2.735-.026L6.06 23.301a2.78 2.78 0 0 1-1.392-2.408v-9.486c0-.996.529-1.912 1.391-2.408z"/>
    </g>
  </svg>`;
};
const $1a00d6c2ebe03e6f$export$e23ae35269442b4f = ({ appearance: appearance, label: label = 'Rovo', size: size = (0, $lEsIP.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $lEsIP.defaultLogoParams).textColor, iconColor: iconColor = (0, $lEsIP.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iVs6J.default), {
        appearance: appearance,
        svg: $1a00d6c2ebe03e6f$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("f18hZ", function(module, exports) {

$parcel$export(module.exports, "HiddenIcon", () => $33a2f5af6a5e0c92$export$bce21421c351deb1);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6C81H = parcelRequire("6C81H");
const $33a2f5af6a5e0c92$export$bce21421c351deb1 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6C81H))), {
        ...props
    });

});
parcelRegister("6C81H", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c90f995a462686dc43276b76786a54f3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $013e232b862e20a6$var$_react = $013e232b862e20a6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $013e232b862e20a6$var$_baseNew = $013e232b862e20a6$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $013e232b862e20a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpenStrikethrough".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Intended uses: unwatch page in Confluence, hide password in text field, and unfollow in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $013e232b862e20a6$var$EyeOpenStrikethroughIcon = (props)=>/*#__PURE__*/ $013e232b862e20a6$var$_react.default.createElement($013e232b862e20a6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m.47 1.53 14 14 1.06-1.06-14-14zm8.74 10.86 1.24 1.24A8.5 8.5 0 0 1 8 14C4.43 14 1.32 11.77.17 8.62c-.15-.4-.15-.84 0-1.24a8 8 0 0 1 1.51-2.53l1.06 1.06a6.5 6.5 0 0 0-1.16 1.98.3.3 0 0 0 0 .21c.93 2.56 3.48 4.4 6.42 4.4q.62 0 1.21-.11M8 2a8.5 8.5 0 0 0-2.45.36L6.79 3.6q.59-.1 1.21-.1c2.94 0 5.49 1.85 6.42 4.4a.3.3 0 0 1 0 .21 6.5 6.5 0 0 1-1.16 1.98l1.06 1.06a8 8 0 0 0 1.51-2.53c.15-.4.15-.84 0-1.24C14.68 4.23 11.57 2 8 2"/>`
    }, props));
$013e232b862e20a6$var$EyeOpenStrikethroughIcon.displayName = 'EyeOpenStrikethroughIcon';
var $013e232b862e20a6$var$_default = module.exports.default = $013e232b862e20a6$var$EyeOpenStrikethroughIcon;

});


parcelRegister("kDYSZ", function(module, exports) {

$parcel$export(module.exports, "StarIconButton", () => $ca4e80d09e432419$export$703abb8bd2abdfa5);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $3JT92 = parcelRequire("3JT92");

var $5IcUR = parcelRequire("5IcUR");

var $7piTm = parcelRequire("7piTm");

var $3Lty3 = parcelRequire("3Lty3");

var $6cbg1 = parcelRequire("6cbg1");
const $ca4e80d09e432419$var$styles = {
    pressableStarIcon: "_bfhk18uv _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _4t3i1tcg _1bsb1tcg",
    hidden: "_tzy4idpf"
};
const $ca4e80d09e432419$export$703abb8bd2abdfa5 = ({ isStarred: isStarred, handleToggle: handleToggle, visible: visible = true })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
        xcss: (0, $3JT92.cx)($ca4e80d09e432419$var$styles.pressableStarIcon, !visible && $ca4e80d09e432419$var$styles.hidden),
        onClick: handleToggle,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        children: isStarred || isHovered ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5IcUR))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, $6cbg1.default).removeFromFavouritesLabel),
            color: "var(--ds-icon-accent-orange, #E56910)"
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7piTm))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, $6cbg1.default).clickToFavouriteLabel),
            color: "var(--ds-icon, #44546F)"
        })
    });
};

});
parcelRegister("5IcUR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3b98083f7180ee5a6483375174c0842e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $428b14ab8e8af837$var$_react = $428b14ab8e8af837$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $428b14ab8e8af837$var$_starStarred = $428b14ab8e8af837$var$_interopRequireDefault((parcelRequire("dm1qi")));

var $428b14ab8e8af837$var$_starFilled = $428b14ab8e8af837$var$_interopRequireDefault((parcelRequire("bH1hf")));
function $428b14ab8e8af837$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StarStarredIcon.
 * This component is StarStarredIcon, with `UNSAFE_fallbackIcon` set to "StarFilledIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $428b14ab8e8af837$var$StarStarredIcon = (props)=>/*#__PURE__*/ $428b14ab8e8af837$var$_react.default.createElement($428b14ab8e8af837$var$_starStarred.default, Object.assign({
        LEGACY_fallbackIcon: $428b14ab8e8af837$var$_starFilled.default
    }, props));
$428b14ab8e8af837$var$StarStarredIcon.Name = 'StarStarredIconMigration';
var $428b14ab8e8af837$var$_default = module.exports.default = $428b14ab8e8af837$var$StarStarredIcon;

});

parcelRegister("7piTm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::981bc152c9d73fe857301cf222775bab>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $564985c3728d4aa2$var$_react = $564985c3728d4aa2$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $564985c3728d4aa2$var$_starUnstarred = $564985c3728d4aa2$var$_interopRequireDefault((parcelRequire("dAf5R")));

var $564985c3728d4aa2$var$_star = $564985c3728d4aa2$var$_interopRequireDefault((parcelRequire("5oTeF")));
function $564985c3728d4aa2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StarUnstarredIcon.
 * This component is StarUnstarredIcon, with `UNSAFE_fallbackIcon` set to "StarIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starring or favoriting objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $564985c3728d4aa2$var$StarUnstarredIcon = (props)=>/*#__PURE__*/ $564985c3728d4aa2$var$_react.default.createElement($564985c3728d4aa2$var$_starUnstarred.default, Object.assign({
        LEGACY_fallbackIcon: $564985c3728d4aa2$var$_star.default
    }, props));
$564985c3728d4aa2$var$StarUnstarredIcon.Name = 'StarUnstarredIconMigration';
var $564985c3728d4aa2$var$_default = module.exports.default = $564985c3728d4aa2$var$StarUnstarredIcon;

});

parcelRegister("6cbg1", function(module, exports) {

$parcel$export(module.exports, "default", () => $3eaaeba7b25cecb8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3eaaeba7b25cecb8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    removeFromFavouritesLabel: {
        id: 'rovo-chat.browse-agents.remove-from-favourites-label',
        defaultMessage: 'Remove from favourites',
        description: 'Remove from favourites label'
    },
    clickToFavouriteLabel: {
        id: 'rovo-chat.browse-agents.click-to-favourite-label',
        defaultMessage: 'Not favourited, click to favourite',
        description: 'Click to favourite agent label'
    }
});

});


parcelRegister("fITvF", function(module, exports) {

$parcel$export(module.exports, "messages", () => $836da4b3f18cbcda$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $836da4b3f18cbcda$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    agentCreatedBy: {
        id: 'ai-mate.agent-profile-info.created-by',
        defaultMessage: 'Rovo Agent by {creatorNameWithLink}',
        description: 'Message to show who created this Rovo agent'
    },
    agentDeactivated: {
        id: 'ai-mate.agent-profile-info.deactivated',
        defaultMessage: '(deactivated)',
        description: 'Message to show that this agent is deactivated'
    },
    starredCount: {
        id: 'ai-mate.agent-profile-info.starred-count',
        defaultMessage: '{count} starred',
        description: 'Message to show how many times this agent has been starred by users'
    },
    hiddenIcon: {
        id: 'ai-mate.agent-profile-info.hidden-icon',
        defaultMessage: 'Hidden',
        description: 'Icon to show that this agent is hidden'
    },
    hiddenTooltip: {
        id: 'ai-mate.agent-profile-info.hidden-tooltip',
        defaultMessage: "Agent won't show in search results",
        description: 'Tooltip to explain what strikethough eye icon means'
    },
    starAgentTooltip: {
        id: 'ai-mate.agent-profile-info.star-agent-tooltip',
        defaultMessage: 'Star Agent',
        description: 'Tooltip to explain what star icon does'
    },
    creatorLabel: {
        id: 'ai-mate.agent-profile-info.creator',
        defaultMessage: 'Creator',
        description: 'Accessible label for creator link'
    }
});

});


parcelRegister("fygPX", function(module, exports) {

$parcel$export(module.exports, "AgentStarCount", () => $82bf86c773cd27a9$export$65f8fe094f79ae2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $l8fTj = parcelRequire("l8fTj");

var $MHKc7 = parcelRequire("MHKc7");

var $1DVhQ = parcelRequire("1DVhQ");

var $3aPFe = parcelRequire("3aPFe");

var $6cFwt = parcelRequire("6cFwt");
const $82bf86c773cd27a9$var$styles = {
    count: "_11c81o8v _zulp1b66 _1e0c1txw _4cvr1h6o _bozgv77o"
};
const $82bf86c773cd27a9$export$65f8fe094f79ae2 = ({ starCount: starCount, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if ((starCount === null || starCount === undefined) && !isLoading) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $MHKc7.default), {
        xcss: $82bf86c773cd27a9$var$styles.count,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l8fTj))), {
                LEGACY_margin: `0 ${"var(--ds-space-negative-025, -2px)"}`,
                color: "currentColor",
                label: "",
                LEGACY_size: "small"
            }),
            isLoading ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
                testId: "agent-profile-info-star-count-skeleton",
                isShimmering: true,
                height: 16,
                width: 75,
                borderRadius: 3
            }) : formatMessage((0, $3aPFe.messages).starredCount, {
                starCount: (0, $6cFwt.formatNumber)(starCount ?? 0)
            })
        ]
    });
};

});
parcelRegister("l8fTj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a16470c3bb291b102b1f88d7113da531>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f626abf9a5007502$var$_react = $f626abf9a5007502$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f626abf9a5007502$var$_starUnstarred = $f626abf9a5007502$var$_interopRequireDefault((parcelRequire("1Cvrw")));

var $f626abf9a5007502$var$_star = $f626abf9a5007502$var$_interopRequireDefault((parcelRequire("5oTeF")));
function $f626abf9a5007502$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StarUnstarredIcon.
 * This component is StarUnstarredIcon, with `UNSAFE_fallbackIcon` set to "StarIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for starring or favoriting objects as a secondary/tertiary action.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f626abf9a5007502$var$StarUnstarredIcon = (props)=>/*#__PURE__*/ $f626abf9a5007502$var$_react.default.createElement($f626abf9a5007502$var$_starUnstarred.default, Object.assign({
        LEGACY_fallbackIcon: $f626abf9a5007502$var$_star.default
    }, props));
$f626abf9a5007502$var$StarUnstarredIcon.Name = 'StarUnstarredIconMigration';
var $f626abf9a5007502$var$_default = module.exports.default = $f626abf9a5007502$var$StarUnstarredIcon;

});

parcelRegister("3aPFe", function(module, exports) {

$parcel$export(module.exports, "messages", () => $056b41d8fa6dcf86$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $056b41d8fa6dcf86$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    starredCount: {
        id: 'ai-mate.agent-profile-info.starred-count',
        defaultMessage: '{starCount} {starCount, plural, one {user} other {users}}',
        description: 'Text showing the number of times an agent has been favourited or starred'
    }
});

});

parcelRegister("6cFwt", function(module, exports) {

$parcel$export(module.exports, "formatNumber", () => $60c3ed960e6d0ab5$export$f5dd818bff069720);
/* Example usage
formatNumber(4100); // Output: "4.1k"
formatNumber(1234567); // Output: "1.2M"
formatNumber(9876543210); // Output: "9.9B"
formatNumber(500); // Output: "500"
*/ const $60c3ed960e6d0ab5$export$f5dd818bff069720 = (inputNumber)=>{
    if (inputNumber >= 1e9) return (inputNumber / 1e9).toFixed(1) + 'B';
    else if (inputNumber >= 1e6) return (inputNumber / 1e6).toFixed(1) + 'M';
    else if (inputNumber >= 1e3) return (inputNumber / 1e3).toFixed(1) + 'k';
    else return inputNumber.toString();
};

});


parcelRegister("dkXLT", function(module, exports) {

$parcel$export(module.exports, "AgentInstructions", () => $6bbfe7c969c0249d$export$48d253a044b54931);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $3JT92 = parcelRequire("3JT92");

var $8w53e = parcelRequire("8w53e");

var $a3mGm = parcelRequire("a3mGm");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
var $3Lty3 = parcelRequire("3Lty3");
var $414Wj = parcelRequire("414Wj");
var $dS3PR = parcelRequire("dS3PR");

var $3bDjY = parcelRequire("3bDjY");

var $3Ykta = parcelRequire("3Ykta");
const $6bbfe7c969c0249d$var$styles = {
    copyButton: "_2rkosqtm _1bsbzwfg _4t3izwfg _bfhk11bn _irr312j4",
    fullSizeText: "_c71l1osq _18m91wug",
    instructionsContainer: "_2rkoiti9 _16jlkb7n _1o9zkb7n _i0dlf1ug _189ee4h9 _1dqonqa1 _1h6d1elr _o5726vc6 _kqswh2mm _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
    smallText: "_c71l1kdj _18m915zi",
    hidden: "_tzy4idpf",
    heading: "_1e0c1txw",
    forgeAgentWrapper: "_2rkoiti9 _16qszucj _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
};
const $6bbfe7c969c0249d$var$stylesCompiled = {
    copyContainer: "_kqswstnw _154i19bv _1xi219bv"
};
const $6bbfe7c969c0249d$export$48d253a044b54931 = ({ promptTemplate: promptTemplate, onCopy: onCopy, isForgeAgent: isForgeAgent, fullHeightText: fullHeightText = true })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [instructionsHovered, setInstructionsHovered] = (0, $5uXOq.useState)(false);
    const getInstructionsRender = ()=>{
        if (isForgeAgent) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
            xcss: $6bbfe7c969c0249d$var$styles.forgeAgentWrapper,
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3mGm))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: ""
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
                    space: "space.100",
                    alignBlock: "start",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                            weight: "bold",
                            children: formatMessage((0, $3Ykta.default).privateInstructionsTitle)
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                            size: "small",
                            children: formatMessage((0, $3Ykta.default).privateInstructionsDescription)
                        })
                    ]
                })
            ]
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            xcss: (0, $3JT92.cx)($6bbfe7c969c0249d$var$styles.instructionsContainer, fullHeightText ? $6bbfe7c969c0249d$var$styles.fullSizeText : $6bbfe7c969c0249d$var$styles.smallText),
            onMouseEnter: ()=>{
                setInstructionsHovered(true);
            },
            onMouseLeave: ()=>{
                setInstructionsHovered(false);
            },
            children: promptTemplate ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                        children: promptTemplate
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            $6bbfe7c969c0249d$var$stylesCompiled.copyContainer,
                            !instructionsHovered && $6bbfe7c969c0249d$var$styles.hidden
                        ]),
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                            content: formatMessage((0, $3Ykta.default).copyInstructionsTooltip),
                            position: "top",
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
                                "aria-label": formatMessage((0, $3Ykta.default).copyInstructionsTooltip),
                                xcss: $6bbfe7c969c0249d$var$styles.copyButton,
                                onBlur: ()=>setInstructionsHovered(false),
                                onFocus: ()=>setInstructionsHovered(true),
                                onClick: ()=>onCopy(promptTemplate),
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8w53e))), {
                                    color: "var(--ds-icon)",
                                    label: ""
                                })
                            })
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                as: "em",
                color: "color.text.subtle",
                children: formatMessage((0, $3Ykta.default).noInstructionPlaceholder)
            })
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $414Wj.default), {
        space: "space.100",
        grow: "fill",
        alignBlock: "start",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    as: "h2",
                    xcss: $6bbfe7c969c0249d$var$styles.heading,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                        size: "large",
                        color: "color.text.subtle",
                        weight: "semibold",
                        children: formatMessage((0, $3Ykta.default).instructionsLabel)
                    })
                }),
                getInstructionsRender()
            ]
        })
    });
};

});
parcelRegister("8w53e", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cbd1068d7fb082440154244857d12f2c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $63353af41c1756be$var$_react = $63353af41c1756be$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $63353af41c1756be$var$_baseNew = $63353af41c1756be$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $63353af41c1756be$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $63353af41c1756be$var$CopyIcon = (props)=>/*#__PURE__*/ $63353af41c1756be$var$_react.default.createElement($63353af41c1756be$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM16 6v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75V6z" clip-rule="evenodd"/>`
    }, props));
$63353af41c1756be$var$CopyIcon.displayName = 'CopyIcon';
var $63353af41c1756be$var$_default = module.exports.default = $63353af41c1756be$var$CopyIcon;

});

parcelRegister("a3mGm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::766864a6ad12ee0b57d7ed41e0a75cca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $751bc76853fe58bc$var$_react = $751bc76853fe58bc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $751bc76853fe58bc$var$_lockLocked = $751bc76853fe58bc$var$_interopRequireDefault((parcelRequire("bwyQI")));

var $751bc76853fe58bc$var$_lock = $751bc76853fe58bc$var$_interopRequireDefault((parcelRequire("3G2gB")));
function $751bc76853fe58bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LockLockedIcon.
 * This component is LockLockedIcon, with `UNSAFE_fallbackIcon` set to "LockIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $751bc76853fe58bc$var$LockLockedIcon = (props)=>/*#__PURE__*/ $751bc76853fe58bc$var$_react.default.createElement($751bc76853fe58bc$var$_lockLocked.default, Object.assign({
        LEGACY_fallbackIcon: $751bc76853fe58bc$var$_lock.default
    }, props));
$751bc76853fe58bc$var$LockLockedIcon.Name = 'LockLockedIconMigration';
var $751bc76853fe58bc$var$_default = module.exports.default = $751bc76853fe58bc$var$LockLockedIcon;

});
parcelRegister("bwyQI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::86c9de42fef4ccbc35a6164a0094138a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $863db7350f859785$var$_react = $863db7350f859785$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $863db7350f859785$var$_baseNew = $863db7350f859785$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $863db7350f859785$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $863db7350f859785$var$LockLockedIcon = (props)=>/*#__PURE__*/ $863db7350f859785$var$_react.default.createElement($863db7350f859785$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$863db7350f859785$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $863db7350f859785$var$_default = module.exports.default = $863db7350f859785$var$LockLockedIcon;

});

parcelRegister("3G2gB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ad70d7fd26028c0$var$_react = $2ad70d7fd26028c0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $2ad70d7fd26028c0$var$_lockLocked = $2ad70d7fd26028c0$var$_interopRequireDefault((parcelRequire("bwyQI")));
function $2ad70d7fd26028c0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2ad70d7fd26028c0$var$LockIcon = (props)=>/*#__PURE__*/ $2ad70d7fd26028c0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M16 11V9h-2V7.002A2 2 0 0 0 12 5c-1.102 0-2 .898-2 2.002V9H8v2H7v8h10v-8zm-2 0h-4V9h4zM8 9V7.002A4.004 4.004 0 0 1 12 3a4 4 0 0 1 4 4.002V9h.994A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01C5 9.899 5.897 9 7.006 9zm0 0h2v2H8zm6 0h2v2h-2z"/><circle cx="12" cy="15" r="2"/></g></svg>`
    }, props, {
        newIcon: $2ad70d7fd26028c0$var$_lockLocked.default
    }));
$2ad70d7fd26028c0$var$LockIcon.displayName = 'LockIcon';
var $2ad70d7fd26028c0$var$_default = module.exports.default = $2ad70d7fd26028c0$var$LockIcon;

});


parcelRegister("3Ykta", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6ec93ea0e5e84df$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b6ec93ea0e5e84df$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    instructionsLabel: {
        id: 'rovo-chat.view-agent.instructions-label',
        defaultMessage: 'Instructions',
        description: 'Label for instructions'
    },
    copyInstructionsLabel: {
        id: 'rovo-chat.view-agent.copy-instructions-label',
        defaultMessage: 'Copy',
        description: 'Label for copy instructions button'
    },
    copyInstructionsTooltip: {
        id: 'rovo-chat.view-agent.copy-instructions-tooltip',
        defaultMessage: 'Copy instructions',
        description: 'Label for copy instructions tooltip'
    },
    noInstructionPlaceholder: {
        id: 'rovo-chat.view-agent.no-instruction-placeholder',
        defaultMessage: 'This Agent has no custom instructions',
        description: 'Placeholder for no instructions'
    },
    privateInstructionsTitle: {
        id: 'rovo-chat.view-agent.hidden-instructions-title',
        defaultMessage: 'These instructions are private',
        description: 'Title of the instructions section, this is displayed when instructions are purposely hidden'
    },
    privateInstructionsDescription: {
        id: 'rovo-chat.view-agent.hidden-instructions-description',
        defaultMessage: 'Forge Agents built with code have their instructions hidden for privacy.',
        description: 'Description of the instructions section, this is displayed when instructions are purposely hidden'
    }
});

});


parcelRegister("jdXUD", function(module, exports) {

$parcel$export(module.exports, "useAgentDetailsController", () => $31fd280abbc83947$export$e65200649bbc56ce);
$parcel$export(module.exports, "useAgentDetailsByIdentityAccountId", () => $31fd280abbc83947$export$7d1c308c0d5404ad);

var $91cKc = parcelRequire("91cKc");

var $cK3Jm = parcelRequire("cK3Jm");
var $4ojTZ = parcelRequire("4ojTZ");
const $31fd280abbc83947$export$e65200649bbc56ce = (0, $cK3Jm.createHookWithAssistanceService)(({ agentId: agentId, enabled: enabled = true, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker } })=>{
    const queryResult = (0, $4ojTZ.useQuery)({
        queryKey: [
            'fetchAgentDetails',
            agentId
        ],
        queryFn: ()=>{
            experienceTracker.start({
                id: (0, $91cKc.ExperienceName).FETCH_AGENT_BY_AGENT_ID,
                name: (0, $91cKc.ExperienceName).FETCH_AGENT_BY_AGENT_ID
            });
            return assistanceService.getAgentDetails(agentId);
        },
        onSuccess: ()=>{
            experienceTracker.succeed({
                name: (0, $91cKc.ExperienceName).FETCH_AGENT_BY_AGENT_ID
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $91cKc.ExperienceName).FETCH_AGENT_BY_AGENT_ID,
                error: error
            });
        },
        enabled: enabled
    });
    return queryResult;
});
const $31fd280abbc83947$export$7d1c308c0d5404ad = (0, $cK3Jm.createHookWithAssistanceService)(({ identityAccountId: identityAccountId, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker }, enabled: enabled = true })=>{
    const queryResult = (0, $4ojTZ.useQuery)({
        queryKey: [
            'fetchAgentDetails',
            identityAccountId
        ],
        queryFn: ()=>{
            experienceTracker.start({
                id: (0, $91cKc.ExperienceName).FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID,
                name: (0, $91cKc.ExperienceName).FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID
            });
            return assistanceService.getAgentDetailsByIdentityAccountId(identityAccountId);
        },
        onSuccess: ()=>{
            experienceTracker.succeed({
                name: (0, $91cKc.ExperienceName).FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $91cKc.ExperienceName).FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID,
                error: error
            });
        },
        enabled: enabled
    });
    return queryResult;
});

});
parcelRegister("91cKc", function(module, exports) {

$parcel$export(module.exports, "ExperienceName", () => $8cf0ed4e0647d0d1$export$b881bd9f00ed8ed1);
const $8cf0ed4e0647d0d1$export$b881bd9f00ed8ed1 = {
    LOAD_PANEL: 'aiMateLoadPanel',
    LOAD_BROWSE_AGENTS: 'aiMateLoadBrowseAgents',
    LOAD_CREATE_AGENT: 'aiMateLoadCreateAgent',
    FETCH_CHAT: 'aiMateFetchChat',
    FETCH_AGENTS: 'aiMateFetchAgents',
    FETCH_AGENT_BY_AGENT_ID: 'aiMateFetchAgentByAgentId',
    FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID: 'aiMateFetchAgentByIdentityAccountId',
    CREATE_AGENT: 'aiMateCreateAgent',
    UPDATE_AGENT: 'aiMateUpdateAgent',
    DELETE_AGENT: 'aiMateDeleteAgent',
    FAVOURITE_AGENT: 'aiMateFavouriteAgent',
    UNFAVOURITE_AGENT: 'aiMateUnfavouriteAgent',
    CLEAR_CHAT: 'aiMateClearChat',
    SEND_MESSAGE: 'aiMateSendMessage',
    ABORT_AGENT_STREAM: 'aiMateAbortAgentStream',
    GET_CONVERSATION_CHANNELS: 'aiMateGetConversationChannels',
    UPDATE_CONVERSATION_CHANNEL: 'aiMateUpdateConversationChannel',
    CREATE_SEEDED_CONVERSATION_CHANNEL: 'aiMateCreateSeededConversationChannel',
    PUBSUB_LISTENER: 'aiMatePubSubListener',
    FETCH_AGENT_TENANT_DATA: 'aiMateFetchAgentTenantData',
    RESOLVE_CONVERSATION_ACTION: 'aiMateResolveConversationAction',
    MESSAGE_RENDERER: 'aiMateMessageRenderer',
    FETCH_CONTEXTUAL_STARTERS: 'aiMateFetchContextualStarters',
    GENERATE_CONVERSATION_STARTERS: 'aiMateGenerateConversationStarters',
    FETCH_AGENT_TEAM_DATA: 'aiMateFetchAgentTeamData',
    FETCH_CONNECTED_KNOWLEDGE_SOURCES: 'aiMateFetchConnectedKnowledgeSources',
    FETCH_AGENT_ACTIONS: 'aiMateFetchAgentActions',
    CHANGE_AGENT_OWNER: 'aiMateChangeAgentOwner',
    GET_AGENT_PERMISSIONS: 'aiMateGetAgentPermissions',
    SEND_MESSAGE_NL_AGENT: 'aiMateSendMessageNLAgent',
    GET_RECOMMENDED_AGENTS: 'aiMateGetRecommendedAgents',
    UPLOAD_FILES_TO_CONVERSATION: 'aiMateUploadFilesToConversation',
    VALIDATE_FILES: 'aiMateValidateFiles',
    GET_CONVERSATION_FILES: 'aiMateGetConversationFiles',
    CSM_WIDGET_RENDER: 'csmWidgetRender',
    CSM_AGENT_IDENTITY_NAME: 'csmAgentIdentityName',
    CSM_AGENT_IDENTITY_COMPANY: 'csmAgentIdentityCompany',
    CSM_AGENT_IDENTITY_TONE: 'csmAgentIdentityTone',
    CSM_AGENT_IDENTITY_GREETING_MESSAGE: 'csmAgentIdentityGreetingMessage'
};

});

parcelRegister("cK3Jm", function(module, exports) {

$parcel$export(module.exports, "AssistanceServiceBase", () => $23f77fef74bdf9a2$export$40a7802808e2fbe3);
$parcel$export(module.exports, "AssistanceServiceImpl", () => $23f77fef74bdf9a2$export$a522c5f4ccda1c94);
$parcel$export(module.exports, "AssistanceServiceProvider", () => $23f77fef74bdf9a2$export$8fe647eb935c33db);
$parcel$export(module.exports, "useAssistanceService", () => $23f77fef74bdf9a2$export$7e31a1844ebbaf85);
$parcel$export(module.exports, "createHookWithAssistanceService", () => $23f77fef74bdf9a2$export$5a9ea20fc196ec62);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $VSDnB = parcelRequire("VSDnB");

var $cSxED = parcelRequire("cSxED");

var $7qdbi = parcelRequire("7qdbi");

var $cNqSS = parcelRequire("cNqSS");

var $4c7JV = parcelRequire("4c7JV");

var $lb2g6 = parcelRequire("lb2g6");

var $khfvG = parcelRequire("khfvG");

var $3zcGU = parcelRequire("3zcGU");

var $f7UWp = parcelRequire("f7UWp");
const $23f77fef74bdf9a2$var$PRODUCT_HEADER = 'x-product';
const $23f77fef74bdf9a2$var$EXPERIENCE_ID_HEADER = 'x-experience-id';
class $23f77fef74bdf9a2$export$40a7802808e2fbe3 {
    constructor(props){
        this.getConfig = ()=>{
            return {
                ...this.config
            };
        };
        const defaultBaseUrl = '/gateway/api/assist';
        const defaultConfig = {
            baseUrl: defaultBaseUrl,
            headers: {}
        };
        this.config = {
            ...props,
            baseUrl: props.baseUrl || defaultConfig.baseUrl,
            credentials: props.credentials,
            headers: {
                ...props.headers || defaultConfig.headers
            }
        };
    }
    createHeaders(init) {
        return new Headers({
            [$23f77fef74bdf9a2$var$PRODUCT_HEADER]: this.config.product,
            [$23f77fef74bdf9a2$var$EXPERIENCE_ID_HEADER]: this.config.experienceId,
            ...this.config.headers || {},
            ...init || {}
        });
    }
    async fetch({ path: path, options: options }) {
        const { baseUrl: configBaseUrl, credentials: configCredentials } = this.config;
        const baseUrl = configBaseUrl;
        const requestUrl = (0, $lb2g6.addPath)(baseUrl, path);
        const response = await (0, $f7UWp.fetchFn)(requestUrl, {
            credentials: configCredentials,
            ...options
        });
        return (0, $lb2g6.processResponse)({
            response: response
        });
    }
    async fetchJson(options) {
        const response = await this.fetch(options);
        const json = await response.json();
        return json;
    }
    async fetchStream(options) {
        const response = await this.fetch(options);
        return {
            responseData: {
                traceId: (0, $lb2g6.getTraceIdFromResponse)(response)
            },
            generator: (0, $cNqSS.readJsonStream)(response)
        };
    }
}
class $23f77fef74bdf9a2$export$a522c5f4ccda1c94 extends $23f77fef74bdf9a2$export$40a7802808e2fbe3 {
    constructor(props){
        super(props), this.getAgentActions = async ()=>{
            const response = await this.fetchJson({
                path: '/rovo/v1/agents/configuration/actions',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                }
            });
            return response.actions;
        }, this.getAgentKnowledgeConfiguration = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agents/configuration/knowledge',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                }
            });
        }, this.getAgentPermissions = (agentId, payload)=>{
            return this.fetchJson({
                path: `/rovo/v2/permissions/agents/${agentId}`,
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'content-type': 'application/json;charset=UTF-8'
                    }),
                    body: JSON.stringify(payload)
                }
            });
        }, this.getRecommendedAgents = ({ limit: limit, query: query })=>{
            return this.fetchJson({
                path: `/rovo/v1/agents/recommend/v2?limit=${limit}&query=${query}`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                }
            });
        }, this.getConversationDebugLogs = async (conversationId)=>{
            const response = await this.fetchJson({
                path: `/rovo/v1/chat/conversation/${conversationId}/debug-logs`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                }
            });
            return response.items;
        }, this.validateFiles = async (payload)=>{
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            return this.fetchJson({
                path: `/rovo/v1/chat/message/file/validate`,
                options: {
                    method: 'POST',
                    headers: headers,
                    body: JSON.stringify(payload)
                }
            });
        }, this.uploadFiles = async (payload)=>{
            const formData = new FormData();
            for (const file of payload.files)formData.append('files', file);
            const response = await this.fetchJson({
                path: `/rovo/v1/chat/message/file`,
                options: {
                    method: 'POST',
                    headers: this.createHeaders(),
                    body: formData
                }
            });
            return response;
        }, this.agentPlaygroundSendMessage = (payload)=>{
            return this.fetchStream({
                path: '/rovo/v1/agent-playground/chat/stream',
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'content-type': 'application/json;charset=UTF-8'
                    }),
                    body: JSON.stringify({
                        latest_user_message: payload.message,
                        agent_id: payload.agentId,
                        conversation_id: payload.conversationId,
                        content_mime_type: 'text/adf',
                        workflow_configuration: payload.workflowConfiguration,
                        additional_context: {
                            file_attachment_ids: payload.additionalContext?.fileIds
                        }
                    })
                }
            });
        }, this.agentPlaygroundGetConversations = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/chat/conversations',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                }
            });
        }, this.agentPlaygroundGetTools = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/tools',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                }
            });
        };
    }
    async sendMessageStream({ agentNamedId: agentNamedId, agentId: agentId, message: message, conversationId: conversationId, controller: controller, storeMessage: storeMessage = false, citationsEnabled: citationsEnabled = true, jiraWorkflowContext: jiraWorkflowContext, editorContext: editorContext, browserContext: browserContext, additionalContext: additionalContext, fileIds: fileIds, webSearchEnabled: webSearchEnabled, deepResearchEnabled: deepResearchEnabled }) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        // If browserContext received and context is undefined, assume we're unable to retrieve the context of the page in focus
        const url = browserContext ? browserContext.context?.browserUrl : window?.location?.href;
        const body = {
            content: message,
            context: {
                browser_url: url,
                webSearchEnabled: webSearchEnabled,
                deepResearchEnabled: deepResearchEnabled,
                ...editorContext ? {
                    editor: editorContext
                } : {},
                // If browserUrl is inaccessable, fallback to htmlBody or canvasText if they exist
                ...browserContext ? {
                    browser: {
                        htmlBody: browserContext.context?.htmlBody,
                        canvasText: browserContext.context?.canvasText
                    }
                } : {},
                ...(0, $VSDnB.fg)('enable_jira_workflow_wizard_agent_in_wf_editor') ? {
                    jiraWorkflowContext: jiraWorkflowContext
                } : {},
                ...additionalContext,
                fileIds: fileIds
            },
            recipient_agent_named_id: agentNamedId,
            agent_id: agentId,
            mimeType: typeof message === 'string' ? 'text/markdown' : 'text/adf',
            // don't allow store message if feature flag is off
            store_message: (0, $VSDnB.fg)('ai_mate_show_store_messages') ? storeMessage : false,
            citations_enabled: citationsEnabled
        };
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
            signal: controller?.signal
        };
        return this.fetchStream({
            path: `/rovo/v1/chat/conversation/${conversationId}/message/stream`,
            options: options
        });
    }
    async nlCreateAgentStream({ controller: controller, latest_user_message: latest_user_message, draft_agent: draft_agent, conversation_history: conversation_history }) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const body = {
            latest_user_message: latest_user_message,
            draft_agent: draft_agent,
            conversation_history: conversation_history
        };
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
            signal: controller?.signal
        };
        return this.fetchStream({
            path: `/rovo/v1/agents/nlcreate`,
            options: options
        });
    }
    async getChat(conversationId) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers
        };
        const rawChat = await this.fetchJson({
            path: `/rovo/v1/chat/conversation/${conversationId}/messages`,
            options: options
        });
        const chatArray = rawChat.items;
        return chatArray.map((message)=>// Must be converted into StreamResponse
            (0, $4c7JV.isHumanMessage)(message) ? message : (0, $3zcGU.toStreamResponse)(message));
    }
    async deleteChat(conversationId, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        await this.fetch({
            path: `/rovo/v1/chat/conversation/${conversationId}`,
            options: options
        });
    }
    async getAgents(controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        const response = await this.fetchJson({
            path: '/rovo/v1/agents',
            options: options
        });
        return response.items;
    }
    async getAgentDetails(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `/rovo/v1/agents/${id}`,
            options: options
        });
    }
    async getAgentDetailsByIdentityAccountId(identityAccountId, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `/rovo/v1/agents/accountid/${identityAccountId}`,
            options: options
        });
    }
    async createAgent(payload, controller) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload),
            signal: controller?.signal
        };
        return this.fetchJson({
            path: '/rovo/v1/agents',
            options: options
        });
    }
    async updateAgent(id, payload, controller) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'PUT',
            headers: headers,
            body: JSON.stringify(payload),
            signal: controller?.signal
        };
        const response = await this.fetchJson({
            path: `/rovo/v1/agents/${id}`,
            options: options
        });
        return response;
    }
    async deleteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `/rovo/v1/agents/${id}`,
            options: options
        });
    }
    async favouriteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'POST',
            headers: headers,
            signal: controller?.signal
        };
        this.fetch({
            path: `/rovo/v1/agents/${id}/favourite`,
            options: options
        });
    }
    async unfavouriteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        this.fetch({
            path: `/rovo/v1/agents/${id}/favourite`,
            options: options
        });
    }
    async createConversationChannel(options) {
        return this.fetchJson({
            path: `/rovo/v1/chat/conversation`,
            options: {
                method: 'POST',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                }),
                body: JSON.stringify({
                    name: options?.name ?? (0, $khfvG.generateConversationName)(),
                    dialogues: options?.dialogues ?? undefined
                })
            }
        });
    }
    async getConversationChannels() {
        // Clean up `ConversationChannel[] | { items: ConversationChannel[] }` when fg('rovo_convo_ai_migration') is removed
        const result = await this.fetchJson({
            path: `/rovo/v1/chat/conversations`,
            options: {
                method: 'GET',
                headers: this.createHeaders()
            }
        });
        return result.items;
    }
    updateConversationChannel(id, payload) {
        return this.fetchJson({
            path: `/rovo/v1/chat/conversation/${id}`,
            options: {
                method: 'PUT',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                }),
                body: JSON.stringify(payload)
            }
        });
    }
    async resolveConversationAction(id, payload) {
        return this.fetchJson({
            path: `/rovo/v1/chat/conversation/${id}/action`,
            options: {
                method: 'POST',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                }),
                body: JSON.stringify({
                    ...payload,
                    context: {
                        ...payload.context,
                        browser_url: window.location.href
                    }
                })
            }
        });
    }
    // REST starters, newer API
    async generateAgentStarters(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/rovo/v1/conversation-starters/agent-starter-suggestion',
            options: options
        });
    }
    // REST conversation starters, newer API
    async generateContextualStarters(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/rovo/v1/conversation-starters/page-contextual',
            options: options
        });
    }
}
const $23f77fef74bdf9a2$var$AssistanceServiceContext = /*#__PURE__*/ (0, $5uXOq.createContext)(new $23f77fef74bdf9a2$export$a522c5f4ccda1c94({
    baseUrl: '',
    product: '',
    experienceId: ''
}));
const $23f77fef74bdf9a2$export$8fe647eb935c33db = ({ value: value, children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)($23f77fef74bdf9a2$var$AssistanceServiceContext.Provider, {
        value: value,
        children: children
    });
const $23f77fef74bdf9a2$export$7e31a1844ebbaf85 = (props)=>{
    (0, $gKZoD.di)((0, $5uXOq.useContext), $23f77fef74bdf9a2$export$a522c5f4ccda1c94);
    const service = (0, $5uXOq.useContext)($23f77fef74bdf9a2$var$AssistanceServiceContext);
    (0, $7qdbi.setRovoChatProduct)(props?.product ?? service.getConfig().product);
    if (!props || !props.experienceId && !props.product && !props.headers) return service;
    const product = props.product ?? service.getConfig().product;
    const experienceId = props.experienceId ?? service.getConfig().experienceId;
    const headers = props.headers ?? service.getConfig().headers;
    return new $23f77fef74bdf9a2$export$a522c5f4ccda1c94({
        ...service.getConfig(),
        product: product,
        experienceId: experienceId,
        headers: headers
    });
};
const $23f77fef74bdf9a2$export$5a9ea20fc196ec62 = (originalHook)=>{
    return (props)=>{
        (0, $gKZoD.di)($23f77fef74bdf9a2$export$a522c5f4ccda1c94, (0, $cSxED.useAIMateExperienceTracker));
        const { assistanceServiceParams: assistanceServiceParams, ...restProps } = props;
        const experienceTracker = (0, $cSxED.useAIMateExperienceTracker)({
            touchpointSource: assistanceServiceParams.touchpointSource
        });
        const headers = (0, $5uXOq.useMemo)(()=>{
            return {
                'x-cloudid': props.assistanceServiceParams.siteId,
                ...props.assistanceServiceParams.headers
            };
        }, [
            props.assistanceServiceParams.siteId,
            props.assistanceServiceParams.headers
        ]);
        const assistanceService = (0, $5uXOq.useMemo)(()=>{
            return new $23f77fef74bdf9a2$export$a522c5f4ccda1c94({
                product: assistanceServiceParams.product,
                experienceId: assistanceServiceParams.experienceId,
                headers: headers,
                baseUrl: assistanceServiceParams.baseUrl
            });
        }, [
            assistanceServiceParams.baseUrl,
            assistanceServiceParams.experienceId,
            assistanceServiceParams.product,
            headers
        ]);
        const result = originalHook({
            ...restProps,
            assistanceServiceInjectedParams: {
                ...assistanceServiceParams,
                headers: headers,
                experienceTracker: experienceTracker,
                assistanceService: assistanceService
            }
        });
        return result;
    };
};

});
parcelRegister("cSxED", function(module, exports) {

$parcel$export(module.exports, "useAIMateExperienceTracker", () => $0ff262dad5216a84$export$412c53791574f6f0);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $ha42n = parcelRequire("ha42n");

var $jXUCh = parcelRequire("jXUCh");

var $3kN8f = parcelRequire("3kN8f");

var $jSnf2 = parcelRequire("jSnf2");
const $0ff262dad5216a84$var$isRovoInstrumentedError = (error)=>error && typeof error === 'object' && 'errorAttributes' in error && typeof error.errorAttributes === 'object';
class $0ff262dad5216a84$var$ExperienceTrackerHandler {
    constructor(){
        this.experienceTracker = new (0, $ha42n.ExperienceTracker)();
        this.sendAnalyticsEvent = null;
        this.experienceTracker.subscribe((event)=>{
            // for FailEvent
            if ('error' in event) {
                // do not fail experience tracking if the error is a client fetch error
                if ((0, $jXUCh.isClientFetchError)(event.error)) return;
                let filteredErrorAttributes = {};
                if (event.attributes && (0, $VSDnB.fg)('rovo_chat_analytics_attributes_dr_ws')) {
                    const { webSearchEnabled: webSearchEnabled, deepResearchEnabled: deepResearchEnabled } = event.attributes;
                    if (webSearchEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        webSearchEnabled: webSearchEnabled
                    };
                    if (deepResearchEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        deepResearchEnabled: deepResearchEnabled
                    };
                }
                if ($0ff262dad5216a84$var$isRovoInstrumentedError(event.error)) {
                    const errorAttributes = event.error.errorAttributes;
                    // Remove undefined properties
                    filteredErrorAttributes = Object.fromEntries(Object.entries(errorAttributes).filter(([_, value])=>value !== undefined));
                    // Filter 5xx errors since backend monitoring will cover this
                    // as per https://hello.atlassian.net/wiki/spaces/CONVAI/pages/3547354267/Meeting+notes+FE+SLOs+which+one+to+promote
                    if (errorAttributes?.statusCode && errorAttributes?.statusCode >= 500) return;
                }
                const error = event.error instanceof Error ? event.error : new Error(JSON.stringify(event.error));
                // this is added by `useExperienceTracker` below
                const touchpointSource = event.attributes?.touchpointSource;
                (0, $3kN8f.logException)({
                    exception: error,
                    name: event.name,
                    tags: {
                        source: 'aiMateExperienceTracker',
                        ...filteredErrorAttributes,
                        ...touchpointSource && {
                            touchpointSource: touchpointSource
                        }
                    }
                });
            }
            this.sendAnalyticsEvent?.({
                eventType: 'operational',
                action: event.action,
                actionSubject: 'ui',
                attributes: {
                    task: event.name,
                    taskId: event.id,
                    startTime: event.startTime,
                    ...event.attributes
                }
            }, {
                removeDefaultTags: true
            });
        });
    }
    setSendAnalyticsEvent(sendAnalyticsEvent) {
        this.sendAnalyticsEvent = sendAnalyticsEvent;
    }
    static getInstance() {
        if (!$0ff262dad5216a84$var$ExperienceTrackerHandler.instance) $0ff262dad5216a84$var$ExperienceTrackerHandler.instance = new $0ff262dad5216a84$var$ExperienceTrackerHandler();
        return $0ff262dad5216a84$var$ExperienceTrackerHandler.instance;
    }
}
const $0ff262dad5216a84$export$412c53791574f6f0 = (params)=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $jSnf2.useAnalytics)();
    (0, $5uXOq.useMemo)(()=>{
        const experienceTracker = $0ff262dad5216a84$var$ExperienceTrackerHandler.getInstance();
        // this is not ideal, okay just because `sendAnalyticsEvent` is never change
        // since every hook instance will override the singleton sendAnalyticsEvent
        experienceTracker.setSendAnalyticsEvent(sendAnalyticsEvent);
    }, [
        sendAnalyticsEvent
    ]);
    const experienceTrackerProxy = (0, $5uXOq.useMemo)(()=>{
        const proxyHandler = {
            get: (target, prop)=>{
                // Overriding the fail method to add touchpointSource to the attributes
                if (prop === 'fail') return (failParams)=>{
                    target.fail({
                        ...failParams,
                        attributes: {
                            ...failParams.attributes,
                            touchpointSource: params?.touchpointSource
                        }
                    });
                };
                return typeof target[prop] === 'function' ? target[prop].bind(target) : target[prop];
            }
        };
        return new Proxy($0ff262dad5216a84$var$ExperienceTrackerHandler.getInstance().experienceTracker, proxyHandler);
    }, [
        params?.touchpointSource
    ]);
    return experienceTrackerProxy;
};

});
parcelRegister("jXUCh", function(module, exports) {

$parcel$export(module.exports, "isClientFetchError", () => $750b6f13fd837870$export$2e7adc44463c3f4f);
// Referenced from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
const $750b6f13fd837870$var$KNOWN_NETWORK_ERRORS = [
    '... is not valid JSON',
    'server with the specified hostname could not be found',
    'cannot parse response',
    'connection failure',
    'Failed to fetch',
    'in JSON at position 0',
    'JSON.parse: unexpected character at line 1 column 1 of the JSON data',
    'JSON.parse: unexpected end of data at line 1 column 1 of the JSON data',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'Syntax or http error',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted',
    'Unable to fetch manifest',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'dynamically imported module',
    'Importing a module script failed'
];
const $750b6f13fd837870$var$isClientFetchErrorMessage = (message)=>Boolean(message) && !!$750b6f13fd837870$var$KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
const $750b6f13fd837870$var$KNOWN_NETWORK_ERRORS_TYPES = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $750b6f13fd837870$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($750b6f13fd837870$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.name) || $750b6f13fd837870$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($750b6f13fd837870$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.cause.name) || $750b6f13fd837870$var$isClientFetchErrorMessage(error.cause.message)));

});

parcelRegister("3kN8f", function(module, exports) {

$parcel$export(module.exports, "setupSentryClient", () => $083186225bc5f71c$export$d8bd0edf6c978788);
$parcel$export(module.exports, "logException", () => $083186225bc5f71c$export$f86b2a1a2ce291b3);

var $5AZpC = parcelRequire("5AZpC");

var $jXUCh = parcelRequire("jXUCh");

var $9It69 = parcelRequire("9It69");

var $2aeVO = parcelRequire("2aeVO");

// importing local file instead of from '@sentry/browser' otherwise there will be typescript errors
const $083186225bc5f71c$var$importSentryAsync = async ()=>Promise.resolve((parcelRequire("8Xuap")));
let $083186225bc5f71c$var$sentryClient;
// copied from platform/packages/people-and-teams/teams-client/src/services/sentry/utils/initialise-sentry.ts
const $083186225bc5f71c$var$DISABLED_INTEGRATIONS = [
    'onerror',
    'onunhandledrejection',
    // In Jira this integration is being initialised twice, resulting in no events being sent to Sentry
    'Dedupe'
];
const $083186225bc5f71c$var$getEnvironment = ()=>{
    return 'production';
};
const $083186225bc5f71c$export$d8bd0edf6c978788 = async ({ customSentryDsn: customSentryDsn, packageName: packageName, product: productOverride } = {})=>{
    let accountId = 'UNKNOWN_AAID';
    let product = productOverride ?? (0, $9It69.getRovoChatProduct)();
    try {
        const profileData = await (0, $5AZpC.performHttpFetch)({
            path: '/gateway/api/me',
            options: {
                method: 'GET'
            }
        });
        if (profileData?.account_id) accountId = profileData.account_id;
    } catch (_) {
    // do nothing
    }
    if ($083186225bc5f71c$var$sentryClient) {
        // if sentry is trying to be initialized again with new product or account id
        // update the user and tags
        $083186225bc5f71c$var$sentryClient.setTag('product', product);
        $083186225bc5f71c$var$sentryClient.setUser({
            id: accountId
        });
        // do not initialise sentry again, only update the existing one
        return;
    }
    let importedSentry;
    try {
        importedSentry = await $083186225bc5f71c$var$importSentryAsync();
    } catch (e) {
        console.warn('Failed to load conversation-assistant sentry', e); // eslint-disable-line no-console
        return;
    }
    // https://atlassian-2y.sentry.io/projects/ai-mate-conversation-assistant/getting-started/
    const defaultSentryDsn = 'https://0d679a1c0fe3816e2b2e34d4ca85d5da@o55978.ingest.sentry.io/4506794008903680';
    importedSentry.init({
        dsn: customSentryDsn || defaultSentryDsn,
        environment: $083186225bc5f71c$var$getEnvironment(),
        integrations: (integrations)=>{
            return integrations.filter((integration)=>{
                return $083186225bc5f71c$var$DISABLED_INTEGRATIONS.indexOf(integration.name) === -1;
            });
        },
        initialScope: {
            user: {
                id: accountId
            },
            tags: {
                packageName: packageName || '@atlassian/conversation-assistant',
                product: product
            }
        },
        // referencing jira/src/packages/platform/observability/errors-handling/src/utils/sentry/handling/normalise-sentry-event.tsx
        beforeSend: (event, hint)=>{
            const exception = hint?.originalException;
            // Ignore network-like errors
            if ((0, $jXUCh.isClientFetchError)(exception)) return null;
            if (!event.tags?.name) // we only want to capture errors that has `name` tag from `logException` function below
            // since the `DISABLED_INTEGRATIONS` filter above is not enough to prevent unhandled errors
            return null;
            let updatedEvent = event;
            if (updatedEvent.request?.url) {
                // Ignore events from localhost and staging
                if (updatedEvent.request.url.includes('localhost') || updatedEvent.request.url.includes('jira-dev.com') || updatedEvent.request.url.includes('stg.atlassian.com') || updatedEvent.request.url.includes('stg.internal.atlassian.com') || updatedEvent.request.url.includes('stg-east.frontend.public.atl-paas.net')) return null;
                updatedEvent.request.url = (0, $2aeVO.normaliseUrl)(updatedEvent.request.url);
            }
            return updatedEvent;
        },
        attachStacktrace: true
    });
    $083186225bc5f71c$var$sentryClient = importedSentry;
};
const $083186225bc5f71c$var$getSentryClient = async ()=>{
    if (!$083186225bc5f71c$var$sentryClient) // this only happens if something using sentry before the initialisation in root app
    await $083186225bc5f71c$export$d8bd0edf6c978788();
    return $083186225bc5f71c$var$sentryClient;
};
const $083186225bc5f71c$export$f86b2a1a2ce291b3 = async ({ exception: exception, name: name, tags: tags })=>{
    const sentryClient = await $083186225bc5f71c$var$getSentryClient();
    if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
    sentryClient.withScope((scope)=>{
        scope.setTag('name', name);
        if (tags) scope.setTags(tags);
        sentryClient.captureException(exception, scope);
    });
};

});
parcelRegister("5AZpC", function(module, exports) {

$parcel$export(module.exports, "performHttpFetch", () => $e3205999c8add5e6$export$a38d93aa782475f6);
//Shared code with conversation-assistant-service/src/common/utils/fetch.ts

var $b0RFn = parcelRequire("b0RFn");
//TODO have this extend RovoInstrumentedError once that PR is merged
class $e3205999c8add5e6$var$HttpApiError extends Error {
    constructor(message, errorAttributes){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
    }
}
const $e3205999c8add5e6$export$a38d93aa782475f6 = async ({ path: path, options: options })=>{
    try {
        const response = await fetch(path, options);
        if (!response.ok || response.status >= 400) await $e3205999c8add5e6$var$processHttpErrorResponse({
            response: response
        });
        return await response.json();
    } catch (err) {
        throw new (0, $b0RFn.FetchError)(`performHttpFetch error whle fetching ${path}`, {
            cause: err
        });
    }
};
const $e3205999c8add5e6$var$processHttpErrorResponse = async ({ response: response })=>{
    throw new $e3205999c8add5e6$var$HttpApiError(`[Code ${response.status}] ${await response.text()}`, {
        statusCode: response.status
    });
};

});
parcelRegister("b0RFn", function(module, exports) {

$parcel$export(module.exports, "FetchError", () => $b201945370d0e866$export$26e841bcf1aeb894);
class $b201945370d0e866$export$26e841bcf1aeb894 extends Error {
    constructor(message, cause){
        super(message), this.cause = cause;
        this.name = 'FetchError';
        if (cause) this.cause = cause;
    }
}

});


parcelRegister("9It69", function(module, exports) {

$parcel$export(module.exports, "getRovoChatProduct", () => $8e07af78c7c996fd$export$d4fdfa93c283ffc);
const $8e07af78c7c996fd$export$d4fdfa93c283ffc = ()=>{
    let product = 'UNKNOWN';
    if (window && window.__ROVO_CHAT_CONFIG_PRODUCT__) product = window.__ROVO_CHAT_CONFIG_PRODUCT__;
    return product;
};

});

parcelRegister("2aeVO", function(module, exports) {

$parcel$export(module.exports, "normaliseUrl", () => $f1e1fab54a39e125$export$d57ae76c6dc57a5);
const $f1e1fab54a39e125$var$pathnamePrefixes = [
    '/jira/',
    '/wiki/',
    '/browse/'
];
const $f1e1fab54a39e125$var$ATLAS_HOST = 'home.atlassian.com';
const $f1e1fab54a39e125$var$ATLAS_TEAM_HOST = 'team.atlassian.com';
const $f1e1fab54a39e125$export$d57ae76c6dc57a5 = (url)=>{
    try {
        let parsedUrl = new URL(url);
        let normalizedPath = '/any/';
        if (parsedUrl.host === $f1e1fab54a39e125$var$ATLAS_HOST || parsedUrl.host === $f1e1fab54a39e125$var$ATLAS_TEAM_HOST) // Replace org ID with "orgId" in the path
        normalizedPath = parsedUrl.pathname.replace(/\/o\/[^/]+/, '/o/orgId');
        const prefixRegex = new RegExp(`^(${$f1e1fab54a39e125$var$pathnamePrefixes.join('|')})`);
        if (prefixRegex.test(parsedUrl.pathname)) normalizedPath = parsedUrl.pathname.match(prefixRegex)[0];
        const normalizedUrl = `${parsedUrl.protocol}//${parsedUrl.host}${normalizedPath}`;
        return normalizedUrl;
    } catch (error) {
        return 'https://could-not-parse.example.com';
    }
};

});



parcelRegister("7qdbi", function(module, exports) {

$parcel$export(module.exports, "setRovoChatProduct", () => $247284f3c41a7fa5$export$caa27b16709bc2df);
// Dupe of same function from conversation-assistant
// No need to add a whole dependency just for this function
const $247284f3c41a7fa5$export$caa27b16709bc2df = (product)=>{
    if (window) window.__ROVO_CHAT_CONFIG_PRODUCT__ = product;
};

});

parcelRegister("cNqSS", function(module, exports) {

$parcel$export(module.exports, "readJsonStream", () => $2504014003f7f3a1$export$1f24b2b263bcfa75);

var $2uI0R = parcelRequire("2uI0R");
async function* $2504014003f7f3a1$export$1f24b2b263bcfa75(response) {
    const reader = (0, $2uI0R.getBufferReader)(response);
    let doneStreaming = false;
    let remainder = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) try {
            const processedChunks = `${remainder}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            remainder = '';
            for (let chunk of processedChunks)try {
                yield JSON.parse(chunk);
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                remainder = chunk;
            }
        } catch (e) {
            const error = new Error(`Error Processing Stream Data: ${value}`);
            throw error;
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else throw e;
    }
    while (!doneStreaming);
}

});
parcelRegister("2uI0R", function(module, exports) {

$parcel$export(module.exports, "getBufferReader", () => $2735314bca0a1e9a$export$f6383c3ea1307da9);
const $2735314bca0a1e9a$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};

});


parcelRegister("4c7JV", function(module, exports) {

$parcel$export(module.exports, "ACCEPTABLE_USE_VIOLATIONS_ERROR", () => $228fb1e7a583589a$export$c424fe9570a5f2d9);
$parcel$export(module.exports, "isHumanMessage", () => $228fb1e7a583589a$export$a69fab2afb88c2eb);
$parcel$export(module.exports, "isAssistantMessage", () => $228fb1e7a583589a$export$6f965deda7f0960c);
$parcel$export(module.exports, "isStreamResponse", () => $228fb1e7a583589a$export$b4631726cbc1440a);
$parcel$export(module.exports, "isAgentResponse", () => $228fb1e7a583589a$export$a6e5100ca2770191);
$parcel$export(module.exports, "isStreamError", () => $228fb1e7a583589a$export$d422a2733a3b5def);
$parcel$export(module.exports, "isStreamAUPError", () => $228fb1e7a583589a$export$1e1cf807ece63df4);
$parcel$export(module.exports, "isStreamAnswerPart", () => $228fb1e7a583589a$export$e45102edbc73b240);
$parcel$export(module.exports, "isStreamResearchBeginningTrace", () => $228fb1e7a583589a$export$9c1f93971e9e3fbe);
$parcel$export(module.exports, "isStreamResearchStepContent", () => $228fb1e7a583589a$export$79a0ed7d987faa8f);
$parcel$export(module.exports, "isStreamResearchStepTitle", () => $228fb1e7a583589a$export$7b1c8227569f1a92);
$parcel$export(module.exports, "isStreamResearchStepSource", () => $228fb1e7a583589a$export$68192da24ac8c141);
$parcel$export(module.exports, "isStreamResearchStepCompleted", () => $228fb1e7a583589a$export$cfccfd17b68ccb0);
$parcel$export(module.exports, "isStreamResearchPayload", () => $228fb1e7a583589a$export$46e0fb5e4b019a49);
$parcel$export(module.exports, "isStreamTrace", () => $228fb1e7a583589a$export$fd5a05be03f147a0);
$parcel$export(module.exports, "isFollowUpMessage", () => $228fb1e7a583589a$export$aeae5b4fda357302);
$parcel$export(module.exports, "isChannelNotFoundError", () => $228fb1e7a583589a$export$6ce1ccc24e75456f);
$parcel$export(module.exports, "isRateLimitedError", () => $228fb1e7a583589a$export$bc96a6a479480590);
$parcel$export(module.exports, "isHipaaError", () => $228fb1e7a583589a$export$f8b1b75846492611);
$parcel$export(module.exports, "isConversationChannelDataMessage", () => $228fb1e7a583589a$export$b454081350f4a578);

var $2NKK6 = parcelRequire("2NKK6");

var $gRLdW = parcelRequire("gRLdW");
const $228fb1e7a583589a$export$5945515082cc2cbf = 'CONVERSATION_CHANNEL_NOT_FOUND';
const $228fb1e7a583589a$export$c424fe9570a5f2d9 = 'ACCEPTABLE_USE_VIOLATIONS';
const $228fb1e7a583589a$export$fb661125ffb29bd6 = (message)=>{
    return $228fb1e7a583589a$export$a69fab2afb88c2eb(message) || $228fb1e7a583589a$export$6f965deda7f0960c(message) || $228fb1e7a583589a$export$b4631726cbc1440a(message);
};
const $228fb1e7a583589a$export$a69fab2afb88c2eb = (message)=>message instanceof Object && message.role === 'HUMAN';
const $228fb1e7a583589a$export$6f965deda7f0960c = (message)=>message instanceof Object && message.role === 'ASSISTANT';
const $228fb1e7a583589a$export$a6e5100ca2770191 = (message)=>message instanceof Object && $228fb1e7a583589a$export$6f965deda7f0960c(message.message);
const $228fb1e7a583589a$export$b4631726cbc1440a = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
const $228fb1e7a583589a$export$d422a2733a3b5def = (message)=>message instanceof Object && message.type === 'ERROR';
const $228fb1e7a583589a$export$1e1cf807ece63df4 = (message)=>$228fb1e7a583589a$export$d422a2733a3b5def(message) && message.message?.message_template === $228fb1e7a583589a$export$c424fe9570a5f2d9;
const $228fb1e7a583589a$export$e45102edbc73b240 = (message)=>message instanceof Object && message.type === 'ANSWER_PART';
const $228fb1e7a583589a$export$9c1f93971e9e3fbe = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH';
const $228fb1e7a583589a$export$79a0ed7d987faa8f = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP';
const $228fb1e7a583589a$export$7b1c8227569f1a92 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_TITLE';
const $228fb1e7a583589a$export$68192da24ac8c141 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_SOURCE';
const $228fb1e7a583589a$export$cfccfd17b68ccb0 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_COMPLETE';
const $228fb1e7a583589a$export$46e0fb5e4b019a49 = (message)=>message instanceof Object && message.type === 'TRACE' && (message.message.message_template === 'RESEARCH' || message.message.message_template === 'RESEARCH_STEP' || message.message.message_template === 'RESEARCH_STEP_TITLE' || message.message.message_template === 'RESEARCH_STEP_SOURCE' || message.message.message_template === 'RESEARCH_STEP_COMPLETE');
const $228fb1e7a583589a$export$fd5a05be03f147a0 = (message)=>{
    // TRACE and research steps are sharing the same type, but we want to separate them
    if ($228fb1e7a583589a$export$46e0fb5e4b019a49(message)) return false;
    return message instanceof Object && message.type === 'TRACE';
};
const $228fb1e7a583589a$export$aeae5b4fda357302 = (message)=>message !== undefined && message !== null && typeof message === 'object' && 'type' in message && message.type === 'FOLLOW_UP_QUERIES';
const $228fb1e7a583589a$export$6ce1ccc24e75456f = (error)=>(0, $gRLdW.isApiError)(error) && error.errorAttributes?.errorCode === $228fb1e7a583589a$export$5945515082cc2cbf;
const $228fb1e7a583589a$export$bc96a6a479480590 = (error)=>(0, $gRLdW.isApiError)(error) && error.errorAttributes.statusCode === 429;
const $228fb1e7a583589a$export$f8b1b75846492611 = (error)=>(0, $gRLdW.isApiError)(error) && !!error.errorAttributes.errorCode && error.errorAttributes.errorCode === (0, $2NKK6.ASSISTANCE_SERVICE_ERROR_CODES).HAS_HIPAA_ENABLED;
const $228fb1e7a583589a$export$b454081350f4a578 = (message)=>message instanceof Object && message.type === 'CONVERSATION_CHANNEL_DATA';

});
parcelRegister("2NKK6", function(module, exports) {

$parcel$export(module.exports, "ASSISTANCE_SERVICE_ERROR_CODES", () => $c336cfded2d331a0$export$1106bf31edf2a9b8);
$parcel$export(module.exports, "STATUS_CODES", () => $c336cfded2d331a0$export$333e4f57333eadfa);
const $c336cfded2d331a0$export$e8114853eca81277 = 'ai-mate';
const $c336cfded2d331a0$export$1106bf31edf2a9b8 = {
    AGENT_DOES_NOT_EXIST: 'errorAgentNotFound',
    USER_NOT_CREATOR: 'errorIncorrectOwner',
    AGENT_HAS_CONVERSATIONS: 'errorAgentInUse',
    AGENT_DEACTIVATED: 'convoai.rest.bad.request.archived.agent',
    ROVO_PRODUCT_NOT_ACTIVE: 'convoai.rest.rovo.product.not.active',
    HAS_HIPAA_ENABLED: 'convoai.rest.browsing.product.has.hipaa.enabled',
    FILE_SIZE_TOO_LARGE: 'convoai.rest.bad.request.file.size.too.large'
};
const $c336cfded2d331a0$export$333e4f57333eadfa = {
    UNSUPPORTED_FILE_TYPE: 415
};

});

parcelRegister("gRLdW", function(module, exports) {

$parcel$export(module.exports, "ApiError", () => $884e41a84621b493$export$f2e832acab1bdd79);
$parcel$export(module.exports, "isApiError", () => $884e41a84621b493$export$89d83cc97c52a37);
$parcel$export(module.exports, "mapErrorToApiError", () => $884e41a84621b493$export$3c02d1a328d4d808);
class $884e41a84621b493$export$f2e832acab1bdd79 extends Error {
    constructor(message, errorAttributes){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
    }
}
const $884e41a84621b493$export$89d83cc97c52a37 = (error)=>error instanceof $884e41a84621b493$export$f2e832acab1bdd79;
const $884e41a84621b493$export$3c02d1a328d4d808 = (error)=>{
    if ($884e41a84621b493$export$89d83cc97c52a37(error)) return error;
    // Fallback since we expect the error to be an instance of ApiError
    return new $884e41a84621b493$export$f2e832acab1bdd79(error.message, {
        statusCode: 0
    });
};

});


parcelRegister("lb2g6", function(module, exports) {

$parcel$export(module.exports, "addPath", () => $d75893d8e1262208$export$4c25481b843feb0b);
$parcel$export(module.exports, "getTraceIdFromResponse", () => $d75893d8e1262208$export$9f229e40eb65abfc);
$parcel$export(module.exports, "processResponse", () => $d75893d8e1262208$export$21fcb6cfd5628534);

var $gRLdW = parcelRequire("gRLdW");
const $d75893d8e1262208$export$4c25481b843feb0b = (baseUrl, path)=>{
    if (path === '') // return base url without trailing slash
    return baseUrl;
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
const $d75893d8e1262208$export$9f229e40eb65abfc = (response)=>response?.headers?.get('x-trace-id') ?? response?.headers?.get('atl-traceid') ?? response?.headers?.get('x-b3-traceid') ?? undefined;
const $d75893d8e1262208$var$processErrorResponse = async ({ response: response })=>{
    let errorCode;
    let outputErrorMessage;
    const responseText = await response.text();
    let rawErrorMessage;
    try {
        const errorBodyJson = JSON.parse(responseText);
        const { error_code: error_code, error_message: error_message, message_template: message_template, errors: errors, errorMessage: errorMessage } = errorBodyJson;
        rawErrorMessage = errorMessage ?? error_message;
        if (errors?.length) // Use a single error code for now
        errorCode = errors[0];
        else if (error_code) errorCode = error_code;
        else errorCode = message_template;
        if (!errorCode || !rawErrorMessage) outputErrorMessage = responseText;
        else outputErrorMessage = `${errorCode} - ${rawErrorMessage}`;
    } catch (err) {
        outputErrorMessage = responseText;
    }
    throw new (0, $gRLdW.ApiError)(`[Code ${response.status}] ${outputErrorMessage}`, {
        errorCode: errorCode,
        statusCode: response.status,
        rawErrorMessage: rawErrorMessage,
        traceId: $d75893d8e1262208$export$9f229e40eb65abfc(response)
    });
};
const $d75893d8e1262208$export$21fcb6cfd5628534 = async ({ response: response })=>{
    if (!response.ok || response.status >= 400) await $d75893d8e1262208$var$processErrorResponse({
        response: response
    });
    return response;
};

});

parcelRegister("khfvG", function(module, exports) {

$parcel$export(module.exports, "generateConversationName", () => $1d5a08981e582a14$export$11cc4786742ed7c2);
const $1d5a08981e582a14$export$11cc4786742ed7c2 = ()=>{
    const date = new Date();
    const formattedDate = date.toLocaleDateString(undefined, {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit'
    });
    const formattedTime = date.toLocaleTimeString(undefined, {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });
    const name = `${formattedDate} ${formattedTime}`;
    return name;
};

});

parcelRegister("3zcGU", function(module, exports) {

$parcel$export(module.exports, "getId", () => $c587188fcee2b8b3$export$218c8c3169c024d2);
$parcel$export(module.exports, "addAnswerPart", () => $c587188fcee2b8b3$export$6e5609c05ab74cc7);
$parcel$export(module.exports, "removeSensitiveData", () => $c587188fcee2b8b3$export$efd4f6b5d168b654);
$parcel$export(module.exports, "createHumanMessage", () => $c587188fcee2b8b3$export$4010f996e89e886a);
$parcel$export(module.exports, "toStreamResponse", () => $c587188fcee2b8b3$export$3220a4ff7b3a96df);

var $4c7JV = parcelRequire("4c7JV");
const $c587188fcee2b8b3$export$218c8c3169c024d2 = (streamResponse)=>streamResponse.message.message.id;
const $c587188fcee2b8b3$var$addAnswerPartAssistantMessage = (response, answerPart)=>{
    const content = `${response.content}${answerPart.message.content}`;
    // Remove source indexes, e.g [^1^] from the content
    const cleanedContent = content.replace(/\[\^\d+\^\]/g, '');
    return {
        ...response,
        content: cleanedContent
    };
};
const $c587188fcee2b8b3$var$addAnswerPartAgentResponse = (response, answerPart)=>({
        ...response,
        message: $c587188fcee2b8b3$var$addAnswerPartAssistantMessage(response.message, answerPart)
    });
const $c587188fcee2b8b3$export$6e5609c05ab74cc7 = (response, answerPart)=>({
        ...response,
        message: $c587188fcee2b8b3$var$addAnswerPartAgentResponse(response.message, answerPart)
    });
const $c587188fcee2b8b3$var$removeSensitiveDataAssistantMessage = (message)=>{
    const { plugin_invocations: plugin_invocations, ...rest } = message;
    return {
        ...rest,
        plugin_invocations: plugin_invocations.map((pluginInvocation)=>({
                ...pluginInvocation,
                plugin_output: '--PRIVATE--'
            }))
    };
};
const $c587188fcee2b8b3$var$removeSensitiveDataAgentResponse = (message)=>({
        ...message,
        message: $c587188fcee2b8b3$var$removeSensitiveDataAssistantMessage(message.message)
    });
const $c587188fcee2b8b3$export$efd4f6b5d168b654 = (message)=>({
        ...message,
        message: $c587188fcee2b8b3$var$removeSensitiveDataAgentResponse(message.message)
    });
const $c587188fcee2b8b3$export$4010f996e89e886a = (id, content, isFromSeededConversation, requestId, fileUploads)=>{
    return {
        role: 'HUMAN',
        id: id,
        content: content,
        time_created: new Date().toISOString(),
        user_ari: 'unknown',
        plugin_invocations: [],
        isFromSeededConversation: isFromSeededConversation,
        requestId: requestId,
        file_uploads: fileUploads
    };
};
const $c587188fcee2b8b3$export$3220a4ff7b3a96df = (message)=>{
    if ((0, $4c7JV.isAgentResponse)(message)) return {
        type: 'FINAL_RESPONSE',
        message: message
    };
    return {
        type: 'FINAL_RESPONSE',
        message: {
            message: message
        }
    };
};

});

parcelRegister("f7UWp", function(module, exports) {

$parcel$export(module.exports, "fetchFn", () => $083f568d1e8b8dc8$export$10f0d162cb6dae7c);
const $083f568d1e8b8dc8$export$10f0d162cb6dae7c = window.fetch;

});


parcelRegister("4ojTZ", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $667e963723dc9f11$export$dd0a697e1782aedd);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $3sQ5x = parcelRequire("3sQ5x");
var $6dDSs = parcelRequire("6dDSs");
var $iXqE5 = parcelRequire("iXqE5");

var $VSDnB = parcelRequire("VSDnB");

var $gRLdW = parcelRequire("gRLdW");
const $667e963723dc9f11$var$store = (0, $iXqE5.createStore)({
    initialState: {
        cache: {}
    },
    actions: {
        updateCacheEntry: (key, value)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const currentCacheEntry = state.cache[key] ?? {
                    data: null,
                    error: null,
                    isFetching: false
                };
                const newCacheEntry = {
                    ...currentCacheEntry,
                    ...value
                };
                setState({
                    cache: {
                        ...state.cache,
                        [key]: newCacheEntry
                    }
                });
            },
        getCacheEntry: (key)=>({ getState: getState })=>{
                const state = getState();
                return state.cache[key];
            }
    }
});
const $667e963723dc9f11$var$selectorOld = (0, $6dDSs.createSelector)((state)=>state.cache, (_, key)=>key, (cache, key)=>cache[key] ?? {
        data: null,
        error: null,
        isFetching: false
    });
const $667e963723dc9f11$var$selector = (0, $6dDSs.createSelector)((state)=>state.cache, (_, props)=>props.key, (_, props)=>props.initialQueryEnabled, /**
	 * Based on testing, the result of this selector will be compared with previous result using `shallowEqual`
	 * and it will determine whether to rerender the component
	 * and also after looking at docs in https://github.com/atlassian/react-sweet-state/blob/master/src/utils/memoize.js#L38
	 *
	 * e.g. for `enabled` true condition:
	 * -> 1st call -> cache[key] === undefined; so it will return { data: null, error: null, isFetching: true }
	 * -> 2nd call -> cache[key] !== undefined; so it will return cache[key]; however shallowEqual(cache[key], previousResult) will return true -> so no rerender
	 *
	 * To test this, run the unit test, and then force this function to return new stuff on every call
	 * e.g. `return { ...result, random: Math.random() };`
	 * it will result in increase renderCount in the unit test
	 */ (cache, key, initialQueryEnabled)=>cache[key] ?? {
        data: null,
        error: null,
        isFetching: initialQueryEnabled
    });
const $667e963723dc9f11$var$useCacheEntryOld = (0, $3sQ5x.createHook)($667e963723dc9f11$var$store, {
    selector: $667e963723dc9f11$var$selectorOld
});
const $667e963723dc9f11$var$useCacheEntryNew = (0, $3sQ5x.createHook)($667e963723dc9f11$var$store, {
    selector: $667e963723dc9f11$var$selector
});
const $667e963723dc9f11$export$dd0a697e1782aedd = ({ queryKey: queryKeyParts, queryFn: queryFn, onSuccess: onSuccess, onError: onError, enabled: enabled = true, refetchOnWindowFocus: refetchOnWindowFocus = false })=>{
    const queryKey = queryKeyParts.map((x)=>x?.toString()).join('_');
    const queryFnRef = (0, $5uXOq.useRef)(queryFn);
    queryFnRef.current = queryFn;
    const onSuccessRef = (0, $5uXOq.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $5uXOq.useRef)(onError);
    onErrorRef.current = onError;
    let cache;
    let updateCacheEntry;
    let getCacheEntry;
    if ((0, $VSDnB.fg)('rovo_chat_use_query_correct_initial_state')) // eslint-disable-next-line react-hooks/rules-of-hooks
    [cache, { updateCacheEntry: updateCacheEntry, getCacheEntry: getCacheEntry }] = $667e963723dc9f11$var$useCacheEntryNew({
        key: queryKey,
        initialQueryEnabled: enabled
    });
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    [cache, { updateCacheEntry: updateCacheEntry, getCacheEntry: getCacheEntry }] = $667e963723dc9f11$var$useCacheEntryOld(queryKey);
    const fetchData = (0, $5uXOq.useCallback)(async ()=>{
        updateCacheEntry(queryKey, {
            isFetching: true
        });
        try {
            const response = await queryFnRef.current();
            updateCacheEntry(queryKey, {
                data: response
            });
            onSuccessRef.current?.(response);
            return response;
        } catch (error) {
            const apiError = (0, $gRLdW.mapErrorToApiError)(error);
            updateCacheEntry(queryKey, {
                error: apiError
            });
            onErrorRef.current?.(apiError);
        } finally{
            updateCacheEntry(queryKey, {
                isFetching: false
            });
        }
        return null;
    }, [
        updateCacheEntry,
        queryKey
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (enabled && refetchOnWindowFocus) {
            const unbind = (0, $cBeZP.bind)(window, {
                // We use visibilitychange instead of focus to prevent triggering refetch when moving between iframes such as agent embed
                type: 'visibilitychange',
                listener: ()=>{
                    if (enabled && refetchOnWindowFocus && !getCacheEntry(queryKey)?.isFetching) {
                        if (document.visibilityState === 'visible') fetchData();
                    }
                }
            });
            return unbind;
        }
    }, [
        enabled,
        fetchData,
        getCacheEntry,
        queryKey,
        refetchOnWindowFocus
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!getCacheEntry(queryKey) && enabled) fetchData();
    }, [
        queryKey,
        fetchData,
        enabled,
        getCacheEntry
    ]);
    return {
        data: cache.data,
        error: cache.error,
        isFetching: cache.isFetching,
        refetch: fetchData
    };
};

});


parcelRegister("a9Thh", function(module, exports) {

$parcel$export(module.exports, "LeftAside", () => $44aa7966e217105d$export$e56858e2d9136a46);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $414Wj = parcelRequire("414Wj");

var $kgrc7 = parcelRequire("kgrc7");
const $44aa7966e217105d$var$style = {
    root: "_ca0qv47k _n3tdv47k _19bvv47k _u5f3v47k _1bahv2br _1bsbnklw _1ul9nklw",
    rootFullWidth: "_1bsb1osq"
};
const $44aa7966e217105d$export$e56858e2d9136a46 = ({ children: children })=>{
    const { isSingleColumn: isSingleColumn } = (0, $kgrc7.useLayoutStore)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $414Wj.default), {
            space: "space.400",
            xcss: (0, $3JT92.cx)($44aa7966e217105d$var$style.root, isSingleColumn && $44aa7966e217105d$var$style.rootFullWidth),
            children: children
        })
    });
};

});
parcelRegister("kgrc7", function(module, exports) {

$parcel$export(module.exports, "useLayoutStore", () => $55d2701b4494a401$export$ee413f68c0e5c346);
$parcel$export(module.exports, "useLayoutStoreActions", () => $55d2701b4494a401$export$6136bc3b9858cff4);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $55d2701b4494a401$var$SINGLE_COLUMN_BREAKPOINT = 768;
const $55d2701b4494a401$var$initialState = {
    containerWidth: null
};
const $55d2701b4494a401$var$actions = {
    setContainerWidth: (containerWidth)=>({ setState: setState })=>{
            setState({
                containerWidth: containerWidth
            });
        }
};
const $55d2701b4494a401$var$LayoutStore = (0, $iXqE5.createStore)({
    initialState: $55d2701b4494a401$var$initialState,
    actions: $55d2701b4494a401$var$actions,
    name: 'LayoutStore'
});
const $55d2701b4494a401$var$useLayoutStoreInner = (0, $3sQ5x.createHook)($55d2701b4494a401$var$LayoutStore, {
    selector: (state)=>({
            ...state,
            isSingleColumn: !!(state.containerWidth && state.containerWidth < $55d2701b4494a401$var$SINGLE_COLUMN_BREAKPOINT)
        })
});
const $55d2701b4494a401$export$ee413f68c0e5c346 = ()=>$55d2701b4494a401$var$useLayoutStoreInner()[0];
const $55d2701b4494a401$export$6136bc3b9858cff4 = ()=>$55d2701b4494a401$var$useLayoutStoreInner()[1];

});


parcelRegister("hI6kz", function(module, exports) {

$parcel$export(module.exports, "ProfileContent", () => $781eb20b14c5c646$export$ecf07060fe596e2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $MHKc7 = parcelRequire("MHKc7");
var $bUmQV = parcelRequire("bUmQV");

var $kgrc7 = parcelRequire("kgrc7");
const $781eb20b14c5c646$var$styles = {
    root: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1bsb1osq _p12fr84k",
    flexColumn: "_2lx21bp4",
    grid: "_1e0c11p5 _yv0eqw8w _1bsb1osq"
};
const $781eb20b14c5c646$export$ecf07060fe596e2 = ({ children: children })=>{
    const { isSingleColumn: isSingleColumn } = (0, $kgrc7.useLayoutStore)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $781eb20b14c5c646$var$styles.root,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bUmQV.default), {
            xcss: (0, $3JT92.cx)(isSingleColumn ? $781eb20b14c5c646$var$styles.flexColumn : $781eb20b14c5c646$var$styles.grid),
            children: children
        })
    });
};

});

parcelRegister("7m1xZ", function(module, exports) {

$parcel$export(module.exports, "useDialog", () => $a473b7b94d8a74c9$export$d55e7ee900f34e93);

var $5uXOq = parcelRequire("5uXOq");

var $jEb7N = parcelRequire("jEb7N");
const $a473b7b94d8a74c9$export$d55e7ee900f34e93 = ()=>{
    return (0, $5uXOq.useContext)((0, $jEb7N.DialogsContext));
};

});

parcelRegister("aOf1o", function(module, exports) {

$parcel$export(module.exports, "useExpTrackerStart", () => $9471edc08800666d$export$3ec42c6cc9df311c);

var $5uXOq = parcelRequire("5uXOq");

var $5LvDD = parcelRequire("5LvDD");

var $38ra6 = parcelRequire("38ra6");
function $9471edc08800666d$export$3ec42c6cc9df311c(options) {
    const { id: id, name: name, timeout: timeout, isTriggerOnMount: isTriggerOnMount = true, subExperiences: subExperiences, latencySloMs: latencySloMs, startAttributes: startAttributes, onSuccess: onSuccess } = options;
    const analytics = (0, $38ra6.default)();
    const tracker = analytics.expTracker();
    const triggerStartEvent = (0, $5uXOq.useCallback)(()=>{
        const options = {
            id: id,
            name: name,
            timeout: timeout,
            collect: undefined,
            attributes: startAttributes,
            onSuccess: onSuccess
        };
        if (subExperiences) options.collect = (0, $5LvDD.collectAll)(subExperiences);
        if (latencySloMs) options.attributes = {
            latencySlo: latencySloMs
        };
        tracker.start(options);
    }, [
        id,
        name,
        timeout,
        startAttributes,
        onSuccess,
        subExperiences,
        latencySloMs,
        tracker
    ]);
    const triggerSuccessEvent = (0, $5uXOq.useCallback)(()=>{
        tracker.succeed({
            name: name
        });
    }, [
        name,
        tracker
    ]);
    const triggerFailEvent = (0, $5uXOq.useCallback)((error)=>{
        tracker.stopOnError({
            name: name,
            error: error
        });
    }, [
        name,
        tracker
    ]);
    const triggerAbortEvent = (0, $5uXOq.useCallback)((reason)=>{
        tracker.abort({
            name: name,
            reason: reason
        });
    }, [
        name,
        tracker
    ]);
    // we use 'useState' here because we want to trigger start event as soon as possible, before rendering component,
    (0, $5uXOq.useState)(()=>{
        // default behaviour: trigger start event when mounting.
        // "isTriggerOnMount=false" is allow to turn off the default behaviour.
        if (isTriggerOnMount) triggerStartEvent();
    });
    // allow to trigger start event whenever consumers want like inside onClick.
    return {
        start: triggerStartEvent,
        succeed: triggerSuccessEvent,
        abort: triggerAbortEvent,
        fail: triggerFailEvent
    };
}

});
parcelRegister("5LvDD", function(module, exports) {

$parcel$export(module.exports, "collectAll", () => $e8cb564f08d00082$export$feb7963ae429f97f);
$parcel$export(module.exports, "collectAny", () => $e8cb564f08d00082$export$79dbdd3e43727beb);

var $hhYjW = parcelRequire("hhYjW");
function $e8cb564f08d00082$export$feb7963ae429f97f(experienceNames) {
    const experienceNameSet = new Set(experienceNames);
    return (events, experience)=>{
        // Fail as soon as any sub-experience is failed or aborted
        experience.stopOn(events.find((event)=>experienceNameSet.has(event.name) && (event.action === 'taskFail' || event.action === 'taskAbort')));
        // If there's a success remove the experience from the set
        // of experiences we're waiting for.
        events.forEach((event)=>{
            if ((0, $hhYjW.isStop)(event)) experienceNameSet.delete(event.name);
        });
        // Experience is considered complete if all sub-experiences
        // are complete.
        if (experienceNameSet.size === 0) experience.succeed();
    };
}
function $e8cb564f08d00082$export$79dbdd3e43727beb(experienceNames) {
    return (events, experience)=>experience.stopOn(events.find((event)=>(0, $hhYjW.isStop)(event) && (0, $hhYjW.hasName)(event, ...experienceNames)));
}

});


parcelRegister("lHKVj", function(module, exports) {

$parcel$export(module.exports, "useExpTrackerStop", () => $0116da51a3eb5ecd$export$432668e70196929c);

var $5uXOq = parcelRequire("5uXOq");

var $iknOf = parcelRequire("iknOf");

var $38ra6 = parcelRequire("38ra6");
function $0116da51a3eb5ecd$export$432668e70196929c(options) {
    const { name: name, error: error, checkShouldAbort: checkShouldAbort } = options;
    const analytics = (0, $38ra6.default)();
    const tracker = analytics.expTracker();
    (0, $5uXOq.useEffect)(()=>{
        const triggerStopEvent = ()=>{
            if (!error) return;
            // If error has a statusCode of 429, abort instead.
            if ($0116da51a3eb5ecd$var$isRateLimitError(error)) {
                abortExpTracker(`Ignoring 429 error: ${error.message}`);
                return;
            }
            tracker.stopOnError({
                name: name,
                error: error
            });
        };
        const abortExpTracker = (reason)=>{
            tracker.abort({
                name: name,
                reason: reason
            });
        };
        if (error) {
            const reason = checkShouldAbort ? checkShouldAbort(error) : undefined;
            if (typeof reason === 'string' || $0116da51a3eb5ecd$var$isRateLimitError(error)) abortExpTracker(reason ?? `Ignoring 429 error: ${error.message}`);
            else triggerStopEvent();
        }
    }, [
        checkShouldAbort,
        error,
        name,
        tracker
    ]);
}
const $0116da51a3eb5ecd$var$isRateLimitError = (error)=>{
    if (error instanceof (0, $iknOf.UseQueryLightError) && error.networkError) return $0116da51a3eb5ecd$var$isRateLimitError(error.networkError);
    return 'statusCode' in error && error.statusCode === 429 || 'status' in error && error.status === 429 || error.message.includes('429');
};

});
parcelRegister("iknOf", function(module, exports) {

$parcel$export(module.exports, "UseQueryLightError", () => $0948a197dcd914bf$export$a1c33d09dbc37a86);
var $0948a197dcd914bf$export$fe4bb20808298551 = /*#__PURE__*/ function(ErrorCategory) {
    ErrorCategory["NotFound"] = "NotFound";
    ErrorCategory["NotPermitted"] = "NotPermitted";
    ErrorCategory["MalformedInput"] = "MalformedInput";
    ErrorCategory["Internal"] = "Internal";
    return ErrorCategory;
}({});
class $0948a197dcd914bf$export$7f29b23735f2fedd extends Error {
    constructor(message){
        super(message);
        this.message = message;
    }
}
class $0948a197dcd914bf$export$a1c33d09dbc37a86 extends Error {
    constructor(message, name, graphQLErrors, networkError, extensions, extraInfo){
        super(message);
        this.graphQLErrors = graphQLErrors;
        this.networkError = networkError;
        this.extensions = extensions;
        this.extraInfo = extraInfo;
        if (name) this.name = name;
    }
}

});


parcelRegister("bA8uW", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_TIMEOUT_USER_EXP", () => $909c5e43d630b80c$export$6a2b57b882ff619b);
$parcel$export(module.exports, "UserExperienceNames", () => $909c5e43d630b80c$export$aff1d63763bf8a44);
$parcel$export(module.exports, "TEAM_PROFILE_PAGE_SUB_EVENT_NAMES", () => $909c5e43d630b80c$export$f6872ed66cc3dc3a);
$parcel$export(module.exports, "USER_PROFILE_PAGE_SUB_EVENT_NAMES", () => $909c5e43d630b80c$export$e302f7a9166a33eb);
$parcel$export(module.exports, "SEARCH_HOME_PAGE_SUB_EVENT_NAMES", () => $909c5e43d630b80c$export$ab5c192ffd15cb07);
$parcel$export(module.exports, "CREATE_TEAM_FLOW_SUB_EVENT_NAMES", () => $909c5e43d630b80c$export$bebaacf4c0d1b056);
// Use defaut timeout from Confluence
// https://stash.atlassian.com/projects/confcloud/repos/confluence-frontend/browse/next/packages/experience-tracker/src/ExperienceTimeout.ts#2
const $909c5e43d630b80c$export$6a2b57b882ff619b = 60000; // 60s
const $909c5e43d630b80c$export$c816bd9ab77da948 = 15000; // 15s
var $909c5e43d630b80c$export$aff1d63763bf8a44 = /*#__PURE__*/ function(UserExperienceNames) {
    UserExperienceNames["CREATE_TEAM"] = "createTeam";
    UserExperienceNames["CREATE_TEAM_OPEN_DIALOG"] = "createTeam/openDialog";
    UserExperienceNames["CREATE_TEAM_SUBMIT"] = "createTeam/create";
    // a compound experience
    UserExperienceNames["TEAM_PROFILE_PAGE"] = "teamProfile/render";
    UserExperienceNames["TEAM_PROFILE_MEMBERS"] = "teamProfile/membersPanel";
    UserExperienceNames["TEAM_PROFILE_LINKS"] = "teamProfile/links";
    UserExperienceNames["TEAM_PROFILE_WORKED_ON"] = "teamProfile/workedOn";
    UserExperienceNames["TEAM_PROFILE_TEAMS_CONTAINERS"] = "teamProfile/teamsContainers";
    UserExperienceNames["TEAM_PROFILE_TEAM_ABOUT"] = "teamProfile/teamAboutPanel";
    UserExperienceNames["TEAM_PROFILE_PROJECTS_AND_GOALS"] = "teamProfile/projectsAndGoals";
    UserExperienceNames["TEAM_PROFILE_HELP_POINTERS"] = "teamProfile/helpPointers";
    UserExperienceNames["TEAM_PROFILE_KUDOS"] = "teamProfile/kudos";
    UserExperienceNames["TEAM_PROFILE_SOFTWARE_COMPONENTS"] = "teamProfile/softwareComponents";
    UserExperienceNames["USER_PROFILE_AI_TOPICS"] = "userProfile/aiTopics";
    // a compound experience
    UserExperienceNames["USER_PROFILE_PAGE"] = "userProfile/render";
    UserExperienceNames["USER_PROFILE_PAGE_SLOW"] = "userProfile/renderSlow";
    UserExperienceNames["USER_PROFILE_WORKED_ON"] = "userProfile/workedOn";
    UserExperienceNames["USER_PROFILE_CONTAINERS"] = "userProfile/container";
    UserExperienceNames["USER_PROFILE_USER_ABOUT"] = "userProfile/userAbout";
    UserExperienceNames["USER_PROFILE_COLLABORATORS"] = "userProfile/collaborators";
    UserExperienceNames["USER_PROFILE_USERS_TEAMS"] = "userProfile/usersTeams";
    UserExperienceNames["USER_PROFILE_USER_MANAGER"] = "userProfile/userManager";
    UserExperienceNames["USER_PROFILE_TAG"] = "userProfile/tag";
    // a compound experience
    UserExperienceNames["SEARCH_HOME_PAGE"] = "searchHomePage/render";
    UserExperienceNames["SEARCH_HOME_PAGE_COLLABORATORS"] = "searchHomePage/collaborators";
    UserExperienceNames["SEARCH_HOME_PAGE_YOUR_TEAMS"] = "searchHomePage/yourTeams";
    UserExperienceNames["USER_PROFILE_PROJECTS_AND_GOALS"] = "userProfile/projectsAndGoals";
    UserExperienceNames["USER_PROFILE_MANAGERS_AND_TEAMS"] = "userProfile/managersAndTeams";
    UserExperienceNames["USER_PROFILE_KUDOS"] = "userProfile/kudos";
    // edit team name or description from Team profile page
    UserExperienceNames["EDIT_TEAM_NAME_OR_DESCRIPTION"] = "editTeamNameOrDescription";
    // remove team member
    UserExperienceNames["REMOVE_TEAM_MEMBER"] = "removeTeamMember";
    UserExperienceNames["REMOVE_TEAM_MEMBER_OPEN_DIALOG"] = "removeTeamMember/openDialog";
    UserExperienceNames["REMOVE_TEAM_MEMBER_SUBMIT"] = "removeTeamMember/submit";
    // upload user avatar from User profile page
    UserExperienceNames["UPLOAD_USER_AVATAR"] = "uploadUserAvatar";
    UserExperienceNames["UPLOAD_HEADER_IMAGE"] = "uploadHeaderImage";
    // team membership control changing
    UserExperienceNames["MEMBERSHIP_CONTROL_CHANGE"] = "membershipControl/change";
    UserExperienceNames["MEMBERSHIP_CONTROL_HANDLE_REQUESTS"] = "membershipControl/handleRequests";
    UserExperienceNames["MEMBERSHIP_CONTROL_TEAM_TYPE"] = "membershipControl/teamType";
    // agent profile page
    UserExperienceNames["AGENT_PROFILE_PAGE"] = "agentProfile/render";
    return UserExperienceNames;
}({});
const $909c5e43d630b80c$export$f6872ed66cc3dc3a = [
    "teamProfile/membersPanel",
    "teamProfile/links",
    "teamProfile/workedOn",
    "teamProfile/teamAboutPanel"
];
const $909c5e43d630b80c$export$e302f7a9166a33eb = [
    "userProfile/userAbout",
    "userProfile/usersTeams",
    "userProfile/workedOn",
    "userProfile/container"
];
const $909c5e43d630b80c$export$ab5c192ffd15cb07 = [
    "searchHomePage/collaborators",
    "searchHomePage/yourTeams"
];
const $909c5e43d630b80c$export$bebaacf4c0d1b056 = [
    "createTeam/openDialog",
    "createTeam/create"
];
const $909c5e43d630b80c$export$74d8df99c7474c3b = [
    "removeTeamMember/openDialog",
    "removeTeamMember/submit"
];

});

parcelRegister("7YTpJ", function(module, exports) {

$parcel$export(module.exports, "filterExcludedMessages", () => $70081da22e1ca189$export$c29ee7cc86cf93b3);
$parcel$export(module.exports, "ORG_ARI_PREFIX", () => $70081da22e1ca189$export$1c01d3601a97c3b);
$parcel$export(module.exports, "fromV2ToTeamSearchViewFormat", () => $70081da22e1ca189$export$af61e778dfb162b1);
$parcel$export(module.exports, "trimUserARI", () => $70081da22e1ca189$export$4fd803d471120b8f);
const $70081da22e1ca189$var$EXCLUDED_GRAPHQL_ERROR_MESSAGES = [
    'TeamDeleted'
];
function $70081da22e1ca189$export$c29ee7cc86cf93b3(errors) {
    return errors.filter((error)=>$70081da22e1ca189$var$EXCLUDED_GRAPHQL_ERROR_MESSAGES.every((excludedMessage)=>!error.message.includes(excludedMessage)) && error?.extensions?.classification !== 'TEAMS_TEAM_DELETED');
}
const $70081da22e1ca189$export$ec4e6762fd0f4a48 = 'ari:cloud:teams::team/';
const $70081da22e1ca189$export$cfedc369802e0c68 = 'ari:cloud:identity::team/';
const $70081da22e1ca189$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $70081da22e1ca189$export$1c01d3601a97c3b = 'ari:cloud:platform::org/';
const $70081da22e1ca189$export$af61e778dfb162b1 = (nodes)=>{
    return nodes.map((node)=>{
        return {
            id: $70081da22e1ca189$export$5916b2f8faacfe5a(node.team.id),
            orgId: node.team.organizationId,
            membershipSettings: node.team.membershipSettings,
            description: node.team.description,
            displayName: node.team.displayName,
            state: node.team.state,
            largeAvatarImageUrl: node.team.largeAvatarImageUrl,
            smallAvatarImageUrl: node.team.smallAvatarImageUrl,
            largeHeaderImageUrl: node.team.largeHeaderImageUrl,
            smallHeaderImageUrl: node.team.smallHeaderImageUrl,
            members: node.team.members?.nodes?.filter((memberNode)=>memberNode.member?.id)?.map((memberNode)=>({
                    id: $70081da22e1ca189$export$4fd803d471120b8f(memberNode.member?.id),
                    status: memberNode.member?.accountStatus,
                    fullName: memberNode.member?.name || '',
                    avatarUrl: memberNode.member?.picture
                })),
            memberCount: node.memberCount,
            includesYou: node.includesYou,
            isVerified: node.team.isVerified
        };
    });
};
const $70081da22e1ca189$export$5916b2f8faacfe5a = (teamId = '')=>{
    return teamId.replace($70081da22e1ca189$export$cfedc369802e0c68, '').replace($70081da22e1ca189$export$ec4e6762fd0f4a48, ''); // PTC-4213 will remove the references to the old team ARI
};
const $70081da22e1ca189$export$4fd803d471120b8f = (userId = '')=>{
    return userId.replace($70081da22e1ca189$export$470b0d72e4fdc43a, '');
};
const $70081da22e1ca189$export$a94a044414e86bdc = (orgId)=>{
    return orgId?.replace($70081da22e1ca189$export$1c01d3601a97c3b, '');
};

});

parcelRegister("8ZB0E", function(module, exports) {

$parcel$export(module.exports, "useRovoAgentData", () => $4edf914651e30a7b$export$763c7f4444e7eb2d);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $4edf914651e30a7b$var$setAgentInfo = (data)=>({ setState: setState })=>{
        setState({
            agentData: data
        });
    };
const $4edf914651e30a7b$var$actions = {
    setAgentInfo: $4edf914651e30a7b$var$setAgentInfo
};
const $4edf914651e30a7b$var$RovoAgentStore = (0, $iXqE5.createStore)({
    initialState: {
        agentData: undefined
    },
    actions: $4edf914651e30a7b$var$actions
});
const $4edf914651e30a7b$export$6301922aaad7e8f5 = (0, $3sQ5x.createHook)($4edf914651e30a7b$var$RovoAgentStore, {
    selector: (state)=>state.agentData
});
const $4edf914651e30a7b$export$763c7f4444e7eb2d = (0, $3sQ5x.createHook)($4edf914651e30a7b$var$RovoAgentStore);

});

parcelRegister("3UaSs", function(module, exports) {

$parcel$export(module.exports, "App", () => $83a3ab3c620955c6$export$86fbec116b87613f);
$parcel$export(module.exports, "RelativeWrapperOfHeaderImage", () => $83a3ab3c620955c6$export$c0d0370fa0c37541);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");
const $83a3ab3c620955c6$export$86fbec116b87613f = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "ccxr90-0"
})`height:100%;*{box-sizing:border-box;}a:hover{text-decoration:none;}`;
const $83a3ab3c620955c6$export$c0d0370fa0c37541 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "ccxr90-1"
})`position:relative;`;

});

parcelRegister("9zycQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e61ddbfe684411c0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fff3y = parcelRequire("fff3y");

var $h6cEF = parcelRequire("h6cEF");
var $8sQBu = parcelRequire("8sQBu");

var $dXPcV = parcelRequire("dXPcV");
function $e61ddbfe684411c0$var$ContainersInProfilePage(props) {
    const { userId: userId, status: status, userFullName: userFullName } = props;
    const [{ principalUserId: principalUserId }] = (0, $fff3y.usePrincipalUser)();
    const { error: error, hasError: hasError, data: data, loading: loading } = (0, $dXPcV.default)({
        userId: userId,
        maxNumberOfCards: (0, $h6cEF.DEFAULT_CARDS_SIZE)
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8sQBu.default), {
        hasLoaded: !!data && !loading,
        isCurrentUser: principalUserId === userId,
        userStatus: status,
        hasError: hasError,
        error: error,
        items: data,
        userId: userId,
        userFullName: userFullName
    });
}
var $e61ddbfe684411c0$export$2e2bcd8739ae039 = $e61ddbfe684411c0$var$ContainersInProfilePage;

});
parcelRegister("h6cEF", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CARDS_SIZE", () => $64e4aa33d08e84c4$export$eea11e2ee6ebb03f);

var $8sQBu = parcelRequire("8sQBu");
const $64e4aa33d08e84c4$export$eea11e2ee6ebb03f = 4;

});
parcelRegister("8sQBu", function(module, exports) {

$parcel$export(module.exports, "default", () => $aebc9202d6bd8a73$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $ousew = parcelRequire("ousew");

var $VSDnB = parcelRequire("VSDnB");

var $414Wj = parcelRequire("414Wj");

var $ddc5X = parcelRequire("ddc5X");

var $bA8uW = parcelRequire("bA8uW");
var $jDqI3 = parcelRequire("jDqI3");
var $aOf1o = parcelRequire("aOf1o");
var $lHKVj = parcelRequire("lHKVj");
var $afcOx = parcelRequire("afcOx");

var $h4k2d = parcelRequire("h4k2d");

var $hIjCF = parcelRequire("hIjCF");

var $36A8W = parcelRequire("36A8W");

var $49Zpb = parcelRequire("49Zpb");
const $aebc9202d6bd8a73$var$MAX_PLACES_LIMIT = 50;
function $aebc9202d6bd8a73$var$ProfilePlaces(props) {
    const { hasError: hasError, error: error, hasLoaded: hasLoaded, isCurrentUser: isCurrentUser, userStatus: userStatus, items: items = [], userId: userId, userFullName: userFullName } = props;
    (0, $aOf1o.useExpTrackerStart)({
        id: userId,
        name: (0, $bA8uW.UserExperienceNames).USER_PROFILE_CONTAINERS,
        timeout: (0, $bA8uW.DEFAULT_TIMEOUT_USER_EXP)
    });
    (0, $lHKVj.useExpTrackerStop)({
        name: (0, $bA8uW.UserExperienceNames).USER_PROFILE_CONTAINERS,
        error: error
    });
    const renderSkeleton = ()=>{
        const defaultNumOfPlaces = 4;
        return Array(defaultNumOfPlaces).fill(undefined).map((_, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $36A8W.default), {
                type: "space",
                name: "",
                path: "",
                hasLoaded: false
            }, `item-${index}`));
    };
    const renderPlacesList = ()=>{
        /**
		 * NOTE: Following is just a hack to limit the total number of boards.
		 * In real life the total number of places will be far less than this.
		 * But since there's no guarantee that the backend will not be sending
		 * a very large number of boards, the following limit is enforced.
		 */ const places = items.slice(0, $aebc9202d6bd8a73$var$MAX_PLACES_LIMIT);
        const Wrapper = (0, $VSDnB.fg)('user-profile-refresh') ? $aebc9202d6bd8a73$var$ListWrapper : $49Zpb.ProfilePlacesList;
        return /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapper, {
            "data-test-selector": "profile-places",
            children: hasLoaded ? places.map((item)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $36A8W.default), {
                    type: item.type,
                    name: item.name,
                    path: item.path,
                    icon: item.icon,
                    hasLoaded: true
                }, `${item.type}-${item.name}`)) : renderSkeleton()
        });
    };
    const headline = isCurrentUser ? $aebc9202d6bd8a73$export$defe85febe8b728c.ownerHeadline : userStatus === (0, $afcOx.UserStatus).inactive || userStatus === (0, $afcOx.UserStatus).closed ? $aebc9202d6bd8a73$export$defe85febe8b728c.otherHeadlinePast : $aebc9202d6bd8a73$export$defe85febe8b728c.otherHeadline;
    // loading --> rendering skeleton
    // not loading + empty data --> rendering empty state and ExperienceSuccess
    // not loading + has error --> rendering nothing and "useExpTrackerStop" will trigger the stop experience event.
    // not loading + has data --> render UI and ExperienceSuccess
    if (hasLoaded && !hasError && items.length === 0) {
        const ListWrapper = (0, $VSDnB.fg)('user-profile-refresh') ? (0, $ddc5X.ItemWrapper) : $49Zpb.EmptyPlacesList;
        // trigger success event when data is loaded but it's empty
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hIjCF.PanelContent), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hIjCF.PanelContentHeader), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hIjCF.PanelContentTitle), {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...headline
                        })
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)(ListWrapper, {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h4k2d.default), {
                        isCurrentUser: isCurrentUser || false,
                        userFullName: userFullName,
                        userStatus: userStatus
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jDqI3.ExperienceSuccess), {
                    hasLoaded: true,
                    name: (0, $bA8uW.UserExperienceNames).USER_PROFILE_CONTAINERS
                })
            ]
        });
    }
    if (hasError) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hIjCF.PanelContent), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hIjCF.PanelContentHeader), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hIjCF.PanelContentTitle), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...headline
                    })
                })
            }),
            renderPlacesList(),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jDqI3.ExperienceSuccess), {
                hasLoaded: hasLoaded && !hasError,
                name: (0, $bA8uW.UserExperienceNames).USER_PROFILE_CONTAINERS
            })
        ]
    });
}
const $aebc9202d6bd8a73$var$ListWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $414Wj.default), {
        space: "space.150",
        "data-test-selector": "profile-places",
        children: children
    });
};
const $aebc9202d6bd8a73$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    ownerHeadline: {
        id: 'pf-home.profile-page.places-list.owner.headline',
        defaultMessage: 'Places you work in',
        description: 'Section headline for Places where a users personal Confluence space and Jira boards shown to profile owner'
    },
    otherHeadline: {
        id: 'pf-home.profile-page.places-list.other.headline',
        defaultMessage: 'Places they work in',
        description: 'Section headline for Places where a users personal Confluence space and Jira boards shown to a profile visitor'
    },
    otherHeadlinePast: {
        id: 'pf-home.profile-page.places-list.other.headline-past',
        defaultMessage: 'Places they work in',
        description: 'Section headline for Places where a deactivated or deleted users personal Confluence space and Jira boards shown to a profile visitor'
    }
});
var $aebc9202d6bd8a73$export$2e2bcd8739ae039 = $aebc9202d6bd8a73$var$ProfilePlaces;

});
parcelRegister("ddc5X", function(module, exports) {

$parcel$export(module.exports, "ItemWrapper", () => $355a088641e11845$export$ef9839ae55b8ba40);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $MHKc7 = parcelRequire("MHKc7");
const $355a088641e11845$var$styles = {
    wrapper: "_2rkopd34 _189ee4h9 _1h6dmuej _1dqonqa1 _kqswh2mm _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvutpp _p12f1osq",
    extraPadding: "_ca0qv47k _u5f3xy5q _n3tdv47k _19bvxy5q"
};
const $355a088641e11845$export$ef9839ae55b8ba40 = ({ testId: testId, children: children, extraPadding: extraPadding, testSelector: testSelector, ...rest })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        backgroundColor: "elevation.surface",
        xcss: (0, $3JT92.cx)($355a088641e11845$var$styles.wrapper, extraPadding && $355a088641e11845$var$styles.extraPadding),
        testId: testId,
        "data-test-selector": testSelector,
        ...rest,
        children: children
    });
};

});

parcelRegister("jDqI3", function(module, exports) {

$parcel$export(module.exports, "ExperienceSuccess", () => $eed2d630b0ff4506$export$4962f3898bd5c829);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $oRoJ1 = parcelRequire("oRoJ1");
function $eed2d630b0ff4506$export$4962f3898bd5c829(props) {
    const { hasLoaded: hasLoaded, name: name, attributes: attributes } = props;
    if (!hasLoaded) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $oRoJ1.ExperienceSuccess), {
        name: name,
        attributes: attributes
    });
}

});
parcelRegister("oRoJ1", function(module, exports) {

$parcel$export(module.exports, "ExperienceSuccess", () => $c3bbc3576721f681$export$4962f3898bd5c829);

var $5uXOq = parcelRequire("5uXOq");

var $bSOOm = parcelRequire("bSOOm");
function $c3bbc3576721f681$export$4962f3898bd5c829({ name: name, attributes: attributes }) {
    const experienceTracker = (0, $5uXOq.useContext)((0, $bSOOm.ExperienceTrackerContext));
    (0, $5uXOq.useEffect)(()=>experienceTracker.succeed({
            name: name,
            attributes: attributes
        }), [
        name,
        attributes,
        experienceTracker
    ]);
    return null;
}

});


parcelRegister("afcOx", function(module, exports) {

$parcel$export(module.exports, "UserStatus", () => $2e4870bf45f0be88$export$a82073022ded66e8);
$parcel$export(module.exports, "FieldType", () => $2e4870bf45f0be88$export$ed12481c953b8653);
var $2e4870bf45f0be88$export$ef730685c1b8e238 = /*#__PURE__*/ function(UserPrivacyLevel) {
    UserPrivacyLevel["private"] = "private";
    UserPrivacyLevel["domain"] = "domain";
    UserPrivacyLevel["public"] = "public";
    return UserPrivacyLevel;
}({});
var $2e4870bf45f0be88$export$a82073022ded66e8 = /*#__PURE__*/ function(UserStatus) {
    UserStatus["active"] = "active";
    UserStatus["inactive"] = "inactive";
    UserStatus["closed"] = "closed";
    return UserStatus;
}({});
var $2e4870bf45f0be88$export$ed12481c953b8653 = /*#__PURE__*/ function(FieldType) {
    FieldType["FullName"] = "fullName";
    FieldType["Nickname"] = "nickname";
    FieldType["Title"] = "title";
    FieldType["Department"] = "department";
    FieldType["CompanyName"] = "companyName";
    FieldType["Location"] = "location";
    FieldType["Timezone"] = "timezone";
    FieldType["Email"] = "email";
    FieldType["PhoneNumber"] = "phoneNumber";
    FieldType["Avatar"] = "picture";
    FieldType["Language"] = "language";
    FieldType["LocalTime"] = "localTime";
    FieldType["RemoteWeekdayIndex"] = "remoteWeekdayIndex";
    FieldType["RemoteWeekdayString"] = "remoteWeekdayString";
    FieldType["RemoteTimeString"] = "remoteTimeString";
    return FieldType;
}({});
var $2e4870bf45f0be88$export$a9678af7d3f0f4cb = /*#__PURE__*/ function(IdentityFieldName) {
    IdentityFieldName["PHONE_NUMBER"] = "phone_number";
    IdentityFieldName["JOB_TITLE"] = "job_title";
    IdentityFieldName["DEPARTMENT"] = "department";
    IdentityFieldName["COMPANY_NAME"] = "organization";
    IdentityFieldName["LOCATION"] = "location";
    IdentityFieldName["ZONEINFO"] = "zoneinfo";
    IdentityFieldName["NAME"] = "name";
    IdentityFieldName["EMAIL"] = "email";
    return IdentityFieldName;
}({});

});

parcelRegister("h4k2d", function(module, exports) {

$parcel$export(module.exports, "default", () => $31ae20232f92a5d0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $afcOx = parcelRequire("afcOx");

var $k3GIb = parcelRequire("k3GIb");

var $4T1R9 = parcelRequire("4T1R9");
const $31ae20232f92a5d0$var$EmptyPlacesListState = ({ isCurrentUser: isCurrentUser, userFullName: userFullName, userStatus: userStatus })=>{
    const intl = (0, $koVbs.default)();
    const renderDescText = ()=>{
        const descMessage = isCurrentUser ? $31ae20232f92a5d0$var$messages.noPlacesListOwnerDesc : userStatus === (0, $afcOx.UserStatus).inactive || userStatus === (0, $afcOx.UserStatus).closed ? $31ae20232f92a5d0$var$messages.noPlacesListPastUserDesc : $31ae20232f92a5d0$var$messages.noPlacesListOtherDesc;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...descMessage,
            values: {
                user: userFullName
            }
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k3GIb.default), {
        title: intl.formatMessage($31ae20232f92a5d0$var$messages.noPlacesListTitle),
        description: renderDescText(),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($4T1R9)))
    });
};
const $31ae20232f92a5d0$var$messages = (0, $7VHMR.defineMessages)({
    noPlacesListTitle: {
        id: 'ptc-directory.profile-page.places-list.no-places-list.title',
        defaultMessage: "We don\u2019t have places to show here yet",
        description: 'Title of the message displayed when there is no places associated to the profile that is being viewed'
    },
    noPlacesListOwnerDesc: {
        id: 'ptc-directory.profile-page.places-list.no-places-list.owner.description',
        defaultMessage: "There are no projects or spaces you\u2019ve worked in across the last 90 days.",
        description: 'Description of the message displayed when there is no places associated to the owner profile that is being viewed'
    },
    noPlacesListOtherDesc: {
        id: 'ptc-directory.profile-page.places-list.no-places-list.other.description',
        defaultMessage: "{user} hasn\u2019t worked in any projects or spaces in the last 90 days.",
        description: 'Description of the message displayed when there is no places associated to the person profile that is being viewed'
    },
    noPlacesListPastUserDesc: {
        id: 'ptc-directory.profile-page.places-list.no-places-list.past-user.description',
        defaultMessage: "{user}\u2019s account is deactivated or deleted. We can\u2019t show the projects or spaces {user} worked in across the last 90 days.",
        description: 'Description of the message displayed when there is no places associated to a deactivated or deleted users profile that is being viewed'
    }
});
var $31ae20232f92a5d0$export$2e2bcd8739ae039 = $31ae20232f92a5d0$var$EmptyPlacesListState;

});
parcelRegister("k3GIb", function(module, exports) {

$parcel$export(module.exports, "default", () => $285cf07fe4a32b56$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $9mq25 = parcelRequire("9mq25");
function $285cf07fe4a32b56$export$c696c866211ccfa4({ title: title, description: description, image: image, imageUrl: imageUrl, actions: actions, py: py, px: px, testId: testId }) {
    const img = imageUrl ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9mq25.EmptyStateImage), {
        src: imageUrl
    }) : image;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9mq25.EmptyStateContainer), {
        py: py,
        px: px,
        "data-testid": testId,
        children: [
            img && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9mq25.EmptyStateImageContainer), {
                children: img
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9mq25.EmptyStateBody), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9mq25.EmptyStateTitle), {
                        children: title
                    }),
                    description && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9mq25.EmptyStateDescription), {
                        children: description
                    }),
                    actions && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9mq25.EmptyStateActions), {
                        children: actions
                    })
                ]
            })
        ]
    });
}
var $285cf07fe4a32b56$export$2e2bcd8739ae039 = $285cf07fe4a32b56$export$c696c866211ccfa4;

});
parcelRegister("9mq25", function(module, exports) {

$parcel$export(module.exports, "EmptyStateContainer", () => $8566c66dc785b8a1$export$2a511c47e1cb5779);
$parcel$export(module.exports, "EmptyStateImageContainer", () => $8566c66dc785b8a1$export$bd5d2fea0a40a42f);
$parcel$export(module.exports, "EmptyStateImage", () => $8566c66dc785b8a1$export$a7907bb86a15af4e);
$parcel$export(module.exports, "EmptyStateBody", () => $8566c66dc785b8a1$export$df244a6e5075ebb4);
$parcel$export(module.exports, "EmptyStateTitle", () => $8566c66dc785b8a1$export$54260be545246e4e);
$parcel$export(module.exports, "EmptyStateDescription", () => $8566c66dc785b8a1$export$242239d9c1732d0a);
$parcel$export(module.exports, "EmptyStateActions", () => $8566c66dc785b8a1$export$725343b91068621d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $k5uoT = parcelRequire("k5uoT");

var $bWGt6 = parcelRequire("bWGt6");
function $8566c66dc785b8a1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8566c66dc785b8a1$var$gridSizeTimes = (factor)=>(0, $k5uoT.gridSize)() * factor;
const $8566c66dc785b8a1$export$2a511c47e1cb5779 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1i83sxm6"
})((props)=>({
        position: 'relative',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `${$8566c66dc785b8a1$var$gridSizeTimes(props.py || 4)}px ${$8566c66dc785b8a1$var$gridSizeTimes(props.px || 7)}px`,
        transition: 'box-shadow 0.25s ease',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center'
    }));
const $8566c66dc785b8a1$export$bd5d2fea0a40a42f = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1i83sxm5"
})({
    display: 'flex',
    flex: '0 0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${$8566c66dc785b8a1$var$gridSizeTimes(15)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxHeight: `${$8566c66dc785b8a1$var$gridSizeTimes(15)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginRight: `${$8566c66dc785b8a1$var$gridSizeTimes(4)}px`,
    justifyContent: 'center',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    svg: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `${$8566c66dc785b8a1$var$gridSizeTimes(15)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxHeight: `${$8566c66dc785b8a1$var$gridSizeTimes(15)}px`
    }
});
const $8566c66dc785b8a1$export$a7907bb86a15af4e = /*#__PURE__*/ (0, $bWGt6.default)("img", {
    target: "e1i83sxm4"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${$8566c66dc785b8a1$var$gridSizeTimes(15)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxHeight: `${$8566c66dc785b8a1$var$gridSizeTimes(15)}px`
});
const $8566c66dc785b8a1$export$df244a6e5075ebb4 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1i83sxm3"
})({
    name: "p4355k",
    styles: "min-width:180px"
});
const $8566c66dc785b8a1$export$54260be545246e4e = /*#__PURE__*/ (0, $bWGt6.default)("h3", {
    target: "e1i83sxm2"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginBottom: `${$8566c66dc785b8a1$var$gridSizeTimes(2)}px`
});
const $8566c66dc785b8a1$export$242239d9c1732d0a = /*#__PURE__*/ (0, $bWGt6.default)("p", {
    target: "e1i83sxm1"
})({
    name: "0",
    styles: ""
});
const $8566c66dc785b8a1$export$725343b91068621d = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1i83sxm0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginTop: `${$8566c66dc785b8a1$var$gridSizeTimes(2)}px`
});

});


parcelRegister("4T1R9", function(module, exports) {
module.exports = new URL("PlacesListEmpty_ptc.36d458cf.svg", import.meta.url).toString();

});


parcelRegister("hIjCF", function(module, exports) {

$parcel$export(module.exports, "PanelContent", () => $7533baea2253dd05$export$d30ae7d97aafb468);
$parcel$export(module.exports, "PanelContentHeader", () => $7533baea2253dd05$export$eb71a19746598b2f);
$parcel$export(module.exports, "PanelContentTitle", () => $7533baea2253dd05$export$c703356189ebc2de);
$parcel$export(module.exports, "PanelContentBody", () => $7533baea2253dd05$export$c75fef9a59663656);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");

const $7533baea2253dd05$export$d30ae7d97aafb468 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1r5dj51-0"
})``;
const $7533baea2253dd05$export$eb71a19746598b2f = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1r5dj51-1"
})`display:flex;flex-direction:row;justify-content:space-between;margin-bottom:${(props)=>props.hasSubInfo ? "var(--ds-space-050, 4px)" : "var(--ds-space-200, 16px)"};position:relative;`;
const $7533baea2253dd05$export$c703356189ebc2de = /*#__PURE__*/ (0, $47bDC.default).h2.withConfig({
    componentId: "sc-1r5dj51-2"
})`font:${"var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};margin-top:0;word-break:'break-all';`;
const $7533baea2253dd05$export$58f06e463130acb4 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1r5dj51-3"
})`background:${`var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`};border-radius:${"var(--ds-border-radius-100, 3px)"};padding:${"var(--ds-space-100, 8px)"};`;
const $7533baea2253dd05$export$c75fef9a59663656 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1r5dj51-4"
})`background:${`var(--ds-surface-raised, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`};border-radius:${"var(--ds-border-radius-100, 3px)"};box-shadow:${`var(--ds-shadow-raised, ${`0 1px 1px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px 1px ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)}`})`};padding-top:${"var(--ds-space-200, 16px)"};padding-bottom:${"var(--ds-space-200, 16px)"};padding-left:${"var(--ds-space-075, 6px)"};padding-right:${"var(--ds-space-075, 6px)"};`;

});

parcelRegister("36A8W", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5d7bf0b894092bc$export$2e2bcd8739ae039);

var $5EtDt = parcelRequire("5EtDt");
var $d5d7bf0b894092bc$export$2e2bcd8739ae039 = (0, $5EtDt.default);

});
parcelRegister("5EtDt", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1e9b8002a005154$export$2e2bcd8739ae039);
/* ProfilePlacesItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");

var $9xuGL = parcelRequire("9xuGL");

var $dME4E = parcelRequire("dME4E");

var $8woxI = parcelRequire("8woxI");

var $iwwXK = parcelRequire("iwwXK");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $ddc5X = parcelRequire("ddc5X");

var $fyzT1 = parcelRequire("fyzT1");
var $gBNI9 = parcelRequire("gBNI9");
var $grAcD = parcelRequire("grAcD");
var $38ra6 = parcelRequire("38ra6");

var $la5R9 = parcelRequire("la5R9");
const $c1e9b8002a005154$var$styles = {
    skeletonItem: "_18zrze3t _1tke7vkz",
    skeletonItemWithIcon: "_18zrze3t _1tke1f4h",
    skeletonItemSpacing: "_6rth1b66"
};
const $c1e9b8002a005154$export$d4349a8ff634836e = $la5R9.PlaceLink;
const $c1e9b8002a005154$var$MainIcon = ({ icon: icon, type: type })=>{
    if (icon) return /*#__PURE__*/ (0, $2OMIu.jsx)($la5R9.BaseIcon, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ujWmd.default), {
            size: "small",
            src: icon,
            appearance: "square"
        })
    });
    if (type === 'space') return /*#__PURE__*/ (0, $2OMIu.jsx)($la5R9.SpaceIcon, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9xuGL))), {
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($8woxI))),
            color: "currentColor",
            LEGACY_size: "medium",
            spacing: "spacious",
            label: ""
        })
    });
    else if (type === 'board') return /*#__PURE__*/ (0, $2OMIu.jsx)($la5R9.BoardIcon, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dME4E))), {
            color: "currentColor",
            LEGACY_size: "medium",
            spacing: "spacious",
            label: ""
        })
    });
    return null;
};
const $c1e9b8002a005154$var$HeaderIcon = ({ type: type })=>{
    switch(type){
        case 'space':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gBNI9.default), {
                size: "xxsmall",
                productKey: (0, $grAcD.ShortProductKey).CONFLUENCE
            });
        case 'board':
        case 'project':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gBNI9.default), {
                size: "xxsmall",
                productKey: (0, $grAcD.ShortProductKey).JIRA
            });
        default:
            return null;
    }
};
function $c1e9b8002a005154$var$typeToTitle(type) {
    switch(type){
        case 'space':
            return 'Confluence';
        case 'board':
        case 'project':
            return 'Jira';
        default:
            return '';
    }
}
const $c1e9b8002a005154$export$a67ff5ee53b7f29a = (props)=>{
    const analytics = (0, $38ra6.default)();
    const { name: name, path: path, type: type, hasLoaded: hasLoaded } = props;
    const handleAnchorClick = ()=>{
        analytics.pushUIEvent({
            source: (0, $fyzT1.AnalyticsEventSource).USER_PROFILE_SCREEN,
            actionSubject: 'placesLink',
            action: (0, $fyzT1.AnalyticsEventActions).CLICKED,
            attributes: {
                type: type
            }
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)($c1e9b8002a005154$var$PlacesItem, {
        children: hasLoaded ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)($la5R9.Header, {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)($la5R9.HeaderIcon, {
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)($c1e9b8002a005154$var$HeaderIcon, {
                                type: type
                            })
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)($la5R9.HeaderTitle, {
                            children: $c1e9b8002a005154$var$typeToTitle(type)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)($la5R9.Content, {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)($c1e9b8002a005154$var$MainIcon, {
                            ...props
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)($la5R9.Details, {
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)($c1e9b8002a005154$export$d4349a8ff634836e, {
                                href: path,
                                onClick: handleAnchorClick,
                                children: name
                            })
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    xcss: $c1e9b8002a005154$var$styles.skeletonItemSpacing,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwwXK.default), {
                        isShimmering: true,
                        width: "150px",
                        xcss: $c1e9b8002a005154$var$styles.skeletonItem
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwwXK.default), {
                    hasIcon: true,
                    isShimmering: true,
                    xcss: $c1e9b8002a005154$var$styles.skeletonItemWithIcon
                })
            ]
        })
    });
};
const $c1e9b8002a005154$var$PlacesItem = ({ children: children })=>(0, $VSDnB.fg)('user-profile-refresh') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ddc5X.ItemWrapper), {
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($la5R9.PlacesItem, {
        children: children
    });
var $c1e9b8002a005154$export$2e2bcd8739ae039 = $c1e9b8002a005154$export$a67ff5ee53b7f29a;

});
parcelRegister("8woxI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $63445998dc5f82bb$var$_react = $63445998dc5f82bb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $63445998dc5f82bb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $63445998dc5f82bb$var$FolderFilledIcon = (props)=>/*#__PURE__*/ $63445998dc5f82bb$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.2 6h7.81C21.108 6 22 6.893 22 7.992v11.016c0 1.1-.898 1.992-1.99 1.992H3.99A1.99 1.99 0 0 1 2 19.008V5.006C2 3.898 2.896 3 3.997 3h5.006c1.103 0 2.327.826 2.742 1.862z"/></svg>`
    }, props));
$63445998dc5f82bb$var$FolderFilledIcon.displayName = 'FolderFilledIcon';
var $63445998dc5f82bb$var$_default = module.exports.default = $63445998dc5f82bb$var$FolderFilledIcon;

});

parcelRegister("gBNI9", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f7789eb0040e355$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $iMzG0 = parcelRequire("iMzG0");
var $7anl7 = parcelRequire("7anl7");
var $29YN9 = parcelRequire("29YN9");
var $epnSS = parcelRequire("epnSS");
var $JDSfd = parcelRequire("JDSfd");
var $gOcFi = parcelRequire("gOcFi");

var $grAcD = parcelRequire("grAcD");
function $6f7789eb0040e355$export$2e2bcd8739ae039(props) {
    const { productKey: productKey, size: size = 'small', defaultIcon: defaultIcon = null, productName: productName } = props;
    // @atlaskit/logo is updating `xsmall` to `xxsmall` to introduce a new size.
    let updatedSize = size === 'xsmall' ? 'xxsmall' : size;
    const mapProductKeyToIcon = {
        [(0, $grAcD.ShortProductKey).JIRA]: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $29YN9.JiraIcon), {
            size: updatedSize,
            label: productName || 'Jira',
            appearance: "brand"
        }),
        [(0, $grAcD.ShortProductKey).CONFLUENCE]: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7anl7.ConfluenceIcon), {
            size: updatedSize,
            label: productName || 'Confluence',
            appearance: "brand"
        }),
        [(0, $grAcD.ShortProductKey).JIRA_SOFTWARE]: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $JDSfd.JiraSoftwareIcon), {
            size: updatedSize,
            label: productName || 'Jira',
            appearance: "brand"
        }),
        [(0, $grAcD.ShortProductKey).JIRA_SERVICE_DESK]: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $epnSS.JiraServiceManagementIcon), {
            size: updatedSize,
            label: productName || 'Jira',
            appearance: "brand"
        }),
        [(0, $grAcD.ShortProductKey).JIRA_CORE]: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gOcFi.JiraWorkManagementIcon), {
            size: updatedSize,
            label: productName || 'Jira',
            appearance: "brand"
        }),
        [(0, $grAcD.ShortProductKey).BITBUCKET]: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iMzG0.BitbucketIcon), {
            size: updatedSize,
            label: productName || 'Bitbucket',
            appearance: "brand"
        })
    };
    return productKey && mapProductKeyToIcon[productKey] ? mapProductKeyToIcon[productKey] : defaultIcon;
}

});
parcelRegister("iMzG0", function(module, exports) {

$parcel$export(module.exports, "BitbucketIcon", () => $0af9b15279bc8ff1$export$5fc1066e677788d4);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $hxoiH = parcelRequire("hxoiH");

var $lEsIP = parcelRequire("lEsIP");

var $6PPEt = parcelRequire("6PPEt");

var $iVs6J = parcelRequire("iVs6J");
const $0af9b15279bc8ff1$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $6PPEt.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="m25.586 15.819-1.618 9.885c-.106.598-.528.95-1.126.95H9.122c-.598 0-1.02-.352-1.126-.95L5.146 8.08c-.105-.598.212-.985.775-.985h20.123c.562 0 .88.387.773.985l-.773 4.644c-.106.668-.493.95-1.126.95H12.816c-.176 0-.282.105-.246.316l.95 5.84c.035.14.14.246.281.246h4.362c.141 0 .246-.105.282-.246l.668-4.222c.07-.527.422-.738.915-.738h4.75c.703 0 .914.351.808.95"/>
    </svg>`;
};
const $0af9b15279bc8ff1$export$5fc1066e677788d4 = ({ appearance: appearance, label: label = 'Bitbucket', size: size = (0, $lEsIP.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lEsIP.defaultLogoParams).iconColor, textColor: textColor = (0, $lEsIP.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iVs6J.default), {
        appearance: appearance,
        label: label,
        svg: $0af9b15279bc8ff1$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("JDSfd", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareIcon", () => $96323ff1b52d1676$export$c3835feba2a66e67);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $9KnKW = parcelRequire("9KnKW");

var $hxoiH = parcelRequire("hxoiH");

var $lEsIP = parcelRequire("lEsIP");

var $6PPEt = parcelRequire("6PPEt");

var $iVs6J = parcelRequire("iVs6J");
const $96323ff1b52d1676$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode, id)=>{
    let colors = {
        iconGradientStart: (0, $lEsIP.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, $lEsIP.legacyDefaultLogoParams).iconGradientStart,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $6PPEt.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return `
  <svg viewBox="0 0 32 32" height="32" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">
    <defs>
      <linearGradient x1="108.695%" x2="12.439%" y1="-14.936%" y2="45.215%" id="${id}-1">
        <stop stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} offset="0%"></stop>
        <stop stop-color="${colors.iconGradientStop}" offset="100%"></stop>
      </linearGradient>
      <linearGradient x1="0%" x2="91.029%" y1="118.55%" y2="63.971%" id="${id}-2">
        <stop stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} offset="0%"></stop>
        <stop stop-color="${colors.iconGradientStop}" offset="100%"></stop>
      </linearGradient>
    </defs>
    <g stroke="none" stroke-width="1" fill-rule="nonzero">
      <path fill="${colors.iconColor}" d="M15.9669691 29.3616152C17.2195568 28.1097726 17.9233158 26.4114623 17.9233158 24.6405626 17.9233158 22.8696629 17.2195568 21.1713527 15.9669691 19.91951L7.26805808 11.2489111 3.31143376 15.2055354C2.89743442 15.6200502 2.89743442 16.291565 3.31143376 16.7060799L15.9669691 29.3616152zM28.6225045 15.2055354L15.9669691 2.55 15.9280399 2.58892922C13.3485687 5.19994003 13.3612164 9.40374108 15.9563521 11.9991833L24.6623412 20.6662432 28.6225045 16.7060799C29.0365039 16.291565 29.0365039 15.6200502 28.6225045 15.2055354z" />
      <path fill="url(#${id}-1" d="M15.9669691,11.9921053 C13.3718335,9.39666304 13.3591857,5.19286199 15.938657,2.58185118 L6.91061706,11.6063521 L11.6316697,16.3274047 L15.9669691,11.9921053 Z" />
      <path fill="url(#${id}-2" d="M20.2951906,15.5912886 L15.9669691,19.91951 C17.2195568,21.1713527 17.9233158,22.8696629 17.9233158,24.6405626 C17.9233158,26.4114623 17.2195568,28.1097726 15.9669691,29.3616152 L25.0162432,20.3123412 L20.2951906,15.5912886 Z" />
    </g>
  </svg>`;
};
const $96323ff1b52d1676$export$c3835feba2a66e67 = ({ appearance: appearance, label: label = 'Jira Software', size: size = (0, $lEsIP.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lEsIP.defaultLogoParams).iconColor, textColor: textColor = (0, $lEsIP.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    const id = (0, $9KnKW.useId)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iVs6J.default), {
        appearance: appearance,
        label: label,
        svg: $96323ff1b52d1676$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("gOcFi", function(module, exports) {

$parcel$export(module.exports, "JiraWorkManagementIcon", () => $1e0c574ab61cf9f9$export$7330b9fc5718fd30);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $9KnKW = parcelRequire("9KnKW");

var $hxoiH = parcelRequire("hxoiH");

var $lEsIP = parcelRequire("lEsIP");

var $6PPEt = parcelRequire("6PPEt");

var $iVs6J = parcelRequire("iVs6J");
const $1e0c574ab61cf9f9$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode, id)=>{
    let colors = {
        iconGradientStart: (0, $lEsIP.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, $lEsIP.legacyDefaultLogoParams).iconGradientStart,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $6PPEt.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return `
    <svg
      fill="none"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <linearGradient
        id="${id}"
        gradientUnits="userSpaceOnUse"
        x1="13.9485"
        x2="20.7792"
        y1="20.2388"
        y2="11.8277"
      >
        <stop offset="0" stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} />
        <stop offset="100%" stop-color="${colors.iconGradientStop}" />
      </linearGradient>
      <path
        d="m18.3893 7-3.4257 13.1867c4.3592 1.2052 7.8383-.3558 9.1709-5.4802l1.9988-7.6973z"
        fill="url(#${id})"
      />
      <path
      fill="${colors.iconColor}"
      d="m13.7566 24.8265 3.4257-13.1866c-4.3623-1.196-7.8383.3649-9.17087 5.4985l-2.01143 7.6881z"
      />
    </svg>`;
};
const $1e0c574ab61cf9f9$export$7330b9fc5718fd30 = ({ appearance: appearance, label: label = 'Jira Work Management', size: size = (0, $lEsIP.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lEsIP.defaultLogoParams).iconColor, textColor: textColor = (0, $lEsIP.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    const id = (0, $9KnKW.useId)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iVs6J.default), {
        appearance: appearance,
        label: label,
        svg: $1e0c574ab61cf9f9$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("grAcD", function(module, exports) {

$parcel$export(module.exports, "ShortProductKey", () => $8afd1569bdb4f7a5$export$736dd0bf2ecc436f);
$parcel$export(module.exports, "ProductName", () => $8afd1569bdb4f7a5$export$acdfad52bc8c6626);
/**
 * ShortProductKey is used in code. It should not have a special characters or empty space
 */ var $8afd1569bdb4f7a5$export$736dd0bf2ecc436f = /*#__PURE__*/ function(ShortProductKey) {
    ShortProductKey["CONFLUENCE"] = "confluence";
    ShortProductKey["JIRA"] = "jira";
    ShortProductKey["JIRA_CORE"] = "jira_core";
    ShortProductKey["JIRA_SOFTWARE"] = "jira_software";
    ShortProductKey["JIRA_SERVICE_DESK"] = "jira_service_key";
    ShortProductKey["BITBUCKET"] = "bitbucket";
    return ShortProductKey;
}({});
var $8afd1569bdb4f7a5$export$acdfad52bc8c6626 = /*#__PURE__*/ function(ProductName) {
    ProductName["CONFLUENCE"] = "Confluence";
    ProductName["JIRA"] = "Jira";
    ProductName["JIRA_CORE"] = "Jira Core";
    ProductName["JIRA_SOFTWARE"] = "Jira Software";
    ProductName["JIRA_SERVICE_DESK"] = "Jira Service Desk";
    ProductName["BITBUCKET"] = "Bitbucket";
    ProductName["TEAM_CENTRAL"] = "Team Central";
    ProductName["ATLAS"] = "Atlas";
    ProductName["HOME"] = "Atlassian Home";
    return ProductName;
}({});
var $8afd1569bdb4f7a5$export$fc3a4bf3fb08b1b4 = /*#__PURE__*/ function(LongProductKey) {
    LongProductKey["JIRA_CORE"] = "jira-core.ondemand";
    LongProductKey["JIRA_SOFTWARE"] = "jira-software.ondemand";
    LongProductKey["CONFLUENCE"] = "confluence.ondemand";
    LongProductKey["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
    LongProductKey["BITBUCKET"] = "bitbucket";
    return LongProductKey;
}({});

});


parcelRegister("la5R9", function(module, exports) {

$parcel$export(module.exports, "BaseIcon", () => $b9651884ef5baecb$export$20931e2295160b07);
$parcel$export(module.exports, "PlacesItem", () => $b9651884ef5baecb$export$834d50fab48eb11a);
$parcel$export(module.exports, "Header", () => $b9651884ef5baecb$export$8b251419efc915eb);
$parcel$export(module.exports, "HeaderIcon", () => $b9651884ef5baecb$export$3a4bb31ac4bd7451);
$parcel$export(module.exports, "HeaderTitle", () => $b9651884ef5baecb$export$edb76fdb8665f52);
$parcel$export(module.exports, "Content", () => $b9651884ef5baecb$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "SpaceIcon", () => $b9651884ef5baecb$export$38ffce4a7986ba20);
$parcel$export(module.exports, "BoardIcon", () => $b9651884ef5baecb$export$2f9da8868573b55d);
$parcel$export(module.exports, "Details", () => $b9651884ef5baecb$export$3e8048d3cf2ba3fd);
$parcel$export(module.exports, "PlaceLink", () => $b9651884ef5baecb$export$d4349a8ff634836e);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");


var $3FhRS = parcelRequire("3FhRS");
const $b9651884ef5baecb$export$20931e2295160b07 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-6lxli0-0"
})`border-radius:${"var(--ds-border-radius-100, 3px)"};display:flex;width:${"var(--ds-space-300, 24px)"};height:${"var(--ds-space-300, 24px)"};color:${`var(--ds-surface-raised, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`};margin-left:${"var(--ds-space-050, 4px)"};margin-top:${"var(--ds-space-050, 4px)"};margin-right:${"var(--ds-space-150, 12px)"};span{display:flex;align-items:center;justify-content:center;}svg{width:${"var(--ds-space-250, 20px)"};height:${"var(--ds-space-250, 20px)"};}img{width:${"var(--ds-space-300, 24px)"};height:${"var(--ds-space-300, 24px)"};}`;
const $b9651884ef5baecb$export$834d50fab48eb11a = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-6lxli0-1"
})`position:relative;border-radius:${"var(--ds-border-radius-100, 3px)"};padding:${"var(--ds-space-150, 12px)"} ${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"} ${"var(--ds-space-150, 12px)"};background:${`var(--ds-surface-raised, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`};box-shadow:${`var(--ds-shadow-raised, ${`0 1px 1px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px 1px ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)}`})`};transition:box-shadow 0.25s ease;overflow:hidden;display:flex;flex-direction:column;&:hover,&.active{box-shadow:${`var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`};}`;
const $b9651884ef5baecb$export$8b251419efc915eb = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-6lxli0-2"
})`display:flex;flex-direction:row;align-items:center;margin-bottom:${"var(--ds-space-050, 4px)"};`;
const $b9651884ef5baecb$export$3a4bb31ac4bd7451 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-6lxli0-3"
})`display:flex;margin-left:${"var(--ds-space-025, 2px)"};margin-right:${"var(--ds-space-050, 4px)"};width:${"var(--ds-space-200, 16px)"};height:${"var(--ds-space-200, 16px)"};color:${`var(--ds-icon-brand, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`};`;
const $b9651884ef5baecb$export$edb76fdb8665f52 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-6lxli0-4"
})`font:${"var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};margin-top:0px;`;
const $b9651884ef5baecb$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-6lxli0-5"
})`display:flex;align-items:center;`;
const $b9651884ef5baecb$export$38ffce4a7986ba20 = /*#__PURE__*/ (0, $47bDC.default)($b9651884ef5baecb$export$20931e2295160b07).withConfig({
    componentId: "sc-6lxli0-6"
})`background:${`var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`};display:grid;place-items:center;`;
const $b9651884ef5baecb$export$2f9da8868573b55d = /*#__PURE__*/ (0, $47bDC.default)($b9651884ef5baecb$export$20931e2295160b07).withConfig({
    componentId: "sc-6lxli0-7"
})`background:${`var(--ds-icon-brand, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`};`;
const $b9651884ef5baecb$export$3e8048d3cf2ba3fd = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-6lxli0-8"
})`display:flex;flex-direction:column;min-width:0;white-space:nowrap;`;
const $b9651884ef5baecb$export$d4349a8ff634836e = /*#__PURE__*/ (0, $47bDC.default)((0, $3FhRS.default)).withConfig({
    componentId: "sc-6lxli0-9"
})`font:${"var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};margin-top:${"var(--ds-space-025, 2px)"};text-overflow:ellipsis;overflow:hidden;&:focus{box-shadow:0 0 0 2px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`};outline:none;border-radius:${"var(--ds-border-radius-100, 3px)"};}`;

});
parcelRegister("3FhRS", function(module, exports) {

$parcel$export(module.exports, "default", () => $5832523139a7a4e6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fyzT1 = parcelRequire("fyzT1");
var $38ra6 = parcelRequire("38ra6");

var $39CLR = parcelRequire("39CLR");

var $2FwA3 = parcelRequire("2FwA3");
const $5832523139a7a4e6$var$isModified = (event)=>Boolean(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
const $5832523139a7a4e6$var$getSpaAndRelativePath = (href, contextSpaPaths)=>{
    const relativePath = (0, $39CLR.getRelativeUrl)(href);
    const isSPA = (0, $39CLR.isSPALink)(relativePath, contextSpaPaths);
    return {
        isSPA: isSPA,
        relativePath: relativePath
    };
};
const $5832523139a7a4e6$export$a6c7ac8248d6e38a = ({ href: href, onClick: onClick, target: target, testId: testId, ...rest })=>{
    const analytics = (0, $38ra6.default)();
    const { contextSpaPaths: contextSpaPaths, contextEntryPoint: contextEntryPoint, push: push } = (0, $2FwA3.useAppConfig)();
    (0, $5uXOq.useEffect)(()=>{
        if (!href) analytics.pushOperationalEvent({
            source: (0, $fyzT1.AnalyticsEventSource).CLIENT_METRICS,
            actionSubject: 'link',
            action: (0, $fyzT1.AnalyticsEventActions).FAILED,
            attributes: {
                contextSpaPaths: contextSpaPaths,
                contextEntryPoint: contextEntryPoint
            },
            tags: [
                'error'
            ]
        });
    }, [
        analytics,
        contextEntryPoint,
        contextSpaPaths,
        href
    ]);
    const handleClick = (0, $5uXOq.useCallback)((event)=>{
        if (onClick) onClick(event);
        if (href) {
            const { relativePath: relativePath, isSPA: isSPA } = $5832523139a7a4e6$var$getSpaAndRelativePath(href, contextSpaPaths);
            if (isSPA && // only use push for links that work for SPA transitions
            !event.defaultPrevented && // set when onClick called preventDefault
            event.button === 0 && // only use push for left mouse button clicks
            (!target || target === '_self') && // let browser handle "_blank" etc
            !$5832523139a7a4e6$var$isModified(event) // let browser handle clicks with modifier
            ) {
                event.preventDefault();
                push(relativePath);
            }
        }
    }, [
        onClick,
        href,
        contextSpaPaths,
        push,
        target
    ]);
    if (href) {
        const { isSPA: isSPA } = $5832523139a7a4e6$var$getSpaAndRelativePath(href, contextSpaPaths);
        const props = {
            href: (0, $39CLR.prefixWithContextEntryPoint)(href, contextEntryPoint),
            ...target ? {
                target: target
            } : isSPA ? {} : {
                target: '_blank'
            },
            ...isSPA ? {} : {
                rel: 'noopener noreferrer'
            }
        };
        return(// eslint-disable-next-line jsx-a11y/anchor-has-content, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlaskit/design-system/no-html-anchor
        /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
            ...rest,
            onClick: handleClick,
            ...props,
            "data-testid": testId
        }));
    }
    // if href is missing render <a> with original onClick handler
    // and without href or target
    // Note that we trigger an operational event in `componentDidMount` to monitor why `href` is not passed.
    // I have a suspicion that empty href can cause broken link
    return(// eslint-disable-next-line jsx-a11y/anchor-has-content, @atlaskit/design-system/no-html-anchor, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
        ...rest,
        onClick: onClick
    }));
};
var $5832523139a7a4e6$export$2e2bcd8739ae039 = $5832523139a7a4e6$export$a6c7ac8248d6e38a;

});
parcelRegister("39CLR", function(module, exports) {

$parcel$export(module.exports, "getDomainFromLinkUri", () => $8eae38f2ed4e3aaa$export$cda14c9dfe45538);
$parcel$export(module.exports, "getRelativeUrl", () => $8eae38f2ed4e3aaa$export$d614758658023fd);
$parcel$export(module.exports, "prefixWithContextEntryPoint", () => $8eae38f2ed4e3aaa$export$715c8f9057ac0c01);
$parcel$export(module.exports, "isSPALink", () => $8eae38f2ed4e3aaa$export$82ba20246315fbed);

var $a2luh = parcelRequire("a2luh");
const $8eae38f2ed4e3aaa$export$1cc7e75fbd30f64f = (location)=>`${location.hash}${location.search}`;
const $8eae38f2ed4e3aaa$export$cda14c9dfe45538 = (url)=>{
    let hostname;
    try {
        try {
            hostname = $8eae38f2ed4e3aaa$export$eb5a321f13bbb969(url);
        } catch (noProtocolError) {
            /**
			 * Backend (Legion) validates whether the string is URI compliant. But URL expects
			 * the string to have a protocol. This is not validated by URI compliancy. So
			 * following is just a quick fix just for display purposes.
			 */ hostname = $8eae38f2ed4e3aaa$export$eb5a321f13bbb969('http://' + url);
        }
    } catch (error) {
        return '';
    }
    return hostname.replace(/^www\./, '');
};
const $8eae38f2ed4e3aaa$export$eb5a321f13bbb969 = (url)=>{
    const urlObj = new URL(url);
    return urlObj.hostname;
};
const $8eae38f2ed4e3aaa$export$c8d36b71889c2b08 = (email)=>{
    const parts = email.split('@');
    if (parts.length === 1) return null;
    else if (parts.length === 2 && !parts[0]) return null;
    else if (!parts[parts.length - 1]) return null;
    return parts[parts.length - 1];
};
const $8eae38f2ed4e3aaa$export$d614758658023fd = (url)=>{
    if (!$8eae38f2ed4e3aaa$var$isAbsoluteLink(url)) return url;
    try {
        const { pathname: pathname, search: search, hash: hash } = new URL(url);
        return `${pathname}${search}${hash}`;
    } catch (error) {
        (0, $a2luh.logException)(error, 'Cannot parse URL in getRelativeUrl', {
            url: url
        });
    }
    return url;
};
const $8eae38f2ed4e3aaa$var$isAbsoluteLink = (url)=>{
    return url.startsWith('http') || url.startsWith('www');
};
const $8eae38f2ed4e3aaa$export$715c8f9057ac0c01 = (path, contextEntryPoint = '')=>{
    if ($8eae38f2ed4e3aaa$var$isAbsoluteLink(path) || // do not prefix for absolute URL
    contextEntryPoint && path.startsWith(contextEntryPoint) || // do not prefix if the link already has product context path
    path.startsWith('/')) return path;
    return `${contextEntryPoint}/${path}`;
};
const $8eae38f2ed4e3aaa$export$82ba20246315fbed = (url, contextSpaPaths)=>{
    if (!contextSpaPaths || !contextSpaPaths.length) return false;
    let isStartWithContextSPA;
    if ($8eae38f2ed4e3aaa$var$isAbsoluteLink(url)) try {
        const { pathname: pathname, search: search, hash: hash, origin: origin } = new URL(url);
        const relativeUrl = `${pathname}${search}${hash}`;
        const isSameDomain = window.location.href.includes(origin);
        isStartWithContextSPA = !!contextSpaPaths.find((contextPath)=>{
            return relativeUrl.startsWith(contextPath);
        });
        return isStartWithContextSPA && isSameDomain;
    } catch (error) {
        (0, $a2luh.logException)(error, 'Cannot parse URL in isSPALink', {
            url: url
        });
        return false;
    }
    // is relative link
    isStartWithContextSPA = !!contextSpaPaths.find((contextPath)=>{
        return url.startsWith(contextPath);
    });
    return isStartWithContextSPA || !url.startsWith('/');
};

});

parcelRegister("2FwA3", function(module, exports) {

$parcel$export(module.exports, "useAppConfig", () => $4d516aa0d4ed8764$export$a3e0ece8c3f698d7);
$parcel$export(module.exports, "default", () => $4d516aa0d4ed8764$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $4d516aa0d4ed8764$var$error = new Error('AppConfigProvider is not found in higher components');
const $4d516aa0d4ed8764$var$defaultState = {
    addFlag: ()=>{
        throw $4d516aa0d4ed8764$var$error;
    },
    push: ()=>{
        throw $4d516aa0d4ed8764$var$error;
    },
    replace: ()=>{
        throw $4d516aa0d4ed8764$var$error;
    },
    history: undefined,
    contextSpaPaths: [],
    contextEntryPoint: '',
    docTitle: {},
    appName: '',
    productName: '',
    env: undefined,
    cloudId: '',
    isJiraAvailable: false,
    productFeatureFlags: {},
    orgId: undefined,
    siteUrl: undefined
};
const $4d516aa0d4ed8764$var$AppConfigContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext($4d516aa0d4ed8764$var$defaultState);
const $4d516aa0d4ed8764$export$a3e0ece8c3f698d7 = ()=>{
    return (0, $5uXOq.useContext)($4d516aa0d4ed8764$var$AppConfigContext);
};
var $4d516aa0d4ed8764$export$2e2bcd8739ae039 = $4d516aa0d4ed8764$var$AppConfigContext;

});





parcelRegister("49Zpb", function(module, exports) {

$parcel$export(module.exports, "ProfilePlacesList", () => $b49bb4864d30f319$export$f092d7408da4b0d);
$parcel$export(module.exports, "EmptyPlacesList", () => $b49bb4864d30f319$export$f88a6b5813accf5a);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");

const $b49bb4864d30f319$export$f092d7408da4b0d = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-114isdp-0"
})`padding:${"var(--ds-space-100, 8px)"};border-radius:${"var(--ds-border-radius-100, 3px)"};background:${`var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`};> div{margin-bottom:${"var(--ds-space-100, 8px)"};}> div:last-child{margin-bottom:0;}`;
const $b49bb4864d30f319$export$f88a6b5813accf5a = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-114isdp-1"
})`padding:${"var(--ds-space-200, 16px)"} ${"var(--ds-space-100, 8px)"};border-radius:${"var(--ds-border-radius-100, 3px)"};box-shadow:${`var(--ds-shadow-raised, ${`0 1px 1px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px 1px ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)}`})`};> div{margin-bottom:${"var(--ds-space-100, 8px)"};}> div:last-child{margin-bottom:0;}`;

});



parcelRegister("dXPcV", function(module, exports) {

$parcel$export(module.exports, "default", () => $313efcd2742b09c5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $dmOdc = parcelRequire("dmOdc");

var $fyzT1 = parcelRequire("fyzT1");
var $38ra6 = parcelRequire("38ra6");
var $fff3y = parcelRequire("fff3y");
var $5WmsO = parcelRequire("5WmsO");

var $k3Vai = parcelRequire("k3Vai");

var $l84Dn = parcelRequire("l84Dn");
const $313efcd2742b09c5$var$getCurrentTime = ()=>window && window.performance ? window.performance.now() : Date.now();
function $313efcd2742b09c5$var$useContainersQuery(props) {
    const [{ cloudId: cloudId }] = (0, $5WmsO.useSite)();
    const [{ principalUserId: principalUserId }] = (0, $fff3y.usePrincipalUser)();
    const analytics = (0, $38ra6.default)();
    const [sessionId] = (0, $5uXOq.useState)((0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))());
    const [startTime, setStartTime] = (0, $5uXOq.useState)(0);
    const userId = props.userId || principalUserId;
    const request = (0, $5uXOq.useCallback)(()=>{
        return (0, $dmOdc.teamsClient).getUserContainers({
            siteId: cloudId,
            userId: userId,
            principalId: principalUserId,
            maxNumberOfResults: props.maxNumberOfCards,
            sessionId: sessionId
        });
    }, [
        cloudId,
        principalUserId,
        props.maxNumberOfCards,
        sessionId,
        userId
    ]);
    const { fetchData: fetchData, loading: loading, data: data, error: error } = (0, $k3Vai.useServiceLight)(request);
    const loadingRef = (0, $5uXOq.useRef)(loading);
    (0, $5uXOq.useEffect)(()=>{
        setStartTime($313efcd2742b09c5$var$getCurrentTime());
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (principalUserId) fetchData();
    }, [
        fetchData,
        principalUserId
    ]);
    const triggerAnalyticsEvent = (0, $5uXOq.useCallback)((elapsedTimeMs, data)=>{
        const containers = data.Containers && data.Containers.collaborationGraphEntities || [];
        const ids = containers.map(({ id: id })=>id);
        analytics.pushOperationalEvent({
            source: (0, $fyzT1.AnalyticsEventSource).USER_PROFILE_SCREEN,
            actionSubject: 'collaboration-graph',
            attributes: {
                resultLength: ids.length,
                sessionId: sessionId,
                resultIds: ids,
                endpoint: 'userToContainer',
                userId: userId,
                elapsedTimeMs: elapsedTimeMs
            },
            action: 'requested'
        });
    }, [
        userId,
        analytics,
        sessionId
    ]);
    if (loadingRef.current !== loading) {
        loadingRef.current = loading;
        if (!loading) {
            const end = $313efcd2742b09c5$var$getCurrentTime();
            const diff = end - startTime;
            triggerAnalyticsEvent(diff, {
                Containers: data || {
                    collaborationGraphEntities: []
                }
            });
        }
    }
    return {
        data: data ? (0, $l84Dn.toContainersViewFormat)(data.collaborationGraphEntities) : [],
        loading: loading,
        hasError: !!error,
        error: error
    };
}
var $313efcd2742b09c5$export$2e2bcd8739ae039 = $313efcd2742b09c5$var$useContainersQuery;

});
parcelRegister("l84Dn", function(module, exports) {

$parcel$export(module.exports, "toContainersViewFormat", () => $db4f064ec519a677$export$1700279c740b8615);
const $db4f064ec519a677$var$getType = ({ containerType: containerType })=>{
    switch(containerType){
        case 'jiraProject':
            return 'project';
        case 'confluenceSpace':
            return 'space';
        default:
            return 'project';
    }
};
function $db4f064ec519a677$export$1700279c740b8615(nodes) {
    if (!nodes) return [];
    return nodes.filter((container)=>!!container).filter(({ containerType: containerType = '' })=>containerType === 'jiraProject' || containerType === 'confluenceSpace').map((node)=>{
        if (!node || !node.containerDetails) return;
        return {
            id: node?.id,
            name: node?.containerDetails?.name,
            icon: node?.containerDetails?.iconUrl,
            type: $db4f064ec519a677$var$getType(node),
            path: node?.containerDetails?.url,
            hasLoaded: true
        };
    }).filter((it)=>!!it);
}

});



parcelRegister("aKmPs", function(module, exports) {

$parcel$export(module.exports, "default", () => $ced19670b4a49108$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $9uQ9L = parcelRequire("9uQ9L");

var $2zjbs = parcelRequire("2zjbs");
function $ced19670b4a49108$export$dd5ad0b65cf665da(props) {
    const { children: children, docTitle: docTitle, title: title } = props;
    const resultTitle = [
        docTitle.start,
        title,
        docTitle.end
    ].filter((s)=>Boolean(s)).join(docTitle.delimiter || ' - ');
    return(// @ts-ignore
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9uQ9L))), {
        title: resultTitle,
        children: children
    }));
}
var $ced19670b4a49108$export$2e2bcd8739ae039 = (0, $2zjbs.default)($ced19670b4a49108$export$dd5ad0b65cf665da);

});
parcelRegister("9uQ9L", function(module, exports) {
'use strict';

var $5uXOq = parcelRequire("5uXOq");

var $8rCP3 = parcelRequire("8rCP3");

var $qB6JE = parcelRequire("qB6JE");
function $6e9f5f93a6c394a7$var$reducePropsToState(propsList) {
    var innermostProps = propsList[propsList.length - 1];
    if (innermostProps) return innermostProps.title;
}
function $6e9f5f93a6c394a7$var$handleStateChangeOnClient(title) {
    var nextTitle = title || '';
    if (nextTitle !== document.title) document.title = nextTitle;
}
function $6e9f5f93a6c394a7$var$DocumentTitle() {}
$6e9f5f93a6c394a7$var$DocumentTitle.prototype = Object.create($5uXOq.Component.prototype);
$6e9f5f93a6c394a7$var$DocumentTitle.displayName = 'DocumentTitle';
$6e9f5f93a6c394a7$var$DocumentTitle.propTypes = {
    title: $8rCP3.string.isRequired
};
$6e9f5f93a6c394a7$var$DocumentTitle.prototype.render = function() {
    if (this.props.children) return $5uXOq.Children.only(this.props.children);
    else return null;
};
module.exports = $qB6JE($6e9f5f93a6c394a7$var$reducePropsToState, $6e9f5f93a6c394a7$var$handleStateChangeOnClient)($6e9f5f93a6c394a7$var$DocumentTitle);

});
parcelRegister("qB6JE", function(module, exports) {
'use strict';
function $04ff36a02ec98ee9$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $5uXOq = parcelRequire("5uXOq");
var $04ff36a02ec98ee9$var$React__default = $04ff36a02ec98ee9$var$_interopDefault($5uXOq);

var $04ff36a02ec98ee9$var$shallowEqual = $04ff36a02ec98ee9$var$_interopDefault((parcelRequire("oRlQ1")));
function $04ff36a02ec98ee9$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $04ff36a02ec98ee9$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $04ff36a02ec98ee9$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $04ff36a02ec98ee9$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== 'function') throw new Error('Expected reducePropsToState to be a function.');
    if (typeof handleStateChangeOnClient !== 'function') throw new Error('Expected handleStateChangeOnClient to be a function.');
    if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') throw new Error('Expected mapStateOnServer to either be undefined or a function.');
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== 'function') throw new Error('Expected WrappedComponent to be a React component.');
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_Component) {
            $04ff36a02ec98ee9$var$_inheritsLoose(SideEffect, _Component);
            function SideEffect() {
                return _Component.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
                return !$04ff36a02ec98ee9$var$shallowEqual(nextProps, this.props);
            };
            _proto.componentWillMount = function componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $04ff36a02ec98ee9$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($5uXOq.Component);
        $04ff36a02ec98ee9$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $04ff36a02ec98ee9$var$_defineProperty(SideEffect, "canUseDOM", $04ff36a02ec98ee9$var$canUseDOM);
        return SideEffect;
    };
}
module.exports = $04ff36a02ec98ee9$var$withSideEffect;

});
parcelRegister("oRlQ1", function(module, exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

});



parcelRegister("2zjbs", function(module, exports) {

$parcel$export(module.exports, "default", () => $046c20baa687bf07$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2FwA3 = parcelRequire("2FwA3");
function $046c20baa687bf07$export$2e2bcd8739ae039(WrappedComponent) {
    const nameOfWrapperComponent = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithDocumentTitleComponent extends (0, $5uXOq.PureComponent) {
        static{
            this.displayName = `withDocumentTitleHOC(${nameOfWrapperComponent})`;
        }
        render() {
            const wrappedComponentProps = this.props;
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2FwA3.default).Consumer, {
                children: ({ docTitle: docTitle })=>/*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
                        ...wrappedComponentProps,
                        docTitle: docTitle
                    })
            });
        }
    }
    return WithDocumentTitleComponent;
}

});


parcelRegister("eX5cl", function(module, exports) {

$parcel$export(module.exports, "AsideColumn", () => $62433294b4f19257$export$7fd6f44981b465b2);
$parcel$export(module.exports, "AsideColumnItem", () => $62433294b4f19257$export$f634bf5b1a9553c4);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ /**
 * Implementation of the People and Teams Page Framework spec.
 * https://product-fabric.atlassian.net/wiki/spaces/PTD/pages/641534197/Page+framework
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");

var $9aSzh = parcelRequire("9aSzh");

var $5mXu0 = parcelRequire("5mXu0");
const $62433294b4f19257$export$7fd6f44981b465b2 = /*#__PURE__*/ (0, $47bDC.default).aside.withConfig({
    componentId: "xyb5d3-0"
})`${(0, $9aSzh.baseColumnStyles)};flex:0 0 ${(0, $5mXu0.profileGridSizeTimes)(4)}px;margin-bottom:${"var(--ds-space-400, 32px)"};&:last-of-type{margin-bottom:0;}`;
const $62433294b4f19257$export$f634bf5b1a9553c4 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "xyb5d3-1"
})`&:not(:last-child){margin-bottom:${"var(--ds-space-300, 24px)"};}`;

});
parcelRegister("9aSzh", function(module, exports) {

$parcel$export(module.exports, "baseColumnStyles", () => $3c52d2a79f187e72$export$d0f72508c56edec0);
/**
 * Implementation of the People and Teams Page Framework spec.
 * https://product-fabric.atlassian.net/wiki/spaces/PTD/pages/641534197/Page+framework
 */ // eslint-disable-next-line import/order, @repo/internal/styles/use-emotion, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");

var $5mXu0 = parcelRequire("5mXu0");
const $3c52d2a79f187e72$export$d0f72508c56edec0 = /*#__PURE__*/ (0, $47bDC.css)`padding:0 ${(0, $5mXu0.halfGutterSize)}px;min-width:${(0, $5mXu0.minColumnWidth)}px;@media (max-width:${(0, $5mXu0.responsiveThreshold)}px){flex:1 1;padding:0;}`;

});
parcelRegister("5mXu0", function(module, exports) {

$parcel$export(module.exports, "profileGridSizeTimes", () => $f33c72287e19aa69$export$4ee2721235c833ba);
$parcel$export(module.exports, "halfGutterSize", () => $f33c72287e19aa69$export$a5c9f6dcfaa13620);
$parcel$export(module.exports, "minColumnWidth", () => $f33c72287e19aa69$export$78f737406522d217);
$parcel$export(module.exports, "responsiveThreshold", () => $f33c72287e19aa69$export$e52bb911ec277d52);
/**
 * Util function for creating sizes based on the profile grid.
 * Takes the form a of function to be consistent with Atlaskit theme grid sizes.
 */ const $f33c72287e19aa69$export$4ee2721235c833ba = (n)=>80 * n;
const $f33c72287e19aa69$export$a5c9f6dcfaa13620 = 20;
const $f33c72287e19aa69$export$78f737406522d217 = $f33c72287e19aa69$export$4ee2721235c833ba(3);
const $f33c72287e19aa69$export$a3fc3c10977fa604 = 768;
const $f33c72287e19aa69$export$e52bb911ec277d52 = $f33c72287e19aa69$export$a3fc3c10977fa604 + 64;

});



parcelRegister("bKeYn", function(module, exports) {

$parcel$export(module.exports, "Body", () => $f7775499e5b59e81$export$4b2c32e08f77ff18);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $a6rxo = parcelRequire("a6rxo");
const $f7775499e5b59e81$export$4b2c32e08f77ff18 = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)($a6rxo.BodyOld, {
        children: children
    });
const $f7775499e5b59e81$export$77acdd2a63439b4c = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)($a6rxo.WideBody, {
        children: children
    });
var $f7775499e5b59e81$export$2e2bcd8739ae039 = $f7775499e5b59e81$export$4b2c32e08f77ff18;

});
parcelRegister("a6rxo", function(module, exports) {

$parcel$export(module.exports, "BodyOld", () => $2509b468bd9c9d4f$export$9db55a75b5a749b);
$parcel$export(module.exports, "WideBody", () => $2509b468bd9c9d4f$export$77acdd2a63439b4c);
/**
 * Implementation of the People and Teams Page Framework spec.
 * https://product-fabric.atlassian.net/wiki/spaces/PTD/pages/641534197/Page+framework
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");

var $5mXu0 = parcelRequire("5mXu0");
const $2509b468bd9c9d4f$export$4b2c32e08f77ff18 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1g7almm-0"
})`display:flex;flex-direction:column;justify-content:flex-start;min-height:calc(100vh - 56px);max-width:${(0, $5mXu0.profileGridSizeTimes)(14)}px;margin:0 auto;padding:0 ${(0, $5mXu0.halfGutterSize)}px;@media (max-width:${(0, $5mXu0.responsiveThreshold)}px){padding:0 ${"var(--ds-space-300, 24px)"};}padding-bottom:${"var(--ds-space-400, 32px)"};`;
const $2509b468bd9c9d4f$export$9db55a75b5a749b = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1g7almm-1"
})`display:flex;flex-direction:column;justify-content:flex-start;min-height:calc(100vh - 56px);max-width:${(0, $5mXu0.profileGridSizeTimes)(12.5)}px;margin:0 auto;padding:0 ${(0, $5mXu0.halfGutterSize)}px;@media (max-width:${(0, $5mXu0.responsiveThreshold)}px){padding:0 ${"var(--ds-space-300, 24px)"};}padding-bottom:${"var(--ds-space-400, 32px)"};`;
const $2509b468bd9c9d4f$export$77acdd2a63439b4c = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1g7almm-2"
})`display:flex;flex-direction:column;justify-content:flex-start;min-height:calc(100vh - 56px);max-width:${(0, $5mXu0.profileGridSizeTimes)(18)}px;margin:0 auto;padding:0 ${(0, $5mXu0.halfGutterSize)}px;@media (max-width:${(0, $5mXu0.responsiveThreshold)}px){padding:0 ${"var(--ds-space-300, 24px)"};}padding-bottom:${"var(--ds-space-400, 32px)"};`;

});


parcelRegister("gujzl", function(module, exports) {

$parcel$export(module.exports, "MainColumn", () => $77d5409b05600d3e$export$2d9aae88ab6846ab);
$parcel$export(module.exports, "MainColumnItem", () => $77d5409b05600d3e$export$a3de91dc1c7d9c74);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ /**
 * Implementation of the People and Teams Page Framework spec.
 * https://product-fabric.atlassian.net/wiki/spaces/PTD/pages/641534197/Page+framework
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");

var $k5uoT = parcelRequire("k5uoT");

var $9aSzh = parcelRequire("9aSzh");

var $5mXu0 = parcelRequire("5mXu0");
const $77d5409b05600d3e$export$2d9aae88ab6846ab = /*#__PURE__*/ (0, $47bDC.default).main.withConfig({
    componentId: "e4gbwm-0"
})`${(0, $9aSzh.baseColumnStyles)};flex:0 1 ${(0, $5mXu0.profileGridSizeTimes)(8)}px;margin-top:${"var(--ds-space-400, 32px)"};margin-bottom:${"var(--ds-space-400, 32px)"};&:last-of-type{margin-bottom:0;}`;
const $77d5409b05600d3e$export$a3de91dc1c7d9c74 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "e4gbwm-1"
})`scroll-margin-top:${(0, $k5uoT.gridSize)() * 23}px;&:not(:last-child){margin-bottom:${"var(--ds-space-400, 32px)"};}`;
const $77d5409b05600d3e$export$b59f717f8d137994 = /*#__PURE__*/ (0, $47bDC.default).main.withConfig({
    componentId: "e4gbwm-2"
})`${(0, $9aSzh.baseColumnStyles)};flex:0 1 ${(0, $5mXu0.profileGridSizeTimes)(12)}px;margin-top:${"var(--ds-space-400, 32px)"};margin-bottom:${"var(--ds-space-400, 32px)"};&:last-of-type{margin-bottom:0;}`;

});

parcelRegister("lgzkR", function(module, exports) {

$parcel$export(module.exports, "ResponsiveSection", () => $3cf83c5295d7c080$export$6f5ca33df9ef97dc);
/**
 * Implementation of the People and Teams Page Framework spec.
 * https://product-fabric.atlassian.net/wiki/spaces/PTD/pages/641534197/Page+framework
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");

var $5mXu0 = parcelRequire("5mXu0");

var $7MQWS = parcelRequire("7MQWS");
const $3cf83c5295d7c080$export$6f5ca33df9ef97dc = /*#__PURE__*/ (0, $47bDC.default)((0, $7MQWS.Section)).withConfig({
    componentId: "uvj1rq-0"
})`@media (max-width:${(0, $5mXu0.responsiveThreshold)}px){flex-direction:column;justify-content:flex-start;}`;

});
parcelRegister("7MQWS", function(module, exports) {

$parcel$export(module.exports, "Section", () => $f5d37ed89170413e$export$6e2c8f0811a474ce);
/**
 * Implementation of the People and Teams Page Framework spec.
 * https://product-fabric.atlassian.net/wiki/spaces/PTD/pages/641534197/Page+framework
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");
const $f5d37ed89170413e$export$6e2c8f0811a474ce = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "jfynxk-0"
})`display:flex;flex-direction:row;justify-content:center;`;

});


parcelRegister("7zl35", function(module, exports) {

$parcel$export(module.exports, "ErrorScreen", () => $bab77af7fdfb31e0$export$42f84e610f279c31);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fyzT1 = parcelRequire("fyzT1");
var $4BpOs = parcelRequire("4BpOs");
var $iiI2P = parcelRequire("iiI2P");
var $38ra6 = parcelRequire("38ra6");

var $iHA6C = parcelRequire("iHA6C");

var $lAVIa = parcelRequire("lAVIa");

var $gTfPe = parcelRequire("gTfPe");
const $bab77af7fdfb31e0$export$db8be4c3614e42ec = new Map([
    [
        (0, $4BpOs.ErrorCategory).NotFound,
        (0, $lAVIa.UserNotFound)
    ]
]);
const $bab77af7fdfb31e0$export$42f84e610f279c31 = ({ error: error })=>{
    const analytics = (0, $38ra6.default)();
    // Failed analytics
    (0, $5uXOq.useEffect)(()=>{
        analytics.pushTrackEvent({
            action: (0, $fyzT1.AnalyticsEventActions).FAILED,
            actionSubject: `${(0, $fyzT1.AnalyticsEventSource).USER_PROFILE_SCREEN}Load`,
            source: (0, $fyzT1.AnalyticsEventSource).USER_PROFILE_SCREEN
        });
    }, [
        analytics
    ]);
    const errorCategory = (0, $iHA6C.parseErrorObjectToErrorCategory)(error);
    const ErrorComponent = errorCategory !== '' && $bab77af7fdfb31e0$export$db8be4c3614e42ec.has(errorCategory) ? $bab77af7fdfb31e0$export$db8be4c3614e42ec.get(errorCategory) : (0, $iiI2P.GenericErrorPage);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($gTfPe.LoadingWrapper, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(ErrorComponent, {})
    });
};

});
parcelRegister("iiI2P", function(module, exports) {

$parcel$export(module.exports, "GenericErrorPage", () => $3bcfcb1d3bcb026c$export$5d76009b056f3e5d);
$parcel$export(module.exports, "default", () => $3bcfcb1d3bcb026c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $ousew = parcelRequire("ousew");

var $fVnbM = parcelRequire("fVnbM");

var $bJMK1 = parcelRequire("bJMK1");

var $5r4mZ = parcelRequire("5r4mZ");

var $jzj7m = parcelRequire("jzj7m");
const $3bcfcb1d3bcb026c$export$2369ec80391a4c8c = /*#__PURE__*/ (0, $2OMIu.jsx)($jzj7m.ErrorImage, {
    src: (0, (/*@__PURE__*/$parcel$interopDefault($5r4mZ)))
});
const $3bcfcb1d3bcb026c$export$c120a0e80fd44ca6 = ({ title: title, body: body, image: image, actions: actions })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)($jzj7m.Container, {
        "data-test-selector": "error-page",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)($jzj7m.ImageOuter, {
                children: image || $3bcfcb1d3bcb026c$export$2369ec80391a4c8c
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)($jzj7m.ErrorTextContainer, {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)($jzj7m.TitleWrapper, {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)($jzj7m.Title, {
                            children: title
                        })
                    }),
                    body && /*#__PURE__*/ (0, $2OMIu.jsx)($jzj7m.DescriptionWrapper, {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)($jzj7m.Description, {
                            children: body
                        })
                    })
                ]
            }),
            actions && /*#__PURE__*/ (0, $2OMIu.jsx)($jzj7m.ButtonContainer, {
                children: actions
            })
        ]
    });
};
const $3bcfcb1d3bcb026c$export$5d76009b056f3e5d = (props)=>{
    const actions = props.hasSupportLink && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
        rel: "noopener noreferrer",
        target: "_blank",
        href: `${(0, $bJMK1.getAtlassianContextUrl)('support')}/contact/#/`,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...$3bcfcb1d3bcb026c$var$messages.contactUs
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($3bcfcb1d3bcb026c$export$c120a0e80fd44ca6, {
        title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...$3bcfcb1d3bcb026c$var$messages.title
        }),
        body: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...$3bcfcb1d3bcb026c$var$messages.description
        }),
        actions: actions || undefined
    });
};
const $3bcfcb1d3bcb026c$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        id: 'pf-home.generic-error-title',
        defaultMessage: 'Something went wrong'
    },
    contactUs: {
        id: 'ptc-directory.error-boundary.message-link-text',
        defaultMessage: 'Contact support',
        description: 'The text of the link leading to the Atlassian support website, shown below the error description on the error pages'
    },
    description: {
        id: 'pf-home.generic-error-description',
        defaultMessage: "We keep track of these errors, but feel free to contact us if refreshing doesn\u2019t fix things."
    }
});
var $3bcfcb1d3bcb026c$export$2e2bcd8739ae039 = $3bcfcb1d3bcb026c$export$c120a0e80fd44ca6;

});
parcelRegister("5r4mZ", function(module, exports) {
module.exports = new URL("svg-error-window_ptc.150cf151.svg", import.meta.url).toString();

});

parcelRegister("jzj7m", function(module, exports) {

$parcel$export(module.exports, "ErrorImage", () => $9534cd56a74aa25f$export$7326e6d938a8137b);
$parcel$export(module.exports, "Container", () => $9534cd56a74aa25f$export$42a852a2b6b56249);
$parcel$export(module.exports, "ImageOuter", () => $9534cd56a74aa25f$export$6cce79b2fcc860dc);
$parcel$export(module.exports, "TitleWrapper", () => $9534cd56a74aa25f$export$585a3b23e887288b);
$parcel$export(module.exports, "ButtonContainer", () => $9534cd56a74aa25f$export$eddf54ea3db8d0f0);
$parcel$export(module.exports, "Title", () => $9534cd56a74aa25f$export$f99233281efd08a0);
$parcel$export(module.exports, "DescriptionWrapper", () => $9534cd56a74aa25f$export$2bf1f2b0d31b60fc);
$parcel$export(module.exports, "Description", () => $9534cd56a74aa25f$export$393edc798c47379d);
$parcel$export(module.exports, "ErrorTextContainer", () => $9534cd56a74aa25f$export$5086488b1ac4411e);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");

const $9534cd56a74aa25f$export$7326e6d938a8137b = /*#__PURE__*/ (0, $47bDC.default).img.withConfig({
    componentId: "kvymlk-0"
})`width:263px;margin:0 0 ${"var(--ds-space-600, 48px)"} 0;display:flex;`;
const $9534cd56a74aa25f$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "kvymlk-1"
})`align-items:center;justify-content:center;display:flex;flex-wrap:wrap;margin:${"var(--ds-space-1000, 80px)"} auto 0;max-width:600px;flex-direction:column;@media (max-width:640px){flex-direction:column;}`;
const $9534cd56a74aa25f$export$6cce79b2fcc860dc = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "kvymlk-2"
})`flex:none;flex-basis:200px;justify-content:center;@media (max-width:640px){margin-right:0;flex-basis:auto;& img{max-width:100%;padding:0 ${"var(--ds-space-300, 24px)"};}}`;
const $9534cd56a74aa25f$export$585a3b23e887288b = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "kvymlk-3"
})`display:flex;margin-bottom:${"var(--ds-space-150, 12px)"};@media (max-width:640px){text-align:center;}`;
const $9534cd56a74aa25f$export$eddf54ea3db8d0f0 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "kvymlk-4"
})`display:flex;justify-content:center;text-align:center;margin-top:${"var(--ds-space-200, 16px)"};`;
const $9534cd56a74aa25f$export$f99233281efd08a0 = /*#__PURE__*/ (0, $47bDC.default).h1.withConfig({
    componentId: "kvymlk-5"
})``;
const $9534cd56a74aa25f$export$2bf1f2b0d31b60fc = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "kvymlk-6"
})`display:flex;flex-wrap:wrap;`;
const $9534cd56a74aa25f$export$393edc798c47379d = /*#__PURE__*/ (0, $47bDC.default).p.withConfig({
    componentId: "kvymlk-7"
})`font-size:1em;line-height:24px;color:${`var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`};@media (max-width:640px){text-align:center;}`;
const $9534cd56a74aa25f$export$5086488b1ac4411e = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "kvymlk-8"
})`display:flex;justify-content:center;text-align:center;flex-wrap:wrap;width:80%;flex-direction:column;align-items:center;@media (max-width:640px){max-width:304px;width:100%;}`;

});


parcelRegister("iHA6C", function(module, exports) {

$parcel$export(module.exports, "isRealErrorUserProfile", () => $f63c3d8e2c241724$export$ad79d1c90d717965);
$parcel$export(module.exports, "errorUserNotFound", () => $f63c3d8e2c241724$export$10bf856e639f2ac5);
$parcel$export(module.exports, "parseErrorObjectToErrorCategory", () => $f63c3d8e2c241724$export$cf76974422373a05);
$parcel$export(module.exports, "parseTeamErrorCategory", () => $f63c3d8e2c241724$export$cd92fd5c21ce6635);

var $4BpOs = parcelRequire("4BpOs");
var $hxoeG = parcelRequire("hxoeG");
const $f63c3d8e2c241724$export$ad79d1c90d717965 = (error)=>{
    if (!error) return false;
    if (error?.message?.includes('User not found') || error?.message?.includes('Access is denied') || error?.message?.includes('TEAM CENTRAL UNAUTHORIZED')) return false;
    if (!error.graphQLErrors) return true;
    return !error.graphQLErrors.every((e)=>!e || e.category === (0, $4BpOs.ErrorCategory).NotFound || e.category === (0, $4BpOs.ErrorCategory).NotPermitted);
};
const $f63c3d8e2c241724$export$10bf856e639f2ac5 = new Error('User not found');
function $f63c3d8e2c241724$export$cf76974422373a05(error) {
    if (!error) return '';
    if (error?.message === $f63c3d8e2c241724$export$10bf856e639f2ac5.message) return (0, $4BpOs.ErrorCategory).NotFound;
    return error.graphQLErrors?.[0]?.category || '';
}
const $f63c3d8e2c241724$var$MAP_TEAM_STATUS_ERROR_TYPES_MAP = {
    403: (0, $hxoeG.TeamProfileErrorType).NO_PERMISSION,
    404: (0, $hxoeG.TeamProfileErrorType).TEAM_MISSING,
    410: (0, $hxoeG.TeamProfileErrorType).TEAM_DELETED
};
const $f63c3d8e2c241724$export$cd92fd5c21ce6635 = (error)=>error ? $f63c3d8e2c241724$var$MAP_TEAM_STATUS_ERROR_TYPES_MAP[error.status] || (0, $hxoeG.TeamProfileErrorType).UNKNOWN : null;

});
parcelRegister("hxoeG", function(module, exports) {

$parcel$export(module.exports, "TeamProfileErrorType", () => $fca2dbb71bb98d64$export$b89d4f1cb2ee533c);
var $fca2dbb71bb98d64$export$b89d4f1cb2ee533c = /*#__PURE__*/ function(TeamProfileErrorType) {
    TeamProfileErrorType["TEAM_MISSING"] = "teamMissing";
    TeamProfileErrorType["NO_PERMISSION"] = "noPermission";
    TeamProfileErrorType["TEAM_DELETED"] = "deleted";
    TeamProfileErrorType["UNKNOWN"] = "unknown";
    TeamProfileErrorType["NO_ACCESS_TO_TEAMS"] = "noAccessToTeams";
    return TeamProfileErrorType;
}({});

});


parcelRegister("lAVIa", function(module, exports) {

$parcel$export(module.exports, "UserNotFound", () => $9c9c968fed3671fa$export$d1f0ba24af7dd9bb);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $ousew = parcelRequire("ousew");

var $eCeGD = parcelRequire("eCeGD");

var $iiI2P = parcelRequire("iiI2P");
var $38ra6 = parcelRequire("38ra6");

var $2n9WB = parcelRequire("2n9WB");

var $3FhRS = parcelRequire("3FhRS");

var $cjsF8 = parcelRequire("cjsF8");
const $9c9c968fed3671fa$var$Actions = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3FhRS.default), {
        href: "search",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...$9c9c968fed3671fa$var$messages.buttonText
            })
        })
    });
const $9c9c968fed3671fa$var$NOT_FOUND_IMAGE_WIDTH = 497;
const $9c9c968fed3671fa$export$d1f0ba24af7dd9bb = ()=>{
    const analytics = (0, $38ra6.default)();
    const expTracker = analytics.expTracker();
    // In a weird case, back and forth by browser back/next button causes `error` to not return correctly although user does not exist.
    // So it is better to abort all current user experience tracking when user is not found.
    (0, $5uXOq.useEffect)(()=>{
        expTracker.abort({
            reason: 'User Not Found'
        });
    }, [
        expTracker
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iiI2P.default), {
        title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...$9c9c968fed3671fa$var$messages.notFoundTitle
        }),
        body: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...$9c9c968fed3671fa$var$messages.notFoundDescription1
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("br", {}),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...$9c9c968fed3671fa$var$messages.notFoundDescription2
                })
            ]
        }),
        image: /*#__PURE__*/ (0, $2OMIu.jsx)($cjsF8.NotFoundImage, {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($2n9WB))),
            width: $9c9c968fed3671fa$var$NOT_FOUND_IMAGE_WIDTH
        }),
        actions: /*#__PURE__*/ (0, $2OMIu.jsx)($9c9c968fed3671fa$var$Actions, {})
    });
};
const $9c9c968fed3671fa$var$messages = (0, $7VHMR.defineMessages)({
    notFoundTitle: {
        id: 'ptc-directory.profile-page.not-found.title',
        defaultMessage: "Looks like we\u2019re off the beaten track",
        description: 'The title of the error page when a user tries to view a user but the user id does not exist'
    },
    notFoundDescription1: {
        id: 'ptc-directory.profile-page.not-found.description.first',
        defaultMessage: 'We landed here for a user that does not exist.',
        description: 'The first line of the description when a user landed on an invalid page'
    },
    notFoundDescription2: {
        id: 'ptc-directory.profile-page.not-found.description.second',
        defaultMessage: 'Head back to the directory to search for another user.',
        description: 'The second line of the description when a user landed on an invalid page'
    },
    buttonText: {
        id: 'ptc-directory.profile-page.error.home.button',
        defaultMessage: 'Back to directory',
        description: 'The button text to return to the search page'
    }
});

});
parcelRegister("2n9WB", function(module, exports) {
module.exports = new URL("svg-user-not-found_ptc.0205a184.svg", import.meta.url).toString();

});

parcelRegister("cjsF8", function(module, exports) {

$parcel$export(module.exports, "NotFoundImage", () => $8f9737ac80b2ded5$export$22dc9752913c971e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");
const $8f9737ac80b2ded5$export$22dc9752913c971e = /*#__PURE__*/ (0, $47bDC.default).img.withConfig({
    componentId: "sc-1wghneo-0"
})`margin:0 0 ${"var(--ds-space-500, 40px)"} 0;display:flex;`;

});


parcelRegister("gTfPe", function(module, exports) {

$parcel$export(module.exports, "SidebarContent", () => $7c8966fd68543407$export$49e8f7b58a4df4ea);
$parcel$export(module.exports, "SidebarContentNext", () => $7c8966fd68543407$export$222c2783abd9eeb3);
$parcel$export(module.exports, "AvatarWrapper", () => $7c8966fd68543407$export$f7513421c53ce141);
$parcel$export(module.exports, "Details", () => $7c8966fd68543407$export$3e8048d3cf2ba3fd);
$parcel$export(module.exports, "Name", () => $7c8966fd68543407$export$c7bd411105e2dec3);
$parcel$export(module.exports, "Nickname", () => $7c8966fd68543407$export$445f45ad592d8c5);
$parcel$export(module.exports, "LoadingWrapper", () => $7c8966fd68543407$export$43a792a870d28db2);
$parcel$export(module.exports, "NonActiveUserLozenge", () => $7c8966fd68543407$export$184eb2c877f30f66);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ 
var $47bDC = parcelRequire("47bDC");

const $7c8966fd68543407$export$3f46768c2c1337f2 = -91;
const $7c8966fd68543407$export$49e8f7b58a4df4ea = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1oxac7m-0"
})`margin-top:${$7c8966fd68543407$export$3f46768c2c1337f2}px;`;
const $7c8966fd68543407$export$222c2783abd9eeb3 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1oxac7m-1"
})`margin-top:${$7c8966fd68543407$export$3f46768c2c1337f2}px;display:flex;flex-direction:column;align-items:center;`;
const $7c8966fd68543407$export$b4afcc4b43e79a52 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1oxac7m-2"
})`height:0;padding:0;margin:${"var(--ds-space-250, 20px)"} 0 0 0;`;
const $7c8966fd68543407$export$f7513421c53ce141 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1oxac7m-3"
})`position:relative;display:inline-block;height:134px;width:134px;border-radius:50%;margin-bottom:${"var(--ds-space-200, 16px)"};`;
const $7c8966fd68543407$export$3e8048d3cf2ba3fd = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1oxac7m-4"
})`display:flex;flex-direction:column;`;
const $7c8966fd68543407$export$c7bd411105e2dec3 = /*#__PURE__*/ (0, $47bDC.default).h1.withConfig({
    componentId: "sc-1oxac7m-5"
})`font:${"var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};margin-top:0;margin-bottom:${"var(--ds-space-150, 12px)"};word-break:break-all;`;
const $7c8966fd68543407$export$445f45ad592d8c5 = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "sc-1oxac7m-6"
})`color:${`var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`};margin-bottom:${"var(--ds-space-150, 12px)"};word-break:break-all;`;
const $7c8966fd68543407$export$43a792a870d28db2 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1oxac7m-7"
})`opacity:${(props)=>props.isLoading ? 0 : 1};`;
const $7c8966fd68543407$export$184eb2c877f30f66 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1oxac7m-8"
})`margin-bottom:${"var(--ds-space-250, 20px)"};margin-top:${"var(--ds-space-050, 4px)"};`;

});


parcelRegister("iegaf", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc754503aa074ff7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $HsQKd = parcelRequire("HsQKd");
const $fc754503aa074ff7$var$WorkedOnListContainer = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $HsQKd.default), {
        ...props
    });
};
var $fc754503aa074ff7$export$2e2bcd8739ae039 = $fc754503aa074ff7$var$WorkedOnListContainer;

});
parcelRegister("HsQKd", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dee281c1c05402c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fff3y = parcelRequire("fff3y");

var $jFpmD = parcelRequire("jFpmD");

var $hd01g = parcelRequire("hd01g");

var $f8Dur = parcelRequire("f8Dur");

var $9m4mL = parcelRequire("9m4mL");
const $4dee281c1c05402c$var$ProfileRecentWorkClient = (props)=>{
    const { userId: userId } = props;
    const [{ principalUserId: principalUserId }] = (0, $fff3y.usePrincipalUser)();
    const [activities, setActivities] = (0, $5uXOq.useState)([]);
    const [error, setError] = (0, $5uXOq.useState)(undefined);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(true);
    const activityClient = (0, $jFpmD.useActivityClient)('v3', 'people');
    const { data: data } = (0, $hd01g.useTeamsUser)(userId, !userId);
    const loadActivities = (0, $5uXOq.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const fetchedActivities = await activityClient.fetchActivities([
                50,
                125,
                250
            ], {
                limit: 50,
                actors: [
                    `ari:cloud:identity::user/${userId}`
                ]
            }, [
                'workedOn'
            ]);
            const translated = (0, $f8Dur.transformDataFromRecentWorkClient)(fetchedActivities.workedOn);
            setActivities(translated);
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            // @ts-ignore
            setError(error);
        }
    }, [
        activityClient,
        userId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (userId) loadActivities();
    }, [
        loadActivities,
        userId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9m4mL.default), {
        userFullName: data?.fullName,
        userId: userId,
        currentUserId: principalUserId,
        error: error,
        hasError: !!error,
        isLoading: isLoading,
        activities: activities
    });
};
var $4dee281c1c05402c$export$2e2bcd8739ae039 = $4dee281c1c05402c$var$ProfileRecentWorkClient;

});
parcelRegister("hd01g", function(module, exports) {

$parcel$export(module.exports, "useTeamsUser", () => $1b1e413e1dacd172$export$14c10fb40f456eef);

var $5uXOq = parcelRequire("5uXOq");

var $03VaI = parcelRequire("03VaI");
const $1b1e413e1dacd172$export$14c10fb40f456eef = (userId, skip)=>{
    const [users, { getUser: getUser, setUserData: setUserData, ...rest }] = (0, $03VaI.useUser)();
    const userState = users[userId];
    (0, $5uXOq.useEffect)(()=>{
        if (!skip) getUser(userId);
    }, [
        getUser,
        skip,
        userId
    ]);
    return {
        ...rest,
        data: userState?.user,
        isLoading: userState?.isLoading,
        error: userState?.error,
        refetch: ()=>getUser(userId, true),
        setUserData: (data)=>setUserData(userId, data)
    };
};

});
parcelRegister("03VaI", function(module, exports) {

$parcel$export(module.exports, "useUser", () => $80e8b6a666360a4d$export$23bbbc4533528f03);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $dmOdc = parcelRequire("dmOdc");
const $80e8b6a666360a4d$var$CACHE_MAX_AGE = 300000; // 5 minutes
const $80e8b6a666360a4d$var$CACHE_MAX_SIZE = 5;
const $80e8b6a666360a4d$var$initialState = {};
const $80e8b6a666360a4d$export$e324594224ef24da = {
    getUser: (userId, isRefetching)=>async ({ getState: getState, setState: setState })=>{
            const userState = getState()[userId];
            // Do not fetch the user if it is still in cache
            // Or it is loading
            // Or it is refetching
            if (!isRefetching && userState && (userState.isLoading || userState.exp > Date.now())) return;
            // Remove the oldest user from the cache if the cache is full
            const userIds = Object.keys(getState());
            if (userIds.length >= $80e8b6a666360a4d$var$CACHE_MAX_SIZE) {
                const mutableState = {
                    ...getState()
                };
                const oldestUserId = userIds.reduce((oldest, current)=>mutableState[current].exp < mutableState[oldest].exp ? current : oldest);
                delete mutableState[oldestUserId];
                setState({
                    ...mutableState
                });
            }
            setState({
                [userId]: {
                    isLoading: true,
                    error: undefined,
                    user: undefined,
                    exp: -1
                }
            });
            try {
                // AGG user query does not verify user’s org membership,
                // it can provide user info to users who are outside the org.
                // To apply proper restrictions on visibility, we need to check if the user is present in the site.
                // Read more in https://hello.atlassian.net/wiki/spaces/PTC/pages/3492140773/LDR+Replace+pf-directory+CloudUser+with+AGG+User
                const userCheckPromise = (0, $dmOdc.teamsClient).getUserInSiteUserBase(userId);
                const userQueryPromise = (0, $dmOdc.teamsClient).queryAGGUser(userId);
                const checkUserPresentInSiteRes = await userCheckPromise;
                if (!checkUserPresentInSiteRes.isPresent) {
                    setState({
                        [userId]: {
                            isLoading: false,
                            exp: -1
                        }
                    });
                    return;
                }
                const user = await userQueryPromise;
                setState({
                    [userId]: {
                        isLoading: false,
                        exp: Date.now() + $80e8b6a666360a4d$var$CACHE_MAX_AGE,
                        user: {
                            ...user,
                            fullName: user.name,
                            title: user.extendedProfile?.jobTitle,
                            timezone: user.zoneinfo,
                            locale: user.locale,
                            location: user.extendedProfile?.location,
                            companyName: user.extendedProfile?.organization,
                            department: user.extendedProfile?.department,
                            avatarUrl: user.picture,
                            status: user.accountStatus,
                            isBot: user.__typename === 'AppUser',
                            userType: 'user',
                            phoneNumber: user.extendedProfile?.phoneNumbers && user.extendedProfile?.phoneNumbers[0]?.value,
                            isAgent: user.appType === 'agent'
                        }
                    }
                });
            } catch (error) {
                setState({
                    [userId]: {
                        error: error instanceof Error ? error : new Error('Unknown error'),
                        isLoading: false,
                        exp: -1
                    }
                });
            }
        },
    updateUserInfo: (userId, fieldKey, value)=>async ({ getState: getState, setState: setState })=>{
            const userState = getState()[userId];
            if (!userState || !userState.user) return;
            const updatedUser = {
                ...userState.user,
                [fieldKey]: value
            };
            setState({
                [userId]: {
                    ...userState,
                    user: updatedUser
                }
            });
            try {
                await (0, $dmOdc.teamsClient).updateUser({
                    id: userId,
                    [fieldKey]: value
                });
            } catch (error) {
                setState({
                    [userId]: {
                        ...userState,
                        user: userState.user
                    }
                });
            }
        },
    /**
	 * Expose a method to set user data
	 * Useful when we want to update user data that needs relatively long time in BE to sync
	 */ setUserData: (userId, data)=>({ getState: getState, setState: setState })=>{
            const userState = getState()[userId];
            if (!userState || !userState.user) return;
            setState({
                [userId]: {
                    ...userState,
                    user: userState.user && {
                        ...userState.user,
                        ...data
                    }
                }
            });
        }
};
const $80e8b6a666360a4d$var$Store = (0, $iXqE5.createStore)({
    initialState: $80e8b6a666360a4d$var$initialState,
    actions: $80e8b6a666360a4d$export$e324594224ef24da,
    name: 'User'
});
const $80e8b6a666360a4d$export$23bbbc4533528f03 = (0, $3sQ5x.createHook)($80e8b6a666360a4d$var$Store);

});


parcelRegister("f8Dur", function(module, exports) {

$parcel$export(module.exports, "transformDataFromRecentWorkClient", () => $7e0107138655b701$export$25e790c9ec501a25);

var $k2jAn = parcelRequire("k2jAn");
function $7e0107138655b701$var$getDirectContainer(node) {
    let container = '';
    const len = node.containers?.length || 0;
    if (node.containers && len > 0) container = node.containers[len - 1].name;
    const provider = (0, $k2jAn.toTitleCase)((0, $k2jAn.replaceUnderscoresToSpace)((0, $k2jAn.replaceHypensToSpace)(node.object.product.toLowerCase())));
    return container || provider; // fallback is product name
}
function $7e0107138655b701$var$transformContributorToActivity(contributor, type = '', date = null) {
    return {
        date: date,
        user: {
            id: contributor.accountId,
            fullName: contributor.name
        },
        type: type
    };
}
function $7e0107138655b701$var$transformNodeToWorkLensActivityObject(node) {
    const { name: name = '', url: url = '', icon: icon = null, product: product = '' } = node.object || {};
    return {
        name: name || '',
        url: url,
        cloudId: '',
        iconUrl: icon ? icon.value : '',
        provider: product,
        container: $7e0107138655b701$var$getDirectContainer(node)
    };
}
function $7e0107138655b701$var$transformContributersForActor({ actor: actor, contributors: contributors, eventType: eventType, timestamp: timestamp }) {
    const updatedContributors = !contributors.length && actor ? [
        actor
    ] : contributors;
    return updatedContributors.map((contributor)=>$7e0107138655b701$var$transformContributorToActivity(contributor, eventType, timestamp));
}
function $7e0107138655b701$export$25e790c9ec501a25(nodes) {
    return nodes.map((node)=>{
        const { object: { id: objectId }, timestamp: timestamp } = node;
        return {
            objectId: objectId,
            lastModification: timestamp,
            activity: $7e0107138655b701$var$transformContributersForActor(node),
            object: {
                ...$7e0107138655b701$var$transformNodeToWorkLensActivityObject(node)
            }
        };
    });
}

});
parcelRegister("k2jAn", function(module, exports) {

$parcel$export(module.exports, "toTitleCase", () => $c30e14583f2605d7$export$f06f8b3003f18927);
$parcel$export(module.exports, "replaceUnderscoresToSpace", () => $c30e14583f2605d7$export$d3895e5768a00fee);
$parcel$export(module.exports, "replaceHypensToSpace", () => $c30e14583f2605d7$export$568995155ea86c06);
/**
 * Method to capitalise first letter of an input string
 * @param text {String} - the input string
 * @return {String}
 */ const $c30e14583f2605d7$export$1270e6249ad1a81f = (text)=>typeof text === 'string' ? text.charAt(0).toUpperCase() + text.substr(1) : '';
const $c30e14583f2605d7$export$f06f8b3003f18927 = (text)=>{
    if (typeof text !== 'string') return '';
    const words = text.split(' ');
    return words.map((word)=>$c30e14583f2605d7$export$1270e6249ad1a81f(word)).join(' ');
};
const $c30e14583f2605d7$export$d3895e5768a00fee = (text)=>typeof text === 'string' ? text// underscores to spaces
    .replace(/_/g, ' ')// spaces to space
    .replace(/ +/g, ' ') : '';
const $c30e14583f2605d7$export$568995155ea86c06 = (text)=>typeof text === 'string' ? text// underscores to spaces
    .replace(/-/g, ' ')// spaces to space
    .replace(/ +/g, ' ') : '';

});


parcelRegister("9m4mL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5b99589eda8f874$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fyzT1 = parcelRequire("fyzT1");
var $bA8uW = parcelRequire("bA8uW");
var $jDqI3 = parcelRequire("jDqI3");
var $38ra6 = parcelRequire("38ra6");
var $aOf1o = parcelRequire("aOf1o");
var $lHKVj = parcelRequire("lHKVj");

var $iHA6C = parcelRequire("iHA6C");

var $4HgYh = parcelRequire("4HgYh");
var $hyK1p = parcelRequire("hyK1p");

var $brGTJ = parcelRequire("brGTJ");
function $d5b99589eda8f874$export$c8678fe90ec246e0(props) {
    const { activities: activities, userId: userId, currentUserId: currentUserId, isLoading: isLoading, userFullName: userFullName, hasError: hasError, error: error } = props;
    const analytics = (0, $38ra6.default)();
    const onClickViewAllLink = (0, $5uXOq.useCallback)((location)=>{
        analytics.pushUIEvent({
            source: (0, $fyzT1.AnalyticsEventSource).USER_PROFILE_SCREEN,
            actionSubject: 'viewAllWork',
            action: (0, $fyzT1.AnalyticsEventActions).CLICKED,
            attributes: {
                location: location
            }
        });
    }, [
        analytics
    ]);
    const onClickShowMore = (0, $5uXOq.useCallback)((numItemsDisplayed)=>{
        analytics.pushUIEvent({
            source: (0, $fyzT1.AnalyticsEventSource).USER_PROFILE_SCREEN,
            actionSubject: 'moreWork',
            action: (0, $fyzT1.AnalyticsEventActions).CLICKED,
            attributes: {
                numItemsDisplayed: numItemsDisplayed
            }
        });
    }, [
        analytics
    ]);
    const onActivityEntryClick = (0, $5uXOq.useCallback)((provider, entryIndex)=>{
        analytics.pushUIEvent({
            source: (0, $fyzT1.AnalyticsEventSource).USER_PROFILE_SCREEN,
            actionSubject: 'activityEntry',
            action: (0, $fyzT1.AnalyticsEventActions).CLICKED,
            attributes: {
                provider: provider.toUpperCase(),
                entryIndex: entryIndex
            }
        });
    }, [
        analytics
    ]);
    (0, $aOf1o.useExpTrackerStart)({
        id: userId,
        name: (0, $bA8uW.UserExperienceNames).USER_PROFILE_WORKED_ON,
        timeout: (0, $bA8uW.DEFAULT_TIMEOUT_USER_EXP)
    });
    (0, $lHKVj.useExpTrackerStop)({
        name: (0, $bA8uW.UserExperienceNames).USER_PROFILE_WORKED_ON,
        error: error,
        checkShouldAbort: (error)=>{
            if ((0, $iHA6C.isRealErrorUserProfile)(error)) return;
            return `Aborted because of ${error.message}`;
        }
    });
    let emptyView;
    if (hasError) emptyView = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hyK1p.default), {
        userFullName: userFullName,
        userId: userId
    });
    else emptyView = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4HgYh.default), {
        isCurrentUser: !!userId && userId === currentUserId,
        userFullName: userFullName,
        isForTable: false
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $brGTJ.default), {
                activities: activities,
                currentUserId: currentUserId,
                viewAllLink: `${userId}/work`,
                isLoading: isLoading,
                onClickViewAllLink: onClickViewAllLink,
                onClickShowMore: onClickShowMore,
                onClickActivityEntry: onActivityEntryClick,
                emptyView: emptyView,
                userId: userId
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jDqI3.ExperienceSuccess), {
                hasLoaded: !hasError && !isLoading,
                name: (0, $bA8uW.UserExperienceNames).USER_PROFILE_WORKED_ON
            })
        ]
    });
}
var $d5b99589eda8f874$export$2e2bcd8739ae039 = $d5b99589eda8f874$export$c8678fe90ec246e0;

});
parcelRegister("4HgYh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4908c45b819c3a39$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $hTEpF = parcelRequire("hTEpF");

var $dlt3Y = parcelRequire("dlt3Y");

var $1oj7F = parcelRequire("1oj7F");

var $hpYon = parcelRequire("hpYon");
function $4908c45b819c3a39$var$EmptyWorkState(props) {
    const { isForTable: isForTable, userId: userId, userFullName: userFullName, isCurrentUser: isCurrentUser } = props;
    const intl = (0, $koVbs.default)();
    const renderDescText = ()=>{
        const descMessage = isCurrentUser ? $4908c45b819c3a39$var$messages.noWorkListDescForYou : $4908c45b819c3a39$var$messages.noWorkListPersonDesc;
        return userFullName ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...descMessage,
            values: {
                user: userFullName
            }
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...$4908c45b819c3a39$var$messages.noWorkListTeamDesc
        });
    };
    if (isForTable) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hTEpF.default), {
        header: intl.formatMessage($4908c45b819c3a39$var$messages.noWorkListTitle),
        description: renderDescText(),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($1oj7F))),
        primaryAction: userId && userFullName && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hpYon.default), {
            isInEmptyState: true,
            userId: userId,
            userFullName: userFullName
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dlt3Y.EmptyStateNew), {
        title: intl.formatMessage($4908c45b819c3a39$var$messages.noWorkListTitle),
        description: renderDescText(),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($1oj7F))),
        actions: userId && userFullName && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hpYon.default), {
            isInEmptyState: true,
            userId: userId,
            userFullName: userFullName
        })
    });
}
const $4908c45b819c3a39$var$messages = (0, $7VHMR.defineMessages)({
    noWorkListTitle: {
        id: 'ptc-directory.profile-page.work-list.no-work-list.title',
        defaultMessage: 'There is no work to see here',
        description: 'Title of the message displayed when there is no work associated to the profile that is being viewed'
    },
    noWorkListTeamDesc: {
        id: 'ptc-directory.profile-page.work-list.no-work-list.team.description',
        defaultMessage: 'Things the team created, edited or commented on in the last 90 days.',
        description: 'Description of the message displayed when there is no work associated to the team profile that is being viewed'
    },
    noWorkListPersonDesc: {
        id: 'ptc-directory.profile-page.work-list.no-work-list.personal.description',
        defaultMessage: 'Things {user} created, edited or commented on in the last 90 days.',
        description: 'Description of the message displayed when there is no work associated to the person profile that is being viewed'
    },
    noWorkListDescForYou: {
        id: 'ptc-directory.profile-page.work-list.no-work-list.personal.description.you',
        defaultMessage: 'Things you created, edited or commented on in the last 90 days.',
        description: 'Description of the message displayed when there is no work associated to the current logged-in person profile that is being viewed'
    }
});
var $4908c45b819c3a39$export$2e2bcd8739ae039 = $4908c45b819c3a39$var$EmptyWorkState;

});
parcelRegister("dlt3Y", function(module, exports) {

$parcel$export(module.exports, "EmptyStateNew", () => $8027b1c73a356b50$export$4fb40e9ec756139e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $5qRwM = parcelRequire("5qRwM");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
var $414Wj = parcelRequire("414Wj");
var $dS3PR = parcelRequire("dS3PR");
const $8027b1c73a356b50$var$styles = {
    emptyStateBackgroundStyled: "_2rkopd34 _189ee4h9 _1h6dmuej _1dqonqa1 _kqswh2mm _ca0qv47k _u5f3xy5q _n3tdv47k _19bvxy5q",
    image: "_1bsbmgvx _4t3i7l9q"
};
const $8027b1c73a356b50$export$4fb40e9ec756139e = (props)=>{
    const { title: title, description: description, imageUrl: imageUrl, actions: actions, testId: testId, image: image } = props;
    const img = imageUrl ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5qRwM.default), {
        src: imageUrl,
        alt: ""
    }) : image;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        backgroundColor: "elevation.surface",
        xcss: $8027b1c73a356b50$var$styles.emptyStateBackgroundStyled,
        testId: testId,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
            space: "space.400",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    xcss: $8027b1c73a356b50$var$styles.image,
                    children: img
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
                    space: "space.200",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                            size: "small",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                            children: description
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                            space: "space.050",
                            children: actions
                        })
                    ]
                })
            ]
        })
    });
};

});

parcelRegister("1oj7F", function(module, exports) {
module.exports = new URL("WorkListEmpty_ptc.6b3d5f72.svg", import.meta.url).toString();

});

parcelRegister("hpYon", function(module, exports) {

$parcel$export(module.exports, "default", () => $b174b66200cd5524$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $ousew = parcelRequire("ousew");

var $VSDnB = parcelRequire("VSDnB");

var $cgL5K = parcelRequire("cgL5K");

var $fyzT1 = parcelRequire("fyzT1");
var $38ra6 = parcelRequire("38ra6");

var $e9Zmx = parcelRequire("e9Zmx");

var $2FwA3 = parcelRequire("2FwA3");
const $b174b66200cd5524$var$getConfluenceSearchLink = (userId)=>{
    return `/wiki/search?contributors=${encodeURIComponent(userId)}&lastModified=lastMonth`;
};
const $b174b66200cd5524$var$getJiraSearchLink = (userId)=>{
    // not sure why Jira does not need context-path for issue search page
    const jql = `assignee in (${userId})` + ` OR reporter in (${userId})` + ` OR creator in (${userId})` + ` OR watcher in (${userId})` + ' ORDER BY updated DESC';
    return `/issues/?jql=${encodeURIComponent(jql)}`;
};
const $b174b66200cd5524$var$SearchLink = (props)=>{
    const analytics = (0, $38ra6.default)();
    const { siteUrl: siteUrl } = (0, $2FwA3.useAppConfig)();
    const { container: container, userId: userId } = props;
    const onClickSearchLink = ()=>{
        analytics.pushUIEvent({
            source: (0, $fyzT1.AnalyticsEventSource).USER_WORK_SCREEN,
            actionSubject: 'searchMoreLink',
            action: (0, $fyzT1.AnalyticsEventActions).CLICKED,
            attributes: {
                container: container
            }
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e9Zmx.StyledLink), {
        href: (0, $VSDnB.fg)('append_site_url_more_search') ? `${siteUrl}${container === 'Confluence' ? $b174b66200cd5524$var$getConfluenceSearchLink(userId) : $b174b66200cd5524$var$getJiraSearchLink(userId)}` : container === 'Confluence' ? $b174b66200cd5524$var$getConfluenceSearchLink(userId) : $b174b66200cd5524$var$getJiraSearchLink(userId),
        target: "_blank",
        "data-test-selector": container.toLowerCase(),
        onClick: onClickSearchLink,
        children: container
    });
};
const $b174b66200cd5524$var$SearchMoreWork = (props)=>{
    const { isInEmptyState: isInEmptyState, userId: userId, userFullName: userFullName } = props;
    if (!userId || !userFullName) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cgL5K.default), {
        as: "p",
        children: [
            isInEmptyState ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...$b174b66200cd5524$var$messages.searchInEmptyState
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...$b174b66200cd5524$var$messages.searchNotInEmptyState
            }),
            ' ',
            /*#__PURE__*/ (0, $2OMIu.jsx)($b174b66200cd5524$var$SearchLink, {
                container: "Confluence",
                userId: userId
            }),
            " ",
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...$b174b66200cd5524$var$messages.or
            }),
            ' ',
            /*#__PURE__*/ (0, $2OMIu.jsx)($b174b66200cd5524$var$SearchLink, {
                container: "Jira",
                userId: userId
            })
        ]
    });
};
const $b174b66200cd5524$var$messages = (0, $7VHMR.defineMessages)({
    searchInEmptyState: {
        id: 'ptc-directory.profile-page.work-list.search.in.empty.state',
        defaultMessage: 'You can also search in',
        description: 'A part of a full message is which "You can also search in Confluence or Jira". This is used in empty state of work list component'
    },
    searchNotInEmptyState: {
        id: 'ptc-directory.profile-page.work-list.search.in.not.empty.state',
        defaultMessage: 'Search for more in',
        description: 'A part of a full message is which "Search for more in in Confluence or Jira". This is used in empty state of work list table component'
    },
    or: {
        id: 'ptc-directory.profile-page.work-list.or',
        defaultMessage: 'or',
        description: ''
    }
});
var $b174b66200cd5524$export$2e2bcd8739ae039 = $b174b66200cd5524$var$SearchMoreWork;

});
parcelRegister("e9Zmx", function(module, exports) {

$parcel$export(module.exports, "StyledLink", () => $6e31ab205a549ca5$export$9048d548939551ee);
/**
 * Use this component whenever you would need <a> or <Link>.
 * Use with `href` property to create an <a> tag and with `to` property
 * to create a <Link> tag.
 *
 * With using this component for all link elements we make sure links have
 * the proper hover and focus styles. Atlaskit/button with link appearance
 * does not have a correct focus style and is harder to deal with as it might
 * need additional props like spacing depending on where it's used.
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");


var $3FhRS = parcelRequire("3FhRS");
const $6e31ab205a549ca5$var$getColor = (props)=>props.appearance === 'subtle' ? `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})` : `var(--ds-link, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
const $6e31ab205a549ca5$var$getHoverColor = (props)=>props.appearance === 'subtle' ? `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$7c87d337fb91a97d})` : `var(--ds-link, ${0, $829f609a65d26a98$export$e62e8919cca44969})`;
const $6e31ab205a549ca5$var$getActiveColor = (props)=>props.appearance === 'subtle' ? `var(--ds-text, ${0, $829f609a65d26a98$export$7c87d337fb91a97d})` : `var(--ds-link-pressed, ${0, $829f609a65d26a98$export$e62e8919cca44969})`;
const $6e31ab205a549ca5$export$9048d548939551ee = /*#__PURE__*/ (0, $47bDC.default)((0, $3FhRS.default)).withConfig({
    componentId: "ae9szl-0"
})`color:${(props)=>$6e31ab205a549ca5$var$getColor(props)};&&:hover{color:${(props)=>$6e31ab205a549ca5$var$getHoverColor(props)};text-decoration:underline;}&&:focus{outline:2px solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`};outline-offset:2px;}&&:active{color:${(props)=>$6e31ab205a549ca5$var$getActiveColor(props)};outline:none;text-decoration:none;}`;

});



parcelRegister("hyK1p", function(module, exports) {

$parcel$export(module.exports, "default", () => $d79b87cc8a30f7cd$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $hTEpF = parcelRequire("hTEpF");

var $e4yMr = parcelRequire("e4yMr");

var $VSDnB = parcelRequire("VSDnB");

var $bJMK1 = parcelRequire("bJMK1");

var $jwXXk = parcelRequire("jwXXk");

var $hpYon = parcelRequire("hpYon");
const $d79b87cc8a30f7cd$var$SUPPORT_LINK_URI = (0, $bJMK1.getAtlassianContextUrl)('support');
const $d79b87cc8a30f7cd$var$SUPPORT_LINK = (0, $bJMK1.getAtlassianContextDomain)('support');
function $d79b87cc8a30f7cd$var$ErrorWorkState(props) {
    const { userId: userId, userFullName: userFullName } = props;
    const intl = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hTEpF.default), {
        header: intl.formatMessage($d79b87cc8a30f7cd$var$messages.errorTitle),
        description: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...$d79b87cc8a30f7cd$var$messages.errorDesc,
            values: {
                a: ()=>(0, $VSDnB.fg)('dst-a11y__replace-anchor-with-link__people-and-tea') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e4yMr.default), {
                        "data-testid": "support-link",
                        href: $d79b87cc8a30f7cd$var$SUPPORT_LINK_URI,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: $d79b87cc8a30f7cd$var$SUPPORT_LINK
                    }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                    /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
                        "data-testid": "support-link",
                        href: $d79b87cc8a30f7cd$var$SUPPORT_LINK_URI,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: $d79b87cc8a30f7cd$var$SUPPORT_LINK
                    })
            }
        }),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($jwXXk))),
        primaryAction: userFullName && userId && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hpYon.default), {
            isInEmptyState: true,
            userId: userId,
            userFullName: userFullName
        })
    });
}
const $d79b87cc8a30f7cd$var$messages = (0, $7VHMR.defineMessages)({
    errorTitle: {
        id: 'ptc-directory.profile-page.table-work-list.error.title',
        defaultMessage: 'We seem to have lost the connection',
        description: 'Title of error UI when fetching work list fails'
    },
    errorDesc: {
        id: 'ptc-directory.profile-page.table-work-list.error.desc',
        defaultMessage: 'Wait a few moments, then try refreshing the page. If this keeps happening, let us know at <a></a>.',
        description: 'Description of error UI when fetching work list fails'
    }
});
var $d79b87cc8a30f7cd$export$2e2bcd8739ae039 = $d79b87cc8a30f7cd$var$ErrorWorkState;

});
parcelRegister("jwXXk", function(module, exports) {
module.exports = new URL("WorkListError_ptc.b9457501.svg", import.meta.url).toString();

});


parcelRegister("brGTJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7674ab23854abda9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $ousew = parcelRequire("ousew");

var $jUV4i = parcelRequire("jUV4i");

var $5Q1Ge = parcelRequire("5Q1Ge");

var $5GuIO = parcelRequire("5GuIO");
const $7674ab23854abda9$var$timeFormatOptions = {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
};
const $7674ab23854abda9$var$getDescription = (activityObject, currentUserId)=>{
    if (activityObject.activity.length <= 0 || !activityObject.activity[0].user) return null;
    const description = activityObject.activity.length > 1 ? (0, $5Q1Ge.getI18nDataForManyEntries)(activityObject.activity, currentUserId) : (0, $5Q1Ge.getI18nDataForSingleEntry)(activityObject.activity[0], currentUserId);
    return description;
};
const $7674ab23854abda9$var$isDefined = (prop)=>{
    return !!prop;
};
function $7674ab23854abda9$export$ad0c9978cddbc3ff(activities, currentUserId) {
    return activities.map((activityObject)=>{
        const i18nForDescription = $7674ab23854abda9$var$getDescription(activityObject, currentUserId);
        if (!i18nForDescription) return null;
        if (i18nForDescription && 'time' in i18nForDescription.params && typeof i18nForDescription.params.time === 'string') i18nForDescription.params.time = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7VHMR.FormattedDate), {
            ...$7674ab23854abda9$var$timeFormatOptions,
            value: i18nForDescription.params.time
        });
        const { name: name = '', iconUrl: iconUrl = '', url: url = '', container: container = '', provider: provider = '' } = activityObject?.object || {};
        return {
            objectName: name,
            objectIconUrl: iconUrl,
            objectUrl: url,
            containerName: container,
            provider: provider,
            description: i18nForDescription ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...i18nForDescription.key,
                values: i18nForDescription.params
            }) : ''
        };
    }).filter($7674ab23854abda9$var$isDefined);
}
const $7674ab23854abda9$var$getInfoText = (userId, currentUserId)=>{
    /**
	 * Return null if:
	 *  - userId or currentUserId is not defined
	 *  - current user is not viewing own activity
	 */ if (!userId || !currentUserId || userId !== currentUserId) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...(0, $5GuIO.messages).privacyAssuringInfoText
    });
};
function $7674ab23854abda9$export$2e2bcd8739ae039(props) {
    const { activities: activities, currentUserId: currentUserId, userId: userId, titleText: titleText, emptyView: emptyView, isLoading: isLoading, ...otherProps } = props;
    const workItems = $7674ab23854abda9$export$ad0c9978cddbc3ff(activities || [], currentUserId);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jUV4i.default), {
        ...otherProps,
        workItems: workItems,
        isInitiallyExpanded: false,
        emptyView: emptyView,
        titleText: titleText,
        infoText: $7674ab23854abda9$var$getInfoText(userId, currentUserId),
        isLoading: isLoading
    });
}

});
parcelRegister("jUV4i", function(module, exports) {

$parcel$export(module.exports, "default", () => $03f4b8fbd8be4192$export$2e2bcd8739ae039);
/* WorkList.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $ddc5X = parcelRequire("ddc5X");

var $eZEvj = parcelRequire("eZEvj");

var $e9Zmx = parcelRequire("e9Zmx");

var $hIjCF = parcelRequire("hIjCF");

var $7aQTI = parcelRequire("7aQTI");

var $8oKfA = parcelRequire("8oKfA");
const $03f4b8fbd8be4192$var$styles = {
    workListItemsWrapper: "_2rkoiti9 _qtt8glyw _16qszucj _ca0qpxbi _n3tdpxbi _19bvu2gc _u5f3u2gc",
    workListItemsNext: "_qtt8glyw _19bvze3t",
    skeletonList: "_bozgu2gc _y4tiu2gc"
};
const $03f4b8fbd8be4192$export$2aa3c3bd0ee6f3b7 = (props)=>{
    const [isExpanded, setIsExpanded] = (0, $5uXOq.useState)(props.isInitiallyExpanded);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onShowMore = (e)=>{
        e.preventDefault();
        const { workItems: workItems, onClickShowMore: onClickShowMore, limitExpanded: limitExpanded } = props;
        setIsExpanded(true);
        const workItemsCount = workItems.length;
        if (onClickShowMore) onClickShowMore(// No limit? Show workItems count, otherwise show smaller of limit vs count
        !limitExpanded ? workItemsCount : workItemsCount <= limitExpanded ? workItemsCount : limitExpanded);
    };
    const onClickViewAllLink = (location)=>()=>{
            if (props.onClickViewAllLink) props.onClickViewAllLink(location);
        };
    const onClickActivityEntry = (provider, entryIndex)=>()=>{
            if (props.onClickActivityEntry) props.onClickActivityEntry(provider, entryIndex);
        };
    const renderShowMoreButton = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($8oKfA.FooterLink, {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e9Zmx.StyledLink), {
                appearance: "subtle",
                onClick: onShowMore,
                href: "#",
                "aria-label": formatMessage($03f4b8fbd8be4192$export$defe85febe8b728c.showMoreLinkLabel),
                children: formatMessage($03f4b8fbd8be4192$export$defe85febe8b728c.showMoreLink)
            })
        });
    const renderViewAllFooterButton = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($8oKfA.FooterLink, {
            "data-testid": "view-all-link__footer",
            children: renderViewAllLink({
                appearance: 'subtle',
                location: 'footer'
            })
        });
    const renderViewAllHeaderButton = ()=>props.workItems.length > 0 && props.viewAllLink && /*#__PURE__*/ (0, $2OMIu.jsx)($8oKfA.HeaderLink, {
            "data-testid": "view-all-link__header",
            children: renderViewAllLink({
                location: 'header'
            })
        });
    const renderViewAllLink = (linkOptions)=>{
        const { appearance: appearance = 'default', location: location } = linkOptions;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e9Zmx.StyledLink), {
            appearance: appearance,
            href: props.viewAllLink,
            onClick: onClickViewAllLink(location),
            "aria-label": formatMessage($03f4b8fbd8be4192$export$defe85febe8b728c.viewAllLinkLabel),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...$03f4b8fbd8be4192$export$defe85febe8b728c.viewAllLink
            })
        });
    };
    const renderFooterButtons = ()=>{
        const { viewAllLink: viewAllLink, workItems: workItems, limitDefault: limitDefault } = props;
        const workItemsCount = workItems.length;
        const canExpand = workItemsCount > limitDefault;
        if (workItemsCount === 0) return null;
        if (!isExpanded && canExpand) return renderShowMoreButton();
        if (viewAllLink) return renderViewAllFooterButton();
        return null;
    };
    const renderWorkItems = ()=>{
        const { workItems: workItems, limitDefault: limitDefault, limitExpanded: limitExpanded, isLoading: isLoading } = props;
        if (isLoading) return /*#__PURE__*/ (0, $2OMIu.jsx)($8oKfA.SkeletonWrapper, {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZEvj.default), {
                hasIcon: true,
                isShimmering: true,
                itemCount: limitDefault || 0,
                xcss: $03f4b8fbd8be4192$var$styles.skeletonList
            })
        });
        if (!workItems.length) return null;
        const limit = isExpanded ? limitExpanded : limitDefault;
        return workItems.slice(0, limit).map((resourceItem, idx)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $7aQTI.default), {
                objectName: resourceItem.objectName,
                description: resourceItem.description,
                objectUrl: resourceItem.objectUrl,
                objectIconUrl: resourceItem.objectIconUrl,
                containerName: resourceItem.containerName,
                provider: resourceItem.provider,
                onClick: onClickActivityEntry(resourceItem.provider, idx)
            }, `work-item-${idx}`));
    };
    const { titleText: titleText, infoText: infoText, workItems: workItems, emptyView: emptyView } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hIjCF.PanelContent), {
        "data-testid": "profile-work-list",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hIjCF.PanelContentHeader), {
                hasSubInfo: !!infoText,
                "data-testid": "profile-work-list-header",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hIjCF.PanelContentTitle), {
                        children: titleText || formatMessage($03f4b8fbd8be4192$export$defe85febe8b728c.listTitle)
                    }),
                    renderViewAllHeaderButton()
                ]
            }),
            infoText && /*#__PURE__*/ (0, $2OMIu.jsx)($8oKfA.WorkListInfoText, {
                "data-testid": "profile-work-list-info",
                children: infoText
            }),
            (0, $VSDnB.fg)('enable_team_profile_heading_a11y_fix') ? !workItems.length ? emptyView : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ddc5X.ItemWrapper), {
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $MHKc7.default), {
                    as: "ul",
                    xcss: $03f4b8fbd8be4192$var$styles.workListItemsNext,
                    children: [
                        renderWorkItems(),
                        renderFooterButtons()
                    ]
                })
            }) : !workItems.length ? emptyView : /*#__PURE__*/ (0, $2OMIu.jsxs)($8oKfA.WorkListItems, {
                children: [
                    renderWorkItems(),
                    renderFooterButtons()
                ]
            })
        ]
    });
};
$03f4b8fbd8be4192$export$2aa3c3bd0ee6f3b7.defaultProps = {
    isInitiallyExpanded: false,
    workItems: [],
    limitDefault: 5,
    limitExpanded: 10,
    onClickViewAllLink: ()=>null,
    onClickShowMore: ()=>null,
    onClickActivityEntry: ()=>null
};
const $03f4b8fbd8be4192$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    listTitle: {
        id: 'ptc-directory.profile-page.work-list.title',
        defaultMessage: 'Worked on'
    },
    showMoreLink: {
        id: 'ptc-directory.profile-page.work-list.show-more.link',
        defaultMessage: 'Show more',
        description: 'Link to reveal more work associated to the profile that is being viewed'
    },
    showMoreLinkLabel: {
        id: 'ptc-directory.profile-page.work-list.show-more.label',
        defaultMessage: 'Show more about worked on pages',
        description: 'Helper text for screen reader users. It is announced by screen reader when user focus the show more link'
    },
    viewAllLink: {
        id: 'ptc-directory.profile-page.work-list.view-all.link',
        defaultMessage: 'View all',
        description: 'Link to navigate to Work child page'
    },
    viewAllLinkLabel: {
        id: 'ptc-directory.profile-page.work-list.view-all.label',
        defaultMessage: 'View all worked on pages',
        description: 'Helper text for screen reader users. It is announced by screen reader when user focus the view all link'
    }
});
var $03f4b8fbd8be4192$export$2e2bcd8739ae039 = $03f4b8fbd8be4192$export$2aa3c3bd0ee6f3b7;

});
parcelRegister("eZEvj", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f0881c3fa7e502b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $iwwXK = parcelRequire("iwwXK");
const $2f0881c3fa7e502b$var$SkeletonList = ({ hasIcon: hasIcon, hasAvatar: hasAvatar, isShimmering: isShimmering, xcss: xcss, itemCount: itemCount })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: Array(itemCount).fill(undefined).map((_, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwwXK.default), {
                hasAvatar: hasAvatar,
                hasIcon: hasIcon,
                isShimmering: isShimmering,
                xcss: xcss
            }, `skeleton-${index}`))
    });
};
var $2f0881c3fa7e502b$export$2e2bcd8739ae039 = $2f0881c3fa7e502b$var$SkeletonList;

});

parcelRegister("7aQTI", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab598b54597e1e85$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $ousew = parcelRequire("ousew");

var $3u0c5 = parcelRequire("3u0c5");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");

var $5Q1Ge = parcelRequire("5Q1Ge");

var $kG2FO = parcelRequire("kG2FO");
const $ab598b54597e1e85$export$314aaaef607a8c3a = (props)=>{
    const { provider: provider, objectIconUrl: objectIconUrl, objectName: objectName, containerName: containerName, description: description, objectUrl: objectUrl, onClick: onClick } = props;
    const renderDraftStatus = ()=>{
        if (!(0, $5Q1Ge.isConfluenceDraft)(provider, objectUrl)) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)($kG2FO.LozengeWrapper, {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
                appearance: "inprogress",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...$ab598b54597e1e85$var$messages.draft
                })
            })
        });
    };
    const renderBody = ()=>{
        return /*#__PURE__*/ (0, $2OMIu.jsxs)($kG2FO.Content, {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)($kG2FO.ContentIcon, {
                    src: objectIconUrl,
                    alt: ""
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)($kG2FO.Details, {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsxs)($kG2FO.DetailsHeadline, {
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgL5K.default), {
                                    as: "p",
                                    children: objectName
                                }),
                                renderDraftStatus()
                            ]
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsxs)($kG2FO.DetailsDescription, {
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)($kG2FO.ContainerName, {
                                    children: containerName
                                }),
                                /*#__PURE__*/ (0, $2OMIu.jsx)($kG2FO.Description, {
                                    children: description
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    return (0, $VSDnB.fg)('enable_team_profile_heading_a11y_fix') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        as: "li",
        testId: "work-item",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($kG2FO.WorkItemLink, {
            href: objectUrl,
            onClick: onClick,
            children: renderBody()
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($kG2FO.WorkItemLink, {
        href: objectUrl,
        onClick: onClick,
        children: renderBody()
    });
};
const $ab598b54597e1e85$var$messages = (0, $7VHMR.defineMessages)({
    draft: {
        id: 'ptc-directory.profile-page.work-item.draft',
        defaultMessage: 'Draft',
        description: 'A status of Confluence draft page. Draft pages are pages that have not yet been published. This text shows in a lozenge and in work list'
    }
});
var $ab598b54597e1e85$export$2e2bcd8739ae039 = $ab598b54597e1e85$export$314aaaef607a8c3a;

});
parcelRegister("5Q1Ge", function(module, exports) {

$parcel$export(module.exports, "getI18nDataForSingleEntry", () => $877c8ce535842865$export$8d4c96888e68a4cb);
$parcel$export(module.exports, "getI18nDataForManyEntries", () => $877c8ce535842865$export$a8eeb0c18ec4b955);
$parcel$export(module.exports, "isConfluenceDraft", () => $877c8ce535842865$export$c73d42331d87b9d8);

var $9JptI = parcelRequire("9JptI");
var $iMVUf = parcelRequire("iMVUf");

var $5GuIO = parcelRequire("5GuIO");
const $877c8ce535842865$export$493c11ff22f45a24 = (activityDate)=>{
    if ((0, $iMVUf.default)(activityDate)) return 'Yesterday';
    if ((0, $9JptI.default)(activityDate)) return 'Today';
    return 'Time';
};
var $877c8ce535842865$export$5f5db21fc2e4c897 = /*#__PURE__*/ function(ActivityType) {
    ActivityType["EDITED"] = "Edited";
    ActivityType["COMMENTED"] = "Commented";
    ActivityType["CREATED"] = "Created";
    ActivityType["WORKED"] = "Worked";
    // some new event type from Worklens
    ActivityType["ASSIGNED"] = "Assigned";
    ActivityType["UNASSIGNED"] = "Unassigned";
    ActivityType["LIKED"] = "Liked";
    ActivityType["PUBLISHED"] = "Published";
    ActivityType["UPDATED"] = "Updated";
    return ActivityType;
}({});
const $877c8ce535842865$export$72f0c8726f4b058c = (activityType)=>{
    const allActivityVerbs = Object.values($877c8ce535842865$export$5f5db21fc2e4c897);
    const supportedVerb = allActivityVerbs.find((actionType)=>{
        return actionType.toLowerCase() === activityType.toLowerCase();
    });
    return supportedVerb || "Worked";
};
const $877c8ce535842865$export$8d4c96888e68a4cb = (activityEntry, currentUserId)=>{
    // Due to i18n'ing being a hard problem, there are many possible cases already listed in messages.
    // We'll construct the key rather than list them all here.
    // Key will be of the form: [you|other]Individual[Verb][Today|Yesterday|Time]
    const whoMadeActivity = activityEntry.user && activityEntry.user.id === currentUserId ? 'you' : 'other';
    const activityVerb = $877c8ce535842865$export$72f0c8726f4b058c(activityEntry.type);
    const activityTime = $877c8ce535842865$export$493c11ff22f45a24(activityEntry.date ? new Date(activityEntry.date) : new Date());
    const params = {
        name: activityEntry.user.fullName || ''
    };
    if (activityTime === 'Time') params.time = activityEntry.date || undefined;
    return {
        key: (0, $5GuIO.messages)[whoMadeActivity + 'Individual' + activityVerb + activityTime],
        params: params
    };
};
const $877c8ce535842865$var$I18N_KEYS_VARIATIONS_FOR_MULTIPLE = {
    you: {
        // including "with you" meaning for more than 1 activity
        '2': (0, $5GuIO.messages).youDoubleWorkedOn,
        '3': (0, $5GuIO.messages).youTripleWorkedOn,
        many: (0, $5GuIO.messages).youManyWorkedOn
    },
    others: {
        '2': (0, $5GuIO.messages).othersDoubleWorkedOn,
        '3': (0, $5GuIO.messages).othersTripleWorkedOn,
        many: (0, $5GuIO.messages).othersManyWorkedOn
    }
};
const $877c8ce535842865$export$a8eeb0c18ec4b955 = (userActivityEntries, currentUser)=>{
    const containsCurrentUser = userActivityEntries.some((activity)=>activity.user.id === currentUser);
    const otherUserFullNames = userActivityEntries.filter((activity)=>activity.user.id !== currentUser).map((activity)=>activity.user.fullName);
    // params that we will pass to our translations
    const othersCount = otherUserFullNames.length - (containsCurrentUser ? 1 : 2);
    const names = {};
    otherUserFullNames.forEach((userFullName, idx)=>{
        // @ts-ignore
        names[`name${idx + 1}`] = userFullName;
    });
    const activitiesCount = userActivityEntries.length;
    const collabAmount = activitiesCount <= 3 ? activitiesCount : 'many';
    const collabType = containsCurrentUser ? 'you' : 'others';
    return {
        // @ts-ignore
        key: $877c8ce535842865$var$I18N_KEYS_VARIATIONS_FOR_MULTIPLE[collabType][collabAmount],
        params: {
            count: othersCount,
            ...names
        }
    };
};
function $877c8ce535842865$export$c73d42331d87b9d8(provider, objectUrl) {
    if (!provider || !objectUrl) return false;
    return provider.toLowerCase() === 'confluence' && (objectUrl.includes('draftId=') || objectUrl.includes('draftShareId='));
}

});
parcelRegister("5GuIO", function(module, exports) {

$parcel$export(module.exports, "messages", () => $10c2dc679ea19de0$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");

var $5qQ7p = parcelRequire("5qQ7p");

var $2GJ1r = parcelRequire("2GJ1r");

var $ePTdu = parcelRequire("ePTdu");

var $hJW8u = parcelRequire("hJW8u");
/**
 * There are a LOT of messages here due to the joys of i18n. They roughly fall into the following categories"
 *  -> Single person that isn't you performed an action (one for each verb and time period combination)
 *  -> Single person that is you performed an action (one for each verb and time period combination)
 *  -> Two people performed an action (one for including you, and one for not including you)
 *  -> Three people performed an action (one for including you, and one for not including you)
 *  -> More than three people performed an action (one for including you, and one for not including you)
 */ const $10c2dc679ea19de0$var$otherMsg = (0, $7VHMR.defineMessages)({
    privacyAssuringInfoText: {
        id: 'ptc-directory.work-activity.privacy-assurity',
        defaultMessage: 'Others will only see what they can access.',
        description: "Appears next to a list of recently worked on items on a user\u2019s own profile page. Only appears when viewing yourself. Text assuring the user that private activity items will not appear to others who view this page. Visibility is subject to each individual\u2019s privileges."
    }
});
const $10c2dc679ea19de0$export$defe85febe8b728c = {
    ...$10c2dc679ea19de0$var$otherMsg,
    ...(0, $5qQ7p.messages),
    ...(0, $2GJ1r.messages),
    ...(0, $hJW8u.messages),
    ...(0, $ePTdu.messages)
};

});
parcelRegister("5qQ7p", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f233f745d6bd71fd$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f233f745d6bd71fd$var$msgForCommented = (0, $7VHMR.defineMessages)({
    otherIndividualCommentedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.commented.today',
        defaultMessage: '{name} commented here today',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else commented on the work today."
    },
    otherIndividualCommentedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.commented.yesterday',
        defaultMessage: '{name} commented here yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else commented on the work yesterday."
    },
    otherIndividualCommentedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.commented.time',
        defaultMessage: '{name} commented here on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else commented on the work earlier than yesterday."
    }
});
const $f233f745d6bd71fd$var$msgForCreated = (0, $7VHMR.defineMessages)({
    otherIndividualCreatedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.created.today',
        defaultMessage: '{name} created this today',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else created the work today."
    },
    otherIndividualCreatedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.created.yesterday',
        defaultMessage: '{name} created this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else created the work yesterday"
    },
    otherIndividualCreatedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.created.time',
        defaultMessage: '{name} created this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else created the work earlier than yesterday."
    }
});
const $f233f745d6bd71fd$var$msgForEdited = (0, $7VHMR.defineMessages)({
    otherIndividualEditedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.edited.today',
        defaultMessage: '{name} edited this today',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else edited the work today"
    },
    otherIndividualEditedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.edited.yesterday',
        defaultMessage: '{name} edited this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else edited the work yesterday"
    },
    otherIndividualEditedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.edited.time',
        defaultMessage: '{name} edited this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else edited the work earlier than yesterday"
    }
});
const $f233f745d6bd71fd$var$msgForWorked = (0, $7VHMR.defineMessages)({
    otherIndividualWorkedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.worked.today',
        defaultMessage: '{name} worked on this today',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else performed an unknown operation on the work today"
    },
    otherIndividualWorkedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.worked.yesterday',
        defaultMessage: '{name} worked on this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else performed an unknown operation on the work yesterday"
    },
    otherIndividualWorkedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.worked.time',
        defaultMessage: '{name} worked on this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else performed an unknown operation on the work earlier than yesterday"
    }
});
const $f233f745d6bd71fd$var$msgForAssigned = (0, $7VHMR.defineMessages)({
    otherIndividualAssignedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.assigned.today',
        defaultMessage: '{name} was assigned this today',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else assigned the work today"
    },
    otherIndividualAssignedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.assigned.yesterday',
        defaultMessage: '{name} was assigned this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else assigned the work yesterday"
    },
    otherIndividualAssignedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.assigned.time',
        defaultMessage: '{name} was assigned this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else assigned the work earlier than yesterday"
    }
});
const $f233f745d6bd71fd$var$msgForUnassigned = (0, $7VHMR.defineMessages)({
    otherIndividualUnassignedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.unassigned.today',
        defaultMessage: '{name} was unassigned this today',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else unassigned the work today"
    },
    otherIndividualUnassignedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.unassigned.yesterday',
        defaultMessage: '{name} was unassigned this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else unassigned the work yesterday"
    },
    otherIndividualUnassignedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.unassigned.time',
        defaultMessage: '{name} was unassigned this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else unassigned the work earlier than yesterday"
    }
});
const $f233f745d6bd71fd$var$msgForLiked = (0, $7VHMR.defineMessages)({
    otherIndividualLikedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.liked.today',
        defaultMessage: '{name} liked this today',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else liked the work today"
    },
    otherIndividualLikedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.liked.yesterday',
        defaultMessage: '{name} liked this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else liked the work yesterday"
    },
    otherIndividualLikedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.liked.time',
        defaultMessage: '{name} liked this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else liked the work earlier than yesterday"
    }
});
const $f233f745d6bd71fd$var$msgForPublished = (0, $7VHMR.defineMessages)({
    otherIndividualPublishedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.published.today',
        defaultMessage: '{name} published this today',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else published the work today"
    },
    otherIndividualPublishedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.published.yesterday',
        defaultMessage: '{name} published this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else published the work yesterday"
    },
    otherIndividualPublishedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.published.time',
        defaultMessage: '{name} published this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else published the work earlier than yesterday"
    }
});
const $f233f745d6bd71fd$var$msgForUpdated = (0, $7VHMR.defineMessages)({
    otherIndividualUpdatedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.updated.today',
        defaultMessage: '{name} updated this today',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else updated the work today"
    },
    otherIndividualUpdatedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.updated.yesterday',
        defaultMessage: '{name} updated this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else updated the work yesterday"
    },
    otherIndividualUpdatedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.updated.time',
        defaultMessage: '{name} updated this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else updated the work earlier than yesterday"
    }
});
const $f233f745d6bd71fd$export$defe85febe8b728c = {
    ...$f233f745d6bd71fd$var$msgForCommented,
    ...$f233f745d6bd71fd$var$msgForCreated,
    ...$f233f745d6bd71fd$var$msgForEdited,
    ...$f233f745d6bd71fd$var$msgForWorked,
    ...$f233f745d6bd71fd$var$msgForAssigned,
    ...$f233f745d6bd71fd$var$msgForUnassigned,
    ...$f233f745d6bd71fd$var$msgForLiked,
    ...$f233f745d6bd71fd$var$msgForPublished,
    ...$f233f745d6bd71fd$var$msgForUpdated
};

});

parcelRegister("2GJ1r", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ed9271a4a426003e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $ed9271a4a426003e$var$msgForWorked = (0, $7VHMR.defineMessages)({
    youIndividualWorkedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.worked.today',
        defaultMessage: 'You worked on this today',
        description: "This message appears in work list area of the user profile pageand indicate when you performed an unknown operation on the work today"
    },
    youIndividualWorkedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.worked.yesterday',
        defaultMessage: 'You worked on this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when you performed an unknown operation on the work yesterday"
    },
    youIndividualWorkedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.worked.time',
        defaultMessage: 'You worked on this {time}',
        description: "This message appears in work list area of the user profile pageand indicate when you performed an unknown operation on the work earlier than yesterday"
    }
});
const $ed9271a4a426003e$var$msgForCommented = (0, $7VHMR.defineMessages)({
    youIndividualCommentedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.commented.today',
        defaultMessage: 'You commented here today',
        description: "This message appears in work list area of the user profile pageand indicate when the current user commented on the work today"
    },
    youIndividualCommentedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.commented.yesterday',
        defaultMessage: 'You commented here yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when the current user commented on the work yesterday"
    },
    youIndividualCommentedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.commented.time',
        defaultMessage: 'You commented here on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when the current user commented on the work earlier than yesterday"
    }
});
const $ed9271a4a426003e$var$msgForCreated = (0, $7VHMR.defineMessages)({
    youIndividualCreatedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.created.today',
        defaultMessage: 'You created this today',
        description: "This message appears in work list area of the user profile pageand indicate when the current user created the work today"
    },
    youIndividualCreatedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.created.yesterday',
        defaultMessage: 'You created this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when the current user created the work yesterday"
    },
    youIndividualCreatedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.created.time',
        defaultMessage: 'You created this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when the current user created the work earlier than yesterday"
    }
});
const $ed9271a4a426003e$var$msgForEdited = (0, $7VHMR.defineMessages)({
    youIndividualEditedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.edited.today',
        defaultMessage: 'You edited this today',
        description: "This message appears in work list area of the user profile pageand indicate when the current user edited the work today"
    },
    youIndividualEditedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.edited.yesterday',
        defaultMessage: 'You edited this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when the current user edited the work yesterday"
    },
    youIndividualEditedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.edited.time',
        defaultMessage: 'You edited this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when the current user edited the work earlier than yesterday"
    }
});
const $ed9271a4a426003e$var$msgForAssigned = (0, $7VHMR.defineMessages)({
    youIndividualAssignedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.assigned.today',
        defaultMessage: 'You were assigned this today',
        description: "This message appears in work list area of the user profile pageand indicate when the current user is assigned the work today"
    },
    youIndividualAssignedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.assigned.yesterday',
        defaultMessage: 'You were assigned this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when the current user is assigned the work yesterday"
    },
    youIndividualAssignedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.assigned.time',
        defaultMessage: 'You were assigned this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when the current user is assigned the work earlier than yesterday"
    }
});
const $ed9271a4a426003e$var$msgForUnassigned = (0, $7VHMR.defineMessages)({
    youIndividualUnassignedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.unassigned.today',
        defaultMessage: 'You were unassigned this today',
        description: "This message appears in work list area of the user profile pageand indicate when the current user is unassigned the work today"
    },
    youIndividualUnassignedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.unassigned.yesterday',
        defaultMessage: 'You were unassigned this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when the current user is assigned the work yesterday"
    },
    youIndividualUnassignedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.unassigned.time',
        defaultMessage: 'You were unassigned this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when the current user is unassigned the work earlier than yesterday"
    }
});
const $ed9271a4a426003e$var$msgForLiked = (0, $7VHMR.defineMessages)({
    youIndividualLikedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.liked.today',
        defaultMessage: 'You liked this today',
        description: "This message appears in work list area of the user profile pageand indicate when the current user liked the work today"
    },
    youIndividualLikedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.liked.yesterday',
        defaultMessage: 'You liked this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when the current user is assigned the work yesterday"
    },
    youIndividualLikedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.liked.time',
        defaultMessage: 'You liked this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when the current user liked the work earlier than yesterday"
    }
});
const $ed9271a4a426003e$var$msgForPublished = (0, $7VHMR.defineMessages)({
    youIndividualPublishedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.published.today',
        defaultMessage: 'You published this today',
        description: "This message appears in work list area of the user profile pageand indicate when the current user published the work today"
    },
    youIndividualPublishedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.published.yesterday',
        defaultMessage: 'You published this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when the current user is assigned the work yesterday"
    },
    youIndividualPublishedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.published.time',
        defaultMessage: 'You published this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when the current user published the work earlier than yesterday"
    }
});
const $ed9271a4a426003e$var$msgForUpdated = (0, $7VHMR.defineMessages)({
    youIndividualUpdatedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.updated.today',
        defaultMessage: 'You updated this today',
        description: "This message appears in work list area of the user profile pageand indicate when the current user updated the work today"
    },
    youIndividualUpdatedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.updated.yesterday',
        defaultMessage: 'You updated this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when the current user is assigned the work yesterday"
    },
    youIndividualUpdatedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.updated.time',
        defaultMessage: 'You updated this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when the current user updated the work earlier than yesterday"
    }
});
const $ed9271a4a426003e$export$defe85febe8b728c = {
    ...$ed9271a4a426003e$var$msgForWorked,
    ...$ed9271a4a426003e$var$msgForCommented,
    ...$ed9271a4a426003e$var$msgForCreated,
    ...$ed9271a4a426003e$var$msgForEdited,
    ...$ed9271a4a426003e$var$msgForAssigned,
    ...$ed9271a4a426003e$var$msgForUnassigned,
    ...$ed9271a4a426003e$var$msgForLiked,
    ...$ed9271a4a426003e$var$msgForPublished,
    ...$ed9271a4a426003e$var$msgForUpdated
};

});

parcelRegister("ePTdu", function(module, exports) {

$parcel$export(module.exports, "messages", () => $436aca3b2f77fbf0$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $436aca3b2f77fbf0$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    othersManyWorkedOn: {
        id: 'ptc-directory.team-profile-page.team-work.many.others.worked',
        defaultMessage: '{name1}, {name2}, and {count} others have all worked on this',
        description: "This message appears in work list area of the user profile pageand indicate when more than three users that arent you worked on an object"
    },
    youManyWorkedOn: {
        id: 'ptc-directory.team-profile-page.team-work.many.you.worked',
        defaultMessage: 'You, {name1}, and {count} others have all worked on this',
        description: "This message appears in work list area of the user profile pageand indicate when more than three users including the current user worked on an object"
    }
});

});

parcelRegister("hJW8u", function(module, exports) {

$parcel$export(module.exports, "messages", () => $42c6e3d10907095e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $42c6e3d10907095e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    othersDoubleWorkedOn: {
        id: 'ptc-directory.team-profile-page.team-work.double.others.worked',
        defaultMessage: '{name1} and {name2} have both worked on this',
        description: "This message appears in work list area of the user profile pageand indicate when two users that arent you worked on an object"
    },
    youDoubleWorkedOn: {
        id: 'ptc-directory.team-profile-page.team-work.double.you.worked',
        defaultMessage: 'You and {name1} have both worked on this',
        description: "This message appears in work list area of the user profile pageand indicate when two users including the current user worked on an object"
    },
    // Messages for three people
    othersTripleWorkedOn: {
        id: 'ptc-directory.team-profile-page.team-work.triple.others.worked',
        defaultMessage: '{name1}, {name2}, and {name3} have all worked on this',
        description: "This message appears in work list area of the user profile pageand indicate when three users that arent you worked on an object"
    },
    youTripleWorkedOn: {
        id: 'ptc-directory.team-profile-page.team-work.triple.you.worked',
        defaultMessage: 'You, {name1}, and {name2} have all worked on this',
        description: "This message appears in work list area of the user profile pageand indicate when three users including the current user worked on an object"
    }
});

});



parcelRegister("kG2FO", function(module, exports) {

$parcel$export(module.exports, "WorkItemLink", () => $9080898bf1dcbb39$export$337f3677fd9cf9c1);
$parcel$export(module.exports, "Content", () => $9080898bf1dcbb39$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "ContentIcon", () => $9080898bf1dcbb39$export$a1ea799cb5c1b499);
$parcel$export(module.exports, "Details", () => $9080898bf1dcbb39$export$3e8048d3cf2ba3fd);
$parcel$export(module.exports, "DetailsHeadline", () => $9080898bf1dcbb39$export$505f19144b08f91a);
$parcel$export(module.exports, "DetailsDescription", () => $9080898bf1dcbb39$export$6ac35bf2875b1dd9);
$parcel$export(module.exports, "ContainerName", () => $9080898bf1dcbb39$export$b7e45c2cd09f088a);
$parcel$export(module.exports, "Description", () => $9080898bf1dcbb39$export$393edc798c47379d);
$parcel$export(module.exports, "LozengeWrapper", () => $9080898bf1dcbb39$export$75180efdd3f4d9c2);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");


var $3FhRS = parcelRequire("3FhRS");
const $9080898bf1dcbb39$export$337f3677fd9cf9c1 = /*#__PURE__*/ (0, $47bDC.default)((0, $3FhRS.default)).withConfig({
    componentId: "sc-1brh7h6-0"
})`position:relative;margin:0;overflow:hidden;display:block;padding-left:${"var(--ds-space-150, 12px)"};padding-right:${"var(--ds-space-150, 12px)"};border-radius:${"var(--ds-border-radius-100, 3px)"};&:hover{background:${`var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`};}&:focus{outline:0;box-shadow:0 0 0 2px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`};}& + &{margin:${"var(--ds-space-050, 4px)"} 0 0 0;}`;
const $9080898bf1dcbb39$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1brh7h6-1"
})`display:flex;`;
const $9080898bf1dcbb39$export$a1ea799cb5c1b499 = /*#__PURE__*/ (0, $47bDC.default).img.withConfig({
    componentId: "sc-1brh7h6-2"
})`border-radius:${"var(--ds-border-radius-100, 3px)"};display:flex;flex-shrink:0;width:${"var(--ds-space-300, 24px)"};height:${"var(--ds-space-300, 24px)"};margin-top:${"var(--ds-space-100, 8px)"};margin-bottom:${"var(--ds-space-100, 8px)"};`;
const $9080898bf1dcbb39$export$3e8048d3cf2ba3fd = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1brh7h6-3"
})`display:flex;flex-direction:column;margin-left:${"var(--ds-space-200, 16px)"};justify-content:center;min-width:0;`;
const $9080898bf1dcbb39$export$505f19144b08f91a = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1brh7h6-4"
})`padding-right:${"var(--ds-space-150, 12px)"};padding-bottom:${"var(--ds-space-025, 2px)"};display:flex;align-items:center;p{display:inline-block;font:${"var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};margin:0;color:${`var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`};overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}`;
const $9080898bf1dcbb39$export$6ac35bf2875b1dd9 = /*#__PURE__*/ (0, $47bDC.default).p.withConfig({
    componentId: "sc-1brh7h6-5"
})`font:${"var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};color:${`var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`};margin:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding-right:${"var(--ds-space-150, 12px)"};`;
const $9080898bf1dcbb39$export$b7e45c2cd09f088a = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "sc-1brh7h6-6"
})`&:after{content:'\\00B7';padding-right:${"var(--ds-space-050, 4px)"};padding-left:${"var(--ds-space-050, 4px)"};}`;
const $9080898bf1dcbb39$export$393edc798c47379d = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "sc-1brh7h6-7"
})``;
const $9080898bf1dcbb39$export$75180efdd3f4d9c2 = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "sc-1brh7h6-8"
})`margin-left:${"var(--ds-space-050, 4px)"};`;

});


parcelRegister("8oKfA", function(module, exports) {

$parcel$export(module.exports, "HeaderLink", () => $da07566774d8264f$export$29c3409e43add430);
$parcel$export(module.exports, "FooterLink", () => $da07566774d8264f$export$e0513c91be1318ca);
$parcel$export(module.exports, "WorkListInfoText", () => $da07566774d8264f$export$fff90b174811109c);
$parcel$export(module.exports, "WorkListItems", () => $da07566774d8264f$export$3af7e1e011c8bee1);
$parcel$export(module.exports, "SkeletonWrapper", () => $da07566774d8264f$export$6069cbe61f690103);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");


var $6PHb3 = parcelRequire("6PHb3");
const $da07566774d8264f$export$29c3409e43add430 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-12dsuy4-0"
})`margin-left:${"var(--ds-space-300, 24px)"};`;
const $da07566774d8264f$export$e0513c91be1318ca = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-12dsuy4-1"
})`font-size:${"var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};margin-left:${"var(--ds-space-150, 12px)"};margin-top:${"var(--ds-space-200, 16px)"};display:flex;color:${`var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`};`;
const $da07566774d8264f$export$fff90b174811109c = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-12dsuy4-2"
})`display:flex;align-items:center;width:100%;${(0, $6PHb3.smallTextTypography)};`;
const $da07566774d8264f$export$3af7e1e011c8bee1 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-12dsuy4-3"
})`border-radius:${"var(--ds-border-radius-100, 3px)"};background-color:${"var(--ds-surface-raised, transparent)"};box-shadow:${`var(--ds-shadow-raised, ${`0 1px 1px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px 1px ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)}`})`};padding:${"var(--ds-space-200, 16px)"} ${"var(--ds-space-100, 8px)"};${$da07566774d8264f$export$fff90b174811109c} + &{margin-top:${"var(--ds-space-200, 16px)"};}`;
const $da07566774d8264f$export$7fd31be4a556b1a0 = /*#__PURE__*/ (0, $47bDC.default).img.withConfig({
    componentId: "sc-12dsuy4-4"
})`height:${144}px;`;
const $da07566774d8264f$export$475f8a59614a59ca = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-12dsuy4-5"
})`margin-left:${"var(--ds-space-400, 32px)"};min-width:180px;`;
const $da07566774d8264f$export$a4f85c7f5a5731ac = /*#__PURE__*/ (0, $47bDC.default).h3.withConfig({
    componentId: "sc-12dsuy4-6"
})`margin-bottom:${"var(--ds-space-200, 16px)"};`;
const $da07566774d8264f$export$cb03cebe08ab9b6a = /*#__PURE__*/ (0, $47bDC.default).p.withConfig({
    componentId: "sc-12dsuy4-7"
})``;
const $da07566774d8264f$export$6069cbe61f690103 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-12dsuy4-8"
})`& + &{margin:${"var(--ds-space-050, 4px)"} 0 0 0;}`;

});
parcelRegister("6PHb3", function(module, exports) {

$parcel$export(module.exports, "ellipsis", () => $074079ff2807afce$export$a5b94313d6908893);
$parcel$export(module.exports, "ellipsisInFlexChild", () => $074079ff2807afce$export$58ca30256a534b20);
$parcel$export(module.exports, "smallTextTypography", () => $074079ff2807afce$export$64de456cd1a0ab3f);
$parcel$export(module.exports, "linkShadowItem", () => $074079ff2807afce$export$37da6d213fb80270);
$parcel$export(module.exports, "MultilineEllipsis", () => $074079ff2807afce$export$7252344cf484ff6d);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression */ 

var $47bDC = parcelRequire("47bDC");

var $cLkWx = parcelRequire("cLkWx");
const $074079ff2807afce$export$a5b94313d6908893 = `
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
const $074079ff2807afce$export$e6fc941710bd9bc7 = `
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const $074079ff2807afce$export$58ca30256a534b20 = /*#__PURE__*/ (0, $47bDC.css)`min-width:0;${$074079ff2807afce$export$a5b94313d6908893};`;
const $074079ff2807afce$export$2c2e9c688ff3eaac = /*#__PURE__*/ (0, $47bDC.css)`font:${"var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};font-weight:${"var(--ds-font-weight-regular, 400)"};color:${`var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`};`;
const $074079ff2807afce$export$64de456cd1a0ab3f = /*#__PURE__*/ (0, $47bDC.css)`color:${`var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`};font:${"var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};`;
const $074079ff2807afce$export$37da6d213fb80270 = /*#__PURE__*/ (0, $47bDC.css)`background:${`var(--ds-surface-raised, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`};border-radius:${"var(--ds-border-radius-100, 3px)"};transition:box-shadow 0.25s ease;box-shadow:${`var(--ds-shadow-raised, ${`0 1px 1px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px 1px ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)}`})`};&:hover,&.active{box-shadow:${`var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`};}`;
const $074079ff2807afce$export$7252344cf484ff6d = (maxLines = 1, lineHeight = (0, $cLkWx.rootAbsoluteLineHeight))=>(0, $47bDC.css)`overflow:hidden;-webkit-line-clamp:${maxLines};-webkit-box-orient:vertical;display:-webkit-box;text-overflow:ellipsis;max-height:${maxLines * lineHeight}px;`;

});
parcelRegister("cLkWx", function(module, exports) {

$parcel$export(module.exports, "rootAbsoluteLineHeight", () => $7f54b0a49ce10b0a$export$914d38d0b781a6d3);
$parcel$export(module.exports, "getGlobalTheme", () => $7f54b0a49ce10b0a$export$813ecdf77207a053);
const $7f54b0a49ce10b0a$export$3abda77ebd0bb50f = 1.42857143;
const $7f54b0a49ce10b0a$export$a22cfca5dbca7fb5 = 14;
const $7f54b0a49ce10b0a$export$914d38d0b781a6d3 = $7f54b0a49ce10b0a$export$3abda77ebd0bb50f * $7f54b0a49ce10b0a$export$a22cfca5dbca7fb5;
const $7f54b0a49ce10b0a$export$813ecdf77207a053 = ()=>{
    // Determine global theme
    const documentElement = document.documentElement;
    const rawTheme = documentElement.getAttribute('data-theme');
    return rawTheme === 'dark' ? 'dark' : 'light';
};

});








parcelRegister("5vaD6", function(module, exports) {

$parcel$export(module.exports, "AgentAboutPanel", () => $469befa4d2561ce6$export$a9a242371bd64127);
/* AgentAboutPanel.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $l1N8i = parcelRequire("l1N8i");

var $kaa7g = parcelRequire("kaa7g");

var $c0aEF = parcelRequire("c0aEF");
var $414Wj = parcelRequire("414Wj");

var $dD7jF = parcelRequire("dD7jF");
var $2XXD4 = parcelRequire("2XXD4");
var $dQjNg = parcelRequire("dQjNg");
var $9XSXa = parcelRequire("9XSXa");

var $fyzT1 = parcelRequire("fyzT1");

var $7YTpJ = parcelRequire("7YTpJ");

var $19iJP = parcelRequire("19iJP");
const $469befa4d2561ce6$var$unboundedStyles = {
    agentAboutPanel: "_2rkoi2wt"
};
const $469befa4d2561ce6$var$styles = {
    agentAboutPanel: "_16qszucj _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _1e0c1txw _2lx21bp4"
};
const $469befa4d2561ce6$var$AbouSectionHeaders = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
        size: "xxsmall",
        children: children
    });
const $469befa4d2561ce6$export$eceb80593c9ade2e = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            $469befa4d2561ce6$var$unboundedStyles.agentAboutPanel
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $414Wj.default), {
            xcss: $469befa4d2561ce6$var$styles.agentAboutPanel,
            space: "space.300",
            children: children
        })
    });
const $469befa4d2561ce6$export$a9a242371bd64127 = ({ agent: agent, assistanceServiceParams: assistanceServiceParams })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const agentIdentityId = (0, $7YTpJ.trimUserARI)(agent?.identity_account_id || '');
    const { getKnowledgeProductsRenderForAgent: getKnowledgeProductsRenderForAgent } = (0, $9XSXa.useKnowledgeProductsRender)({
        assistanceServiceParams: assistanceServiceParams
    });
    const isForgeAgent = agent.creator_type === 'THIRD_PARTY' || agent.creator_type === 'FORGE';
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)($469befa4d2561ce6$export$eceb80593c9ade2e, {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
                    space: "space.100",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)($469befa4d2561ce6$var$AbouSectionHeaders, {
                            children: formatMessage($469befa4d2561ce6$var$messages.aboutLabel)
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                            space: "space.100",
                            alignBlock: "center",
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kaa7g))), {
                                    label: "",
                                    color: "currentColor"
                                }),
                                formatMessage($469befa4d2561ce6$var$messages.rovoAgentLabel)
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
                    space: "space.100",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)($469befa4d2561ce6$var$AbouSectionHeaders, {
                            children: formatMessage($469befa4d2561ce6$var$messages.knowledgeLabel)
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2XXD4.AgentKnowledgeSection), {
                            aris: (0, $dQjNg.getEnabledKnowlegeArisFromAgent)(agent),
                            isForgeAgent: isForgeAgent,
                            knowledgeProductsRender: getKnowledgeProductsRenderForAgent({
                                sources: agent.knowledge_sources?.sources ?? [],
                                // TODO fill this with the correct value
                                cloudUrl: undefined,
                                knowledgeScopeEnabled: agent.knowledge_sources?.enabled ?? false
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
                    space: "space.100",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)($469befa4d2561ce6$var$AbouSectionHeaders, {
                            children: formatMessage($469befa4d2561ce6$var$messages.actionLabel)
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dD7jF.ActionsSection), {
                            actions: agent.action_config || []
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $414Wj.default), {
                    space: "space.100",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $19iJP.default), {
                        userId: agentIdentityId,
                        isActiveUser: !agent.deactivated,
                        userFullName: agent.name,
                        analyticsSource: (0, $fyzT1.AnalyticsEventSource).USER_PROFILE_SCREEN
                    })
                })
            ]
        })
    });
};
const $469befa4d2561ce6$var$messages = (0, $7VHMR.defineMessages)({
    aboutLabel: {
        id: 'ptc-directory.agent-profile.about-agent.about-label',
        defaultMessage: 'About',
        description: 'Label for about section of the agent'
    },
    rovoAgentLabel: {
        id: 'ptc-directory.agent-profile.about-agent.rovo-agent-label',
        defaultMessage: 'Rovo Agent',
        description: 'The content inside About section, indicating this profile is a Rovo Agent'
    },
    knowledgeLabel: {
        id: 'ptc-directory.agent-profile.about-agent.knowledge-label',
        defaultMessage: 'Knowledge',
        description: 'Label for knowledge section of the agent'
    },
    actionLabel: {
        id: 'ptc-directory.agent-profile.about-agent.action-label',
        defaultMessage: 'Actions',
        description: 'Label for action section of the agent'
    },
    teamsLabel: {
        id: 'ptc-directory.agent-profile.about-agent.teams-label',
        defaultMessage: 'Teams',
        description: 'Label for teams section of the agent'
    },
    createTeamLabel: {
        id: 'ptc-directory.agent-profile.about-agent.teams-label',
        defaultMessage: 'Create a team together',
        description: 'Label for teams section of the agent'
    }
});

});
parcelRegister("kaa7g", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e2b10cb2fb36d0ad7bfa02e0b0408651>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eadc96b253df8830$var$_react = $eadc96b253df8830$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $eadc96b253df8830$var$_baseNew = $eadc96b253df8830$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $eadc96b253df8830$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Briefcase".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Job title in Atlas, Operations in JSM.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eadc96b253df8830$var$BriefcaseIcon = (props)=>/*#__PURE__*/ $eadc96b253df8830$var$_react.default.createElement($eadc96b253df8830$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 2.5a.5.5 0 0 0-.5.5v1h5V3a.5.5 0 0 0-.5-.5zM12 4V3a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v1H3a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM3 5.5a.5.5 0 0 0-.5.5v2h11V6a.5.5 0 0 0-.5-.5zm10.5 4H8.75V11h-1.5V9.5H2.5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$eadc96b253df8830$var$BriefcaseIcon.displayName = 'BriefcaseIcon';
var $eadc96b253df8830$var$_default = module.exports.default = $eadc96b253df8830$var$BriefcaseIcon;

});

parcelRegister("dD7jF", function(module, exports) {

$parcel$export(module.exports, "ActionsSection", () => $5b531eefbfc8a4af$export$62272bfa980718f8);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $414Wj = parcelRequire("414Wj");
var $dS3PR = parcelRequire("dS3PR");

var $icliG = parcelRequire("icliG");

var $eot01 = parcelRequire("eot01");
const $5b531eefbfc8a4af$export$62272bfa980718f8 = ({ actions: actions })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!actions.length) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
        children: formatMessage((0, $eot01.default).noActions)
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $414Wj.default), {
        space: "space.050",
        children: actions.map((action)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $icliG.AgentActionPill), {
                action: action
            }, action.id))
    });
};

});
parcelRegister("icliG", function(module, exports) {

$parcel$export(module.exports, "AgentActionPill", () => $a88d4af8adb322fd$export$af13476fcb733bb1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $3u0c5 = parcelRequire("3u0c5");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
var $dS3PR = parcelRequire("dS3PR");

var $dekey = parcelRequire("dekey");

var $lz0gk = parcelRequire("lz0gk");
const $a88d4af8adb322fd$var$styles = {
    wrapper: "_2rkoga04 _189ee4h9 _1dqonqa1 _1h6dmuej _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1bsb1ns9",
    pillIcon: "_2rkoga04 _1bsbgktf _4t3igktf _1e0c1txw _4cvr1h6o _1bah1h6o"
};
const $a88d4af8adb322fd$export$af13476fcb733bb1 = ({ action: { name: name, id: id, tags: tags } })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
        xcss: $a88d4af8adb322fd$var$styles.wrapper,
        space: "space.050",
        alignBlock: "center",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: $a88d4af8adb322fd$var$styles.pillIcon,
                backgroundColor: "color.background.brand.subtlest",
                children: (0, $dekey.getAgentActionIcon)(id)
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dS3PR.default), {
                children: [
                    name,
                    ' ',
                    tags.includes('beta') && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
                        appearance: "new",
                        children: formatMessage((0, $lz0gk.default).betaTag)
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("dekey", function(module, exports) {

$parcel$export(module.exports, "getAgentActionIcon", () => $8ddb066a239459cd$export$8dc132872471a5e1);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dZbEw = parcelRequire("dZbEw");

var $4ldhu = parcelRequire("4ldhu");

var $bFmnZ = parcelRequire("bFmnZ");

var $4IrpZ = parcelRequire("4IrpZ");

var $5nRKm = parcelRequire("5nRKm");

var $kdfZa = parcelRequire("kdfZa");

var $1bKdn = parcelRequire("1bKdn");

var $8mG85 = parcelRequire("8mG85");

var $hMDWV = parcelRequire("hMDWV");

var $lhPtH = parcelRequire("lhPtH");
const $8ddb066a239459cd$export$8dc132872471a5e1 = (actionKey)=>{
    switch(actionKey){
        case 'agent_action_jira_issue_create':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
                label: "",
                color: "var(--ds-icon-brand)"
            });
        case 'agent_action_confluence_page_create':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kdfZa))), {
                label: "",
                color: "var(--ds-icon-brand)"
            });
        case 'agent_action_jira_issue_comment':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFmnZ))), {
                label: "",
                color: "var(--ds-icon-brand)"
            });
        case 'agent_action_confluence_page_comment':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFmnZ))), {
                label: "",
                color: "var(--ds-icon-brand)"
            });
        case 'agent_action_jira_issue_move':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8mG85))), {
                label: "",
                color: "var(--ds-icon-brand)"
            });
        case 'agent_action_jira_issue_delete':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4IrpZ))), {
                label: "",
                color: "var(--ds-icon-brand)"
            });
        case 'agent_action_jira_issue_assign':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bKdn))), {
                label: "",
                color: "var(--ds-icon-brand)"
            });
        case 'agent_action_jira_issue_edit':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5nRKm))), {
                label: "",
                color: "var(--ds-icon-brand)"
            });
        case 'agent_action_jira_issue_transition':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hMDWV))), {
                label: "",
                color: "var(--ds-icon-brand)"
            });
        case 'agent_action_jira_epics_suggest':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lhPtH))), {
                label: "",
                color: "var(--ds-icon-brand)"
            });
        default:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4ldhu))), {
                label: "",
                color: "var(--ds-icon-brand)"
            });
    }
};

});
parcelRegister("4ldhu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2251b011785916069b749fddb2c5cd02>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32936cf628dec798$var$_react = $32936cf628dec798$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $32936cf628dec798$var$_baseNew = $32936cf628dec798$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $32936cf628dec798$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $32936cf628dec798$var$AutomationIcon = (props)=>/*#__PURE__*/ $32936cf628dec798$var$_react.default.createElement($32936cf628dec798$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$32936cf628dec798$var$AutomationIcon.displayName = 'AutomationIcon';
var $32936cf628dec798$var$_default = module.exports.default = $32936cf628dec798$var$AutomationIcon;

});

parcelRegister("bFmnZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::451c857042316b193f6451d1ac5153c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87e4e36d6c115ce9$var$_react = $87e4e36d6c115ce9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $87e4e36d6c115ce9$var$_baseNew = $87e4e36d6c115ce9$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $87e4e36d6c115ce9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $87e4e36d6c115ce9$var$CommentIcon = (props)=>/*#__PURE__*/ $87e4e36d6c115ce9$var$_react.default.createElement($87e4e36d6c115ce9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$87e4e36d6c115ce9$var$CommentIcon.displayName = 'CommentIcon';
var $87e4e36d6c115ce9$var$_default = module.exports.default = $87e4e36d6c115ce9$var$CommentIcon;

});

parcelRegister("5nRKm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ce3559d453dff44735097f553c900f9f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3eb8cab3ab465b93$var$_react = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3eb8cab3ab465b93$var$_baseNew = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3eb8cab3ab465b93$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3eb8cab3ab465b93$var$EditIcon = (props)=>/*#__PURE__*/ $3eb8cab3ab465b93$var$_react.default.createElement($3eb8cab3ab465b93$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.707zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.217l-.54 1.89 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$3eb8cab3ab465b93$var$EditIcon.displayName = 'EditIcon';
var $3eb8cab3ab465b93$var$_default = module.exports.default = $3eb8cab3ab465b93$var$EditIcon;

});

parcelRegister("hMDWV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b20915105f9f06f3ef89ee9497af0ea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cf25e87f153b8182$var$_react = $cf25e87f153b8182$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $cf25e87f153b8182$var$_baseNew = $cf25e87f153b8182$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $cf25e87f153b8182$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Transition".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for transitions in Analytics.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cf25e87f153b8182$var$TransitionIcon = (props)=>/*#__PURE__*/ $cf25e87f153b8182$var$_react.default.createElement($cf25e87f153b8182$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.75 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.122 0a2.251 2.251 0 1 1 0 1.5h-.816c-.586 0-1.062.476-1.062 1.063v5.875A2.563 2.563 0 0 1 6.188 13.5h-.816a2.25 2.25 0 1 1 0-1.5h.816c.586 0 1.062-.476 1.062-1.062V5.062A2.56 2.56 0 0 1 9.813 2.5zM3.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$cf25e87f153b8182$var$TransitionIcon.displayName = 'TransitionIcon';
var $cf25e87f153b8182$var$_default = module.exports.default = $cf25e87f153b8182$var$TransitionIcon;

});

parcelRegister("lhPtH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::26ba74a55619bd4b134c4c0c504c8b64>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7f31df16698d05e$var$_react = $f7f31df16698d05e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f7f31df16698d05e$var$_baseNew = $f7f31df16698d05e$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $f7f31df16698d05e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f7f31df16698d05e$var$WorkItemIcon = (props)=>/*#__PURE__*/ $f7f31df16698d05e$var$_react.default.createElement($f7f31df16698d05e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zm8.426 1.517 1.148.966-4 4.75a.75.75 0 0 1-1.148 0l-2-2.375 1.148-.966L7 9.086z" clip-rule="evenodd"/>`
    }, props));
$f7f31df16698d05e$var$WorkItemIcon.displayName = 'WorkItemIcon';
var $f7f31df16698d05e$var$_default = module.exports.default = $f7f31df16698d05e$var$WorkItemIcon;

});


parcelRegister("lz0gk", function(module, exports) {

$parcel$export(module.exports, "default", () => $35662572778f37c1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $35662572778f37c1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    betaTag: {
        id: 'rovo-chat.view-agent.beta-tag',
        defaultMessage: 'Beta',
        description: 'Tag to display for beta actions'
    }
});

});


parcelRegister("eot01", function(module, exports) {

$parcel$export(module.exports, "default", () => $89203a81d15bc590$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $89203a81d15bc590$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noActions: {
        id: 'rovo-chat.view-agent.no-actions',
        defaultMessage: 'No actions',
        description: 'Text to display when there are no actions for the agent'
    }
});

});


parcelRegister("2XXD4", function(module, exports) {

$parcel$export(module.exports, "AgentKnowledgeSection", () => $0bc9ec33b8968148$export$b1c40600d1679d39);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $gKZoD = parcelRequire("gKZoD");

var $1jWct = parcelRequire("1jWct");

var $8dO33 = parcelRequire("8dO33");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");

var $1DVhQ = parcelRequire("1DVhQ");

var $kVZJG = parcelRequire("kVZJG");

var $4ojTZ = parcelRequire("4ojTZ");

var $jNfmW = parcelRequire("jNfmW");

var $50H8f = parcelRequire("50H8f");

var $6lMjD = parcelRequire("6lMjD");
const $0bc9ec33b8968148$export$b1c40600d1679d39 = ({ aris: aris, isForgeAgent: isForgeAgent, knowledgeProductsRender: knowledgeProductsRender })=>{
    (0, $gKZoD.di)((0, $50H8f.useKnowledgeFilterService));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { getEntitiesByAris: getEntitiesByAris } = (0, $50H8f.useKnowledgeFilterService)();
    const { isFetching: isFetching, data: urls } = (0, $4ojTZ.useQuery)({
        queryKey: [
            'getEntitiesByAris'
        ].concat(aris || []),
        queryFn: async ()=>{
            if (!aris?.length) return [];
            const entities = await getEntitiesByAris({
                aris: aris
            });
            const links = entities.map((entity)=>entity.url);
            return links;
        },
        enabled: !isForgeAgent
    });
    const getKnowledgeRender = ()=>{
        if (isForgeAgent) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $f5TWP.default), {
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1jWct))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: ""
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $luBm6.default), {
                    space: "space.100",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgL5K.default), {
                        size: "small",
                        children: formatMessage((0, $6lMjD.default).forgeKnowledgeDescription)
                    })
                })
            ]
        });
        if (!urls?.length && !knowledgeProductsRender && !isFetching) return formatMessage((0, $6lMjD.default).noKnowledgeAdded);
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
            space: "space.050",
            children: [
                isFetching ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
                            height: 22,
                            width: 200,
                            borderRadius: 8,
                            isShimmering: true
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
                            height: 22,
                            width: 150,
                            borderRadius: 8,
                            isShimmering: true
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
                            height: 22,
                            width: 200,
                            borderRadius: 8,
                            isShimmering: true
                        })
                    ]
                }) : urls?.map((url)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kVZJG.Card), {
                        fallbackComponent: (0, $jNfmW.smartLinkFallback)(url),
                        appearance: "inline",
                        url: url
                    }, url)),
                knowledgeProductsRender
            ]
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8dO33.SmartCardProvider), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
            testId: "view-agent-knowledge-cards",
            children: getKnowledgeRender()
        })
    });
};

});
parcelRegister("kVZJG", function(module, exports) {

$parcel$export(module.exports, "Card", () => $fc8afc0c39cee453$export$60332b2344f7fe41);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");
var $i5FdW = parcelRequire("i5FdW");

var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $fzJZi = parcelRequire("fzJZi");

var $lpxJ1 = parcelRequire("lpxJ1");
class $fc8afc0c39cee453$var$PlainCard extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        const content = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lpxJ1.CardWithURLRenderer), {
            ...this.props
        });
        return this.props.intl ? content : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
            locale: "en",
            children: content
        });
    }
}
const $fc8afc0c39cee453$export$60332b2344f7fe41 = (0, $994MI.default)((0, $fzJZi.context))((0, $cb25w.default)()((0, $8RXs9.default)($fc8afc0c39cee453$var$PlainCard, {
    enforceContext: false
})));

});
parcelRegister("fzJZi", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $3b4d25437cc28513$export$85183a312807388d);
$parcel$export(module.exports, "context", () => $3b4d25437cc28513$export$a078c61943f9dbbe);
$parcel$export(module.exports, "TrackQuickActionType", () => $3b4d25437cc28513$export$72af824fa910c33e);
$parcel$export(module.exports, "TrackQuickActionFailureReason", () => $3b4d25437cc28513$export$c89e475f7f7174c2);
$parcel$export(module.exports, "SmartLinkEvents", () => $3b4d25437cc28513$export$b91e0203b928470c);
const $3b4d25437cc28513$export$85183a312807388d = 'media';
const $3b4d25437cc28513$export$a078c61943f9dbbe = {
    componentName: 'smart-cards',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
var $3b4d25437cc28513$export$72af824fa910c33e = /*#__PURE__*/ function(TrackQuickActionType) {
    TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
    return TrackQuickActionType;
}({});
var $3b4d25437cc28513$export$c89e475f7f7174c2 = /*#__PURE__*/ function(TrackQuickActionFailureReason) {
    TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
    TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
    TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
    return TrackQuickActionFailureReason;
}({});
class $3b4d25437cc28513$export$b91e0203b928470c {
    insertSmartLink(url, type, createAnalyticsEvent) {
        $3b4d25437cc28513$export$2a123f7ee48a122c({
            action: 'inserted',
            actionSubject: 'smartLink',
            eventType: 'track',
            attributes: {
                type: type
            },
            nonPrivacySafeAttributes: {
                domainName: url
            }
        }, createAnalyticsEvent);
    }
}
const $3b4d25437cc28513$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent(payload).fire($3b4d25437cc28513$export$85183a312807388d);
};

});

parcelRegister("lpxJ1", function(module, exports) {

$parcel$export(module.exports, "CardWithURLRenderer", () => $422a0598dbbdc42a$export$e00a7788e30dc998);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $gKZoD = parcelRequire("gKZoD");

var $7Jxgt = parcelRequire("7Jxgt");

var $VSDnB = parcelRequire("VSDnB");

var $a1vqi = parcelRequire("a1vqi");

var $1VPdD = parcelRequire("1VPdD");

var $kxcRq = parcelRequire("kxcRq");

var $5igsJ = parcelRequire("5igsJ");

var $91tw3 = parcelRequire("91tw3");

var $5vDFA = parcelRequire("5vDFA");

var $i41Ob = parcelRequire("i41Ob");

const $422a0598dbbdc42a$export$a7690c318cd6a95e = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(0, $kxcRq.importWithRetry)(()=>(parcelRequire("bybQQ"))));
function $422a0598dbbdc42a$export$e00a7788e30dc998(props) {
    (0, $gKZoD.di)($422a0598dbbdc42a$export$a7690c318cd6a95e);
    const [id] = (0, $5uXOq.useState)(()=>props.id ? props.id : (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))());
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        // ComponentWillUnmount
        return ()=>{
            (0, $5vDFA.clearMarks)(id);
            (0, $5vDFA.clearMeasures)(id);
        };
    }, [
        id
    ]);
    const { url: url, appearance: appearance, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, onClick: onClick, container: container, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, inheritDimensions: inheritDimensions, platform: platform, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, children: children, ui: ui, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, placeholder: placeholder, fallbackComponent: fallbackComponent, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline } = props;
    const isFlexibleUi = (0, $91tw3.isFlexibleUiCard)(children, (0, $VSDnB.fg)('platform-linking-flexible-card-openness') ? ui : undefined);
    const analyticsContext = (0, $5igsJ.useSmartLinkAnalyticsContext)({
        display: isFlexibleUi ? 'flexible' : appearance,
        id: id,
        url: url ?? ''
    });
    const errorHandler = (0, $5uXOq.useCallback)((error, info)=>{
        const { componentStack: componentStack } = info;
        const errorInfo = {
            componentStack: componentStack
        };
        // NB: APIErrors are thrown in response to Object Resolver Service. We do not
        // fire an event for these, as they do not cover failed UI render events.
        // The rest of the errors caught here are unexpected, and correlate
        // to the reliability of the smart-card front-end components.
        // Likewise, chunk loading errors are not caused by a failure of smart-card rendering.
        if (error.name === 'ChunkLoadError') fireEvent('operational.smartLink.chunkLoadFailed', {
            ...analyticsContext?.attributes,
            display: appearance,
            error: error,
            errorInfo: errorInfo,
            definitionId: null
        });
        else if (error.name !== 'APIError') {
            (0, $1VPdD.startUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $1VPdD.failUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $1VPdD.failUfoExperience)('smart-link-authenticated', id || 'NULL');
            fireEvent('ui.smartLink.renderFailed', {
                ...analyticsContext?.attributes,
                display: isFlexibleUi ? 'flexible' : appearance,
                id: id ?? null,
                error: error,
                errorInfo: errorInfo
            });
        }
        onError && onError({
            status: 'errored',
            url: url ?? '',
            err: error
        });
    }, [
        analyticsContext?.attributes,
        appearance,
        fireEvent,
        id,
        isFlexibleUi,
        onError,
        url
    ]);
    if (!url) throw new Error('@atlaskit/smart-card: url property is missing.');
    const defaultFallBackComponent = ()=>null;
    const FallbackComponent = fallbackComponent ?? defaultFallBackComponent;
    const ErrorFallback = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)(FallbackComponent, {});
    const cardWithUrlProps = {
        id: id,
        url: url,
        appearance: appearance,
        onClick: onClick,
        isSelected: isSelected,
        isHovered: isHovered,
        frameStyle: frameStyle,
        container: container,
        onResolve: onResolve,
        onError: onError,
        testId: testId,
        actionOptions: actionOptions,
        inheritDimensions: inheritDimensions,
        platform: platform,
        embedIframeRef: embedIframeRef,
        embedIframeUrlType: embedIframeUrlType,
        inlinePreloaderStyle: inlinePreloaderStyle,
        ui: ui,
        showHoverPreview: showHoverPreview,
        hoverPreviewOptions: hoverPreviewOptions,
        placeholder: placeholder,
        removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
        resolvingPlaceholder: resolvingPlaceholder,
        truncateInline: truncateInline
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
        FallbackComponent: ErrorFallback,
        onError: errorHandler,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
            fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i41Ob.LoadingCardLink), {
                ...cardWithUrlProps
            }),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($422a0598dbbdc42a$export$a7690c318cd6a95e, {
                ...cardWithUrlProps,
                children: children
            })
        })
    });
}

});
parcelRegister("a1vqi", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $91130a451fd4887d$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::1f3587129789e7883af37adad3817cd2>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");


var $1PQcU = parcelRequire("1PQcU");
const $91130a451fd4887d$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireEvent = (0, $5uXOq.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $1PQcU.default)(...params));
        event.fire((0, $37b399a913bad22b$export$3f072f06b90c3985));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
const $37b399a913bad22b$export$3f072f06b90c3985 = 'media';

parcelRegister("1PQcU", function(module, exports) {

$parcel$export(module.exports, "default", () => $539e70e97f68df84$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::eb8cd1263459fb798341024dc0c461ea>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ const $539e70e97f68df84$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $539e70e97f68df84$export$2e2bcd8739ae039 = $539e70e97f68df84$var$createEventPayload;

});


parcelRegister("1VPdD", function(module, exports) {

$parcel$export(module.exports, "startUfoExperience", () => $2308e6f5aae12b86$export$5e9287b6a10f8075);
$parcel$export(module.exports, "succeedUfoExperience", () => $2308e6f5aae12b86$export$c5a5cf072c836c0e);
$parcel$export(module.exports, "failUfoExperience", () => $2308e6f5aae12b86$export$8dda83bafca11b77);
$parcel$export(module.exports, "addMetadataToExperience", () => $2308e6f5aae12b86$export$4084c0df4a03a6af);

var $cBycP = parcelRequire("cBycP");
var $7Zbvr = parcelRequire("7Zbvr");
const $2308e6f5aae12b86$var$inlineExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $7Zbvr.ExperienceTypes).Experience,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult
};
const $2308e6f5aae12b86$var$renderExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $7Zbvr.ExperienceTypes).Load,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).PageSegmentLoad
};
const $2308e6f5aae12b86$var$aiExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $7Zbvr.ExperienceTypes).Experience,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult
};
const $2308e6f5aae12b86$var$ufoExperiences = {
    'smart-link-rendered': new (0, $cBycP.ConcurrentExperience)('smart-link-rendered', $2308e6f5aae12b86$var$renderExperience),
    'smart-link-authenticated': new (0, $cBycP.ConcurrentExperience)('smart-link-authenticated', $2308e6f5aae12b86$var$inlineExperience),
    'smart-link-action-invocation': new (0, $cBycP.ConcurrentExperience)('smart-link-action-invocation', $2308e6f5aae12b86$var$inlineExperience),
    'smart-link-ai-summary': new (0, $cBycP.ConcurrentExperience)('smart-link-ai-summary', $2308e6f5aae12b86$var$aiExperience)
};
const $2308e6f5aae12b86$export$5e9287b6a10f8075 = (experienceName, id, properties)=>{
    const experience = $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (properties) experience.addMetadata(properties);
};
const $2308e6f5aae12b86$export$c5a5cf072c836c0e = (experienceName, id, properties)=>{
    const experience = $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: properties
    });
};
const $2308e6f5aae12b86$export$8dda83bafca11b77 = (experienceName, id, properties)=>{
    const experience = $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: properties
    });
};
const $2308e6f5aae12b86$export$4084c0df4a03a6af = (experienceName, id, properties)=>{
    $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id).addMetadata(properties);
};

});

parcelRegister("kxcRq", function(module, exports) {

$parcel$export(module.exports, "isSpecialEvent", () => $c53851cced73411d$export$efca2c4705678489);
$parcel$export(module.exports, "getIconForFileType", () => $c53851cced73411d$export$4d685c85ebc7a1e3);
$parcel$export(module.exports, "getLazyIcons", () => $c53851cced73411d$export$92d31eb5326761b6);
$parcel$export(module.exports, "getIframeSandboxAttribute", () => $c53851cced73411d$export$9b7e6a102056a387);
$parcel$export(module.exports, "handleOnClick", () => $c53851cced73411d$export$ffccab2ae3d093ef);
$parcel$export(module.exports, "isIntersectionObserverSupported", () => $c53851cced73411d$export$6c837641a9ab03cb);
$parcel$export(module.exports, "importWithRetry", () => $c53851cced73411d$export$aacbf48ace518c5a);
$parcel$export(module.exports, "downloadUrl", () => $c53851cced73411d$export$8a96edb1c96563f4);
$parcel$export(module.exports, "openUrl", () => $c53851cced73411d$export$a238cfe4a10e6279);
$parcel$export(module.exports, "getPreviewUrlWithTheme", () => $c53851cced73411d$export$4470f298c61a79da);
$parcel$export(module.exports, "isIconSizeLarge", () => $c53851cced73411d$export$d2b8fb9e780e17e7);
$parcel$export(module.exports, "isProfileType", () => $c53851cced73411d$export$6a4545d6b336c401);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4qBtX = parcelRequire("4qBtX");

var $VSDnB = parcelRequire("VSDnB");

var $imVhc = parcelRequire("imVhc");

var $8dVIb = parcelRequire("8dVIb");

var $liAf6 = parcelRequire("liAf6");
const $c53851cced73411d$export$efca2c4705678489 = (evt)=>evt.isDefaultPrevented() && ($c53851cced73411d$export$e6c5ffa684aac4d7() || $c53851cced73411d$export$d8de0cd37d316fdf(evt) || $c53851cced73411d$export$5b1771037ab7c451(evt));
const $c53851cced73411d$export$e6c5ffa684aac4d7 = ()=>window.parent !== parent;
const $c53851cced73411d$export$d8de0cd37d316fdf = (event)=>{
    return (0, $VSDnB.fg)('platform-smart-card-shift-key') ? event.metaKey || event.ctrlKey || event.shiftKey : event.metaKey || event.ctrlKey;
};
const $c53851cced73411d$export$5b1771037ab7c451 = (event)=>event.button === 1;
const $c53851cced73411d$export$4d685c85ebc7a1e3 = (fileMimeType)=>{
    if (!fileMimeType) return;
    let icon = $c53851cced73411d$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [label, importCb] = icon;
    if (!importCb) return;
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
        loader: ()=>importCb().then((module)=>module.default),
        loading: ()=>null
    }); // because we're using dynamic loading here, TS will not be able to infer the type
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
        label: label,
        testId: "document-file-format-icon"
    });
};
const $c53851cced73411d$export$371bef29a3733127 = (fileMimeType)=>{
    let icon = $c53851cced73411d$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [label] = icon;
    return label;
};


























































































const $c53851cced73411d$export$92d31eb5326761b6 = ()=>{
    return {
        [(0, $8dVIb.IconType).Document]: {
            default: ()=>Promise.resolve((parcelRequire("94rku")))
        },
        [(0, $8dVIb.IconType).Blog]: {
            default: ()=>Promise.resolve((parcelRequire("dVpJZ")))
        },
        [(0, $8dVIb.IconType).Audio]: {
            default: ()=>(parcelRequire("jP3VI"))
        },
        [(0, $8dVIb.IconType).Code]: {
            default: ()=>(parcelRequire("2zelF"))
        },
        [(0, $8dVIb.IconType).File]: {
            default: ()=>(parcelRequire("b1MFH"))
        },
        [(0, $8dVIb.IconType).Folder]: {
            default: ()=>(parcelRequire("hIRd2"))
        },
        [(0, $8dVIb.IconType).Generic]: {
            default: ()=>(parcelRequire("b1MFH"))
        },
        [(0, $8dVIb.IconType).Image]: {
            default: ()=>(parcelRequire("kcbfF"))
        },
        [(0, $8dVIb.IconType).Presentation]: {
            default: ()=>(parcelRequire("3lFDz"))
        },
        [(0, $8dVIb.IconType).Spreadsheet]: {
            default: ()=>(parcelRequire("eslUC"))
        },
        [(0, $8dVIb.IconType).Video]: {
            default: ()=>(parcelRequire("aO5d7"))
        },
        [(0, $8dVIb.IconType).Project]: {
            default: ()=>Promise.resolve((parcelRequire("ckyDP")))
        },
        [(0, $8dVIb.IconType).Template]: {
            default: ()=>(parcelRequire("1LOaS"))
        },
        [(0, $8dVIb.IconType).Forbidden]: {
            default: ()=>(parcelRequire("k8THN"))
        },
        [(0, $8dVIb.IconType).Default]: {
            default: ()=>Promise.resolve((parcelRequire("jOyH3")))
        },
        [(0, $8dVIb.IconType).Archive]: {
            default: ()=>(parcelRequire("fBf2G")),
            large: ()=>(parcelRequire("kee99"))
        },
        [(0, $8dVIb.IconType).Executable]: {
            default: ()=>(parcelRequire("lslfp")),
            large: ()=>(parcelRequire("8yVZ6"))
        },
        [(0, $8dVIb.IconType).GIF]: {
            default: ()=>(parcelRequire("4nfzo")),
            large: ()=>(parcelRequire("5e2oM"))
        },
        [(0, $8dVIb.IconType).GoogleDocs]: {
            default: ()=>(parcelRequire("lyNGw")),
            large: ()=>(parcelRequire("7pYnQ"))
        },
        [(0, $8dVIb.IconType).GoogleForms]: {
            default: ()=>(parcelRequire("bnA29")),
            large: ()=>(parcelRequire("cEK5F"))
        },
        [(0, $8dVIb.IconType).GoogleSheets]: {
            default: ()=>(parcelRequire("kwONT")),
            large: ()=>(parcelRequire("eFVyZ"))
        },
        [(0, $8dVIb.IconType).GoogleSlides]: {
            default: ()=>(parcelRequire("9Auxh")),
            large: ()=>(parcelRequire("b1syu"))
        },
        [(0, $8dVIb.IconType).MSExcel]: {
            default: ()=>(parcelRequire("hpac9")),
            large: ()=>(parcelRequire("e4niJ"))
        },
        [(0, $8dVIb.IconType).MSPowerpoint]: {
            default: ()=>(parcelRequire("5nTq3")),
            large: ()=>(parcelRequire("5FD7P"))
        },
        [(0, $8dVIb.IconType).MSWord]: {
            default: ()=>(parcelRequire("818b0")),
            large: ()=>(parcelRequire("7rpmm"))
        },
        [(0, $8dVIb.IconType).PDF]: {
            default: ()=>(parcelRequire("lnlq4")),
            large: ()=>(parcelRequire("1bqc1"))
        },
        [(0, $8dVIb.IconType).Sketch]: {
            default: ()=>(parcelRequire("hSsH1")),
            large: ()=>(parcelRequire("4ggae"))
        },
        // Bitbucket icons
        [(0, $8dVIb.IconType).Branch]: {
            default: ()=>(parcelRequire("l0b36")),
            large: ()=>(parcelRequire("faNHh"))
        },
        [(0, $8dVIb.IconType).Commit]: {
            default: ()=>(parcelRequire("gJjAW")),
            large: ()=>(parcelRequire("7Cfy8"))
        },
        [(0, $8dVIb.IconType).PullRequest]: {
            default: ()=>(parcelRequire("2ja6p")),
            large: ()=>(parcelRequire("lhK2t"))
        },
        [(0, $8dVIb.IconType).Repo]: {
            default: ()=>(parcelRequire("c9WGr")),
            large: ()=>(parcelRequire("Zl279"))
        },
        // Jira icons
        [(0, $8dVIb.IconType).Bug]: {
            default: ()=>(parcelRequire("gt1ix")),
            large: ()=>(parcelRequire("jfHd4"))
        },
        [(0, $8dVIb.IconType).Change]: {
            default: ()=>(parcelRequire("2LtvO")),
            large: ()=>(parcelRequire("h6mSM"))
        },
        [(0, $8dVIb.IconType).Epic]: {
            default: ()=>(parcelRequire("gbLQ9")),
            large: ()=>(parcelRequire("2Nnnn"))
        },
        [(0, $8dVIb.IconType).Incident]: {
            default: ()=>(parcelRequire("c7kWc")),
            large: ()=>(parcelRequire("af9Ay"))
        },
        [(0, $8dVIb.IconType).Problem]: {
            default: ()=>(parcelRequire("hBYHT")),
            large: ()=>(parcelRequire("JuWWj"))
        },
        [(0, $8dVIb.IconType).ServiceRequest]: {
            default: ()=>(parcelRequire("jhNzO")),
            large: ()=>(parcelRequire("3Umjx"))
        },
        [(0, $8dVIb.IconType).Story]: {
            default: ()=>(parcelRequire("ibZAY")),
            large: ()=>(parcelRequire("bpMfi"))
        },
        [(0, $8dVIb.IconType).SubTask]: {
            default: ()=>(parcelRequire("lGtKi")),
            large: ()=>(parcelRequire("3unVm"))
        },
        [(0, $8dVIb.IconType).Task]: {
            default: ()=>(parcelRequire("l5z4M")),
            large: ()=>(parcelRequire("kEBpI"))
        },
        // Confluence icons
        [(0, $8dVIb.IconType).LiveDocument]: {
            default: ()=>Promise.resolve((parcelRequire("4Atwu"))),
            large: ()=>Promise.resolve((parcelRequire("8lQ8Y")))
        },
        // Provider icons
        [(0, $8dVIb.IconType).Confluence]: {
            default: ()=>Promise.resolve((parcelRequire("7anl7"))).then(({ ConfluenceIcon: ConfluenceIcon })=>({
                        default: ConfluenceIcon
                    }))
        },
        [(0, $8dVIb.IconType).Jira]: {
            default: ()=>Promise.resolve((parcelRequire("29YN9"))).then(({ JiraIcon: JiraIcon })=>({
                        default: JiraIcon
                    }))
        },
        // Badge icons
        [(0, $8dVIb.IconType).Attachment]: {
            default: ()=>(parcelRequire("b2QJV"))
        },
        [(0, $8dVIb.IconType).CheckItem]: {
            default: ()=>(parcelRequire("hTMzv"))
        },
        [(0, $8dVIb.IconType).Component]: {
            default: ()=>(parcelRequire("i5LI7"))
        },
        [(0, $8dVIb.IconType).Comment]: {
            default: ()=>(parcelRequire("28C0M"))
        },
        [(0, $8dVIb.IconType).View]: {
            default: ()=>(parcelRequire("5ewzx"))
        },
        [(0, $8dVIb.IconType).React]: {
            default: ()=>(parcelRequire("8NR13"))
        },
        [(0, $8dVIb.IconType).Vote]: {
            default: ()=>(parcelRequire("acQVl"))
        },
        [(0, $8dVIb.IconType).PriorityBlocker]: {
            default: ()=>(parcelRequire("eXA0t"))
        },
        [(0, $8dVIb.IconType).PriorityCritical]: {
            default: ()=>(parcelRequire("9kf9T"))
        },
        [(0, $8dVIb.IconType).PriorityHigh]: {
            default: ()=>(parcelRequire("jiNtU"))
        },
        [(0, $8dVIb.IconType).PriorityHighest]: {
            default: ()=>(parcelRequire("eL0Ys"))
        },
        [(0, $8dVIb.IconType).PriorityLow]: {
            default: ()=>(parcelRequire("aX5mo"))
        },
        [(0, $8dVIb.IconType).PriorityLowest]: {
            default: ()=>(parcelRequire("fIUai"))
        },
        [(0, $8dVIb.IconType).PriorityMajor]: {
            default: ()=>(parcelRequire("9EtBf"))
        },
        [(0, $8dVIb.IconType).PriorityMedium]: {
            default: ()=>(parcelRequire("1t6AM"))
        },
        [(0, $8dVIb.IconType).PriorityMinor]: {
            default: ()=>(parcelRequire("d3Riz"))
        },
        [(0, $8dVIb.IconType).PriorityTrivial]: {
            default: ()=>(parcelRequire("34KmU"))
        },
        [(0, $8dVIb.IconType).PriorityUndefined]: {
            default: ()=>(parcelRequire("99TdN"))
        },
        [(0, $8dVIb.IconType).ProgrammingLanguage]: {
            default: ()=>(parcelRequire("lWPoA"))
        },
        [(0, $8dVIb.IconType).Subscriber]: {
            default: ()=>Promise.resolve((parcelRequire("4hqZ5")))
        },
        [(0, $8dVIb.IconType).SubTasksProgress]: {
            default: ()=>(parcelRequire("89ySK"))
        }
    };
};
const $c53851cced73411d$var$getTypeToIconMap = (fileFormat)=>{
    const iconDescriptor = (0, $liAf6.default)(fileFormat);
    if (!iconDescriptor?.icon || !iconDescriptor.label) return null;
    const lazyIcons = $c53851cced73411d$export$92d31eb5326761b6();
    return [
        iconDescriptor.label,
        lazyIcons[iconDescriptor.icon]?.default
    ];
};
const $c53851cced73411d$export$9b7e6a102056a387 = (isTrusted)=>{
    if (isTrusted) return undefined;
    const sandboxPermissions = 'allow-downloads allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts';
    return sandboxPermissions;
};
const $c53851cced73411d$export$ffccab2ae3d093ef = (handler)=>(e)=>{
        e.preventDefault();
        e.stopPropagation();
        handler();
    };
const $c53851cced73411d$export$6c837641a9ab03cb = ()=>typeof IntersectionObserver !== 'undefined';
const $c53851cced73411d$export$e772c8ff12451969 = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};
const $c53851cced73411d$export$aacbf48ace518c5a = async (importFn, retries = 2, interval = 500)=>{
    try {
        return await importFn();
    } catch (error) {
        if (error.name === 'ChunkLoadError' && retries > 0) {
            await $c53851cced73411d$export$e772c8ff12451969(interval);
            return $c53851cced73411d$export$aacbf48ace518c5a(importFn, retries - 1, interval);
        } else throw error;
    }
};
const $c53851cced73411d$export$8a96edb1c96563f4 = async (url)=>{
    if (!url) return;
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    link.download = url;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const $c53851cced73411d$export$a238cfe4a10e6279 = async (url)=>{
    if (!url) return;
    window.open(url, '_blank', 'noopener=yes');
};
const $c53851cced73411d$export$4470f298c61a79da = (previewUrl, themeState)=>{
    try {
        const url = new URL(previewUrl);
        url.searchParams.append('themeState', (0, $imVhc.themeObjectToString)(themeState));
        return url.href;
    } catch  {
        return previewUrl;
    }
};
const $c53851cced73411d$export$d2b8fb9e780e17e7 = (size)=>size && [
        (0, $8dVIb.SmartLinkSize).Large,
        (0, $8dVIb.SmartLinkSize).XLarge
    ].includes(size);
const $c53851cced73411d$export$6a4545d6b336c401 = (type)=>!!(type && type.includes('Profile'));

});
parcelRegister("8dVIb", function(module, exports) {

$parcel$export(module.exports, "CONTENT_URL_SECURITY_AND_PERMISSIONS", () => $ad6fd5c2f706e309$export$5c881701926acbef);
$parcel$export(module.exports, "CONTENT_URL_3P_ACCOUNT_AUTH", () => $ad6fd5c2f706e309$export$93d67ab022d9f8d2);
$parcel$export(module.exports, "CONTENT_URL_AI", () => $ad6fd5c2f706e309$export$70d24f0465ae60f8);
$parcel$export(module.exports, "CONTENT_URL_AI_TROUBLESHOOTING", () => $ad6fd5c2f706e309$export$a3ed5c4e9d9599b7);
$parcel$export(module.exports, "CONTENT_URL_ACCEPTABLE_USE_POLICY", () => $ad6fd5c2f706e309$export$73b198e73554a323);
$parcel$export(module.exports, "SmartLinkAlignment", () => $ad6fd5c2f706e309$export$8910bf86027fe6be);
$parcel$export(module.exports, "SmartLinkDirection", () => $ad6fd5c2f706e309$export$60831686b0574c86);
$parcel$export(module.exports, "SmartLinkPosition", () => $ad6fd5c2f706e309$export$d58e6377644d1dcf);
$parcel$export(module.exports, "SmartLinkSize", () => $ad6fd5c2f706e309$export$51f13ced115cbdae);
$parcel$export(module.exports, "SmartLinkStatus", () => $ad6fd5c2f706e309$export$61cff06be26816f);
$parcel$export(module.exports, "SmartLinkTheme", () => $ad6fd5c2f706e309$export$aed0f1e801ad691f);
$parcel$export(module.exports, "SmartLinkInternalTheme", () => $ad6fd5c2f706e309$export$9aafec380d7005da);
$parcel$export(module.exports, "SmartLinkWidth", () => $ad6fd5c2f706e309$export$19c60054ee783de6);
$parcel$export(module.exports, "ElementName", () => $ad6fd5c2f706e309$export$d65b168331104a46);
$parcel$export(module.exports, "ActionName", () => $ad6fd5c2f706e309$export$9c95d6e1614bad84);
$parcel$export(module.exports, "InternalActionName", () => $ad6fd5c2f706e309$export$4871a84b35cf8eb9);
$parcel$export(module.exports, "IconType", () => $ad6fd5c2f706e309$export$13ff1290a9e22e77);
$parcel$export(module.exports, "MediaType", () => $ad6fd5c2f706e309$export$483c11740a902fcd);
$parcel$export(module.exports, "MediaPlacement", () => $ad6fd5c2f706e309$export$f9f4737e25ab90fa);
$parcel$export(module.exports, "CardDisplay", () => $ad6fd5c2f706e309$export$6ca4ef8b3dc2c804);
const $ad6fd5c2f706e309$export$5c881701926acbef = 'https://support.atlassian.com/confluence-cloud/docs/insert-links-and-anchors/#Smart-links';
const $ad6fd5c2f706e309$export$93d67ab022d9f8d2 = 'https://support.atlassian.com/confluence-cloud/docs/what-data-is-sent-and-received-when-pasting-a-smart-link/';
const $ad6fd5c2f706e309$export$70d24f0465ae60f8 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $ad6fd5c2f706e309$export$a3ed5c4e9d9599b7 = 'https://status.atlassian.com/';
const $ad6fd5c2f706e309$export$73b198e73554a323 = 'https://www.atlassian.com/legal/acceptable-use-policy';
var $ad6fd5c2f706e309$export$8910bf86027fe6be = /*#__PURE__*/ function(SmartLinkAlignment) {
    SmartLinkAlignment["Left"] = "left";
    SmartLinkAlignment["Right"] = "right";
    return SmartLinkAlignment;
}({});
var $ad6fd5c2f706e309$export$60831686b0574c86 = /*#__PURE__*/ function(SmartLinkDirection) {
    SmartLinkDirection["Horizontal"] = "horizontal";
    SmartLinkDirection["Vertical"] = "vertical";
    return SmartLinkDirection;
}({});
var $ad6fd5c2f706e309$export$d58e6377644d1dcf = /*#__PURE__*/ function(SmartLinkPosition) {
    SmartLinkPosition["Top"] = "top";
    SmartLinkPosition["Center"] = "center";
    return SmartLinkPosition;
}({});
var $ad6fd5c2f706e309$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $ad6fd5c2f706e309$export$61cff06be26816f = /*#__PURE__*/ function(SmartLinkStatus) {
    SmartLinkStatus["Pending"] = "pending";
    SmartLinkStatus["Resolving"] = "resolving";
    SmartLinkStatus["Resolved"] = "resolved";
    SmartLinkStatus["Forbidden"] = "forbidden";
    SmartLinkStatus["Errored"] = "errored";
    SmartLinkStatus["NotFound"] = "not_found";
    SmartLinkStatus["Unauthorized"] = "unauthorized";
    SmartLinkStatus["Fallback"] = "fallback";
    return SmartLinkStatus;
}({});
var $ad6fd5c2f706e309$export$aed0f1e801ad691f = /*#__PURE__*/ function(SmartLinkTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkTheme["Black"] = "black";
    SmartLinkTheme["Link"] = "link";
    return SmartLinkTheme;
}({});
var $ad6fd5c2f706e309$export$9aafec380d7005da = /*#__PURE__*/ function(SmartLinkInternalTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkInternalTheme["Grey"] = "grey";
    return SmartLinkInternalTheme;
}({});
var $ad6fd5c2f706e309$export$19c60054ee783de6 = /*#__PURE__*/ function(SmartLinkWidth) {
    SmartLinkWidth["FitToContent"] = "fit-to-content";
    SmartLinkWidth["Flexible"] = "flexible";
    return SmartLinkWidth;
}({});
var $ad6fd5c2f706e309$export$d65b168331104a46 = /*#__PURE__*/ function(ElementName) {
    ElementName["AppliedToComponentsCount"] = "AppliedToComponentsCount";
    ElementName["AssignedTo"] = "AssignedTo";
    ElementName["AssignedToGroup"] = "AssignedToGroup";
    ElementName["AttachmentCount"] = "AttachmentCount";
    ElementName["AuthorGroup"] = "AuthorGroup";
    ElementName["ChecklistProgress"] = "ChecklistProgress";
    ElementName["CollaboratorGroup"] = "CollaboratorGroup";
    ElementName["CommentCount"] = "CommentCount";
    ElementName["CreatedBy"] = "CreatedBy";
    ElementName["CreatedOn"] = "CreatedOn";
    ElementName["DueOn"] = "DueOn";
    ElementName["LatestCommit"] = "LatestCommit";
    ElementName["LinkIcon"] = "LinkIcon";
    ElementName["Location"] = "Location";
    ElementName["ModifiedBy"] = "ModifiedBy";
    ElementName["ModifiedOn"] = "ModifiedOn";
    ElementName["OwnedBy"] = "OwnedBy";
    ElementName["OwnedByGroup"] = "OwnedByGroup";
    ElementName["Preview"] = "Preview";
    ElementName["Priority"] = "Priority";
    ElementName["ProgrammingLanguage"] = "ProgrammingLanguage";
    ElementName["Provider"] = "Provider";
    ElementName["ReactCount"] = "ReactCount";
    ElementName["ReadTime"] = "ReadTime";
    ElementName["Snippet"] = "Snippet";
    ElementName["SourceBranch"] = "SourceBranch";
    ElementName["State"] = "State";
    ElementName["SubscriberCount"] = "SubscriberCount";
    ElementName["SubTasksProgress"] = "SubTasksProgress";
    ElementName["StoryPoints"] = "StoryPoints";
    ElementName["TargetBranch"] = "TargetBranch";
    ElementName["Title"] = "Title";
    ElementName["ViewCount"] = "ViewCount";
    ElementName["VoteCount"] = "VoteCount";
    ElementName["SentOn"] = "SentOn";
    return ElementName;
}({});
var $ad6fd5c2f706e309$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["CopyLinkAction"] = "CopyLinkAction";
    ActionName["DeleteAction"] = "DeleteAction";
    ActionName["EditAction"] = "EditAction";
    ActionName["FollowAction"] = "FollowAction";
    ActionName["PreviewAction"] = "PreviewAction";
    ActionName["AutomationAction"] = "AutomationAction";
    ActionName["DownloadAction"] = "DownloadAction";
    ActionName["CustomAction"] = "CustomAction";
    return ActionName;
}({});
var $ad6fd5c2f706e309$export$4871a84b35cf8eb9 = /*#__PURE__*/ function(InternalActionName) {
    InternalActionName["AISummaryAction"] = "AISummaryAction";
    InternalActionName["UnresolvedAction"] = "UnresolvedAction";
    InternalActionName["ViewRelatedLinksAction"] = "ViewRelatedLinksAction";
    return InternalActionName;
}({});
var $ad6fd5c2f706e309$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Blog"] = "FileType:Blog";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Template"] = "FileType:Template";
    IconType["Video"] = "FileType:Video";
    // BitBucket?
    IconType["Branch"] = "BitBucket:Branch";
    IconType["Commit"] = "BitBucket:Commit";
    IconType["Project"] = "BitBucket:Project";
    IconType["PullRequest"] = "BitBucket:PullRequest";
    IconType["Repo"] = "BitBucket:Repo";
    // Jira?
    IconType["Bug"] = "Jira:Bug";
    IconType["Change"] = "Jira:Change";
    IconType["Epic"] = "Jira:Epic";
    IconType["Incident"] = "Jira:Incident";
    IconType["Problem"] = "Jira:Problem";
    IconType["ServiceRequest"] = "Jira:ServiceRequest";
    IconType["Story"] = "Jira:Story";
    IconType["SubTask"] = "Jira:SubTask";
    IconType["Task"] = "Jira:Task";
    // Confluence
    IconType["LiveDocument"] = "Confluence:LiveDocument";
    // Provider
    IconType["Confluence"] = "Provider:Confluence";
    IconType["Jira"] = "Provider:Jira";
    // Fallback
    IconType["Default"] = "Default";
    IconType["Error"] = "Default:Error";
    IconType["Forbidden"] = "Default:Forbidden";
    // Badge
    IconType["Attachment"] = "Badge:Attachment";
    IconType["CheckItem"] = "Badge:Task";
    IconType["Comment"] = "Badge:Comment";
    IconType["Component"] = "Badge:Component";
    IconType["View"] = "Badge:View";
    IconType["React"] = "Badge:React";
    IconType["Vote"] = "Badge:Vote";
    IconType["PriorityBlocker"] = "Badge:PriorityBlocker";
    IconType["PriorityCritical"] = "Badge:PriorityCritical";
    IconType["PriorityHigh"] = "Badge:PriorityHigh";
    IconType["PriorityHighest"] = "Badge:PriorityHighest";
    IconType["PriorityLow"] = "Badge:PriorityLow";
    IconType["PriorityLowest"] = "Badge:PriorityLowest";
    IconType["PriorityMajor"] = "Badge:PriorityMajor";
    IconType["PriorityMedium"] = "Badge:PriorityMedium";
    IconType["PriorityMinor"] = "Badge:PriorityMinor";
    IconType["PriorityTrivial"] = "Badge:PriorityTrivial";
    IconType["PriorityUndefined"] = "Badge:PriorityUndefined";
    IconType["ProgrammingLanguage"] = "Badge:ProgrammingLanguage";
    IconType["Subscriber"] = "Badge:Subscriber";
    IconType["SubTasksProgress"] = "Badge:SubTask";
    return IconType;
}({});
var $ad6fd5c2f706e309$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["Image"] = "image";
    return MediaType;
}({});
var $ad6fd5c2f706e309$export$f9f4737e25ab90fa = /*#__PURE__*/ function(MediaPlacement) {
    MediaPlacement["Left"] = "left";
    MediaPlacement["Right"] = "right";
    return MediaPlacement;
}({});
var $ad6fd5c2f706e309$export$6ca4ef8b3dc2c804 = /*#__PURE__*/ function(CardDisplay) {
    CardDisplay["Inline"] = "inline";
    CardDisplay["Block"] = "block";
    CardDisplay["Embed"] = "embed";
    CardDisplay["EmbedPreview"] = "embedPreview";
    CardDisplay["Flexible"] = "flexible";
    CardDisplay["HoverCardPreview"] = "hoverCardPreview";
    return CardDisplay;
}({});

});

parcelRegister("liAf6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d67e22f2f57cb4a6$export$2e2bcd8739ae039);

var $8dVIb = parcelRequire("8dVIb");
const $d67e22f2f57cb4a6$var$extractFileFormatIcon = (fileFormat)=>{
    switch(fileFormat){
        // Generic documents
        case 'folder':
            return {
                icon: (0, $8dVIb.IconType).Folder,
                label: 'Folder'
            };
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            return {
                icon: (0, $8dVIb.IconType).Document,
                label: 'Document'
            };
        case 'application/pdf':
            return {
                icon: (0, $8dVIb.IconType).PDF,
                label: 'PDF document'
            };
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            return {
                icon: (0, $8dVIb.IconType).Presentation,
                label: 'Presentation'
            };
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            return {
                icon: (0, $8dVIb.IconType).Spreadsheet,
                label: 'Spreadsheet'
            };
        // Google Drive
        case 'application/vnd.google-apps.document':
            return {
                icon: (0, $8dVIb.IconType).GoogleDocs,
                label: 'Google Docs'
            };
        case 'application/vnd.google-apps.form':
            return {
                icon: (0, $8dVIb.IconType).GoogleForms,
                label: 'Google Form'
            };
        case 'application/vnd.google-apps.spreadsheet':
            return {
                icon: (0, $8dVIb.IconType).GoogleSheets,
                label: 'Google Sheets'
            };
        case 'application/vnd.google-apps.presentation':
            return {
                icon: (0, $8dVIb.IconType).GoogleSlides,
                label: 'Google Slides'
            };
        // Microsoft
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return {
                icon: (0, $8dVIb.IconType).MSExcel,
                label: 'Excel spreadsheet'
            };
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return {
                icon: (0, $8dVIb.IconType).MSPowerpoint,
                label: 'PowerPoint presentation'
            };
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return {
                icon: (0, $8dVIb.IconType).MSWord,
                label: 'Word document'
            };
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            return {
                icon: (0, $8dVIb.IconType).Image,
                label: 'Image'
            };
        case 'image/gif':
            return {
                icon: (0, $8dVIb.IconType).GIF,
                label: 'GIF'
            };
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            return {
                icon: (0, $8dVIb.IconType).Audio,
                label: 'Audio'
            };
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            return {
                icon: (0, $8dVIb.IconType).Video,
                label: 'Video'
            };
        // Others
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            return {
                icon: (0, $8dVIb.IconType).Code,
                label: 'Source Code'
            };
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            return {
                icon: (0, $8dVIb.IconType).Archive,
                label: 'Archive'
            };
        case 'application/dmg':
            return {
                icon: (0, $8dVIb.IconType).Executable,
                label: 'Executable'
            };
        case 'application/sketch':
            return {
                icon: (0, $8dVIb.IconType).Sketch,
                label: 'Sketch'
            };
        case 'application/octet-stream':
            return {
                icon: (0, $8dVIb.IconType).Generic,
                label: 'Binary file'
            };
        case 'application/invision.prototype':
            return {
                icon: (0, $8dVIb.IconType).Generic,
                label: 'Prototype'
            };
        default:
            return undefined;
    }
};
var $d67e22f2f57cb4a6$export$2e2bcd8739ae039 = $d67e22f2f57cb4a6$var$extractFileFormatIcon;

});

parcelRegister("94rku", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $56fb369bc3845a35$export$2e2bcd8739ae039);

var $duwKf = parcelRequire("duwKf");

var $lwV66 = parcelRequire("lwV66");

var $kdfZa = parcelRequire("kdfZa");

var $50H21 = parcelRequire("50H21");
const $56fb369bc3845a35$var$PageIconWithColor = (0, $50H21.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($kdfZa))), 'blueBold', (0, $50H21.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($duwKf))), (0, (/*@__PURE__*/$parcel$interopDefault($lwV66)))));
$56fb369bc3845a35$var$PageIconWithColor.displayName = 'PageIconWithColor';
var $56fb369bc3845a35$export$2e2bcd8739ae039 = $56fb369bc3845a35$var$PageIconWithColor;

});
parcelRegister("duwKf", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9d277a30a5a98acd$var$_react = $9d277a30a5a98acd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $9d277a30a5a98acd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9d277a30a5a98acd$var$Document16Icon = (props)=>/*#__PURE__*/ $9d277a30a5a98acd$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$9d277a30a5a98acd$var$Document16Icon.displayName = 'Document16Icon';
var $9d277a30a5a98acd$var$_default = module.exports.default = $9d277a30a5a98acd$var$Document16Icon;

});

parcelRegister("lwV66", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $040b7f7dd846f7fd$var$_react = $040b7f7dd846f7fd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $040b7f7dd846f7fd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $040b7f7dd846f7fd$var$Document24Icon = (props)=>/*#__PURE__*/ $040b7f7dd846f7fd$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 18c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01c-.54 0-.995.448-.995 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$040b7f7dd846f7fd$var$Document24Icon.displayName = 'Document24Icon';
var $040b7f7dd846f7fd$var$_default = module.exports.default = $040b7f7dd846f7fd$var$Document24Icon;

});

parcelRegister("50H21", function(module, exports) {

$parcel$export(module.exports, "renderIconPerSize", () => $399bb260cc38f0bb$export$28dd5ad82647c000);
$parcel$export(module.exports, "renderIconTile", () => $399bb260cc38f0bb$export$87c3646d0e299cfe);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $8dVIb = parcelRequire("8dVIb");

var $kxcRq = parcelRequire("kxcRq");
const $399bb260cc38f0bb$export$3acc3fb10995f020 = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
        case (0, $8dVIb.SmartLinkSize).Large:
            return '24';
        default:
            return '16';
    }
};
const $399bb260cc38f0bb$export$28dd5ad82647c000 = (IconSmall, IconLarge)=>{
    return ({ size: size, ...props })=>{
        if ((0, $kxcRq.isIconSizeLarge)(size)) return /*#__PURE__*/ (0, $2OMIu.jsx)(IconLarge, {
            ...props
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)(IconSmall, {
            ...props
        });
    };
};
const $399bb260cc38f0bb$export$87c3646d0e299cfe = (Icon, appearance, LegacyIcon)=>{
    return ({ size: size, ...props })=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
            appearance: appearance,
            icon: Icon,
            size: $399bb260cc38f0bb$export$3acc3fb10995f020(size),
            ...props,
            LEGACY_fallbackComponent: LegacyIcon && /*#__PURE__*/ (0, $2OMIu.jsx)(LegacyIcon, {
                ...props,
                size: size
            })
        });
    };
};

});
parcelRegister("cwmS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a921419639fe8f6f$export$2e2bcd8739ae039);
/* icon-tile.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");
const $a921419639fe8f6f$var$sizeMap = {
    '16': "_1bsb7vkz _4t3i7vkz",
    '24': "_1bsb1tcg _4t3i1tcg",
    '32': "_1bsbzwfg _4t3izwfg",
    '40': "_1bsb1ylp _4t3i1ylp",
    '48': "_1bsbckbl _4t3ickbl"
};
const $a921419639fe8f6f$var$appearanceMap = {
    grayBold: "_bfhk1t1b _syaz5w2r",
    limeBold: "_bfhktde4 _syaz5w2r",
    greenBold: "_bfhk1e5c _syaz5w2r",
    blueBold: "_bfhkc8cv _syaz5w2r",
    redBold: "_bfhkuibq _syaz5w2r",
    purpleBold: "_bfhkygwo _syaz5w2r",
    magentaBold: "_bfhkc3uk _syaz5w2r",
    tealBold: "_bfhk2c8p _syaz5w2r",
    orangeBold: "_bfhkjgng _syaz5w2r",
    yellowBold: "_bfhk1vop _syaz5w2r",
    gray: "_bfhk1v33 _syaz16ni",
    lime: "_bfhkz2ec _syaz8645",
    orange: "_bfhkf2vu _syaz7r97",
    magenta: "_bfhkv9ra _syazv8hk",
    green: "_bfhk1wnw _syaz17hp",
    blue: "_bfhk4v9p _syaz1ov1",
    red: "_bfhk1rtt _syaznbxb",
    purple: "_bfhk1jkz _syaz5yjc",
    teal: "_bfhk1a17 _syaz8uof",
    yellow: "_bfhk3fv2 _syaz1oqg"
};
const $a921419639fe8f6f$var$shapeMap = {
    square: "_2rkoiti9",
    circle: "_2rko14q2"
};
const $a921419639fe8f6f$var$iconTileStyles = null;
function $a921419639fe8f6f$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = '24', shape: shape = 'square', LEGACY_fallbackComponent: LEGACY_fallbackComponent, testId: testId } = props;
    const ExpandedIcon = Icon;
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (LEGACY_fallbackComponent && !(0, $VSDnB.fg)('platform-visual-refresh-icons')) return LEGACY_fallbackComponent;
    else return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1wybidpf",
            $a921419639fe8f6f$var$appearanceMap[appearance],
            $a921419639fe8f6f$var$sizeMap[size],
            $a921419639fe8f6f$var$shapeMap[shape]
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(ExpandedIcon, {
            color: "currentColor",
            label: label,
            spacing: "spacious",
            shouldScale: true
        })
    });
}

});



parcelRegister("dVpJZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5e665de7fe478f98$export$2e2bcd8739ae039);

var $iRZQl = parcelRequire("iRZQl");

var $7oCpB = parcelRequire("7oCpB");

var $50H21 = parcelRequire("50H21");
const $5e665de7fe478f98$var$BlogIconWithColor = (0, $50H21.renderIconPerSize)((0, $iRZQl.default), (0, $7oCpB.default));
$5e665de7fe478f98$var$BlogIconWithColor.displayName = 'BlogIconWithColor';
var $5e665de7fe478f98$export$2e2bcd8739ae039 = $5e665de7fe478f98$var$BlogIconWithColor;

});
parcelRegister("iRZQl", function(module, exports) {

$parcel$export(module.exports, "default", () => $24299d4e22463111$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::845767e81b63ae055da0ba81295847f0>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $2UiHO = parcelRequire("2UiHO");

var $VSDnB = parcelRequire("VSDnB");

var $hZgcq = parcelRequire("hZgcq");
/**
 * __16px `blog` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $24299d4e22463111$var$Blog16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2UiHO))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hZgcq.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hZgcq.default), {
        label: label,
        testId: testId
    });
};
$24299d4e22463111$var$Blog16Icon.displayName = 'Blog16Icon';
var $24299d4e22463111$export$2e2bcd8739ae039 = $24299d4e22463111$var$Blog16Icon;

});
parcelRegister("2UiHO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::295e96fa490818737b2d2c8ee4291bb5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $21df524c58bafc58$var$_react = $21df524c58bafc58$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $21df524c58bafc58$var$_baseNew = $21df524c58bafc58$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $21df524c58bafc58$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuotationMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: blockquote, comment, testimonial, blogs in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $21df524c58bafc58$var$QuotationMarkIcon = (props)=>/*#__PURE__*/ $21df524c58bafc58$var$_react.default.createElement($21df524c58bafc58$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5A2.5 2.5 0 0 0 5.5 10V9H2a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5zM9 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5a2.5 2.5 0 0 0 2.5-2.5V9H11a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$21df524c58bafc58$var$QuotationMarkIcon.displayName = 'QuotationMarkIcon';
var $21df524c58bafc58$var$_default = module.exports.default = $21df524c58bafc58$var$QuotationMarkIcon;

});

parcelRegister("hZgcq", function(module, exports) {

$parcel$export(module.exports, "default", () => $47749dc4aba4294e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::387cb99b24103ef6908201cae0580f7c>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $47749dc4aba4294e$var$Blog16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M6.972 6.128a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325m7 0a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$47749dc4aba4294e$var$Blog16Icon.displayName = 'Blog16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$47749dc4aba4294e$export$2e2bcd8739ae039 = $47749dc4aba4294e$var$Blog16Icon;

});


parcelRegister("7oCpB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8806751d7f7ea905$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bba35c7457f1c82d9d31626969c259a0>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $2UiHO = parcelRequire("2UiHO");

var $VSDnB = parcelRequire("VSDnB");

var $asoCt = parcelRequire("asoCt");
/**
 * __24px `blog` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $8806751d7f7ea905$var$Blog24Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2UiHO))),
        appearance: "blueBold",
        size: "24",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $asoCt.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $asoCt.default), {
        label: label,
        testId: testId
    });
};
$8806751d7f7ea905$var$Blog24Icon.displayName = 'Blog24Icon';
var $8806751d7f7ea905$export$2e2bcd8739ae039 = $8806751d7f7ea905$var$Blog24Icon;

});
parcelRegister("asoCt", function(module, exports) {

$parcel$export(module.exports, "default", () => $158d85a5273c8dbb$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7682b4d34bd2a783038ec83f3b47a94>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $158d85a5273c8dbb$var$Blog24Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M10.998 9.035a3.5 3.5 0 1 0-3.046 3.94q-.71 1.254-1.87 2.827a1.17 1.17 0 0 0 .102 1.506.85.85 0 0 0 1.298-.092q4.013-5.52 3.516-8.18m8.895 0a3.5 3.5 0 1 0-3.046 3.94q-.71 1.254-1.87 2.827a1.17 1.17 0 0 0 .102 1.506.85.85 0 0 0 1.298-.092q4.012-5.52 3.516-8.18M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`,
        ...props,
        size: "medium"
    });
$158d85a5273c8dbb$var$Blog24Icon.displayName = 'Blog24Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$158d85a5273c8dbb$export$2e2bcd8739ae039 = $158d85a5273c8dbb$var$Blog24Icon;

});



parcelRegister("jP3VI", function(module, exports) {

let $e6e5d427a0d38fe7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e6e5d427a0d38fe7$var$load("aQTX9").then(()=>parcelRequire('aQnRv'));

});

parcelRegister("2zelF", function(module, exports) {

let $1de9faf58c0c87e3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1de9faf58c0c87e3$var$load("3T2eQ").then(()=>parcelRequire('3WUNe'));

});

parcelRegister("b1MFH", function(module, exports) {

let $80758ad7c0b11bca$var$load = (parcelRequire("28QjX"))(4);
module.exports = $80758ad7c0b11bca$var$load("5vEK3").then(()=>parcelRequire('3vtQf'));

});

parcelRegister("hIRd2", function(module, exports) {

let $ce6fd2014e57e430$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ce6fd2014e57e430$var$load("ffQaD"),
    $ce6fd2014e57e430$var$load("kvRbA"),
    $ce6fd2014e57e430$var$load("ldrEN")
]).then(()=>parcelRequire('ikced'));

});

parcelRegister("kcbfF", function(module, exports) {

let $eb3da7fce14b245c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eb3da7fce14b245c$var$load("jZklo").then(()=>parcelRequire('aRGuz'));

});

parcelRegister("3lFDz", function(module, exports) {

let $2703a189e00aa90b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2703a189e00aa90b$var$load("ggenH").then(()=>parcelRequire('gVXQp'));

});

parcelRegister("eslUC", function(module, exports) {

let $a864ad89c11a85e7$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a864ad89c11a85e7$var$load("ffQaD"),
    $a864ad89c11a85e7$var$load("kvRbA"),
    $a864ad89c11a85e7$var$load("7RCPH")
]).then(()=>parcelRequire('9bx9i'));

});

parcelRegister("aO5d7", function(module, exports) {

let $7de29da141eece0c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7de29da141eece0c$var$load("bHxrz").then(()=>parcelRequire('T5PvZ'));

});

parcelRegister("1LOaS", function(module, exports) {

let $14a119d77047e1cc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $14a119d77047e1cc$var$load("9tcWs").then(()=>parcelRequire('5mR3i'));

});

parcelRegister("k8THN", function(module, exports) {

let $ea9fc3e9dd344518$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ea9fc3e9dd344518$var$load("46xqb").then(()=>parcelRequire('a8hd9'));

});

parcelRegister("jOyH3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0c2e6e563a714afa66b2c445d0695bd6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6cd993777d46e1b$var$_react = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e6cd993777d46e1b$var$_link = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("1f9bV")));

var $e6cd993777d46e1b$var$_link2 = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("458iJ")));
function $e6cd993777d46e1b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "LinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e6cd993777d46e1b$var$LinkIcon = (props)=>/*#__PURE__*/ $e6cd993777d46e1b$var$_react.default.createElement($e6cd993777d46e1b$var$_link.default, Object.assign({
        LEGACY_fallbackIcon: $e6cd993777d46e1b$var$_link2.default
    }, props));
$e6cd993777d46e1b$var$LinkIcon.Name = 'LinkIconMigration';
var $e6cd993777d46e1b$var$_default = module.exports.default = $e6cd993777d46e1b$var$LinkIcon;

});
parcelRegister("1f9bV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7acdc4638dae9667d9917d02594abf75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e7e525cdad15340$var$_react = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0e7e525cdad15340$var$_baseNew = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $0e7e525cdad15340$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0e7e525cdad15340$var$LinkIcon = (props)=>/*#__PURE__*/ $0e7e525cdad15340$var$_react.default.createElement($0e7e525cdad15340$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$0e7e525cdad15340$var$LinkIcon.displayName = 'LinkIcon';
var $0e7e525cdad15340$var$_default = module.exports.default = $0e7e525cdad15340$var$LinkIcon;

});

parcelRegister("458iJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2f8e117d74b4de46$var$_react = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $2f8e117d74b4de46$var$_link = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("1f9bV")));
function $2f8e117d74b4de46$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2f8e117d74b4de46$var$LinkIcon = (props)=>/*#__PURE__*/ $2f8e117d74b4de46$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props, {
        newIcon: $2f8e117d74b4de46$var$_link.default
    }));
$2f8e117d74b4de46$var$LinkIcon.displayName = 'LinkIcon';
var $2f8e117d74b4de46$var$_default = module.exports.default = $2f8e117d74b4de46$var$LinkIcon;

});


parcelRegister("fBf2G", function(module, exports) {

let $b5b5fad0121b0aed$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b5b5fad0121b0aed$var$load("kRL9H").then(()=>parcelRequire('8njZH'));

});

parcelRegister("kee99", function(module, exports) {

let $eba016aa82a444ac$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eba016aa82a444ac$var$load("5soZa").then(()=>parcelRequire('9CRO6'));

});

parcelRegister("lslfp", function(module, exports) {

let $f9ecb1cf63d607e6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f9ecb1cf63d607e6$var$load("ece3U").then(()=>parcelRequire('lp0fk'));

});

parcelRegister("8yVZ6", function(module, exports) {

let $63be7a3a4598be7a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $63be7a3a4598be7a$var$load("1HQ0J").then(()=>parcelRequire('dGYEZ'));

});

parcelRegister("4nfzo", function(module, exports) {

let $32f5634727f32f4e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $32f5634727f32f4e$var$load("2xhmB").then(()=>parcelRequire('96Idm'));

});

parcelRegister("5e2oM", function(module, exports) {

let $3ce01edc74408d8e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3ce01edc74408d8e$var$load("8hyuR").then(()=>parcelRequire('RiK2l'));

});

parcelRegister("lyNGw", function(module, exports) {

let $fb235055aa698154$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fb235055aa698154$var$load("4Hcjo").then(()=>parcelRequire('3KifV'));

});

parcelRegister("7pYnQ", function(module, exports) {

let $5669b5249fdb6af1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5669b5249fdb6af1$var$load("yxx4T").then(()=>parcelRequire('iBOon'));

});

parcelRegister("bnA29", function(module, exports) {

let $848dcb3f06f2141b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $848dcb3f06f2141b$var$load("gyqsg").then(()=>parcelRequire('j8IiS'));

});

parcelRegister("cEK5F", function(module, exports) {

let $936cf90f8e3e2f60$var$load = (parcelRequire("28QjX"))(4);
module.exports = $936cf90f8e3e2f60$var$load("eI2NM").then(()=>parcelRequire('jdlqN'));

});

parcelRegister("kwONT", function(module, exports) {

let $ef1e345b5057ffb4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ef1e345b5057ffb4$var$load("lbzkh").then(()=>parcelRequire('iByEQ'));

});

parcelRegister("eFVyZ", function(module, exports) {

let $aaf18be27d7ddeca$var$load = (parcelRequire("28QjX"))(4);
module.exports = $aaf18be27d7ddeca$var$load("1toGC").then(()=>parcelRequire('c70Lr'));

});

parcelRegister("9Auxh", function(module, exports) {

let $6faf29a3253d3b39$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6faf29a3253d3b39$var$load("5yV3B").then(()=>parcelRequire('F35X1'));

});

parcelRegister("b1syu", function(module, exports) {

let $8065f0354f624b50$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8065f0354f624b50$var$load("d0F9x").then(()=>parcelRequire('2osAJ'));

});

parcelRegister("hpac9", function(module, exports) {

let $cabcadf6ae2e1f42$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cabcadf6ae2e1f42$var$load("7cJNA").then(()=>parcelRequire('eABwY'));

});

parcelRegister("e4niJ", function(module, exports) {

let $a3e383822d90894c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a3e383822d90894c$var$load("cuyPa").then(()=>parcelRequire('7zjHG'));

});

parcelRegister("5nTq3", function(module, exports) {

let $3eba16db4c5c1d72$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3eba16db4c5c1d72$var$load("53hH3").then(()=>parcelRequire('kKp2J'));

});

parcelRegister("5FD7P", function(module, exports) {

let $420f218bbefec4c3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $420f218bbefec4c3$var$load("5Eq1b").then(()=>parcelRequire('cHwqN'));

});

parcelRegister("818b0", function(module, exports) {

let $5d64c263665334a2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5d64c263665334a2$var$load("jCvJI").then(()=>parcelRequire('im5Hg'));

});

parcelRegister("7rpmm", function(module, exports) {

let $56aeb9ea10df1bd3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $56aeb9ea10df1bd3$var$load("jvPYJ").then(()=>parcelRequire('2sfBf'));

});

parcelRegister("lnlq4", function(module, exports) {

let $f8fc5c6b4e705851$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f8fc5c6b4e705851$var$load("hu0uQ").then(()=>parcelRequire('5m93C'));

});

parcelRegister("1bqc1", function(module, exports) {

let $0dcb22e00a0d6271$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0dcb22e00a0d6271$var$load("h5pFP").then(()=>parcelRequire('2tm8x'));

});

parcelRegister("hSsH1", function(module, exports) {

let $d03dbc9f90006243$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d03dbc9f90006243$var$load("b1qY8").then(()=>parcelRequire('lE6mu'));

});

parcelRegister("4ggae", function(module, exports) {

let $31a531e2d90f4446$var$load = (parcelRequire("28QjX"))(4);
module.exports = $31a531e2d90f4446$var$load("8c61R").then(()=>parcelRequire('iABw2'));

});

parcelRegister("l0b36", function(module, exports) {

let $f4a22b2828b1cdb1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f4a22b2828b1cdb1$var$load("2li5z").then(()=>parcelRequire('4sBeG'));

});

parcelRegister("faNHh", function(module, exports) {

let $b0be56fcbb908172$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b0be56fcbb908172$var$load("cdi9t").then(()=>parcelRequire('l04jD'));

});

parcelRegister("gJjAW", function(module, exports) {

let $c2e00c6f1d70175c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c2e00c6f1d70175c$var$load("bb2EZ").then(()=>parcelRequire('bPjbr'));

});

parcelRegister("7Cfy8", function(module, exports) {

let $58b824d1a2ea9c13$var$load = (parcelRequire("28QjX"))(4);
module.exports = $58b824d1a2ea9c13$var$load("fsbZm").then(()=>parcelRequire('52A0r'));

});

parcelRegister("2ja6p", function(module, exports) {

let $1ae53139d9b34c7a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1ae53139d9b34c7a$var$load("3HT5h").then(()=>parcelRequire('6qWjs'));

});

parcelRegister("lhK2t", function(module, exports) {

let $f7eee5dccd5a384d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f7eee5dccd5a384d$var$load("jDEKQ").then(()=>parcelRequire('c9Fqq'));

});

parcelRegister("c9WGr", function(module, exports) {

let $8da3d8a3a86149c1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8da3d8a3a86149c1$var$load("gf8Uv").then(()=>parcelRequire('ezu4w'));

});

parcelRegister("Zl279", function(module, exports) {

let $0b86035afefa8641$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0b86035afefa8641$var$load("exonR").then(()=>parcelRequire('6OpPE'));

});

parcelRegister("gt1ix", function(module, exports) {

let $bfd05c8607605688$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bfd05c8607605688$var$load("53wKz").then(()=>parcelRequire('iAkpb'));

});

parcelRegister("jfHd4", function(module, exports) {

let $e040ef9611e0e60c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e040ef9611e0e60c$var$load("gDjNE").then(()=>parcelRequire('41M8N'));

});

parcelRegister("2LtvO", function(module, exports) {

let $2036dd0a795d1552$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2036dd0a795d1552$var$load("lRg5D").then(()=>parcelRequire('jnURg'));

});

parcelRegister("h6mSM", function(module, exports) {

let $c734bf2e0d63df94$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c734bf2e0d63df94$var$load("ljL6x").then(()=>parcelRequire('4MX1d'));

});

parcelRegister("gbLQ9", function(module, exports) {

let $bc92c87e3f4d201b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bc92c87e3f4d201b$var$load("5A29q").then(()=>parcelRequire('gAdQO'));

});

parcelRegister("2Nnnn", function(module, exports) {

let $20924a5914a94fa0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $20924a5914a94fa0$var$load("dJFy4").then(()=>parcelRequire('eHc1t'));

});

parcelRegister("c7kWc", function(module, exports) {

let $8d266143d00ca655$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8d266143d00ca655$var$load("3wvhu").then(()=>parcelRequire('6ClRv'));

});

parcelRegister("af9Ay", function(module, exports) {

let $7752be2f3d740436$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7752be2f3d740436$var$load("4f6Qg").then(()=>parcelRequire('529Ow'));

});

parcelRegister("hBYHT", function(module, exports) {

let $cd24fb7f877e529e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cd24fb7f877e529e$var$load("jNEyH").then(()=>parcelRequire('1ni2E'));

});

parcelRegister("JuWWj", function(module, exports) {

let $088c3609920e6766$var$load = (parcelRequire("28QjX"))(4);
module.exports = $088c3609920e6766$var$load("5b7z5").then(()=>parcelRequire('gaBfD'));

});

parcelRegister("jhNzO", function(module, exports) {

let $e0a60fb679938115$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e0a60fb679938115$var$load("4TPxn").then(()=>parcelRequire('kQSMP'));

});

parcelRegister("3Umjx", function(module, exports) {

let $2d87e92c7a44ae09$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2d87e92c7a44ae09$var$load("75rqy").then(()=>parcelRequire('36Q2c'));

});

parcelRegister("ibZAY", function(module, exports) {

let $d3e9089b778b963c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d3e9089b778b963c$var$load("4RWcO").then(()=>parcelRequire('kvhCa'));

});

parcelRegister("bpMfi", function(module, exports) {

let $84f77414cd4cb748$var$load = (parcelRequire("28QjX"))(4);
module.exports = $84f77414cd4cb748$var$load("jxvAw").then(()=>parcelRequire('21nCU'));

});

parcelRegister("lGtKi", function(module, exports) {

let $fc949817bb9f3c14$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fc949817bb9f3c14$var$load("h5jED").then(()=>parcelRequire('dvo9I'));

});

parcelRegister("3unVm", function(module, exports) {

let $28a6bb471d98579f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $28a6bb471d98579f$var$load("3L0Vc").then(()=>parcelRequire('93zHH'));

});

parcelRegister("l5z4M", function(module, exports) {

let $f5a545fb7fb23c40$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f5a545fb7fb23c40$var$load("1MO1y").then(()=>parcelRequire('ercGv'));

});

parcelRegister("kEBpI", function(module, exports) {

let $f09490ac2941d78c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f09490ac2941d78c$var$load("koGHi").then(()=>parcelRequire('eFWxr'));

});

parcelRegister("4Atwu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $67f5211f96bd858e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c1228c9bdd9840505938b56c7ed44212>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $2OgES = parcelRequire("2OgES");

var $VSDnB = parcelRequire("VSDnB");

var $i0wCi = parcelRequire("i0wCi");
/**
 * __16px `page-live-doc` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $67f5211f96bd858e$var$PageLiveDoc16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2OgES))),
        appearance: "magentaBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i0wCi.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i0wCi.default), {
        label: label,
        testId: testId
    });
};
$67f5211f96bd858e$var$PageLiveDoc16Icon.displayName = 'PageLiveDoc16Icon';
var $67f5211f96bd858e$export$2e2bcd8739ae039 = $67f5211f96bd858e$var$PageLiveDoc16Icon;

});
parcelRegister("2OgES", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::692b62fec4c56cd82ae8d8d02e2d3f2e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $20bd2c4c7f421719$var$_react = $20bd2c4c7f421719$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $20bd2c4c7f421719$var$_baseNew = $20bd2c4c7f421719$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $20bd2c4c7f421719$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $20bd2c4c7f421719$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $20bd2c4c7f421719$var$_react.default.createElement($20bd2c4c7f421719$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$20bd2c4c7f421719$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $20bd2c4c7f421719$var$_default = module.exports.default = $20bd2c4c7f421719$var$PageLiveDocIcon;

});

parcelRegister("i0wCi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e01b6db3f29618ed$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bbb561a99c36d24f949f1ade9ed1fa72>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $e01b6db3f29618ed$var$PageLiveDoc16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#cd519d" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.293 3.293A1 1 0 0 0 4 5h8a1 1 0 1 0 0-2H4a1 1 0 0 0-.707.293m0 4A1 1 0 0 0 4 9h2a1 1 0 0 0 0-2H4a1 1 0 0 0-.707.293m0 4A1 1 0 0 0 4 13h2a1 1 0 0 0 0-2H4a1 1 0 0 0-.707.293m6.703-4.161a1 1 0 0 0-1.466 1.11l1 4a1 1 0 0 0 1.94 0L11.78 11H13a1 1 0 0 0 .496-1.868z" clip-rule="evenodd"/></svg>`,
        ...props,
        size: "small"
    });
$e01b6db3f29618ed$var$PageLiveDoc16Icon.displayName = 'PageLiveDoc16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e01b6db3f29618ed$export$2e2bcd8739ae039 = $e01b6db3f29618ed$var$PageLiveDoc16Icon;

});


parcelRegister("8lQ8Y", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $40d9c5b900864dd9$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::724c9bd5f0d44d16613664f162286445>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $2OgES = parcelRequire("2OgES");

var $VSDnB = parcelRequire("VSDnB");

var $25dv3 = parcelRequire("25dv3");
/**
 * __24px `page-live-doc` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $40d9c5b900864dd9$var$PageLiveDoc24Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2OgES))),
        appearance: "magentaBold",
        size: "24",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $25dv3.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $25dv3.default), {
        label: label,
        testId: testId
    });
};
$40d9c5b900864dd9$var$PageLiveDoc24Icon.displayName = 'PageLiveDoc24Icon';
var $40d9c5b900864dd9$export$2e2bcd8739ae039 = $40d9c5b900864dd9$var$PageLiveDoc24Icon;

});
parcelRegister("25dv3", function(module, exports) {

$parcel$export(module.exports, "default", () => $23b5ea63b1e20da2$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c5906433494daa938e0cf018edb0a9fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $23b5ea63b1e20da2$var$PageLiveDoc24Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#cd519d" fill-rule="evenodd" d="M24 3a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3zM4 6a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m1 5a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2zm-1 7a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m10.555-6.832a1 1 0 0 0-1.545.973l1 7a1 1 0 0 0 1.884.306L17.118 17H20a1 1 0 0 0 .555-1.832z" clip-rule="evenodd"/></svg>`,
        ...props,
        size: "medium"
    });
$23b5ea63b1e20da2$var$PageLiveDoc24Icon.displayName = 'PageLiveDoc24Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$23b5ea63b1e20da2$export$2e2bcd8739ae039 = $23b5ea63b1e20da2$var$PageLiveDoc24Icon;

});


parcelRegister("b2QJV", function(module, exports) {

let $80a8ca9d9079b9ba$var$load = (parcelRequire("28QjX"))(4);
module.exports = $80a8ca9d9079b9ba$var$load("bHtk9").then(()=>parcelRequire('eZ9Cp'));

});

parcelRegister("hTMzv", function(module, exports) {

let $d07d400d364d97f5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d07d400d364d97f5$var$load("10YFK").then(()=>parcelRequire('f5h6d'));

});

parcelRegister("i5LI7", function(module, exports) {

let $d2bdb3fa3cba1265$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d2bdb3fa3cba1265$var$load("eHHfh").then(()=>parcelRequire('biU84'));

});

parcelRegister("28C0M", function(module, exports) {

let $18e9d06c8bb828e0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $18e9d06c8bb828e0$var$load("aA0tq").then(()=>parcelRequire('729P0'));

});

parcelRegister("5ewzx", function(module, exports) {

let $3cf786b2f3106989$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3cf786b2f3106989$var$load("f0D0P").then(()=>parcelRequire('6N55R'));

});

parcelRegister("8NR13", function(module, exports) {

let $668c0634cfa76a7f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $668c0634cfa76a7f$var$load("fTI2h").then(()=>parcelRequire('3xPiH'));

});

parcelRegister("acQVl", function(module, exports) {

let $76e413f697d051f0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $76e413f697d051f0$var$load("b6xhe").then(()=>parcelRequire('9j532'));

});

parcelRegister("eXA0t", function(module, exports) {

let $ae42818d45a34fe6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ae42818d45a34fe6$var$load("4b20x").then(()=>parcelRequire('jJL9z'));

});

parcelRegister("9kf9T", function(module, exports) {

let $6ca1bd775537e485$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6ca1bd775537e485$var$load("bhhPH").then(()=>parcelRequire('3pKEh'));

});

parcelRegister("jiNtU", function(module, exports) {

let $e0d614c1b037b486$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e0d614c1b037b486$var$load("jTNTf").then(()=>parcelRequire('k7gBp'));

});

parcelRegister("eL0Ys", function(module, exports) {

let $abe635e95dbbcf20$var$load = (parcelRequire("28QjX"))(4);
module.exports = $abe635e95dbbcf20$var$load("1bW9w").then(()=>parcelRequire('Le10t'));

});

parcelRegister("aX5mo", function(module, exports) {

let $7f93927a0d8f10f8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7f93927a0d8f10f8$var$load("dqho9").then(()=>parcelRequire('kc1MS'));

});

parcelRegister("fIUai", function(module, exports) {

let $b726884848bc31ae$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b726884848bc31ae$var$load("j82pJ").then(()=>parcelRequire('hfn9j'));

});

parcelRegister("9EtBf", function(module, exports) {

let $706ecf612af6f4c0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $706ecf612af6f4c0$var$load("a0E5q").then(()=>parcelRequire('4zl0K'));

});

parcelRegister("1t6AM", function(module, exports) {

let $111d9cf2449fdb30$var$load = (parcelRequire("28QjX"))(4);
module.exports = $111d9cf2449fdb30$var$load("4E7mO").then(()=>parcelRequire('cfbO3'));

});

parcelRegister("d3Riz", function(module, exports) {

let $9824e629a9213344$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9824e629a9213344$var$load("kel8g").then(()=>parcelRequire('jyFo7'));

});

parcelRegister("34KmU", function(module, exports) {

let $23d5b6a342ab0291$var$load = (parcelRequire("28QjX"))(4);
module.exports = $23d5b6a342ab0291$var$load("98SE2").then(()=>parcelRequire('eJNZM'));

});

parcelRegister("99TdN", function(module, exports) {

let $6aafca294ba4066d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6aafca294ba4066d$var$load("ffQaD"),
    $6aafca294ba4066d$var$load("kvRbA"),
    $6aafca294ba4066d$var$load("lMeFU")
]).then(()=>parcelRequire('2CRmv'));

});

parcelRegister("lWPoA", function(module, exports) {

let $ffa6e1d54a154aa3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ffa6e1d54a154aa3$var$load("1AaKL").then(()=>parcelRequire('2ciBJ'));

});

parcelRegister("89ySK", function(module, exports) {

let $5efa38d08ffa18a2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5efa38d08ffa18a2$var$load("6wTPq").then(()=>parcelRequire('2lRM4'));

});


parcelRegister("5igsJ", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkAnalyticsContext", () => $31931ec4ffeaf53a$export$ac28ada90c4970b7);
$parcel$export(module.exports, "SmartLinkAnalyticsContext", () => $31931ec4ffeaf53a$export$eaff10f7ec59c455);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");

var $ffYTp = parcelRequire("ffYTp");

var $051X7 = parcelRequire("051X7");

var $cCcdH = parcelRequire("cCcdH");

var $VSDnB = parcelRequire("VSDnB");

var $hjhAz = parcelRequire("hjhAz");

var $fzJZi = parcelRequire("fzJZi");
const $31931ec4ffeaf53a$var$getExtendedResolvedAttributes = (linkDetails, details, linkStatus, error)=>({
        definitionId: details?.meta?.definitionId ?? null,
        resourceType: details?.meta?.resourceType ?? null,
        ...(0, $ffYTp.getResolvedAttributes)(linkDetails, details, linkStatus, error)
    });
const $31931ec4ffeaf53a$var$getSmartLinkAnalyticsContext = ({ display: display, id: id, response: response, source: source, status: status, url: url, error: error })=>{
    const resolvedAttributes = $31931ec4ffeaf53a$var$getExtendedResolvedAttributes({
        url: url
    }, response, status, error);
    return {
        source: source,
        attributes: {
            ...(0, $fzJZi.context),
            display: display,
            id: id,
            ...resolvedAttributes
        }
    };
};
const $31931ec4ffeaf53a$export$ac28ada90c4970b7 = ({ display: display, id: id, source: source, url: url })=>{
    const { store: store } = (0, $051X7.useSmartLinkContext)();
    const state = store ? (0, $cCcdH.getUrl)(store, url) : undefined;
    return (0, $5uXOq.useMemo)(()=>{
        return $31931ec4ffeaf53a$var$getSmartLinkAnalyticsContext({
            display: display,
            id: id,
            response: state?.details,
            source: source,
            status: state?.status,
            url: url,
            error: state?.error
        });
    }, [
        display,
        id,
        source,
        state?.details,
        state?.status,
        url,
        state?.error
    ]);
};
const $31931ec4ffeaf53a$export$eaff10f7ec59c455 = ({ children: children, display: display, id: id, source: source, url: url })=>{
    const { details: details, status: status, error: error } = (0, $hjhAz.useSmartCardState)(url);
    const data = $31931ec4ffeaf53a$var$getSmartLinkAnalyticsContext({
        display: display,
        id: id,
        response: details,
        source: source,
        status: status,
        url: url,
        error: (0, $VSDnB.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? error : undefined
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
        data: data,
        children: children
    });
};

});
parcelRegister("ffYTp", function(module, exports) {

$parcel$export(module.exports, "getResolvedAttributes", () => $842bbc6d3f3b5d59$export$7243431f5325a7b);

var $fiKQs = parcelRequire("fiKQs");

var $iHcpV = parcelRequire("iHcpV");

var $VSDnB = parcelRequire("VSDnB");
const $842bbc6d3f3b5d59$export$7243431f5325a7b = (linkDetails, details, linkStatus, error)=>{
    const status = linkStatus ?? (details && (0, $fiKQs.getStatus)(details));
    const displayCategory = linkDetails.displayCategory === 'link' ? 'link' : (0, $iHcpV.getDisplayCategory)(status);
    return {
        status: status ?? null,
        statusDetails: details?.meta?.requestAccess?.accessType ?? null,
        displayCategory: displayCategory,
        extensionKey: (0, $VSDnB.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? details?.meta?.key ?? error?.extensionKey ?? null : details?.meta?.key ?? null,
        destinationTenantId: details?.meta?.tenantId ?? null,
        destinationActivationId: details?.meta?.activationId ?? null,
        destinationContainerId: details?.meta?.containerId ?? null,
        destinationCategory: details?.meta?.category ?? null,
        destinationProduct: details?.meta?.product ?? null,
        destinationSubproduct: details?.meta?.subproduct ?? null,
        destinationObjectId: details?.meta?.objectId ?? null,
        destinationObjectType: details?.meta?.resourceType ?? null,
        canBeDatasource: (details?.datasources || []).length > 0
    };
};

});
parcelRegister("iHcpV", function(module, exports) {

$parcel$export(module.exports, "getDisplayCategory", () => $1a9daeca9ad503b7$export$28ddbae335bd80b5);
const $1a9daeca9ad503b7$export$28ddbae335bd80b5 = (status)=>{
    return !status || status !== 'not_found' ? 'smartLink' : 'link';
};

});


parcelRegister("hjhAz", function(module, exports) {

$parcel$export(module.exports, "useSmartCardState", () => $7fb324870ee27912$export$b0444d00ba7313c6);

var $bDWQ3 = parcelRequire("bDWQ3");

var $051X7 = parcelRequire("051X7");
const $7fb324870ee27912$var$PENDING_STATE = {
    status: 'pending'
};
function $7fb324870ee27912$export$b0444d00ba7313c6(url) {
    const { store: store } = (0, $051X7.useSmartLinkContext)();
    const cardState = (0, $bDWQ3.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, store.getState, (state)=>state[url]);
    return cardState ?? $7fb324870ee27912$var$PENDING_STATE;
}

});


parcelRegister("91tw3", function(module, exports) {

$parcel$export(module.exports, "isFlexibleUiCard", () => $f30ba994fabdf720$export$3c94e0f4719f5c2a);
$parcel$export(module.exports, "isFlexibleUiTitleBlock", () => $f30ba994fabdf720$export$df0092b19156b140);
$parcel$export(module.exports, "isStyleCacheProvider", () => $f30ba994fabdf720$export$14ff825bfe645006);
$parcel$export(module.exports, "isFlexibleUiBlock", () => $f30ba994fabdf720$export$b56fc89cf6e7d1e9);
$parcel$export(module.exports, "isFlexibleUiElement", () => $f30ba994fabdf720$export$d7fc505bb0bd5756);
$parcel$export(module.exports, "isFlexibleUiPreviewBlock", () => $f30ba994fabdf720$export$c0547b4405cae584);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $66ZRy = parcelRequire("66ZRy");
var $buvhv = parcelRequire("buvhv");
var $hYQw7 = parcelRequire("hYQw7");
var $ietxm = parcelRequire("ietxm");

var $eqoQu = parcelRequire("eqoQu");
const $f30ba994fabdf720$export$3c94e0f4719f5c2a = (children, ui)=>{
    if ((0, $VSDnB.fg)('platform-linking-flexible-card-openness')) {
        if (ui?.removeBlockRestriction) return children && (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children)?.length > 0 ? true : false;
    }
    if (children && (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children).some((child)=>$f30ba994fabdf720$export$df0092b19156b140(child))) return true;
    return false;
};
const $f30ba994fabdf720$export$14ff825bfe645006 = (node)=>{
    if (typeof node.type !== 'string' && node.type?.name === 'StyleCacheProvider' && node.props.children) return true;
    else if (typeof node.type !== 'string' && node.type?.name === 'CC' && node.props.children) return true;
    return false;
};
const $f30ba994fabdf720$export$b56fc89cf6e7d1e9 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node)) return false;
    if ($f30ba994fabdf720$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $f30ba994fabdf720$export$b56fc89cf6e7d1e9(child);
        });
        return isChildrenValid;
    }
    if (Object.values($66ZRy).some((type)=>type === node.type)) return true;
    return false;
};
const $f30ba994fabdf720$export$d7fc505bb0bd5756 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node)) return false;
    if (Object.values($eqoQu).some((type)=>type === node.type)) return true;
    if ($f30ba994fabdf720$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $f30ba994fabdf720$export$d7fc505bb0bd5756(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $f30ba994fabdf720$export$df0092b19156b140 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node)) return false;
    if (node.type === (0, $buvhv.default)) return true;
    if ($f30ba994fabdf720$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $f30ba994fabdf720$export$df0092b19156b140(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $f30ba994fabdf720$export$c0547b4405cae584 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node)) return false;
    if (node.type === (0, $hYQw7.default)) return true;
    if ($f30ba994fabdf720$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $f30ba994fabdf720$export$c0547b4405cae584(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $f30ba994fabdf720$export$43edae7b55c79927 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node) && node.type === (0, $ietxm.default);

});
parcelRegister("66ZRy", function(module, exports) {

$parcel$export(module.exports, "FooterBlock", () => (parcelRequire("ietxm")).default);
$parcel$export(module.exports, "MetadataBlock", () => (parcelRequire("gg6Qm")).default);
$parcel$export(module.exports, "PreviewBlock", () => (parcelRequire("hYQw7")).default);
$parcel$export(module.exports, "SnippetBlock", () => (parcelRequire("1JaZ4")).default);
$parcel$export(module.exports, "TitleBlock", () => (parcelRequire("buvhv")).default);
$parcel$export(module.exports, "CustomBlock", () => (parcelRequire("dghu0")).default);
$parcel$export(module.exports, "InternalFooterBlock", () => (parcelRequire("5HrTg")).default);
$parcel$export(module.exports, "AISummaryBlock", () => (parcelRequire("1qDIM")).default);
$parcel$export(module.exports, "AIFooterBlock", () => (parcelRequire("85ffk")).default);
$parcel$export(module.exports, "ActionBlock", () => (parcelRequire("fh9qw")).default);

var $ietxm = parcelRequire("ietxm");

var $gg6Qm = parcelRequire("gg6Qm");

var $hYQw7 = parcelRequire("hYQw7");

var $1JaZ4 = parcelRequire("1JaZ4");

var $buvhv = parcelRequire("buvhv");

var $dghu0 = parcelRequire("dghu0");

var $5HrTg = parcelRequire("5HrTg");

var $1qDIM = parcelRequire("1qDIM");

var $85ffk = parcelRequire("85ffk");

var $fh9qw = parcelRequire("fh9qw");

});
parcelRegister("ietxm", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fcebb5ad9978d90$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $5HrTg = parcelRequire("5HrTg");
/**
 * Represents a FooterBlock, designed to contain elements and actions that should appear
 * at the bottom of a link card.
 * @public
 * @param {FooterBlockProps} FooterBlockProps
 * @see Block
 */ const $3fcebb5ad9978d90$var$FooterBlock = ({ status: status, testId: testId = 'smart-footer-block', alwaysShow: alwaysShow, ...props })=>{
    if (status !== (0, $8dVIb.SmartLinkStatus).Resolved && !alwaysShow) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5HrTg.default), {
        ...props,
        testId: testId
    });
};
var $3fcebb5ad9978d90$export$2e2bcd8739ae039 = $3fcebb5ad9978d90$var$FooterBlock;

});
parcelRegister("5HrTg", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8eaafd3e75b73f4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $b6uPu = parcelRequire("b6uPu");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $eqoQu = parcelRequire("eqoQu");

var $bubxq = parcelRequire("bubxq");

var $dghu0 = parcelRequire("dghu0");

var $1BfaB = parcelRequire("1BfaB");

var $akF1x = parcelRequire("akF1x");
const $b8eaafd3e75b73f4$var$actionGroupStylesOld = null;
const $b8eaafd3e75b73f4$var$actionGroupStyles = null;
const $b8eaafd3e75b73f4$var$safariStyles = null;
const $b8eaafd3e75b73f4$var$FooterBlockResolvedView = (props)=>{
    const { actions: actions, testId: testId, onActionMenuOpenChange: onActionMenuOpenChange, size: size = (0, $8dVIb.SmartLinkSize).Medium, hideProvider: hideProvider } = props;
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const hasActions = (0, $5uXOq.useMemo)(()=>(0, $akF1x.filterActionItems)(actions, context)?.length > 0, [
        actions,
        context
    ]);
    const { safari: safari = false } = (0, $VSDnB.fg)('platform-linking-visual-refresh-v2') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useMemo)(()=>(0, $b6uPu.browser)(), []) : {};
    const onDropdownOpenChange = (0, $5uXOq.useCallback)((isOpen)=>{
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...props,
        testId: `${testId}-resolved-view`,
        children: [
            !hideProvider && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqoQu.Provider), {
                ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {
                    appearance: 'subtle'
                } : {},
                testId: `${testId}-provider`
            }),
            actions && hasActions ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                testId: "smart-element-group-actions",
                align: (0, $8dVIb.SmartLinkAlignment).Right,
                direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                width: (0, $8dVIb.SmartLinkWidth).Flexible,
                className: (0, $bwpsq.default)([
                    size === (0, $8dVIb.SmartLinkSize).XLarge && (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_c71lxy5q",
                    size === (0, $8dVIb.SmartLinkSize).XLarge && !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_c71lviql",
                    safari && "_4t3i1osq"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bubxq.default), {
                    onDropdownOpenChange: onDropdownOpenChange,
                    items: actions,
                    appearance: "default",
                    size: size
                })
            }) : null
        ]
    });
};
var $b8eaafd3e75b73f4$export$2e2bcd8739ae039 = $b8eaafd3e75b73f4$var$FooterBlockResolvedView;

});
parcelRegister("b6uPu", function(module, exports) {

$parcel$export(module.exports, "browser", () => $7f7209ce5c1e8d08$export$3f2684e5d7cb1006);
const $7f7209ce5c1e8d08$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.mac = /Mac/.test(navigator.platform);
    let ie = $7f7209ce5c1e8d08$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $7f7209ce5c1e8d08$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $7f7209ce5c1e8d08$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $7f7209ce5c1e8d08$var$result.android = /Android \d/.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $7f7209ce5c1e8d08$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $7f7209ce5c1e8d08$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $7f7209ce5c1e8d08$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
function $7f7209ce5c1e8d08$export$3f2684e5d7cb1006() {
    return $7f7209ce5c1e8d08$var$result;
}

});

parcelRegister("Nh1XU", function(module, exports) {

$parcel$export(module.exports, "FlexibleCardContext", () => $79a38154bf117346$export$13dde4423ab71d62);
$parcel$export(module.exports, "FlexibleUiContext", () => $79a38154bf117346$export$ca70b164b615de47);
$parcel$export(module.exports, "useFlexibleUiContext", () => $79a38154bf117346$export$61d7957a243df7aa);
$parcel$export(module.exports, "FlexibleUiOptionContext", () => $79a38154bf117346$export$f7433dbd6c50e26a);
$parcel$export(module.exports, "useFlexibleUiOptionContext", () => $79a38154bf117346$export$e6b5ad18b56e8f51);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $79a38154bf117346$export$13dde4423ab71d62 = (0, $5uXOq.createContext)(undefined);
const $79a38154bf117346$export$a8c4167e4e9f26ab = ()=>(0, $5uXOq.useContext)($79a38154bf117346$export$13dde4423ab71d62);
const $79a38154bf117346$export$ca70b164b615de47 = (0, $5uXOq.createContext)(undefined);
const $79a38154bf117346$export$61d7957a243df7aa = ()=>(0, $VSDnB.fg)('platform-linking-flexible-card-context') ? $79a38154bf117346$export$a8c4167e4e9f26ab()?.data : (0, $5uXOq.useContext)($79a38154bf117346$export$ca70b164b615de47);
const $79a38154bf117346$export$f7433dbd6c50e26a = (0, $5uXOq.createContext)(undefined);
const $79a38154bf117346$export$e6b5ad18b56e8f51 = ()=>(0, $VSDnB.fg)('platform-linking-flexible-card-context') ? $79a38154bf117346$export$a8c4167e4e9f26ab()?.ui : (0, $5uXOq.useContext)($79a38154bf117346$export$f7433dbd6c50e26a);

});

parcelRegister("eqoQu", function(module, exports) {

$parcel$export(module.exports, "AssignedTo", () => $ec376f2b71614cc0$export$d3af56c23f9e459b);
$parcel$export(module.exports, "AssignedToGroup", () => $ec376f2b71614cc0$export$fbd18f11bf3a3444);
$parcel$export(module.exports, "AttachmentCount", () => $ec376f2b71614cc0$export$3bc3c9693a40aa);
$parcel$export(module.exports, "AuthorGroup", () => $ec376f2b71614cc0$export$2ae2af4435dd6144);
$parcel$export(module.exports, "ChecklistProgress", () => $ec376f2b71614cc0$export$5742b38fd5cfe410);
$parcel$export(module.exports, "CollaboratorGroup", () => $ec376f2b71614cc0$export$a1e647014985ddb9);
$parcel$export(module.exports, "CommentCount", () => $ec376f2b71614cc0$export$f4c1466e6fdd07b);
$parcel$export(module.exports, "CreatedOn", () => $ec376f2b71614cc0$export$53ced9403d373871);
$parcel$export(module.exports, "CreatedBy", () => $ec376f2b71614cc0$export$db468caedefbb630);
$parcel$export(module.exports, "DueOn", () => $ec376f2b71614cc0$export$fea59459cfa1625b);
$parcel$export(module.exports, "LatestCommit", () => $ec376f2b71614cc0$export$2aa8c58ab6c8ae64);
$parcel$export(module.exports, "LinkIcon", () => $ec376f2b71614cc0$export$69387b41dfc808f7);
$parcel$export(module.exports, "Location", () => $ec376f2b71614cc0$export$18a2be9195644f38);
$parcel$export(module.exports, "ModifiedBy", () => $ec376f2b71614cc0$export$ebbbdcc68d717b7b);
$parcel$export(module.exports, "ModifiedOn", () => $ec376f2b71614cc0$export$a6db3f4240728b58);
$parcel$export(module.exports, "OwnedBy", () => $ec376f2b71614cc0$export$fa04b1f8d953704f);
$parcel$export(module.exports, "OwnedByGroup", () => $ec376f2b71614cc0$export$90e81c873cca1e90);
$parcel$export(module.exports, "Priority", () => $ec376f2b71614cc0$export$300334f671c43555);
$parcel$export(module.exports, "ProgrammingLanguage", () => $ec376f2b71614cc0$export$7904b5485bf997ea);
$parcel$export(module.exports, "Provider", () => $ec376f2b71614cc0$export$2881499e37b75b9a);
$parcel$export(module.exports, "ReactCount", () => $ec376f2b71614cc0$export$f69df2decd5f729e);
$parcel$export(module.exports, "ReadTime", () => $ec376f2b71614cc0$export$77dedcd16f070a20);
$parcel$export(module.exports, "SentOn", () => $ec376f2b71614cc0$export$897b145a1ed39fe5);
$parcel$export(module.exports, "SourceBranch", () => $ec376f2b71614cc0$export$387c3264a8f67d61);
$parcel$export(module.exports, "State", () => $ec376f2b71614cc0$export$7254cc27399e90bd);
$parcel$export(module.exports, "SubscriberCount", () => $ec376f2b71614cc0$export$cfafe90bba8a54db);
$parcel$export(module.exports, "SubTasksProgress", () => $ec376f2b71614cc0$export$d441f34e4c8dd9e7);
$parcel$export(module.exports, "StoryPoints", () => $ec376f2b71614cc0$export$634eef04d1a9a575);
$parcel$export(module.exports, "TargetBranch", () => $ec376f2b71614cc0$export$b5e4199e062b8f44);
$parcel$export(module.exports, "Title", () => $ec376f2b71614cc0$export$f99233281efd08a0);
$parcel$export(module.exports, "ViewCount", () => $ec376f2b71614cc0$export$ae2d8be089b6cfe0);
$parcel$export(module.exports, "VoteCount", () => $ec376f2b71614cc0$export$b080bef6ed7fa75a);
$parcel$export(module.exports, "Preview", () => (parcelRequire("4gwhW")).default);
$parcel$export(module.exports, "Snippet", () => (parcelRequire("kp8aU")).default);
$parcel$export(module.exports, "AppliedToComponentsCount", () => (parcelRequire("iG1Aw")).default);

var $8dVIb = parcelRequire("8dVIb");

var $eCsaJ = parcelRequire("eCsaJ");

var $4gwhW = parcelRequire("4gwhW");

var $kp8aU = parcelRequire("kp8aU");

var $iG1Aw = parcelRequire("iG1Aw");
const $ec376f2b71614cc0$export$d3af56c23f9e459b = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).AssignedTo);
const $ec376f2b71614cc0$export$fbd18f11bf3a3444 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).AssignedToGroup);
const $ec376f2b71614cc0$export$3bc3c9693a40aa = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).AttachmentCount);
const $ec376f2b71614cc0$export$2ae2af4435dd6144 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).AuthorGroup);
const $ec376f2b71614cc0$export$5742b38fd5cfe410 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ChecklistProgress);
const $ec376f2b71614cc0$export$a1e647014985ddb9 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).CollaboratorGroup);
const $ec376f2b71614cc0$export$f4c1466e6fdd07b = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).CommentCount);
const $ec376f2b71614cc0$export$53ced9403d373871 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).CreatedOn);
const $ec376f2b71614cc0$export$db468caedefbb630 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).CreatedBy);
const $ec376f2b71614cc0$export$fea59459cfa1625b = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).DueOn);
const $ec376f2b71614cc0$export$2aa8c58ab6c8ae64 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).LatestCommit);
const $ec376f2b71614cc0$export$69387b41dfc808f7 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).LinkIcon);
const $ec376f2b71614cc0$export$18a2be9195644f38 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).Location);
const $ec376f2b71614cc0$export$ebbbdcc68d717b7b = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ModifiedBy);
const $ec376f2b71614cc0$export$a6db3f4240728b58 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ModifiedOn);
const $ec376f2b71614cc0$export$fa04b1f8d953704f = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).OwnedBy);
const $ec376f2b71614cc0$export$90e81c873cca1e90 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).OwnedByGroup);
const $ec376f2b71614cc0$export$300334f671c43555 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).Priority);
const $ec376f2b71614cc0$export$7904b5485bf997ea = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ProgrammingLanguage);
const $ec376f2b71614cc0$export$2881499e37b75b9a = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).Provider);
const $ec376f2b71614cc0$export$f69df2decd5f729e = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ReactCount);
const $ec376f2b71614cc0$export$77dedcd16f070a20 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ReadTime);
const $ec376f2b71614cc0$export$897b145a1ed39fe5 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).SentOn);
const $ec376f2b71614cc0$export$387c3264a8f67d61 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).SourceBranch);
const $ec376f2b71614cc0$export$7254cc27399e90bd = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).State);
const $ec376f2b71614cc0$export$cfafe90bba8a54db = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).SubscriberCount);
const $ec376f2b71614cc0$export$d441f34e4c8dd9e7 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).SubTasksProgress);
const $ec376f2b71614cc0$export$634eef04d1a9a575 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).StoryPoints);
const $ec376f2b71614cc0$export$b5e4199e062b8f44 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).TargetBranch);
const $ec376f2b71614cc0$export$f99233281efd08a0 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).Title);
const $ec376f2b71614cc0$export$ae2d8be089b6cfe0 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ViewCount);
const $ec376f2b71614cc0$export$b080bef6ed7fa75a = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).VoteCount);

});
parcelRegister("eCsaJ", function(module, exports) {

$parcel$export(module.exports, "createElement", () => $3c92d860530d8c8b$export$c8a8987d4410bf2d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $kxcRq = parcelRequire("kxcRq");

var $iG1Aw = parcelRequire("iG1Aw");

var $hCl3E = parcelRequire("hCl3E");

var $8JkyP = parcelRequire("8JkyP");
var $hg3n9 = parcelRequire("hg3n9");
var $hMRm5 = parcelRequire("hMRm5");
var $f8hXJ = parcelRequire("f8hXJ");
var $Rf8nG = parcelRequire("Rf8nG");
var $eL5Me = parcelRequire("eL5Me");

var $1Lomb = parcelRequire("1Lomb");

var $h2tJr = parcelRequire("h2tJr");
const $3c92d860530d8c8b$var$elementMappings = {
    [(0, $8dVIb.ElementName).AppliedToComponentsCount]: {
        component: (0, $iG1Aw.default),
        props: {
            icon: (0, $8dVIb.IconType).Component
        }
    },
    [(0, $8dVIb.ElementName).AttachmentCount]: {
        component: (0, $hg3n9.default),
        props: {
            icon: (0, $8dVIb.IconType).Attachment
        }
    },
    [(0, $8dVIb.ElementName).AuthorGroup]: {
        component: (0, $8JkyP.default)
    },
    [(0, $8dVIb.ElementName).ChecklistProgress]: {
        component: (0, $hg3n9.default),
        props: {
            icon: (0, $8dVIb.IconType).CheckItem
        }
    },
    [(0, $8dVIb.ElementName).CollaboratorGroup]: {
        component: (0, $8JkyP.default)
    },
    [(0, $8dVIb.ElementName).CommentCount]: {
        component: (0, $hg3n9.default),
        props: {
            icon: (0, $8dVIb.IconType).Comment
        }
    },
    [(0, $8dVIb.ElementName).ViewCount]: {
        component: (0, $hg3n9.default),
        props: {
            icon: (0, $8dVIb.IconType).View
        }
    },
    [(0, $8dVIb.ElementName).ReactCount]: {
        component: (0, $hg3n9.default),
        props: {
            icon: (0, $8dVIb.IconType).React
        }
    },
    [(0, $8dVIb.ElementName).VoteCount]: {
        component: (0, $hg3n9.default),
        props: {
            icon: (0, $8dVIb.IconType).Vote
        }
    },
    [(0, $8dVIb.ElementName).CreatedBy]: {
        component: (0, $eL5Me.default)
    },
    [(0, $8dVIb.ElementName).OwnedBy]: {
        component: (0, $eL5Me.default)
    },
    [(0, $8dVIb.ElementName).AssignedTo]: {
        component: (0, $eL5Me.default)
    },
    [(0, $8dVIb.ElementName).AssignedToGroup]: {
        component: (0, $8JkyP.default)
    },
    [(0, $8dVIb.ElementName).OwnedByGroup]: {
        component: (0, $8JkyP.default)
    },
    [(0, $8dVIb.ElementName).CreatedOn]: {
        component: (0, $hMRm5.default)
    },
    [(0, $8dVIb.ElementName).DueOn]: {
        component: (0, $Rf8nG.default)
    },
    [(0, $8dVIb.ElementName).LatestCommit]: {
        component: (0, $hg3n9.default),
        props: {
            icon: (0, $8dVIb.IconType).Commit
        }
    },
    [(0, $8dVIb.ElementName).LinkIcon]: {
        component: (0, $1Lomb.default)
    },
    [(0, $8dVIb.ElementName).ModifiedBy]: {
        component: (0, $eL5Me.default)
    },
    [(0, $8dVIb.ElementName).ModifiedOn]: {
        component: (0, $hMRm5.default)
    },
    [(0, $8dVIb.ElementName).Preview]: {
        component: (0, $h2tJr.default)
    },
    [(0, $8dVIb.ElementName).Priority]: {
        component: (0, $hg3n9.default)
    },
    [(0, $8dVIb.ElementName).ProgrammingLanguage]: {
        component: (0, $hg3n9.default),
        props: {
            icon: (0, $8dVIb.IconType).ProgrammingLanguage
        }
    },
    [(0, $8dVIb.ElementName).Provider]: {
        component: (0, $hg3n9.default)
    },
    [(0, $8dVIb.ElementName).ReadTime]: {
        component: (0, $eL5Me.default)
    },
    [(0, $8dVIb.ElementName).SentOn]: {
        component: (0, $hMRm5.default)
    },
    [(0, $8dVIb.ElementName).SourceBranch]: {
        component: (0, $eL5Me.default)
    },
    [(0, $8dVIb.ElementName).State]: {
        component: (0, $Rf8nG.default)
    },
    [(0, $8dVIb.ElementName).SubscriberCount]: {
        component: (0, $hg3n9.default),
        props: {
            icon: (0, $8dVIb.IconType).Subscriber
        }
    },
    [(0, $8dVIb.ElementName).SubTasksProgress]: {
        component: (0, $hg3n9.default),
        props: {
            icon: (0, $8dVIb.IconType).SubTasksProgress
        }
    },
    [(0, $8dVIb.ElementName).StoryPoints]: {
        component: (0, $hCl3E.default)
    },
    [(0, $8dVIb.ElementName).TargetBranch]: {
        component: (0, $eL5Me.default)
    },
    [(0, $8dVIb.ElementName).Title]: {
        component: (0, $f8hXJ.default)
    },
    [(0, $8dVIb.ElementName).Location]: {
        component: (0, $f8hXJ.default),
        props: {
            theme: (0, $8dVIb.SmartLinkInternalTheme).Grey
        }
    }
};
/**
 * @deprecated
 */ const $3c92d860530d8c8b$var$getContextKey = (name)=>{
    // Attempt to predict context prop name in advance to reduce the amount of
    // code run during runtime
    return name.length > 0 ? name.charAt(0).toLowerCase() + name.slice(1) : undefined;
};
/**
 * @deprecated
 */ const $3c92d860530d8c8b$var$getData = (elementName, contextKey, context)=>{
    if (!context) return undefined;
    const data = context[contextKey];
    switch(elementName){
        case (0, $8dVIb.ElementName).AssignedToGroup:
        case (0, $8dVIb.ElementName).AuthorGroup:
        case (0, $8dVIb.ElementName).CollaboratorGroup:
        case (0, $8dVIb.ElementName).OwnedByGroup:
            const AvatarGroupsWithFallback = [
                (0, $8dVIb.ElementName).AssignedToGroup
            ];
            const showFallbackAvatar = AvatarGroupsWithFallback.includes(elementName);
            return $3c92d860530d8c8b$var$toAvatarGroupProps(data, showFallbackAvatar);
        case (0, $8dVIb.ElementName).AppliedToComponentsCount:
        case (0, $8dVIb.ElementName).AttachmentCount:
        case (0, $8dVIb.ElementName).ChecklistProgress:
        case (0, $8dVIb.ElementName).CommentCount:
        case (0, $8dVIb.ElementName).ViewCount:
        case (0, $8dVIb.ElementName).ReactCount:
        case (0, $8dVIb.ElementName).VoteCount:
        case (0, $8dVIb.ElementName).ProgrammingLanguage:
        case (0, $8dVIb.ElementName).SubscriberCount:
        case (0, $8dVIb.ElementName).LatestCommit:
        case (0, $8dVIb.ElementName).SubTasksProgress:
            return $3c92d860530d8c8b$var$toBadgeProps(data);
        case (0, $8dVIb.ElementName).StoryPoints:
            return $3c92d860530d8c8b$var$toAtlaskitBadgeProps(data);
        case (0, $8dVIb.ElementName).CreatedBy:
            return $3c92d860530d8c8b$var$toFormattedTextProps((0, $7zaVw.messages).created_by, context.createdBy);
        case (0, $8dVIb.ElementName).AssignedTo:
            return $3c92d860530d8c8b$var$toFormattedTextProps((0, $7zaVw.messages).assigned_to, context.assignedTo);
        case (0, $8dVIb.ElementName).OwnedBy:
            return $3c92d860530d8c8b$var$toFormattedTextProps((0, $7zaVw.messages).owned_by, context.ownedBy);
        case (0, $8dVIb.ElementName).CreatedOn:
            return $3c92d860530d8c8b$var$toDateTimeProps('created', context.createdOn);
        case (0, $8dVIb.ElementName).DueOn:
            return $3c92d860530d8c8b$var$toDateLozengeProps(context.dueOn);
        case (0, $8dVIb.ElementName).ModifiedBy:
            return $3c92d860530d8c8b$var$toFormattedTextProps((0, $7zaVw.messages).modified_by, context.modifiedBy);
        case (0, $8dVIb.ElementName).ModifiedOn:
            return $3c92d860530d8c8b$var$toDateTimeProps('modified', context.modifiedOn);
        case (0, $8dVIb.ElementName).SentOn:
            return $3c92d860530d8c8b$var$toDateTimeProps('sent', context.sentOn);
        case (0, $8dVIb.ElementName).ReadTime:
            return $3c92d860530d8c8b$var$toFormattedTextProps((0, $7zaVw.messages).read_time, data);
        case (0, $8dVIb.ElementName).SourceBranch:
        case (0, $8dVIb.ElementName).TargetBranch:
            return $3c92d860530d8c8b$var$toTextProps(data);
        case (0, $8dVIb.ElementName).Title:
            return $3c92d860530d8c8b$var$toLinkProps(context.title, context.url);
        case (0, $8dVIb.ElementName).LinkIcon:
            if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v2')) return $3c92d860530d8c8b$var$toLinkIconProps(data, context.type);
            return typeof data === 'object' ? data : undefined;
        default:
            return typeof data === 'object' ? data : undefined;
    }
};
const $3c92d860530d8c8b$var$toAvatarGroupProps = (items, showFallbackAvatar)=>{
    return items ? {
        items: items
    } : showFallbackAvatar ? {
        items: []
    } : undefined;
};
const $3c92d860530d8c8b$var$toBadgeProps = (label)=>{
    return label ? {
        label: label
    } : undefined;
};
const $3c92d860530d8c8b$var$toAtlaskitBadgeProps = (value)=>{
    return value ? {
        value: value
    } : undefined;
};
const $3c92d860530d8c8b$var$toDateLozengeProps = (dateString)=>{
    if (dateString) {
        const text = Date.parse(dateString) ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7VHMR.FormattedDate), {
            value: new Date(dateString),
            year: "numeric",
            month: "short",
            day: "numeric",
            formatMatcher: "best fit"
        }) : dateString;
        return {
            text: text
        };
    }
};
const $3c92d860530d8c8b$var$toDateTimeProps = (type, dateString)=>{
    return dateString ? {
        date: new Date(dateString),
        type: type
    } : undefined;
};
const $3c92d860530d8c8b$var$toFormattedTextProps = (descriptor, context)=>{
    if ((0, $VSDnB.fg)('platform-linking-additional-flexible-element-props')) return context ? {
        message: {
            descriptor: descriptor,
            values: {
                context: context
            }
        },
        content: context
    } : undefined;
    return context ? {
        message: {
            descriptor: descriptor,
            values: {
                context: context
            }
        }
    } : undefined;
};
const $3c92d860530d8c8b$var$toLinkProps = (text, url)=>{
    return text ? {
        text: text,
        url: url
    } : undefined;
};
const $3c92d860530d8c8b$var$toTextProps = (content)=>{
    return content ? {
        content: content
    } : undefined;
};
const $3c92d860530d8c8b$var$toLinkIconProps = (data, type)=>{
    const isDataLinkIcon = (_data)=>{
        return typeof _data === 'object' && _data !== null && ('icon' in _data || 'url' in _data);
    };
    if (!isDataLinkIcon(data)) return typeof data === 'object' ? data : undefined;
    const isImageRound = (0, $kxcRq.isProfileType)(type);
    return {
        ...data,
        appearance: isImageRound ? 'round' : 'square'
    };
};
const $3c92d860530d8c8b$export$c8a8987d4410bf2d = (name)=>{
    const { component: BaseElement, props: props } = $3c92d860530d8c8b$var$elementMappings[name] || {};
    const contextKey = $3c92d860530d8c8b$var$getContextKey(name);
    if (!BaseElement) throw Error(`Element ${name} does not exist.`);
    return (overrides)=>{
        const context = (0, $VSDnB.fg)('platform-linking-flexible-card-context') ? (0, $Nh1XU.useFlexibleUiContext)() : (0, $5uXOq.useContext)((0, $Nh1XU.FlexibleUiContext));
        const data = $3c92d860530d8c8b$var$getData(name, contextKey, context);
        return data ? /*#__PURE__*/ (0, $2OMIu.jsx)(BaseElement, {
            ...props,
            ...data,
            ...overrides,
            name: name
        }) : null;
    };
};

});
parcelRegister("7zaVw", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a298b78183f16654$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $a298b78183f16654$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    actions: {
        id: 'fabric.linking.actions',
        defaultMessage: 'Actions',
        description: ''
    },
    add_account: {
        id: 'fabric.linking.add_account',
        defaultMessage: 'Add account',
        description: 'Allows to add a new account'
    },
    ai_summarize: {
        id: 'fabric.linking.ai_summarize',
        defaultMessage: 'Summarize',
        description: 'Action to summarize link resource content with AI'
    },
    ai_summarized: {
        id: 'fabric.linking.ai_summarized',
        defaultMessage: 'Summarized by Atlassian Intelligence',
        description: 'Shown with the content summarised by AI.'
    },
    ai_summarized_abbreviation: {
        id: 'fabric.linking.ai_summarized_abbreviation',
        defaultMessage: 'Summarized by AI',
        description: 'Shown with the content summarised by AI. AI is in abbreviation form to reduce space.'
    },
    ai_summarized_info: {
        id: 'fabric.linking.ai_summarized_info',
        defaultMessage: 'Information quality may vary. <a>Learn more</a>',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarized_info_short: {
        id: 'fabric.linking.ai_summarized_info_short',
        defaultMessage: 'Content quality may vary',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarizing: {
        id: 'fabric.linking.ai_summarizing',
        defaultMessage: 'Atlassian Intelligence is working...',
        description: 'Shown when AI summary is summarising the link resource content.'
    },
    ai_summary_error_generic: {
        id: 'fabric.linking.ai_summary_error_generic',
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <a>check the status of AI</a>.",
        description: 'Shown when AI Summary encountered an unexpected error while summarizing the linked resource content.'
    },
    ai_summary_error_acceptable_use_violation: {
        id: 'fabric.linking.ai_summary_error_acceptable_use_violation',
        defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>.",
        description: 'Shown when AI summary is summarising the link resource content and the content violates atlassians acceptable use policy.'
    },
    ai_summary_error_hipaa_content_detected: {
        id: 'fabric.linking.ai_summary_error_hipaa_content_detected',
        defaultMessage: 'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content.',
        description: 'Shown when the AI summary is summarising the link resource content and the content contains HIPAA restricted content.'
    },
    ai_summary_error_exceeding_context_length_error: {
        id: 'fabric.linking.ai_summary_error_exceeding_context_length_error',
        defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize.",
        description: 'Shown when the AI summary is summarising the link resource content and the content is too large to summarize.'
    },
    assigned_to: {
        id: 'fabric.linking.assigned_to',
        defaultMessage: 'Assigned to {context}',
        description: 'Indicates the person or entity that the resource is assigned to.'
    },
    automation_action_title: {
        id: 'fabric.linking.automation-action.title',
        defaultMessage: 'View automation rules',
        description: 'The title of the button in a hover card to open an automation menu for a given SmartLink.'
    },
    automation_action_icon_label: {
        id: 'fabric.linking.automation-action.icon.label',
        defaultMessage: 'Automation icon',
        description: 'The label for the automation icon inside of the button opening the automation menu.'
    },
    automation_action_tooltip: {
        id: 'fabric.linking.automation-action.tooltip',
        defaultMessage: 'Select an automation rule to run',
        description: 'The tooltip for the automation action indicating that a button will open an automation modal.'
    },
    automation_action_confluence_page_modal_title: {
        id: 'fabric.linking.automation-action.confluence.page.modal.title',
        defaultMessage: 'Page automations',
        description: 'The title of the automation modal when the SmartLink is a Confluence page'
    },
    automation_action_confluence_page_modal_description: {
        id: 'fabric.linking.automation-action.confluence.page.modal.description',
        defaultMessage: 'Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators.',
        description: 'The description in the automation modal when the SmartLink is a Confluence page. Indicating which page the automation will apply to, and who controls the available automations.'
    },
    cancel: {
        id: 'fabric.linking.cancel',
        defaultMessage: 'Cancel',
        description: 'cancel'
    },
    beta: {
        id: 'fabric.linking.beta',
        defaultMessage: 'Beta',
        description: 'Indicates a beta phase of the feature.'
    },
    cannot_connect: {
        id: 'fabric.linking.cannot_connect',
        defaultMessage: "Can't connect, try again",
        description: 'Error for when a provided link is not found.'
    },
    cannot_find_link: {
        id: 'fabric.linking.cannot_find_link',
        defaultMessage: "Can't find link",
        description: 'Error for when a provided link is not found.'
    },
    click_to_join: {
        id: 'fabric.linking.click_to_join',
        defaultMessage: 'Join {context}',
        description: 'Allows the user join the product or service immediately'
    },
    click_to_join_description: {
        id: 'fabric.linking.click_to_join_description',
        defaultMessage: "You've been approved, so you can join {context} right away.",
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    close: {
        id: 'fabric.linking.close',
        defaultMessage: 'Close',
        description: ''
    },
    check_this_link: {
        id: 'fabric.linking.check_this_link',
        defaultMessage: 'Check this link',
        description: 'Link safety warning modal header'
    },
    compass_applied_components_count: {
        id: 'compass.applied_components_count.non-final',
        defaultMessage: 'Applied to {numberOfComponents, plural, one {{numberOfComponents, number} component}  other {{numberOfComponents, number} components}}'
    },
    connect_to: {
        id: 'fabric.linking.connect_to',
        defaultMessage: 'Connect to {name}',
        description: 'Allows the user to connect with different types of external services'
    },
    connect_account_description: {
        id: 'fabric.linking.connect_account_description',
        defaultMessage: "We'll open a new page to help you connect your {name} account",
        description: 'Explains what will happen when the users connects to a new account'
    },
    connect_link_account: {
        id: 'fabric.linking.connect_link_account',
        defaultMessage: 'Connect to preview',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
    },
    connect_link_account_card: {
        id: 'fabric.linking.connect_link_account_card_view',
        defaultMessage: 'Connect',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_link_account_card_name: {
        id: 'fabric.linking.connect_link_account_card_view_name',
        defaultMessage: 'Connect your {context} account',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    connect_link_account_card_description: {
        id: 'fabric.linking.connect_link_account_card_view_description',
        defaultMessage: 'To show a preview of this link, connect your {context} account.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
    },
    connect_unauthorised_account_action: {
        id: 'fabric.linking.connect_unauthorised_account_action',
        defaultMessage: 'Connect to {context}',
        description: 'Shown on a button to connect user external account to their Atlassian account.'
    },
    connect_unauthorised_account_description: {
        id: 'fabric.linking.connect_unauthorised_account_description',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    continue: {
        id: 'fabric.linking.continue',
        defaultMessage: 'Continue',
        description: 'continue'
    },
    copy_url_to_clipboard: {
        id: 'fabric.linking.copy_url_to_clipboard',
        defaultMessage: 'Copy link',
        description: ''
    },
    copied_url_to_clipboard: {
        id: 'fabric.linking.copied_url_to_clipboard',
        defaultMessage: 'Copied!',
        description: 'Url has been copied to the clipboard'
    },
    could_not_load_link: {
        id: 'fabric.linking.couldnt_load_link',
        defaultMessage: "We couldn't load this link for an unknown reason.",
        description: 'Error case for card view - link could not be loaded.'
    },
    created_by: {
        id: 'fabric.linking.created_by',
        defaultMessage: 'Created by {context}',
        description: 'Indicates the person or entity that created the resource.'
    },
    created_on_relative: {
        id: 'fabric.linking.create_on_relative',
        defaultMessage: 'Created {context}',
        description: 'Indicated when entity was created (relative form)'
    },
    created_on_absolute: {
        id: 'fabric.linking.create_on_absolute',
        defaultMessage: 'Created on {context}',
        description: 'Indicated when entity was created (absolute form)'
    },
    delete: {
        id: 'fabric.linking.delete',
        defaultMessage: 'Delete',
        description: 'Allow a user to delete a link'
    },
    download: {
        id: 'fabric.linking.download',
        defaultMessage: 'Download',
        description: ''
    },
    download_description: {
        id: 'fabric.linking.download_description',
        defaultMessage: 'Download this file into your local storage',
        description: 'Description on what Download does'
    },
    download_file: {
        id: 'fabric.linking.download_file',
        defaultMessage: 'Download file',
        description: 'Allow a user to download a file'
    },
    ai_summary_action: {
        id: 'fabric.linking.ai_summary_action',
        defaultMessage: 'Summarize with AI',
        description: 'Allow a user to summarize a link'
    },
    ai_summary_action_description: {
        id: 'fabric.linking.ai_summary_action_description',
        defaultMessage: 'Summarize the content of this link using Atlassian Intelligence.',
        description: 'Description of what the summarize link with AI action does'
    },
    copy_summary_action: {
        id: 'fabric.linking.copy_summary_action',
        defaultMessage: 'Copy summary',
        description: 'Allow a user to copy a generated summary'
    },
    copy_summary_action_description: {
        id: 'fabric.linking.copy_summary_action_description',
        defaultMessage: 'Copy summary',
        description: 'Description of what the copy summary AI action does'
    },
    copied_summary_action_description: {
        id: 'fabric.linking.copied_summary_action_description',
        defaultMessage: 'Copied summary to clipboard',
        description: 'Confirmation to the user that the summry has been copied'
    },
    edit: {
        id: 'fabric.linking.edit',
        defaultMessage: 'Edit',
        description: 'Allow a user to edit a link'
    },
    follow: {
        id: 'fabric.linking.follow',
        defaultMessage: 'Follow',
        description: 'Click to follow a project.'
    },
    follow_project_description: {
        id: 'fabric.linking.follow_project_description',
        defaultMessage: 'Follow to get notifications on this project',
        description: 'Description on what Follow does'
    },
    follow_project: {
        id: 'fabric.linking.follow_project',
        defaultMessage: 'Follow project',
        description: 'Click to follow a project.'
    },
    follow_project_error: {
        id: 'fabric.linking.follow_project_error',
        defaultMessage: 'We encountered an error while trying to follow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    follow_goal_description: {
        id: 'fabric.linking.follow_goal_description',
        defaultMessage: 'Follow this goal to get notifications on updates',
        description: 'Description on what Follow does'
    },
    follow_goal: {
        id: 'fabric.linking.follow_goal',
        defaultMessage: 'Follow goal',
        description: 'Click to follow a project.'
    },
    follow_goal_error: {
        id: 'fabric.linking.follow_goal_error',
        defaultMessage: 'We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas goal'
    },
    go_back: {
        id: 'fabric.linking.go_back',
        defaultMessage: 'Go back',
        description: 'go back'
    },
    invalid_permissions: {
        id: 'fabric.linking.invalid_permissions',
        defaultMessage: 'Restricted content',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    invalid_permissions_description: {
        id: 'fabric.linking.invalid_permissions_description',
        defaultMessage: "You'll need to request access or try a different account to view this preview.",
        description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
    },
    join_to_view: {
        id: 'fabric.linking.join_to_view',
        defaultMessage: 'Join {context} to view this issue',
        description: 'Allows the user join the product or service immediately'
    },
    learn_more_about_smart_links: {
        id: 'fabric.linking.learn_more_about_smart_links',
        defaultMessage: 'Learn more about Smart Links.',
        description: 'An anchor link to redirect user to a page about Smart Links.'
    },
    learn_more_about_connecting_account: {
        id: 'fabric.linking.learn_more_about_connecting_account',
        defaultMessage: 'Learn more about connecting your account to Atlassian products.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    loading: {
        id: 'fabric.linking.loading',
        defaultMessage: 'Loading...',
        description: 'Indicates an element on a page is loading.'
    },
    modified_by: {
        id: 'fabric.linking.updated_by',
        defaultMessage: 'Modified by {context}',
        description: 'Indicates the person or entity that modified the resource.'
    },
    modified_on_relative: {
        id: 'fabric.linking.modified_on_relative',
        defaultMessage: 'Updated {context}',
        description: 'Indicated when entity was modified (relative form)'
    },
    modified_on_absolute: {
        id: 'fabric.linking.modified_on_absolute',
        defaultMessage: 'Updated on {context}',
        description: 'Indicated when entity was modified (absolute form)'
    },
    more_actions: {
        id: 'fabric.linking.more_actions',
        defaultMessage: 'More actions',
        description: 'Allows the users to see more link actions'
    },
    /**
	 * @deprecated remove when cleaning up FG platform_bandicoots-smart-card-disable-aria
	 */ more_information_about_this_work_item: {
        id: 'fabric.linking.more_information_about_this_work_item',
        defaultMessage: 'More information about this work item',
        description: 'Allows the users to see more about the work item'
    },
    open_issue_in_jira: {
        id: 'fabric.linking.open_issue_in_jira',
        defaultMessage: 'Open issue in Jira',
        description: 'Click to open link in Jira'
    },
    open_link_in_a_new_tab: {
        id: 'fabric.linking.open_link_in_a_new_tab',
        defaultMessage: 'Open link in a new tab',
        description: 'Click to open link in a new tab'
    },
    owned_by: {
        id: 'fabric.linking.owned_by',
        defaultMessage: 'Owned by {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    preview_description: {
        id: 'fabric.linking.preview_description',
        defaultMessage: 'Open a full screen preview of this link',
        description: 'Description on what Preview does'
    },
    preview_improved: {
        id: 'fabric.linking.preview_improved',
        defaultMessage: 'Open preview',
        description: 'Click to view a richer view of your content, without needing to navigate to it.'
    },
    preview_close: {
        id: 'fabric.linking.preview_close',
        defaultMessage: 'Close preview',
        description: 'Click to close embed preview modal.'
    },
    preview_max_size: {
        id: 'fabric.linking.preview_max_size',
        defaultMessage: 'View full screen',
        description: 'Click to increase embed preview modal size to a maximum viewing size.'
    },
    preview_min_size: {
        id: 'fabric.linking.preview_min_size',
        defaultMessage: 'Close full screen',
        description: 'Click to decrease embed preview modal size to a minimum viewing size.'
    },
    priority_blocker: {
        id: 'fabric.linking.priority_blocker',
        defaultMessage: 'Blocker',
        description: 'Indicated priority as blocker'
    },
    priority_critical: {
        id: 'fabric.linking.priority_critical',
        defaultMessage: 'Critical',
        description: 'Indicated priority as critical'
    },
    priority_high: {
        id: 'fabric.linking.priority_high',
        defaultMessage: 'High',
        description: 'Indicated priority as high'
    },
    priority_highest: {
        id: 'fabric.linking.priority_highest',
        defaultMessage: 'Highest',
        description: 'Indicated priority as highest'
    },
    priority_low: {
        id: 'fabric.linking.priority_low',
        defaultMessage: 'Low',
        description: 'Indicated priority as low'
    },
    priority_lowest: {
        id: 'fabric.linking.priority_lowest',
        defaultMessage: 'Lowest',
        description: 'Indicated priority as lowest'
    },
    priority_major: {
        id: 'fabric.linking.priority_major',
        defaultMessage: 'Major',
        description: 'Indicated priority as major'
    },
    priority_medium: {
        id: 'fabric.linking.priority_medium',
        defaultMessage: 'Medium',
        description: 'Indicated priority as medium'
    },
    priority_minor: {
        id: 'fabric.linking.priority_minor',
        defaultMessage: 'Minor',
        description: 'Indicated priority as minor'
    },
    priority_trivial: {
        id: 'fabric.linking.priority_trivial',
        defaultMessage: 'Trivial',
        description: 'Indicated priority as trivial'
    },
    priority_undefined: {
        id: 'fabric.linking.priority_undefined',
        defaultMessage: 'Undefined',
        description: 'Indicated priority as unknown'
    },
    forbidden_access: {
        id: 'fabric.linking.forbidden_access',
        defaultMessage: 'Your access is forbidden',
        description: 'Shown when a user does not have access to a resource behind the link.'
    },
    pending_request: {
        id: 'fabric.linking.pending_request',
        defaultMessage: 'Your access request is pending',
        description: 'Shown when a user has requested an access but status is pending.'
    },
    read_time: {
        id: 'fabric.linking.read_time',
        defaultMessage: '{context} min read',
        description: 'Estimated time to read this resource'
    },
    restricted_link: {
        id: 'fabric.linking.restricted_link',
        defaultMessage: 'Restricted link, try another account',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    request_access_to_view: {
        id: 'fabric.linking.request_access_to_view',
        defaultMessage: 'Request access to {context} to view this issue',
        description: 'Allows the user to request access to a product or service'
    },
    request_denied: {
        id: 'fabric.linking.request_denied',
        defaultMessage: 'Your access request was denied',
        description: 'The user had request access but the request was denied by a product or service'
    },
    retry: {
        id: 'fabric.linking.retry',
        defaultMessage: 'Retry',
        description: 'Allows user to perform an action again'
    },
    save: {
        id: 'fabric.linking.save',
        defaultMessage: 'Save',
        description: 'Just the "save" word'
    },
    sent_on_relative: {
        id: 'fabric.linking.sent_on_relative',
        defaultMessage: 'Sent {context}',
        description: 'Indicated when entity was sent (relative form)'
    },
    sent_on_absolute: {
        id: 'fabric.linking.sent_on_absolute',
        defaultMessage: 'Sent on {context}',
        description: 'Indicated when entity was sent (absolute form)'
    },
    status_change_load_error: {
        id: 'fabric.linking.status_change_load_error',
        defaultMessage: "We couldn\u2019t load the statuses and transitions",
        description: 'Informs the user that the loading of status transitions failed'
    },
    status_change_permission_error: {
        id: 'fabric.linking.status_change_permission_error',
        defaultMessage: "You don\u2019t have permission to transition this issue. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    status_change_update_error: {
        id: 'fabric.linking.status_change_update_error',
        defaultMessage: "We couldn\u2019t update the status",
        description: "Occurs when a user tries to update an issue's status but fails to do so"
    },
    try_again: {
        id: 'fabric.linking.try_again',
        defaultMessage: 'Try again',
        description: 'Allow the user to try an action again'
    },
    try_another_account: {
        id: 'fabric.linking.try_another_account',
        defaultMessage: 'Try another account',
        description: 'Allows the user to try an action again with a different account'
    },
    link_safety_warning_message: {
        id: 'fabric.linking.link_safety_warning_message',
        defaultMessage: 'The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>',
        description: 'Link safety check warning message'
    },
    unauthorised_account_description: {
        id: 'fabric.linking.unauthorised_account_description',
        defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_description_no_provider: {
        id: 'fabric.linking.unauthorised_account_description_no_provider',
        defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_name: {
        id: 'fabric.linking.unauthorised_account_name',
        defaultMessage: "We can't display private pages from {context}",
        description: 'Shown when a user does not have access to a link.'
    },
    unauthorised_account_name_no_provider: {
        id: 'fabric.linking.unauthorised_account_name_no_provider',
        defaultMessage: "We can't display private pages",
        description: 'Shown when a user does not have access to a link.'
    },
    unassigned: {
        id: 'fabric.linking.unassigned',
        defaultMessage: 'Unassigned',
        description: 'Shown as a tooltip text for a default unassigned fallback avatar'
    },
    unfollow: {
        id: 'fabric.linking.unfollow',
        defaultMessage: 'Unfollow',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_description: {
        id: 'fabric.linking.unfollow_project_description',
        defaultMessage: 'Unfollow to stop receiving project notifications',
        description: 'Description on what Unfollow does'
    },
    unfollow_project: {
        id: 'fabric.linking.unfollow_project',
        defaultMessage: 'Unfollow project',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_error: {
        id: 'fabric.linking.unfollow_project_error',
        defaultMessage: 'We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    unfollow_goal_description: {
        id: 'fabric.linking.unfollow_goal_description',
        defaultMessage: 'Unfollow to stop receiving notifications for this goal',
        description: 'Description on what Unfollow does'
    },
    unfollow_goal: {
        id: 'fabric.linking.unfollow_goal',
        defaultMessage: 'Unfollow goal',
        description: 'Click to unfollow a project.'
    },
    unfollow_goal_error: {
        id: 'fabric.linking.unfollow_goal_error',
        defaultMessage: 'We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas goal'
    },
    unlink_account: {
        id: 'fabric.linking.unlink_account',
        defaultMessage: 'Unlink Account',
        description: 'Allows to remove a connected account from the user'
    },
    view: {
        id: 'fabric.linking.view',
        defaultMessage: 'View',
        description: 'Go through to a piece of content to view it in its original context.'
    },
    viewIn: {
        id: 'fabric.linking.srclink',
        defaultMessage: 'View in',
        description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
    },
    viewOriginal: {
        id: 'fabric.linking.srclinkunknown',
        defaultMessage: 'View Original',
        description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
    },
    default_no_access_title: {
        id: 'fabric.linking.no_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they dont have access to certain content'
    },
    direct_access_title: {
        id: 'fabric.linking.direct_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access_description: {
        id: 'fabric.linking.direct_access_description',
        defaultMessage: 'Your team uses {product} to collaborate and you can start using it right away!',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access: {
        id: 'fabric.linking.direct_access',
        defaultMessage: 'Join now',
        description: 'Allows the user join the product or service immediately'
    },
    request_access_description: {
        id: 'fabric.linking.request_access_description',
        defaultMessage: 'Your team uses {product} to collaborate. Send your admin a request for access.',
        description: 'Informs the user to request access to a product by talking to the website administrator'
    },
    request_access: {
        id: 'fabric.linking.request_access',
        defaultMessage: 'Request access',
        description: 'Allows the user to request access to a product or service'
    },
    request_access_pending_title: {
        id: 'fabric.linking.request_access_pending_title',
        defaultMessage: 'Access to {product} is pending',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_access_pending_description: {
        id: 'fabric.linking.request_access_pending_description',
        defaultMessage: 'Your request to access {hostname} is awaiting admin approval.',
        description: 'Informs the user that their request to view this content is pending website administrator approval'
    },
    request_access_pending: {
        id: 'fabric.linking.request_access_pending',
        defaultMessage: 'Pending approval',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_denied_description: {
        id: 'fabric.linking.request_denied_description',
        defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}.",
        description: 'Informs the user that their request to view this content was denied'
    },
    access_exists_description: {
        id: 'fabric.linking.access_exists_description',
        defaultMessage: 'Request access to view this content from {hostname}.',
        description: 'Informs the user to contact the website administrator to request access to a product'
    },
    not_found_description: {
        id: 'fabric.linking.not_found_description',
        defaultMessage: "The page doesn't exist or it may have changed after this link was added.",
        description: 'Error case for when a provided item is not found within the list of items'
    },
    not_found_title: {
        id: 'fabric.linking.not_found_title',
        defaultMessage: "We can't show you this {product} page",
        description: 'Error case for when a provided link is not found'
    },
    forbidden_title: {
        id: 'fabric.linking.forbidden_title',
        defaultMessage: "You don't have access to this content",
        description: 'Informs the user that they do not have access to the linked content.'
    },
    forbidden_description: {
        id: 'fabric.linking.forbidden_description',
        defaultMessage: 'Contact your admin to request access to {hostname}.',
        description: 'Informs the user that they must contact the site administrator for access.'
    },
    related: {
        id: 'fabric.linking.related',
        defaultMessage: 'Related',
        description: 'Informs the user about related resources'
    },
    generic_error_message: {
        id: 'fabric.linking.generic_error_message',
        defaultMessage: 'An error occurred',
        description: 'A generic error message to the user'
    },
    related_links_modal_title: {
        id: 'fabric.linking.related_links_modal_title',
        defaultMessage: 'Recent links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_modal_title_v2: {
        id: 'fabric.linking.related_links_modal_title_v2',
        defaultMessage: 'Related links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_view_related_urls: {
        id: 'fabric.linking.related_links_view_related_urls',
        defaultMessage: 'View recent links',
        description: 'Action to view related links to the given resource'
    },
    related_links_view_related_links: {
        id: 'fabric.linking.related_links_view_related_links',
        defaultMessage: 'View related links',
        description: 'Action to view related links to the given resource'
    },
    related_links_found_in: {
        id: 'fabric.linking.related_links_found_in',
        defaultMessage: 'Found In',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_found_in_v2: {
        id: 'fabric.linking.related_links_found_in_v2',
        defaultMessage: 'Found in',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_not_found: {
        id: 'fabric.linking.related_links_not_found',
        defaultMessage: "We didn't find any links to show here.",
        description: 'Informs the user that there are no related resources for the given url'
    },
    related_links_includes_links_to: {
        id: 'fabric.linking.related_links_includes_links_to',
        defaultMessage: 'Includes Links To',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_includes_links_to_v2: {
        id: 'fabric.linking.related_links_includes_links_to_v2',
        defaultMessage: 'Includes links to',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_modal_error_header: {
        id: 'fabric.linking.related_links_modal_error_header',
        defaultMessage: 'Something went wrong',
        description: 'Title for related links error'
    },
    related_links_modal_error_title: {
        id: 'fabric.linking.related_links_modal_error_title',
        defaultMessage: `We're having trouble loading related links`,
        description: 'Title for related links error'
    },
    related_links_modal_unavailable_title: {
        id: 'fabric.linking.related_links_modal_unavailable_title',
        defaultMessage: `We couldn't find any related links`,
        description: 'Title for related links error'
    },
    related_links_modal_error_message: {
        id: 'fabric.linking.related_links_modal_error_message',
        defaultMessage: 'We ran into an issue trying to load recent links. Check your connection or refresh to try again.',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_error_description: {
        id: 'fabric.linking.related_links_modal_error_description',
        defaultMessage: 'Check your connection or refresh the page to try again',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_description: {
        id: 'fabric.linking.related_links_modal_unavailable_description',
        defaultMessage: 'We continuously review and add related links for updated pages or other content types',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_header: {
        id: 'fabric.linking.related_links_modal_unavailable_header',
        defaultMessage: 'No recent links',
        description: 'Title for related links being unavailable'
    },
    related_links_modal_unavailable_message: {
        id: 'fabric.linking.related_links_modal_unavailable_message',
        defaultMessage: "We didn't find any links to show here. We continuously review and add recent links for updated pages or other content types.",
        description: 'Informs the user that related links were not found but may be available in the future'
    },
    join_to_viewIssueTermRefresh: {
        id: 'fabric.linking.join_to_view-issue-term-refresh',
        defaultMessage: 'Join {context} to view this work item',
        description: 'Allows the user join the product or service immediately'
    },
    open_issue_in_jiraIssueTermRefresh: {
        id: 'fabric.linking.open_issue_in_jira-issue-term-refresh',
        defaultMessage: 'Open work item in Jira',
        description: 'Click to open link in Jira'
    },
    request_access_to_viewIssueTermRefresh: {
        id: 'fabric.linking.request_access_to_view-issue-term-refresh',
        defaultMessage: 'Request access to {context} to view this work item',
        description: 'Allows the user to request access to a product or service'
    },
    status_change_permission_errorIssueTermRefresh: {
        id: 'fabric.linking.status_change_permission_error-issue-term-refresh',
        defaultMessage: "You don\u2019t have permission to transition this work item. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    }
});

});

parcelRegister("iG1Aw", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e7eab4f33cc1929$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $hg3n9 = parcelRequire("hg3n9");
const $4e7eab4f33cc1929$var$AppliedToComponentsCountElement = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const context = (0, $VSDnB.fg)('platform-linking-flexible-card-context') ? (0, $Nh1XU.useFlexibleUiContext)() : (0, $5uXOq.useContext)((0, $Nh1XU.FlexibleUiContext));
    if (// Check for null and undefined, render if it's 0.
    context?.appliedToComponentsCount === null || context?.appliedToComponentsCount === undefined) return null;
    const label = formatMessage((0, $7zaVw.messages).compass_applied_components_count, {
        numberOfComponents: context.appliedToComponentsCount
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hg3n9.default), {
        icon: (0, $8dVIb.IconType).Component,
        label: label,
        ...props
    });
};
var $4e7eab4f33cc1929$export$2e2bcd8739ae039 = $4e7eab4f33cc1929$var$AppliedToComponentsCountElement;

});
parcelRegister("hg3n9", function(module, exports) {

$parcel$export(module.exports, "default", () => $13d6ce54266be73c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $h5UrH = parcelRequire("h5UrH");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $9Hdrc = parcelRequire("9Hdrc");

var $l5Xsv = parcelRequire("l5Xsv");

var $3dubP = parcelRequire("3dubP");

var $fpDmE = parcelRequire("fpDmE");
const $13d6ce54266be73c$var$styles = {
    container: "_zulp1b66 _1e0c116y _4cvr1h6o _1ul91ns9",
    icon: "_1e0c116y _v4pn116y _1b94116y _1ii7116y _4t3i7vkz _bna77vkz _1xjx7vkz _17527vkz _ca0qze3t _14bqze3t _1oh2ze3t _i2i3ze3t _u5f3ze3t _3tceze3t _99ztze3t _uhasze3t _n3tdze3t _1ym6ze3t _1m2uze3t _5jw9ze3t _19bvze3t _1xr1ze3t _9n9oze3t _7wy9ze3t _1bsb7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _s7n4nkob _rtqbnkob _e4kmnkob _z239nkob",
    text: "_11c81o8v"
};
const $13d6ce54266be73c$var$colorMap = {
    subtle: "_syaz131l",
    default: "_syaz1gjq"
};
const $13d6ce54266be73c$var$badgeStyles = null;
const $13d6ce54266be73c$var$iconStyles = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $13d6ce54266be73c$var$labelStylesOld = null;
const $13d6ce54266be73c$var$messageMapper = {
    [(0, $8dVIb.IconType).PriorityBlocker]: (0, $7zaVw.messages).priority_blocker,
    [(0, $8dVIb.IconType).PriorityCritical]: (0, $7zaVw.messages).priority_critical,
    [(0, $8dVIb.IconType).PriorityHigh]: (0, $7zaVw.messages).priority_high,
    [(0, $8dVIb.IconType).PriorityHighest]: (0, $7zaVw.messages).priority_highest,
    [(0, $8dVIb.IconType).PriorityLow]: (0, $7zaVw.messages).priority_low,
    [(0, $8dVIb.IconType).PriorityLowest]: (0, $7zaVw.messages).priority_lowest,
    [(0, $8dVIb.IconType).PriorityMajor]: (0, $7zaVw.messages).priority_major,
    [(0, $8dVIb.IconType).PriorityMedium]: (0, $7zaVw.messages).priority_medium,
    [(0, $8dVIb.IconType).PriorityMinor]: (0, $7zaVw.messages).priority_minor,
    [(0, $8dVIb.IconType).PriorityTrivial]: (0, $7zaVw.messages).priority_trivial,
    [(0, $8dVIb.IconType).PriorityUndefined]: (0, $7zaVw.messages).priority_undefined
};
const $13d6ce54266be73c$var$getFormattedMessageFromIcon = (icon)=>{
    if (icon) {
        const descriptor = $13d6ce54266be73c$var$messageMapper[icon];
        if (descriptor) return (0, $fpDmE.getFormattedMessage)({
            descriptor: descriptor
        });
    }
};
const $13d6ce54266be73c$var$renderAtlaskitIcon = (icon, testId)=>{
    if (icon) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Hdrc.default), {
        icon: icon,
        label: icon,
        testId: `${testId}-icon`
    });
};
const $13d6ce54266be73c$var$renderImageIcon = (url, testId)=>{
    if (url) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l5Xsv.default), {
        testId: testId,
        url: url
    });
};
/**
 * A base element that displays some text with an associated icon.
 * @internal
 * @param {BaseBadgeElementProps} BaseBadgeElementProps - The props necessary for the Badge.
 * @see CommentCount
 * @see ViewCount
 * @see ReactCount
 * @see VoteCount
 * @see SubscriberCount
 * @see Priority
 * @see ProgrammingLanguage
 * @see Provider
 */ const $13d6ce54266be73c$var$BaseBadgeRefreshNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ appearance: appearance = 'default', hideIcon: hideIcon = false, icon: icon, label: label, name: name, testId: testId = 'smart-element-badge', url: url, color: color }, ref)=>{
    const formattedMessageOrLabel = $13d6ce54266be73c$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $13d6ce54266be73c$var$renderAtlaskitIcon(icon, testId) || $13d6ce54266be73c$var$renderImageIcon(url, testId);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId,
        ref: ref,
        style: {
            color: color && (0, $VSDnB.fg)('platform-linking-additional-flexible-element-props') ? color : undefined
        },
        className: (0, $bwpsq.default)([
            $13d6ce54266be73c$var$styles.container,
            $13d6ce54266be73c$var$colorMap[appearance]
        ]),
        children: [
            !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                as: "span",
                xcss: $13d6ce54266be73c$var$styles.icon,
                children: badgeIcon
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                as: "span",
                testId: `${testId}-label`,
                xcss: $13d6ce54266be73c$var$styles.text,
                children: formattedMessageOrLabel
            })
        ]
    });
});
// On cleanup of platform-linking-visual-refresh-v1, this should become
// export default withOverrideCss(BaseBadgeElement);
const $13d6ce54266be73c$var$BaseBadgeElementRefreshNewWithOverrideCss = (0, $3dubP.withOverrideCss)($13d6ce54266be73c$var$BaseBadgeRefreshNew);
/**
 * A base element that displays some text with an associated icon.
 * @internal
 * @param {BadgeProps} BadgeProps - The props necessary for the Badge.
 * @see CommentCount
 * @see ViewCount
 * @see ReactCount
 * @see VoteCount
 * @see SubscriberCount
 * @see Priority
 * @see ProgrammingLanguage
 * @see Provider
 */ const $13d6ce54266be73c$var$BaseBadgeElementCompiledNew = ({ hideIcon: hideIcon = false, icon: icon, label: label, name: name, className: className, testId: testId = 'smart-element-badge', url: url })=>{
    const formattedMessageOrLabel = $13d6ce54266be73c$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $13d6ce54266be73c$var$renderAtlaskitIcon(icon, testId) || $13d6ce54266be73c$var$renderImageIcon(url, testId);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _1e0c116y _1ul91ns9",
            className
        ]),
        children: [
            !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    "_16jlidpf _1o9zidpf _i0dl1wug _syaz1oju _vwz4idpf _s7n4nkob _4t3i1j6v _1tke1j6v _c71l1j6v _1bsb1j6v _1ul91j6v _p12f1j6v _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71j6v _1xjx1j6v _17521j6v _qci81j6v _15iz1j6v _erub1j6v _19l31j6v _1pr21j6v _1u5t1j6v _mezj1j6v _e2oo1j6v _w8l51j6v _1rg21j6v _q7cv1j6v _xwbj1j6v _rtys1j6v _b8nk1j6v _4x201j6v _1jtnidpf _13t3idpf _rm9uidpf _rtqbnkob _e4kmnkob _z239nkob"
                ]),
                children: badgeIcon
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                "data-testid": `${testId}-label`,
                className: (0, $bwpsq.default)([
                    "_11c8dcr7 _syaz131l _19bv1xvx _s7n4nkob"
                ]),
                children: formattedMessageOrLabel
            })
        ]
    });
};
var $13d6ce54266be73c$export$2e2bcd8739ae039 = (0, $h5UrH.withFeatureFlaggedComponent)($13d6ce54266be73c$var$BaseBadgeElementCompiledNew, $13d6ce54266be73c$var$BaseBadgeElementRefreshNewWithOverrideCss, ()=>(0, $VSDnB.fg)('platform-linking-visual-refresh-v1'));

});
parcelRegister("h5UrH", function(module, exports) {

$parcel$export(module.exports, "withFeatureFlaggedComponent", () => $080bc03d046ff7bd$export$55dba0d8ccf3da86);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $080bc03d046ff7bd$export$55dba0d8ccf3da86 = (ComponentOld, ComponentNext, featureFlagFn)=>{
    return (props)=>{
        // copied from packages/editor/editor-common/src/utils/withFeatureFlaggedComponent.tsx
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return featureFlagFn() ? /*#__PURE__*/ (0, $2OMIu.jsx)(ComponentNext, {
            ...props
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)(ComponentOld, {
            ...props
        });
    };
};

});

parcelRegister("9Hdrc", function(module, exports) {

$parcel$export(module.exports, "default", () => $1647af7fe5459c6c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4qBtX = parcelRequire("4qBtX");

var $7anl7 = parcelRequire("7anl7");
var $29YN9 = parcelRequire("29YN9");

var $dVpJZ = parcelRequire("dVpJZ");

var $e1vlu = parcelRequire("e1vlu");

var $94rku = parcelRequire("94rku");

var $8dVIb = parcelRequire("8dVIb");

var $kxcRq = parcelRequire("kxcRq");
const $1647af7fe5459c6c$var$getIconImportFn = (icon, size)=>{
    const item = (0, $kxcRq.getLazyIcons)()[icon];
    if ((0, $kxcRq.isIconSizeLarge)(size) && item?.large) return item.large;
    return item?.default;
};
const $1647af7fe5459c6c$var$importIcon = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $1647af7fe5459c6c$var$AtlaskitIcon = ({ icon: icon, label: label, testId: testId, size: size = (0, $8dVIb.SmartLinkSize).Medium })=>{
    // Check for synchonously loaded icons first for SSR purposes
    switch(icon){
        case (0, $8dVIb.IconType).Document:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $94rku.default), {
                label: label ?? 'document',
                testId: testId,
                size: size
            });
        case (0, $8dVIb.IconType).Blog:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dVpJZ.default), {
                label: label ?? 'blog',
                testId: testId,
                size: size
            });
        case (0, $8dVIb.IconType).LiveDocument:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e1vlu.default), {
                label: label ?? 'live-doc',
                testId: testId,
                size: size
            });
    }
    const importFn = $1647af7fe5459c6c$var$getIconImportFn(icon, size);
    if (!importFn) return null;
    const ImportedIcon = $1647af7fe5459c6c$var$importIcon(importFn);
    switch(icon){
        case (0, $8dVIb.IconType).Confluence:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7anl7.ConfluenceIcon), {
                appearance: "brand",
                testId: testId,
                size: size === (0, $8dVIb.SmartLinkSize).Large || size === (0, $8dVIb.SmartLinkSize).XLarge ? 'small' : 'xxsmall'
            });
        case (0, $8dVIb.IconType).Jira:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $29YN9.JiraIcon), {
                appearance: "brand",
                testId: testId,
                size: size === (0, $8dVIb.SmartLinkSize).Large || size === (0, $8dVIb.SmartLinkSize).XLarge ? 'small' : 'xxsmall'
            });
        case (0, $8dVIb.IconType).Error:
        case (0, $8dVIb.IconType).Forbidden:
            return /*#__PURE__*/ (0, $2OMIu.jsx)(ImportedIcon, {
                label: label,
                testId: testId,
                LEGACY_size: size === (0, $8dVIb.SmartLinkSize).Large || size === (0, $8dVIb.SmartLinkSize).XLarge ? 'medium' : 'small',
                color: "var(--ds-icon-danger, #C9372C)"
            });
        default:
            return /*#__PURE__*/ (0, $2OMIu.jsx)(ImportedIcon, {
                label: label,
                testId: testId,
                LEGACY_size: size === (0, $8dVIb.SmartLinkSize).Large || size === (0, $8dVIb.SmartLinkSize).XLarge ? 'medium' : 'small',
                size: size
            });
    }
};
var $1647af7fe5459c6c$export$2e2bcd8739ae039 = $1647af7fe5459c6c$var$AtlaskitIcon;

});
parcelRegister("e1vlu", function(module, exports) {

$parcel$export(module.exports, "default", () => $df3c19aa4679ee0a$export$2e2bcd8739ae039);

var $4Atwu = parcelRequire("4Atwu");

var $8lQ8Y = parcelRequire("8lQ8Y");

var $50H21 = parcelRequire("50H21");
const $df3c19aa4679ee0a$var$LiveDocumentIconWithColor = (0, $50H21.renderIconPerSize)((0, $4Atwu.default), (0, $8lQ8Y.default));
$df3c19aa4679ee0a$var$LiveDocumentIconWithColor.displayName = 'LiveDocumentIconWithColor';
var $df3c19aa4679ee0a$export$2e2bcd8739ae039 = $df3c19aa4679ee0a$var$LiveDocumentIconWithColor;

});


parcelRegister("l5Xsv", function(module, exports) {

$parcel$export(module.exports, "default", () => $951590e808a48e01$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bmnhy = parcelRequire("bmnhy");

var $VSDnB = parcelRequire("VSDnB");

var $gU02S = parcelRequire("gU02S");
const $951590e808a48e01$var$styles = {
    roundImg: "_2rko14q2"
};
const $951590e808a48e01$var$ImageIcon = ({ defaultIcon: defaultIcon, testId: testId, url: url, width: width, height: height, appearance: appearance = 'square', onError: onError, onLoad: onLoad })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bmnhy))), {
        src: url,
        loading: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU02S.LoadingSkeleton), {
            testId: `${testId}-loading`,
            width: width,
            height: height
        }),
        loaded: /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
            src: url,
            "data-testid": `${testId}-image`,
            alt: "",
            style: {
                width: width,
                height: height
            },
            className: (0, $bwpsq.default)([
                appearance === 'round' && (0, $VSDnB.fg)('platform-linking-visual-refresh-v2') && $951590e808a48e01$var$styles.roundImg
            ])
        }),
        errored: defaultIcon,
        onError: onError,
        onLoad: onLoad
    });
var $951590e808a48e01$export$2e2bcd8739ae039 = $951590e808a48e01$var$ImageIcon;

});
parcelRegister("bmnhy", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $8453cf1ee7ef4644$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $5uXOq = parcelRequire("5uXOq");
var $8453cf1ee7ef4644$var$React = $8453cf1ee7ef4644$var$_interopRequireWildcard($5uXOq);
function $8453cf1ee7ef4644$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $8453cf1ee7ef4644$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8453cf1ee7ef4644$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $8453cf1ee7ef4644$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $8453cf1ee7ef4644$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $8453cf1ee7ef4644$var$loaded() {
    return {
        isLoaded: true
    };
}
function $8453cf1ee7ef4644$var$errored() {
    return {
        isErrored: true
    };
}
function $8453cf1ee7ef4644$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $8453cf1ee7ef4644$var$ImageRenderer = function(_React$Component) {
    $8453cf1ee7ef4644$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $8453cf1ee7ef4644$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $8453cf1ee7ef4644$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($8453cf1ee7ef4644$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($8453cf1ee7ef4644$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $8453cf1ee7ef4644$var$_possibleConstructorReturn(_this, _ret);
    }
    $8453cf1ee7ef4644$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($8453cf1ee7ef4644$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($8453cf1ee7ef4644$var$hasPropsChanged(this.props, nextProps)) this.setState($8453cf1ee7ef4644$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($8453cf1ee7ef4644$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($8453cf1ee7ef4644$var$React.Component);
module.exports.default = $8453cf1ee7ef4644$var$ImageRenderer;

});

parcelRegister("gU02S", function(module, exports) {

$parcel$export(module.exports, "LoadingSkeleton", () => $880176eb12ae8419$export$44c18d210d5de37b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $880176eb12ae8419$var$animationNameStyles = null;
const $880176eb12ae8419$var$loadingSkeletonStyle = null;
const $880176eb12ae8419$export$44c18d210d5de37b = ({ testId: testId, width: width, height: height })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId,
        style: {
            width: width,
            height: height
        },
        className: (0, $bwpsq.default)([
            "_2rkoyh40 _uiztglyw _bfhk178v _1itk1bc0 _12vemgnk _1lrw6rms _1e0c1o8l _5sag9cwz _1o51q7pw _tip812c5 _j7hqqkar _1pglp3kn"
        ])
    });
};

});


parcelRegister("3dubP", function(module, exports) {

$parcel$export(module.exports, "withOverrideCss", () => $9f9aac8ddfd1f0ad$export$e0bdcacb944f1da6);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $9f9aac8ddfd1f0ad$export$e0bdcacb944f1da6(Component) {
    return (props)=>{
        const ref = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (props?.className && ref.current) ref.current.className = `${ref.current.className} ${props.className}`;
        }, [
            props?.className
        ]);
        return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
            ...props,
            ref: ref
        });
    };
}

});

parcelRegister("fpDmE", function(module, exports) {

$parcel$export(module.exports, "sizeToButtonSpacing", () => $3ebf94f205ad0182$export$9d642f65a919fb93);
$parcel$export(module.exports, "getFormattedMessage", () => $3ebf94f205ad0182$export$f1aa79f2218fb713);
$parcel$export(module.exports, "getFormattedMessageAsString", () => $3ebf94f205ad0182$export$66ecb50a9dd1768);
$parcel$export(module.exports, "getIconWidth", () => $3ebf94f205ad0182$export$fb10bc5609c6347e);
$parcel$export(module.exports, "importIcon", () => $3ebf94f205ad0182$export$6dc831e1a0a7a851);
$parcel$export(module.exports, "getMaxLines", () => $3ebf94f205ad0182$export$c2293adf1794c09);
$parcel$export(module.exports, "getPrimitivesInlineSpaceBySize", () => $3ebf94f205ad0182$export$475c391af8171fec);
$parcel$export(module.exports, "hasWhiteSpace", () => $3ebf94f205ad0182$export$619e376a425cb759);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $4qBtX = parcelRequire("4qBtX");

var $8dVIb = parcelRequire("8dVIb");
const $3ebf94f205ad0182$export$9d642f65a919fb93 = {
    [(0, $8dVIb.SmartLinkSize).Small]: 'none',
    [(0, $8dVIb.SmartLinkSize).Medium]: 'compact',
    [(0, $8dVIb.SmartLinkSize).Large]: 'compact',
    [(0, $8dVIb.SmartLinkSize).XLarge]: 'default'
};
const $3ebf94f205ad0182$export$f1aa79f2218fb713 = (message)=>{
    if (message) {
        const { descriptor: descriptor, values: values } = message;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...descriptor,
            values: values
        });
    }
};
const $3ebf94f205ad0182$export$66ecb50a9dd1768 = (intl, message, context)=>{
    const { formatMessage: formatMessage } = intl;
    return message ? formatMessage(message, {
        context: context
    }) : '';
};
const $3ebf94f205ad0182$export$fb10bc5609c6347e = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
        case (0, $8dVIb.SmartLinkSize).Large:
            return "var(--ds-space-300, 24px)";
        case (0, $8dVIb.SmartLinkSize).Medium:
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return "var(--ds-space-200, 16px)";
    }
};
const $3ebf94f205ad0182$export$6dc831e1a0a7a851 = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $3ebf94f205ad0182$export$a681bd062fee88a5 = (size)=>{
    // The maximum line height based on all elements in specific size.
    // These heights belongs to AvatarGroup.
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
        case (0, $8dVIb.SmartLinkSize).Large:
            return 1.75;
        case (0, $8dVIb.SmartLinkSize).Medium:
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return 1.5;
    }
};
const $3ebf94f205ad0182$export$c2293adf1794c09 = (value, defaultValue, max, min)=>{
    if (value > max) return defaultValue;
    if (value < min) return min;
    return value;
};
const $3ebf94f205ad0182$export$475c391af8171fec = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return 'space.250';
        case (0, $8dVIb.SmartLinkSize).Large:
            return 'space.200';
        case (0, $8dVIb.SmartLinkSize).Medium:
            return 'space.100';
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return 'space.050';
    }
};
const $3ebf94f205ad0182$export$619e376a425cb759 = (str)=>{
    return str.search(/\s/) >= 0;
};

});



parcelRegister("hCl3E", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c065edb88142747$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $16T6Y = parcelRequire("16T6Y");

var $VSDnB = parcelRequire("VSDnB");
const $9c065edb88142747$var$badgeStylesOld = null;
const $9c065edb88142747$var$badgeStyles = null;
/**
 * A base element that displays a visual indicator for a numeric value
 * @internal
 * @see StoryPoints
 * */ const $9c065edb88142747$var$AtlaskitElementBadge = ({ value: value, name: name, className: className, testId: testId = 'smart-element-atlaskit-badge' })=>{
    if (!value) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-atlaskit-badge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_4cvr1h6o _1e0c116y",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_4cvr1h6o _1e0c116y _1ul91ns9",
            className
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $16T6Y.default), {
            children: value
        })
    });
};
var $9c065edb88142747$export$2e2bcd8739ae039 = $9c065edb88142747$var$AtlaskitElementBadge;

});

parcelRegister("8JkyP", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e642c27a7b9b549$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $jnhNB = parcelRequire("jnhNB");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $fpDmE = parcelRequire("fpDmE");
const $6e642c27a7b9b549$var$styles = null;
const $6e642c27a7b9b549$var$stylesMap = {
    xlarge: "_1e0c116y _1kvxu2gc _102oidpf",
    large: "_1e0c116y _1kvxu2gc _102oidpf",
    medium: "_1e0c116y _1kvxu2gc _102oidpf _6fu61k92 _1rrq1k92 _udwj1k92 _10pr1k92",
    small: "_1e0c116y _1kvxu2gc _102oidpf _6fu61k92 _1rrq1k92 _udwj1k92 _10pr1k92"
};
const $6e642c27a7b9b549$var$getPersonNameWithPrefix = (elementName, personName, intl)=>{
    switch(elementName){
        case (0, $8dVIb.ElementName).AssignedToGroup:
            return (0, $fpDmE.getFormattedMessageAsString)(intl, (0, $7zaVw.messages).assigned_to, personName);
        case (0, $8dVIb.ElementName).OwnedByGroup:
            return (0, $fpDmE.getFormattedMessageAsString)(intl, (0, $7zaVw.messages).owned_by, personName);
        case (0, $8dVIb.ElementName).AuthorGroup:
            return (0, $fpDmE.getFormattedMessageAsString)(intl, (0, $7zaVw.messages).created_by, personName);
        default:
            return personName;
    }
};
/**
 * A base element that displays a group of avatars.
 * @internal
 * @param {BaseAvatarGroupElementProps} BaseAvatarGroupElementProps - The props necessary for the AvatarGroup.
 * @see AuthorGroup
 * @see CollaboratorGroup
 */ const $6e642c27a7b9b549$var$BaseAvatarGroup = ({ items: items = [], maxCount: maxCount = 4, name: name, className: className, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-element-avatar-group', showNamePrefix: showNamePrefix = false, showFallbackAvatar: showFallbackAvatar = true })=>{
    const intl = (0, $koVbs.default)();
    const data = (0, $5uXOq.useMemo)(()=>{
        if (!items.length && showFallbackAvatar) switch(name){
            case (0, $8dVIb.ElementName).AssignedToGroup:
                return [
                    {
                        name: (0, $fpDmE.getFormattedMessageAsString)(intl, (0, $7zaVw.messages).unassigned)
                    }
                ];
            default:
                return [];
        }
        //show a name prefix if there is one Avatar in a group only
        if (name && items.length === 1 && showNamePrefix) return items.map((person)=>{
            return {
                ...person,
                name: $6e642c27a7b9b549$var$getPersonNameWithPrefix(name, person.name, intl) || person.name
            };
        });
        return items;
    }, [
        name,
        items,
        showNamePrefix,
        showFallbackAvatar,
        intl
    ]);
    if (!data.length) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-avatar-group": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $6e642c27a7b9b549$var$stylesMap[size],
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1ul91ns9",
            className
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jnhNB.default), {
            maxCount: maxCount,
            appearance: "stack",
            size: "small",
            data: data,
            testId: testId
        })
    });
};
var $6e642c27a7b9b549$export$2e2bcd8739ae039 = $6e642c27a7b9b549$var$BaseAvatarGroup;

});

parcelRegister("hMRm5", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ff906df4a1f5956$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $j7anB = parcelRequire("j7anB");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $VSDnB = parcelRequire("VSDnB");

var $7zaVw = parcelRequire("7zaVw");
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $4ff906df4a1f5956$var$stylesOld = null;
const $4ff906df4a1f5956$var$styles = null;
const $4ff906df4a1f5956$var$typeToDescriptorMap = {
    created: {
        relative: (0, $7zaVw.messages).created_on_relative,
        absolute: (0, $7zaVw.messages).created_on_absolute
    },
    modified: {
        relative: (0, $7zaVw.messages).modified_on_relative,
        absolute: (0, $7zaVw.messages).modified_on_absolute
    },
    sent: {
        relative: (0, $7zaVw.messages).sent_on_relative,
        absolute: (0, $7zaVw.messages).sent_on_absolute
    }
};
/**
 * A base element that displays an ISO Timestamp in text.
 * @internal
 * @param {BaseDateTimeProps} BaseDateTimeProps - The props necessary for the DateTime element.
 * @see CreatedOn
 * @see ModifiedOn
 * @see SentOn
 */ const $4ff906df4a1f5956$var$BaseDateTimeElement = ({ date: date, name: name, className: className, type: type, testId: testId = 'smart-element-date-time', text: text, hideDatePrefix: hideDatePrefix = false, color: color })=>{
    const { formatRelativeTime: formatRelativeTime, formatDate: formatDate } = (0, $koVbs.default)();
    if (!type || !date) return null;
    const isLongerThenWeek = Math.abs(date.getTime() - Date.now()) > 604800000;
    let context;
    let typeVariant;
    if (isLongerThenWeek) {
        typeVariant = 'absolute';
        context = formatDate(date, {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    } else {
        const { value: value, unit: unit } = (0, $j7anB.selectUnit)(date, Date.now());
        typeVariant = 'relative';
        context = formatRelativeTime(value, unit, {
            numeric: 'auto'
        });
    }
    let content;
    if (hideDatePrefix && (0, $VSDnB.fg)('platform-linking-additional-flexible-element-props')) content = context;
    else if (text) content = `${text} ${context}`;
    else content = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...$4ff906df4a1f5956$var$typeToDescriptorMap[type][typeVariant],
        values: {
            context: context
        }
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        style: {
            color: color && (0, $VSDnB.fg)('platform-linking-additional-flexible-element-props') ? color : undefined
        },
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-date-time": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_11c8dcr7 _1reo15vq _18m915vq _syaz131l _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _102k1j6v",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_11c81o8v _1reo15vq _18m915vq _syaz1gjq _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _102k7vkz",
            className
        ]),
        children: content
    });
};
var $4ff906df4a1f5956$export$2e2bcd8739ae039 = $4ff906df4a1f5956$var$BaseDateTimeElement;

});

parcelRegister("f8hXJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f4293f1156eec10$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $8dVIb = parcelRequire("8dVIb");

var $4URMI = parcelRequire("4URMI");

var $fpDmE = parcelRequire("fpDmE");
const $2f4293f1156eec10$var$DEFAULT_MAX_LINES = 2;
const $2f4293f1156eec10$var$MAXIMUM_MAX_LINES = 2;
const $2f4293f1156eec10$var$MINIMUM_MAX_LINES = 1;
const $2f4293f1156eec10$var$containerStyles = null;
const $2f4293f1156eec10$var$getMaxLines = (maxLines)=>{
    if (maxLines > $2f4293f1156eec10$var$MAXIMUM_MAX_LINES) return $2f4293f1156eec10$var$DEFAULT_MAX_LINES;
    if (maxLines < $2f4293f1156eec10$var$MINIMUM_MAX_LINES) return $2f4293f1156eec10$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $2f4293f1156eec10$var$withTooltip = (trigger, content, testId)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: content,
        testId: `${testId}-tooltip`,
        tag: "span",
        children: trigger
    });
const $2f4293f1156eec10$var$linkStyleSizeMap = {
    xlarge: "_11c8lodh _k48pi7a9 _vwz41k8s",
    large: "_11c82smr _k48pi7a9 _vwz41j6v",
    medium: "_11c82smr _k48pi7a9 _vwz41j6v",
    small: "_11c8dcr7 _k48pi7a9 _vwz41j6v"
};
const $2f4293f1156eec10$var$baseAnchorStyle = null;
const $2f4293f1156eec10$var$workBreakStyleMap = {
    true: "_1nmz1hna",
    false: "_1nmz9jpi"
};
const $2f4293f1156eec10$var$anchorConstantsStyles = null;
const $2f4293f1156eec10$var$anchorLineClampMap = {
    1: "_1yyjkb7n",
    2: "_1yyjcs5v"
};
const $2f4293f1156eec10$var$anchorLinkLineHeight1Map = {
    xlarge: "_102k1k8s",
    large: "_102k1j6v",
    medium: "_102k1j6v",
    small: "_102k1j6v"
};
const $2f4293f1156eec10$var$anchorLinkLineHeight2Map = {
    xlarge: "_102k1wto",
    large: "_102kviql",
    medium: "_102kviql",
    small: "_102kviql"
};
const $2f4293f1156eec10$var$themeStyleMap = {
    grey: "_fjv618uv _93u918uv _g2lk18uv _pnzf18uv _hlwq8stv _1e2m8stv _1l4b8stv _ue8d8stv _yni7nqa1 _1bianqa1 _93jhnqa1 _64n6nqa1 _1ray131l _dlb7131l _rnxt131l _1h4d131l _10uedcr7 _ye10131l",
    black: "_syaz1gjq _9oik18uv _1bnx8stv _jf4cnqa1 _30l31gjq _9h8h1fxt",
    link: "_syaz14q2 _9oik18uv _1bnx8stv _jf4cnqa1 _30l314q2 _9h8h16c2"
};
/**
 * A base element that represent an anchor.
 * @internal
 * @param {BaseLinkElementProps} BaseLinkElementProps - The props necessary for the Link element.
 * @see LinkIcon
 */ const $2f4293f1156eec10$var$BaseLinkElement = ({ hideTooltip: hideTooltip, maxLines: maxLines = $2f4293f1156eec10$var$DEFAULT_MAX_LINES, name: name, className: className, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-element-link', text: text, theme: theme = (0, $8dVIb.SmartLinkTheme).Link, url: url, onClick: onClick, target: target = '_blank', anchorRef: anchorRef })=>{
    const onMouseDown = (0, $4URMI.useMouseDownEvent)();
    const hasSpace = (0, $5uXOq.useMemo)(()=>text ? (0, $fpDmE.hasWhiteSpace)(text) : false, [
        text
    ]);
    const anchor = /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
        "data-smart-element": name,
        "data-smart-element-link": true,
        "data-testid": testId,
        onClick: onClick,
        onMouseDown: onMouseDown,
        href: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug",
            $2f4293f1156eec10$var$linkStyleSizeMap[size],
            $2f4293f1156eec10$var$anchorLineClampMap[$2f4293f1156eec10$var$getMaxLines(maxLines)],
            "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _sudp1e54",
            $2f4293f1156eec10$var$workBreakStyleMap[hasSpace ? 'true' : 'false'],
            $2f4293f1156eec10$var$getMaxLines(maxLines) === 1 && $2f4293f1156eec10$var$anchorLinkLineHeight1Map[size],
            $2f4293f1156eec10$var$getMaxLines(maxLines) === 2 && $2f4293f1156eec10$var$anchorLinkLineHeight2Map[size],
            $2f4293f1156eec10$var$themeStyleMap[theme],
            className
        ]),
        ...target !== '_self' && {
            target: target
        },
        ref: anchorRef,
        children: text
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug"
        ]),
        children: hideTooltip || text === undefined ? anchor : $2f4293f1156eec10$var$withTooltip(anchor, text, testId)
    });
};
var $2f4293f1156eec10$export$2e2bcd8739ae039 = $2f4293f1156eec10$var$BaseLinkElement;

});
parcelRegister("4URMI", function(module, exports) {

$parcel$export(module.exports, "useLinkClicked", () => $0d5ea96be37e2b5d$export$5993d3ca6c85f774);
$parcel$export(module.exports, "useMouseDownEvent", () => $0d5ea96be37e2b5d$export$df67f318ded0283c);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $g2eZ6 = parcelRequire("g2eZ6");
var $0d5ea96be37e2b5d$export$81a5b494baf0f17c = /*#__PURE__*/ function(ClickButton) {
    ClickButton[ClickButton["Left"] = 0] = "Left";
    ClickButton[ClickButton["Middle"] = 1] = "Middle";
    ClickButton[ClickButton["Right"] = 2] = "Right";
    return ClickButton;
}({});
const $0d5ea96be37e2b5d$export$5993d3ca6c85f774 = (/**
	 * Handler to
	 */ handler, /**
	 * Filter which mouse events should trigger the link clicked event
	 */ predicate)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)((...args)=>{
        const [event] = args;
        handler?.apply(null, args);
        if (!predicate || predicate?.(event)) (0, $g2eZ6.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        handler,
        predicate,
        createAnalyticsEvent
    ]);
};
const $0d5ea96be37e2b5d$var$isNotLeftClick = (event)=>event.button !== 0;
const $0d5ea96be37e2b5d$export$df67f318ded0283c = (onMouseDown)=>{
    return $0d5ea96be37e2b5d$export$5993d3ca6c85f774(onMouseDown, $0d5ea96be37e2b5d$var$isNotLeftClick);
};

});
parcelRegister("g2eZ6", function(module, exports) {

$parcel$export(module.exports, "fireLinkClickedEvent", () => $473b45d487f9fd1b$export$7987de3055fbdcb0);
$parcel$export(module.exports, "withLinkClickedEvent", () => $473b45d487f9fd1b$export$263352d59c0c5966);

var $5uXOq = parcelRequire("5uXOq");

var $b6uPu = parcelRequire("b6uPu");

var $4URMI = parcelRequire("4URMI");

var $fzJZi = parcelRequire("fzJZi");
const $473b45d487f9fd1b$export$cfb45d54e1604f6c = new Map([
    [
        undefined,
        'none'
    ],
    [
        0,
        'left'
    ],
    [
        1,
        'middle'
    ],
    [
        2,
        'right'
    ]
]);
const $473b45d487f9fd1b$export$74743eda5dda3ccf = (e)=>{
    return [
        'alt',
        'ctrl',
        'meta',
        'shift'
    ].filter((key)=>e[`${key}Key`] === true);
};
const $473b45d487f9fd1b$var$isContentEditable = (el)=>{
    return el instanceof HTMLElement && el.isContentEditable;
};
function $473b45d487f9fd1b$export$d2a83e3b34be812b(e, clickType) {
    const { mac: mac, safari: safari } = (0, $b6uPu.browser)();
    /**
	 * If the link/parent is content editable then left click won't have typical effect
	 */ if ($473b45d487f9fd1b$var$isContentEditable(e.currentTarget) && [
        'left',
        'middle'
    ].includes(clickType)) return 'contentEditable';
    switch(clickType){
        case 'left':
        case 'keyboard':
            {
                // Meta key = Cmd for macOS, Windows key sometimes for Windows (otherwise false)
                // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/metaKey
                if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                if (e.shiftKey) {
                    // Alt/option click in safari typically adds the link to bookmarks
                    if (safari) return 'alt';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.ctrlKey) {
                    // Ctrl+Left on macOS defaults to triggering a right click instead (so won't trigger onClick)
                    // but if this behaviour is disabled, likely outcome is clickThrough
                    if (mac) return 'clickThrough';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.altKey) return 'alt';
                const target = e.currentTarget.getAttribute('target');
                if (target === '_blank') return 'clickThroughNewTabOrWindow';
                return 'clickThrough';
            }
        case 'middle':
            return 'clickThroughNewTabOrWindow';
        case 'right':
            return 'contextMenu';
    }
    return 'unknown';
}
const $473b45d487f9fd1b$var$linkClickedEvent = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        }
    });
const $473b45d487f9fd1b$export$7fedc699766c16de = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : $473b45d487f9fd1b$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    const clickOutcome = $473b45d487f9fd1b$export$d2a83e3b34be812b(event, clickType);
    const keysHeld = $473b45d487f9fd1b$export$74743eda5dda3ccf(event);
    const defaultPrevented = event.defaultPrevented;
    const linkClickedEventResult = $473b45d487f9fd1b$var$linkClickedEvent({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented
    });
    // if the current target is an anchor tag, we can get the href from it and use that as the url being navigated too.
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        return {
            ...linkClickedEventResult,
            nonPrivacySafeAttributes: {
                url: url
            }
        };
    } else // We can't get the href from the event target, so dont include the url or any non privacy safe attributes
    return linkClickedEventResult;
};
const $473b45d487f9fd1b$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
        const payload = $473b45d487f9fd1b$export$7fedc699766c16de(event);
        if (payload) createAnalyticsEvent({
            ...payload,
            ...overrides,
            attributes: {
                ...payload.attributes,
                ...overrides?.attributes
            },
            nonPrivacySafeAttributes: {
                ...payload.nonPrivacySafeAttributes,
                ...overrides?.nonPrivacySafeAttributes
            }
        }).fire((0, $fzJZi.ANALYTICS_CHANNEL));
    };
const $473b45d487f9fd1b$var$getDisplayName = (WrappedComponent)=>{
    if (typeof WrappedComponent === 'string') return WrappedComponent;
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
function $473b45d487f9fd1b$export$263352d59c0c5966(WrappedComponent) {
    const Component = (props)=>{
        const onClick = (0, $4URMI.useLinkClicked)(props.onClick);
        const onMouseDown = (0, $4URMI.useMouseDownEvent)(props.onMouseDown);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            onClick: onClick,
            onMouseDown: onMouseDown
        });
    };
    Component.displayName = `withLinkClickedEvent(${$473b45d487f9fd1b$var$getDisplayName(WrappedComponent)})`;
    return Component;
}

});



parcelRegister("Rf8nG", function(module, exports) {

$parcel$export(module.exports, "default", () => $07a7759432a651e8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3u0c5 = parcelRequire("3u0c5");

var $VSDnB = parcelRequire("VSDnB");

var $Nh1XU = parcelRequire("Nh1XU");

var $k3gQe = parcelRequire("k3gQe");
const $07a7759432a651e8$var$stylesOld = null;
const $07a7759432a651e8$var$styles = null;
/**
 * A base element that displays a Lozenge.
 * @internal
 * @param {BaseLozengeElementProps} BaseLozengeElementProps - The props necessary for the Lozenge element.
 * @see State
 */ const $07a7759432a651e8$var$BaseLozengeElement = ({ action: action, appearance: appearance = 'default', name: name, className: className, style: style, text: text, testId: testId = 'smart-element-lozenge' })=>{
    const ui = (0, $Nh1XU.useFlexibleUiOptionContext)();
    if (!text) return null;
    const lozenge = action ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k3gQe.default), {
        action: action,
        appearance: appearance,
        testId: testId,
        text: text,
        zIndex: ui?.zIndex
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
        appearance: appearance,
        ...(0, $VSDnB.fg)('platform-component-visual-refresh') ? {
            isBold: true
        } : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        testId: `${testId}-lozenge`,
        children: text
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-lozenge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1e0c116y _vwz41kw7",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1e0c116y _1ul91ns9",
            className
        ]),
        children: lozenge
    });
};
var $07a7759432a651e8$export$2e2bcd8739ae039 = $07a7759432a651e8$var$BaseLozengeElement;

});
parcelRegister("k3gQe", function(module, exports) {

$parcel$export(module.exports, "default", () => $89d832514be004f9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $BLPHT = parcelRequire("BLPHT");

var $VSDnB = parcelRequire("VSDnB");

var $a1vqi = parcelRequire("a1vqi");

var $dlJZx = parcelRequire("dlJZx");

var $3q2sI = parcelRequire("3q2sI");

var $euMlu = parcelRequire("euMlu");

var $f22ja = parcelRequire("f22ja");

var $gDUps = parcelRequire("gDUps");

var $fzJZi = parcelRequire("fzJZi");

var $i7KLg = parcelRequire("i7KLg");

var $k2WzX = parcelRequire("k2WzX");

var $eDeTc = parcelRequire("eDeTc");

var $2Qn0O = parcelRequire("2Qn0O");

var $aizlC = parcelRequire("aizlC");

var $fgopX = parcelRequire("fgopX");
const $89d832514be004f9$var$validateItems = (items = [], text)=>{
    return items.filter((item)=>item.text !== text);
};
const $89d832514be004f9$var$LozengeAction = ({ action: action, appearance: appearance, testId: testId = 'smart-element-lozenge-action', text: text, zIndex: zIndex })=>{
    const [selected, setSelected] = (0, $5uXOq.useState)({
        appearance: appearance,
        text: text
    });
    const [isLoaded, setIsLoaded] = (0, $5uXOq.useState)(false);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [items, setItems] = (0, $5uXOq.useState)();
    const [errorMessage, setErrorMessage] = (0, $5uXOq.useState)();
    const reload = (0, $f22ja.default)();
    const invoke = (0, $3q2sI.default)();
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        setSelected({
            text: text,
            appearance: appearance
        });
    }, [
        text,
        appearance
    ]);
    const { url: url, id: linkId, invokePreviewAction: invokePreviewAction } = action?.update?.details || {};
    const handleOpenChange = (0, $5uXOq.useCallback)(async (args)=>{
        setIsOpen(args.isOpen);
        if (args.isOpen) {
            fireEvent('ui.button.clicked.smartLinkStatusLozenge', {});
            fireEvent('track.smartLinkQuickAction.started', {
                smartLinkActionType: (0, $fzJZi.TrackQuickActionType).StatusUpdate
            });
            if (!isLoaded && action?.read) try {
                setIsLoading(true);
                const responseItems = await invoke(action.read, (0, $dlJZx.default));
                const validItems = typeof text === 'string' ? $89d832514be004f9$var$validateItems(responseItems, text) : responseItems;
                setItems(validItems);
                setIsLoaded(true);
                if (validItems?.length === 0) {
                    fireEvent('track.smartLinkQuickAction.failed', (0, $k2WzX.permissionLoadErrorAnalyticsPayload));
                    setErrorMessage((0, $VSDnB.fg)('confluence-issue-terminology-refresh') ? (0, $2Qn0O.LozengeActionErrorMessages).noDataIssueTermRefresh : (0, $2Qn0O.LozengeActionErrorMessages).noData);
                    setIsLoaded(false);
                }
            } catch (err) {
                setErrorMessage((0, $2Qn0O.LozengeActionErrorMessages).unknown);
                setIsLoaded(false);
                fireEvent('track.smartLinkQuickAction.failed', (0, $k2WzX.unknownLoadErrorAnalyticsPayload));
            } finally{
                setIsLoading(false);
            }
        }
        if (!args.isOpen) setErrorMessage(undefined);
    }, [
        action.read,
        invoke,
        isLoaded,
        text,
        fireEvent
    ]);
    const trigger = (0, $5uXOq.useCallback)((props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $fgopX.default), {
            ...props,
            appearance: selected.appearance,
            isOpen: isOpen,
            testId: testId,
            text: selected.text
        }), [
        selected.appearance,
        selected.text,
        isOpen,
        testId
    ]);
    const handleItemClick = (0, $5uXOq.useCallback)(async (id, text, appearance)=>{
        try {
            fireEvent('ui.button.clicked.smartLinkStatusListItem', {});
            const updateAction = action?.update;
            if (updateAction && id) {
                setIsLoading(true);
                const request = (0, $gDUps.default)(updateAction, id);
                await invoke(request);
                setSelected({
                    appearance: appearance,
                    text: text
                });
                setIsLoading(false);
                setIsLoaded(false);
                setIsOpen(false);
                setItems([]);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: (0, $fzJZi.TrackQuickActionType).StatusUpdate
                });
                if (url) await reload(url, true, undefined, linkId);
            }
        } catch (err) {
            setIsLoading(false);
            if ((0, $euMlu.isInvokeCustomError)(err)) {
                setErrorMessage(err.message);
                fireEvent('track.smartLinkQuickAction.failed', (0, $k2WzX.validationUpdateErrorAnalyticsPayload));
            } else {
                setErrorMessage((0, $2Qn0O.LozengeActionErrorMessages).updateFailed);
                fireEvent('track.smartLinkQuickAction.failed', (0, $k2WzX.unknownUpdateErrorAnalyticsPayload));
            }
        }
    }, [
        action?.update,
        invoke,
        linkId,
        reload,
        url,
        fireEvent
    ]);
    const dropdownItemGroup = (0, $5uXOq.useMemo)(()=>{
        if (errorMessage) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eDeTc.default), {
            errorMessage: errorMessage,
            testId: testId,
            url: url,
            invokePreviewAction: invokePreviewAction
        });
        if (items && items.length > 0) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aizlC.default), {
            testId: testId,
            items: items,
            onClick: handleItemClick
        });
    }, [
        errorMessage,
        handleItemClick,
        items,
        invokePreviewAction,
        testId,
        url
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $BLPHT.default), {
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: handleOpenChange,
        testId: testId,
        trigger: trigger,
        zIndex: zIndex,
        children: dropdownItemGroup
    });
};
var $89d832514be004f9$export$2e2bcd8739ae039 = (0, $i7KLg.default)($89d832514be004f9$var$LozengeAction);

});
parcelRegister("dlJZx", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eaacaffc693a3ec$export$2e2bcd8739ae039);
const $6eaacaffc693a3ec$var$extractLozengeActionItems = (response)=>{
    const items = response?.transitions?.map(({ appearance: appearance, id: id, name: name })=>({
            appearance: appearance ?? 'default',
            id: id,
            text: name
        })) ?? [];
    return items.sort((a, b)=>a.appearance.localeCompare(b.appearance) || a.text.localeCompare(b.text));
};
var $6eaacaffc693a3ec$export$2e2bcd8739ae039 = $6eaacaffc693a3ec$var$extractLozengeActionItems;

});

parcelRegister("3q2sI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5a60e7c58b54588$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iiAnG = parcelRequire("iiAnG");

var $051X7 = parcelRequire("051X7");
const $f5a60e7c58b54588$var$useInvoke = ()=>{
    const { connections: connections } = (0, $051X7.useSmartLinkContext)();
    const clientExt = (0, $iiAnG.useSmartLinkClientExtension)(connections.client);
    return (0, $5uXOq.useCallback)(async (req, cb)=>{
        const response = await clientExt.invoke(req);
        return cb ? cb(response) : response;
    }, [
        clientExt
    ]);
};
var $f5a60e7c58b54588$export$2e2bcd8739ae039 = $f5a60e7c58b54588$var$useInvoke;

});
parcelRegister("iiAnG", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkClientExtension", () => $ffb669da1b6b71e8$export$303ede4eed148855);

var $5uXOq = parcelRequire("5uXOq");

var $dV0Jy = parcelRequire("dV0Jy");

var $T540Y = parcelRequire("T540Y");

var $3b94d = parcelRequire("3b94d");
const $ffb669da1b6b71e8$export$303ede4eed148855 = (cardClient)=>{
    const resolverUrl = (0, $3b94d.useResolverUrl)(cardClient);
    const invoke = (0, $5uXOq.useCallback)(async (data)=>{
        try {
            return await (0, $dV0Jy.request)('post', `${resolverUrl}/invoke`, data, undefined, [
                200,
                201,
                202,
                203,
                204
            ]);
        } catch (err) {
            // checking if the error is a Response type
            // since we already had a few HOTs caused by comparing with instanceOf',
            // we're verifying the type by the contents
            if (err && err.json && typeof err.json === 'function') {
                const errorBody = await err.json();
                if (errorBody) throw new (0, $T540Y.InvokeError)(errorBody?.error.message, errorBody?.error.status);
            }
            throw err;
        }
    }, [
        resolverUrl
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            invoke: invoke
        }), [
        invoke
    ]);
};

});
parcelRegister("T540Y", function(module, exports) {

$parcel$export(module.exports, "SmartLinkActionType", () => $171ae91e706973ef$export$6324b7946ad663e9);
$parcel$export(module.exports, "InvokeError", () => $171ae91e706973ef$export$d4d72202bff63658);
/**
 * The enum that describes Smart Link action types
 */ var $171ae91e706973ef$export$6324b7946ad663e9 = /*#__PURE__*/ function(SmartLinkActionType) {
    SmartLinkActionType["FollowEntityAction"] = "FollowEntityAction";
    SmartLinkActionType["GetStatusTransitionsAction"] = "GetStatusTransitionsAction";
    SmartLinkActionType["StatusUpdateAction"] = "StatusUpdateAction";
    SmartLinkActionType["UnfollowEntityAction"] = "UnfollowEntityAction";
    return SmartLinkActionType;
}({});
class $171ae91e706973ef$export$d4d72202bff63658 extends Error {
    constructor(message, errorCode){
        super(message);
        this.errorCode = errorCode;
    }
}

});

parcelRegister("3b94d", function(module, exports) {

$parcel$export(module.exports, "useResolverUrl", () => $eebf021c5f687360$export$d08617a365fbe694);

var $5uXOq = parcelRequire("5uXOq");

var $itO4f = parcelRequire("itO4f");
const $eebf021c5f687360$export$d08617a365fbe694 = (cardClient)=>(0, $5uXOq.useMemo)(()=>(0, $itO4f.getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
        cardClient?.baseUrlOverride,
        cardClient?.envKey
    ]);

});



parcelRegister("euMlu", function(module, exports) {

$parcel$export(module.exports, "getInvokeFailureReason", () => $0ad6fedaface02c5$export$65b3f792dff0bd60);
$parcel$export(module.exports, "isInvokeCustomError", () => $0ad6fedaface02c5$export$1694272377fa07d8);

var $fzJZi = parcelRequire("fzJZi");
const $0ad6fedaface02c5$export$65b3f792dff0bd60 = (err)=>{
    if (!$0ad6fedaface02c5$export$1694272377fa07d8(err)) return (0, $fzJZi.TrackQuickActionFailureReason).UnknownError;
    switch(err?.errorCode){
        case 403:
            return (0, $fzJZi.TrackQuickActionFailureReason).PermissionError;
        default:
            return (0, $fzJZi.TrackQuickActionFailureReason).UnknownError;
    }
};
const $0ad6fedaface02c5$export$1694272377fa07d8 = (err)=>err?.message !== undefined && err?.errorCode !== undefined;

});

parcelRegister("f22ja", function(module, exports) {

$parcel$export(module.exports, "default", () => $f48b36e6e5cada34$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kYwnb = parcelRequire("kYwnb");

var $051X7 = parcelRequire("051X7");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $1VPdD = parcelRequire("1VPdD");

var $nb8r1 = parcelRequire("nb8r1");
const $f48b36e6e5cada34$var$useResolve = ()=>{
    // Request JSON-LD data for the card from ORS, if it has extended
    // its cache lifespan OR there is no data for it currently. Once the data
    // has come back asynchronously, call the useResponse callback to
    // dispatch the resolved action for the card.
    const { store: store, connections: connections } = (0, $051X7.useSmartLinkContext)();
    const { getState: getState } = store;
    const { handleResolvedLinkResponse: handleResolvedLinkResponse, handleResolvedLinkError: handleResolvedLinkError } = (0, $nb8r1.default)();
    return (0, $5uXOq.useCallback)(async (url, isReloading = false, isMetadataRequest = false, id = '')=>{
        const { details: details } = getState()[url] || {
            status: (0, $8dVIb.SmartLinkStatus).Pending,
            details: undefined
        };
        const hasData = (0, $VSDnB.fg)('smart_links_noun_support') ? !!(details && details.data || (0, $kYwnb.isEntityPresent)(details)) : !!(details && details.data);
        if (isReloading || !hasData || isMetadataRequest) return connections.client.fetchData(url, isReloading).then((response)=>handleResolvedLinkResponse(url, response, isReloading, isMetadataRequest)).catch((error)=>handleResolvedLinkError(url, error, undefined, isMetadataRequest));
        else (0, $1VPdD.addMetadataToExperience)('smart-link-rendered', id, {
            cached: true
        });
    }, [
        connections.client,
        getState,
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $f48b36e6e5cada34$export$2e2bcd8739ae039 = $f48b36e6e5cada34$var$useResolve;

});
parcelRegister("nb8r1", function(module, exports) {

$parcel$export(module.exports, "default", () => $09545a48e55da9e9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $051X7 = parcelRequire("051X7");

var $2yPrN = parcelRequire("2yPrN");
var $kDZ6Z = parcelRequire("kDZ6Z");
var $fiKQs = parcelRequire("fiKQs");

var $8dVIb = parcelRequire("8dVIb");

var $aOsut = parcelRequire("aOsut");

const $09545a48e55da9e9$var$useResponse = ()=>{
    // Takes in the JSON-LD response and dispatch the resolved action for the card.
    // It will dispatch a successful or error action
    const { store: store, config: config } = (0, $051X7.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const hasAuthFlowSupported = config.authFlow !== 'disabled';
    const setMetadataStatus = (0, $5uXOq.useCallback)((url, metadataStatus)=>{
        dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch
    ]);
    const handleResolvedLinkError = (0, $5uXOq.useCallback)((url, error, response, isMetadataRequest)=>{
        const newState = {
            status: (0, $8dVIb.SmartLinkStatus).Pending,
            details: undefined
        };
        const { details: details } = getState()[url] || newState;
        const hasData = !!(details && details.data);
        // If metadata request then set metadata status, return and do not alter link status
        if (isMetadataRequest) {
            setMetadataStatus(url, 'errored');
            return;
        }
        if (error.kind === 'fatal') {
            // If we already have resolved data for this URL in the store, then
            // simply fallback to the previous data.
            if (hasData) dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_RESOLVED), {
                url: url
            }, details));
            else {
                dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_ERROR), {
                    url: url
                }, details, error));
                throw error;
            }
        } else if (error.kind === 'auth') dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_RESOLVED), {
            url: url
        }, (0, $aOsut.getUnauthorizedJsonLd)()));
        else if (error.kind === 'fallback') // Fallback to blue link with smart link formatting. Not part of reliability.
        dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_ERROR_FALLBACK), {
            url: url
        }, response, error));
        else // Fallback to blue link with smart link formatting. Part of reliability.
        dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_ERROR), {
            url: url
        }, undefined, error));
    }, [
        getState,
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkSuccess = (0, $5uXOq.useCallback)((resourceUrl, response, isReloading, isMetadataRequest)=>{
        //if a link resolves normally, metadata will also always be resolved
        setMetadataStatus(resourceUrl, 'resolved');
        // Dispatch Analytics and resolved card action - including unauthorized states.
        if (isReloading) dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_RELOADING), {
            url: resourceUrl
        }, response));
        else dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_RESOLVED), {
            url: resourceUrl
        }, response, undefined, undefined, isMetadataRequest));
    }, [
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkResponse = (0, $5uXOq.useCallback)((resourceUrl, response, isReloading = false, isMetadataRequest)=>{
        const hostname = new URL(resourceUrl).hostname;
        const nextStatus = response ? (0, $fiKQs.getStatus)(response) : 'fatal';
        // If we require authorization & do not have an authFlow available,
        // throw an error and render as a normal blue link.
        if ((nextStatus === 'unauthorized' || nextStatus === 'forbidden') && !hasAuthFlowSupported) {
            handleResolvedLinkError(resourceUrl, new (0, $kDZ6Z.APIError)('fallback', hostname, (0, $cc6a74b99a201fc4$export$3e81ce851ffda0ad)), response, isMetadataRequest);
            return;
        }
        // Handle any other errors
        if (!response || nextStatus === 'fatal') {
            handleResolvedLinkError(resourceUrl, new (0, $kDZ6Z.APIError)('fatal', hostname, (0, $cc6a74b99a201fc4$export$45e7dda0d43d7f55)), undefined, isMetadataRequest);
            return;
        }
        // Handle errors of any other kind in the metadata request response
        if (isMetadataRequest && nextStatus !== 'resolved') {
            handleResolvedLinkError(resourceUrl, new (0, $kDZ6Z.APIError)('error', hostname, (0, $cc6a74b99a201fc4$export$338f7d9ccca1975d)), response, isMetadataRequest);
            return;
        }
        /**
			 * Using unstable_batchedUpdates because this store update happens async and triggers a rerender
			 * more info:
			 * https://github.com/facebook/react/blob/v18.2.0/packages/use-sync-external-store/src/useSyncExternalStoreShimClient.js#L113
			 * https://react-redux.js.org/api/batch
			 */ (0, $7nsd3.unstable_batchedUpdates)(()=>{
            handleResolvedLinkSuccess(resourceUrl, response, isReloading, isMetadataRequest);
        });
    }, [
        handleResolvedLinkError,
        handleResolvedLinkSuccess,
        hasAuthFlowSupported
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            handleResolvedLinkError: handleResolvedLinkError,
            handleResolvedLinkResponse: handleResolvedLinkResponse
        }), [
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $09545a48e55da9e9$export$2e2bcd8739ae039 = $09545a48e55da9e9$var$useResponse;

});
parcelRegister("aOsut", function(module, exports) {

$parcel$export(module.exports, "getEmptyJsonLd", () => $5dc57cbabb8840da$export$2796a804c6e44f63);
$parcel$export(module.exports, "getUnauthorizedJsonLd", () => $5dc57cbabb8840da$export$b9482e0f6d365cc7);
$parcel$export(module.exports, "getForbiddenJsonLd", () => $5dc57cbabb8840da$export$e32193033a594efb);
const $5dc57cbabb8840da$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $5dc57cbabb8840da$export$2796a804c6e44f63 = ()=>$5dc57cbabb8840da$var$emptyData;
const $5dc57cbabb8840da$export$b9482e0f6d365cc7 = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'unauthorized',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$5dc57cbabb8840da$var$emptyData
        }
    });
const $5dc57cbabb8840da$export$e32193033a594efb = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'forbidden',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$5dc57cbabb8840da$var$emptyData
        }
    });

});

const $cc6a74b99a201fc4$export$297c39c8b9bfca0 = 'resolving';
const $cc6a74b99a201fc4$export$b64a888338c24e0e = 'errored';
const $cc6a74b99a201fc4$export$677b6edfa0002c70 = 'fallback';
const $cc6a74b99a201fc4$export$3e81ce851ffda0ad = 'Provider.authFlow is not set to OAuth2.';
const $cc6a74b99a201fc4$export$45e7dda0d43d7f55 = 'Fatal error resolving URL';
const $cc6a74b99a201fc4$export$338f7d9ccca1975d = 'Error resolving metadata.';



parcelRegister("gDUps", function(module, exports) {

$parcel$export(module.exports, "default", () => $66cd4b0a305f86bf$export$2e2bcd8739ae039);
const $66cd4b0a305f86bf$var$createStatusUpdateRequest = (request, id)=>({
        providerKey: request.providerKey,
        action: {
            ...request.action,
            payload: {
                newStatusId: id
            }
        }
    });
var $66cd4b0a305f86bf$export$2e2bcd8739ae039 = $66cd4b0a305f86bf$var$createStatusUpdateRequest;

});

parcelRegister("i7KLg", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0c1a5dbe8fe9dd0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $3u0c5 = parcelRequire("3u0c5");

var $VSDnB = parcelRequire("VSDnB");
const $c0c1a5dbe8fe9dd0$var$withErrorBoundary = (Component)=>(props)=>{
        const fallback = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
                appearance: props?.appearance,
                ...(0, $VSDnB.fg)('platform-component-visual-refresh') ? {
                    isBold: true
                } : undefined,
                testId: `${props?.testId ?? 'smart-element-lozenge-action'}-fallback`,
                children: props?.text
            }), [
            props?.appearance,
            props?.testId,
            props?.text
        ]);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
            fallback: fallback,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                ...props
            })
        });
    };
var $c0c1a5dbe8fe9dd0$export$2e2bcd8739ae039 = $c0c1a5dbe8fe9dd0$var$withErrorBoundary;

});

parcelRegister("k2WzX", function(module, exports) {

$parcel$export(module.exports, "unknownLoadErrorAnalyticsPayload", () => $9f7317929809ab5b$export$2a568ff99500df53);
$parcel$export(module.exports, "permissionLoadErrorAnalyticsPayload", () => $9f7317929809ab5b$export$2de2d0ccc17b915f);
$parcel$export(module.exports, "unknownUpdateErrorAnalyticsPayload", () => $9f7317929809ab5b$export$c1c05f9d51f7c467);
$parcel$export(module.exports, "validationUpdateErrorAnalyticsPayload", () => $9f7317929809ab5b$export$618660b8f2aa87e2);
const $9f7317929809ab5b$export$2a568ff99500df53 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'load'
};
const $9f7317929809ab5b$export$2de2d0ccc17b915f = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'PermissionError',
    step: 'load'
};
const $9f7317929809ab5b$export$c1c05f9d51f7c467 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'update'
};
const $9f7317929809ab5b$export$618660b8f2aa87e2 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'ValidationError',
    step: 'update'
};

});

parcelRegister("eDeTc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ed6f8e41f2a6640$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $ousew = parcelRequire("ousew");

var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $dD7Zc = parcelRequire("dD7Zc");

var $VSDnB = parcelRequire("VSDnB");


var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $iPVbQ = parcelRequire("iPVbQ");

var $fpDmE = parcelRequire("fpDmE");
const $7ed6f8e41f2a6640$var$MAX_LINE_NUMBER = 8;
const $7ed6f8e41f2a6640$var$contentStyles = null;
const $7ed6f8e41f2a6640$var$linkStyles = null;
const $7ed6f8e41f2a6640$var$textStylesBase = null;
const $7ed6f8e41f2a6640$var$dropdownItemGroupStyles = null;
const $7ed6f8e41f2a6640$var$LozengeActionError = ({ errorMessage: errorMessage, testId: testId, maxLineNumber: maxLineNumber = $7ed6f8e41f2a6640$var$MAX_LINE_NUMBER, invokePreviewAction: invokePreviewAction })=>{
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const invoke = (0, $iPVbQ.default)({});
    const isPreviewAvailable = invokePreviewAction !== undefined;
    const handlePreviewOpen = (0, $5uXOq.useCallback)(()=>{
        if (isPreviewAvailable) {
            fireEvent('ui.button.clicked.smartLinkStatusOpenPreview', {});
            if (invokePreviewAction) invoke(invokePreviewAction);
        }
    }, [
        isPreviewAvailable,
        invoke,
        invokePreviewAction,
        fireEvent
    ]);
    const dynamicCss = null;
    const content = (0, $5uXOq.useMemo)(()=>{
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                    className: (0, $bwpsq.default)([
                        "_zulpu2gc _11c81ixg _1reo15vq _18m915vq _1e0c1txw _1ul9idpf _2lx2vrvc _19pkv77o _4cvr1y6m _pqme2smr _102e2smr _ngc01fxt _1t4p1fxt"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
                            testId: `${testId}-icon`,
                            LEGACY_size: "medium",
                            color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`,
                            LEGACY_secondaryColor: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`,
                            label: 'error',
                            spacing: "spacious"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            "data-testid": `${testId}-error-message`,
                            className: (0, $bwpsq.default)([
                                "_11c81ixg _1reo15vq _18m915vq _o5724jg8 _1e0ccj1k _1bto1l2s _1nmz1hna _sudp1e54",
                                "_1yyj1n6p _102k16q4"
                            ]),
                            style: {
                                "--_t4prqe": (0, $lD23V.default)(maxLineNumber)
                            },
                            children: typeof errorMessage === 'string' ? errorMessage : (0, $fpDmE.getFormattedMessage)(errorMessage)
                        })
                    ]
                }),
                isPreviewAvailable ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        "_zulpu2gc _1reo15vq _18m915vq _11c82smr _1e0c1txw _1ul9idpf _2lx2vrvc _4cvr1h6o _80omtlke _19pku2gc _18u0xy5q _otyrv77o"
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
                        target: "_blank",
                        "data-testid": `${testId}-open-embed`,
                        onClick: handlePreviewOpen,
                        children: (0, $VSDnB.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $7zaVw.messages).open_issue_in_jiraIssueTermRefresh
                        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $7zaVw.messages).open_issue_in_jira
                        })
                    })
                }) : null
            ]
        });
    }, [
        errorMessage,
        handlePreviewOpen,
        isPreviewAvailable,
        testId,
        dynamicCss
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": `${testId}-error-item-group`,
        className: (0, $bwpsq.default)([
            "_14hp1wdt _6pup1kw7 _1eo073ad"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aRoVz.default), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
                testId: `${testId}-error`,
                children: content
            })
        })
    });
};
var $7ed6f8e41f2a6640$export$2e2bcd8739ae039 = $7ed6f8e41f2a6640$var$LozengeActionError;

});
parcelRegister("iPVbQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a560b45251b869c0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $a1vqi = parcelRequire("a1vqi");

var $5vDFA = parcelRequire("5vDFA");

var $1VPdD = parcelRequire("1VPdD");
const $a560b45251b869c0$var$ACTION_EXPERIENCE_NAME = 'smart-link-action-invocation';
/**
 * Invoke client action such as preview, download and open link
 */ const $a560b45251b869c0$var$useInvokeClientAction = ({ fireEvent: fireEventProp })=>{
    const { fireEvent: defaultFireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const fireEvent = fireEventProp ?? defaultFireEvent;
    return (0, $5uXOq.useCallback)(async ({ actionSubjectId: actionSubjectId, actionType: actionType, actionFn: actionFn, definitionId: definitionId = null, extensionKey: extensionKey, display: display, id: id, resourceType: resourceType = null })=>{
        const experienceId = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))();
        // Begin performance instrumentation.
        const markName = `${experienceId}-${actionType}`;
        $5vDFA.mark(markName, 'pending');
        try {
            // Begin UFO experience
            (0, $1VPdD.startUfoExperience)($a560b45251b869c0$var$ACTION_EXPERIENCE_NAME, experienceId, {
                actionType: actionType,
                display: display,
                extensionKey: extensionKey,
                invokeType: 'client'
            });
            // Begin analytics instrumentation.
            if (actionSubjectId !== undefined) fireEvent(`ui.button.clicked.${actionSubjectId}`, {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            // Invoke action
            const result = await actionFn();
            $5vDFA.mark(markName, 'resolved');
            (0, $1VPdD.succeedUfoExperience)($a560b45251b869c0$var$ACTION_EXPERIENCE_NAME, experienceId);
            fireEvent('operational.smartLinkAction.resolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $5vDFA.getMeasure(markName, 'resolved')?.duration ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            return result;
        } catch (err) {
            $5vDFA.mark(markName, 'errored');
            (0, $1VPdD.failUfoExperience)($a560b45251b869c0$var$ACTION_EXPERIENCE_NAME, experienceId);
            const reason = typeof err === 'string' ? err : err?.message;
            fireEvent('operational.smartLinkAction.unresolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $5vDFA.getMeasure(markName, 'errored')?.duration ?? null,
                id: id ?? experienceId,
                reason: reason,
                resourceType: resourceType
            });
        }
    }, [
        fireEvent
    ]);
};
var $a560b45251b869c0$export$2e2bcd8739ae039 = $a560b45251b869c0$var$useInvokeClientAction;

});
parcelRegister("5vDFA", function(module, exports) {

$parcel$export(module.exports, "clearMarks", () => $483ef2a5b4b04745$export$1a717feb4df1a945);
$parcel$export(module.exports, "clearMeasures", () => $483ef2a5b4b04745$export$de42547d395c8271);
$parcel$export(module.exports, "getMeasure", () => $483ef2a5b4b04745$export$d6e97a903ae9a3aa);
$parcel$export(module.exports, "mark", () => $483ef2a5b4b04745$export$bf7f2fce5c1cf636);
$parcel$export(module.exports, "create", () => $483ef2a5b4b04745$export$185802fd694ee1f5);
const $483ef2a5b4b04745$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $483ef2a5b4b04745$var$hasPerformanceAPIAvailable = $483ef2a5b4b04745$var$isPerformanceAPIAvailable();
const $483ef2a5b4b04745$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;
const $483ef2a5b4b04745$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;
const $483ef2a5b4b04745$export$1a717feb4df1a945 = (id)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
        marks.forEach((mark)=>performance.clearMarks(mark.name));
    }
};
const $483ef2a5b4b04745$export$de42547d395c8271 = (id)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
        measures.forEach((measure)=>performance.clearMeasures(measure.name));
    }
};
const $483ef2a5b4b04745$var$getMark = (id, status)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const name = $483ef2a5b4b04745$export$fcff3185c7ce7f2b(id, status);
        const marks = performance.getEntriesByName(name);
        if (marks.length > 0) return marks[0];
        return undefined;
    }
};
const $483ef2a5b4b04745$export$d6e97a903ae9a3aa = (id, status)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const name = $483ef2a5b4b04745$export$984df7f61dd7928f(id, status);
        const measures = performance.getEntriesByName(name);
        if (measures.length > 0) return measures[0];
        return undefined;
    }
};
const $483ef2a5b4b04745$export$bf7f2fce5c1cf636 = (id, status)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const name = $483ef2a5b4b04745$export$fcff3185c7ce7f2b(id, status);
        performance.mark(name);
    }
};
const $483ef2a5b4b04745$export$185802fd694ee1f5 = (id, status)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const name = $483ef2a5b4b04745$export$984df7f61dd7928f(id, status);
        const measure = $483ef2a5b4b04745$export$d6e97a903ae9a3aa(id, status);
        if (!measure) {
            const startMark = $483ef2a5b4b04745$var$getMark(id, 'pending');
            const endMark = $483ef2a5b4b04745$var$getMark(id, status);
            if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
        }
    }
};

});



parcelRegister("2Qn0O", function(module, exports) {

$parcel$export(module.exports, "LozengeActionErrorMessages", () => $94674035efe67a9d$export$4f2e371a667ad688);

var $7zaVw = parcelRequire("7zaVw");
const $94674035efe67a9d$export$4f2e371a667ad688 = {
    noData: {
        descriptor: (0, $7zaVw.messages)['status_change_permission_error']
    },
    noDataIssueTermRefresh: {
        descriptor: (0, $7zaVw.messages)['status_change_permission_errorIssueTermRefresh']
    },
    unknown: {
        descriptor: (0, $7zaVw.messages)['status_change_load_error']
    },
    updateFailed: {
        descriptor: (0, $7zaVw.messages)['status_change_update_error']
    }
};

});

parcelRegister("aizlC", function(module, exports) {

$parcel$export(module.exports, "default", () => $0de089d76c0ce596$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aRoVz = parcelRequire("aRoVz");

var $3QMlO = parcelRequire("3QMlO");
const $0de089d76c0ce596$var$dropdownItemGroupStyles = null;
const $0de089d76c0ce596$var$LozengeActionItemsGroup = ({ items: items, testId: testId, onClick: onClick })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": `${testId}-item-group`,
        className: (0, $bwpsq.default)([
            "_c71l1mjv _18m91wug _1pv01r31 _1m1b1r31 _qh55glyw _lt2aglyw _ph3k1o36 _1twe1o36 _1ll7166n _qprf166n _n6y8usvi _109gusvi _z29hu4to _wlxpu4to _1gfl12x7 _yhjmutpp _1gqn12x7 _11lvutpp _d4lf1f4h _14hp1wdt _6pup1kw7"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aRoVz.default), {
            children: items.map((item, idx)=>/*#__PURE__*/ (0, $5uXOq.createElement)((0, $3QMlO.default), {
                    ...item,
                    key: idx,
                    onClick: onClick,
                    testId: `${testId}-item-${idx}`
                }))
        })
    });
var $0de089d76c0ce596$export$2e2bcd8739ae039 = $0de089d76c0ce596$var$LozengeActionItemsGroup;

});
parcelRegister("3QMlO", function(module, exports) {

$parcel$export(module.exports, "default", () => $21bfe154deafa121$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $3u0c5 = parcelRequire("3u0c5");

var $VSDnB = parcelRequire("VSDnB");
const $21bfe154deafa121$var$LozengeActionItem = ({ appearance: appearance, id: id, onClick: onClick, testId: testId, text: text })=>{
    const handleClick = (0, $5uXOq.useCallback)((e)=>{
        // Prevent dropdown to close on select item.
        // We want to show loading screen.
        e.stopPropagation();
        if (onClick) onClick(id, text, appearance);
    }, [
        appearance,
        id,
        onClick,
        text
    ]);
    const handleMouseEnter = (0, $5uXOq.useCallback)((e)=>{
        e.currentTarget?.firstElementChild?.focus();
    }, []);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        onMouseEnter: handleMouseEnter,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
            onClick: handleClick,
            testId: testId,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
                appearance: appearance,
                ...(0, $VSDnB.fg)('platform-component-visual-refresh') ? {
                    isBold: true
                } : undefined,
                children: text
            })
        })
    }));
};
var $21bfe154deafa121$export$2e2bcd8739ae039 = $21bfe154deafa121$var$LozengeActionItem;

});


parcelRegister("fgopX", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec70f521c081a340$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $c8Oei = parcelRequire("c8Oei");

var $h5UrH = parcelRequire("h5UrH");

var $3u0c5 = parcelRequire("3u0c5");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
const $ec70f521c081a340$var$styles = {
    chevronDown: "_18u012x7 _1e0c1txw",
    lozengeContainer: "_kkk2n7od _2rkoiti9 _1dqonqa1 _189ee4h9 _1h6d3acm _bfhk18uv _1e0c1txw _4cvr1h6o _4t3i7vkz",
    lozengeContainerSelected: "_1reo15vq _18m915vq _1h6d1p6i"
};
const $ec70f521c081a340$var$triggerLozengeStyles = null;
const $ec70f521c081a340$var$triggerButtonStyles = null;
const $ec70f521c081a340$var$LozengeActionTriggerOld = ({ appearance: appearance, isOpen: isOpen, testId: testId, text: text, triggerRef: triggerRef, ...props })=>{
    const [isBold, setIsBold] = (0, $5uXOq.useState)(false);
    const onMouseEnter = (0, $5uXOq.useCallback)(()=>setIsBold(true), []);
    const onMouseLeave = (0, $5uXOq.useCallback)(()=>setIsBold(false), []);
    const lozenge = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
            appearance: appearance,
            isBold: (0, $VSDnB.fg)('platform-component-visual-refresh') ? true : isBold,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
                className: (0, $bwpsq.default)([
                    "_4cvr1h6o _1e0c1txw"
                ]),
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                        children: text
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                        as: "span",
                        xcss: $ec70f521c081a340$var$styles.chevronDown,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
                            color: "currentColor",
                            label: "options",
                            LEGACY_size: "medium",
                            LEGACY_margin: "-4px -8px -4px -7px"
                        })
                    })
                ]
            })
        }), [
        appearance,
        isBold,
        text
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
        type: "button",
        ...props,
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ref: triggerRef,
        className: (0, $bwpsq.default)([
            "_kkk2n7od _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _15vhn7od _1dqonqa1 _189eyh40 _1h6d3acm _bfhk18uv _syazn7od _80omtlke _ect4n7od _1wybn7od _zg8ln7od _k48pn7od _vwz4idpf _1p1dn7od _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _mizu1r31 _1guj1r31 _p8tl1r31 _ra3xglyw _pbhaglyw _1q2vglyw _128m1o36 _11ow1o36 _j8b81o36 _1bas14y2 _19h614y2 _1d3914y2 _1ejj1vm4 _1u6l1vm4 _6ssh1vm4"
        ]),
        children: lozenge
    });
};
const $ec70f521c081a340$var$LozengeActionTrigger = ({ appearance: appearance, isOpen: isOpen, testId: testId, text: text, triggerRef: triggerRef, ...props })=>{
    const [isHovering, setIsHovering] = (0, $5uXOq.useState)(false);
    const [isPressing, setIsPressing] = (0, $5uXOq.useState)(false);
    const [lozengeBackgroundColor, setLozengeBackgroundColor] = (0, $5uXOq.useState)(undefined);
    const [lozengeForegroundColor, setLozengeForegroundColor] = (0, $5uXOq.useState)(undefined);
    const onMouseEnter = (0, $5uXOq.useCallback)(()=>setIsHovering(true), []);
    const onMouseLeave = (0, $5uXOq.useCallback)(()=>setIsHovering(false), []);
    const onMouseOrKeyDown = (0, $5uXOq.useCallback)(()=>setIsPressing(true), []);
    const onMouseOrKeyUp = (0, $5uXOq.useCallback)(()=>setIsPressing(false), []);
    (0, $5uXOq.useEffect)(()=>{
        if (isPressing) {
            setLozengeBackgroundColor("var(--ds-background-selected-pressed, #85B8FF)");
            setLozengeForegroundColor("var(--ds-text-selected, #0C66E4)");
        } else if (isOpen) {
            if (isHovering) setLozengeBackgroundColor("var(--ds-background-selected-hovered, #CCE0FF)");
            else setLozengeBackgroundColor("var(--ds-background-selected, #E9F2FF)");
            setLozengeForegroundColor("var(--ds-text-selected, #0C66E4)");
        } else {
            setLozengeBackgroundColor(undefined);
            setLozengeForegroundColor(undefined);
        }
    }, [
        isPressing,
        isOpen,
        isHovering
    ]);
    const lozenge = (0, $5uXOq.useMemo)(()=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            xcss: (0, $DEWI6.cx)($ec70f521c081a340$var$styles.lozengeContainer, (isOpen || isPressing) && $ec70f521c081a340$var$styles.lozengeContainerSelected),
            as: "span",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
                appearance: appearance,
                isBold: (0, $VSDnB.fg)('platform-component-visual-refresh') ? true : isHovering,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: {
                    backgroundColor: lozengeBackgroundColor,
                    color: lozengeForegroundColor
                },
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
                    className: (0, $bwpsq.default)([
                        "_4cvr1h6o _1e0c1txw"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            children: text
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            as: "span",
                            xcss: $ec70f521c081a340$var$styles.chevronDown,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
                                color: "currentColor",
                                label: "options",
                                LEGACY_size: "medium",
                                LEGACY_margin: "-4px -8px -4px -7px"
                            })
                        })
                    ]
                })
            })
        });
    }, [
        appearance,
        isHovering,
        isPressing,
        text,
        isOpen,
        lozengeBackgroundColor,
        lozengeForegroundColor
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
        type: "button",
        ...props,
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseDown: onMouseOrKeyDown,
        onMouseUp: onMouseOrKeyUp,
        onKeyDown: onMouseOrKeyDown,
        onKeyUp: onMouseOrKeyUp,
        ref: triggerRef,
        className: (0, $bwpsq.default)([
            "_kkk2n7od _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _15vhn7od _1dqonqa1 _189eyh40 _1h6d3acm _bfhk18uv _syazn7od _80omtlke _ect4n7od _1wybn7od _zg8ln7od _k48pn7od _vwz4idpf _1p1dn7od _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _mizu1r31 _1guj1r31 _p8tl1r31 _ra3xglyw _pbhaglyw _1q2vglyw _128m1o36 _11ow1o36 _j8b81o36 _1bas14y2 _19h614y2 _1d3914y2 _1ejj1vm4 _1u6l1vm4 _6ssh1vm4"
        ]),
        children: lozenge
    });
};
var $ec70f521c081a340$export$2e2bcd8739ae039 = (0, $h5UrH.withFeatureFlaggedComponent)($ec70f521c081a340$var$LozengeActionTriggerOld, $ec70f521c081a340$var$LozengeActionTrigger, ()=>(0, $VSDnB.fg)('platform-linking-visual-refresh-v2'));

});



parcelRegister("eL5Me", function(module, exports) {

$parcel$export(module.exports, "default", () => $0077ab6b3bad1a53$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $VSDnB = parcelRequire("VSDnB");

var $fpDmE = parcelRequire("fpDmE");
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $0077ab6b3bad1a53$var$baseStyleOld = null;
const $0077ab6b3bad1a53$var$baseStyle = null;
const $0077ab6b3bad1a53$export$79422073c7118b5b = ({ content: content, maxLines: maxLines = 1, message: message, name: name, className: className, testId: testId = 'smart-element-text', hideFormat: hideFormat = false, color: color })=>{
    if (!message && !content) return null;
    const dynamicCss = null;
    const newContent = hideFormat && content ? content : (0, $fpDmE.getFormattedMessage)(message) || content;
    const oldContent = (0, $fpDmE.getFormattedMessage)(message) || content;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-text": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_11c8dcr7 _1reo15vq _18m915vq _syaz131l _o5724jg8 _1e0ccj1k _1bto1l2s _1nmz1hna _sudp1e54",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_11c81o8v _1reo15vq _18m915vq _syaz1gjq _o5724jg8 _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _sudp1e54",
            "_1yyjr31u _102k1dud",
            className
        ]),
        style: {
            color: color && (0, $VSDnB.fg)('platform-linking-additional-flexible-element-props') ? color : undefined,
            "--_1erfju8": (0, $lD23V.default)(maxLines)
        },
        children: (0, $VSDnB.fg)('platform-linking-additional-flexible-element-props') ? newContent : oldContent
    });
};
var $0077ab6b3bad1a53$export$2e2bcd8739ae039 = $0077ab6b3bad1a53$export$79422073c7118b5b;

});

parcelRegister("1Lomb", function(module, exports) {

$parcel$export(module.exports, "default", () => $84eab550f66bf0cf$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jOyH3 = parcelRequire("jOyH3");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $8dVIb = parcelRequire("8dVIb");

var $9Hdrc = parcelRequire("9Hdrc");

var $l5Xsv = parcelRequire("l5Xsv");

var $fpDmE = parcelRequire("fpDmE");
const $84eab550f66bf0cf$var$styles = {
    container: "_1ul91ns9",
    iconWrapperStyle: "_1e0c1txw _4cvr1h6o _1bah1h6o"
};
const $84eab550f66bf0cf$var$positionStyleMap = {
    center: "_1wpz1h6o",
    top: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wpz1y6m"
};
const $84eab550f66bf0cf$var$customRenderStyleMap = {
    xlarge: "_1reo15vq _18m915vq _11c8nf1z _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kz42d",
    large: "_1reo15vq _18m915vq _11c8nf1z _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kz42d",
    medium: "_1reo15vq _18m915vq _11c8nbxd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kptym",
    small: "_1reo15vq _18m915vq _11c8nbxd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kptym"
};
const $84eab550f66bf0cf$var$renderAtlaskitIcon = (icon, testId, size = (0, $8dVIb.SmartLinkSize).Medium)=>{
    if (icon) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Hdrc.default), {
        icon: icon,
        testId: `${testId}-icon`,
        "aria-hidden": "true",
        label: "" // Since we already set aria-hidden="true", the label should be given an empty string
        ,
        size: size
    });
};
const $84eab550f66bf0cf$var$renderDefaultIcon = (label, testId)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
        label: label,
        testId: `${testId}-default`,
        color: "currentColor"
    });
const $84eab550f66bf0cf$var$renderImageIcon = (defaultIcon, url, testId, size = (0, $8dVIb.SmartLinkSize).Medium, appearance)=>{
    const width = size === (0, $8dVIb.SmartLinkSize).Large ? "var(--ds-space-300, 24px)" : "var(--ds-space-200, 16px)";
    if (url) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l5Xsv.default), {
        defaultIcon: defaultIcon,
        testId: testId,
        url: url,
        width: width,
        height: width,
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v2') && {
            appearance: appearance
        }
    });
};
/**
 * A base element that displays an Icon or favicon.
 * @internal
 * @param props - The props necessary for the Icon element.
 * @see LinkIcon
 */ const $84eab550f66bf0cf$var$IconElement = ({ icon: icon, overrideIcon: overrideIcon, label: label = 'Link', name: name, position: position = (0, $8dVIb.SmartLinkPosition).Top, className: className, render: render, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-element-icon', url: url, appearance: appearance = 'square' })=>{
    const element = (0, $5uXOq.useMemo)(()=>{
        const defaultIcon = $84eab550f66bf0cf$var$renderDefaultIcon(label, testId);
        return overrideIcon || render?.() || $84eab550f66bf0cf$var$renderImageIcon(defaultIcon, url, testId, size, (0, $VSDnB.fg)('platform-linking-visual-refresh-v2') ? appearance : undefined) || $84eab550f66bf0cf$var$renderAtlaskitIcon(icon, testId, size) || defaultIcon;
    }, [
        label,
        testId,
        overrideIcon,
        render,
        url,
        size,
        appearance,
        icon
    ]);
    const width = (0, $fpDmE.getIconWidth)(size);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-icon": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $84eab550f66bf0cf$var$styles.container,
            $84eab550f66bf0cf$var$positionStyleMap[position],
            render && $84eab550f66bf0cf$var$customRenderStyleMap[size],
            className
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            xcss: $84eab550f66bf0cf$var$styles.iconWrapperStyle,
            style: {
                width: width,
                height: width
            },
            children: element
        })
    });
};
var $84eab550f66bf0cf$export$2e2bcd8739ae039 = $84eab550f66bf0cf$var$IconElement;

});

parcelRegister("h2tJr", function(module, exports) {

$parcel$export(module.exports, "default", () => $eecdcb70dc9f547d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l5Xsv = parcelRequire("l5Xsv");
/**
 * Media: Image
 * [aspect-ratio: 16 / 9] The context box is fixed to aspect ratio of 16:9.
 * [object-fit: cover] The replaced content is sized to maintain
 * its aspect ratio while filling the element's entire content box.
 * If the object's aspect ratio does not match the aspect ratio of its box,
 * then the object will be clipped to fit.
 * [object-position] Center alignment of the selected replaced element's
 * contents within the element's box.
 */ const $eecdcb70dc9f547d$var$styles = null;
/**
 * A base element that displays a Media.
 * @internal
 * @param props - The props necessary for the Media element.
 */ const $eecdcb70dc9f547d$var$MediaElement = ({ name: name, className: className, testId: testId = 'smart-element-media', type: type, url: url, onLoad: onLoad, onError: onError })=>{
    if (!type || !url) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-smart-element": name,
        "data-smart-element-media": type,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_1h1tcq2i _1e0c1txw _1bsb1osq _4t3i1ns9 _jqez1osq _1lg71osq _6slq1osq _x1m21osq _1chb1osq _1usb1osq _5c331osq _l9z01osq _6o691dfr _vr2g1dfr _173baqso _1niwaqso _t0h9stnw _1ulbstnw _byj21ooe _3hvr1ooe _1c0s1ssb _15j31ssb _1npy1ssb _19he1ssb _n3vc1wug _1qj91wug _4fdy1wug _18cv1wug _1aoq15vq _1iqz15vq _6fioj63w _l0jmidpf _12zuh2mm",
            className
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l5Xsv.default), {
            testId: `${testId}-image`,
            url: url,
            onError: onError,
            onLoad: onLoad,
            defaultIcon: null
        })
    });
};
var $eecdcb70dc9f547d$export$2e2bcd8739ae039 = $eecdcb70dc9f547d$var$MediaElement;

});


parcelRegister("4gwhW", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf6cfae5130c42ed$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $h2tJr = parcelRequire("h2tJr");
const $cf6cfae5130c42ed$var$PreviewElement = (props)=>{
    const { overrideUrl: overrideUrl, ...rest } = props ?? {};
    const context = (0, $VSDnB.fg)('platform-linking-flexible-card-context') ? (0, $Nh1XU.useFlexibleUiContext)() : (0, $5uXOq.useContext)((0, $Nh1XU.FlexibleUiContext));
    const data = overrideUrl ? {
        url: overrideUrl,
        type: (0, $8dVIb.MediaType).Image
    } : context?.preview;
    if (!data) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h2tJr.default), {
        ...rest,
        ...data
    });
};
var $cf6cfae5130c42ed$export$2e2bcd8739ae039 = $cf6cfae5130c42ed$var$PreviewElement;

});

parcelRegister("kp8aU", function(module, exports) {

$parcel$export(module.exports, "default", () => $673e9555bded0d05$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $Nh1XU = parcelRequire("Nh1XU");

var $eL5Me = parcelRequire("eL5Me");
const $673e9555bded0d05$var$SNIPPET_DEFAULT_MAX_LINES = 3;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $673e9555bded0d05$var$snippetBaseStyleOld = null;
const $673e9555bded0d05$var$snippetBaseStyle = null;
const $673e9555bded0d05$var$SnippetElement = (props)=>{
    const { content: overrideContent, maxLines: maxLines = $673e9555bded0d05$var$SNIPPET_DEFAULT_MAX_LINES, className: className, ...restOfProps } = props ?? {};
    const context = (0, $VSDnB.fg)('platform-linking-flexible-card-context') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $Nh1XU.useFlexibleUiContext)() : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useContext)((0, $Nh1XU.FlexibleUiContext));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eL5Me.default), {
        content: overrideContent ?? context?.snippet,
        maxLines: maxLines,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_syaz1fxt _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_syaz1fxt _1ul9idpf _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        ...restOfProps
    });
};
var $673e9555bded0d05$export$2e2bcd8739ae039 = $673e9555bded0d05$var$SnippetElement;

});


parcelRegister("bubxq", function(module, exports) {

$parcel$export(module.exports, "default", () => $66554651c27d9387$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ousew = parcelRequire("ousew");

var $gKZoD = parcelRequire("gKZoD");

var $ldJSL = parcelRequire("ldJSL");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");

var $bJeNF = parcelRequire("bJeNF");

var $VSDnB = parcelRequire("VSDnB");

var $3bDjY = parcelRequire("3bDjY");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $fpDmE = parcelRequire("fpDmE");

var $akF1x = parcelRequire("akF1x");

var $3Zm9O = parcelRequire("3Zm9O");
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $66554651c27d9387$var$stylesOld = null;
const $66554651c27d9387$var$styles = null;
const $66554651c27d9387$var$renderActionItems = (items = [], size = (0, $8dVIb.SmartLinkSize).Medium, appearance, asDropDownItems, onActionItemClick)=>items.map((item, idx)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Zm9O.default), {
            item: item,
            size: size,
            appearance: appearance,
            asDropDownItems: asDropDownItems,
            onActionItemClick: onActionItemClick
        }, idx));
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $66554651c27d9387$var$ActionGroup = ({ items: items = [], size: size = (0, $8dVIb.SmartLinkSize).Medium, appearance: appearance, visibleButtonsNum: visibleButtonsNum = 2, onDropdownOpenChange: onDropdownOpenChange })=>{
    (0, $gKZoD.di)((0, $BLPHT.default));
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const ui = (0, $Nh1XU.useFlexibleUiOptionContext)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const renderableActionItems = (0, $5uXOq.useMemo)(()=>(0, $akF1x.filterActionItems)(items, context), [
        context,
        items
    ]);
    const isMoreThenTwoItems = renderableActionItems.length > visibleButtonsNum;
    const onOpenChange = (0, $5uXOq.useCallback)((attrs)=>{
        setIsOpen(attrs.isOpen);
        if (onDropdownOpenChange) onDropdownOpenChange(attrs.isOpen);
    }, [
        onDropdownOpenChange
    ]);
    const onActionItemClick = (0, $5uXOq.useCallback)(()=>{
        if (isOpen) onOpenChange({
            isOpen: false
        });
    }, [
        isOpen,
        onOpenChange
    ]);
    const actionButtons = (0, $5uXOq.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(0, visibleButtonsNum - 1) : renderableActionItems;
        return $66554651c27d9387$var$renderActionItems(actionItems, size, appearance, false, onActionItemClick);
    }, [
        appearance,
        isMoreThenTwoItems,
        onActionItemClick,
        renderableActionItems,
        size,
        visibleButtonsNum
    ]);
    const moreActionDropdown = (0, $5uXOq.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(visibleButtonsNum - 1) : [];
        if (actionItems.length > 0) {
            const spacing = (0, $fpDmE.sizeToButtonSpacing)[size];
            const moreIcon = /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))), {
                label: "more",
                color: "currentColor"
            });
            const formatMessage = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages).more_actions
            });
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $BLPHT.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                        content: formatMessage,
                        hideTooltipOnClick: true,
                        testId: "action-group-more-button-tooltip",
                        tag: "span",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                            ...props,
                            spacing: spacing,
                            testId: "action-group-more-button",
                            iconBefore: moreIcon,
                            ref: triggerRef
                        })
                    }),
                testId: "action-group-dropdown",
                zIndex: ui?.zIndex,
                children: $66554651c27d9387$var$renderActionItems(actionItems, size, appearance, true, onActionItemClick)
            });
        }
        return null;
    }, [
        appearance,
        isMoreThenTwoItems,
        isOpen,
        onActionItemClick,
        onOpenChange,
        renderableActionItems,
        size,
        ui?.zIndex,
        visibleButtonsNum
    ]);
    return renderableActionItems.length > 0 ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1e0c116y _vwz41j6v _dzc21h6o _1ilq1i6y",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1e0c116y _dzc21h6o _1ilq1i6y",
            "actions-button-group"
        ]),
        "data-action-open": isOpen,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ldJSL.default), {
            children: [
                actionButtons,
                moreActionDropdown
            ]
        })
    }) : null;
};
var $66554651c27d9387$export$2e2bcd8739ae039 = $66554651c27d9387$var$ActionGroup;

});
parcelRegister("akF1x", function(module, exports) {

$parcel$export(module.exports, "filterActionItems", () => $8ba323b39584fd77$export$adbd04236f07a7d8);
$parcel$export(module.exports, "renderChildren", () => $8ba323b39584fd77$export$cd762ccf1a583d69);
$parcel$export(module.exports, "renderElementItems", () => $8ba323b39584fd77$export$9678d3ca18bd7526);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $91tw3 = parcelRequire("91tw3");

var $eqoQu = parcelRequire("eqoQu");

var $bubxq = parcelRequire("bubxq");

var $1BfaB = parcelRequire("1BfaB");
const $8ba323b39584fd77$export$f942619ce67b1a41 = {
    [(0, $8dVIb.ElementName).AssignedTo]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).AssignedToGroup]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).AttachmentCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).AuthorGroup]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).AppliedToComponentsCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ChecklistProgress]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).CollaboratorGroup]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).CommentCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).CreatedBy]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).CreatedOn]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).DueOn]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).LatestCommit]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).LinkIcon]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).Location]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ModifiedBy]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ModifiedOn]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).OwnedBy]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).OwnedByGroup]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).Preview]: [
        'block'
    ],
    [(0, $8dVIb.ElementName).Priority]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ProgrammingLanguage]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).Provider]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ReactCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ReadTime]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).Snippet]: [
        'block'
    ],
    [(0, $8dVIb.ElementName).SourceBranch]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).SentOn]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).State]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).SubscriberCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).SubTasksProgress]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).StoryPoints]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).TargetBranch]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).Title]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ViewCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).VoteCount]: [
        'inline'
    ]
};
const $8ba323b39584fd77$export$ff20be09ae01c52e = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return 1.25;
        case (0, $8dVIb.SmartLinkSize).Large:
            return 1;
        case (0, $8dVIb.SmartLinkSize).Medium:
            return 0.5;
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return 0.25;
    }
};
const $8ba323b39584fd77$var$isActionGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node) && node.type === (0, $bubxq.default);
const $8ba323b39584fd77$var$isElementDisplayValid = (name, display)=>{
    return $8ba323b39584fd77$export$f942619ce67b1a41[name]?.includes(display) ?? false;
};
const $8ba323b39584fd77$export$f2c7ad0961800b16 = (children)=>{
    return Boolean(children.type() === null);
};
const $8ba323b39584fd77$var$isElementOrElementGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node) && ((0, $91tw3.isFlexibleUiElement)(node) || node.type === (0, $1BfaB.default));
const $8ba323b39584fd77$export$adbd04236f07a7d8 = (items = [], context)=>{
    return items.filter((item)=>{
        switch(item.name){
            case (0, $8dVIb.ActionName).DeleteAction:
            case (0, $8dVIb.ActionName).EditAction:
            case (0, $8dVIb.ActionName).CustomAction:
                // Named and custom actions that user defines.
                return Boolean((0, $8dVIb.ActionName)[item.name]);
            default:
                // Action that require data from the data context to render.
                if (context?.actions === undefined) return false;
                return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
        }
    });
};
const $8ba323b39584fd77$export$cd762ccf1a583d69 = (children, size)=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children, (child)=>{
        if ($8ba323b39584fd77$var$isElementOrElementGroup(child) || $8ba323b39584fd77$var$isActionGroup(child)) {
            const node = child;
            const { size: childSize } = node.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(node, {
                size: childSize || size
            });
        }
        return child;
    });
const $8ba323b39584fd77$export$9678d3ca18bd7526 = (items = [], display = 'inline')=>{
    const elements = items.reduce((acc, curr, idx)=>{
        const { name: name, ...props } = curr;
        const Element = $eqoQu[name];
        const typedProps = props;
        if (Element && $8ba323b39584fd77$var$isElementDisplayValid(name, display)) {
            const element = /*#__PURE__*/ (0, $2OMIu.jsx)(Element, {
                ...typedProps
            }, idx);
            if (!$8ba323b39584fd77$export$f2c7ad0961800b16(element)) return [
                ...acc,
                element
            ];
        }
        return acc;
    }, []);
    if (elements.length) return elements;
};

});
parcelRegister("1BfaB", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed56962f49dee3a8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $akF1x = parcelRequire("akF1x");
const $ed56962f49dee3a8$var$alignmentStyleMap = {
    right: "_1dthh9n0 _r291h9n0 _1bahesu3 _y3gnusic",
    left: "_1dthv2br _r291v2br _1bah1y6m _y3gn1e5h"
};
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $ed56962f49dee3a8$var$baseStyleBySizeOld = {
    xlarge: "_zulp147b _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v",
    large: "_zulp1e9d _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v",
    medium: "_zulpcxkx _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v",
    small: "_zulppdf9 _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v"
};
const $ed56962f49dee3a8$var$baseStyleBySize = {
    xlarge: "_zulpv47k _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    large: "_zulppxbi _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    medium: "_zulpu2gc _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    small: "_zulp1b66 _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf"
};
const $ed56962f49dee3a8$var$baseStyleByDirection = {
    horizontal: "_2lx2vrvc _4cvr1h6o",
    vertical: "_2lx21bp4 _4cvr1y6m"
};
const $ed56962f49dee3a8$var$baseStyleOld = null;
const $ed56962f49dee3a8$var$baseStyles = null;
const $ed56962f49dee3a8$var$widthStyle = {
    flexible: "_16jlkb7n _1o9z11wp _i0dlf1ug",
    'fit-to-content': ""
};
const $ed56962f49dee3a8$var$positionStyle = {
    top: "_1wpz1y6m",
    center: ""
};
const $ed56962f49dee3a8$var$horizontalStyleBase = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $ed56962f49dee3a8$var$horizontalStyleByHeightOld = {
    xlarge: "_1e0ccj1k _102k1m1q",
    large: "_1e0ccj1k _102k1m1q",
    medium: "_1e0ccj1k _102k1k8s",
    small: "_1e0ccj1k _102k1k8s"
};
const $ed56962f49dee3a8$var$horizontalStyleByHeight = {
    xlarge: "_1e0ccj1k _102k125z",
    large: "_1e0ccj1k _102k125z",
    medium: "_1e0ccj1k _102kz42d",
    small: "_1e0ccj1k _102kz42d"
};
const $ed56962f49dee3a8$var$gapStylesLeft = {
    xlarge: "_7yhbv47k _m6ukidpf",
    large: "_7yhbpxbi _m6ukidpf",
    medium: "_7yhbu2gc _m6ukidpf",
    small: "_7yhb1b66 _m6ukidpf"
};
const $ed56962f49dee3a8$var$gapStylesRight = {
    xlarge: "_24rcv47k _3dveidpf",
    large: "_24rcpxbi _3dveidpf",
    medium: "_24rcu2gc _3dveidpf",
    small: "_24rc1b66 _3dveidpf"
};
const $ed56962f49dee3a8$var$minWidthStyle = null;
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $ed56962f49dee3a8$var$ElementGroup = ({ align: align = (0, $8dVIb.SmartLinkAlignment).Left, children: children, direction: direction = (0, $8dVIb.SmartLinkDirection).Horizontal, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-element-group', width: width = (0, $8dVIb.SmartLinkWidth).FitToContent, position: position = (0, $8dVIb.SmartLinkPosition).Center, className: className })=>{
    const isHorizontal = direction === (0, $8dVIb.SmartLinkDirection).Horizontal;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-smart-element-group": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $ed56962f49dee3a8$var$baseStyleBySizeOld[size],
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $ed56962f49dee3a8$var$baseStyleBySize[size],
            $ed56962f49dee3a8$var$baseStyleByDirection[direction],
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_fiawglyw _1ouwidpf _f6ju1ns9",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_fiawglyw",
            $ed56962f49dee3a8$var$alignmentStyleMap[align],
            "_1ul99by0",
            $ed56962f49dee3a8$var$widthStyle[width],
            isHorizontal && "_1reo15vq _18m915vq _1e0c1ule _s7n4nkob _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _1aaynkob _15tynkob _1iu61nu9 _166k1nu9 _1div1nu9 _bmfb1nu9",
            isHorizontal && !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $ed56962f49dee3a8$var$horizontalStyleByHeightOld[size],
            isHorizontal && (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $ed56962f49dee3a8$var$horizontalStyleByHeight[size],
            isHorizontal && align === (0, $8dVIb.SmartLinkAlignment).Left && $ed56962f49dee3a8$var$gapStylesLeft[size],
            isHorizontal && align === (0, $8dVIb.SmartLinkAlignment).Right && $ed56962f49dee3a8$var$gapStylesRight[size],
            $ed56962f49dee3a8$var$positionStyle[position],
            className
        ]),
        children: (0, $akF1x.renderChildren)(children, size)
    });
};
var $ed56962f49dee3a8$export$2e2bcd8739ae039 = $ed56962f49dee3a8$var$ElementGroup;

});


parcelRegister("3Zm9O", function(module, exports) {

$parcel$export(module.exports, "default", () => $70338cdeec0a99e7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jRHKj = parcelRequire("jRHKj");
const $70338cdeec0a99e7$var$ActionGroupItem = ({ item: item, size: size, appearance: appearance, asDropDownItems: asDropDownItems, onActionItemClick: onActionItemClick })=>{
    const { name: name, hideContent: hideContent, hideIcon: hideIcon, onClick: onClick, isDisabled: isDisabled, ...props } = item;
    const handleOnClick = (0, $5uXOq.useCallback)(()=>{
        if (onActionItemClick) onActionItemClick();
        if (onClick) onClick();
    }, [
        onActionItemClick,
        onClick
    ]);
    const Action = name in $jRHKj ? $jRHKj[name] : undefined;
    if (!Action) return null;
    const actionProps = {
        ...props
    };
    if (hideContent && !asDropDownItems) actionProps.content = '';
    if (hideIcon) actionProps.icon = undefined;
    if (item?.entryPointWrapper) actionProps.wrapper = item.entryPointWrapper;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Action, {
        asDropDownItem: asDropDownItems,
        size: size,
        appearance: appearance,
        onClick: handleOnClick,
        isDisabled: isDisabled,
        ...actionProps
    });
};
var $70338cdeec0a99e7$export$2e2bcd8739ae039 = $70338cdeec0a99e7$var$ActionGroupItem;

});
parcelRegister("jRHKj", function(module, exports) {

$parcel$export(module.exports, "CustomAction", () => (parcelRequire("23vM5")).default);
$parcel$export(module.exports, "DeleteAction", () => (parcelRequire("96Kdz")).default);
$parcel$export(module.exports, "EditAction", () => (parcelRequire("fEhHT")).default);
$parcel$export(module.exports, "DownloadAction", () => (parcelRequire("g9G65")).default);
$parcel$export(module.exports, "FollowAction", () => (parcelRequire("b6Mes")).default);
$parcel$export(module.exports, "PreviewAction", () => (parcelRequire("9mTP8")).default);
$parcel$export(module.exports, "CopyLinkAction", () => (parcelRequire("jep3X")).default);
$parcel$export(module.exports, "UnresolvedAction", () => (parcelRequire("erAKX")).default);
$parcel$export(module.exports, "AISummaryAction", () => (parcelRequire("ziZLe")).default);
$parcel$export(module.exports, "AutomationAction", () => (parcelRequire("5OUwn")).default);
$parcel$export(module.exports, "ViewRelatedLinksAction", () => (parcelRequire("faTeC")).default);

var $23vM5 = parcelRequire("23vM5");

var $96Kdz = parcelRequire("96Kdz");

var $fEhHT = parcelRequire("fEhHT");

var $g9G65 = parcelRequire("g9G65");

var $b6Mes = parcelRequire("b6Mes");

var $9mTP8 = parcelRequire("9mTP8");

var $jep3X = parcelRequire("jep3X");

var $erAKX = parcelRequire("erAKX");

var $ziZLe = parcelRequire("ziZLe");

var $5OUwn = parcelRequire("5OUwn");

var $faTeC = parcelRequire("faTeC");

});
parcelRegister("23vM5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bf7d27623ce3bf9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $f6kZQ = parcelRequire("f6kZQ");

var $kuVc8 = parcelRequire("kuVc8");

var $bhB72 = parcelRequire("bhB72");

var $1wpdl = parcelRequire("1wpdl");
/**
 * A base action that can be triggered with an on click.
 * @internal
 * @param {ActionProps} ActionProps - The props necessary for the Action.
 */ const $1bf7d27623ce3bf9$var$Action = ({ as: as, appearance: appearance = 'subtle', content: content, isLoading: isLoading = false, onClick: onClick, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-action', icon: icon, iconPosition: iconPosition = 'before', spaceInline: spaceInline, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltip: hideTooltip, hideTooltipOnMouseDown: hideTooltipOnMouseDown, style: style, asDropDownItem: asDropDownItem, className: className, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, wrapper: Wrapper })=>{
    if (!onClick) return null;
    const isStackItem = as === 'stack-item';
    const isDropdownItem = as === 'dropdown-item' || asDropDownItem;
    const actionIcon = icon ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bhB72.default), {
        asStackItemIcon: isStackItem,
        isDisabled: isDisabled,
        icon: icon,
        size: size,
        testId: testId
    }) : undefined;
    const iconBefore = icon && iconPosition === 'before' ? actionIcon : undefined;
    const iconAfter = icon && iconPosition === 'after' ? actionIcon : undefined;
    if (isStackItem) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1wpdl.default), {
        content: content,
        icon: actionIcon,
        space: spaceInline,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onClick,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        tooltipOnHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        hideTooltip: hideTooltip
    });
    if (isDropdownItem) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kuVc8.default), {
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        testId: testId
    });
    const button = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f6kZQ.default), {
        appearance: appearance,
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        isDisabled: isDisabled,
        href: href,
        ariaLabel: ariaLabel
    });
    return Wrapper !== undefined ? /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapper, {
        children: button
    }) : button;
};
var $1bf7d27623ce3bf9$export$2e2bcd8739ae039 = $1bf7d27623ce3bf9$var$Action;

});
parcelRegister("f6kZQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3ee32ab04698fad$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $2rqOp = parcelRequire("2rqOp");

var $eCeGD = parcelRequire("eCeGD");
var $42CjB = parcelRequire("42CjB");
var $1GGwS = parcelRequire("1GGwS");
var $krXdA = parcelRequire("krXdA");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $3bDjY = parcelRequire("3bDjY");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $3dubP = parcelRequire("3dubP");

var $fpDmE = parcelRequire("fpDmE");
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $b3ee32ab04698fad$var$IconOnlyLarge = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $b3ee32ab04698fad$var$SizeSmall = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $b3ee32ab04698fad$var$SizeSmallIconOnly = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $b3ee32ab04698fad$var$SizeSmallNotIconOnly = null;
const $b3ee32ab04698fad$var$IconButtonAppearanceMap = {
    default: 'default',
    danger: undefined,
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: undefined
};
const $b3ee32ab04698fad$var$ButtonAppearanceMap = {
    default: 'default',
    danger: 'danger',
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: 'warning'
};
const $b3ee32ab04698fad$var$tooltipOptions = {
    hideTooltipOnClick: true
};
const $b3ee32ab04698fad$var$ActionButtonRefreshNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel }, ref)=>{
    const iconOnly = !content;
    const onButtonClick = (0, $5uXOq.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    const button = (0, $5uXOq.useMemo)(()=>{
        const isLinkButton = !!href;
        const spacing = size === (0, $8dVIb.SmartLinkSize).Large || size === (0, $8dVIb.SmartLinkSize).XLarge ? 'default' : 'compact';
        if (iconOnly) {
            const icon = iconBefore || iconAfter;
            const iconFn = ()=>icon || null;
            if (isLinkButton) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $krXdA.default), {
                appearance: $b3ee32ab04698fad$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                href: href,
                isDisabled: isDisabled,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $b3ee32ab04698fad$var$tooltipOptions
            });
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                appearance: $b3ee32ab04698fad$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $b3ee32ab04698fad$var$tooltipOptions
            });
        }
        const iconBeforeFn = ()=>iconBefore || null;
        const iconAfterFn = ()=>iconAfter || null;
        if (isLinkButton) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1GGwS.default), {
                appearance: $b3ee32ab04698fad$var$ButtonAppearanceMap[appearance],
                "aria-label": ariaLabel,
                iconAfter: iconAfterFn,
                iconBefore: iconBeforeFn,
                isDisabled: isDisabled,
                href: href,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                children: content
            })
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                appearance: $b3ee32ab04698fad$var$ButtonAppearanceMap[appearance],
                "aria-label": ariaLabel,
                iconAfter: iconAfterFn,
                iconBefore: iconBeforeFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                children: content
            })
        });
    }, [
        appearance,
        ariaLabel,
        content,
        href,
        iconAfter,
        iconBefore,
        iconOnly,
        isDisabled,
        isLoading,
        onButtonClick,
        onClick,
        size,
        testId,
        tooltipMessage
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        testId: `${testId}-button-wrapper`,
        ref: ref,
        children: button
    });
});
// On cleanup of platform-linking-visual-refresh-v1, this should become
// export default withOverrideCss(ActionButton);
const $b3ee32ab04698fad$var$ActionButtonRefreshNewWithOverrideCss = (0, $3dubP.withOverrideCss)($b3ee32ab04698fad$var$ActionButtonRefreshNew);
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $b3ee32ab04698fad$var$ActionButtonNew = ({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, className: className })=>{
    const iconOnly = !content;
    const onButtonClick = (0, $5uXOq.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            size === (0, $8dVIb.SmartLinkSize).Large && iconOnly && "_1gflidpf _or3fidpf _1ddvidpf _1hhaidpf _yhjmidpf _1trnidpf _1fstidpf _1xceidpf _1gqnidpf _1qdmidpf _df2ridpf _j1twidpf _11lvidpf _192bidpf _vbn7idpf _wfu3idpf _1i3bidpf _13gwidpf _4wlcidpf _rehaidpf _mp2fidpf _ro8midpf _1l0qidpf _1bnaidpf _3kh9idpf _i2vxidpf _8pvjidpf _1e1oidpf _1vtwidpf _ijvwidpf _tpwpidpf _1ad8idpf",
            size === (0, $8dVIb.SmartLinkSize).Small && "_11c8dcr7 _k48p1wq8",
            size === (0, $8dVIb.SmartLinkSize).Small && iconOnly && "_1gfl1xvx _or3f1xvx _1ddv1xvx _1hha1xvx _yhjm1xvx _1trn1xvx _1fst1xvx _1xce1xvx _1gqn1xvx _1qdm1xvx _df2r1xvx _j1tw1xvx _11lv1xvx _192b1xvx _vbn71xvx _wfu31xvx",
            size === (0, $8dVIb.SmartLinkSize).Small && !iconOnly && "_11lvpdf9 _192bpdf9 _vbn7pdf9 _wfu3pdf9 _yhjmpdf9 _1trnpdf9 _1fstpdf9 _1xcepdf9",
            className
        ]),
        "data-testid": `${testId}-button-wrapper`,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2rqOp.default), {
                appearance: appearance,
                iconAfter: iconAfter,
                iconBefore: iconBefore,
                isDisabled: isDisabled,
                isLoading: isLoading,
                onClick: onButtonClick(onClick),
                spacing: (0, $fpDmE.sizeToButtonSpacing)[size],
                testId: testId,
                href: href,
                "aria-label": ariaLabel,
                children: content
            })
        })
    });
};
const $b3ee32ab04698fad$var$ActionButtonHideLegacyButton = (props)=>{
    const ui = (0, $Nh1XU.useFlexibleUiOptionContext)();
    if (ui?.hideLegacyButton || ui?.removeBlockRestriction && (0, $VSDnB.fg)('platform-linking-flexible-card-openness')) return /*#__PURE__*/ (0, $2OMIu.jsx)($b3ee32ab04698fad$var$ActionButtonRefreshNewWithOverrideCss, {
        ...props
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($b3ee32ab04698fad$var$ActionButtonNew, {
        ...props
    });
};
const $b3ee32ab04698fad$var$ActionButton = (props)=>{
    return (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? /*#__PURE__*/ (0, $2OMIu.jsx)($b3ee32ab04698fad$var$ActionButtonHideLegacyButton, {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($b3ee32ab04698fad$var$ActionButtonNew, {
        ...props
    });
};
var $b3ee32ab04698fad$export$2e2bcd8739ae039 = $b3ee32ab04698fad$var$ActionButton;

});

parcelRegister("kuVc8", function(module, exports) {

$parcel$export(module.exports, "default", () => $e656bda53d041540$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $kxcRq = parcelRequire("kxcRq");
const $e656bda53d041540$var$ActionDropdownItem = ({ content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
        elemAfter: iconAfter,
        elemBefore: iconBefore,
        isDisabled: isLoading,
        onClick: (0, $kxcRq.handleOnClick)(onClick),
        testId: testId,
        children: content
    });
var $e656bda53d041540$export$2e2bcd8739ae039 = $e656bda53d041540$var$ActionDropdownItem;

});

parcelRegister("bhB72", function(module, exports) {

$parcel$export(module.exports, "default", () => $345d01659b23eb38$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");
const $345d01659b23eb38$var$getIconWidth = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
        case (0, $8dVIb.SmartLinkSize).Large:
            return '1.5rem';
        case (0, $8dVIb.SmartLinkSize).Medium:
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return '1rem';
    }
};
// TODO: Remove on fg cleanup: platform-visual-refresh-icons
const $345d01659b23eb38$var$iconSizeStyleMap = {
    '1.5rem': "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1k8s _1tke1k8s _c71l1k8s _1bsb1k8s _1ul91k8s _p12f1k8s _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71k8s _1xjx1k8s _17521k8s _qci81k8s _15iz1k8s _erub1k8s _19l31k8s _1pr21k8s _1u5t1k8s _mezj1k8s _e2oo1k8s _w8l51k8s _1rg21k8s _q7cv1k8s _xwbj1k8s _rtys1k8s _b8nk1k8s _4x201k8s",
    '1rem': "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1j6v _1tke1j6v _c71l1j6v _1bsb1j6v _1ul91j6v _p12f1j6v _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71j6v _1xjx1j6v _17521j6v _qci81j6v _15iz1j6v _erub1j6v _19l31j6v _1pr21j6v _1u5t1j6v _mezj1j6v _e2oo1j6v _w8l51j6v _1rg21j6v _q7cv1j6v _xwbj1j6v _rtys1j6v _b8nk1j6v _4x201j6v",
    '20px': "_16jlidpf _1o9zidpf _i0dl1wug _4t3igktf _1tkegktf _c71lgktf _1bsbgktf _1ul9gktf _p12fgktf _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna7gktf _1xjxgktf _1752gktf _qci8gktf _15izgktf _erubgktf _19l3gktf _1pr2gktf _1u5tgktf _mezjgktf _e2oogktf _w8l5gktf _1rg2gktf _q7cvgktf _xwbjgktf _rtysgktf _b8nkgktf _4x20gktf"
};
// TODO: Remove on fg cleanup: platform-visual-refresh-icons
const $345d01659b23eb38$var$stackItemIconStylesOld = null;
const $345d01659b23eb38$var$stackItemIconStylesCompiled = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $345d01659b23eb38$var$iconStyleMap = {
    true: "_syaz2oi6",
    false: "_syazwdcn"
};
const $345d01659b23eb38$var$ActionIcon = ({ size: size, testId: testId, icon: icon, isDisabled: isDisabled, asStackItemIcon: asStackItemIcon })=>{
    if (!(0, $VSDnB.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $345d01659b23eb38$var$iconStyleMap[isDisabled ? 'true' : 'false'],
            asStackItemIcon && "_1e0c1o8l _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o",
            asStackItemIcon && $345d01659b23eb38$var$iconSizeStyleMap['20px'],
            !asStackItemIcon && $345d01659b23eb38$var$iconSizeStyleMap[$345d01659b23eb38$var$getIconWidth(size)]
        ]),
        children: icon
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $345d01659b23eb38$var$iconStyleMap[isDisabled ? 'true' : 'false'],
            "_1e0c1o8l"
        ]),
        children: icon
    });
};
var $345d01659b23eb38$export$2e2bcd8739ae039 = $345d01659b23eb38$var$ActionIcon;

});

parcelRegister("1wpdl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6ef8f3a6ac7d3ff$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $5PILj = parcelRequire("5PILj");
const $c6ef8f3a6ac7d3ff$var$ActionStackItem = ({ content: content, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltipOnMouseDown: hideTooltipOnMouseDown, hideTooltip: hideTooltip, ...props })=>hideTooltip ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5PILj.default), {
        ...props,
        content: content
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: tooltipMessage || content,
        onHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5PILj.default), {
                ...props,
                content: content,
                tooltipProps: tooltipProps
            })
    });
var $c6ef8f3a6ac7d3ff$export$2e2bcd8739ae039 = $c6ef8f3a6ac7d3ff$var$ActionStackItem;

});
parcelRegister("5PILj", function(module, exports) {

$parcel$export(module.exports, "default", () => $222d00bebc6cbf68$export$2e2bcd8739ae039);
/* action-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
var $3Lty3 = parcelRequire("3Lty3");

var $eZJjh = parcelRequire("eZJjh");

var $fpDmE = parcelRequire("fpDmE");

var $bhB72 = parcelRequire("bhB72");
const $222d00bebc6cbf68$var$stylesOld = {
    button: "_kkk2n7od _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1bsb1osq _irr3166n _1di61dty",
    content: "_11c8dcr7 _syaz1fxt"
};
const $222d00bebc6cbf68$var$styles = {
    button: "_bfhk1w7a _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1bsb1osq _1ah31i6y _irr3166n _1di61dty",
    content: "_11c81o8v _syaz1fxt"
};
const $222d00bebc6cbf68$var$ActionButton = ({ content: content, icon: iconOption, isDisabled: isDisabled, isLoading: isLoading, onClick: onClickCallback, size: size, space: spaceOption, testId: testId, tooltipProps: tooltipProps, style: style })=>{
    const space = spaceOption ?? (0, $fpDmE.getPrimitivesInlineSpaceBySize)(size);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (!isDisabled && !isLoading && onClickCallback) onClickCallback();
    }, [
        isDisabled,
        isLoading,
        onClickCallback
    ]);
    const icon = iconOption && isLoading ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bhB72.default), {
        asStackItemIcon: true,
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
            testId: `${testId}-loading`
        }),
        size: size
    }) : iconOption;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
        xcss: (0, $3JT92.cx)(!(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $222d00bebc6cbf68$var$stylesOld.button, (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $222d00bebc6cbf68$var$styles.button),
        ...tooltipProps,
        onClick: onClick,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
            alignBlock: "center",
            grow: "fill",
            space: space,
            children: [
                icon,
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    xcss: (0, $3JT92.cx)(!(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $222d00bebc6cbf68$var$stylesOld.content, (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $222d00bebc6cbf68$var$styles.content),
                    children: content
                })
            ]
        })
    });
};
var $222d00bebc6cbf68$export$2e2bcd8739ae039 = $222d00bebc6cbf68$var$ActionButton;

});



parcelRegister("96Kdz", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddac835e19e975e0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $84THj = parcelRequire("84THj");

var $7zaVw = parcelRequire("7zaVw");

var $23vM5 = parcelRequire("23vM5");
const $ddac835e19e975e0$var$DeleteAction = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).delete
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($84THj))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Delete"
        }),
        testId: "smart-action-delete-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).delete
        }),
        ...props
    });
var $ddac835e19e975e0$export$2e2bcd8739ae039 = $ddac835e19e975e0$var$DeleteAction;

});

parcelRegister("fEhHT", function(module, exports) {

$parcel$export(module.exports, "default", () => $23e1c92ea69f35be$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $4ChK1 = parcelRequire("4ChK1");

var $7zaVw = parcelRequire("7zaVw");

var $23vM5 = parcelRequire("23vM5");
const $23e1c92ea69f35be$var$EditAction = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).edit
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4ChK1))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Edit"
        }),
        testId: "smart-action-edit-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).edit
        }),
        ...props
    });
var $23e1c92ea69f35be$export$2e2bcd8739ae039 = $23e1c92ea69f35be$var$EditAction;

});
parcelRegister("4ChK1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::631c9d525a923bb24b78f7aa2d70d92c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $35c87913ec905242$var$_react = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $35c87913ec905242$var$_edit = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("5nRKm")));

var $35c87913ec905242$var$_edit2 = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("gsEeL")));
function $35c87913ec905242$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $35c87913ec905242$var$EditIcon = (props)=>/*#__PURE__*/ $35c87913ec905242$var$_react.default.createElement($35c87913ec905242$var$_edit.default, Object.assign({
        LEGACY_fallbackIcon: $35c87913ec905242$var$_edit2.default
    }, props));
$35c87913ec905242$var$EditIcon.Name = 'EditIconMigration';
var $35c87913ec905242$var$_default = module.exports.default = $35c87913ec905242$var$EditIcon;

});
parcelRegister("gsEeL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfbe7921991bc4cb$var$_react = $bfbe7921991bc4cb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $bfbe7921991bc4cb$var$_edit = $bfbe7921991bc4cb$var$_interopRequireDefault((parcelRequire("5nRKm")));
function $bfbe7921991bc4cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bfbe7921991bc4cb$var$EditIcon = (props)=>/*#__PURE__*/ $bfbe7921991bc4cb$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $bfbe7921991bc4cb$var$_edit.default
    }));
$bfbe7921991bc4cb$var$EditIcon.displayName = 'EditIcon';
var $bfbe7921991bc4cb$var$_default = module.exports.default = $bfbe7921991bc4cb$var$EditIcon;

});



parcelRegister("g9G65", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fb79986052b65c1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $d4dv2 = parcelRequire("d4dv2");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $iPVbQ = parcelRequire("iPVbQ");

var $23vM5 = parcelRequire("23vM5");
const $4fb79986052b65c1$var$DownloadAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const invoke = (0, $iPVbQ.default)({});
    const data = context?.actions?.[(0, $8dVIb.ActionName).DownloadAction];
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const label = isStackItem ? (0, $7zaVw.messages).download_file : (0, $7zaVw.messages).download;
    const tooltipMessage = isStackItem ? (0, $7zaVw.messages).download_description : (0, $7zaVw.messages).download;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...label
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d4dv2))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Download"
        }),
        onClick: onClick,
        testId: "smart-action-download-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...tooltipMessage
        }),
        ...data,
        ...props
    }) : null;
};
var $4fb79986052b65c1$export$2e2bcd8739ae039 = $4fb79986052b65c1$var$DownloadAction;

});
parcelRegister("d4dv2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::647640fe09afef5813e2888b2ce1f074>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $98361ed174bfbb2b$var$_react = $98361ed174bfbb2b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $98361ed174bfbb2b$var$_download = $98361ed174bfbb2b$var$_interopRequireDefault((parcelRequire("EOGIN")));

var $98361ed174bfbb2b$var$_download2 = $98361ed174bfbb2b$var$_interopRequireDefault((parcelRequire("5krT5")));
function $98361ed174bfbb2b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DownloadIcon.
 * This component is DownloadIcon, with `UNSAFE_fallbackIcon` set to "DownloadIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $98361ed174bfbb2b$var$DownloadIcon = (props)=>/*#__PURE__*/ $98361ed174bfbb2b$var$_react.default.createElement($98361ed174bfbb2b$var$_download.default, Object.assign({
        LEGACY_fallbackIcon: $98361ed174bfbb2b$var$_download2.default
    }, props));
$98361ed174bfbb2b$var$DownloadIcon.Name = 'DownloadIconMigration';
var $98361ed174bfbb2b$var$_default = module.exports.default = $98361ed174bfbb2b$var$DownloadIcon;

});
parcelRegister("EOGIN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3903aba4213e0f68da56229d9d15d40>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $07ab0e2228a1635e$var$_react = $07ab0e2228a1635e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $07ab0e2228a1635e$var$_baseNew = $07ab0e2228a1635e$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $07ab0e2228a1635e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Download".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $07ab0e2228a1635e$var$DownloadIcon = (props)=>/*#__PURE__*/ $07ab0e2228a1635e$var$_react.default.createElement($07ab0e2228a1635e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v7.44l2.72-2.72 1.06 1.06-4 4a.75.75 0 0 1-1.06 0l-4-4 1.06-1.06 2.72 2.72V1zM1 13V9h1.5v4a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9H15v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$07ab0e2228a1635e$var$DownloadIcon.displayName = 'DownloadIcon';
var $07ab0e2228a1635e$var$_default = module.exports.default = $07ab0e2228a1635e$var$DownloadIcon;

});

parcelRegister("5krT5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e1473e49ea22b68$var$_react = $3e1473e49ea22b68$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $3e1473e49ea22b68$var$_download = $3e1473e49ea22b68$var$_interopRequireDefault((parcelRequire("EOGIN")));
function $3e1473e49ea22b68$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3e1473e49ea22b68$var$DownloadIcon = (props)=>/*#__PURE__*/ $3e1473e49ea22b68$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M10.687 17.292a.983.983 0 0 0-1.397 0 1 1 0 0 0 0 1.407l1.964 1.98a1.08 1.08 0 0 0 1.538 0l1.919-1.933a1 1 0 0 0 0-1.408.983.983 0 0 0-1.398 0l-1.29 1.3z"/><path fill-rule="nonzero" d="M13.001 19.993 13 10.006C13 9.451 12.552 9 12 9s-1 .45-1 1.007l.001 9.987c0 .555.448 1.006 1 1.006s1-.45 1-1.007"/><path d="M7.938 5.48a5 5 0 0 0-.777-.062C4.356 5.418 2 7.62 2 10.498 2 13.409 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.05.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.12a4.14 4.14 0 0 1 4.069 3.645l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-2-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.02-3.901.9-5.038 2.48"/></g></svg>`
    }, props, {
        newIcon: $3e1473e49ea22b68$var$_download.default
    }));
$3e1473e49ea22b68$var$DownloadIcon.displayName = 'DownloadIcon';
var $3e1473e49ea22b68$var$_default = module.exports.default = $3e1473e49ea22b68$var$DownloadIcon;

});



parcelRegister("b6Mes", function(module, exports) {

$parcel$export(module.exports, "default", () => $879133cabfb6e190$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $fpDmE = parcelRequire("fpDmE");

var $3xnBw = parcelRequire("3xnBw");

var $itef5 = parcelRequire("itef5");


const $879133cabfb6e190$var$importIconMapper = {
    goal: ()=>(parcelRequire("lyOhH")).then(({ GoalIcon: GoalIcon })=>({
                default: GoalIcon
            })),
    projects: ()=>(parcelRequire("kQ6Ua")).then(({ ProjectsIcon: ProjectsIcon })=>({
                default: ProjectsIcon
            }))
};
const $879133cabfb6e190$var$getIcon = (stackIconType)=>{
    const importFn = $879133cabfb6e190$var$importIconMapper[stackIconType];
    if (!importFn) return null;
    return (0, $fpDmE.importIcon)(importFn);
};
const $879133cabfb6e190$var$FollowAction = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $8dVIb.ActionName).FollowAction];
    if (!context || !actionData) return null;
    const { value: value, isProject: isProject, ...data } = actionData;
    const isStackItem = props.as === 'stack-item';
    const message = value ? (0, $7zaVw.messages).follow : (0, $7zaVw.messages).unfollow;
    const projectMessage = value ? (0, $7zaVw.messages).follow_project : (0, $7zaVw.messages).unfollow_project;
    const goalMessage = value ? (0, $7zaVw.messages).follow_goal : (0, $7zaVw.messages).unfollow_goal;
    const stackMessage = isProject ? projectMessage : goalMessage;
    const label = isStackItem ? stackMessage : message;
    const projectTooltipMessage = value ? (0, $7zaVw.messages).follow_project_description : (0, $7zaVw.messages).unfollow_project_description;
    const goalTooltipMessage = value ? (0, $7zaVw.messages).follow_goal_description : (0, $7zaVw.messages).unfollow_goal_description;
    const stackTooltipMessage = isProject ? projectTooltipMessage : goalTooltipMessage;
    const tooltipMessage = isStackItem ? stackTooltipMessage : message;
    const stackIconType = isProject ? 'projects' : 'goal';
    const ImportedIcon = $879133cabfb6e190$var$getIcon(stackIconType);
    const followIcon = /*#__PURE__*/ (0, $2OMIu.jsx)(ImportedIcon, {
        label: "Follow",
        testId: `smart-action-follow-action-${stackIconType}-icon`
    });
    const handleError = ()=>{
        const { onError: onErrorCallback } = props;
        const errorMessage = (0, $itef5.getFollowActionErrorMessage)(isProject, value);
        onErrorCallback?.({
            title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...errorMessage
            }),
            appearance: 'error'
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3xnBw.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...label
        }),
        icon: followIcon,
        testId: "smart-action-follow-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...tooltipMessage
        }),
        ...data,
        ...props,
        onError: handleError
    });
};
var $879133cabfb6e190$export$2e2bcd8739ae039 = $879133cabfb6e190$var$FollowAction;

});
parcelRegister("3xnBw", function(module, exports) {

$parcel$export(module.exports, "default", () => $35d557ed1ef6412d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $a1vqi = parcelRequire("a1vqi");

var $3q2sI = parcelRequire("3q2sI");

var $euMlu = parcelRequire("euMlu");

var $f22ja = parcelRequire("f22ja");

var $69hr0 = parcelRequire("69hr0");

var $23vM5 = parcelRequire("23vM5");
const $35d557ed1ef6412d$var$ServerAction = ({ action: action, onClick: onClick, onError: onErrorCallback, ...props })=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const invoke = (0, $3q2sI.default)();
    const reload = (0, $f22ja.default)();
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const handleClick = (0, $5uXOq.useCallback)(async ()=>{
        if (action) {
            const smartLinkActionType = action.action?.actionType;
            try {
                setIsLoading(true);
                if (smartLinkActionType === 'FollowEntityAction' || smartLinkActionType === 'UnfollowEntityAction') fireEvent('ui.button.clicked.smartLinkFollowButton', {});
                else fireEvent(`ui.button.clicked.${smartLinkActionType}`, {});
                fireEvent('track.smartLinkQuickAction.started', {
                    smartLinkActionType: smartLinkActionType
                });
                const request = (0, $69hr0.default)(action);
                await invoke(request);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: smartLinkActionType
                });
                if (action.reload && action.reload.url) await reload(action.reload.url, true, undefined, action.reload.id);
                setIsLoading(false);
                if (onClick) onClick();
            } catch (err) {
                setIsLoading(false);
                fireEvent('track.smartLinkQuickAction.failed', {
                    smartLinkActionType: smartLinkActionType,
                    reason: (0, $euMlu.getInvokeFailureReason)(err)
                });
                onErrorCallback?.();
            }
        }
    }, [
        action,
        invoke,
        onClick,
        onErrorCallback,
        reload,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        ...props,
        isLoading: isLoading,
        onClick: handleClick
    });
};
var $35d557ed1ef6412d$export$2e2bcd8739ae039 = $35d557ed1ef6412d$var$ServerAction;

});
parcelRegister("69hr0", function(module, exports) {

$parcel$export(module.exports, "default", () => $22d791805237a266$export$2e2bcd8739ae039);
const $22d791805237a266$var$createInvokeRequest = (request, payload)=>({
        action: {
            ...request.action,
            payload: payload
        },
        providerKey: request.providerKey
    });
var $22d791805237a266$export$2e2bcd8739ae039 = $22d791805237a266$var$createInvokeRequest;

});


parcelRegister("itef5", function(module, exports) {

$parcel$export(module.exports, "getFollowActionErrorMessage", () => $d31a392ae92ce299$export$49248678d3914625);

var $7zaVw = parcelRequire("7zaVw");
const $d31a392ae92ce299$export$49248678d3914625 = (isProject = false, isFollow = false)=>{
    if (isProject && isFollow) return (0, $7zaVw.messages).follow_project_error;
    if (isProject && !isFollow) return (0, $7zaVw.messages).unfollow_project_error;
    if (!isProject && isFollow) return (0, $7zaVw.messages).follow_goal_error;
    if (!isProject && !isFollow) return (0, $7zaVw.messages).unfollow_goal_error;
    return (0, $7zaVw.messages).generic_error_message;
};

});

parcelRegister("lyOhH", function(module, exports) {

let $fb23c76bc86d7ec6$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $fb23c76bc86d7ec6$var$load("ffQaD"),
    $fb23c76bc86d7ec6$var$load("kvRbA"),
    $fb23c76bc86d7ec6$var$load("3SzZM")
]).then(()=>parcelRequire('5UxRR'));

});

parcelRegister("kQ6Ua", function(module, exports) {

let $f2be052be792008d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f2be052be792008d$var$load("ffQaD"),
    $f2be052be792008d$var$load("kvRbA"),
    $f2be052be792008d$var$load("jZ50W")
]).then(()=>parcelRequire('gsEJ1'));

});


parcelRegister("9mTP8", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ea9170f77974c10$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $5JpK2 = parcelRequire("5JpK2");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $iPVbQ = parcelRequire("iPVbQ");

var $23vM5 = parcelRequire("23vM5");
const $3ea9170f77974c10$var$PreviewAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const invoke = (0, $iPVbQ.default)({});
    const data = context?.actions?.[(0, $8dVIb.ActionName).PreviewAction];
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const tooltipMessage = isStackItem ? (0, $7zaVw.messages).preview_description : (0, $7zaVw.messages).preview_improved;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).preview_improved
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5JpK2))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Open preview"
        }),
        onClick: onClick,
        testId: "smart-action-preview-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...tooltipMessage
        }),
        hideTooltipOnMouseDown: true,
        ...data,
        ...props
    }) : null;
};
var $3ea9170f77974c10$export$2e2bcd8739ae039 = $3ea9170f77974c10$var$PreviewAction;

});
parcelRegister("5JpK2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::95f2961def649e58284c9134f09a8716>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42c51f70ef43f1c0$var$_react = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $42c51f70ef43f1c0$var$_growDiagonal = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("l14Zy")));

var $42c51f70ef43f1c0$var$_actualSize = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("6LXPU")));
function $42c51f70ef43f1c0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for GrowDiagonalIcon.
 * This component is GrowDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesActualSizeIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $42c51f70ef43f1c0$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $42c51f70ef43f1c0$var$_react.default.createElement($42c51f70ef43f1c0$var$_growDiagonal.default, Object.assign({
        LEGACY_fallbackIcon: $42c51f70ef43f1c0$var$_actualSize.default
    }, props));
$42c51f70ef43f1c0$var$GrowDiagonalIcon.Name = 'GrowDiagonalIconMigration';
var $42c51f70ef43f1c0$var$_default = module.exports.default = $42c51f70ef43f1c0$var$GrowDiagonalIcon;

});


parcelRegister("jep3X", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d1e0763b6a84021$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $jOyH3 = parcelRequire("jOyH3");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $iPVbQ = parcelRequire("iPVbQ");

var $23vM5 = parcelRequire("23vM5");
const $0d1e0763b6a84021$var$CopyLinkAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const invoke = (0, $iPVbQ.default)({});
    const data = context?.actions?.[(0, $8dVIb.ActionName).CopyLinkAction];
    const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)((0, $7zaVw.messages).copy_url_to_clipboard);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke({
                ...data.invokeAction,
                actionFn: async ()=>{
                    await data.invokeAction?.actionFn();
                    setTooltipMessage((0, $7zaVw.messages).copied_url_to_clipboard);
                }
            });
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).copy_url_to_clipboard
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
            color: "currentColor",
            label: "copy url",
            LEGACY_size: "medium",
            spacing: "spacious"
        }),
        onClick: onClick,
        testId: "smart-action-copy-link-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...tooltipMessage
        }),
        tooltipOnHide: ()=>setTooltipMessage((0, $7zaVw.messages).copy_url_to_clipboard),
        ...data,
        ...props
    }) : null;
};
var $0d1e0763b6a84021$export$2e2bcd8739ae039 = $0d1e0763b6a84021$var$CopyLinkAction;

});

parcelRegister("erAKX", function(module, exports) {

$parcel$export(module.exports, "default", () => $12a9f0a1fef78487$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $MHKc7 = parcelRequire("MHKc7");
var $3Lty3 = parcelRequire("3Lty3");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");
const $12a9f0a1fef78487$var$styles = {
    button: "_1e0c1bgi",
    message: "_1rjcze3t _18zrze3t"
};
const $12a9f0a1fef78487$var$UnresolvedAction = ({ testId: testId = 'unresolved-action' })=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const data = context?.actions?.[(0, $8dVIb.InternalActionName).UnresolvedAction];
    if (!data) return null;
    const { descriptor: descriptor, onClick: onClick, values: values } = data;
    const hasAction = onClick !== undefined;
    const message = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        testId: `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : undefined,
        xcss: $12a9f0a1fef78487$var$styles.message,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...descriptor,
            values: values
        })
    });
    return hasAction ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
        onClick: data.onClick,
        style: {
            color: `inherit`,
            font: `inherit`,
            textAlign: `inherit`
        },
        xcss: $12a9f0a1fef78487$var$styles.button,
        children: message
    }) : message;
};
var $12a9f0a1fef78487$export$2e2bcd8739ae039 = $12a9f0a1fef78487$var$UnresolvedAction;

});

parcelRegister("ziZLe", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b53b1e1aa704061$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $dgRei = parcelRequire("dgRei");
const $8b53b1e1aa704061$var$AISummaryAction = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $8dVIb.InternalActionName).AISummaryAction];
    return actionData ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dgRei.AISummaryActionComponent), {
        ...actionData,
        ...props
    }) : null;
};
var $8b53b1e1aa704061$export$2e2bcd8739ae039 = $8b53b1e1aa704061$var$AISummaryAction;

});
parcelRegister("dgRei", function(module, exports) {

$parcel$export(module.exports, "AISummaryActionComponent", () => $a6e4dbdfe418b2c1$export$8eed96bc6d982595);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $1MeuC = parcelRequire("1MeuC");

var $8UCLX = parcelRequire("8UCLX");

var $jdA9V = parcelRequire("jdA9V");
const $a6e4dbdfe418b2c1$export$8eed96bc6d982595 = (props)=>{
    (0, $gKZoD.di)((0, $1MeuC.default));
    const { url: url, onLoadingChange: onLoadingChange, testId: testId = 'smart-action-ai-summary-action' } = props;
    const { state: { status: status, content: content }, summariseUrl: summariseUrl } = (0, $1MeuC.default)(url);
    (0, $5uXOq.useEffect)(()=>{
        onLoadingChange?.(status === 'loading');
    }, [
        onLoadingChange,
        status
    ]);
    return status === 'done' ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jdA9V.CopySummaryAction), {
        ...props,
        testId: testId,
        content: content
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8UCLX.AISummariseAction), {
        ...props,
        testId: testId,
        summariseUrl: summariseUrl,
        status: status
    });
};

});
parcelRegister("1MeuC", function(module, exports) {

$parcel$export(module.exports, "default", () => $27e30e18347ce2a0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hWyvy = parcelRequire("hWyvy");
var $8UXrm = parcelRequire("8UXrm");

var $a1vqi = parcelRequire("a1vqi");

var $1VPdD = parcelRequire("1VPdD");

var $hjhAz = parcelRequire("hjhAz");

var $kR87P = parcelRequire("kR87P");

var $anB5s = parcelRequire("anB5s");
const $27e30e18347ce2a0$var$EXPERIENCE_NAME = 'smart-link-ai-summary';
const $27e30e18347ce2a0$var$useAISummaryAction = (url)=>{
    const { baseUrl: baseUrl, envKey: envKey, product: product } = (0, $anB5s.useAISummaryConfig)();
    const cardState = (0, $hjhAz.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const data = cardState.details?.data;
    const ari = data && (0, $hWyvy.extractAri)(data);
    const dataUrl = data && (0, $8UXrm.extractLink)(data) || '';
    const onStart = (0, $5uXOq.useCallback)((id)=>{
        (0, $1VPdD.startUfoExperience)($27e30e18347ce2a0$var$EXPERIENCE_NAME, id);
    }, []);
    const onSuccess = (0, $5uXOq.useCallback)((id)=>{
        fireEvent('operational.summary.success', {});
        (0, $1VPdD.succeedUfoExperience)($27e30e18347ce2a0$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    const onError = (0, $5uXOq.useCallback)((id, reason)=>{
        /**
			 * Errors should only be counted to the SLO if they are not due to acceptable use violations
			 * HIPAA content detected or exceeding context length.
			 */ const isSloError = reason === undefined ? true : ![
            'ACCEPTABLE_USE_VIOLATIONS',
            'HIPAA_CONTENT_DETECTED',
            'EXCEEDING_CONTEXT_LENGTH_ERROR'
        ].includes(reason);
        fireEvent('operational.summary.failed', {
            reason: reason || null,
            isSloError: isSloError
        });
        (0, $1VPdD.failUfoExperience)($27e30e18347ce2a0$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    return (0, $kR87P.useAISummary)({
        url: dataUrl,
        ari: ari,
        product: product,
        envKey: envKey,
        baseUrl: baseUrl,
        onStart: onStart,
        onSuccess: onSuccess,
        onError: onError
    });
};
var $27e30e18347ce2a0$export$2e2bcd8739ae039 = $27e30e18347ce2a0$var$useAISummaryAction;

});
parcelRegister("kR87P", function(module, exports) {

$parcel$export(module.exports, "useAISummary", () => $c5395471ca862cc2$export$becd8f2eba1bbd96);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $SrCME = parcelRequire("SrCME");

var $561ku = parcelRequire("561ku");
const $c5395471ca862cc2$export$becd8f2eba1bbd96 = (props)=>{
    const { url: url, baseUrl: baseUrl, product: product, ari: ari, envKey: envKey, onError: onError, onStart: onStart, onSuccess: onSuccess } = props;
    const [state, setState] = (0, $5uXOq.useState)((0, $561ku.AISummariesStore).get(url)?.state || {
        status: 'ready',
        content: ''
    });
    const { locale: locale } = (0, $koVbs.default)();
    (0, $5uXOq.useEffect)(()=>{
        //do not create a service for the empty URL string when the link data is not yet available,
        //or the service has already been created and cached.
        if (url && !(0, $561ku.AISummariesStore).get(url)) (0, $561ku.AISummariesStore).set(url, new (0, $SrCME.AISummaryService)({
            url: url,
            ari: ari,
            baseUrl: baseUrl,
            product: product,
            envKey: envKey,
            locale: locale,
            onError: onError,
            onStart: onStart,
            onSuccess: onSuccess
        }));
        //returns function that calls unsubscribe method
        return (0, $561ku.AISummariesStore).get(url)?.subscribe(setState);
    }, [
        url,
        baseUrl,
        onError,
        onStart,
        onSuccess,
        product,
        ari,
        envKey,
        locale
    ]);
    const summariseUrl = ()=>{
        return (0, $561ku.AISummariesStore).get(url)?.summariseUrl();
    };
    return {
        summariseUrl: summariseUrl,
        state: state
    };
};

});
parcelRegister("SrCME", function(module, exports) {

$parcel$export(module.exports, "AISummaryService", () => $ad05438f1e08870b$export$73e4b807d5bd74b6);

var $7Jxgt = parcelRequire("7Jxgt");

var $itO4f = parcelRequire("itO4f");

var $9AA7J = parcelRequire("9AA7J");

var $c0Zwh = parcelRequire("c0Zwh");

var $ghXNq = parcelRequire("ghXNq");
class $ad05438f1e08870b$export$73e4b807d5bd74b6 {
    constructor(props){
        this.state = {
            content: '',
            status: 'ready'
        };
        this.subscribedStateSetters = new Set();
        this.getRequestUrl = (envKey, baseUrlOverride)=>{
            const path = 'assist/chat/v1/invoke_agent/stream';
            if (baseUrlOverride || envKey) {
                const baseUrl = baseUrlOverride || (0, $itO4f.getBaseUrl)(envKey);
                return (0, $ghXNq.addPath)(baseUrl, path);
            }
            return (0, $ghXNq.addPath)('/gateway/api/', path);
        };
        this.fetchStream = async ()=>{
            const payload = {
                recipient_agent_named_id: 'smartlink_summary_agent',
                agent_input_context: {
                    content_url: this.url,
                    content_ari: this.ari,
                    prompt_id: 'smart_links',
                    summary_output_mimetype: 'text/markdown',
                    locale: this.locale
                }
            };
            const options = {
                method: 'POST',
                headers: this.config.headers,
                body: JSON.stringify(payload),
                credentials: 'include'
            };
            const response = await fetch(this.config.requestUrl, options);
            if (!response.ok || response.status >= 400) throw new Error(`Status: ${response.status}\n URL: ${this.url}\n StatusText ${response.statusText}`);
            else return (0, $9AA7J.readStream)(response);
        };
        this.config = {
            requestUrl: this.getRequestUrl(props.envKey, props.baseUrl),
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'x-experience-id': 'smart-link',
                'x-product': (0, $ghXNq.getXProductHeaderValue)(props.product)?.toLowerCase() || 'confluence'
            }
        };
        this.url = props.url;
        this.ari = props.ari;
        this.locale = props.locale;
        this.onStart = props.onStart;
        this.onSuccess = props.onSuccess;
        this.onError = props.onError;
    }
    async summariseUrl() {
        this.state = {
            status: 'loading',
            content: ''
        };
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))();
        try {
            this.onStart?.(id);
            const stream = await this.fetchStream();
            let bufferContent = '';
            for await (const chunk of stream){
                if (chunk.type === 'ANSWER_PART') {
                    bufferContent += chunk.message.content;
                    for (const subscriber of this.subscribedStateSetters)subscriber({
                        ...this.state,
                        content: bufferContent
                    });
                }
                //if AI Mate service returns cached summary we get the summary text in one piece as the last message
                if (chunk.type === 'FINAL_RESPONSE') bufferContent = chunk.message.message.content;
                if (chunk.type === 'ERROR') throw new (0, $c0Zwh.ChunkProcessingError)(chunk?.message?.message_template);
            }
            this.onSuccess?.(id);
            this.state = {
                status: 'done',
                content: bufferContent
            };
        } catch (err) {
            let message = err instanceof (0, $c0Zwh.ChunkProcessingError) ? err.message : 'UNEXPECTED';
            this.onError?.(id, message);
            this.state = {
                status: 'error',
                content: '',
                error: message
            };
        }
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        return this.state;
    }
    subscribe(stateSetter) {
        this.subscribedStateSetters.add(stateSetter);
        return ()=>{
            this.subscribedStateSetters.delete(stateSetter);
        };
    }
}

});
parcelRegister("9AA7J", function(module, exports) {

$parcel$export(module.exports, "readStream", () => $27dc203987154036$export$e45226161c660403);

var $ghXNq = parcelRequire("ghXNq");
async function* $27dc203987154036$export$e45226161c660403(response) {
    const reader = (0, $ghXNq.getBufferReader)(response);
    let doneStreaming = false;
    let chunkBuffer = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) {
            const processedChunks = `${chunkBuffer}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            chunkBuffer = '';
            for (let chunk of processedChunks)try {
                const jsonChunk = JSON.parse(chunk);
                if (jsonChunk.type === 'ERROR') reader.cancel();
                yield jsonChunk;
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                chunkBuffer = chunk;
            }
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else {
            reader.cancel();
            throw e;
        }
    }
    while (!doneStreaming);
    if (chunkBuffer) {
        const error = new Error(`Not all the data was processed: ${chunkBuffer}`);
        throw error;
    }
}

});
parcelRegister("ghXNq", function(module, exports) {

$parcel$export(module.exports, "getBufferReader", () => $6c9c387ba5dd9d5b$export$f6383c3ea1307da9);
$parcel$export(module.exports, "addPath", () => $6c9c387ba5dd9d5b$export$4c25481b843feb0b);
$parcel$export(module.exports, "getXProductHeaderValue", () => $6c9c387ba5dd9d5b$export$ff2962de2b2c930f);
const $6c9c387ba5dd9d5b$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};
const $6c9c387ba5dd9d5b$export$4c25481b843feb0b = (baseUrl, path)=>{
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
/**
 * Subset of a map of Jira `ProductTypes` to AI Mate expected values
 * See for more info: https://atlassian.slack.com/archives/C066UP0G0G3/p1716341647677829?thread_ts=1716338063.255939&cid=C066UP0G0G3
 */ const $6c9c387ba5dd9d5b$var$AiMateJiraXProduct = {
    JSM: 'JSM',
    JSW: 'JIRA-SOFTWARE',
    JWM: 'JIRA-CORE',
    JPD: 'JPD'
};
/**
 * Checks if `product` is a Jira related product.
 */ const $6c9c387ba5dd9d5b$var$isJiraProduct = (product)=>{
    const JIRA_PRODUCTS = [
        'JPD',
        'JSM',
        'JSW',
        'JWM'
    ];
    return product !== undefined && JIRA_PRODUCTS.includes(product);
};
const $6c9c387ba5dd9d5b$export$ff2962de2b2c930f = (product)=>{
    if ($6c9c387ba5dd9d5b$var$isJiraProduct(product)) return $6c9c387ba5dd9d5b$var$AiMateJiraXProduct[product];
    return product;
};

});


parcelRegister("c0Zwh", function(module, exports) {

$parcel$export(module.exports, "ChunkProcessingError", () => $0e5f8d5a8019ed33$export$fcec967a4b7ebd84);
class $0e5f8d5a8019ed33$export$fcec967a4b7ebd84 extends Error {
    constructor(error){
        super(error);
    }
}
const $0e5f8d5a8019ed33$export$d8bd0967cb58683 = [
    'NETWORK_ERROR',
    'NO_ANSWER',
    'RATE_LIMIT',
    'NO_AGENT',
    'PLUGIN_ERRORED',
    'OPENAI_RATE_LIMIT_USER_ABUSE',
    'ACCEPTABLE_USE_VIOLATIONS',
    'AI_DISABLED',
    'UNEXPECTED',
    'HIPAA_CONTENT_DETECTED',
    'EXCEEDING_CONTEXT_LENGTH_ERROR'
];

});


parcelRegister("561ku", function(module, exports) {

$parcel$export(module.exports, "AISummariesStore", () => $cc472589618fd980$export$6979339b6d41707e);

var $iwKVT = parcelRequire("iwKVT");
const $cc472589618fd980$var$AI_SUMMARY_CACHE_SIZE = 100;
const $cc472589618fd980$export$6979339b6d41707e = new (0, $iwKVT.LRUMap)($cc472589618fd980$var$AI_SUMMARY_CACHE_SIZE);

});


parcelRegister("anB5s", function(module, exports) {

$parcel$export(module.exports, "useAISummaryConfig", () => $cd0a62b074a064ce$export$4480af2c00aa7ebe);

var $5uXOq = parcelRequire("5uXOq");

var $051X7 = parcelRequire("051X7");
const $cd0a62b074a064ce$export$4480af2c00aa7ebe = ()=>{
    const { connections: connections, product: product, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $051X7.useSmartLinkContext)();
    return (0, $5uXOq.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            isAdminHubAIEnabled: isAdminHubAIEnabled
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        isAdminHubAIEnabled
    ]);
};

});


parcelRegister("8UCLX", function(module, exports) {

$parcel$export(module.exports, "AISummariseAction", () => $a2971ac1720627ee$export$75a19de44af58722);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $jps85 = parcelRequire("jps85");

var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $8z1HA = parcelRequire("8z1HA");

var $23vM5 = parcelRequire("23vM5");

var $blyr7 = parcelRequire("blyr7");
function $a2971ac1720627ee$export$75a19de44af58722({ url: url, onClick: onClickCallback, onError: onErrorCallback, testId: testId, status: status, summariseUrl: summariseUrl, ...props }) {
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const onCompleted = (0, $5uXOq.useCallback)((state)=>{
        if (state?.status === 'error') onErrorCallback?.((0, $blyr7.getErrorMessage)(state.error));
    }, [
        onErrorCallback
    ]);
    const handleActionClick = (0, $5uXOq.useCallback)(()=>{
        fireEvent('ui.button.clicked.aiSummary', {});
        fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 0,
            userGeneratedAI: 1
        });
        summariseUrl()?.then(onCompleted, onCompleted);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        onCompleted,
        summariseUrl
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).ai_summary_action
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jps85))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Summarise with AI",
            LEGACY_fallbackIcon: (0, $8z1HA.default)
        }),
        onClick: handleActionClick,
        testId: `${testId}-summarise-action`,
        isLoading: status === 'loading',
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).ai_summary_action_description
        }),
        ...props
    });
}

});
parcelRegister("jps85", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8054c1d672105cf334f7f37a83f0cf2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e2162c0618e136c6$var$_react = $e2162c0618e136c6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e2162c0618e136c6$var$_baseNew = $e2162c0618e136c6$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e2162c0618e136c6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AtlassianIntelligence".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Intelligence products or experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e2162c0618e136c6$var$AtlassianIntelligenceIcon = (props)=>/*#__PURE__*/ $e2162c0618e136c6$var$_react.default.createElement($e2162c0618e136c6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 4V1h1.5v3zM5.47 6.53l-4-4 1.06-1.06 4 4zm4-1.06 4-4 1.06 1.06-4 4zM1 7.25h3v1.5H1zm11 0h3v1.5h-3zM1.47 13.47l4-4 1.06 1.06-4 4zm12 1.06-4-4 1.06-1.06 4 4zM7.25 15v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$e2162c0618e136c6$var$AtlassianIntelligenceIcon.displayName = 'AtlassianIntelligenceIcon';
var $e2162c0618e136c6$var$_default = module.exports.default = $e2162c0618e136c6$var$AtlassianIntelligenceIcon;

});

parcelRegister("8z1HA", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f8c2f1acb4b6b88$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dV6Te = parcelRequire("dV6Te");
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications
 */ const $7f8c2f1acb4b6b88$var$AiIcon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dV6Te.default), {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.17 12C17.17 11.4477 17.6177 11 18.17 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H18.17C17.6177 13 17.17 12.5523 17.17 12Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12 17.17C12.5523 17.17 13 17.6177 13 18.17V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V18.17C11 17.6177 11.4477 17.17 12 17.17Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M14.2929 14.2929C14.6835 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0977 18.6834 20.0977 19.3166 19.7071 19.7071C19.3166 20.0976 18.6835 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M19.7071 4.29289C20.0977 4.68342 20.0977 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6835 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6835 3.90237 19.3166 3.90237 19.7071 4.29289Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
                    fill: "var(--ds-icon, #44546F)"
                })
            ]
        })
    });
var $7f8c2f1acb4b6b88$export$2e2bcd8739ae039 = $7f8c2f1acb4b6b88$var$AiIcon;

});

parcelRegister("blyr7", function(module, exports) {

$parcel$export(module.exports, "getErrorMessage", () => $2b1346f84062e88d$export$82f46aa4e6535a45);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $cnaAy = parcelRequire("cnaAy");

var $RbANO = parcelRequire("RbANO");

var $1r4gF = parcelRequire("1r4gF");
const $2b1346f84062e88d$export$82f46aa4e6535a45 = (error)=>{
    const { message: message, url: url } = (0, $cnaAy.getAISummaryErrorMessage)(error);
    return {
        appearance: 'error',
        title: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $RbANO.default), {
                    reason: error
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...message,
                    values: {
                        a: (chunks)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1r4gF.default), {
                                href: url,
                                children: chunks
                            })
                    }
                })
            ]
        })
    };
};

});
parcelRegister("cnaAy", function(module, exports) {

$parcel$export(module.exports, "getIsAISummaryEnabled", () => $3339f41fc1b0dac1$export$d439c74cb206ff29);
$parcel$export(module.exports, "getAISummaryErrorMessage", () => $3339f41fc1b0dac1$export$cd2e891d7f87074d);

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");
const $3339f41fc1b0dac1$export$d439c74cb206ff29 = (isAdminHubAIEnabled = false, response)=>Boolean(isAdminHubAIEnabled && response?.meta?.supportedFeature?.includes('AISummary'));
const $3339f41fc1b0dac1$export$cd2e891d7f87074d = (error)=>{
    switch(error){
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return {
                message: (0, $7zaVw.messages).ai_summary_error_acceptable_use_violation,
                url: (0, $8dVIb.CONTENT_URL_ACCEPTABLE_USE_POLICY)
            };
        case 'HIPAA_CONTENT_DETECTED':
            return {
                message: (0, $7zaVw.messages).ai_summary_error_hipaa_content_detected
            };
        case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
            return {
                message: (0, $7zaVw.messages).ai_summary_error_exceeding_context_length_error
            };
        default:
            return {
                message: (0, $7zaVw.messages).ai_summary_error_generic,
                url: (0, $8dVIb.CONTENT_URL_AI_TROUBLESHOOTING)
            };
    }
};

});

parcelRegister("RbANO", function(module, exports) {

$parcel$export(module.exports, "default", () => $402c39c7523f0dd1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $a1vqi = parcelRequire("a1vqi");
const $402c39c7523f0dd1$var$AIEventErrorViewed = ({ reason: reason })=>{
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        fireEvent('ui.error.viewed.aiSummary', {
            reason: reason
        });
    }, [
        fireEvent,
        reason
    ]);
    return null;
};
var $402c39c7523f0dd1$export$2e2bcd8739ae039 = $402c39c7523f0dd1$var$AIEventErrorViewed;

});

parcelRegister("1r4gF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff8f369a3b340dfb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $e4yMr = parcelRequire("e4yMr");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");
const $ff8f369a3b340dfb$var$AILearnMoreAnchor = ({ children: children, ...props })=>(0, $VSDnB.fg)('platform-linking-fix-a11y-in-smart-card') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e4yMr.default), {
        href: (0, $8dVIb.CONTENT_URL_AI),
        target: "_blank",
        rel: "noopener noreferrer",
        ...props,
        children: children
    }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
        href: (0, $8dVIb.CONTENT_URL_AI),
        target: "_blank",
        rel: "noopener noreferrer",
        ...props,
        children: children
    });
var $ff8f369a3b340dfb$export$2e2bcd8739ae039 = $ff8f369a3b340dfb$var$AILearnMoreAnchor;

});



parcelRegister("jdA9V", function(module, exports) {

$parcel$export(module.exports, "CopySummaryAction", () => $2e1357a85e616794$export$cfa1d3eed9a61059);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $3Fq5M = parcelRequire("3Fq5M");

var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $23vM5 = parcelRequire("23vM5");
function $2e1357a85e616794$export$cfa1d3eed9a61059({ url: url, onClick: onClickCallback, testId: testId, content: content, ...props }) {
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)((0, $7zaVw.messages).copy_summary_action_description);
    const handleCopySummaryClick = (0, $5uXOq.useCallback)(async ()=>{
        fireEvent('ui.button.clicked.copySummary', {});
        await navigator.clipboard.writeText(content ?? '');
        setTooltipMessage((0, $7zaVw.messages).copied_summary_action_description);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        content
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).copy_summary_action
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3Fq5M))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Copy Summary"
        }),
        onClick: handleCopySummaryClick,
        testId: `${testId}-copy-summary-action`,
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...tooltipMessage
        }),
        tooltipOnHide: ()=>setTooltipMessage((0, $7zaVw.messages).copy_summary_action_description),
        ...props
    });
}

});
parcelRegister("3Fq5M", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::746afd86dff7a846534476462b8fe4e7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ab970d264bef26f$var$_react = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2ab970d264bef26f$var$_copy = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("8w53e")));

var $2ab970d264bef26f$var$_copy2 = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("eE13R")));
function $2ab970d264bef26f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CopyIcon.
 * This component is CopyIcon, with `UNSAFE_fallbackIcon` set to "CopyIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2ab970d264bef26f$var$CopyIcon = (props)=>/*#__PURE__*/ $2ab970d264bef26f$var$_react.default.createElement($2ab970d264bef26f$var$_copy.default, Object.assign({
        LEGACY_fallbackIcon: $2ab970d264bef26f$var$_copy2.default
    }, props));
$2ab970d264bef26f$var$CopyIcon.Name = 'CopyIconMigration';
var $2ab970d264bef26f$var$_default = module.exports.default = $2ab970d264bef26f$var$CopyIcon;

});
parcelRegister("eE13R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aa959fe1f5a86e24$var$_react = $aa959fe1f5a86e24$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $aa959fe1f5a86e24$var$_copy = $aa959fe1f5a86e24$var$_interopRequireDefault((parcelRequire("8w53e")));
function $aa959fe1f5a86e24$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $aa959fe1f5a86e24$var$CopyIcon = (props)=>/*#__PURE__*/ $aa959fe1f5a86e24$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
    }, props, {
        newIcon: $aa959fe1f5a86e24$var$_copy.default
    }));
$aa959fe1f5a86e24$var$CopyIcon.displayName = 'CopyIcon';
var $aa959fe1f5a86e24$var$_default = module.exports.default = $aa959fe1f5a86e24$var$CopyIcon;

});





parcelRegister("5OUwn", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fd2a7343c5a2622$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $4ldhu = parcelRequire("4ldhu");

var $dS3PR = parcelRequire("dS3PR");

var $a1vqi = parcelRequire("a1vqi");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $7HAq8 = parcelRequire("7HAq8");

var $23vM5 = parcelRequire("23vM5");

var $e5vwM = parcelRequire("e5vwM");

var $3Lbo8 = parcelRequire("3Lbo8");

const $9fd2a7343c5a2622$var$AutomationModal = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("9O9YP")));
const $9fd2a7343c5a2622$var$AutomationAction = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const modal = (0, $7HAq8.useSmartLinkModal)();
    const { onClick: onClickCallback } = props;
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const automationActionData = context?.actions?.[(0, $8dVIb.ActionName).AutomationAction];
    const automationActionOnClick = (0, $5uXOq.useCallback)((automationActionData)=>{
        const { product: product, resourceType: resourceType, baseAutomationUrl: baseAutomationUrl, objectAri: objectAri, siteAri: siteAri, canManageAutomation: canManageAutomation, analyticsSource: analyticsSource, objectName: objectName } = automationActionData;
        fireEvent('ui.button.clicked.automationAction', {});
        const { modalTitle: modalTitle, modalDescription: modalDescription } = (0, $3Lbo8.getModalContent)(product, resourceType) || {};
        const automationModalTitle = modalTitle ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...modalTitle
        }) : undefined;
        const automationModalDescription = modalDescription ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...modalDescription,
            values: {
                name: objectName,
                b: (chunks)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                        as: "strong",
                        children: chunks
                    }),
                br: /*#__PURE__*/ (0, $2OMIu.jsx)("br", {})
            }
        }) : undefined;
        modal.open(/*#__PURE__*/ (0, $2OMIu.jsx)($9fd2a7343c5a2622$var$AutomationModal, {
            baseAutomationUrl: baseAutomationUrl,
            objectAri: objectAri,
            siteAri: siteAri,
            canManageAutomation: canManageAutomation,
            analyticsSource: analyticsSource,
            modalTitle: automationModalTitle,
            modalDescription: automationModalDescription,
            onClose: ()=>modal.close()
        }));
        onClickCallback?.();
    }, [
        modal,
        onClickCallback,
        fireEvent
    ]);
    if (!automationActionData) return null;
    const automationActionTitle = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...(0, $7zaVw.messages).automation_action_title
    });
    const automationActionTooltip = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...(0, $7zaVw.messages).automation_action_tooltip
    });
    const automationActionIconLabel = formatMessage((0, $7zaVw.messages).automation_action_icon_label);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
            content: automationActionTitle,
            icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4ldhu))), {
                spacing: "spacious",
                LEGACY_fallbackIcon: (0, $e5vwM.default),
                color: "currentColor",
                label: automationActionIconLabel
            }),
            testId: "smart-action-automation-action",
            tooltipMessage: automationActionTooltip,
            ...props,
            onClick: ()=>automationActionOnClick(automationActionData)
        })
    });
};
var $9fd2a7343c5a2622$export$2e2bcd8739ae039 = $9fd2a7343c5a2622$var$AutomationAction;

});
parcelRegister("7HAq8", function(module, exports) {

$parcel$export(module.exports, "SmartLinkModalProvider", () => $bc735e1cde43eb76$export$bb4eb02a83e1a0f8);
$parcel$export(module.exports, "useSmartLinkModal", () => $bc735e1cde43eb76$export$1fd7f5f21a6d6cb8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $lnPiq = parcelRequire("lnPiq");
const $bc735e1cde43eb76$var$FALLBACK_API = {
    open: ()=>{},
    close: ()=>{}
};
const $bc735e1cde43eb76$export$f4c0a0f23ba57f8c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext($bc735e1cde43eb76$var$FALLBACK_API);
const $bc735e1cde43eb76$export$bb4eb02a83e1a0f8 = ({ children: children })=>{
    const [element, setElement] = (0, $5uXOq.useState)(null);
    const api = (0, $5uXOq.useMemo)(()=>({
            open: (modal)=>setElement(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lnPiq.StopPropagation), {
                        children: modal
                    })
                })),
            close: ()=>setElement(null)
        }), []);
    const fallbackRender = (0, $5uXOq.useCallback)(({ resetErrorBoundary: resetErrorBoundary })=>{
        resetErrorBoundary();
        return null;
    }, []);
    const onReset = (0, $5uXOq.useCallback)(()=>setElement(null), []);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)($bc735e1cde43eb76$export$f4c0a0f23ba57f8c.Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
                fallbackRender: fallbackRender,
                onReset: onReset,
                children: element
            })
        ]
    });
};
const $bc735e1cde43eb76$export$1fd7f5f21a6d6cb8 = ()=>(0, $5uXOq.useContext)($bc735e1cde43eb76$export$f4c0a0f23ba57f8c);

});
parcelRegister("lnPiq", function(module, exports) {

$parcel$export(module.exports, "StopPropagation", () => $a203465a8c9e0684$export$3e100bc08448f36c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
const $a203465a8c9e0684$var$styles = null;
const $a203465a8c9e0684$export$3e100bc08448f36c = ({ children: children })=>{
    const onClick = (0, $5uXOq.useCallback)((e)=>{
        // Prevent click event inside modal from bubble up
        e.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        onClick: onClick,
        className: (0, $bwpsq.default)([
            "_c71lidpf _p12fidpf _kqswstnw"
        ]),
        children: children
    });
};

});


parcelRegister("e5vwM", function(module, exports) {

$parcel$export(module.exports, "default", () => $23884530c116b98b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $23884530c116b98b$var$AutomationManualTriggersGlyph = ({ label: label })=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        "aria-label": label,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M14 5L10 19",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M14 5L7 12H17L10 19",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $23884530c116b98b$export$2e2bcd8739ae039 = $23884530c116b98b$var$AutomationManualTriggersGlyph;

});

parcelRegister("3Lbo8", function(module, exports) {

$parcel$export(module.exports, "getModalContent", () => $6b74a4060fa13021$export$93e707b363eaf5c8);

var $7zaVw = parcelRequire("7zaVw");
const $6b74a4060fa13021$export$93e707b363eaf5c8 = (product, resourceType)=>{
    const modalContentMap = {
        confluence: {
            page: {
                modalTitle: (0, $7zaVw.messages).automation_action_confluence_page_modal_title,
                modalDescription: (0, $7zaVw.messages).automation_action_confluence_page_modal_description
            }
        }
    };
    return modalContentMap?.[product]?.[resourceType];
};

});

parcelRegister("9O9YP", function(module, exports) {

let $72408668de532ebc$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $72408668de532ebc$var$load("kNFvF"),
    $72408668de532ebc$var$load("ffQaD"),
    $72408668de532ebc$var$load("kvRbA"),
    $72408668de532ebc$var$load("47Kh6")
]).then(()=>parcelRequire('1Rjyb'));

});


parcelRegister("faTeC", function(module, exports) {

$parcel$export(module.exports, "default", () => $b95acafe5e8a7ba5$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $VSDnB = parcelRequire("VSDnB");

var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $7HAq8 = parcelRequire("7HAq8");

var $23vM5 = parcelRequire("23vM5");

var $k98Kd = parcelRequire("k98Kd");

const $b95acafe5e8a7ba5$var$RelatedLinksModal = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("3ivMk")));
const $b95acafe5e8a7ba5$var$ViewRelatedLinksAction = ({ onClick: onClickCallback, ...props })=>{
    const modal = (0, $7HAq8.useSmartLinkModal)();
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const actionData = context?.actions?.ViewRelatedLinksAction;
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        const ari = actionData?.ari;
        if (ari) modal.open(/*#__PURE__*/ (0, $2OMIu.jsx)($b95acafe5e8a7ba5$var$RelatedLinksModal, {
            ari: ari,
            showModal: true,
            onClose: ()=>modal.close()
        }));
        fireEvent('ui.button.clicked.relatedLinks', {});
        onClickCallback?.();
    }, [
        actionData?.ari,
        fireEvent,
        modal,
        onClickCallback
    ]);
    return actionData ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v2') ? (0, $7zaVw.messages).related_links_view_related_links : (0, $7zaVw.messages).related_links_view_related_urls
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k98Kd.default), {}),
        onClick: onClick,
        testId: "smart-action-view-related-links-action",
        ariaLabel: "View most recent pages or content types coming from or found on this link",
        ...props
    }) : null;
};
var $b95acafe5e8a7ba5$export$2e2bcd8739ae039 = $b95acafe5e8a7ba5$var$ViewRelatedLinksAction;

});
parcelRegister("k98Kd", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c9aac1bc71ae3e1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hyKRO = parcelRequire("hyKRO");

var $ehOs2 = parcelRequire("ehOs2");

var $VSDnB = parcelRequire("VSDnB");
const $7c9aac1bc71ae3e1$var$rotateSvg = null;
/**
 * ChildIssuesIcon but 180 degrees rotated
 */ const $7c9aac1bc71ae3e1$var$RelatedLinksActionIcon = ()=>(0, $VSDnB.fg)('platform-linking-visual-refresh-v2') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hyKRO))), {
        color: "currentColor",
        spacing: "spacious",
        label: "View related links..."
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_t9ec1sub _1e0c1o8l"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ehOs2))), {
            color: "currentColor",
            spacing: "spacious",
            label: "View recent links..."
        })
    });
var $7c9aac1bc71ae3e1$export$2e2bcd8739ae039 = $7c9aac1bc71ae3e1$var$RelatedLinksActionIcon;

});
parcelRegister("ehOs2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::460873555b00dc694a7c27133071dd5e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a669c9c7dda1a2bd$var$_react = $a669c9c7dda1a2bd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a669c9c7dda1a2bd$var$_childIssues = $a669c9c7dda1a2bd$var$_interopRequireDefault((parcelRequire("a5U1O")));

var $a669c9c7dda1a2bd$var$_childIssues2 = $a669c9c7dda1a2bd$var$_interopRequireDefault((parcelRequire("hxodJ")));
function $a669c9c7dda1a2bd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChildIssuesIcon.
 * This component is ChildIssuesIcon, with `UNSAFE_fallbackIcon` set to "ChildIssuesIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for child issues in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a669c9c7dda1a2bd$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $a669c9c7dda1a2bd$var$_react.default.createElement($a669c9c7dda1a2bd$var$_childIssues.default, Object.assign({
        LEGACY_fallbackIcon: $a669c9c7dda1a2bd$var$_childIssues2.default
    }, props));
$a669c9c7dda1a2bd$var$ChildIssuesIcon.Name = 'ChildIssuesIconMigration';
var $a669c9c7dda1a2bd$var$_default = module.exports.default = $a669c9c7dda1a2bd$var$ChildIssuesIcon;

});
parcelRegister("a5U1O", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::359c101bebeaae075dd3e3e9a50caec7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7595d510a7cf11ee$var$_react = $7595d510a7cf11ee$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7595d510a7cf11ee$var$_baseNew = $7595d510a7cf11ee$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $7595d510a7cf11ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChildIssues".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for child issues in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7595d510a7cf11ee$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $7595d510a7cf11ee$var$_react.default.createElement($7595d510a7cf11ee$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 4.5V1H1v10a2 2 0 0 0 2 2h4v.75c0 .69.56 1.25 1.25 1.25h5.5c.69 0 1.25-.56 1.25-1.25v-3c0-.69-.56-1.25-1.25-1.25h-5.5c-.69 0-1.25.56-1.25 1.25v.75H3a.5.5 0 0 1-.5-.5V6H7v.75C7 7.44 7.56 8 8.25 8h5.5C14.44 8 15 7.44 15 6.75v-3c0-.69-.56-1.25-1.25-1.25h-5.5C7.56 2.5 7 3.06 7 3.75v.75zm6-.5v2.5h5V4zm0 7v2.5h5V11z" clip-rule="evenodd"/>`
    }, props));
$7595d510a7cf11ee$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
var $7595d510a7cf11ee$var$_default = module.exports.default = $7595d510a7cf11ee$var$ChildIssuesIcon;

});

parcelRegister("hxodJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc484e6d94653edf$var$_react = $cc484e6d94653edf$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $cc484e6d94653edf$var$_childIssues = $cc484e6d94653edf$var$_interopRequireDefault((parcelRequire("a5U1O")));
function $cc484e6d94653edf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cc484e6d94653edf$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $cc484e6d94653edf$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11 7h2v5h-2zm5 6h2v3h-2zM6 13h2v3H6z"/><path d="M7 11h10a1 1 0 0 1 1 1v1H6v-1a1 1 0 0 1 1-1"/><path fill-rule="nonzero" d="M5 18v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2m10 2v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2M10 5v1h4V5zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2"/></g></svg>`
    }, props, {
        newIcon: $cc484e6d94653edf$var$_childIssues.default
    }));
$cc484e6d94653edf$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
var $cc484e6d94653edf$var$_default = module.exports.default = $cc484e6d94653edf$var$ChildIssuesIcon;

});



parcelRegister("3ivMk", function(module, exports) {

let $266bb40faa8f7fb6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $266bb40faa8f7fb6$var$load("hHAog").then(()=>parcelRequire('14MtF'));

});





parcelRegister("dghu0", function(module, exports) {

$parcel$export(module.exports, "default", () => $96a6d91fb5d77548$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $akF1x = parcelRequire("akF1x");
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $96a6d91fb5d77548$var$BaseBlockStylesOld = null;
const $96a6d91fb5d77548$var$baseBlockStyles = null;
const $96a6d91fb5d77548$var$highlightRemoveStyles = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $96a6d91fb5d77548$var$gapsStylesOld = {
    xlarge: "_zulp1k92 _1ljq1k92",
    large: "_zulp1j6v _1ljq1j6v",
    medium: "_zulp1kwk _1ljq1kwk",
    small: "_zulp6mu8 _1ljq6mu8"
};
const $96a6d91fb5d77548$var$gapStyles = {
    xlarge: "_zulpv47k _1ljqv47k",
    large: "_zulppxbi _1ljqpxbi",
    medium: "_zulpu2gc _1ljqu2gc",
    small: "_zulp1b66 _1ljq1b66"
};
const $96a6d91fb5d77548$var$directionStyles = {
    vertical: "_2lx21bp4 _4cvr1y6m",
    horizontal: "_2lx2vrvc _4cvr1h6o"
};
/**
 * A block represents a collection of elements and actions that are arranged
 * in a row. All elements and actions should be contained within a Block.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $96a6d91fb5d77548$var$Block = ({ children: children, direction: direction = (0, $8dVIb.SmartLinkDirection).Horizontal, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-block', className: className, blockRef: blockRef, onRender: onRender, onTransitionEnd: onTransitionEnd, style: style })=>{
    (0, $5uXOq.useEffect)(()=>{
        onRender && onRender();
    }, [
        onRender
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _4cvr1h6o _vwz41j6v _1e0c1txw _1ul9idpf _1bah1y6m _fiawglyw _1ouwidpf _f6ju1ns9 _1uzp1mp2 _ytq1bjq5 _a7e8uxlv",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _1bah1y6m _fiawglyw _1uzp1mp2 _a6bxmuej _e4i5bjq5 _1gu21oju _5b7tuxlv _17ae1oju",
            "_12ji1snc _1qu2agmp _12y310yn _12ji1kw7 _syaz1kw7 _18ql1j28 _1ifmglyw _181uglyw _1rkwglyw _te17glyw _uiztglyw",
            $96a6d91fb5d77548$var$directionStyles[direction],
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $96a6d91fb5d77548$var$gapsStylesOld[size],
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $96a6d91fb5d77548$var$gapStyles[size],
            className
        ]),
        "data-smart-block": true,
        "data-testid": testId,
        onTransitionEnd: onTransitionEnd,
        ref: blockRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        children: (0, $akF1x.renderChildren)(children, size)
    });
};
var $96a6d91fb5d77548$export$2e2bcd8739ae039 = $96a6d91fb5d77548$var$Block;

});



parcelRegister("gg6Qm", function(module, exports) {

$parcel$export(module.exports, "default", () => $61dcf60a0013442f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $dghu0 = parcelRequire("dghu0");

var $1BfaB = parcelRequire("1BfaB");

var $akF1x = parcelRequire("akF1x");
const $61dcf60a0013442f$var$DEFAULT_MAX_LINES = 2;
const $61dcf60a0013442f$var$MAXIMUM_MAX_LINES = 2;
const $61dcf60a0013442f$var$MINIMUM_MAX_LINES = 1;
const $61dcf60a0013442f$var$truncateStyles = {
    '1': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54",
    '2': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjcs5v _sudp1e54"
};
const $61dcf60a0013442f$var$sizeStylesOld = {
    xlarge: "_vwz41m1q _102k1k7u",
    large: "_vwz41m1q _102k1k7u",
    medium: "_vwz41k8s _102k1wto",
    small: "_vwz41k8s _102k1wto"
};
const $61dcf60a0013442f$var$sizeStyles = {
    xlarge: "_102k8vuz",
    large: "_102k8vuz",
    medium: "_102kckbl",
    small: "_102kckbl"
};
const $61dcf60a0013442f$var$getMaxLines = (maxLines)=>{
    if (maxLines > $61dcf60a0013442f$var$MAXIMUM_MAX_LINES) return $61dcf60a0013442f$var$DEFAULT_MAX_LINES;
    if (maxLines < $61dcf60a0013442f$var$MINIMUM_MAX_LINES) return $61dcf60a0013442f$var$MINIMUM_MAX_LINES;
    return maxLines;
};
/**
 * Represents a MetadataBlock, designed to contain groups of metadata in the form of elements.
 * Accepts an array of elements to be shown either primary (left hand side) or secondary (right hand side).
 * @public
 * @param {MetadataBlockProps} MetadataBlockProps
 * @see Block
 */ const $61dcf60a0013442f$var$MetadataBlock = ({ maxLines: maxLines = $61dcf60a0013442f$var$DEFAULT_MAX_LINES, status: status = (0, $8dVIb.SmartLinkStatus).Fallback, testId: testId = 'smart-block-metadata', primary: primary = [], secondary: secondary = [], ...blockProps })=>{
    if (primary.length === 0 && secondary.length === 0 || status !== (0, $8dVIb.SmartLinkStatus).Resolved) return null;
    const primaryElements = (0, $akF1x.renderElementItems)(primary);
    const secondaryElements = (0, $akF1x.renderElementItems)(secondary);
    const { size: size = (0, $8dVIb.SmartLinkSize).Medium } = blockProps;
    const maxLinesTotal = $61dcf60a0013442f$var$getMaxLines(maxLines);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        children: [
            primaryElements && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                align: (0, $8dVIb.SmartLinkAlignment).Left,
                direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                width: (0, $8dVIb.SmartLinkWidth).Flexible,
                size: size,
                className: (0, $bwpsq.default)([
                    $61dcf60a0013442f$var$truncateStyles[maxLinesTotal],
                    !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $61dcf60a0013442f$var$sizeStylesOld[size],
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $61dcf60a0013442f$var$sizeStyles[size]
                ]),
                children: primaryElements
            }),
            secondaryElements && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                align: (0, $8dVIb.SmartLinkAlignment).Right,
                direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                width: (0, $8dVIb.SmartLinkWidth).Flexible,
                size: size,
                className: (0, $bwpsq.default)([
                    $61dcf60a0013442f$var$truncateStyles[maxLinesTotal],
                    !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $61dcf60a0013442f$var$sizeStylesOld[size],
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $61dcf60a0013442f$var$sizeStyles[size]
                ]),
                children: secondaryElements
            })
        ]
    });
};
var $61dcf60a0013442f$export$2e2bcd8739ae039 = $61dcf60a0013442f$var$MetadataBlock;

});

parcelRegister("hYQw7", function(module, exports) {

$parcel$export(module.exports, "default", () => $61b44b31e2da1312$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $cElbi = parcelRequire("cElbi");
/**
 * Represents a PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlockProps} PreviewBlock
 * @see Block
 */ const $61b44b31e2da1312$var$PreviewBlock = ({ status: // eslint-disable-next-line @typescript-eslint/no-unused-vars
status = (0, $8dVIb.SmartLinkStatus).Fallback, testId: testId = 'smart-block-preview', overrideUrl: overrideUrl, ...blockProps })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cElbi.default), {
        ...blockProps,
        testId: testId,
        overrideUrl: overrideUrl
    });
};
var $61b44b31e2da1312$export$2e2bcd8739ae039 = $61b44b31e2da1312$var$PreviewBlock;

});
parcelRegister("cElbi", function(module, exports) {

$parcel$export(module.exports, "default", () => $64981f7edc74268b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $4gwhW = parcelRequire("4gwhW");

var $dghu0 = parcelRequire("dghu0");
const $64981f7edc74268b$var$previewBlockStyleCommon = null;
const $64981f7edc74268b$var$ignoreContainerPaddingStyle = null;
/**
 * Represents a resolved PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlock} PreviewBlock
 * @see Block
 */ const $64981f7edc74268b$var$PreviewBlockResolvedView = ({ ignoreContainerPadding: ignoreContainerPadding = false, onError: onError, placement: placement, testId: testId, overrideUrl: overrideUrl, style: style, className: className, ...blockProps })=>{
    const [dynamicStyles, setDynamicStyles] = (0, $5uXOq.useState)(style ?? {});
    const updateStyles = (0, $5uXOq.useCallback)(()=>{
        if (placement === (0, $8dVIb.MediaPlacement).Left || placement === (0, $8dVIb.MediaPlacement).Right) {
            const containerPadding = ignoreContainerPadding ? (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? '0px' : '0rem' : 'var(--container-padding)';
            const newStyle = {
                ...style,
                position: 'absolute',
                top: containerPadding,
                bottom: containerPadding,
                width: `calc(var(--preview-block-width) - ${containerPadding})`,
                ...placement === (0, $8dVIb.MediaPlacement).Left ? {
                    left: containerPadding
                } : {},
                ...placement === (0, $8dVIb.MediaPlacement).Right ? {
                    right: containerPadding
                } : {}
            };
            setDynamicStyles(newStyle);
        } else if (ignoreContainerPadding) setDynamicStyles({
            ...style
        });
    }, [
        ignoreContainerPadding,
        placement,
        style
    ]);
    (0, $5uXOq.useEffect)(()=>{
        updateStyles();
    }, [
        ignoreContainerPadding,
        placement,
        updateStyles,
        className
    ]);
    const handleOnLoad = (0, $5uXOq.useCallback)(()=>{
        updateStyles();
    }, [
        updateStyles
    ]);
    const handleOnError = (0, $5uXOq.useCallback)(()=>{
        if (onError) onError();
    }, [
        onError
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            placement && "_1t26n7od _ze72n7od _10aa1osq _rjuj1osq _mr051dfr",
            !placement && ignoreContainerPadding && "_18u01ivi _2hwxc10g _e0oi1ya9 _dmhj1ya9",
            className
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4gwhW.default), {
            onError: handleOnError,
            onLoad: handleOnLoad,
            overrideUrl: overrideUrl
        })
    });
};
var $64981f7edc74268b$export$2e2bcd8739ae039 = $64981f7edc74268b$var$PreviewBlockResolvedView;

});


parcelRegister("1JaZ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c880264dd5ccb40b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $khbkQ = parcelRequire("khbkQ");

var $kp8aU = parcelRequire("kp8aU");

var $fpDmE = parcelRequire("fpDmE");

var $dghu0 = parcelRequire("dghu0");
const $c880264dd5ccb40b$var$DEFAULT_MAX_LINES = 3;
const $c880264dd5ccb40b$var$MAXIMUM_MAX_LINES = 6;
const $c880264dd5ccb40b$var$MINIMUM_MAX_LINES = 1;
/**
 * Represents a SnippetBlock, which is used to display longer form text content, like descriptions.
 * @public
 * @param {SnippetBlockProps} SnippetBlockProps
 * @see Block
 */ const $c880264dd5ccb40b$var$SnippetBlock = ({ maxLines: maxLines = $c880264dd5ccb40b$var$DEFAULT_MAX_LINES, status: status = (0, $8dVIb.SmartLinkStatus).Fallback, testId: testId = 'smart-block-snippet', text: text, ...blockProps })=>{
    const context = (0, $VSDnB.fg)('cc-ai-linking-platform-snippet-renderer') ? (0, $Nh1XU.useFlexibleUiContext)() : undefined;
    const renderers = (0, $VSDnB.fg)('cc-ai-linking-platform-snippet-renderer') ? (0, $khbkQ.useSmartLinkRenderers)() : undefined;
    if (status !== (0, $8dVIb.SmartLinkStatus).Resolved && !text) return null;
    const snippetMaxLines = (0, $fpDmE.getMaxLines)(maxLines, $c880264dd5ccb40b$var$DEFAULT_MAX_LINES, $c880264dd5ccb40b$var$MAXIMUM_MAX_LINES, $c880264dd5ccb40b$var$MINIMUM_MAX_LINES);
    const statusTestId = !text ? 'resolved' : 'non-resolved';
    const snippet = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kp8aU.default), {
        maxLines: snippetMaxLines,
        content: text
    });
    if (!(0, $VSDnB.fg)('cc-ai-linking-platform-snippet-renderer')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-${statusTestId}-view`,
        children: snippet
    });
    const SnippetReplacement = renderers?.snippet;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-${statusTestId}-view`,
        children: SnippetReplacement ? /*#__PURE__*/ (0, $2OMIu.jsx)(SnippetReplacement, {
            fallbackText: (text || context?.snippet) ?? '',
            fallbackComponent: snippet,
            contentId: context?.meta?.objectId ?? '',
            contentType: context?.meta?.resourceType ?? '',
            cloudId: context?.meta?.tenantId ?? '',
            maxLines: snippetMaxLines
        }) : snippet
    });
};
var $c880264dd5ccb40b$export$2e2bcd8739ae039 = $c880264dd5ccb40b$var$SnippetBlock;

});
parcelRegister("khbkQ", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkRenderers", () => $53b108afa53560ee$export$c3514c024fefef57);

var $5uXOq = parcelRequire("5uXOq");

var $051X7 = parcelRequire("051X7");
const $53b108afa53560ee$export$c3514c024fefef57 = ()=>{
    const context = (0, $051X7.useSmartLinkContext)();
    let renderers = context?.renderers;
    renderers = (0, $5uXOq.useMemo)(()=>renderers, [
        renderers
    ]);
    return renderers;
};

});


parcelRegister("buvhv", function(module, exports) {

$parcel$export(module.exports, "default", () => $93b66054384f48ec$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $4URMI = parcelRequire("4URMI");

var $eqoQu = parcelRequire("eqoQu");

var $bubxq = parcelRequire("bubxq");

var $fkxMX = parcelRequire("fkxMX");

var $bXy5i = parcelRequire("bXy5i");

var $jHa2h = parcelRequire("jHa2h");
const $93b66054384f48ec$var$actionStyles = null;
const $93b66054384f48ec$var$getTitleBlockViewComponent = (status)=>{
    switch(status){
        case (0, $8dVIb.SmartLinkStatus).Pending:
        case (0, $8dVIb.SmartLinkStatus).Resolving:
            return 0, $jHa2h.default;
        case (0, $8dVIb.SmartLinkStatus).Resolved:
            return 0, $bXy5i.default;
        case (0, $8dVIb.SmartLinkStatus).Unauthorized:
        case (0, $8dVIb.SmartLinkStatus).Forbidden:
        case (0, $8dVIb.SmartLinkStatus).NotFound:
        case (0, $8dVIb.SmartLinkStatus).Errored:
        case (0, $8dVIb.SmartLinkStatus).Fallback:
        default:
            return 0, $fkxMX.default;
    }
};
/**
 * Represents a TitleBlock, which is the foundation of Flexible UI.
 * This contains an icon, the link, and any associated metadata and actions in one block.
 * The TitleBlock will also render differently given the state of the smart link.
 * This can be found in the corresponding Resolving, Resolved and Errored views.
 * @public
 * @param {TitleBlockProps} TitleBlockProps
 * @see Block
 * @see TitleBlockResolvingViewNew
 * @see TitleBlockResolvedViewNew
 * @see TitleBlockErroredViewNew
 */ const $93b66054384f48ec$var$TitleBlock = ({ actions: actions = [], anchorTarget: anchorTarget, hideTitleTooltip: hideTitleTooltip, maxLines: maxLines, onActionMenuOpenChange: onActionMenuOpenChange, onClick: onClick, status: status = (0, $8dVIb.SmartLinkStatus).Fallback, showActionOnHover: showActionOnHover, testId: testId = 'smart-block-title', text: text, icon: icon, theme: theme, hideRetry: hideRetry, metadataPosition: metadataPosition, hideIcon: hideIcon = false, className: className, anchorRef: anchorRef, ...props })=>{
    if (!(0, $VSDnB.fg)('platform-linking-flexible-card-unresolved-action')) {
        if (hideRetry && props.retry) delete props.retry;
    }
    const [actionDropdownOpen, setActionDropdownOpen] = (0, $5uXOq.useState)(false);
    const onDropdownOpenChange = (0, $5uXOq.useCallback)((isOpen)=>{
        setActionDropdownOpen(isOpen);
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    const actionGroup = actions.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bubxq.default), {
        items: actions,
        visibleButtonsNum: showActionOnHover ? 1 : 2,
        onDropdownOpenChange: onDropdownOpenChange
    });
    const overrideText = !!text ? {
        text: text
    } : {};
    const onMouseDown = (0, $4URMI.useMouseDownEvent)();
    const title = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqoQu.Title), {
        hideTooltip: hideTitleTooltip,
        maxLines: maxLines,
        onClick: onClick,
        onMouseDown: onMouseDown,
        target: anchorTarget,
        theme: theme,
        anchorRef: anchorRef,
        ...overrideText
    });
    const Component = $93b66054384f48ec$var$getTitleBlockViewComponent(status);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        ...props,
        actionGroup: actionGroup,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            showActionOnHover && !actionDropdownOpen && "_1bfhidpf _wn5xkb7n _h157kb7n",
            className
        ]),
        testId: testId,
        title: title,
        metadataPosition: metadataPosition,
        hideIcon: hideIcon,
        ...(0, $VSDnB.fg)('platform-linking-flexible-card-unresolved-action') ? {
            hideRetry: hideRetry
        } : undefined,
        icon: icon,
        size: props.size,
        theme: theme
    });
};
var $93b66054384f48ec$export$2e2bcd8739ae039 = $93b66054384f48ec$var$TitleBlock;

});
parcelRegister("fkxMX", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcbea6814ca213c7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $erAKX = parcelRequire("erAKX");

var $eqoQu = parcelRequire("eqoQu");

var $dghu0 = parcelRequire("dghu0");

var $1BfaB = parcelRequire("1BfaB");
/**
 * Represents an Errored TitleBlock view.
 * This will render when a Smart Link did not successfully resolve.
 * This may be a result of a Smart Link not having the correct credentials,
 * or the backend response was errored or malformed.
 * @see TitleBlock
 */ const $dcbea6814ca213c7$var$TitleBlockErroredView = ({ actionGroup: actionGroup, hideRetry: hideRetry, retry: retry, position: position, testId: testId, title: title, icon: icon, hideIcon: hideIcon, ...blockProps })=>{
    const { descriptor: descriptor, onClick: onClick, values: values } = retry || {};
    const hasAction = onClick !== undefined;
    const context = (0, $VSDnB.fg)('platform-linking-flexible-card-unresolved-action') ? (0, $Nh1XU.useFlexibleUiContext)() : {};
    const showRetry = (0, $VSDnB.fg)('platform-linking-flexible-card-unresolved-action') ? !hideRetry && Boolean(context?.actions?.[(0, $8dVIb.InternalActionName).UnresolvedAction]) : false;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-errored-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqoQu.LinkIcon), {
                overrideIcon: icon,
                position: position
            }),
            title,
            showRetry && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                align: (0, $8dVIb.SmartLinkAlignment).Right,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $erAKX.default), {
                    testId: testId
                })
            }),
            !(0, $VSDnB.fg)('platform-linking-flexible-card-unresolved-action') && descriptor && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                align: (0, $8dVIb.SmartLinkAlignment).Right,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    onClick: onClick,
                    testId: `${testId}-errored-view-message`,
                    tabIndex: hasAction ? 0 : -1,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...descriptor,
                        values: values
                    })
                })
            }),
            actionGroup
        ]
    });
};
var $dcbea6814ca213c7$export$2e2bcd8739ae039 = $dcbea6814ca213c7$var$TitleBlockErroredView;

});

parcelRegister("bXy5i", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2967317da51f9f7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8dVIb = parcelRequire("8dVIb");

var $eqoQu = parcelRequire("eqoQu");

var $dghu0 = parcelRequire("dghu0");

var $1BfaB = parcelRequire("1BfaB");

var $akF1x = parcelRequire("akF1x");
const $e2967317da51f9f7$var$style = null;
/**
 * This renders a fully resolved TitleBlock.
 * This should render when a Smart Link returns a valid response.
 * @see TitleBlock
 */ const $e2967317da51f9f7$var$TitleBlockResolvedView = ({ actionGroup: actionGroup, metadata: metadata = [], position: position, subtitle: subtitle = [], testId: testId, text: text, icon: icon, title: title, metadataPosition: metadataPosition, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size } = blockProps;
    const metadataElements = (0, $akF1x.renderElementItems)(metadata);
    const subtitleElements = (0, $akF1x.renderElementItems)(subtitle);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqoQu.LinkIcon), {
                overrideIcon: icon,
                position: position,
                size: size
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $1BfaB.default), {
                direction: (0, $8dVIb.SmartLinkDirection).Vertical,
                width: (0, $8dVIb.SmartLinkWidth).Flexible,
                size: blockProps.size,
                className: (0, $bwpsq.default)([
                    "_zulp1b66"
                ]),
                children: [
                    title,
                    subtitleElements && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                        direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                        children: subtitleElements
                    })
                ]
            }),
            metadataElements && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                align: (0, $8dVIb.SmartLinkAlignment).Right,
                position: metadataPosition ?? (0, $8dVIb.SmartLinkPosition).Center,
                size: blockProps.size,
                children: metadataElements
            }),
            actionGroup
        ]
    });
};
var $e2967317da51f9f7$export$2e2bcd8739ae039 = $e2967317da51f9f7$var$TitleBlockResolvedView;

});

parcelRegister("jHa2h", function(module, exports) {

$parcel$export(module.exports, "default", () => $045d1b1e49cae759$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $gU02S = parcelRequire("gU02S");

var $fpDmE = parcelRequire("fpDmE");

var $dghu0 = parcelRequire("dghu0");
/**
 * This represents a TitleBlock for a Smart Link that is currently waiting
 * for a request to finish.
 * This should render when a Smart Link has sent a request.
 * @see TitleBlock
 */ const $045d1b1e49cae759$var$TitleBlockResolvingView = ({ actionGroup: actionGroup, testId: testId, title: title, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size = (0, $8dVIb.SmartLinkSize).Medium } = blockProps;
    const iconWidth = (0, $fpDmE.getIconWidth)(size);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-resolving-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                style: {
                    width: iconWidth,
                    height: iconWidth
                },
                "data-testid": `${testId}-icon`,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU02S.LoadingSkeleton), {
                    width: iconWidth,
                    height: iconWidth,
                    testId: `${testId}-icon-loading`
                })
            }),
            title,
            actionGroup
        ]
    });
};
var $045d1b1e49cae759$export$2e2bcd8739ae039 = $045d1b1e49cae759$var$TitleBlockResolvingView;

});


parcelRegister("1qDIM", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dff75b4d7cc06d3$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $4tgi5 = parcelRequire("4tgi5");
/**
 * Represents an AISummaryBlock, designed to summarising link resource
 * content using AI.
 * @public
 * @param {AISummaryBlockProps} AISummaryBlock
 * @see Block
 */ const $5dff75b4d7cc06d3$var$AISummaryBlock = ({ status: status, testId: testId = 'smart-ai-summary-block', ...props })=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $8dVIb.InternalActionName).AISummaryAction];
    if (status !== (0, $8dVIb.SmartLinkStatus).Resolved) return null;
    if (!actionData?.url) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4tgi5.default), {
        ...props,
        testId: testId,
        url: actionData.url
    });
};
var $5dff75b4d7cc06d3$export$2e2bcd8739ae039 = $5dff75b4d7cc06d3$var$AISummaryBlock;

});
parcelRegister("4tgi5", function(module, exports) {

$parcel$export(module.exports, "default", () => $413bb2fab5c71807$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gKZoD = parcelRequire("gKZoD");

var $8dVIb = parcelRequire("8dVIb");

var $1MeuC = parcelRequire("1MeuC");

var $bHeMs = parcelRequire("bHeMs");

var $aBTst = parcelRequire("aBTst");

var $dghu0 = parcelRequire("dghu0");

var $adeuB = parcelRequire("adeuB");
const $413bb2fab5c71807$var$styles = null;
const $413bb2fab5c71807$var$AISummaryBlockResolvedView = (props)=>{
    (0, $gKZoD.di)((0, $1MeuC.default), (0, $bHeMs.default));
    const { testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, placeholder: placeholder, url: url } = props;
    const { state: { content: content, status: status } } = (0, $1MeuC.default)(url);
    const showAISummary = status === 'done' || // We want to display the AI Summary component only when there is content available during the loading process.
    status === 'loading' && !!content;
    const isSummarisedOnMountRef = (0, $5uXOq.useRef)(status === 'done');
    const minHeight = isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
    if (!showAISummary) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: placeholder
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...props,
        direction: (0, $8dVIb.SmartLinkDirection).Vertical,
        testId: `${testId}-resolved-view`,
        /**
   * Enabled for feature discovery to allow box shadow to overflow
   * Cleanup: https://product-fabric.atlassian.net/browse/EDM-8681
   */ className: (0, $bwpsq.default)([
            "_1reoewfl _18m9ewfl"
        ]),
        children: [
            status === 'done' && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $adeuB.default), {
                fromCache: isSummarisedOnMountRef.current
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aBTst.default), {
                minHeight: minHeight,
                show: showAISummary,
                showTransition: !isSummarisedOnMountRef.current,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bHeMs.default), {
                    testId: `${testId}-ai-summary`,
                    minHeight: minHeight,
                    content: content
                })
            })
        ]
    });
};
var $413bb2fab5c71807$export$2e2bcd8739ae039 = $413bb2fab5c71807$var$AISummaryBlockResolvedView;

});
parcelRegister("bHeMs", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea67ef8b17402f34$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $flpap = parcelRequire("flpap");

var $VSDnB = parcelRequire("VSDnB");

var $aRS1S = parcelRequire("aRS1S");
const $ea67ef8b17402f34$var$AISummaryCSSStyles = null;
const $ea67ef8b17402f34$var$baseStyle = null;
/**
 * A component to render a response from AI in markdown text.
 * @internal
 * @param {AISummaryProps} AISummaryProps
 */ const $ea67ef8b17402f34$var$AISummary = ({ content: content = '', className: className, testId: testId = 'ai-summary', minHeight: minHeight = 0 })=>{
    if (!content && minHeight === 0) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $flpap.default), {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_11c8dcr7 _slp31hna _1nmz1hna _o5724jg8 _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_11c81o8v _syaz1gjq _slp31hna _1nmz1hna _o5724jg8 _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        children: content,
        options: {
            forceWrapper: true,
            overrides: {
                ul: (0, $aRS1S.default)
            }
        },
        style: {
            minHeight: minHeight
        }
    });
};
var $ea67ef8b17402f34$export$2e2bcd8739ae039 = $ea67ef8b17402f34$var$AISummary;

});
parcelRegister("flpap", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2bc56c6c0b4e02e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $b2bc56c6c0b4e02e$var$t() {
    return $b2bc56c6c0b4e02e$var$t = Object.assign ? Object.assign.bind() : function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }, $b2bc56c6c0b4e02e$var$t.apply(this, arguments);
}
const $b2bc56c6c0b4e02e$var$n = [
    "children",
    "options"
], $b2bc56c6c0b4e02e$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
};
var $b2bc56c6c0b4e02e$var$i;
!function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}($b2bc56c6c0b4e02e$var$i || ($b2bc56c6c0b4e02e$var$i = {}));
const $b2bc56c6c0b4e02e$var$l = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce((e, t)=>(e[t.toLowerCase()] = t, e), {
    class: "className",
    for: "htmlFor"
}), $b2bc56c6c0b4e02e$var$a = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $b2bc56c6c0b4e02e$var$o = [
    "style",
    "script"
], $b2bc56c6c0b4e02e$var$c = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $b2bc56c6c0b4e02e$var$s = /mailto:/i, $b2bc56c6c0b4e02e$var$d = /\n{2,}$/, $b2bc56c6c0b4e02e$var$p = /^(\s*>[\s\S]*?)(?=\n{2,})/, $b2bc56c6c0b4e02e$var$u = /^ *> ?/gm, $b2bc56c6c0b4e02e$var$f = /^ {2,}\n/, $b2bc56c6c0b4e02e$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $b2bc56c6c0b4e02e$var$m = /^(?: {1,3})?(`{3,}|~{3,}) *(\S+)? *([^\n]*?)?\n([\s\S]*?)(?:\1\n?|$)/, $b2bc56c6c0b4e02e$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $b2bc56c6c0b4e02e$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $b2bc56c6c0b4e02e$var$k = /^(?:\n *)*\n/, $b2bc56c6c0b4e02e$var$x = /\r\n?/g, $b2bc56c6c0b4e02e$var$b = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $b2bc56c6c0b4e02e$var$v = /^\[\^([^\]]+)]/, $b2bc56c6c0b4e02e$var$S = /\f/g, $b2bc56c6c0b4e02e$var$E = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $b2bc56c6c0b4e02e$var$C = /^\s*?\[(x|\s)\]/, $b2bc56c6c0b4e02e$var$$ = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $b2bc56c6c0b4e02e$var$w = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $b2bc56c6c0b4e02e$var$z = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $b2bc56c6c0b4e02e$var$L = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $b2bc56c6c0b4e02e$var$A = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $b2bc56c6c0b4e02e$var$T = /^<!--[\s\S]*?(?:-->)/, $b2bc56c6c0b4e02e$var$O = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $b2bc56c6c0b4e02e$var$B = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $b2bc56c6c0b4e02e$var$M = /^\{.*\}$/, $b2bc56c6c0b4e02e$var$R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $b2bc56c6c0b4e02e$var$I = /^<([^ >]+@[^ >]+)>/, $b2bc56c6c0b4e02e$var$U = /^<([^ >]+:\/[^ >]+)>/, $b2bc56c6c0b4e02e$var$D = /-([a-z])?/gi, $b2bc56c6c0b4e02e$var$j = /^(\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $b2bc56c6c0b4e02e$var$N = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $b2bc56c6c0b4e02e$var$H = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $b2bc56c6c0b4e02e$var$F = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $b2bc56c6c0b4e02e$var$P = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $b2bc56c6c0b4e02e$var$_ = /\t/g, $b2bc56c6c0b4e02e$var$G = /(^ *\||\| *$)/g, $b2bc56c6c0b4e02e$var$W = /^ *:-+: *$/, $b2bc56c6c0b4e02e$var$Z = /^ *:-+ *$/, $b2bc56c6c0b4e02e$var$q = /^ *-+: *$/, $b2bc56c6c0b4e02e$var$Q = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~~.*?~~|==.*?==|.|\\n)*?)", $b2bc56c6c0b4e02e$var$V = new RegExp(`^([*_])\\1${$b2bc56c6c0b4e02e$var$Q}\\1\\1(?!\\1)`), $b2bc56c6c0b4e02e$var$X = new RegExp(`^([*_])${$b2bc56c6c0b4e02e$var$Q}\\1(?!\\1|\\w)`), $b2bc56c6c0b4e02e$var$J = new RegExp(`^==${$b2bc56c6c0b4e02e$var$Q}==`), $b2bc56c6c0b4e02e$var$K = new RegExp(`^~~${$b2bc56c6c0b4e02e$var$Q}~~`), $b2bc56c6c0b4e02e$var$Y = /^\\([^0-9A-Za-z\s])/, $b2bc56c6c0b4e02e$var$ee = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $b2bc56c6c0b4e02e$var$te = /^\n+/, $b2bc56c6c0b4e02e$var$ne = /^([ \t]*)/, $b2bc56c6c0b4e02e$var$re = /\\([^\\])/g, $b2bc56c6c0b4e02e$var$ie = / *\n+$/, $b2bc56c6c0b4e02e$var$le = /(?:^|\n)( *)$/, $b2bc56c6c0b4e02e$var$ae = "(?:\\d+\\.)", $b2bc56c6c0b4e02e$var$oe = "(?:[*+-])";
function $b2bc56c6c0b4e02e$var$ce(e) {
    return "( *)(" + (1 === e ? $b2bc56c6c0b4e02e$var$ae : $b2bc56c6c0b4e02e$var$oe) + ") +";
}
const $b2bc56c6c0b4e02e$var$se = $b2bc56c6c0b4e02e$var$ce(1), $b2bc56c6c0b4e02e$var$de = $b2bc56c6c0b4e02e$var$ce(2);
function $b2bc56c6c0b4e02e$var$pe(e) {
    return new RegExp("^" + (1 === e ? $b2bc56c6c0b4e02e$var$se : $b2bc56c6c0b4e02e$var$de));
}
const $b2bc56c6c0b4e02e$var$ue = $b2bc56c6c0b4e02e$var$pe(1), $b2bc56c6c0b4e02e$var$fe = $b2bc56c6c0b4e02e$var$pe(2);
function $b2bc56c6c0b4e02e$var$he(e) {
    return new RegExp("^" + (1 === e ? $b2bc56c6c0b4e02e$var$se : $b2bc56c6c0b4e02e$var$de) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $b2bc56c6c0b4e02e$var$ae : $b2bc56c6c0b4e02e$var$oe) + " )[^\\n]*)*(\\n|$)", "gm");
}
const $b2bc56c6c0b4e02e$var$me = $b2bc56c6c0b4e02e$var$he(1), $b2bc56c6c0b4e02e$var$ge = $b2bc56c6c0b4e02e$var$he(2);
function $b2bc56c6c0b4e02e$var$ye(e) {
    const t = 1 === e ? $b2bc56c6c0b4e02e$var$ae : $b2bc56c6c0b4e02e$var$oe;
    return new RegExp("^( *)(" + t + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + t + " (?!" + t + " ))\\n*|\\s*\\n*$)");
}
const $b2bc56c6c0b4e02e$var$ke = $b2bc56c6c0b4e02e$var$ye(1), $b2bc56c6c0b4e02e$var$xe = $b2bc56c6c0b4e02e$var$ye(2);
function $b2bc56c6c0b4e02e$var$be(e, t) {
    const n = 1 === t, i = n ? $b2bc56c6c0b4e02e$var$ke : $b2bc56c6c0b4e02e$var$xe, l = n ? $b2bc56c6c0b4e02e$var$me : $b2bc56c6c0b4e02e$var$ge, a = n ? $b2bc56c6c0b4e02e$var$ue : $b2bc56c6c0b4e02e$var$fe;
    return {
        match (e, t) {
            const n = $b2bc56c6c0b4e02e$var$le.exec(t.prevCapture);
            return n && (t.list || !t.inline && !t.simple) ? i.exec(e = n[1] + e) : null;
        },
        order: 1,
        parse (e, t, r) {
            const i = n ? +e[2] : void 0, o = e[0].replace($b2bc56c6c0b4e02e$var$d, "\n").match(l);
            let c = !1;
            return {
                items: o.map(function(e, n) {
                    const i = a.exec(e)[0].length, l = new RegExp("^ {1," + i + "}", "gm"), s = e.replace(l, "").replace(a, ""), d = n === o.length - 1, p = -1 !== s.indexOf("\n\n") || d && c;
                    c = p;
                    const u = r.inline, f = r.list;
                    let h;
                    r.list = !0, p ? (r.inline = !1, h = s.replace($b2bc56c6c0b4e02e$var$ie, "\n\n")) : (r.inline = !0, h = s.replace($b2bc56c6c0b4e02e$var$ie, ""));
                    const m = t(h, r);
                    return r.inline = u, r.list = f, m;
                }),
                ordered: n,
                start: i
            };
        },
        render: (t, n, i)=>e(t.ordered ? "ol" : "ul", {
                key: i.key,
                start: t.type === $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.orderedList ? t.start : void 0
            }, t.items.map(function(t, r) {
                return e("li", {
                    key: r
                }, n(t, i));
            }))
    };
}
const $b2bc56c6c0b4e02e$var$ve = new RegExp("^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $b2bc56c6c0b4e02e$var$Se = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $b2bc56c6c0b4e02e$var$Ee = [
    $b2bc56c6c0b4e02e$var$p,
    $b2bc56c6c0b4e02e$var$m,
    $b2bc56c6c0b4e02e$var$g,
    $b2bc56c6c0b4e02e$var$$,
    $b2bc56c6c0b4e02e$var$z,
    $b2bc56c6c0b4e02e$var$w,
    $b2bc56c6c0b4e02e$var$T,
    $b2bc56c6c0b4e02e$var$j,
    $b2bc56c6c0b4e02e$var$me,
    $b2bc56c6c0b4e02e$var$ke,
    $b2bc56c6c0b4e02e$var$ge,
    $b2bc56c6c0b4e02e$var$xe
], $b2bc56c6c0b4e02e$var$Ce = [
    ...$b2bc56c6c0b4e02e$var$Ee,
    /^[^\n]+(?:  \n|\n{2,})/,
    $b2bc56c6c0b4e02e$var$L,
    $b2bc56c6c0b4e02e$var$B
];
function $b2bc56c6c0b4e02e$export$c383cdd2a518017a(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $b2bc56c6c0b4e02e$var$we(e) {
    return $b2bc56c6c0b4e02e$var$q.test(e) ? "right" : $b2bc56c6c0b4e02e$var$W.test(e) ? "center" : $b2bc56c6c0b4e02e$var$Z.test(e) ? "left" : null;
}
function $b2bc56c6c0b4e02e$var$ze(e, t, n, i) {
    const l = n.inTable;
    n.inTable = !0;
    let a = e.trim().split(/( *(?:`[^`]*`|<.*?>.*?<\/.*?>(?!<\/.*?>)|\\\||\|) *)/).reduce((e, l)=>("|" === l.trim() ? e.push(i ? {
            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.tableSeparator
        } : {
            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text,
            text: l
        }) : "" !== l && e.push.apply(e, t(l, n)), e), []);
    n.inTable = l;
    let o = [
        []
    ];
    return a.forEach(function(e, t) {
        e.type === $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.tableSeparator ? 0 !== t && t !== a.length - 1 && o.push([]) : (e.type !== $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text || null != a[t + 1] && a[t + 1].type !== $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.tableSeparator || (e.text = e.text.trimEnd()), o[o.length - 1].push(e));
    }), o;
}
function $b2bc56c6c0b4e02e$var$Le(e, t, n) {
    n.inline = !0;
    const i = e[2] ? e[2].replace($b2bc56c6c0b4e02e$var$G, "").split("|").map($b2bc56c6c0b4e02e$var$we) : [], l = e[3] ? function(e, t, n) {
        return e.trim().split("\n").map(function(e) {
            return $b2bc56c6c0b4e02e$var$ze(e, t, n, !0);
        });
    }(e[3], t, n) : [], a = $b2bc56c6c0b4e02e$var$ze(e[1], t, n, !!l.length);
    return n.inline = !1, l.length ? {
        align: i,
        cells: l,
        header: a,
        type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.table
    } : {
        children: a,
        type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.paragraph
    };
}
function $b2bc56c6c0b4e02e$var$Ae(e, t) {
    return null == e.align[t] ? {} : {
        textAlign: e.align[t]
    };
}
function $b2bc56c6c0b4e02e$var$Te(e) {
    return function(t, n) {
        return n.inline ? e.exec(t) : null;
    };
}
function $b2bc56c6c0b4e02e$var$Oe(e) {
    return function(t, n) {
        return n.inline || n.simple ? e.exec(t) : null;
    };
}
function $b2bc56c6c0b4e02e$var$Be(e) {
    return function(t, n) {
        return n.inline || n.simple ? null : e.exec(t);
    };
}
function $b2bc56c6c0b4e02e$var$Me(e) {
    return function(t) {
        return e.exec(t);
    };
}
function $b2bc56c6c0b4e02e$var$Re(e, t) {
    if (t.inline || t.simple) return null;
    let n = "";
    e.split("\n").every((e)=>!$b2bc56c6c0b4e02e$var$Ee.some((t)=>t.test(e)) && (n += e + "\n", e.trim()));
    const r = n.trimEnd();
    return "" == r ? null : [
        n,
        r
    ];
}
function $b2bc56c6c0b4e02e$export$3e2338ea76b578c9(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return null;
    } catch (e) {
        return null;
    }
    return e;
}
function $b2bc56c6c0b4e02e$var$Ue(e) {
    return e.replace($b2bc56c6c0b4e02e$var$re, "$1");
}
function $b2bc56c6c0b4e02e$var$De(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !0, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $b2bc56c6c0b4e02e$var$je(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !1, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $b2bc56c6c0b4e02e$var$Ne(e, t, n) {
    const r = n.inline || !1;
    n.inline = !1;
    const i = e(t, n);
    return n.inline = r, i;
}
const $b2bc56c6c0b4e02e$var$He = (e, t, n)=>({
        children: $b2bc56c6c0b4e02e$var$De(t, e[1], n)
    });
function $b2bc56c6c0b4e02e$var$Fe() {
    return {};
}
function $b2bc56c6c0b4e02e$var$Pe() {
    return null;
}
function $b2bc56c6c0b4e02e$var$_e(...e) {
    return e.filter(Boolean).join(" ");
}
function $b2bc56c6c0b4e02e$var$Ge(e, t, n) {
    let r = e;
    const i = t.split(".");
    for(; i.length && (r = r[i[0]], void 0 !== r);)i.shift();
    return r || n;
}
function $b2bc56c6c0b4e02e$export$69f434acfbdb0b32(n = "", i = {}) {
    function d(e, n, ...r) {
        const l = $b2bc56c6c0b4e02e$var$Ge(i.overrides, `${e}.props`, {});
        return i.createElement(function(e, t) {
            const n = $b2bc56c6c0b4e02e$var$Ge(t, e);
            return n ? "function" == typeof n || "object" == typeof n && "render" in n ? n : $b2bc56c6c0b4e02e$var$Ge(t, `${e}.component`, e) : e;
        }(e, i.overrides), $b2bc56c6c0b4e02e$var$t({}, n, l, {
            className: $b2bc56c6c0b4e02e$var$_e(null == n ? void 0 : n.className, l.className) || void 0
        }), ...r);
    }
    function G(t) {
        t = t.replace($b2bc56c6c0b4e02e$var$E, "");
        let n = !1;
        i.forceInline ? n = !0 : i.forceBlock || (n = !1 === $b2bc56c6c0b4e02e$var$P.test(t));
        const r = ie(re(n ? t : `${t.trimEnd().replace($b2bc56c6c0b4e02e$var$te, "")}\n\n`, {
            inline: n
        }));
        for(; "string" == typeof r[r.length - 1] && !r[r.length - 1].trim();)r.pop();
        if (null === i.wrapper) return r;
        const l = i.wrapper || (n ? "span" : "div");
        let a;
        if (r.length > 1 || i.forceWrapper) a = r;
        else {
            if (1 === r.length) return a = r[0], "string" == typeof a ? d("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return $5uXOq.createElement(l, {
            key: "outer"
        }, a);
    }
    function W(t, n) {
        const r = n.match($b2bc56c6c0b4e02e$var$c);
        return r ? r.reduce(function(n, r, a) {
            const o = r.indexOf("=");
            if (-1 !== o) {
                const c = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($b2bc56c6c0b4e02e$var$O) && (e = e.replace($b2bc56c6c0b4e02e$var$D, function(e, t) {
                        return t.toUpperCase();
                    })), e;
                })(r.slice(0, o)).trim(), s = function(e) {
                    const t = e[0];
                    return ('"' === t || "'" === t) && e.length >= 2 && e[e.length - 1] === t ? e.slice(1, -1) : e;
                }(r.slice(o + 1).trim()), d = $b2bc56c6c0b4e02e$var$l[c] || c, p = n[d] = function(e, t, n, r) {
                    return "style" === t ? n.split(/;\s?/).reduce(function(e, t) {
                        const n = t.slice(0, t.indexOf(":"));
                        return e[n.trim().replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = t.slice(n.length + 1).trim(), e;
                    }, {}) : "href" === t || "src" === t ? r(n, e, t) : (n.match($b2bc56c6c0b4e02e$var$M) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(t, c, s, i.sanitizer);
                "string" == typeof p && ($b2bc56c6c0b4e02e$var$L.test(p) || $b2bc56c6c0b4e02e$var$B.test(p)) && (n[d] = $5uXOq.cloneElement(G(p.trim()), {
                    key: a
                }));
            } else "style" !== r && (n[$b2bc56c6c0b4e02e$var$l[r] || r] = !0);
            return n;
        }, {}) : null;
    }
    i.overrides = i.overrides || {}, i.sanitizer = i.sanitizer || $b2bc56c6c0b4e02e$export$3e2338ea76b578c9, i.slugify = i.slugify || $b2bc56c6c0b4e02e$export$c383cdd2a518017a, i.namedCodesToUnicode = i.namedCodesToUnicode ? $b2bc56c6c0b4e02e$var$t({}, $b2bc56c6c0b4e02e$var$a, i.namedCodesToUnicode) : $b2bc56c6c0b4e02e$var$a, i.createElement = i.createElement || $5uXOq.createElement;
    const Z = [], q = {}, Q = {
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.blockQuote]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$p),
            order: 1,
            parse: (e, t, n)=>({
                    children: t(e[0].replace($b2bc56c6c0b4e02e$var$u, ""), n)
                }),
            render: (e, t, n)=>d("blockquote", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.breakLine]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$f),
            order: 1,
            parse: $b2bc56c6c0b4e02e$var$Fe,
            render: (e, t, n)=>d("br", {
                    key: n.key
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.breakThematic]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$h),
            order: 1,
            parse: $b2bc56c6c0b4e02e$var$Fe,
            render: (e, t, n)=>d("hr", {
                    key: n.key
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeBlock]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$g),
            order: 0,
            parse: (e)=>({
                    lang: void 0,
                    text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
                }),
            render: (e, n, r)=>d("pre", {
                    key: r.key
                }, d("code", $b2bc56c6c0b4e02e$var$t({}, e.attrs, {
                    className: e.lang ? `lang-${e.lang}` : ""
                }), e.text))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeFenced]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$m),
            order: 0,
            parse: (e)=>({
                    attrs: W("code", e[3] || ""),
                    lang: e[2] || void 0,
                    text: e[4],
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeBlock
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeInline]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$y),
            order: 3,
            parse: (e)=>({
                    text: e[2]
                }),
            render: (e, t, n)=>d("code", {
                    key: n.key
                }, e.text)
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.footnote]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$b),
            order: 0,
            parse: (e)=>(Z.push({
                    footnote: e[2],
                    identifier: e[1]
                }), {}),
            render: $b2bc56c6c0b4e02e$var$Pe
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.footnoteReference]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$v),
            order: 1,
            parse: (e)=>({
                    target: `#${i.slugify(e[1], $b2bc56c6c0b4e02e$export$c383cdd2a518017a)}`,
                    text: e[1]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href")
                }, d("sup", {
                    key: n.key
                }, e.text))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.gfmTask]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$C),
            order: 1,
            parse: (e)=>({
                    completed: "x" === e[1].toLowerCase()
                }),
            render: (e, t, n)=>d("input", {
                    checked: e.completed,
                    key: n.key,
                    readOnly: !0,
                    type: "checkbox"
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.heading]: {
            match: $b2bc56c6c0b4e02e$var$Be(i.enforceAtxHeadings ? $b2bc56c6c0b4e02e$var$w : $b2bc56c6c0b4e02e$var$$),
            order: 1,
            parse: (e, t, n)=>({
                    children: $b2bc56c6c0b4e02e$var$De(t, e[2], n),
                    id: i.slugify(e[2], $b2bc56c6c0b4e02e$export$c383cdd2a518017a),
                    level: e[1].length
                }),
            render: (e, t, n)=>d(`h${e.level}`, {
                    id: e.id,
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.headingSetext]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$z),
            order: 0,
            parse: (e, t, n)=>({
                    children: $b2bc56c6c0b4e02e$var$De(t, e[1], n),
                    level: "=" === e[2] ? 1 : 2,
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.heading
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlBlock]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$L),
            order: 1,
            parse (e, t, n) {
                const [, r] = e[3].match($b2bc56c6c0b4e02e$var$ne), i = new RegExp(`^${r}`, "gm"), l = e[3].replace(i, ""), a = (c = l, $b2bc56c6c0b4e02e$var$Ce.some((e)=>e.test(c)) ? $b2bc56c6c0b4e02e$var$Ne : $b2bc56c6c0b4e02e$var$De);
                var c;
                const s = e[1].toLowerCase(), d = -1 !== $b2bc56c6c0b4e02e$var$o.indexOf(s), p = (d ? s : e[1]).trim(), u = {
                    attrs: W(p, e[2]),
                    noInnerParse: d,
                    tag: p
                };
                return n.inAnchor = n.inAnchor || "a" === s, d ? u.text = e[3] : u.children = a(t, l, n), n.inAnchor = !1, u;
            },
            render: (e, n, r)=>d(e.tag, $b2bc56c6c0b4e02e$var$t({
                    key: r.key
                }, e.attrs), e.text || (e.children ? n(e.children, r) : ""))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlSelfClosing]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$B),
            order: 1,
            parse (e) {
                const t = e[1].trim();
                return {
                    attrs: W(t, e[2] || ""),
                    tag: t
                };
            },
            render: (e, n, r)=>d(e.tag, $b2bc56c6c0b4e02e$var$t({}, e.attrs, {
                    key: r.key
                }))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlComment]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$T),
            order: 1,
            parse: ()=>({}),
            render: $b2bc56c6c0b4e02e$var$Pe
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.image]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$Se),
            order: 1,
            parse: (e)=>({
                    alt: e[1],
                    target: $b2bc56c6c0b4e02e$var$Ue(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("img", {
                    key: n.key,
                    alt: e.alt || void 0,
                    title: e.title || void 0,
                    src: i.sanitizer(e.target, "img", "src")
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$ve),
            order: 3,
            parse: (e, t, n)=>({
                    children: $b2bc56c6c0b4e02e$var$je(t, e[1], n),
                    target: $b2bc56c6c0b4e02e$var$Ue(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href"),
                    title: e.title
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.linkAngleBraceStyleDetector]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$U),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.linkBareUrlDetector]: {
            match: (e, t)=>t.inAnchor || i.disableAutoLink ? null : $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$R)(e, t),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    title: void 0,
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.linkMailtoDetector]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$I),
            order: 0,
            parse (e) {
                let t = e[1], n = e[1];
                return $b2bc56c6c0b4e02e$var$s.test(n) || (n = "mailto:" + n), {
                    children: [
                        {
                            text: t.replace("mailto:", ""),
                            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: n,
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link
                };
            }
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.orderedList]: $b2bc56c6c0b4e02e$var$be(d, 1),
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.unorderedList]: $b2bc56c6c0b4e02e$var$be(d, 2),
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.newlineCoalescer]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$k),
            order: 3,
            parse: $b2bc56c6c0b4e02e$var$Fe,
            render: ()=>"\n"
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.paragraph]: {
            match: $b2bc56c6c0b4e02e$var$Re,
            order: 3,
            parse: $b2bc56c6c0b4e02e$var$He,
            render: (e, t, n)=>d("p", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.ref]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$N),
            order: 0,
            parse: (e)=>(q[e[1]] = {
                    target: e[2],
                    title: e[4]
                }, {}),
            render: $b2bc56c6c0b4e02e$var$Pe
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.refImage]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$H),
            order: 0,
            parse: (e)=>({
                    alt: e[1] || void 0,
                    ref: e[2]
                }),
            render: (e, t, n)=>q[e.ref] ? d("img", {
                    key: n.key,
                    alt: e.alt,
                    src: i.sanitizer(q[e.ref].target, "img", "src"),
                    title: q[e.ref].title
                }) : null
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.refLink]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$F),
            order: 0,
            parse: (e, t, n)=>({
                    children: t(e[1], n),
                    fallbackChildren: e[0],
                    ref: e[2]
                }),
            render: (e, t, n)=>q[e.ref] ? d("a", {
                    key: n.key,
                    href: i.sanitizer(q[e.ref].target, "a", "href"),
                    title: q[e.ref].title
                }, t(e.children, n)) : d("span", {
                    key: n.key
                }, e.fallbackChildren)
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.table]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$j),
            order: 1,
            parse: $b2bc56c6c0b4e02e$var$Le,
            render (e, t, n) {
                const r = e;
                return d("table", {
                    key: n.key
                }, d("thead", null, d("tr", null, r.header.map(function(e, i) {
                    return d("th", {
                        key: i,
                        style: $b2bc56c6c0b4e02e$var$Ae(r, i)
                    }, t(e, n));
                }))), d("tbody", null, r.cells.map(function(e, i) {
                    return d("tr", {
                        key: i
                    }, e.map(function(e, i) {
                        return d("td", {
                            key: i,
                            style: $b2bc56c6c0b4e02e$var$Ae(r, i)
                        }, t(e, n));
                    }));
                })));
            }
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$ee),
            order: 4,
            parse: (e)=>({
                    text: e[0].replace($b2bc56c6c0b4e02e$var$A, (e, t)=>i.namedCodesToUnicode[t] ? i.namedCodesToUnicode[t] : e)
                }),
            render: (e)=>e.text
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textBolded]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$V),
            order: 2,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("strong", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textEmphasized]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$X),
            order: 3,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("em", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textEscaped]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$Y),
            order: 1,
            parse: (e)=>({
                    text: e[1],
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textMarked]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$J),
            order: 3,
            parse: $b2bc56c6c0b4e02e$var$He,
            render: (e, t, n)=>d("mark", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textStrikethroughed]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$K),
            order: 3,
            parse: $b2bc56c6c0b4e02e$var$He,
            render: (e, t, n)=>d("del", {
                    key: n.key
                }, t(e.children, n))
        }
    };
    !0 === i.disableParsingRawHTML && (delete Q[$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlBlock], delete Q[$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlSelfClosing]);
    const re = function(e) {
        let t = Object.keys(e);
        function n(r, i) {
            let l = [];
            for(i.prevCapture = i.prevCapture || ""; r;){
                let a = 0;
                for(; a < t.length;){
                    const o = t[a], c = e[o], s = c.match(r, i);
                    if (s) {
                        const e = s[0];
                        i.prevCapture += e, r = r.substring(e.length);
                        const t = c.parse(s, n, i);
                        null == t.type && (t.type = o), l.push(t);
                        break;
                    }
                    a++;
                }
            }
            return i.prevCapture = "", l;
        }
        return t.sort(function(t, n) {
            let r = e[t].order, i = e[n].order;
            return r !== i ? r - i : t < n ? -1 : 1;
        }), function(e, t) {
            return n(function(e) {
                return e.replace($b2bc56c6c0b4e02e$var$x, "\n").replace($b2bc56c6c0b4e02e$var$S, "").replace($b2bc56c6c0b4e02e$var$_, "    ");
            }(e), t);
        };
    }(Q), ie = (le = function(e, t) {
        return function(n, r, i) {
            const l = e[n.type].render;
            return t ? t(()=>l(n, r, i), n, r, i) : l(n, r, i);
        };
    }(Q, i.renderRule), function e(t, n = {}) {
        if (Array.isArray(t)) {
            const r = n.key, i = [];
            let l = !1;
            for(let r = 0; r < t.length; r++){
                n.key = r;
                const a = e(t[r], n), o = "string" == typeof a;
                o && l ? i[i.length - 1] += a : null !== a && i.push(a), l = o;
            }
            return n.key = r, i;
        }
        return le(t, e, n);
    });
    var le;
    const ae = G(n);
    return Z.length ? d("div", null, ae, d("footer", {
        key: "footer"
    }, Z.map(function(e) {
        return d("div", {
            id: i.slugify(e.identifier, $b2bc56c6c0b4e02e$export$c383cdd2a518017a),
            key: e.identifier
        }, e.identifier, ie(re(e.footnote, {
            inline: !0
        })));
    }))) : ae;
}
var $b2bc56c6c0b4e02e$export$2e2bcd8739ae039 = (t)=>{
    let { children: r = "", options: i } = t, l = function(e, t) {
        if (null == e) return {};
        var n, r, i = {}, l = Object.keys(e);
        for(r = 0; r < l.length; r++)t.indexOf(n = l[r]) >= 0 || (i[n] = e[n]);
        return i;
    }(t, $b2bc56c6c0b4e02e$var$n);
    return $5uXOq.cloneElement($b2bc56c6c0b4e02e$export$69f434acfbdb0b32(r, i), l);
};

});

parcelRegister("aRS1S", function(module, exports) {

$parcel$export(module.exports, "default", () => $270fc2c4bbd80c91$export$2e2bcd8739ae039);
/* ulist.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");
const $270fc2c4bbd80c91$var$listStyles = null;
const $270fc2c4bbd80c91$var$UList = ({ children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("ul", {
        ...props,
        className: (0, $bwpsq.default)([
            "_19bvv47k _bozgv47k"
        ]),
        children: children
    });
var $270fc2c4bbd80c91$export$2e2bcd8739ae039 = $270fc2c4bbd80c91$var$UList;

});


parcelRegister("aBTst", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8d8f80d50d9d1e4$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
const $a8d8f80d50d9d1e4$export$6118ed0013927eb2 = ({ children: children, isFadeIn: isFadeIn = false, minHeight: minHeight = 0, show: show, showTransition: showTransition = false })=>{
    const [height, setHeight] = (0, $5uXOq.useState)(0);
    const ref = (0, $5uXOq.useRef)(null);
    const transition = isFadeIn ? 'height, opacity' : 'height';
    (0, $5uXOq.useEffect)(()=>{
        if (show && ref.current) // set the height of the error message container explicitly to the height
        // of its contents (including anything hidden due to overflow) so that we
        // can animate the height of the container
        setHeight(ref.current.scrollHeight);
        else setHeight(0);
    }, [
        children,
        show
    ]);
    return show ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        style: {
            height: height,
            minHeight: minHeight,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
            lineHeight: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // a fit for purpose state variable to control when the 'visible' styles should be appled
            opacity: height > 0 ? 1 : 0,
            // we only want to transition opacity and height when the error message is initially shown
            // not if its to be shown on mount
            transitionProperty: showTransition ? transition : 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            transitionDuration: '0.3s'
        },
        ref: ref,
        children: children
    }) : null;
};
var $a8d8f80d50d9d1e4$export$2e2bcd8739ae039 = $a8d8f80d50d9d1e4$export$6118ed0013927eb2;

});

parcelRegister("adeuB", function(module, exports) {

$parcel$export(module.exports, "default", () => $749bb6d43c83bff0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $a1vqi = parcelRequire("a1vqi");
const $749bb6d43c83bff0$var$AIEventSummaryViewed = ({ fromCache: fromCache = null })=>{
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        fireEvent('ui.summary.viewed', {
            fromCache: fromCache
        });
        if (fromCache) fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 1,
            userGeneratedAI: 0
        });
    }, [
        fireEvent,
        fromCache
    ]);
    return null;
};
var $749bb6d43c83bff0$export$2e2bcd8739ae039 = $749bb6d43c83bff0$var$AIEventSummaryViewed;

});



parcelRegister("85ffk", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5cb2203e6787402$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $obtkX = parcelRequire("obtkX");
/**
 * Represents a AIFooterBlock, designed to show provider metadata in
 * addition to AI tooltip icons if AI is enabled
 * @param {AIFooterBlockProps} AIFooterBlockProps
 * @see Block
 */ const $d5cb2203e6787402$var$AIFooterBlock = ({ status: status, testId: testId = 'smart-ai-footer-block', ...props })=>{
    if (status !== (0, $8dVIb.SmartLinkStatus).Resolved) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $obtkX.default), {
        ...props,
        testId: testId
    });
};
var $d5cb2203e6787402$export$2e2bcd8739ae039 = $d5cb2203e6787402$var$AIFooterBlock;

});
parcelRegister("obtkX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6b56bbc6d143050$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $eqoQu = parcelRequire("eqoQu");

var $dghu0 = parcelRequire("dghu0");

var $kBKwT = parcelRequire("kBKwT");
const $f6b56bbc6d143050$var$AIFooterBlockResolvedView = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $8dVIb.InternalActionName).AISummaryAction];
    const { testId: testId } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...props,
        testId: `${testId}-resolved-view`,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqoQu.Provider), {
                ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {
                    appearance: 'subtle'
                } : {},
                testId: `${testId}-provider`
            }),
            actionData ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kBKwT.AIFooterMetadata), {
                ...actionData,
                testId: `${testId}-ai-metadata`
            }) : null
        ]
    });
};
var $f6b56bbc6d143050$export$2e2bcd8739ae039 = $f6b56bbc6d143050$var$AIFooterBlockResolvedView;

});
parcelRegister("kBKwT", function(module, exports) {

$parcel$export(module.exports, "AIFooterMetadata", () => $84dc366e320e5880$export$175228cc2c92b3b6);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $gKZoD = parcelRequire("gKZoD");

var $jps85 = parcelRequire("jps85");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");

var $3bDjY = parcelRequire("3bDjY");

var $7zaVw = parcelRequire("7zaVw");

var $1MeuC = parcelRequire("1MeuC");

var $8z1HA = parcelRequire("8z1HA");

var $c8Sqt = parcelRequire("c8Sqt");
const $84dc366e320e5880$export$175228cc2c92b3b6 = ({ testId: testId, url: url })=>{
    (0, $gKZoD.di)((0, $1MeuC.default));
    const { state: { status: status } } = (0, $1MeuC.default)(url);
    if (status !== 'done') return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
        space: "space.100",
        testId: testId,
        alignInline: "end",
        grow: "fill",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $7zaVw.messages).ai_summarized_info_short
                }),
                position: "bottom",
                children: (tooltipProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                        ...tooltipProps,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c8Sqt.InfoIcon), {
                            label: "Information",
                            LEGACY_size: "small",
                            color: "var(--ds-icon-subtle, #626F86)"
                        })
                    })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jps85))), {
                label: "AI",
                LEGACY_size: "small",
                LEGACY_fallbackIcon: (0, $8z1HA.default),
                color: "var(--ds-icon-subtle, #626F86)"
            })
        ]
    });
};

});
parcelRegister("c8Sqt", function(module, exports) {

$parcel$export(module.exports, "InfoIcon", () => $a035773c38c242b5$export$2957fc44b3d2481);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $2Yv61 = parcelRequire("2Yv61");

var $lqBg9 = parcelRequire("lqBg9");
const $a035773c38c242b5$export$2957fc44b3d2481 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Yv61))), {
        color: props.color || 'currentColor',
        LEGACY_fallbackIcon: (0, $lqBg9.default),
        ...props
    });

});
parcelRegister("lqBg9", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f1ed3211c768fe6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $4f1ed3211c768fe6$var$InfoIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M7 5C7 5.55228 7.44772 6 8 6C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M7.25 7L7.25 12H8.75L8.75 7H7.25Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5C4.96243 2.5 2.5 4.96243 2.5 8Z",
                fill: "currentColor"
            })
        ]
    });
/**
 * __InfoIcon__
 */ const $4f1ed3211c768fe6$var$InfoIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $4f1ed3211c768fe6$var$InfoIconGlyph
    });
var $4f1ed3211c768fe6$export$2e2bcd8739ae039 = $4f1ed3211c768fe6$var$InfoIcon;

});





parcelRegister("fh9qw", function(module, exports) {

$parcel$export(module.exports, "default", () => $b695424587865b74$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gKZoD = parcelRequire("gKZoD");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $jRHKj = parcelRequire("jRHKj");

var $s2ak7 = parcelRequire("s2ak7");
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $b695424587865b74$var$ignoreContainerPaddingStylesOld = null;
const $b695424587865b74$var$ignoreContainerPaddingStyles = null;
const $b695424587865b74$var$DEFAULT_SORT_ORDER = [
    'PreviewAction',
    'CopyLinkAction',
    'AISummaryAction'
];
const $b695424587865b74$var$sort = (a, b)=>{
    let idxA = $b695424587865b74$var$DEFAULT_SORT_ORDER.indexOf(a);
    let idxB = $b695424587865b74$var$DEFAULT_SORT_ORDER.indexOf(b);
    if (idxA === -1) idxA = $b695424587865b74$var$DEFAULT_SORT_ORDER.length;
    if (idxB === -1) idxB = $b695424587865b74$var$DEFAULT_SORT_ORDER.length;
    return idxA - idxB;
};
const $b695424587865b74$export$1af10e3728e3a644 = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $8dVIb.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $8dVIb.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};
const $b695424587865b74$var$ActionBlock = ({ blockRef: blockRef, onClick: onClickCallback, size: size, spaceInline: spaceInline, className: className, testId: testId = 'smart-block-action' })=>{
    (0, $gKZoD.di)((0, $s2ak7.ActionFooter));
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const ui = (0, $Nh1XU.useFlexibleUiOptionContext)();
    const [message, setMessage] = (0, $5uXOq.useState)();
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const onLoadingChange = (0, $5uXOq.useCallback)((isLoading)=>{
        setIsLoading(isLoading);
    }, [
        setIsLoading
    ]);
    const padding = !ui?.hidePadding ? $b695424587865b74$export$1af10e3728e3a644(ui?.size || (0, $8dVIb.SmartLinkSize).Medium) : undefined;
    const onClick = (0, $5uXOq.useCallback)((name)=>{
        setMessage(undefined);
        onClickCallback?.(name);
    }, [
        onClickCallback
    ]);
    const onError = (0, $5uXOq.useCallback)((error)=>{
        setMessage(error);
    }, []);
    const actions = (0, $5uXOq.useMemo)(()=>{
        if (!context?.actions) return;
        const arr = Object.keys(context.actions);
        arr.sort($b695424587865b74$var$sort);
        return arr.map((name)=>{
            const Action = name in $jRHKj ? $jRHKj[name] : undefined;
            return Action ? /*#__PURE__*/ (0, $2OMIu.jsx)(Action, {
                as: "stack-item",
                spaceInline: spaceInline,
                onClick: ()=>onClick(name),
                onError: onError,
                onLoadingChange: onLoadingChange,
                size: size,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/no-unsafe-design-token-usage
                style: padding && {
                    paddingInline: padding
                },
                hideTooltip: isLoading
            }, name) : null;
        });
    }, [
        context?.actions,
        onClick,
        onError,
        padding,
        size,
        spaceInline,
        isLoading,
        onLoadingChange
    ]);
    return actions ? /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        ref: blockRef,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_1e0c1txw _2lx21bp4 _vchhusvi _16jlkb7n _1bsb129b _18u01ivi _2hwxc10g" : "_1e0c1txw _2lx21bp4 _vchhusvi _16jlkb7n _1bsb1osq _18u01ivi _2hwxc10g",
            className
        ]),
        children: [
            actions,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $s2ak7.ActionFooter), {
                message: message,
                testId: testId
            })
        ]
    }) : null;
};
var $b695424587865b74$export$2e2bcd8739ae039 = $b695424587865b74$var$ActionBlock;

});
parcelRegister("s2ak7", function(module, exports) {

$parcel$export(module.exports, "ActionFooter", () => $e384e6334b5a98a7$export$2d2b754ac238f9aa);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $059q9 = parcelRequire("059q9");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");

var $aBTst = parcelRequire("aBTst");
const $e384e6334b5a98a7$var$containerStyles = null;
const $e384e6334b5a98a7$var$errorStyles = null;
const $e384e6334b5a98a7$var$styles = {
    containerStyles: "_kkk2n7od _2rkoglpi _1rjc12x7 _18zru2gc _19pku2gc _2hwxu2gc _otyrze3t _18u0u2gc _1bsb1osq _fiawglyw",
    errorContentStyles: "_bozgv77o",
    titleStyles: "_11c8dcr7 _syaz1gjq"
};
const $e384e6334b5a98a7$var$getIcon = (appearance)=>{
    switch(appearance){
        case 'error':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($059q9))), {
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "compact",
                label: "Error",
                LEGACY_size: "small",
                testId: "action-error-icon",
                LEGACY_margin: `0 ${"var(--ds-space-negative-025, -2px)"}`
            });
        default:
            return null;
    }
};
const $e384e6334b5a98a7$export$2d2b754ac238f9aa = ({ message: message, testId: testId })=>{
    if (!message) return null;
    if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        backgroundColor: message.appearance === 'error' ? 'color.background.danger' : undefined,
        testId: `${testId}-footer`,
        style: {
            width: `calc(100% - var(--container-padding-left) - var(--container-padding-right))`
        },
        xcss: $e384e6334b5a98a7$var$styles.containerStyles,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aBTst.default), {
            isFadeIn: true,
            show: true,
            showTransition: true,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                alignBlock: "start",
                grow: "fill",
                space: "space.075",
                xcss: $e384e6334b5a98a7$var$styles.errorContentStyles,
                children: [
                    message.icon || $e384e6334b5a98a7$var$getIcon(message.appearance),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                        xcss: $e384e6334b5a98a7$var$styles.titleStyles,
                        children: message.title
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testId": `${testId}-footer`,
        className: (0, $bwpsq.default)([
            "_kkk2n7od _2rkoglpi _1yt412x7 _18zru2gc _19pku2gc _2hwxu2gc _otyrze3t _18u0u2gc _vwz4gktf _1bsb1osq _fiawglyw",
            message.appearance === 'error' && "_bfhk1gly"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aBTst.default), {
            isFadeIn: true,
            show: true,
            showTransition: true,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                alignBlock: "start",
                grow: "fill",
                space: "space.075",
                xcss: $e384e6334b5a98a7$var$styles.errorContentStyles,
                children: [
                    message.icon || $e384e6334b5a98a7$var$getIcon(message.appearance),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                        xcss: $e384e6334b5a98a7$var$styles.titleStyles,
                        children: message.title
                    })
                ]
            })
        })
    });
};

});




parcelRegister("i41Ob", function(module, exports) {

$parcel$export(module.exports, "LoadingCardLink", () => $b4c0875f37c33ad9$export$1ca0544321134ad6);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bMldO = parcelRequire("bMldO");

const $b4c0875f37c33ad9$export$1ca0544321134ad6 = ({ isSelected: isSelected, url: url, placeholder: placeholder })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bMldO.CardLinkView), {
        testId: 'lazy-render-placeholder',
        "data-trello-do-not-use-override": "lazy-render-placeholder-trello",
        isSelected: isSelected,
        link: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $b18b5009ce608fe8$export$4b2b7d155f69aed4),
        placeholder: placeholder
    }, 'lazy-render-key');
};

});
parcelRegister("bMldO", function(module, exports) {

$parcel$export(module.exports, "CardLinkView", () => $d0b446175f31475d$export$ce508304ed2dd145);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $kkxZO = parcelRequire("kkxZO");
class $d0b446175f31475d$export$ce508304ed2dd145 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kkxZO.Frame), {
            withoutBackground: true,
            ...this.props,
            children: this.props.placeholder || this.props.link
        });
    }
}

});
parcelRegister("kkxZO", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $2ed7f4f9fecd197d$export$b89a827e9254211a);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $4URMI = parcelRequire("4URMI");

var $8RHvB = parcelRequire("8RHvB");
const $2ed7f4f9fecd197d$export$b89a827e9254211a = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { isSelected: isSelected, children: children, onClick: onClick, link: link, withoutBackground: withoutBackground, testId: testId, className: className, isHovered: isHovered, truncateInline: truncateInline } = props;
    const handleClick = (0, $5uXOq.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, $5uXOq.useCallback)((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleMouseDown = (0, $4URMI.useMouseDownEvent)();
    const isInteractive = Boolean(onClick);
    const isAnchor = Boolean(link || onClick);
    // Depending on whenever Frame was given onClick or link itself we display span or anchor elements
    const Wrapper = isAnchor ? (0, $8RHvB.WrapperAnchor) : (0, $8RHvB.WrapperSpan);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapper, {
        href: link,
        withoutBackground: withoutBackground,
        isSelected: isSelected,
        isInteractive: isInteractive,
        tabIndex: isInteractive ? 0 : undefined,
        role: isInteractive ? 'button' : undefined,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        onKeyPress: handleKeyPress,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ref: ref,
        isHovered: isHovered,
        truncateInline: truncateInline,
        children: children
    });
});

});
parcelRegister("8RHvB", function(module, exports) {

$parcel$export(module.exports, "WrapperSpan", () => $7f29852863f1f016$export$8b5c95e985c4ec9a);
$parcel$export(module.exports, "WrapperAnchor", () => $7f29852863f1f016$export$6e4bde711df5c2ab);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $7f29852863f1f016$var$lineHeight = 22;
const $7f29852863f1f016$export$8b5c95e985c4ec9a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ref: ref,
        ...props,
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_1yt4x7n9 _2rkoiti9 _v56415x0 _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28" : "_1yt4x7n9 _2rkoiti9 _v56415x0 _vwz4qslr _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28",
            truncateInline && (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            truncateInline && !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _vwz4183y _1e0c1abx _1yyjkb7n _sudp1e54 _17bix7n9 _nr8z1o8l _102kqslr",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19ith6cr _bfhkhp5a _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
            isHovered && "_1h6dmr28",
            isHovered && !withoutBackground && "_4bfu18uv _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qscw00 _uiztglyw _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _bfw7h6cr _1nrm18uv _c2waglyw _1iohnqa1" : "_uizt1kdv"
        ]),
        children: props.children
    });
});
const $7f29852863f1f016$export$6e4bde711df5c2ab = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
        href: href,
        ref: ref,
        ...props,
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_1yt4x7n9 _2rkoiti9 _v56415x0 _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28" : "_1yt4x7n9 _2rkoiti9 _v56415x0 _vwz4qslr _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28",
            truncateInline && (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            truncateInline && !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _vwz4183y _1e0c1abx _1yyjkb7n _sudp1e54 _17bix7n9 _nr8z1o8l _102kqslr",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19ith6cr _bfhkhp5a _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
            isHovered && "_1h6dmr28",
            isHovered && !withoutBackground && "_4bfu18uv _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qscw00 _uiztglyw _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _bfw7h6cr _1nrm18uv _c2waglyw _1iohnqa1" : "_uizt1kdv",
            isInteractive && "_nt751r31 _49pcglyw _1hvw1o36 _1372tlke _7ehicw00 _1j5pglyw _1di629zg"
        ]),
        children: props.children
    });
});
const $7f29852863f1f016$var$baseWrapperStylesNew = null;
const $7f29852863f1f016$var$baseWrapperStylesOld = null;
// if the parent instruct the wrapper to be interactive, and the wrapper is in focus, apply selectedStyles
const $7f29852863f1f016$var$interactiveStyles = null;
const $7f29852863f1f016$var$hoveredStyles = null;
const $7f29852863f1f016$var$hoveredWithBackgroundStyles = null;
const $7f29852863f1f016$var$withoutBackgroundStyles = null;
const $7f29852863f1f016$var$withBackgroundStyles = null;
const $7f29852863f1f016$var$truncateStylesNew = null;
const $7f29852863f1f016$var$truncateStylesOld = null;
const $7f29852863f1f016$var$notSelectedStyle = null;
const $7f29852863f1f016$var$selectedStyles = null;

});



const $b18b5009ce608fe8$export$4b2b7d155f69aed4 = 'smart-link-loading-placeholder';


parcelRegister("bybQQ", function(module, exports) {

let $868c101b2146f4f5$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $868c101b2146f4f5$var$load("ffQaD"),
    $868c101b2146f4f5$var$load("kvRbA"),
    $868c101b2146f4f5$var$load("kHlHw")
]).then(()=>parcelRequire('6Of57'));

});



parcelRegister("jNfmW", function(module, exports) {

$parcel$export(module.exports, "smartLinkFallback", () => $9ef24fe69398dbc8$export$e684dcf56ac8ae14);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $e4yMr = parcelRequire("e4yMr");
const $9ef24fe69398dbc8$export$e684dcf56ac8ae14 = (url)=>()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $e4yMr.default), {
            href: url,
            target: "_blank",
            rel: "noopener noreferrer",
            children: url
        });

});

parcelRegister("50H8f", function(module, exports) {

$parcel$export(module.exports, "useKnowledgeFilterService", () => $2d4285338743d707$export$e7f441744c2ab3f0);
$parcel$export(module.exports, "useKnowledgeFilterFormField", () => $2d4285338743d707$export$ad221c44afd5157f);

var $5uXOq = parcelRequire("5uXOq");

var $bewxV = parcelRequire("bewxV");

var $3R6Lh = parcelRequire("3R6Lh");
const $2d4285338743d707$export$cac55d864f039044 = (0, $5uXOq.createContext)(null);
const $2d4285338743d707$export$e7f441744c2ab3f0 = ()=>{
    const { siteId: siteId } = (0, $3R6Lh.useSiteContext)();
    const serviceContext = (0, $5uXOq.useContext)($2d4285338743d707$export$cac55d864f039044);
    const knowledgeFilterService = (0, $5uXOq.useMemo)(()=>{
        if (serviceContext) return serviceContext;
        return new (0, $bewxV.KnowledgeFilterServiceImpl)(siteId);
    }, [
        serviceContext,
        siteId
    ]);
    return knowledgeFilterService;
};
const $2d4285338743d707$export$ad221c44afd5157f = ()=>{
    const { getEntitiesByAris: getEntitiesByAris } = $2d4285338743d707$export$e7f441744c2ab3f0();
    const getKnowledgeSourcesFromFormFields = (0, $5uXOq.useCallback)((fields)=>{
        const sources = [];
        for(const fieldSource in fields.knowledgeEnabledFields)if (fields.knowledgeEnabledFields[fieldSource]) {
            let configuration;
            if (fieldSource === 'confluence') configuration = {
                space_filter: fields.confluenceSpaceFilters && fields.confluenceFilterScope?.value === 'spaces' ? fields.confluenceSpaceFilters.map((filter)=>filter.ari) : [],
                parent_filter: fields.confluenceAncestorPageFilters && fields.confluenceFilterScope?.value === 'pages' ? fields.confluenceAncestorPageFilters?.map((filter)=>filter.ari) : []
            };
            else if (fieldSource === 'jira') configuration = {
                project_filter: fields.jiraProjectFilters?.map((filter)=>filter.ari) ?? []
            };
            sources.push({
                enabled: true,
                source: fieldSource,
                configuration: configuration
            });
        }
        return {
            enabled: fields.knowledgeScope,
            sources: sources
        };
    }, []);
    const getKnowledgeSourceFieldsFromScaffold = (0, $5uXOq.useCallback)(async (agent)=>{
        const { knowledge_sources: knowledge_sources } = agent;
        if (!knowledge_sources?.enabled) return {
            knowledgeScope: false
        };
        let config = {
            knowledgeScope: true,
            knowledgeEnabledFields: {}
        };
        const filterPromises = [];
        for (const { source: source, configuration: knowledgeConfig, enabled: enabled } of knowledge_sources.sources)switch(source){
            case 'confluence':
                config.knowledgeEnabledFields.confluence = enabled;
                if (knowledgeConfig?.parent_filter.length) filterPromises.push(getEntitiesByAris({
                    aris: knowledgeConfig.parent_filter
                }).then((filters)=>{
                    config.confluenceAncestorPageFilters = filters.map((page)=>({
                            ari: page.ari,
                            label: page.displayName,
                            value: page.ari,
                            url: page.url
                        }));
                    config.confluenceFilterScope = {
                        label: '',
                        value: 'pages'
                    };
                }));
                if (knowledgeConfig?.space_filter.length) filterPromises.push(getEntitiesByAris({
                    aris: knowledgeConfig.space_filter
                }).then((filters)=>{
                    config.confluenceSpaceFilters = filters.map((page)=>({
                            ari: page.ari,
                            label: page.displayName,
                            value: page.ari,
                            iconUrl: page.iconUrl,
                            url: page.url
                        }));
                    config.confluenceFilterScope = {
                        label: '',
                        value: 'spaces'
                    };
                }));
                break;
            case 'jira':
                config.knowledgeEnabledFields.jira = enabled;
                if (knowledgeConfig) filterPromises.push(getEntitiesByAris({
                    aris: knowledgeConfig.project_filter
                }).then((filters)=>{
                    config.jiraProjectFilters = filters.map((page)=>({
                            ari: page.ari,
                            label: page.displayName,
                            value: page.ari,
                            iconUrl: page.iconUrl,
                            url: page.url
                        }));
                }));
                break;
            default:
                config.knowledgeEnabledFields[source] = enabled;
                break;
        }
        await Promise.all(filterPromises);
        return config;
    }, [
        getEntitiesByAris
    ]);
    return {
        getKnowledgeSourcesFromFormFields: getKnowledgeSourcesFromFormFields,
        getKnowledgeSourceFieldsFromScaffold: getKnowledgeSourceFieldsFromScaffold
    };
};

});
parcelRegister("bewxV", function(module, exports) {

$parcel$export(module.exports, "KnowledgeFilterServiceImpl", () => $bd46e17b0573787c$export$a0684b2b2bbfab69);

var $3kN8f = parcelRequire("3kN8f");

var $RMYZT = parcelRequire("RMYZT");

function $bd46e17b0573787c$var$notEmpty(value) {
    return value !== null && value !== undefined;
}
class $bd46e17b0573787c$export$a0684b2b2bbfab69 {
    constructor(siteId){
        this.siteId = siteId;
        this.entityTypeToAti = (type)=>{
            switch(type){
                case 'space':
                    return 'ati:cloud:confluence:space';
                case 'page':
                    return 'ati:cloud:confluence:page';
                case 'project':
                    return 'ati:cloud:jira:project';
            }
        };
        this.filterResults = async ({ query: query, entityType: entityType, confluenceSpaces: confluenceSpaces = [] })=>{
            const result = await (0, $RMYZT.fetchAgg)({
                graphQuery: (0, $f354927440a471b9$export$4bc63ef50ec3954e),
                siteId: this.siteId,
                variables: {
                    query: query,
                    entityAti: this.entityTypeToAti(entityType),
                    confluenceSpaces: confluenceSpaces
                }
            });
            return result.data.search.search.edges?.map((edge)=>edge.node).map((item)=>({
                    ari: item.ari,
                    displayName: item.displayName,
                    iconUrl: item.iconUrl,
                    spaceKey: item.spaceKey,
                    url: item.url
                }));
        };
        this.getEntitiesByAris = async (options)=>{
            let entities = {
                space: {
                    responseMapper: (response)=>response?.data?.confluence?.spaces?.filter($bd46e17b0573787c$var$notEmpty).map((space)=>({
                                ...space,
                                url: space.links.base + space.links.webUi,
                                iconUrl: space.iconUrl.path
                            })) ?? [],
                    aris: [],
                    graphQuery: (0, $f354927440a471b9$export$21da0c227e4ca0b8)
                },
                page: {
                    responseMapper: (response)=>response?.data?.confluence?.pages?.filter($bd46e17b0573787c$var$notEmpty).map((page)=>({
                                ...page,
                                url: page.links.base + page.links.webUi
                            })) ?? [],
                    aris: [],
                    graphQuery: (0, $f354927440a471b9$export$a970d24119afd9d2)
                },
                project: {
                    responseMapper: (response)=>response?.data?.jira?.jiraProjects?.filter($bd46e17b0573787c$var$notEmpty).map((project)=>({
                                ...project,
                                iconUrl: project.iconUrl.small
                            })) ?? [],
                    aris: [],
                    graphQuery: (0, $f354927440a471b9$export$46cf0e4af88c5342)
                }
            };
            for (const ari of options.aris)try {
                const resourceType = ari.split(/[:\/]/)[4];
                if (entities[resourceType]) entities[resourceType].aris.push(ari);
            } catch (error) {
            // Ignore invalid aris
            }
            const aggPromises = [];
            for (const { aris: aris, graphQuery: graphQuery, responseMapper: responseMapper } of Object.values(entities))if (aris.length) aggPromises.push((0, $RMYZT.fetchAgg)({
                graphQuery: graphQuery,
                variables: {
                    aris: aris
                }
            }).then((result)=>{
                return responseMapper(result).map((item)=>({
                        ari: item.ari,
                        displayName: item.displayName,
                        iconUrl: item.iconUrl,
                        spaceKey: item.spaceKey,
                        url: item.url
                    }));
            }));
            const results = await Promise.all(aggPromises).catch((error)=>{
                (0, $3kN8f.logException)({
                    exception: error,
                    name: 'KnowledgeFilterService.getEntitiesByAris'
                });
                return [];
            });
            return results.flat();
        };
    }
}

});
parcelRegister("RMYZT", function(module, exports) {

$parcel$export(module.exports, "fetchAgg", () => $ec3ff2ac22aaa523$export$f49dad89491f6bf2);

var $lyFsp = parcelRequire("lyFsp");
const $ec3ff2ac22aaa523$export$f49dad89491f6bf2 = async ({ siteId: siteId, graphQuery: graphQuery, variables: variables })=>{
    const response = await (0, $lyFsp.performGqlFetch)({
        gqlQuery: graphQuery,
        variables: {
            siteAri: siteId ? `ari:cloud:confluence::site/${siteId}` : undefined,
            ...variables
        }
    });
    return response;
};

});
parcelRegister("lyFsp", function(module, exports) {

$parcel$export(module.exports, "performGqlFetch", () => $ab52746bc71cce73$export$f602b5befecb0b84);

var $5uriq = parcelRequire("5uriq");
const $ab52746bc71cce73$var$extractQueryName = (gqlQuery)=>{
    const operationMatch = gqlQuery.match(/(?:query|mutation)\s+(\w+)/);
    return operationMatch ? operationMatch[1] : null;
};
const $ab52746bc71cce73$export$f602b5befecb0b84 = async ({ gqlQuery: gqlQuery, headerOptions: headerOptions, variables: variables })=>{
    try {
        const response = await fetch('/gateway/api/graphql', {
            headers: {
                'Content-Type': 'application/json',
                ...headerOptions
            },
            method: 'POST',
            body: JSON.stringify({
                query: gqlQuery,
                variables: variables
            })
        });
        const json = await response.json();
        if (json?.errors?.length) await $ab52746bc71cce73$var$processGqlErrorResponse({
            errors: json.errors,
            gqlQuery: gqlQuery
        });
        return json;
    } catch (err) {
        throw new (0, $5uriq.FetchError)('GraphQL query failed', {
            cause: err
        });
    }
};
class $ab52746bc71cce73$export$ba203f24e0131ba7 extends Error {
    constructor(message, { errors: errors, queryName: queryName }){
        super(message);
        this.name = 'GraphQLError';
        this.errors = errors;
        this.queryName = queryName;
    }
}
const $ab52746bc71cce73$var$processGqlErrorResponse = async ({ errors: errors, gqlQuery: gqlQuery })=>{
    const errorsToThrow = [];
    errors.forEach((error)=>{
        errorsToThrow.push({
            message: error.message,
            status_code: error.extensions.statusCode,
            classification: error.extensions.classification
        });
    });
    throw new $ab52746bc71cce73$export$ba203f24e0131ba7('GraphQL API error', {
        errors: errorsToThrow,
        queryName: $ab52746bc71cce73$var$extractQueryName(gqlQuery)
    });
};

});
parcelRegister("5uriq", function(module, exports) {

$parcel$export(module.exports, "FetchError", () => $83a711147490cc54$export$26e841bcf1aeb894);
class $83a711147490cc54$export$26e841bcf1aeb894 extends Error {
    constructor(message, cause){
        super(message), this.cause = cause;
        this.name = 'FetchError';
        if (cause) this.cause = cause;
    }
}

});



const $f354927440a471b9$export$4bc63ef50ec3954e = `
query ListSpaces($query: String!, $siteAri: String!, $entityAti: String!, $confluenceSpaces: [String!]) {
	search {
		search(
			query: $query
			filters: {
				entities: [$entityAti],
				locations: [$siteAri],
				confluenceFilters: {
					spacesFilter: $confluenceSpaces
				}
			}
			experience: "rovo-chat"
		) {
			edges {
				node {
					ari: id
					displayName: title
					iconUrl
					url
					... on SearchConfluenceSpace {
						spaceKey: key
					}
				}
			}
		}
	}
}
`;
const $f354927440a471b9$export$46cf0e4af88c5342 = `
query GetProjects($aris: [ID!]!) {
  jira {
    jiraProjects(
      ids: $aris
    ) {
      ari: id
      displayName: name
      iconUrl: avatar {
        small
      }
			url: webUrl
    }
  }
}
`;
const $f354927440a471b9$export$a970d24119afd9d2 = `
query GetPages($aris: [ID!]!) {
  confluence {
    pages(
      ids: $aris
    ) {
      ari: id
      displayName: title
			links {
        base
        webUi
      }
    }
  }
}
`;
const $f354927440a471b9$export$21da0c227e4ca0b8 = `
query GetSpaces($aris: [ID!]!) {
  confluence {
    spaces(
      ids: $aris
    ) {
      ari: id
      displayName: name
      iconUrl: icon {
        path
      }
			spaceKey: key
			links {
        base
        webUi
      }
    }
  }
}
`;


parcelRegister("3R6Lh", function(module, exports) {

$parcel$export(module.exports, "SiteContext", () => $6673bdb2d1c96344$export$2cab3982d83485b0);
$parcel$export(module.exports, "useSiteContext", () => $6673bdb2d1c96344$export$55c0e3cb4fbc46cf);

var $5uXOq = parcelRequire("5uXOq");
const $6673bdb2d1c96344$export$2cab3982d83485b0 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    siteId: ''
});
const $6673bdb2d1c96344$export$55c0e3cb4fbc46cf = ()=>{
    const context = (0, $5uXOq.useContext)($6673bdb2d1c96344$export$2cab3982d83485b0);
    return context;
};

});


parcelRegister("6lMjD", function(module, exports) {

$parcel$export(module.exports, "default", () => $103efdab9cf81168$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $103efdab9cf81168$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noKnowledgeAdded: {
        id: 'rovo-chat.view-agent.no-knowledge-added',
        defaultMessage: 'No custom knowledge sources',
        description: 'Message displayed when no knowledge is added to the Agent'
    },
    forgeKnowledgeDescription: {
        id: 'rovo-chat.view-agent.hidden-knowledge-description',
        defaultMessage: "Forge Agents built with code don't use typical knowledge sources",
        description: 'Description of the knowledge section, this is displayed when knowledge is purposely hidden'
    }
});

});


parcelRegister("dQjNg", function(module, exports) {

$parcel$export(module.exports, "getAAIDFromARI", () => $09d02c91f15af39c$export$3761e66a04602cbd);
$parcel$export(module.exports, "getARIFromAAID", () => $09d02c91f15af39c$export$acf3e1bcf222b00d);
$parcel$export(module.exports, "AgentCreatedBy", () => $09d02c91f15af39c$export$1565ea9a9fb7ad67);
$parcel$export(module.exports, "useProfileResolution", () => $09d02c91f15af39c$export$5d980898591175e);
$parcel$export(module.exports, "filterAndSortAgents", () => $09d02c91f15af39c$export$13d60404a0dddebd);
$parcel$export(module.exports, "getEnabledKnowlegeArisFromAgent", () => $09d02c91f15af39c$export$a6e36c224ec3c0cb);
$parcel$export(module.exports, "getSuggestedOotbAgents", () => $09d02c91f15af39c$export$6d876204c5d593ac);
$parcel$export(module.exports, "isDevelopmentAgent", () => $09d02c91f15af39c$export$9148c67556b3ebc6);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $gKZoD = parcelRequire("gKZoD");

var $e4yMr = parcelRequire("e4yMr");

var $2pMF0 = parcelRequire("2pMF0");

var $8dw1i = parcelRequire("8dw1i");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");

var $264zF = parcelRequire("264zF");

var $1DVhQ = parcelRequire("1DVhQ");

var $4ojTZ = parcelRequire("4ojTZ");

var $8G7CX = parcelRequire("8G7CX");

var $3xYdY = parcelRequire("3xYdY");

var $gBv35 = parcelRequire("gBv35");

var $3go6U = parcelRequire("3go6U");
const $09d02c91f15af39c$export$3761e66a04602cbd = (ari)=>{
    const matched = ari.match(/\/([a-zA-Z0-9_\|\-\:]{1,128})$/);
    return matched ? matched[1] : undefined;
};
const $09d02c91f15af39c$export$acf3e1bcf222b00d = (aaid)=>{
    return `ari:cloud:identity::user/${aaid}`;
};
const $09d02c91f15af39c$export$1565ea9a9fb7ad67 = ({ agent: agent, siteId: siteId, simplified: simplified })=>{
    if ((0, $8G7CX.isCustomerAgent)(agent)) {
        const aaid = agent.creator ? $09d02c91f15af39c$export$3761e66a04602cbd(agent.creator) : undefined;
        if (!aaid) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)($09d02c91f15af39c$var$ResolvingMention, {
            userId: aaid,
            siteId: siteId,
            profileCard: true,
            simplified: simplified
        });
    }
    if ((0, $8G7CX.isSystemAgent)(agent) || !agent.creator) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $f5TWP.default), {
        alignBlock: "center",
        testId: "atlassian-icon",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2pMF0.AtlassianIcon), {
                appearance: "brand",
                size: "small"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                children: "Atlassian"
            })
        ]
    });
    if ((0, $8G7CX.isForgeAgent)(agent)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        children: agent.creator
    });
    return null;
};
const $09d02c91f15af39c$var$ResolvingMention = ({ userId: userId, siteId: siteId, profileCard: profileCard = false, simplified: simplified = false })=>{
    (0, $gKZoD.di)($09d02c91f15af39c$export$5d980898591175e);
    const { profile: profile, client: client } = $09d02c91f15af39c$export$5d980898591175e(userId, siteId);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const fullName = profile.data?.status === 'inactive' && profile.data.fullName ? formatMessage((0, $3go6U.default).deactivatedCreatorName, {
        name: profile.data.fullName
    }) : profile.data?.fullName;
    if (profile.isFetching || !profile.data) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
        isShimmering: true,
        height: 18,
        width: 100,
        borderRadius: 3
    });
    if (simplified) return (0, $VSDnB.fg)('dst-a11y__replace-anchor-with-link__ai-mate') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e4yMr.default), {
        href: `/people/${userId}`,
        target: "_blank",
        children: fullName
    }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
        href: `/people/${userId}`,
        target: "_blank",
        children: fullName
    });
    return profileCard ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $264zF.default), {
        userId: userId,
        resourceClient: client,
        ariaLabel: fullName,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8dw1i.default), {
            id: userId,
            isHighlighted: profile.data.isCurrentUser,
            text: `@${fullName}`
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8dw1i.default), {
        id: userId,
        isHighlighted: profile.data.isCurrentUser,
        text: `@${fullName}`
    });
};
function $09d02c91f15af39c$export$5d980898591175e(userId, siteId, shouldFetch = true) {
    const profileClient = (0, $gBv35.useProfileClient)();
    const profile = (0, $4ojTZ.useQuery)({
        queryKey: [
            'fetchProfile',
            siteId,
            userId
        ],
        queryFn: async ()=>{
            try {
                const response = await profileClient.getProfile(siteId, userId);
                return response;
            } catch (error) {
                return {};
            }
        },
        enabled: shouldFetch
    });
    return {
        profile: profile,
        client: profileClient
    };
}
const $09d02c91f15af39c$export$13d60404a0dddebd = (agents, filters)=>{
    return agents.filter((agent)=>agent.name.toLocaleLowerCase().includes(filters.searchValue.toLocaleLowerCase()) || agent.description?.toLocaleLowerCase().includes(filters.searchValue.toLocaleLowerCase())).sort((a, b)=>a.name.localeCompare(b.name));
};
const $09d02c91f15af39c$export$a6e36c224ec3c0cb = (agent)=>{
    if (!agent.knowledge_sources?.enabled) return [];
    return agent.knowledge_sources.sources.filter((source)=>source.enabled).reduce((acc, source)=>{
        switch(source.source){
            case 'confluence':
                acc.push(...source.configuration?.parent_filter ?? []);
                acc.push(...source.configuration?.space_filter ?? []);
                break;
            case 'jira':
                acc.push(...source.configuration?.project_filter ?? []);
                break;
        }
        return acc;
    }, []);
};
const $09d02c91f15af39c$export$6d876204c5d593ac = ({ availableAgents: availableAgents, product: product })=>{
    // If no product is provided / product is not supported, fallback to using default agents
    const defaultAgentsNamedIds = product ? (0, $3xYdY.DEFAULT_OOTB_AGENTS_NAMED_IDS)[product] ?? (0, $3xYdY.DEFAULT_AGENTS_NAMED_ID_LIST) : (0, $3xYdY.DEFAULT_AGENTS_NAMED_ID_LIST);
    const defaultAgents = availableAgents.filter((agent)=>defaultAgentsNamedIds.has(agent.named_id) || agent.external_config_reference && defaultAgentsNamedIds.has(agent.external_config_reference));
    return defaultAgents;
};
const $09d02c91f15af39c$export$9148c67556b3ebc6 = (agent)=>{
    return (agent.action_config ?? []).some((config)=>config.id === 'agent_action_jira_issue_trigger_autodev');
};

});
parcelRegister("8dw1i", function(module, exports) {

$parcel$export(module.exports, "UNKNOWN_USER_ID", () => $359ac0149aaccbc2$export$af8124aa496797f2);
$parcel$export(module.exports, "default", () => $359ac0149aaccbc2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jhVLw = parcelRequire("jhVLw");

var $kbF2s = parcelRequire("kbF2s");

var $ab8uA = parcelRequire("ab8uA");

var $k3AGD = parcelRequire("k3AGD");

var $cqJWb = parcelRequire("cqJWb");

var $4kfbr = parcelRequire("4kfbr");

var $cb25w = parcelRequire("cb25w");

var $jZA09 = parcelRequire("jZA09");

var $j6B3T = parcelRequire("j6B3T");

var $bTspB = parcelRequire("bTspB");
const $359ac0149aaccbc2$export$7452d7062a4d0634 = 1000;
const $359ac0149aaccbc2$export$af8124aa496797f2 = '_|unknown|_';
class $359ac0149aaccbc2$export$92ab8442e7a15cef extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    constructor(props){
        super(props), this.handleOnClick = (e)=>{
            const { id: id, text: text, onClick: onClick } = this.props;
            if (onClick) onClick(id, text, e);
        }, this.handleOnMouseEnter = (e)=>{
            const { id: id, text: text, onMouseEnter: onMouseEnter, onHover: onHover } = this.props;
            if (onMouseEnter) onMouseEnter(id, text, e);
            this.hoverTimeout = window.setTimeout(()=>{
                if (onHover) onHover();
                this.hoverTimeout = undefined;
            }, $359ac0149aaccbc2$export$7452d7062a4d0634);
        }, this.handleOnMouseLeave = (e)=>{
            const { id: id, text: text, onMouseLeave: onMouseLeave } = this.props;
            if (onMouseLeave) onMouseLeave(id, text, e);
            if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        }, this.getMentionType = ()=>{
            const { accessLevel: accessLevel, isHighlighted: isHighlighted } = this.props;
            if (isHighlighted) return (0, $cqJWb.MentionType).SELF;
            if ((0, $cqJWb.isRestricted)(accessLevel)) return (0, $cqJWb.MentionType).RESTRICTED;
            return (0, $cqJWb.MentionType).DEFAULT;
        };
        (0, $bTspB.mentionRenderedUfoExperience).getInstance(props.id).start();
    }
    componentDidMount() {
        (0, $bTspB.mentionRenderedUfoExperience).getInstance(this.props.id).success();
    }
    componentWillUnmount() {
        if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        const ufoInstance = (0, $bTspB.mentionRenderedUfoExperience).getInstance(this.props.id);
        if ([
            (0, $jZA09.UFOExperienceState)['STARTED'],
            (0, $jZA09.UFOExperienceState)['IN_PROGRESS']
        ].includes(ufoInstance.state)) ufoInstance.abort();
    }
    renderUnknownUserError(id) {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j6B3T.UnknownUserError), {
            values: {
                userId: id.slice(-5)
            },
            children: (message)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                    children: `@${message}`
                })
        });
    }
    render() {
        const { handleOnClick: handleOnClick, handleOnMouseEnter: handleOnMouseEnter, handleOnMouseLeave: handleOnMouseLeave, props: props } = this;
        const { text: text, id: id, accessLevel: accessLevel, localId: localId } = props;
        const mentionType = this.getMentionType();
        const failedMention = text === `@${$359ac0149aaccbc2$export$af8124aa496797f2}`;
        const showTooltip = mentionType === (0, $cqJWb.MentionType).RESTRICTED;
        const mentionComponent = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jhVLw.default), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ab8uA.default), {
                mentionType: mentionType,
                onClick: handleOnClick,
                onMouseEnter: handleOnMouseEnter,
                onMouseLeave: handleOnMouseLeave,
                spellCheck: false,
                "data-testid": `mention-${id}`,
                "data-mention-type": mentionType,
                "data-mention-tooltip": showTooltip,
                children: failedMention ? this.renderUnknownUserError(id) : text || '@...'
            })
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bTspB.UfoErrorBoundary), {
            id: id,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                id: localId,
                "data-mention-id": id,
                "data-local-id": localId,
                "data-access-level": accessLevel,
                spellCheck: false,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kbF2s.default), {
                    children: showTooltip ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Suspense, {
                        fallback: mentionComponent,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k3AGD.default), {
                            name: text,
                            children: mentionComponent
                        })
                    }) : mentionComponent
                })
            })
        });
    }
}
const $359ac0149aaccbc2$var$MentionWithAnalytics = (0, $cb25w.default)({
    onClick: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $4kfbr.fireAnalyticsMentionEvent)(createEvent)('mention', 'selected', text, id, accessLevel);
        return event;
    },
    onHover: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $4kfbr.fireAnalyticsMentionEvent)(createEvent)('mention', 'hovered', text, id, accessLevel);
        return event;
    }
})($359ac0149aaccbc2$export$92ab8442e7a15cef);
const $359ac0149aaccbc2$var$Mention = $359ac0149aaccbc2$var$MentionWithAnalytics;
var $359ac0149aaccbc2$export$2e2bcd8739ae039 = $359ac0149aaccbc2$var$Mention;

});
parcelRegister("kbF2s", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2323b0dd270b712$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
var $koVbs = parcelRequire("koVbs");

var $j6B3T = parcelRequire("j6B3T");
const $a2323b0dd270b712$var$EMPTY = {};
const $a2323b0dd270b712$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState($a2323b0dd270b712$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        let aborted = false;
        setMessages($a2323b0dd270b712$var$EMPTY);
        (0, $j6B3T.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $a2323b0dd270b712$var$MessagesIntlProvider = (props)=>{
    const { children: children } = props;
    const intl = (0, $koVbs.default)();
    const messages = $a2323b0dd270b712$var$useI18n(intl.locale);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        ...intl,
        messages: messages,
        children: children
    });
};
var $a2323b0dd270b712$export$2e2bcd8739ae039 = $a2323b0dd270b712$var$MessagesIntlProvider;

});
parcelRegister("j6B3T", function(module, exports) {

$parcel$export(module.exports, "UnknownUserError", () => $2ed9ffbf75c73a6c$export$98e06fe7a6174253);
$parcel$export(module.exports, "NoAccessWarning", () => $2ed9ffbf75c73a6c$export$58bd5a2057b6b855);
$parcel$export(module.exports, "NoAccessLabel", () => $2ed9ffbf75c73a6c$export$da9f8ce14593162f);
$parcel$export(module.exports, "getMessagesForLocale", () => $2ed9ffbf75c73a6c$export$d0a3169680473b6c);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $8aQI9 = parcelRequire("8aQI9");
const $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50 = (messageDescriptor)=>({ values: values, children: children })=>{
        const { formatMessage: formatMessage } = (0, $koVbs.default)();
        const message = formatMessage(messageDescriptor, values);
        if (typeof children === 'function') return children(message);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            values: values,
            ...messageDescriptor
        });
    };
const $2ed9ffbf75c73a6c$export$98e06fe7a6174253 = $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50((0, $8aQI9.messages).unknownUserError);
const $2ed9ffbf75c73a6c$export$58bd5a2057b6b855 = $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50((0, $8aQI9.messages).noAccessWarning);
const $2ed9ffbf75c73a6c$export$da9f8ce14593162f = $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50((0, $8aQI9.messages).noAccessLabel);
const $2ed9ffbf75c73a6c$export$4a258ffee7316766 = $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50((0, $8aQI9.messages).defaultHeadline);
const $2ed9ffbf75c73a6c$export$702321a50d74536e = $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50((0, $8aQI9.messages).defaultAdvisedAction);
const $2ed9ffbf75c73a6c$export$ed7f16088a93ae9d = $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50((0, $8aQI9.messages).loginAgain);
const $2ed9ffbf75c73a6c$export$3ab158df56460d1c = $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50((0, $8aQI9.messages).differentText);































const $2ed9ffbf75c73a6c$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("4V1xc")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("hgzxK")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("c1kQi")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("bPWQs")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("ig1sb")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("kvqTP")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("hEjYH")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("2jEOd")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("dNrUU")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("iV0bH")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("grzSg")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("2RhXX")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("706hg")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("eS2Re")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("g7PnV")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("7M1Du")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("kUskF")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("c0nBE")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("hsepf")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("a5G5g")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("8dn2d")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("8Mzy1")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("hs76U")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("dAfpp")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("hyYxe")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("1RuVn")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("fQfFR")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("gCDPw")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("1PTmN")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("mDaRG")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $2ed9ffbf75c73a6c$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("bPWQs")).then((mod)=>mod.default);
            }
    }
};

});
parcelRegister("8aQI9", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6ca607c1e1522de5$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $6ca607c1e1522de5$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    unknownUserError: {
        id: 'fabric.mention.unknow.user.error',
        defaultMessage: 'Unknown user {userId}',
        description: 'Mention user name could not be found or look up failed'
    },
    noAccessWarning: {
        id: 'fabric.mention.noAccess.warning',
        defaultMessage: "{name} won't be notified as they have no access",
        description: "Warning message to show that the mentioned user won't be notified"
    },
    noAccessLabel: {
        id: 'fabric.mention.noAccess.label',
        defaultMessage: 'No access',
        description: 'Label for no access icon'
    },
    defaultHeadline: {
        id: 'fabric.mention.error.defaultHeadline',
        defaultMessage: 'Something went wrong',
        description: 'Error message shown when there is an error communicating with backend'
    },
    defaultAdvisedAction: {
        id: 'fabric.mention.error.defaultAction',
        defaultMessage: 'Try again in a few seconds',
        description: 'Default advised action when an error occurs'
    },
    loginAgain: {
        id: 'fabric.mention.error.loginAgain',
        defaultMessage: 'Try logging out then in again',
        description: 'Login again message when there is an authentication error occurs'
    },
    differentText: {
        id: 'fabric.mention.error.differentText',
        defaultMessage: 'Try entering different text',
        description: 'Enter different text message when a forbidden error occurs'
    },
    memberCountWithoutYou: {
        id: 'fabric.elements.mentions.team.member.count',
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}",
        description: 'Byline to show the number of members in the team when the current user is not a member of the team'
    },
    memberCountWithYou: {
        id: 'fabric.elements.mentions.team.member.count.including.you',
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}, including you",
        description: 'Byline to show the number of members in the team when the current user is also a member of the team'
    },
    plus50MembersWithoutYou: {
        id: 'fabric.elements.mentions.team.member.50plus',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the number of members in the team when the number exceeds 50'
    },
    plus50MembersWithYou: {
        id: 'fabric.elements.mentions.team.member.50plus.including.you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the number of members in the team when the number exceeds 50 and also includes the current user'
    },
    xProductMentionDescription: {
        id: 'fabric.elements.mentions.xproduct.mention.description',
        defaultMessage: 'Needs access to Confluence',
        description: 'Description for a x-product mention item in the mention list in Confluence'
    }
});

});

parcelRegister("4V1xc", function(module, exports) {

let $394dad040c1eb1c1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $394dad040c1eb1c1$var$load("bbFL6").then(()=>parcelRequire('dTLgY'));

});

parcelRegister("hgzxK", function(module, exports) {

let $c91f807584d05c0f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c91f807584d05c0f$var$load("g9fvd").then(()=>parcelRequire('keyh3'));

});

parcelRegister("c1kQi", function(module, exports) {

let $8c05bee5ad23ee63$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8c05bee5ad23ee63$var$load("eF7iV").then(()=>parcelRequire('eL3iu'));

});

parcelRegister("bPWQs", function(module, exports) {

let $89e21a84a5aa2f76$var$load = (parcelRequire("28QjX"))(4);
module.exports = $89e21a84a5aa2f76$var$load("9rDcB").then(()=>parcelRequire('wBhQ2'));

});

parcelRegister("ig1sb", function(module, exports) {

let $d4aad941fb199c5f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d4aad941fb199c5f$var$load("dWi3B").then(()=>parcelRequire('27EyS'));

});

parcelRegister("kvqTP", function(module, exports) {

let $eedb919675cea1d5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eedb919675cea1d5$var$load("jRR8D").then(()=>parcelRequire('eoxiv'));

});

parcelRegister("hEjYH", function(module, exports) {

let $cd95ab546e306c68$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cd95ab546e306c68$var$load("cwacs").then(()=>parcelRequire('6jEIT'));

});

parcelRegister("2jEOd", function(module, exports) {

let $1afd02e97dd0c212$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1afd02e97dd0c212$var$load("6mtZ9").then(()=>parcelRequire('dkMw7'));

});

parcelRegister("dNrUU", function(module, exports) {

let $a0b581aa9aa3c40d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a0b581aa9aa3c40d$var$load("9fGXE").then(()=>parcelRequire('5NjhV'));

});

parcelRegister("iV0bH", function(module, exports) {

let $dc5db227d98e4de5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $dc5db227d98e4de5$var$load("jlGtV").then(()=>parcelRequire('bWMX4'));

});

parcelRegister("grzSg", function(module, exports) {

let $bf8afed4c8dd492b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bf8afed4c8dd492b$var$load("9JumJ").then(()=>parcelRequire('aPy43'));

});

parcelRegister("2RhXX", function(module, exports) {

let $214e77b6a5b3de74$var$load = (parcelRequire("28QjX"))(4);
module.exports = $214e77b6a5b3de74$var$load("8BPCy").then(()=>parcelRequire('6FrOe'));

});

parcelRegister("706hg", function(module, exports) {

let $518d6714216a7d04$var$load = (parcelRequire("28QjX"))(4);
module.exports = $518d6714216a7d04$var$load("g4gxV").then(()=>parcelRequire('epfvh'));

});

parcelRegister("eS2Re", function(module, exports) {

let $ad38534a488cb700$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ad38534a488cb700$var$load("cCq5p").then(()=>parcelRequire('hjvLU'));

});

parcelRegister("g7PnV", function(module, exports) {

let $bbd528c223096720$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bbd528c223096720$var$load("149UD").then(()=>parcelRequire('dclct'));

});

parcelRegister("7M1Du", function(module, exports) {

let $5a8e48fa67a2d516$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5a8e48fa67a2d516$var$load("97yQo").then(()=>parcelRequire('56DDk'));

});

parcelRegister("kUskF", function(module, exports) {

let $f38f03cd2a5ae4ff$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f38f03cd2a5ae4ff$var$load("8yIVQ").then(()=>parcelRequire('1Vmnr'));

});

parcelRegister("c0nBE", function(module, exports) {

let $8bd7cbd37f431014$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8bd7cbd37f431014$var$load("3GLHY").then(()=>parcelRequire('lTYFq'));

});

parcelRegister("hsepf", function(module, exports) {

let $cb5039f6d152e8be$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cb5039f6d152e8be$var$load("6tI9Q").then(()=>parcelRequire('hxNc0'));

});

parcelRegister("a5G5g", function(module, exports) {

let $758b04047d6c3b44$var$load = (parcelRequire("28QjX"))(4);
module.exports = $758b04047d6c3b44$var$load("2wKLW").then(()=>parcelRequire('h7PMN'));

});

parcelRegister("8dn2d", function(module, exports) {

let $5fb167d8555dca1a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5fb167d8555dca1a$var$load("4kFs8").then(()=>parcelRequire('3T3Pt'));

});

parcelRegister("8Mzy1", function(module, exports) {

let $664e6172d1b31024$var$load = (parcelRequire("28QjX"))(4);
module.exports = $664e6172d1b31024$var$load("935xC").then(()=>parcelRequire('jvE81'));

});

parcelRegister("hs76U", function(module, exports) {

let $cb4a912ea02b2eed$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cb4a912ea02b2eed$var$load("5oYFJ").then(()=>parcelRequire('lxjSE'));

});

parcelRegister("dAfpp", function(module, exports) {

let $9e3a9700e92f7c50$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9e3a9700e92f7c50$var$load("bnI4A").then(()=>parcelRequire('fIX00'));

});

parcelRegister("hyYxe", function(module, exports) {

let $cc9491a6d4abd2ec$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cc9491a6d4abd2ec$var$load("50Vsu").then(()=>parcelRequire('kbvg1'));

});

parcelRegister("1RuVn", function(module, exports) {

let $15b2ba9e30c84a21$var$load = (parcelRequire("28QjX"))(4);
module.exports = $15b2ba9e30c84a21$var$load("1r9nh").then(()=>parcelRequire('2eUU2'));

});

parcelRegister("fQfFR", function(module, exports) {

let $b887deeda2e0304e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b887deeda2e0304e$var$load("giDR8").then(()=>parcelRequire('kxF7S'));

});

parcelRegister("gCDPw", function(module, exports) {

let $c19f1759b9405842$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c19f1759b9405842$var$load("e1hNV").then(()=>parcelRequire('aIfZT'));

});

parcelRegister("1PTmN", function(module, exports) {

let $1565808cf8641f34$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1565808cf8641f34$var$load("9VvAX").then(()=>parcelRequire('lVs4z'));

});

parcelRegister("mDaRG", function(module, exports) {

let $0440716063878cbb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0440716063878cbb$var$load("1YQ60").then(()=>parcelRequire('bY3rp'));

});



parcelRegister("ab8uA", function(module, exports) {

$parcel$export(module.exports, "default", () => $6273a4608d138fff$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/no-html-button */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");


var $cqJWb = parcelRequire("cqJWb");

var $5uXOq = parcelRequire("5uXOq");
const $6273a4608d138fff$var$mentionStyle = {
    [(0, $cqJWb.MentionType).SELF]: {
        background: `var(--ds-background-brand-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        borderColor: 'transparent',
        text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        hoveredBackground: `var(--ds-background-brand-bold-hovered, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        pressedBackground: `var(--ds-background-brand-bold-pressed, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
    },
    [(0, $cqJWb.MentionType).RESTRICTED]: {
        background: 'transparent',
        borderColor: `var(--ds-border-bold, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
        text: `var(--ds-text, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
        hoveredBackground: 'transparent',
        pressedBackground: 'transparent'
    },
    [(0, $cqJWb.MentionType).DEFAULT]: {
        background: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
        borderColor: 'transparent',
        text: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
        hoveredBackground: `var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
        pressedBackground: `var(--ds-background-neutral-pressed, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`
    }
};
const $6273a4608d138fff$var$getStyle = ({ mentionType: mentionType }, property)=>{
    const obj = $6273a4608d138fff$var$mentionStyle[mentionType][property];
    return typeof obj === 'string' ? obj : obj;
};
const $6273a4608d138fff$var$PrimitiveMention = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ mentionType: mentionType, ...other }, ref)=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $f8Sb3.css)("display:inline;border:1px solid ", $6273a4608d138fff$var$getStyle({
            mentionType: mentionType
        }, 'borderColor'), ";background:", $6273a4608d138fff$var$getStyle({
            mentionType: mentionType
        }, 'background'), ";color:", $6273a4608d138fff$var$getStyle({
            mentionType: mentionType
        }, 'text'), ";border-radius:20px;cursor:pointer;padding:0 0.3em 2px 0.23em;line-height:1.714;font-size:1em;font-weight:var(--ds-font-weight-regular, 400);word-break:break-word;&:hover{background:", $6273a4608d138fff$var$getStyle({
            mentionType: mentionType
        }, 'hoveredBackground'), ";}&:active{background:", $6273a4608d138fff$var$getStyle({
            mentionType: mentionType
        }, 'pressedBackground'), ";}"),
        ...other
    });
});
var $6273a4608d138fff$export$2e2bcd8739ae039 = $6273a4608d138fff$var$PrimitiveMention;

});
parcelRegister("cqJWb", function(module, exports) {

$parcel$export(module.exports, "MentionType", () => $90ca79fb430b6e09$export$2102863a3c660c6b);
$parcel$export(module.exports, "UserAccessLevel", () => $90ca79fb430b6e09$export$81124e6148ca5db0);
$parcel$export(module.exports, "UserType", () => $90ca79fb430b6e09$export$8436e53e45ffe15b);
$parcel$export(module.exports, "SliNames", () => $90ca79fb430b6e09$export$7afb0727c7d7e8af);
$parcel$export(module.exports, "ComponentNames", () => $90ca79fb430b6e09$export$5c42d9dea6d035c1);
$parcel$export(module.exports, "Actions", () => $90ca79fb430b6e09$export$b52183d5cfb26dc9);
$parcel$export(module.exports, "MentionNameStatus", () => $90ca79fb430b6e09$export$b8fa67dc54502853);
$parcel$export(module.exports, "isRestricted", () => $90ca79fb430b6e09$export$dbaa15dc1820b89a);
$parcel$export(module.exports, "isSpecialMention", () => $90ca79fb430b6e09$export$37b8dcac6198c514);
$parcel$export(module.exports, "isAppMention", () => $90ca79fb430b6e09$export$eb590c844d13454c);
$parcel$export(module.exports, "isTeamMention", () => $90ca79fb430b6e09$export$803b1379348dbfd5);
$parcel$export(module.exports, "isSpecialMentionText", () => $90ca79fb430b6e09$export$d13d4f976b36a397);
$parcel$export(module.exports, "isPromise", () => $90ca79fb430b6e09$export$4369c812aac99591);
var $90ca79fb430b6e09$export$2102863a3c660c6b = /*#__PURE__*/ function(MentionType) {
    MentionType[MentionType["SELF"] = 0] = "SELF";
    MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
    MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
    return MentionType;
}({});
var $90ca79fb430b6e09$export$81124e6148ca5db0 = /*#__PURE__*/ function(UserAccessLevel) {
    UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
    UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
    UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
    UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
    return UserAccessLevel;
}({});
var $90ca79fb430b6e09$export$8436e53e45ffe15b = /*#__PURE__*/ function(UserType) {
    UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
    UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
    UserType[UserType["APP"] = 2] = "APP";
    UserType[UserType["TEAM"] = 3] = "TEAM";
    UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
    return UserType;
}({});
var $90ca79fb430b6e09$export$7afb0727c7d7e8af = /*#__PURE__*/ function(SliNames) {
    SliNames["SEARCH"] = "searchUser";
    SliNames["SEARCH_TEAM"] = "searchTeam";
    SliNames["INITIAL_STATE"] = "initialState";
    SliNames["SELECT"] = "select";
    SliNames["SELECT_TEAM"] = "selectTeam";
    return SliNames;
}({});
var $90ca79fb430b6e09$export$5c42d9dea6d035c1 = /*#__PURE__*/ function(ComponentNames) {
    ComponentNames["TYPEAHEAD"] = "mentionTypeahead";
    ComponentNames["MENTION"] = "mention";
    return ComponentNames;
}({});
var $90ca79fb430b6e09$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["VIEWED"] = "viewed";
    Actions["CLICKED"] = "clicked";
    Actions["CLOSED"] = "closed";
    Actions["SUCCEEDED"] = "succeeded";
    Actions["FAILED"] = "failed";
    return Actions;
}({});
var $90ca79fb430b6e09$export$b8fa67dc54502853 = /*#__PURE__*/ function(MentionNameStatus) {
    MentionNameStatus[MentionNameStatus["UNKNOWN"] = 0] = "UNKNOWN";
    MentionNameStatus[MentionNameStatus["SERVICE_ERROR"] = 1] = "SERVICE_ERROR";
    MentionNameStatus[MentionNameStatus["OK"] = 2] = "OK";
    return MentionNameStatus;
}({});
function $90ca79fb430b6e09$export$dbaa15dc1820b89a(accessLevel) {
    return !!accessLevel && accessLevel === $90ca79fb430b6e09$export$81124e6148ca5db0[0];
}
function $90ca79fb430b6e09$export$37b8dcac6198c514(mention) {
    return !!mention.userType && mention.userType === $90ca79fb430b6e09$export$8436e53e45ffe15b[1];
}
function $90ca79fb430b6e09$export$eb590c844d13454c(mention) {
    return mention.userType && mention.userType === $90ca79fb430b6e09$export$8436e53e45ffe15b[2];
}
function $90ca79fb430b6e09$export$803b1379348dbfd5(mention) {
    return mention.userType && mention.userType === $90ca79fb430b6e09$export$8436e53e45ffe15b[3];
}
function $90ca79fb430b6e09$export$d13d4f976b36a397(mentionText) {
    return mentionText && (mentionText === '@all' || mentionText === '@here');
}
const $90ca79fb430b6e09$export$4369c812aac99591 = (p)=>!!(p && p.then);

});


parcelRegister("k3AGD", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4938be5a70d0163$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $e4938be5a70d0163$var$AsyncNoAccessTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("4DY8U")).then((module)=>{
        return {
            default: module.NoAccessTooltip
        };
    }));
var $e4938be5a70d0163$export$2e2bcd8739ae039 = $e4938be5a70d0163$var$AsyncNoAccessTooltip;

});
parcelRegister("4DY8U", function(module, exports) {

let $3619750138ea79f8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3619750138ea79f8$var$load("eJmNM").then(()=>parcelRequire('4YERU'));

});


parcelRegister("4kfbr", function(module, exports) {

$parcel$export(module.exports, "SLI_EVENT_TYPE", () => $f8976e2813fe24b2$export$245097525aef1262);
$parcel$export(module.exports, "SMART_EVENT_TYPE", () => $f8976e2813fe24b2$export$c724588856bbfbcf);
$parcel$export(module.exports, "fireAnalyticsMentionEvent", () => $f8976e2813fe24b2$export$44902bc7b3f0b09f);
$parcel$export(module.exports, "fireAnalyticsMentionHydrationEvent", () => $f8976e2813fe24b2$export$91b2fa6a0fe06408);



var $cqJWb = parcelRequire("cqJWb");
const $f8976e2813fe24b2$var$packageName = "platform-pkg";
const $f8976e2813fe24b2$var$packageVersion = "0.0.0-use.local";
const $f8976e2813fe24b2$export$245097525aef1262 = 'sli';
const $f8976e2813fe24b2$export$c724588856bbfbcf = 'smart';
const $f8976e2813fe24b2$export$a823474ae5cb9e9c = (props)=>(action, duration, userIds = [], query)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $cqJWb.ComponentNames).TYPEAHEAD,
                attributes: {
                    packageName: $f8976e2813fe24b2$var$packageName,
                    packageVersion: $f8976e2813fe24b2$var$packageVersion,
                    componentName: (0, $cqJWb.ComponentNames).MENTION,
                    duration: Math.round(duration),
                    userIds: userIds,
                    queryLength: query ? query.length : 0
                },
                eventType: (0, $676c5e519aa5ba55$export$12346a674644c156)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $094ce2d9636497d7$export$d821aa4c8afb384e));
        }
    };
const $f8976e2813fe24b2$export$44902bc7b3f0b09f = (createEvent)=>(actionSubject, action, text, id, accessLevel)=>{
        const payload = {
            action: action,
            actionSubject: actionSubject,
            eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
            attributes: {
                packageName: $f8976e2813fe24b2$var$packageName,
                packageVersion: $f8976e2813fe24b2$var$packageVersion,
                componentName: (0, $cqJWb.ComponentNames).MENTION,
                accessLevel: accessLevel,
                isSpecial: (0, $cqJWb.isSpecialMentionText)(text),
                userId: id
            }
        };
        const event = createEvent(payload);
        event.fire((0, $094ce2d9636497d7$export$d821aa4c8afb384e));
        return event;
    };
const $f8976e2813fe24b2$export$c8b245b690e10169 = (props)=>(actionSubject, action)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = $f8976e2813fe24b2$export$c357a2872628de7c(actionSubject, action);
            props.createAnalyticsEvent(eventPayload).fire((0, $094ce2d9636497d7$export$d821aa4c8afb384e));
        }
    };
const $f8976e2813fe24b2$export$c357a2872628de7c = (actionSubject, action, attributes)=>{
    const eventPayload = {
        action: action,
        actionSubject: actionSubject,
        eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
        attributes: {
            packageName: $f8976e2813fe24b2$var$packageName,
            packageVersion: $f8976e2813fe24b2$var$packageVersion,
            componentName: (0, $cqJWb.ComponentNames).MENTION,
            ...attributes
        }
    };
    return eventPayload;
};
const $f8976e2813fe24b2$export$91b2fa6a0fe06408 = (props)=>(action, userId, fromCache, duration)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $cqJWb.ComponentNames).MENTION,
                actionSubjectId: 'hydration',
                attributes: {
                    packageName: $f8976e2813fe24b2$var$packageName,
                    packageVersion: $f8976e2813fe24b2$var$packageVersion,
                    componentName: (0, $cqJWb.ComponentNames).MENTION,
                    userId: userId,
                    fromCache: fromCache,
                    duration: Math.round(duration)
                },
                eventType: (0, $676c5e519aa5ba55$export$12346a674644c156)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $094ce2d9636497d7$export$d821aa4c8afb384e));
        }
    };
// OLD Analytics
const $f8976e2813fe24b2$var$MENTION_ANALYTICS_PREFIX = 'atlassian.fabric.mention';
const $f8976e2813fe24b2$export$34ac71ce24cddec2 = (firePrivateAnalyticsEvent)=>(eventName, text, accessLevel)=>{
        if (firePrivateAnalyticsEvent) firePrivateAnalyticsEvent(`${$f8976e2813fe24b2$var$MENTION_ANALYTICS_PREFIX}.${eventName}`, {
            accessLevel: accessLevel,
            isSpecial: (0, $cqJWb.isSpecialMentionText)(text)
        });
    };

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $676c5e519aa5ba55$export$a1562d08625f5d7e = 'ui';
const $676c5e519aa5ba55$export$947dac6c72b26f81 = 'track';
const $676c5e519aa5ba55$export$f1d537d508d2945a = 'screen';
const $676c5e519aa5ba55$export$12346a674644c156 = 'operational';
const $676c5e519aa5ba55$export$b055de0e665cb20c = 'unknown';

const $094ce2d9636497d7$export$d821aa4c8afb384e = 'fabric-elements';


parcelRegister("bTspB", function(module, exports) {

$parcel$export(module.exports, "mentionRenderedUfoExperience", () => $fb9391c5736559e1$export$1d011e4240507c78);
$parcel$export(module.exports, "UfoErrorBoundary", () => $fb9391c5736559e1$export$5ef1c2550074a375);

var $5uXOq = parcelRequire("5uXOq");

var $cBycP = parcelRequire("cBycP");
var $7Zbvr = parcelRequire("7Zbvr");
const $fb9391c5736559e1$export$1d011e4240507c78 = new (0, $cBycP.ConcurrentExperience)('mention-rendered', {
    platform: {
        component: 'mention'
    },
    type: (0, $7Zbvr.ExperienceTypes).Load,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).PageSegmentLoad
});
class $fb9391c5736559e1$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidCatch() {
        $fb9391c5736559e1$export$1d011e4240507c78.getInstance(this.props.id).failure();
    }
    render() {
        return this.props.children;
    }
}

});


parcelRegister("264zF", function(module, exports) {

$parcel$export(module.exports, "default", () => $74b3c02273951832$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $adIkV = parcelRequire("adIkV");
var $gH4E9 = parcelRequire("gH4E9");

var $VSDnB = parcelRequire("VSDnB");

var $1I7E8 = parcelRequire("1I7E8");

var $k5uoT = parcelRequire("k5uoT");

var $4sfdL = parcelRequire("4sfdL");

var $chprS = parcelRequire("chprS");

var $8ycEU = parcelRequire("8ycEU");

var $ivXTE = parcelRequire("ivXTE");


var $kDbj5 = parcelRequire("kDbj5");

var $dYuIx = parcelRequire("dYuIx");

var $ifxzB = parcelRequire("ifxzB");
function $74b3c02273951832$var$ProfileCardContent({ profilecardProps: profilecardProps, userId: userId, cloudId: cloudId, resourceClient: resourceClient, viewingUserId: viewingUserId, trigger: trigger, product: product, isAgent: isAgent, profileCardAction: profileCardAction, hasError: hasError, errorType: errorType, agentActions: agentActions, addFlag: addFlag }) {
    if (isAgent) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kDbj5.AgentProfileCardResourced), {
        accountId: userId,
        cloudId: cloudId,
        resourceClient: resourceClient,
        viewingUserId: viewingUserId,
        trigger: trigger,
        product: product,
        onChatClick: agentActions?.onChatClick,
        onConversationStartersClick: agentActions?.onConversationStartersClick,
        addFlag: addFlag
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dYuIx.ProfileCardLazy), {
            ...profilecardProps,
            actions: profileCardAction,
            hasError: hasError,
            errorType: errorType,
            withoutElevation: true
        })
    });
}
function $74b3c02273951832$export$2e2bcd8739ae039({ autoFocus: autoFocus, trigger: trigger = 'hover', userId: userId, cloudId: cloudId, resourceClient: resourceClient, actions: actions = [], position: position = 'bottom-start', children: children, testId: testId, addFlag: addFlag, onReportingLinesClick: onReportingLinesClick, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, prepopulatedData: prepopulatedData, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, viewingUserId: viewingUserId, product: product, agentActions: agentActions, ariaHideProfileTrigger: ariaHideProfileTrigger = false, isVisible: propsIsVisible }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isMounted = (0, $5uXOq.useRef)(false);
    const showDelay = trigger === 'click' || propsIsVisible && (0, $VSDnB.fg)('fix_profilecard_trigger_isvisible') ? 0 : (0, $e41878b3b8cab0db$export$5b956b542f1bc1b3);
    const hideDelay = trigger === 'click' || propsIsVisible && (0, $VSDnB.fg)('fix_profilecard_trigger_isvisible') ? 0 : (0, $e41878b3b8cab0db$export$89a9f35a94d7f196);
    const showTimer = (0, $5uXOq.useRef)(0);
    const hideTimer = (0, $5uXOq.useRef)(0);
    const [visible, setVisible] = (0, $5uXOq.useState)(false);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(undefined);
    const [hasError, setHasError] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [data, setData] = (0, $5uXOq.useState)(null);
    const [reportingLinesData, setReportingLinesData] = (0, $5uXOq.useState)(undefined);
    const [shouldShowGiveKudos, setShouldShowGiveKudos] = (0, $5uXOq.useState)(false);
    const [teamCentralBaseUrl, setTeamCentralBaseUrl] = (0, $5uXOq.useState)(undefined);
    const [kudosDrawerOpen, setKudosDrawerOpen] = (0, $5uXOq.useState)(false);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $5uXOq.useState)(false);
    const triggerRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
        };
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        // Reset state when the userId changes
        setIsLoading(undefined);
        setHasError(false);
        setError(null);
        setData(null);
        setReportingLinesData(undefined);
        setShouldShowGiveKudos(false);
        setTeamCentralBaseUrl(undefined);
    }, [
        userId
    ]);
    const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
        // Don't fire any analytics if the component is unmounted
        if (!isMounted.current) return;
        (0, $ivXTE.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const hideProfilecard = (0, $5uXOq.useCallback)(()=>{
        clearTimeout(showTimer.current);
        clearTimeout(hideTimer.current);
        if (!isTriggeredUsingKeyboard) hideTimer.current = window.setTimeout(()=>{
            setVisible(false);
            onVisibilityChange && onVisibilityChange(false);
        }, hideDelay);
    }, [
        hideDelay,
        isTriggeredUsingKeyboard,
        onVisibilityChange
    ]);
    const handleKeyboardClose = (0, $5uXOq.useCallback)((event)=>{
        if (event.key && event.key !== 'Escape') return;
        if (triggerRef.current) triggerRef.current.focus();
        setTriggeredUsingKeyboard(false);
        setVisible(false);
        onVisibilityChange && onVisibilityChange(false);
    }, [
        setTriggeredUsingKeyboard,
        setVisible,
        onVisibilityChange
    ]);
    const handleClientSuccess = (0, $5uXOq.useCallback)((profileData, reportingLinesData, shouldShowGiveKudos, teamCentralBaseUrl)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(false);
        setData(profileData);
        setReportingLinesData(reportingLinesData);
        setTeamCentralBaseUrl(teamCentralBaseUrl);
        setShouldShowGiveKudos(shouldShowGiveKudos);
    }, [
        setHasError,
        setIsLoading,
        setData,
        setReportingLinesData,
        setShouldShowGiveKudos
    ]);
    const handleClientError = (0, $5uXOq.useCallback)((err)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(true);
        setError(err);
    }, [
        setHasError,
        setIsLoading,
        setError
    ]);
    const clientFetchProfile = (0, $5uXOq.useCallback)(async ()=>{
        if (isLoading === true) // don't fetch data when fetching is in process
        return;
        setIsLoading(true);
        setHasError(false);
        setError(null);
        setData(null);
        try {
            const requests = Promise.all([
                resourceClient.getProfile(cloudId || '', userId, fireAnalytics),
                resourceClient.getReportingLines(userId),
                resourceClient.shouldShowGiveKudos(),
                resourceClient.getTeamCentralBaseUrl({
                    withOrgContext: true,
                    withSiteContext: true
                })
            ]);
            const responses = await requests;
            handleClientSuccess(...responses);
        } catch (err) {
            handleClientError(err);
        }
    }, [
        cloudId,
        fireAnalytics,
        isLoading,
        resourceClient,
        userId,
        handleClientSuccess,
        handleClientError
    ]);
    const showProfilecard = (0, $5uXOq.useCallback)(()=>{
        clearTimeout(hideTimer.current);
        clearTimeout(showTimer.current);
        showTimer.current = window.setTimeout(()=>{
            if (!visible) {
                clientFetchProfile();
                setVisible(true);
                onVisibilityChange && onVisibilityChange(true);
            }
        }, showDelay);
    }, [
        showDelay,
        visible,
        clientFetchProfile,
        onVisibilityChange
    ]);
    const onClick = (0, $5uXOq.useCallback)((event)=>{
        // If the user clicks on the trigger then we don't want that click event to
        // propagate out to parent containers. For example when clicking a mention
        // lozenge in an inline-edit.
        event.stopPropagation();
        showProfilecard();
        if (!visible) fireAnalytics((0, $ivXTE.cardTriggered)('user', 'click'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onMouseEnter = (0, $5uXOq.useCallback)(()=>{
        showProfilecard();
        if (!visible) fireAnalytics((0, $ivXTE.cardTriggered)('user', 'hover'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onKeyPress = (0, $5uXOq.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setTriggeredUsingKeyboard(true);
            showProfilecard();
            if (!visible) fireAnalytics((0, $ivXTE.cardTriggered)('user', 'click'));
        }
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onFocus = (0, $5uXOq.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $VSDnB.fg)('fix_profilecard_trigger_isvisible')) return;
        // If the prop isVisible is not defined, we don't want to do anything
        if (propsIsVisible === undefined) return;
        // If the prop isVisible is defined, we want to show or hide the profile card based on the value
        if (propsIsVisible) showProfilecard();
        else hideProfilecard();
    }, [
        hideProfilecard,
        propsIsVisible,
        showProfilecard
    ]);
    const containerListeners = (0, $5uXOq.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onBlur: hideProfilecard,
            onKeyPress: onKeyPress
        } : {
            onClick: onClick,
            onKeyPress: onKeyPress
        }, [
        hideProfilecard,
        onClick,
        onKeyPress,
        onMouseEnter,
        trigger
    ]);
    const filterActions = (0, $5uXOq.useCallback)(()=>{
        return (0, $4sfdL.default)(actions, data);
    }, [
        actions,
        data
    ]);
    const openKudosDrawer = ()=>{
        hideProfilecard();
        setKudosDrawerOpen(true);
    };
    const closeKudosDrawer = ()=>{
        setKudosDrawerOpen(false);
    };
    const showLoading = isLoading === true || isLoading === undefined;
    const wrapperProps = (0, $5uXOq.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onFocus: onFocus
        } : {}, [
        hideProfilecard,
        onFocus,
        onMouseEnter,
        trigger
    ]);
    const profilecardProps = {
        userId: userId,
        fullName: prepopulatedData?.fullName,
        isCurrentUser: userId === viewingUserId,
        clientFetchProfile: clientFetchProfile,
        ...data,
        reportingLines: reportingLinesData,
        onReportingLinesClick: onReportingLinesClick,
        isKudosEnabled: shouldShowGiveKudos,
        teamCentralBaseUrl: teamCentralBaseUrl,
        cloudId: cloudId,
        openKudosDrawer: openKudosDrawer,
        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
        disabledAriaAttributes: disabledAriaAttributes
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1I7E8.default), {
                isOpen: !!visible,
                onClose: (event)=>{
                    hideProfilecard();
                    handleKeyboardClose(event);
                },
                placement: position,
                offset: offset ?? [
                    0,
                    8
                ],
                content: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        ...wrapperProps,
                        children: showLoading ? /*#__PURE__*/ (0, $2OMIu.jsx)($74b3c02273951832$var$LoadingView, {
                            fireAnalytics: fireAnalytics
                        }) : visible && /*#__PURE__*/ (0, $2OMIu.jsx)($74b3c02273951832$var$ProfileCardContent, {
                            profilecardProps: profilecardProps,
                            isAgent: !!data?.isAgent,
                            userId: userId,
                            cloudId: cloudId,
                            resourceClient: resourceClient,
                            viewingUserId: viewingUserId,
                            trigger: trigger,
                            product: product,
                            profileCardAction: filterActions(),
                            errorType: error,
                            hasError: hasError,
                            agentActions: agentActions,
                            addFlag: addFlag
                        })
                    }),
                trigger: (triggerProps)=>{
                    const { ref: callbackRef, ...innerProps } = triggerProps;
                    const ref = (element)=>{
                        triggerRef.current = element;
                        if (typeof callbackRef === 'function') callbackRef(element);
                    };
                    const { 'aria-expanded': _, 'aria-haspopup': __, ...restInnerProps } = innerProps;
                    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                        ...disabledAriaAttributes ? restInnerProps : triggerProps,
                        ...containerListeners,
                        ref: ref,
                        "data-testid": testId,
                        ...!ariaHideProfileTrigger && {
                            'aria-labelledby': ariaLabelledBy
                        },
                        ...disabledAriaAttributes ? {} : {
                            role: 'button',
                            //  aria-hidden cannot contain focusable elements: https://dequeuniversity.com/rules/axe/3.5/aria-hidden-focus
                            tabIndex: ariaHideProfileTrigger ? -1 : 0,
                            'aria-label': ariaHideProfileTrigger ? undefined : (0, $chprS.default)(ariaLabel, profilecardProps.fullName, formatMessage)
                        },
                        ...ariaHideProfileTrigger && {
                            'aria-hidden': 'true'
                        },
                        children: children
                    });
                },
                zIndex: (0, $k5uoT.layers).modal(),
                shouldUseCaptureOnOutsideClick: true,
                autoFocus: autoFocus ?? trigger === 'click',
                // This feature gate is currently enabled only for Jira_Web to avoid UI issues in Confluence_Web.
                shouldRenderToParent: (0, $VSDnB.fg)('enable_appropriate_reading_order_in_profile_card')
            }),
            shouldShowGiveKudos && teamCentralBaseUrl && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $adIkV.GiveKudosLauncherLazy), {
                    isOpen: kudosDrawerOpen,
                    recipient: {
                        type: (0, $gH4E9.KudosType).INDIVIDUAL,
                        recipientId: userId
                    },
                    analyticsSource: "profile-card",
                    teamCentralBaseUrl: teamCentralBaseUrl,
                    cloudId: cloudId,
                    addFlag: addFlag,
                    onClose: closeKudosDrawer
                })
            })
        ]
    });
}
const $74b3c02273951832$var$LoadingView = ({ fireAnalytics: fireAnalytics })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $8ycEU.CardWrapper), {
        testId: "profilecard.profilecardtrigger.loading",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ifxzB.default), {
            fireAnalytics: fireAnalytics
        })
    });

});
parcelRegister("adIkV", function(module, exports) {

$parcel$export(module.exports, "GiveKudosLauncherLazy", () => $c3877992df568d20$export$93fe397a02fe8b76);

var $5uXOq = parcelRequire("5uXOq");

const $c3877992df568d20$export$93fe397a02fe8b76 = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("8yX7f")));

});
parcelRegister("8yX7f", function(module, exports) {

let $63bf5ae7f89f081a$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $63bf5ae7f89f081a$var$load("76n7a"),
    $63bf5ae7f89f081a$var$load("l253H"),
    $63bf5ae7f89f081a$var$load("ffQaD"),
    $63bf5ae7f89f081a$var$load("kvRbA"),
    $63bf5ae7f89f081a$var$load("4Z0s8")
]).then(()=>parcelRequire('iRLc5'));

});


parcelRegister("gH4E9", function(module, exports) {

$parcel$export(module.exports, "KudosType", () => $b9e3bff5640b4187$export$4fa2020056771264);
$parcel$export(module.exports, "FlagEventType", () => $b9e3bff5640b4187$export$d21f9befaa2961a);
$parcel$export(module.exports, "isFlagEventTypeValue", () => $b9e3bff5640b4187$export$7a1fc1a1b0477464);
var $b9e3bff5640b4187$export$4fa2020056771264 = /*#__PURE__*/ function(KudosType) {
    KudosType["INDIVIDUAL"] = "individual";
    KudosType["TEAM"] = "team";
    KudosType["MIXED"] = "mixed";
    return KudosType;
}({});
var $b9e3bff5640b4187$export$d21f9befaa2961a = /*#__PURE__*/ function(FlagEventType) {
    FlagEventType["KUDOS_CREATED"] = "kudos-created";
    FlagEventType["KUDOS_FAILED"] = "kudos-failed";
    FlagEventType["JIRA_KUDOS_CREATED"] = "jira-kudos-created";
    FlagEventType["JIRA_KUDOS_FAILED"] = "jira-kudos-failed";
    FlagEventType["DIRTY"] = "dirty";
    FlagEventType["CLOSE"] = "close";
    return FlagEventType;
}({});
const $b9e3bff5640b4187$export$7a1fc1a1b0477464 = (value)=>{
    return Object.values($b9e3bff5640b4187$export$d21f9befaa2961a).includes(value);
};

});

parcelRegister("4sfdL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea1251cd76451c32$export$2e2bcd8739ae039);
const $ea1251cd76451c32$var$filterActions = (actions = [], data)=>{
    return actions.filter((action)=>{
        if (!action.shouldRender) return true;
        else if (typeof action.shouldRender !== 'function') return Boolean(action.shouldRender);
        return action.shouldRender(data);
    });
};
var $ea1251cd76451c32$export$2e2bcd8739ae039 = $ea1251cd76451c32$var$filterActions;

});

parcelRegister("chprS", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b051cf4c3ebf799$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $4b051cf4c3ebf799$var$getLabelMessage = (ariaLabelProp, fullName, formatMessage)=>{
    if (ariaLabelProp) return ariaLabelProp;
    return fullName ? formatMessage($4b051cf4c3ebf799$var$messages.label, {
        fullName: fullName
    }) : formatMessage($4b051cf4c3ebf799$var$messages.fallbackLabel);
};
const $4b051cf4c3ebf799$var$messages = (0, $7VHMR.defineMessages)({
    fallbackLabel: {
        id: 'profilecard.user.trigger.fallback-aria-label',
        defaultMessage: 'More information about this user',
        description: 'Label for profile card trigger when we do not have user name'
    },
    label: {
        id: 'profilecard.user.trigger.aria-label',
        defaultMessage: 'More information about {fullName}',
        description: 'Label for profile card trigger'
    }
});
var $4b051cf4c3ebf799$export$2e2bcd8739ae039 = $4b051cf4c3ebf799$var$getLabelMessage;

});

parcelRegister("8ycEU", function(module, exports) {

$parcel$export(module.exports, "CardWrapper", () => $a933423b71243bbb$export$6aa22a823032b784);
$parcel$export(module.exports, "SpinnerContainer", () => $a933423b71243bbb$export$a5e06607a5ac6158);
/* UserTrigger.tsx generated by @compiled/babel-plugin v0.36.1 */ // PLEASE NOTE: This file is sync-loaded with the trigger components. Only add components here that
// are necessary for the main render of the trigger component to help maintain bundle size.
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $huHkE = parcelRequire("huHkE");

var $bWGt6 = parcelRequire("bWGt6");
function $a933423b71243bbb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a933423b71243bbb$var$styles = {
    cardWrapper: "_2rkoglpi _1bsb1gwv",
    spinnerContainer: "_4cvr1h6o _1e0c1txw _4t3i16xz _1bah1h6o _kqswh2mm"
};
const $a933423b71243bbb$export$6aa22a823032b784 = ({ children: children, role: role, testId: testId, labelledBy: labelledBy })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a933423b71243bbb$var$styles.cardWrapper),
        backgroundColor: 'elevation.surface.overlay',
        role: role,
        testId: testId,
        "aria-labelledby": labelledBy,
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a933423b71243bbb$var$CardWrapperLegacy, {
        "data-testid": testId,
        role: role,
        "aria-labelledby": labelledBy,
        children: children
    });
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a933423b71243bbb$var$CardWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1fdk60v1"
})("background-color:", (0, $huHkE.bgColor), ";border-radius:var(--ds-border-radius, 3px);width:360px;");
const $a933423b71243bbb$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        testId: testId,
        xcss: (0, $3JT92.cx)($a933423b71243bbb$var$styles.spinnerContainer),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a933423b71243bbb$var$SpinnerContainerLegacy, {
        "data-testid": testId,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a933423b71243bbb$var$SpinnerContainerLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1fdk60v0"
})({
    name: "1e8m6rx",
    styles: "align-items:center;display:flex;height:96px;justify-content:center;position:relative"
});

});
parcelRegister("huHkE", function(module, exports) {

$parcel$export(module.exports, "bgColor", () => $61d9a2704bf54ca1$export$7dcbec377a25efc6);
$parcel$export(module.exports, "headerBgColor", () => $61d9a2704bf54ca1$export$d3ec0459d8f4bbed);
$parcel$export(module.exports, "teamHeaderBgColor", () => $61d9a2704bf54ca1$export$afc7ad7e78cf1c79);
$parcel$export(module.exports, "headerBgColorDisabledUser", () => $61d9a2704bf54ca1$export$ef73fded6fab455c);
$parcel$export(module.exports, "headerTextColor", () => $61d9a2704bf54ca1$export$5c2df128da90e8de);
$parcel$export(module.exports, "appLabelBgColor", () => $61d9a2704bf54ca1$export$6f79b778f6280d31);
$parcel$export(module.exports, "appLabelTextColor", () => $61d9a2704bf54ca1$export$3db47a978b9599f9);
$parcel$export(module.exports, "labelTextColor", () => $61d9a2704bf54ca1$export$dd73341f2a5541fa);
$parcel$export(module.exports, "labelIconColor", () => $61d9a2704bf54ca1$export$5a20f73e634c37e3);
$parcel$export(module.exports, "errorIconColor", () => $61d9a2704bf54ca1$export$85e73a744c5d1042);
$parcel$export(module.exports, "errorTitleColor", () => $61d9a2704bf54ca1$export$be3c814f7ed506ed);

const $61d9a2704bf54ca1$export$7dcbec377a25efc6 = `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
const $61d9a2704bf54ca1$export$d3ec0459d8f4bbed = `var(--ds-background-brand-bold, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`;
const $61d9a2704bf54ca1$export$afc7ad7e78cf1c79 = `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$8754fc7e6d8b3000)})`;
const $61d9a2704bf54ca1$export$ef73fded6fab455c = `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`;
const $61d9a2704bf54ca1$export$5c2df128da90e8de = `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
const $61d9a2704bf54ca1$export$a882617dcf7f98a6 = `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`;
const $61d9a2704bf54ca1$export$6f79b778f6280d31 = `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`;
const $61d9a2704bf54ca1$export$3db47a978b9599f9 = `var(--ds-text, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`;
const $61d9a2704bf54ca1$export$dd73341f2a5541fa = `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`;
const $61d9a2704bf54ca1$export$5a20f73e634c37e3 = `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$c2e91cbeada39b8b)})`;
const $61d9a2704bf54ca1$export$85e73a744c5d1042 = `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`;
const $61d9a2704bf54ca1$export$be3c814f7ed506ed = `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`;
const $61d9a2704bf54ca1$export$ddf766d3bfcf965c = `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`;

});


const $e41878b3b8cab0db$export$5b956b542f1bc1b3 = 800;
const $e41878b3b8cab0db$export$89a9f35a94d7f196 = 200;

parcelRegister("kDbj5", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardResourced", () => $9f87d208f89c63eb$export$4b013ffffcb40af8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $ivXTE = parcelRequire("ivXTE");

var $dG58U = parcelRequire("dG58U");

var $cI0Td = parcelRequire("cI0Td");

var $a3FJs = parcelRequire("a3FJs");

var $iwWWV = parcelRequire("iwWWV");
const $9f87d208f89c63eb$export$4b013ffffcb40af8 = (props)=>{
    const [agentData, setAgentData] = (0, $5uXOq.useState)();
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
        if (createAnalyticsEvent) (0, $ivXTE.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const creatorUserId = (0, $5uXOq.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $dG58U.getAAIDFromARI)(agentData.creator) : '', [
        agentData?.creator_type,
        agentData?.creator
    ]);
    const getCreator = (0, $5uXOq.useCallback)(async (creator_type, creator)=>{
        if (!creator) return undefined;
        switch(creator_type){
            case 'SYSTEM':
                return {
                    type: 'SYSTEM'
                };
            case 'THIRD_PARTY':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'CUSTOMER':
                try {
                    if (!creatorUserId || !props.cloudId) return undefined;
                    const creatorInfo = await props.resourceClient.getProfile(creatorUserId, props.cloudId, fireAnalytics);
                    return {
                        type: 'CUSTOMER',
                        name: creatorInfo.fullName,
                        profileLink: `/people/${creatorUserId}`,
                        id: creatorUserId
                    };
                } catch (error) {
                    return undefined;
                }
            default:
                return undefined;
        }
    }, [
        creatorUserId,
        fireAnalytics,
        props.cloudId,
        props.resourceClient
    ]);
    const fetchData = (0, $5uXOq.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const profileData = await props.resourceClient.getRovoAgentProfile({
                type: 'identity',
                value: props.accountId
            }, fireAnalytics);
            const agentCreatorInfo = await getCreator(profileData?.creator_type, profileData?.creator || undefined);
            setAgentData({
                ...profileData,
                creatorInfo: agentCreatorInfo
            });
        } catch (err) {
            setError(err);
        } finally{
            setIsLoading(false);
        }
    }, [
        fireAnalytics,
        getCreator,
        props.accountId,
        props.resourceClient
    ]);
    (0, $5uXOq.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    if (error || !isLoading && !agentData) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a3FJs.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cI0Td.default), {
            reload: ()=>{
                fetchData();
            },
            errorType: error || null,
            fireAnalytics: ()=>{}
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwWWV.AgentProfileCardLazy), {
            agent: agentData,
            isLoading: isLoading,
            hasError: !!error,
            isCreatedByViewingUser: creatorUserId === props.viewingUserId,
            product: props.product,
            onConversationStartersClick: props.onConversationStartersClick,
            onChatClick: props.onChatClick,
            addFlag: props.addFlag,
            resourceClient: props.resourceClient,
            cloudId: props.cloudId
        })
    });
};

});
parcelRegister("dG58U", function(module, exports) {

$parcel$export(module.exports, "getAAIDFromARI", () => $dd4eeae2be471029$export$3761e66a04602cbd);
const $dd4eeae2be471029$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $dd4eeae2be471029$export$3761e66a04602cbd = (ari)=>{
    return ari.replace($dd4eeae2be471029$export$470b0d72e4fdc43a, '');
};

});

parcelRegister("cI0Td", function(module, exports) {

$parcel$export(module.exports, "default", () => $f71e8c5b4eb5da96$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $eCeGD = parcelRequire("eCeGD");

var $hI6SY = parcelRequire("hI6SY");

var $d5Zn3 = parcelRequire("d5Zn3");

var $VSDnB = parcelRequire("VSDnB");

var $cgL5K = parcelRequire("cgL5K");

var $2uTKk = parcelRequire("2uTKk");

var $ivXTE = parcelRequire("ivXTE");
const $f71e8c5b4eb5da96$var$ErrorMessage = (props)=>{
    const errorType = props.errorType || {
        reason: 'default'
    };
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    (0, $5uXOq.useEffect)(()=>{
        fireAnalytics((0, $ivXTE.profileCardRendered)('user', 'error', {
            hasRetry: hasRetry,
            errorType: errorReason
        }));
    }, [
        errorReason,
        fireAnalytics,
        hasRetry
    ]);
    const errorContent = ()=>{
        if (errorReason === 'NotFound') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2uTKk.ErrorTitle), {
            children: "The user is no longer available for the site"
        });
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2uTKk.ErrorTitle), {
            children: [
                "Oops, looks like we\u2019re having issues",
                /*#__PURE__*/ (0, $2OMIu.jsx)("br", {}),
                reload && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgL5K.default), {
                    color: "color.text.subtlest",
                    children: "Try again and we\u2019ll give it another shot"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2uTKk.ErrorWrapper), {
        testId: "profilecard-error",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hI6SY))), {
                label: "icon error",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($d5Zn3))),
                LEGACY_size: "xlarge"
            }),
            errorContent(),
            reload && ((0, $VSDnB.fg)('ptc_migrate_buttons') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                onClick: reload,
                children: "Try again"
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                appearance: "link",
                onClick: reload,
                children: "Try again"
            }))
        ]
    });
};
var $f71e8c5b4eb5da96$export$2e2bcd8739ae039 = $f71e8c5b4eb5da96$var$ErrorMessage;

});
parcelRegister("2uTKk", function(module, exports) {

$parcel$export(module.exports, "ErrorWrapper", () => $0619b202cbb0de2c$export$bb27b7e39840238f);
$parcel$export(module.exports, "ErrorTitle", () => $0619b202cbb0de2c$export$b065fd053267ec81);
$parcel$export(module.exports, "TeamErrorText", () => $0619b202cbb0de2c$export$90d92ccfb27352c6);
/* Error.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");


var $huHkE = parcelRequire("huHkE");

var $bWGt6 = parcelRequire("bWGt6");
const $0619b202cbb0de2c$var$styles = {
    errorWrapper: "_y3gn1h6o _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
    errorTitle: "_11c82smr _syaz1fxt _19pku2gc",
    teamErrorText: "_syaz1wmz _19pku2gc"
};
const $0619b202cbb0de2c$export$bb27b7e39840238f = (props)=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($0619b202cbb0de2c$var$styles.errorWrapper),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($0619b202cbb0de2c$var$ErrorWrapperLegacy, {
        "data-testId": props.testId,
        children: props.children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0619b202cbb0de2c$var$ErrorWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1gaqn292"
})({
    textAlign: 'center',
    padding: "var(--ds-space-300, 24px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $huHkE.errorIconColor)
});
const $0619b202cbb0de2c$export$b065fd053267ec81 = (props)=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($0619b202cbb0de2c$var$styles.errorTitle),
        children: props.children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($0619b202cbb0de2c$var$ErrorTitleLegacy, {
        children: props.children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0619b202cbb0de2c$var$ErrorTitleLegacy = /*#__PURE__*/ (0, $bWGt6.default)("p", {
    target: "e1gaqn291"
})({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $huHkE.errorTitleColor),
    margin: `${"var(--ds-space-100, 8px)"} 0`
});
const $0619b202cbb0de2c$export$90d92ccfb27352c6 = (props)=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($0619b202cbb0de2c$var$styles.teamErrorText),
        children: props.children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($0619b202cbb0de2c$var$TeamErrorTextLegacy, {
        children: props.children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0619b202cbb0de2c$var$TeamErrorTextLegacy = /*#__PURE__*/ (0, $bWGt6.default)("p", {
    target: "e1gaqn290"
})({
    color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
    marginTop: "var(--ds-space-100, 8px)"
});

});


parcelRegister("a3FJs", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardWrapper", () => $642b3278878bc39a$export$2c6604b50c274e6f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $642b3278878bc39a$var$styles = (0, $8CUq3.xcss)({
    width: '360px'
});
const $642b3278878bc39a$export$2c6604b50c274e6f = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        xcss: $642b3278878bc39a$var$styles,
        children: children
    });
};

});

parcelRegister("iwWWV", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardLazy", () => $b487397875f853f0$export$ed0ca9c1d49ea0bf);

var $5uXOq = parcelRequire("5uXOq");

const $b487397875f853f0$export$ed0ca9c1d49ea0bf = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("g3ERZ")));

});
parcelRegister("g3ERZ", function(module, exports) {

let $bb0ca10dcfe65ac0$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $bb0ca10dcfe65ac0$var$load("76n7a"),
    $bb0ca10dcfe65ac0$var$load("l253H"),
    $bb0ca10dcfe65ac0$var$load("ffQaD"),
    $bb0ca10dcfe65ac0$var$load("kvRbA"),
    $bb0ca10dcfe65ac0$var$load("juOk6")
]).then(()=>parcelRequire('9gV7o'));

});



parcelRegister("dYuIx", function(module, exports) {

$parcel$export(module.exports, "ProfileCardLazy", () => $78b4a66e55984f2d$export$403d297463f226af);

var $5uXOq = parcelRequire("5uXOq");

const $78b4a66e55984f2d$export$403d297463f226af = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("l0Ydb")));

});
parcelRegister("l0Ydb", function(module, exports) {

let $f4c84dd928c83aa6$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f4c84dd928c83aa6$var$load("ffQaD"),
    $f4c84dd928c83aa6$var$load("kvRbA"),
    $f4c84dd928c83aa6$var$load("1ehQl")
]).then(()=>parcelRequire('lrMir'));

});


parcelRegister("ifxzB", function(module, exports) {

$parcel$export(module.exports, "default", () => $44786ae639641a68$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eZJjh = parcelRequire("eZJjh");

var $8ycEU = parcelRequire("8ycEU");

var $ivXTE = parcelRequire("ivXTE");
const $44786ae639641a68$var$UserLoadingState = ({ fireAnalytics: fireAnalytics })=>{
    (0, $5uXOq.useEffect)(()=>{
        fireAnalytics((0, $ivXTE.profileCardRendered)('user', 'spinner'));
    }, [
        fireAnalytics
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8ycEU.SpinnerContainer), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {})
    });
};
var $44786ae639641a68$export$2e2bcd8739ae039 = $44786ae639641a68$var$UserLoadingState;

});


parcelRegister("8G7CX", function(module, exports) {

$parcel$export(module.exports, "isSystemAgent", () => $11e5cd279fe5fb4c$export$7c120b233d4844c6);
$parcel$export(module.exports, "isCustomerAgent", () => $11e5cd279fe5fb4c$export$f817e52cf2c5cc8c);
$parcel$export(module.exports, "isForgeAgent", () => $11e5cd279fe5fb4c$export$2149adda3d8a5807);
$parcel$export(module.exports, "isOOTBAgent", () => $11e5cd279fe5fb4c$export$7091e3bee2adaacb);
const $11e5cd279fe5fb4c$export$7c120b233d4844c6 = (agent)=>agent.creator_type === 'SYSTEM';
const $11e5cd279fe5fb4c$export$f817e52cf2c5cc8c = (agent)=>agent.creator_type === 'CUSTOMER';
const $11e5cd279fe5fb4c$export$2149adda3d8a5807 = (agent)=>agent.creator_type === 'THIRD_PARTY' || agent.creator_type === 'FORGE';
const $11e5cd279fe5fb4c$export$95433d0f8c6ad323 = (agent)=>agent.visibility === 'PRIVATE';
const $11e5cd279fe5fb4c$export$7091e3bee2adaacb = (agent)=>agent.creator_type === 'OOTB';
const $11e5cd279fe5fb4c$export$916e4870f74f205b = {
    ALL_AGENTS: 'all-agents',
    STARRED_AGENTS: 'starred-agents',
    MY_AGENTS: 'my-agents',
    TEMPLATES: 'templates',
    DEVELOPMENT: 'development'
};

});

parcelRegister("3xYdY", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_AGENTS_NAMED_ID_LIST", () => $3b04d45962552af9$export$2d0163867590928d);
$parcel$export(module.exports, "DEFAULT_OOTB_AGENTS_NAMED_IDS", () => $3b04d45962552af9$export$804d9ee5f4cc40a8);
$parcel$export(module.exports, "isCreateOrEditAgentAUPError", () => $3b04d45962552af9$export$a08ace1426fa4a9e);
$parcel$export(module.exports, "isHipaaError", () => $3b04d45962552af9$export$f8b1b75846492611);
const $3b04d45962552af9$export$48783720d93c2d26 = {
    id: 'ai_mate_agent',
    named_id: 'ai_mate_agent',
    name: 'AI Mate',
    description: 'AI Mate',
    creator_type: 'SYSTEM',
    available_plugins: {},
    is_default: true,
    visibility: 'PUBLIC'
};
const $3b04d45962552af9$export$2d0163867590928d = new Set([
    'decision_director_agent',
    'user_manual_writer_agent',
    'product_requirements_expert_agent'
]);
const $3b04d45962552af9$export$804d9ee5f4cc40a8 = {
    ['confluence']: new Set([
        'decision_director_agent',
        'product_requirements_expert_agent',
        'rovo_expert_agent'
    ]),
    ['jira']: new Set([
        'rovo_expert_agent',
        'issue_organizer_agent',
        'jira_theme_analyzer_agent'
    ]),
    ['atlas']: new Set([
        'progress_tracker_agent',
        'product_requirements_expert_agent',
        'rovo_expert_agent'
    ])
};
const $3b04d45962552af9$var$AGENT_AUP_ERROR_CODE = `convoai.agent.responsible-ai.failure`;
const $3b04d45962552af9$var$HIPAA_ERROR_CODE = 'convoai.rest.browsing.product.has.hipaa.enabled';
const $3b04d45962552af9$export$a08ace1426fa4a9e = (error)=>Boolean(error) && typeof error === 'object' && error.errorAttributes && error.errorAttributes.errorCode === $3b04d45962552af9$var$AGENT_AUP_ERROR_CODE;
const $3b04d45962552af9$export$f8b1b75846492611 = (error)=>Boolean(error) && typeof error === 'object' && error.errorAttributes && error.errorAttributes.errorCode === $3b04d45962552af9$var$HIPAA_ERROR_CODE;

});

parcelRegister("gBv35", function(module, exports) {

$parcel$export(module.exports, "useProfileClient", () => $8168d85a70e7a063$export$d43dc22a8337ee9f);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $bp5g1 = parcelRequire("bp5g1");
const $8168d85a70e7a063$var$DIRECTORY_URL = '/gateway/api/directory/graphql';
let $8168d85a70e7a063$var$client;
const $8168d85a70e7a063$export$d43dc22a8337ee9f = ()=>{
    (0, $gKZoD.di)((0, $bp5g1.default));
    const profileClient = (0, $5uXOq.useMemo)(()=>{
        if (!$8168d85a70e7a063$var$client) // To support di
        $8168d85a70e7a063$var$client = new (0, $bp5g1.default)({
            url: $8168d85a70e7a063$var$DIRECTORY_URL,
            cacheSize: 1000,
            // 1 day
            cacheMaxAge: 86400000
        });
        return $8168d85a70e7a063$var$client;
    }, []);
    return profileClient;
};

});

parcelRegister("3go6U", function(module, exports) {

$parcel$export(module.exports, "default", () => $52a6773361bb10a2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $52a6773361bb10a2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    deactivatedCreatorName: {
        id: 'rovo-chat.agent-card.deactivated-name',
        defaultMessage: '{name} (deactivated)',
        description: 'Name of the agent creator when it is deactivated'
    }
});

});


parcelRegister("9XSXa", function(module, exports) {

$parcel$export(module.exports, "useKnowledgeProductsRender", () => $e4eb9c6c2ccd85ae$export$3aa02e5f70d569cc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $e4yMr = parcelRequire("e4yMr");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
var $dS3PR = parcelRequire("dS3PR");

var $jWXme = parcelRequire("jWXme");

var $f1tAG = parcelRequire("f1tAG");

var $1e6hD = parcelRequire("1e6hD");
const $e4eb9c6c2ccd85ae$var$styles = {
    wrapper: "_4t3igktf",
    iconWrapper: "_2lx21bp4 _1n261q9c _4t3i1tcg _1bsb1tcg _1e0c1txw"
};
const $e4eb9c6c2ccd85ae$var$KnowledgeSourceProduct = ({ source: source, cloudUrl: cloudUrl })=>{
    const LinkOrText = cloudUrl ? (0, $e4yMr.default) : (0, $dS3PR.default);
    const label = (0, $jWXme.formatKnowledgeSourceLabel)(source);
    const getLabelRender = ()=>{
        switch(source){
            case 'jira':
                return /*#__PURE__*/ (0, $2OMIu.jsx)(LinkOrText, {
                    maxLines: 1,
                    href: `${cloudUrl}/jira`,
                    target: "_blank",
                    children: label
                });
            case 'confluence':
                return /*#__PURE__*/ (0, $2OMIu.jsx)(LinkOrText, {
                    maxLines: 1,
                    href: `${cloudUrl}/wiki`,
                    target: "_blank",
                    children: label
                });
            case 'atlas':
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e4yMr.default), {
                    href: (0, $f1tAG.getAtlasHost)(),
                    target: "_blank",
                    children: label
                });
            default:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                    maxLines: 1,
                    children: label
                });
        }
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
        xcss: $e4eb9c6c2ccd85ae$var$styles.wrapper,
        alignBlock: "center",
        space: "space.075",
        children: [
            (0, $jWXme.iconMapper)[source],
            getLabelRender()
        ]
    });
};
const $e4eb9c6c2ccd85ae$var$getIconRender = (knowledgeSource)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $e4eb9c6c2ccd85ae$var$styles.iconWrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
            src: `/gateway/api/${knowledgeSource.iconUrl}`,
            role: "presentation",
            alt: knowledgeSource.source
        })
    });
};
const $e4eb9c6c2ccd85ae$var$KnowledgeSourceProductUsingBEFields = ({ knowledgeSource: knowledgeSource, cloudUrl: cloudUrl })=>{
    const LinkOrText = cloudUrl ? (0, $e4yMr.default) : (0, $dS3PR.default);
    const getLabelRender = ()=>{
        switch(knowledgeSource.source){
            case 'jira':
                return /*#__PURE__*/ (0, $2OMIu.jsx)(LinkOrText, {
                    maxLines: 1,
                    href: `${cloudUrl}/jira`,
                    target: "_blank",
                    children: knowledgeSource.friendlyName
                });
            case 'confluence':
                return /*#__PURE__*/ (0, $2OMIu.jsx)(LinkOrText, {
                    maxLines: 1,
                    href: `${cloudUrl}/wiki`,
                    target: "_blank",
                    children: knowledgeSource.friendlyName
                });
            case 'atlas':
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e4yMr.default), {
                    href: (0, $f1tAG.getAtlasHost)(),
                    target: "_blank",
                    children: knowledgeSource.friendlyName
                });
            default:
                return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dS3PR.default), {
                    maxLines: 1,
                    children: [
                        " ",
                        knowledgeSource.friendlyName
                    ]
                });
        }
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
        xcss: $e4eb9c6c2ccd85ae$var$styles.wrapper,
        alignBlock: "center",
        space: "space.075",
        children: [
            $e4eb9c6c2ccd85ae$var$getIconRender(knowledgeSource),
            getLabelRender()
        ]
    });
};
const $e4eb9c6c2ccd85ae$export$581d4179e1c59739 = ({ sources: sources, knowledgeScopeEnabled: knowledgeScopeEnabled, allKnowledgeSourcesFiltered: allKnowledgeSourcesFiltered, cloudUrl: cloudUrl })=>{
    let processedSources = sources;
    const useBEKnowledgeSourceFields = (0, $VSDnB.fg)('rovo_use_be_knowledge_source_fields');
    // When knowledge scope is not enabled, BE by default will use all the available knowledge sources, including any new ones that added
    // we want to simulate the BE behavior here only on rendering layer
    if (!knowledgeScopeEnabled) processedSources = allKnowledgeSourcesFiltered;
    else // When knowledge scope is enabled, merge the filtered sources with their configurations from the backend
    if (useBEKnowledgeSourceFields) processedSources = sources.map((source)=>{
        const matchingSource = allKnowledgeSourcesFiltered.find((filteredSource)=>filteredSource.source === source.source);
        return {
            ...matchingSource,
            ...source
        };
    //Override with AgentKnowledgeSource config value
    });
    const knowledgeSourcesRender = [];
    processedSources.forEach((source)=>{
        if (!source.enabled) return null;
        // if confluence filters has any specific pages or space filter
        // we don't render the confluence product
        if (source.source === 'confluence' && (source.configuration?.parent_filter?.length || source.configuration?.space_filter?.length)) return null;
        // if jira filters has any specific project filter
        // we don't render the jira product
        if (source.source === 'jira' && source.configuration?.project_filter?.length) return null;
        if (useBEKnowledgeSourceFields) knowledgeSourcesRender.push(/*#__PURE__*/ (0, $2OMIu.jsx)($e4eb9c6c2ccd85ae$var$KnowledgeSourceProductUsingBEFields, {
            knowledgeSource: source,
            cloudUrl: cloudUrl
        }, source.source));
        else knowledgeSourcesRender.push(/*#__PURE__*/ (0, $2OMIu.jsx)($e4eb9c6c2ccd85ae$var$KnowledgeSourceProduct, {
            source: source.source,
            cloudUrl: cloudUrl
        }, source.source));
    });
    return knowledgeSourcesRender.length ? knowledgeSourcesRender : null;
};
const $e4eb9c6c2ccd85ae$export$3aa02e5f70d569cc = ({ assistanceServiceParams: assistanceServiceParams })=>{
    (0, $gKZoD.di)((0, $1e6hD.useKnowledgeConnectors));
    const { enabledKnowledgeSources: enabledKnowledgeSources } = (0, $1e6hD.useKnowledgeConnectors)({
        assistanceServiceParams: assistanceServiceParams
    });
    const allKnowledgeSourcesFiltered = (0, $5uXOq.useMemo)(()=>enabledKnowledgeSources.map(({ source: source, iconUrl: iconUrl, friendlyName: friendlyName })=>{
            const configuration = source === 'confluence' ? {
                parent_filter: [],
                space_filter: []
            } : source === 'jira' ? {
                project_filter: []
            } : undefined;
            return {
                source: source,
                configuration: configuration,
                enabled: true,
                iconUrl: iconUrl,
                friendlyName: friendlyName
            };
        }), [
        enabledKnowledgeSources
    ]);
    const getKnowledgeProductsRenderForAgent = (0, $5uXOq.useCallback)((params)=>{
        return $e4eb9c6c2ccd85ae$export$581d4179e1c59739({
            ...params,
            allKnowledgeSourcesFiltered: allKnowledgeSourcesFiltered
        });
    }, [
        allKnowledgeSourcesFiltered
    ]);
    return {
        getKnowledgeProductsRenderForAgent: getKnowledgeProductsRenderForAgent
    };
};

});
parcelRegister("jWXme", function(module, exports) {

$parcel$export(module.exports, "formatKnowledgeSourceLabel", () => $e25beb1cd50a8d63$export$f32a352406d501db);
$parcel$export(module.exports, "iconMapper", () => $e25beb1cd50a8d63$export$c63040ce43e3b7ce);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $czMKq = parcelRequire("czMKq");

var $gAvxW = parcelRequire("gAvxW");

var $iX9TB = parcelRequire("iX9TB");

var $ji7Zl = parcelRequire("ji7Zl");

var $2pMF0 = parcelRequire("2pMF0");
var $7anl7 = parcelRequire("7anl7");
var $29YN9 = parcelRequire("29YN9");
const $e25beb1cd50a8d63$export$f32a352406d501db = (source)=>source === 'atlas' ? 'Atlassian Home' : source.replace(/[_-]/g, ' ') // Replace underscores and dashes with spaces
    .split(' ').map((word)=>word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
const $e25beb1cd50a8d63$export$c63040ce43e3b7ce = {
    confluence: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7anl7.ConfluenceIcon), {
        size: "small",
        appearance: "brand"
    }),
    jira: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $29YN9.JiraIcon), {
        size: "small",
        appearance: "brand"
    }),
    atlas: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2pMF0.AtlassianIcon), {
        label: "",
        size: "small",
        appearance: "brand"
    }),
    // TODO - Migrate to ADS icon/logo later - https://product-fabric.atlassian.net/browse/DSP-21174
    google_drive: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $czMKq.default), {
        label: ""
    }),
    // TODO - Migrate to ADS icon/logo later - https://product-fabric.atlassian.net/browse/DSP-21174
    microsoft_sharepoint: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iX9TB.default), {
        label: ""
    }),
    // TODO - Migrate to ADS icon/logo later - https://product-fabric.atlassian.net/browse/DSP-21174
    slack: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ji7Zl.default), {
        label: ""
    }),
    // TODO - Migrate to ADS icon/logo later - https://product-fabric.atlassian.net/browse/DSP-21174
    loom: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gAvxW.default), {
        label: ""
    })
};

});
parcelRegister("czMKq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d615c308ec78a3ad$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $d615c308ec78a3ad$var$GoogleDriveIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "20",
        height: "18",
        viewBox: "0 0 20 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M3.33374 17.3241L6.66677 11.5493H19.9999L16.6666 17.3241H3.33374Z",
                fill: "#3777E3"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M13.3335 11.5493H19.9999L13.3335 0H6.6665L13.3335 11.5493Z",
                fill: "#FFCF63"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M0 11.5493L3.3335 17.324L9.99985 5.77469L6.66656 0L0 11.5493Z",
                fill: "#11A861"
            })
        ]
    });
/**
 * __GoogleDriveIcon__
 */ const $d615c308ec78a3ad$var$GoogleDriveIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $d615c308ec78a3ad$var$GoogleDriveIconGlyph
    });
var $d615c308ec78a3ad$export$2e2bcd8739ae039 = $d615c308ec78a3ad$var$GoogleDriveIcon;

});

parcelRegister("gAvxW", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0891101eb87cac4$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $c0891101eb87cac4$var$LoomIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "2 2 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("g", {
                clipPath: "url(#clip0_271_181644)",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    d: "M24.0115 12.9534H17.9154L23.1946 9.90666L22.1477 8.09334L16.8678 11.14L19.9151 5.86334L18.1014 4.81666L15.0534 10.092V4H12.9581V10.0927L9.91009 4.81666L8.09565 5.86334L11.1431 11.1387L5.86445 8.09334L4.81687 9.90666L10.0961 12.9534H4V15.0473H10.0955L4.81687 18.094L5.86378 19.9073L11.1437 16.8607L8.09565 22.1373L9.90943 23.184L12.9581 17.908V24H15.0534V17.7773L18.1574 23.1507L19.8585 22.1693L16.7537 16.7947L22.1463 19.9066L23.194 18.0934L17.9154 15.0466H24.0108V12.9534H24.0115ZM14.0057 16.8466C13.6317 16.8467 13.2613 16.7731 12.9158 16.6301C12.5703 16.487 12.2563 16.2773 11.9918 16.0129C11.7273 15.7486 11.5175 15.4347 11.3743 15.0893C11.2311 14.7438 11.1575 14.3736 11.1574 13.9997C11.1573 13.6257 11.2309 13.2554 11.374 12.91C11.5172 12.5646 11.7269 12.2506 11.9913 11.9862C12.2557 11.7218 12.5696 11.512 12.9152 11.3689C13.2607 11.2257 13.631 11.1521 14.0051 11.152C14.7604 11.1519 15.4848 11.4518 16.019 11.9857C16.5532 12.5197 16.8534 13.2439 16.8534 13.999C16.8535 14.7541 16.5536 15.4784 16.0195 16.0125C15.4854 16.5466 14.761 16.8466 14.0057 16.8466Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("defs", {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                    id: "clip0_271_181644",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        transform: "translate(4 4)"
                    })
                })
            })
        ]
    });
/**
 * __LoomIcon__
 */ const $c0891101eb87cac4$var$LoomIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $c0891101eb87cac4$var$LoomIconGlyph
    });
var $c0891101eb87cac4$export$2e2bcd8739ae039 = $c0891101eb87cac4$var$LoomIcon;

});

parcelRegister("iX9TB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8202f9e7d9f2e622$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $8202f9e7d9f2e622$var$MicrosoftSharepointIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("mask", {
                id: "mask0_1701_19689",
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "20",
                height: "20",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    d: "M20 0H0V20H20V0Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                mask: "url(#mask0_1701_19689)",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M10.2328 11.4286C13.3153 11.4286 15.8142 8.87025 15.8142 5.71429C15.8142 2.55838 13.3153 0 10.2328 0C7.15024 0 4.65137 2.55838 4.65137 5.71429C4.65137 8.87025 7.15024 11.4286 10.2328 11.4286Z",
                        fill: "#036C70"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M14.8838 16.1906C17.7095 16.1906 20.0001 13.8453 20.0001 10.9524C20.0001 8.05957 17.7095 5.71436 14.8838 5.71436C12.0582 5.71436 9.76758 8.05957 9.76758 10.9524C9.76758 13.8453 12.0582 16.1906 14.8838 16.1906Z",
                        fill: "#1A9BA1"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M10.93 20C13.1135 20 14.8835 18.1879 14.8835 15.9524C14.8835 13.717 13.1135 11.9048 10.93 11.9048C8.74654 11.9048 6.97656 13.717 6.97656 15.9524C6.97656 18.1879 8.74654 20 10.93 20Z",
                        fill: "#37C6D0"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        opacity: "0.1",
                        d: "M11.1628 5.15708V15.3189C11.1605 15.6721 10.9515 15.9893 10.6327 16.1237C10.531 16.1677 10.4219 16.1904 10.3117 16.1904H6.98145C6.9768 16.1094 6.9768 16.0333 6.9768 15.9523C6.97525 15.8728 6.97835 15.7933 6.9861 15.7142C7.07124 14.1921 7.98717 12.8491 9.35355 12.2428V11.3571C6.31257 10.8637 4.23802 7.93981 4.71991 4.82647C4.72326 4.80491 4.72671 4.78336 4.7303 4.76183C4.75345 4.60124 4.78607 4.44222 4.82797 4.28564H10.3117C10.781 4.28748 11.161 4.67657 11.1628 5.15708Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        opacity: "0.2",
                        d: "M9.84662 4.76196H4.73038C4.21355 7.86969 6.25531 10.8181 9.29075 11.3472C9.38275 11.3632 9.475 11.3768 9.56762 11.3882C8.12575 12.0882 7.07503 14.0763 6.98573 15.7143C6.97798 15.7934 6.97488 15.8729 6.97642 15.9524C6.97642 16.0334 6.97642 16.1096 6.98107 16.1906C6.98946 16.3506 7.00968 16.5098 7.04153 16.6667H9.84625C10.1911 16.6643 10.5009 16.4504 10.6322 16.1238C10.6751 16.0199 10.6974 15.9082 10.6974 15.7953V5.6334C10.6956 5.15306 10.3159 4.76406 9.84662 4.76196Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        opacity: "0.2",
                        d: "M9.84662 4.76196H4.73035C4.21361 7.87006 6.25568 10.8184 9.29149 11.3476C9.35362 11.3583 9.41587 11.3681 9.47825 11.3767C8.08287 12.1272 7.07361 14.1106 6.98616 15.7143H9.84662C10.3152 15.7107 10.6942 15.3227 10.6977 14.8429V5.6334C10.696 5.15289 10.316 4.7638 9.84662 4.76196Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        opacity: "0.2",
                        d: "M9.38134 4.76196H4.73019C4.24225 7.69606 6.03799 10.5216 8.85572 11.2534C7.78884 12.5014 7.13442 14.0628 6.986 15.7143H9.38134C9.85072 15.7126 10.2307 15.3234 10.2325 14.8429V5.6334C10.2322 5.15224 9.85134 4.76224 9.38134 4.76196Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M0.852563 4.76196H9.38C9.85087 4.76196 10.2325 5.15276 10.2325 5.63483V14.3653C10.2325 14.8473 9.85087 15.2382 9.38 15.2382H0.852563C0.3817 15.2382 0 14.8473 0 14.3653V5.63483C0 5.15276 0.3817 4.76196 0.852563 4.76196Z",
                        fill: "#04868B"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M3.80825 9.89327C3.60846 9.75752 3.44157 9.57689 3.32035 9.36514C3.20289 9.14377 3.14433 8.89464 3.15057 8.64277C3.14011 8.30177 3.25251 7.96864 3.46639 7.70702C3.69112 7.44504 3.98162 7.25104 4.30638 7.14607C4.67651 7.02134 5.06418 6.95988 5.45382 6.96417C5.96621 6.94499 6.4779 7.01834 6.96545 7.18083V8.27602C6.75361 8.14464 6.52287 8.04827 6.28172 7.99039C6.02007 7.92464 5.7516 7.89177 5.48218 7.89227C5.1981 7.88164 4.91582 7.94277 4.66034 8.07039C4.46307 8.15752 4.33516 8.35614 4.33475 8.57602C4.33395 8.70952 4.38401 8.83802 4.47429 8.93414C4.58091 9.04764 4.70705 9.13989 4.84638 9.20652C5.00142 9.28564 5.23397 9.39064 5.54406 9.52177C5.5782 9.53289 5.61147 9.54652 5.64358 9.56277C5.94877 9.68489 6.24317 9.83352 6.5236 10.007C6.73595 10.1411 6.91417 10.3249 7.0436 10.5433C7.17628 10.7908 7.2406 11.0706 7.22963 11.3528C7.24478 11.7029 7.14016 12.0474 6.93382 12.327C6.72816 12.5841 6.45319 12.7735 6.14312 12.8718C5.77844 12.9888 5.39781 13.0454 5.01569 13.0394C4.67282 13.041 4.33047 13.0124 3.99242 12.9536C3.707 12.9059 3.42845 12.822 3.16314 12.7041V11.5494C3.41675 11.7349 3.70007 11.8734 4.00033 11.9589C4.29958 12.0544 4.61066 12.1054 4.92406 12.1104C5.21412 12.1291 5.50367 12.0663 5.76127 11.9285C5.94172 11.8243 6.05147 11.6268 6.04686 11.4146C6.04806 11.2671 5.99103 11.1253 5.88872 11.0213C5.76147 10.8934 5.61415 10.7883 5.45291 10.7104C5.26686 10.6151 4.99291 10.4895 4.63105 10.3336C4.34317 10.2153 4.06755 10.0676 3.80825 9.89327Z",
                        fill: "white"
                    })
                ]
            })
        ]
    });
/**
 * __MicrosoftSharepointIcon__
 */ const $8202f9e7d9f2e622$var$MicrosoftSharepointIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $8202f9e7d9f2e622$var$MicrosoftSharepointIconGlyph
    });
var $8202f9e7d9f2e622$export$2e2bcd8739ae039 = $8202f9e7d9f2e622$var$MicrosoftSharepointIcon;

});

parcelRegister("ji7Zl", function(module, exports) {

$parcel$export(module.exports, "default", () => $738cb4e402830970$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $738cb4e402830970$var$SlackIconAiMateGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                clipPath: "url(#clip0_271_181639)",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M9.33321 2C8.22767 2.00082 7.33294 2.89621 7.33375 3.99954C7.33294 5.10288 8.22849 5.99827 9.33403 5.99909H11.3343V4.00036C11.3351 2.89702 10.4396 2.00163 9.33321 2C9.33403 2 9.33403 2 9.33321 2V2ZM9.33321 7.33321H4.00077C2.89522 7.33402 1.99967 8.22941 2.00049 9.33275C1.99886 10.4361 2.89441 11.3315 3.99995 11.3331H9.33321C10.4388 11.3323 11.3343 10.4369 11.3335 9.33357C11.3343 8.22941 10.4388 7.33402 9.33321 7.33321V7.33321Z",
                        fill: "#36C5F0"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M21.9998 9.33275C22.0006 8.22941 21.1051 7.33402 19.9995 7.33321C18.894 7.33402 17.9984 8.22941 17.9992 9.33275V11.3331H19.9995C21.1051 11.3323 22.0006 10.4369 21.9998 9.33275ZM16.6665 9.33275V3.99954C16.6673 2.89702 15.7726 2.00163 14.667 2C13.5615 2.00082 12.6659 2.89621 12.6668 3.99954V9.33275C12.6651 10.4361 13.5607 11.3315 14.6662 11.3331C15.7718 11.3323 16.6673 10.4369 16.6665 9.33275Z",
                        fill: "#2EB67D"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M14.6665 21.9995C15.7721 21.9987 16.6677 21.1033 16.6668 19.9999C16.6677 18.8966 15.7721 18.0012 14.6665 18.0004H12.6663V19.9999C12.6654 21.1025 13.561 21.9979 14.6665 21.9995ZM14.6665 16.6654H19.9998C21.1054 16.6646 22.0009 15.7692 22.0001 14.6659C22.0018 13.5626 21.1062 12.6672 20.0006 12.6655H14.6674C13.5618 12.6663 12.6663 13.5617 12.6671 14.6651C12.6663 15.7692 13.561 16.6646 14.6665 16.6654V16.6654Z",
                        fill: "#ECB22E"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M2.00073 14.6663C1.99992 15.7696 2.89547 16.665 4.00102 16.6659C5.10657 16.665 6.00212 15.7696 6.0013 14.6663V12.6667H4.00102C2.89547 12.6676 1.99992 13.563 2.00073 14.6663ZM7.33401 14.6663V19.9995C7.33237 21.1029 8.22792 21.9983 9.33347 21.9999C10.439 21.9991 11.3346 21.1037 11.3338 20.0003V14.6679C11.3354 13.5646 10.4398 12.6692 9.33429 12.6676C8.22792 12.6676 7.33319 13.563 7.33401 14.6663C7.33401 14.6671 7.33401 14.6663 7.33401 14.6663Z",
                        fill: "#E01E5A"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("defs", {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                    id: "clip0_271_181639",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        transform: "translate(2 2)"
                    })
                })
            })
        ]
    });
/**
 * __SlackIconAiMate__
 */ const $738cb4e402830970$var$SlackIconAiMate = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $738cb4e402830970$var$SlackIconAiMateGlyph
    });
var $738cb4e402830970$export$2e2bcd8739ae039 = $738cb4e402830970$var$SlackIconAiMate;

});


parcelRegister("f1tAG", function(module, exports) {

$parcel$export(module.exports, "getAtlasHost", () => $bb7d427d2d55585d$export$5105758c0e772381);
$parcel$export(module.exports, "getAtlasURL", () => $bb7d427d2d55585d$export$bfee0f88bf621ad3);

var $9oBwb = parcelRequire("9oBwb");
const $bb7d427d2d55585d$var$ATLAS_PROD_URL = 'https://home.atlassian.com';
const $bb7d427d2d55585d$var$ATLAS_STAGING_URL = 'https://home.stg.atlassian.com';
const $bb7d427d2d55585d$export$5105758c0e772381 = ()=>{
    const host = window.location.host;
    const isStaging = host.includes('localhost') || host.includes('.stg.atlassian') || host.includes('.stg-east.frontend.public.atl-paas.net') || host.includes('jira-dev.com');
    return isStaging ? $bb7d427d2d55585d$var$ATLAS_STAGING_URL : $bb7d427d2d55585d$var$ATLAS_PROD_URL;
};
const $bb7d427d2d55585d$export$bfee0f88bf621ad3 = (siteId, path, orgId)=>{
    let argConcat = '?';
    let processedPath = path.startsWith('/') ? path : `/${path}`;
    if (processedPath.includes('?')) argConcat = '&';
    const basePath = orgId ? `${$bb7d427d2d55585d$export$5105758c0e772381()}/o/${orgId}` : $bb7d427d2d55585d$export$5105758c0e772381();
    return (0, $9oBwb.addRovoParamsToUrl)(`${basePath}${processedPath}${argConcat}cloudId=${siteId}`, {
        cloudId: siteId
    });
};

});

parcelRegister("1e6hD", function(module, exports) {

$parcel$export(module.exports, "useKnowledgeConnectors", () => $30bef7cfac4334a4$export$88014f3d16427d4b);

var $5uXOq = parcelRequire("5uXOq");

var $91cKc = parcelRequire("91cKc");

var $cK3Jm = parcelRequire("cK3Jm");
var $4ojTZ = parcelRequire("4ojTZ");
const $30bef7cfac4334a4$export$88014f3d16427d4b = (0, $cK3Jm.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker }, enabled: enabled = true })=>{
    const connectorsQuery = (0, $4ojTZ.useQuery)({
        queryKey: [
            'getKnowledgeConnectors'
        ],
        queryFn: async ()=>{
            experienceTracker.start({
                id: (0, $91cKc.ExperienceName).FETCH_CONNECTED_KNOWLEDGE_SOURCES,
                name: (0, $91cKc.ExperienceName).FETCH_CONNECTED_KNOWLEDGE_SOURCES
            });
            return assistanceService.getAgentKnowledgeConfiguration();
        },
        onSuccess: ()=>{
            experienceTracker.succeed({
                name: (0, $91cKc.ExperienceName).FETCH_CONNECTED_KNOWLEDGE_SOURCES
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $91cKc.ExperienceName).FETCH_CONNECTED_KNOWLEDGE_SOURCES,
                error: error
            });
        },
        enabled: enabled
    });
    const isConnectorEnabled = (0, $5uXOq.useCallback)((type)=>{
        return connectorsQuery.data?.knowledgeSources?.some((value)=>value.source === type) ?? false;
    }, [
        connectorsQuery.data
    ]);
    const enabledKnowledgeSources = (0, $5uXOq.useMemo)(()=>{
        return connectorsQuery.data?.knowledgeSources ?? [];
    }, [
        connectorsQuery.data
    ]);
    return {
        enabledKnowledgeSources: enabledKnowledgeSources,
        isConnectorEnabled: isConnectorEnabled
    };
});

});


parcelRegister("19iJP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca6ebb19826b4cb1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $fuLGr = parcelRequire("fuLGr");
var $c5gm9 = parcelRequire("c5gm9");

var $bXooK = parcelRequire("bXooK");
function $ca6ebb19826b4cb1$export$1064229c13822d9f(props) {
    const [{ orgId: orgId }] = (0, $c5gm9.useOrg)();
    return orgId ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bXooK.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($ca6ebb19826b4cb1$var$ProfileAboutTeamsSpinnerWrapper, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fuLGr.default), {
            size: 'small'
        })
    });
}
var $ca6ebb19826b4cb1$export$2e2bcd8739ae039 = $ca6ebb19826b4cb1$export$1064229c13822d9f;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ca6ebb19826b4cb1$var$ProfileAboutTeamsSpinnerWrapper = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-17jr9k9-0"
})`display:flex;justify-content:center;align-items:center;`;

});
parcelRegister("fuLGr", function(module, exports) {

$parcel$export(module.exports, "default", () => $febac4e5de7fb6a9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eZJjh = parcelRequire("eZJjh");

var $bbYpp = parcelRequire("bbYpp");
const $febac4e5de7fb6a9$var$Spinner = ({ wrapperHeight: wrapperHeight, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)($bbYpp.SpinnerWrapper, {
        height: wrapperHeight,
        "data-test-selector": "spinner",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
            ...props
        })
    });
var $febac4e5de7fb6a9$export$2e2bcd8739ae039 = $febac4e5de7fb6a9$var$Spinner;

});
parcelRegister("bbYpp", function(module, exports) {

$parcel$export(module.exports, "SpinnerWrapper", () => $cdc48abed99e8bc6$export$52b4dfd89a6b3a1b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");
const $cdc48abed99e8bc6$var$getHeight = ({ height: height })=>{
    if (typeof height === 'number') return `${height}px`;
    return height;
};
const $cdc48abed99e8bc6$export$52b4dfd89a6b3a1b = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1umpdm7-0"
})`display:flex;justify-content:center;align-items:center;margin:${"var(--ds-space-200, 16px)"} 0;height:${$cdc48abed99e8bc6$var$getHeight};`;

});


parcelRegister("bXooK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f220f86d100751c4$export$2e2bcd8739ae039);
/* ProfileAboutTeams.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $ousew = parcelRequire("ousew");

var $fVnbM = parcelRequire("fVnbM");

var $eCeGD = parcelRequire("eCeGD");

var $dD7Zc = parcelRequire("dD7Zc");

var $VSDnB = parcelRequire("VSDnB");


var $fyzT1 = parcelRequire("fyzT1");
var $jDqI3 = parcelRequire("jDqI3");
var $eZEvj = parcelRequire("eZEvj");
var $fuLGr = parcelRequire("fuLGr");
var $38ra6 = parcelRequire("38ra6");
var $lHKVj = parcelRequire("lHKVj");
var $fff3y = parcelRequire("fff3y");
var $bA8uW = parcelRequire("bA8uW");

var $1Wq3n = parcelRequire("1Wq3n");

var $1tSRh = parcelRequire("1tSRh");

var $63MVP = parcelRequire("63MVP");

var $4V0ms = parcelRequire("4V0ms");

var $3m1cZ = parcelRequire("3m1cZ");

var $bGUXq = parcelRequire("bGUXq");
const $f220f86d100751c4$var$styles = {
    skeletonList: "_bozgze3t _y4tize3t"
};
const $f220f86d100751c4$export$4a2947f47d583741 = 10;
const $f220f86d100751c4$export$b827413854913969 = 30;
function $f220f86d100751c4$export$2697725d6b507e8c(props) {
    const analytics = (0, $38ra6.default)();
    const [enableInfiniteScroll, setEnableInfiniteScroll] = (0, $5uXOq.useState)(false);
    const [showLess, setShowLess] = (0, $5uXOq.useState)(true);
    const [{ hasLoaded: hasUserDataLoaded, principalUserId: currentUserId }] = (0, $fff3y.usePrincipalUser)();
    const { isLoading: isTeamSearchLoading, teams: teamSearchTeams, error: error, loadMore: loadMore, hasMore: hasMore } = (0, $1Wq3n.useTeamSearchQuery)({
        first: $f220f86d100751c4$export$4a2947f47d583741 + 1,
        // +1 to make sure it has more than 10 teams
        batchSize: $f220f86d100751c4$export$b827413854913969,
        memberIds: [
            props.userId
        ]
    });
    // don't need to trigger start event here because it's already triggered in `NeedBrowseUsersPerm`
    (0, $lHKVj.useExpTrackerStop)({
        name: (0, $bA8uW.UserExperienceNames).USER_PROFILE_USERS_TEAMS,
        error: error
    });
    const createProposedMember = (0, $5uXOq.useCallback)(()=>props.userFullName ? [
            {
                id: props.userId,
                value: props.userId,
                label: props.userFullName,
                avatarUrl: props.userAvatarUrl,
                type: 'user'
            }
        ] : [], [
        props.userAvatarUrl,
        props.userFullName,
        props.userId
    ]);
    const handleTeamItemClick = (0, $5uXOq.useCallback)((e, index)=>{
        analytics.pushUIEvent({
            source: (0, $fyzT1.AnalyticsEventSource)[props.analyticsSource] || (0, $fyzT1.AnalyticsEventSource).USER_PROFILE_SCREEN,
            action: (0, $fyzT1.AnalyticsEventActions).CLICKED,
            actionSubject: 'teamProfileItem',
            attributes: {
                position: index
            }
        });
    }, [
        analytics,
        props.analyticsSource
    ]);
    const isCurrentUser = ()=>currentUserId === props.userId;
    // loading --> skeleton and do not render ExperienceSuccess
    // not loading + empty data + viewing others profile --> rendering nothing and ExperienceSuccess
    // not loading + has error --> rendering nothing and "useExpTrackerStop" will trigger the stop experience event.
    // not loading + has data --> render UI and ExperienceSuccess
    const hasNoData = !teamSearchTeams;
    if (hasNoData) return null;
    if (error) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $63MVP.AboutSectionTitle), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...$f220f86d100751c4$export$defe85febe8b728c.teamSectionTitle
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)($bGUXq.ErrorContainer, {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)($bGUXq.ErrorIconWrapper, {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
                            LEGACY_size: "medium",
                            spacing: "spacious",
                            color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`,
                            label: $f220f86d100751c4$export$defe85febe8b728c.errorStateTitle.defaultMessage
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)($bGUXq.ErrorMessageWrapper, {
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)($bGUXq.ErrorTitle, {
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                    ...$f220f86d100751c4$export$defe85febe8b728c.errorStateTitle
                                })
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)($bGUXq.ErrorMessage, {
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                    ...$f220f86d100751c4$export$defe85febe8b728c.errorStateMessage
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
    const onShowMoreButtonClick = ()=>{
        analytics.pushUIEvent({
            source: (0, $fyzT1.AnalyticsEventSource).USER_PROFILE_SCREEN,
            actionSubject: 'showMore',
            action: (0, $fyzT1.AnalyticsEventActions).CLICKED
        });
        setEnableInfiniteScroll(true);
        setShowLess(false);
    };
    const collapseTeamList = ()=>{
        if (!enableInfiniteScroll) setEnableInfiniteScroll(true);
        setShowLess(!showLess);
    };
    const teamList = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1tSRh.default), {
        loadMore: loadMore,
        hasMore: hasMore && enableInfiniteScroll,
        loader: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fuLGr.default), {}),
        isLoading: isTeamSearchLoading,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                showLess ? teamSearchTeams.slice(0, $f220f86d100751c4$export$4a2947f47d583741).map((team, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $4V0ms.default), {
                        team: team,
                        isCurrentUser: isCurrentUser(),
                        index: index,
                        onClick: handleTeamItemClick
                    }, team.id)) : teamSearchTeams.map((team, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $4V0ms.default), {
                        team: team,
                        isCurrentUser: isCurrentUser(),
                        index: index,
                        onClick: handleTeamItemClick
                    }, team.id)),
                !enableInfiniteScroll && teamSearchTeams.length > $f220f86d100751c4$export$4a2947f47d583741 && (hasMore || !hasMore && showLess) && /*#__PURE__*/ (0, $2OMIu.jsx)($bGUXq.ShowMoreButton, {
                    children: (0, $VSDnB.fg)('ptc_migrate_buttons') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                        onClick: onShowMoreButtonClick,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...$f220f86d100751c4$export$defe85febe8b728c.showMore
                        })
                    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                        appearance: "link",
                        spacing: "none",
                        onClick: onShowMoreButtonClick,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...$f220f86d100751c4$export$defe85febe8b728c.showMore
                        })
                    })
                }),
                enableInfiniteScroll && !hasMore && /*#__PURE__*/ (0, $2OMIu.jsx)($bGUXq.ShowMoreButton, {
                    children: (0, $VSDnB.fg)('ptc_migrate_buttons') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                        onClick: collapseTeamList,
                        children: showLess ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...$f220f86d100751c4$export$defe85febe8b728c.showMore
                        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...$f220f86d100751c4$export$defe85febe8b728c.showLess
                        })
                    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                        appearance: "link",
                        spacing: "none",
                        onClick: collapseTeamList,
                        children: showLess ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...$f220f86d100751c4$export$defe85febe8b728c.showMore
                        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...$f220f86d100751c4$export$defe85febe8b728c.showLess
                        })
                    })
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $63MVP.AboutSectionTitle), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...$f220f86d100751c4$export$defe85febe8b728c.teamSectionTitle
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)($bGUXq.AboutTeamsList, {
                children: [
                    hasUserDataLoaded && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3m1cZ.default), {
                        source: "teamsList",
                        isCurrentUser: isCurrentUser(),
                        proposedMembers: isCurrentUser() ? [] : createProposedMember(),
                        isActiveUser: props.isActiveUser
                    }),
                    isTeamSearchLoading ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZEvj.default), {
                        hasAvatar: true,
                        isShimmering: true,
                        itemCount: 3,
                        xcss: $f220f86d100751c4$var$styles.skeletonList
                    }) : teamList
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jDqI3.ExperienceSuccess), {
                hasLoaded: !isTeamSearchLoading && !error,
                name: (0, $bA8uW.UserExperienceNames).USER_PROFILE_USERS_TEAMS
            })
        ]
    });
}
const $f220f86d100751c4$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    teamSectionTitle: {
        id: 'ptc-directory.user-profile-page.about.teams.heading',
        defaultMessage: 'Teams',
        description: 'Heading for the teams that user is a member of'
    },
    showMore: {
        id: 'ptc-directory.user-profile-page.about.teams.show.more.button',
        defaultMessage: 'Show more',
        description: 'Text for the show more button'
    },
    showLess: {
        id: 'ptc-directory.user-profile-page.about.teams.show.less.button',
        defaultMessage: 'Show less',
        description: 'Text for the show less button'
    },
    errorStateTitle: {
        id: 'ptc-directory.user-profile-page.about.teams.error.title',
        defaultMessage: 'Something went wrong',
        description: 'Error title for when teams fail to load'
    },
    errorStateMessage: {
        id: 'ptc-directory.user-profile-page.about.teams.error.message',
        defaultMessage: 'Refresh the page or try again later',
        description: 'Error instruction for when teams fail to load'
    }
});
var $f220f86d100751c4$export$2e2bcd8739ae039 = $f220f86d100751c4$export$2697725d6b507e8c;

});
parcelRegister("1Wq3n", function(module, exports) {

$parcel$export(module.exports, "useTeamSearchQuery", () => $ca998ca0ff1fba59$export$209c3a9213f9e947);

var $5uXOq = parcelRequire("5uXOq");

var $9C6JH = parcelRequire("9C6JH");

var $gqOOy = parcelRequire("gqOOy");
var $5WmsO = parcelRequire("5WmsO");
var $5hWov = parcelRequire("5hWov");
var $levfe = parcelRequire("levfe");

var $jCvwN = parcelRequire("jCvwN");

var $IZxaE = parcelRequire("IZxaE");

var $cBElP = parcelRequire("cBElP");

var $7YTpJ = parcelRequire("7YTpJ");
const $ca998ca0ff1fba59$var$excludeKnownGraphQLErrors = (error)=>{
    if (error.message?.includes('User does not have access to the org') || error.graphQLErrors?.some((e)=>e.extensions?.statusCode === 403)) // Escapes from this error as discussed in https://atlassian.slack.com/archives/C04939SL1J5/p1675215336793559
    return undefined;
    else if (error.graphQLErrors) {
        const filteredError = {
            ...error,
            // TODO PR Question - Is duplicating an error via spreading OK? (Not really an "Error" after that)
            graphQLErrors: (0, $7YTpJ.filterExcludedMessages)(error.graphQLErrors)
        };
        // If there's no actual errors left, then discard the error object
        const noErrorsLeft = filteredError.networkError == null && filteredError.graphQLErrors.length === 0;
        return noErrorsLeft ? undefined : filteredError;
    }
    return error;
};
function $ca998ca0ff1fba59$var$orgIdWithARI(orgId) {
    return orgId?.startsWith((0, $7YTpJ.ORG_ARI_PREFIX)) ? orgId : `${0, $7YTpJ.ORG_ARI_PREFIX}${orgId}`;
}
const $ca998ca0ff1fba59$export$209c3a9213f9e947 = (props)=>{
    const { cursor: cursor, first: first, memberIds: memberIds, query: query, batchSize: batchSize, skip: providedSkip } = props;
    const { orgId: orgId } = (0, $levfe.useV3OrgIdStatus)();
    const [exitedTeams] = (0, $gqOOy.useExitedTeams)();
    const { isLoading: isTeamsVisibilityLoading, permissions: { canViewTeams: canViewTeams } } = (0, $5hWov.useTeamVisibility)();
    const [{ cloudId: cloudId }] = (0, $5WmsO.useSite)();
    const { data: data, loading: loading, error: error, fetchMore: fetchMore } = (0, $9C6JH.useQueryLight)((0, $IZxaE.default), {
        customHeaders: {
            'X-ExperimentalApi': 'team-members-beta',
            'atl-client-name': "platform-pkg",
            'atl-client-version': "0.0.0-use.local"
        },
        operationName: 'TeamSearchV2',
        serviceUrl: `${(0, $jCvwN.getConfig)().stargateRoot}/graphql`,
        variables: {
            first: first,
            memberIds: memberIds,
            query: query,
            organizationId: $ca998ca0ff1fba59$var$orgIdWithARI(orgId),
            after: cursor,
            sortBy: query ? null : (0, $cBElP.sortBy),
            siteId: cloudId,
            showEmptyTeams: true
        },
        skip: providedSkip || !orgId || /**
     * Don't make the call when
     * 1. the permissions are currently loading
     * 2. the permissions have loaded but the user doesn't have permission to view teams
     */ !canViewTeams || isTeamsVisibilityLoading
    });
    const filteredError = error && $ca998ca0ff1fba59$var$excludeKnownGraphQLErrors(error);
    const formattedTeams = (0, $5uXOq.useMemo)(()=>{
        if (!data?.team || filteredError) // GraphQL queries can have a partial failure, where some data is returned
        // but not all of it. By default, Apollo will discard any partial data if
        // there's an error:
        // https://www.apollographql.com/docs/react/data/error-handling/#partial-data-with-resolver-errors
        //
        // In PTC-6588, we wanted to be able to support partial data for the case
        // where a team has been deleted, so we set the error policy to 'all'.
        // Otherwise, the whole page fails to load because of one bad team.
        // However, most of the app wasn't written to handle partial data, so if
        // there are any errors, we return nothing.
        return [];
        return (0, $7YTpJ.fromV2ToTeamSearchViewFormat)(data.team?.teamSearch?.nodes || []);
    }, [
        data,
        filteredError
    ]);
    const loadMore = ()=>{
        fetchMore({
            variables: {
                after: data?.team?.teamSearch?.pageInfo?.endCursor,
                first: batchSize || first
            },
            handleDataMerge: (prevResult, fetchMoreResult)=>{
                if (!fetchMoreResult) return prevResult;
                const prevTeams = prevResult?.team?.teamSearch?.nodes || [];
                const newTeams = fetchMoreResult?.team?.teamSearch?.nodes || [];
                return {
                    ...fetchMoreResult,
                    team: {
                        ...fetchMoreResult.team,
                        teamSearch: {
                            ...fetchMoreResult.team?.teamSearch,
                            nodes: [
                                ...prevTeams,
                                ...newTeams
                            ]
                        }
                    }
                };
            }
        });
    };
    const filteredTeams = (0, $5uXOq.useMemo)(()=>formattedTeams.filter((team)=>!exitedTeams.has(team.id)), [
        formattedTeams,
        exitedTeams
    ]);
    return {
        isLoading: loading,
        teams: filteredTeams,
        error: filteredError,
        loadMore: loadMore,
        hasMore: !!data?.team?.teamSearch?.pageInfo?.hasNextPage
    };
};

});
parcelRegister("9C6JH", function(module, exports) {

$parcel$export(module.exports, "useQueryLight", () => $45b243a28c63fa91$export$153654f6c7880a35);
$parcel$export(module.exports, "useLazyQueryLight", () => $45b243a28c63fa91$export$3309ae9fea8ae473);

var $5uXOq = parcelRequire("5uXOq");

var $1c8Um = parcelRequire("1c8Um");

var $ajpes = parcelRequire("ajpes");

var $4F5SC = parcelRequire("4F5SC");

var $6laLp = parcelRequire("6laLp");

var $iknOf = parcelRequire("iknOf");
const $45b243a28c63fa91$var$transformError = ({ error: error, graphQLErrors: graphQLErrors })=>{
    const reducedGraphqlErrorMessage = graphQLErrors && graphQLErrors.reduce((acc, gqlError)=>acc + (acc ? '\n' : '') + (gqlError.message ? gqlError.message : ''), '');
    const reducedGraphqlErrorName = graphQLErrors && graphQLErrors.reduce((acc, gqlError)=>acc + (acc ? '\n' : '') + (gqlError.name ? gqlError.name : ''), '');
    return new (0, $iknOf.UseQueryLightError)(// Network error would lead to no graphqlErrors as the query would not be fired. Hence at the front.
    error?.message || reducedGraphqlErrorMessage || 'Unknown error', error?.name || reducedGraphqlErrorName, // graphQLErrors in Apollo error is empty array when there is no error.
    // So we follow the same to make sure error handlers are working as expected.
    graphQLErrors || [], error);
};
const $45b243a28c63fa91$export$153654f6c7880a35 = (query, options)=>{
    const [loading, setLoading] = (0, $5uXOq.useState)(true);
    const [error, setError] = (0, $5uXOq.useState)(undefined);
    const [data, setData] = (0, $5uXOq.useState)(undefined);
    const variablesRef = (0, $5uXOq.useRef)(options.variables);
    // Need this to deep compare variables to avoid infinite loops in useEffect
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(variablesRef.current, options.variables)) variablesRef.current = options.variables;
    // Initial fetch, and refetch
    const fetchData = (0, $5uXOq.useCallback)(async ()=>{
        try {
            setLoading(true);
            const response = await (0, $4F5SC.fetchWithExponentialBackoff)(`${options.serviceUrl}?q=${options.operationName}`, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    ...options.customHeaders
                }),
                credentials: 'include',
                body: JSON.stringify({
                    query: (0, $1c8Um.print)(query),
                    variables: {
                        ...variablesRef.current
                    }
                })
            });
            const responseData = await response.json();
            if (response.ok) {
                if (responseData.errors) setError($45b243a28c63fa91$var$transformError({
                    graphQLErrors: responseData.errors
                }));
                setData(responseData.data);
                setLoading(false);
            } else throw new Error(`Generic fetch error within useQueryLight, status ${response.status}`);
        } catch (error) {
            if (error instanceof Error) setError($45b243a28c63fa91$var$transformError({
                error: error
            }));
            else {
                setError($45b243a28c63fa91$var$transformError({
                    error: new Error('Unknown error')
                }));
                (0, $6laLp.logException)(error, `useQueryLight - ${options.operationName}`);
            }
            setData(undefined);
            setLoading(false);
        }
    }, [
        query,
        options.serviceUrl,
        options.operationName,
        options.customHeaders
    ]);
    // Fetch more
    const fetchMore = (0, $5uXOq.useCallback)(async ({ variables: variables, handleDataMerge: handleDataMerge })=>{
        try {
            // reset errors to catch new ones
            setError(undefined);
            const response = await (0, $4F5SC.fetchWithExponentialBackoff)(`${options.serviceUrl}?q=${options.operationName}`, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    ...options.customHeaders
                }),
                credentials: 'include',
                body: JSON.stringify({
                    query: (0, $1c8Um.print)(query),
                    variables: {
                        ...variablesRef.current,
                        ...variables
                    }
                })
            });
            const responseData = await response.json();
            if (response.ok) {
                if (responseData.errors) setError($45b243a28c63fa91$var$transformError({
                    graphQLErrors: responseData.errors
                }));
                setData((prevData)=>handleDataMerge(prevData, responseData.data));
            } else throw new Error(`Generic fetch error within useQueryLight, status ${response.status}`);
        } catch (error) {
            if (error instanceof Error) setError($45b243a28c63fa91$var$transformError({
                error: error
            }));
            else {
                setError($45b243a28c63fa91$var$transformError({
                    error: new Error('Unknown error')
                }));
                (0, $6laLp.logException)(error, `useQueryLight fetchMore - ${options.operationName}`);
            }
        }
    }, [
        query,
        options.serviceUrl,
        options.operationName,
        options.customHeaders
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!options.skip) fetchData();
        else setLoading(false);
    }, [
        options.skip,
        variablesRef.current
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return {
        loading: loading,
        error: error,
        data: data,
        refetch: fetchData,
        fetchMore: fetchMore
    };
};
const $45b243a28c63fa91$export$3309ae9fea8ae473 = (query, options)=>{
    const [fetchTriggered, setFetchTriggered] = (0, $5uXOq.useState)(false);
    const { loading: loading, error: error, data: data, refetch: refetch, fetchMore: fetchMore } = $45b243a28c63fa91$export$153654f6c7880a35(query, {
        ...options,
        skip: !fetchTriggered
    });
    const triggerFetch = (0, $5uXOq.useCallback)(()=>{
        setFetchTriggered(true);
    }, []);
    return [
        triggerFetch,
        {
            loading: loading,
            error: error,
            data: data,
            refetch: refetch,
            fetchMore: fetchMore
        }
    ];
};

});

parcelRegister("gqOOy", function(module, exports) {

$parcel$export(module.exports, "useTeamProfileDataState", () => $541492975b2c7e18$export$1983fe04e6d15665);
$parcel$export(module.exports, "useTeamMembersState", () => $541492975b2c7e18$export$c90591c2030bee);
$parcel$export(module.exports, "useMyMembership", () => $541492975b2c7e18$export$7d96b11823e54583);
$parcel$export(module.exports, "useExitedTeams", () => $541492975b2c7e18$export$d85ae427dffd7a31);
$parcel$export(module.exports, "useTeamAgentsState", () => $541492975b2c7e18$export$80fb38915e92c27f);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $dmOdc = parcelRequire("dmOdc");

var $aatv6 = parcelRequire("aatv6");
var $66abk = parcelRequire("66abk");
var $bGzDE = parcelRequire("bGzDE");
var $4m5re = parcelRequire("4m5re");
var $4TUdO = parcelRequire("4TUdO");
var $17Odl = parcelRequire("17Odl");
var $jDX6f = parcelRequire("jDX6f");
var $3n2JP = parcelRequire("3n2JP");
var $89d9t = parcelRequire("89d9t");
var $fscon = parcelRequire("fscon");
var $j3TB6 = parcelRequire("j3TB6");

var $lwEMT = parcelRequire("lwEMT");
const $541492975b2c7e18$var$initialState = {
    teamProfile: {
        teamId: '',
        isLoading: true,
        hasLoaded: false,
        errorType: null,
        data: {}
    },
    teamMembers: {
        teamId: '',
        isLoading: true,
        isLoadingNextPage: false,
        hasLoaded: false,
        hasError: false,
        errorType: null,
        members: [],
        requestingToJoinUsers: [],
        membersPageInfo: {
            hasNextPage: false,
            cursor: null
        },
        requestingToJoinUsersPageInfo: {
            hasNextPage: false,
            cursor: null
        }
    },
    teamAgents: {
        teamId: '',
        isLoading: true,
        isLoadingNextPage: false,
        hasLoaded: false,
        hasError: false,
        errorType: null,
        members: []
    },
    myTeamMembership: {
        teamId: '',
        hasLoaded: false,
        membership: undefined
    },
    exitedTeams: new Set(),
    allTeamsData: {
        teams: [],
        isLoading: true,
        hasError: false,
        cursor: ''
    }
};
const $541492975b2c7e18$var$actions = {
    /**
	 * @deprecated set the config on the teamsClient using useTeamsClientSetup
	 */ setTeamClientRootUrl: (rootUrl)=>()=>{
            (0, $dmOdc.teamsClient).setLegionRootUrl(rootUrl);
        },
    collectTeamData: (teamId, forceRefresh)=>async ({ dispatch: dispatch, getState: getState })=>{
            // If we already have the team's data, do not collect it again
            if (!forceRefresh && getState().teamProfile.teamId === teamId) return;
            await Promise.all([
                dispatch((0, $17Odl.getTeamProfile)(teamId)),
                dispatch((0, $4m5re.getMyTeamMembership)(teamId)),
                dispatch((0, $4TUdO.getTeamMembers)(teamId))
            ]);
            dispatch((0, $bGzDE.getRequestingToJoinUsers)(teamId));
        },
    restoreTeam: (teamId, options)=>async ({ dispatch: dispatch })=>{
            await (0, $dmOdc.teamsClient).restoreTeam(teamId);
            if (options?.fetchTeamData) await Promise.all([
                dispatch((0, $17Odl.getTeamProfile)(teamId)),
                dispatch((0, $4m5re.getMyTeamMembership)(teamId)),
                dispatch((0, $4TUdO.getTeamMembers)(teamId))
            ]);
        },
    fetchTeamMembersNextPage: (teamId, count = 100)=>async ({ dispatch: dispatch, getState: getState })=>{
            if (!getState().teamMembers.membersPageInfo.hasNextPage) return;
            await dispatch((0, $4TUdO.getTeamMembers)(teamId, true, count));
        },
    refreshRequestingToJoinUsers: (teamId)=>async ({ dispatch: dispatch, getState: getState })=>{
            // Check that we're refreshing data for the current team
            if (getState().teamProfile.teamId !== teamId) return [];
            return await dispatch((0, $bGzDE.getRequestingToJoinUsers)(teamId));
        },
    prefillTeamData: $89d9t.prefillTeamData,
    updateTeamProfile: (teamId, data)=>async ({ dispatch: dispatch, getState: getState, setState: setState })=>{
            const isTransitioningToOpen = data.membershipSettings === 'OPEN' && getState().teamProfile.data.membershipSettings === 'MEMBER_INVITE';
            const response = await (0, $dmOdc.teamsClient).updateTeamById(teamId, data);
            setState({
                teamProfile: {
                    ...getState().teamProfile,
                    data: response
                }
            });
            if (isTransitioningToOpen) dispatch((0, $4TUdO.getTeamMembers)(teamId));
            return response;
        },
    acceptAllJoinRequests: (teamId)=>async ({ dispatch: dispatch, getState: getState })=>{
            const requests = getState().teamMembers.requestingToJoinUsers;
            await Promise.all(requests.map((request)=>{
                return dispatch((0, $66abk.approveJoinRequest)(teamId, request.membershipId.memberId, request.user));
            }));
        },
    declineAllJoinRequests: (teamId)=>async ({ dispatch: dispatch, getState: getState })=>{
            const requests = getState().teamMembers.requestingToJoinUsers;
            await Promise.all(requests.map((request)=>{
                return dispatch((0, $bGzDE.declineJoinRequest)(teamId, request.membershipId.memberId));
            }));
        },
    removeTeamMember: // Throws if we cannot remove the member
    $j3TB6.removeTeamMember,
    removeTeamAgent: $fscon.removeTeamAgent,
    revokeTeamInvite: (teamId, memberId)=>async ({ getState: getState, setState: setState })=>{
            const { teamMembers: { teamId: currentTeamId } } = getState();
            const removedInvite = await (0, $dmOdc.teamsClient).revokeTeamInvite(teamId, memberId);
            if (removedInvite && removedInvite.state !== 'ALUMNI') throw Error('Invite claims to be cancelled but was not');
            if (currentTeamId !== teamId) return;
            setState({
                teamMembers: {
                    ...getState().teamMembers,
                    members: getState().teamMembers.members.filter((member)=>!!member.user && member.user.id !== memberId)
                }
            });
        },
    joinTeam: // Throws if teamsClient.selfJoinTeam throws
    $aatv6.joinTeam,
    // Throws if teamsClient.cancelJoinRequest throws
    cancelJoinRequest: (teamId)=>async ({ getState: getState, setState: setState })=>{
            const { teamProfile: { teamId: currentTeamId } } = getState();
            await (0, $dmOdc.teamsClient).cancelJoinRequest(teamId);
            const state = getState();
            if (currentTeamId !== teamId) return;
            setState({
                ...state,
                myTeamMembership: {
                    teamId: teamId,
                    hasLoaded: true,
                    membership: undefined
                }
            });
        },
    acceptTeamInvitation: // Throws if teamsClient.acceptTeamInvitation throws
    $aatv6.acceptTeamInvitation,
    // Throws if teamsClient.declineTeamInvitation throws
    declineTeamInvitation: (teamId)=>async ({ getState: getState })=>{
            const { exitedTeams: exitedTeams } = getState();
            await (0, $dmOdc.teamsClient).declineTeamInvitation(teamId);
            exitedTeams.add(teamId);
        // No need to re-fetch, when an invite is declined we navigate away
        },
    inviteUsersToTeam: // Throws if teamsClient.inviteUsersToTeam or publicApiClient.addUsersToTeam throws
    $3n2JP.inviteUsersToTeam,
    inviteAgentsToTeam: $jDX6f.inviteAgentsToTeam,
    approveJoinRequest: // Throws if teamsClient.approveJoinRequest throws
    $66abk.approveJoinRequest,
    declineJoinRequest: // Throws if teamsClient.declineJoinRequest throws
    $bGzDE.declineJoinRequest,
    // Throws if teamsClient.deleteTeam throws
    deleteTeam: (teamId)=>async ({ getState: getState, setState: setState })=>{
            const { exitedTeams: exitedTeams } = getState();
            await (0, $dmOdc.teamsClient).deleteTeam(teamId);
            setState({
                teamProfile: $541492975b2c7e18$var$initialState.teamProfile,
                teamMembers: $541492975b2c7e18$var$initialState.teamMembers,
                myTeamMembership: $541492975b2c7e18$var$initialState.myTeamMembership
            });
            exitedTeams.add(teamId);
        },
    getAllTeams: (allTeamsQuery, keepExistingData)=>async ({ dispatch: dispatch })=>{
            await dispatch((0, $lwEMT.default)(allTeamsQuery, keepExistingData));
        },
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required
    /**
	 * @deprecated
	 */ refreshTeamHealthMonitors: ()=>async ()=>{
            return Promise.resolve();
        }
};
const $541492975b2c7e18$var$TeamStore = (0, $iXqE5.createStore)({
    initialState: $541492975b2c7e18$var$initialState,
    actions: $541492975b2c7e18$var$actions
});
const $541492975b2c7e18$export$1983fe04e6d15665 = (0, $3sQ5x.createHook)($541492975b2c7e18$var$TeamStore, {
    selector: (state)=>state.teamProfile
});
const $541492975b2c7e18$export$c90591c2030bee = (0, $3sQ5x.createHook)($541492975b2c7e18$var$TeamStore, {
    selector: (state)=>state.teamMembers
});
const $541492975b2c7e18$export$7d96b11823e54583 = (0, $3sQ5x.createHook)($541492975b2c7e18$var$TeamStore, {
    selector: (state)=>state.myTeamMembership
});
const $541492975b2c7e18$export$d85ae427dffd7a31 = (0, $3sQ5x.createHook)($541492975b2c7e18$var$TeamStore, {
    selector: (state)=>state.exitedTeams
});
const $541492975b2c7e18$export$a50a7dc1b87fcc7 = (0, $3sQ5x.createHook)($541492975b2c7e18$var$TeamStore, {
    selector: (state)=>state.allTeamsData
});
const $541492975b2c7e18$export$80fb38915e92c27f = (0, $3sQ5x.createHook)($541492975b2c7e18$var$TeamStore, {
    selector: (state)=>state.teamAgents
});

});
parcelRegister("aatv6", function(module, exports) {

$parcel$export(module.exports, "joinTeam", () => $da8183fc149dba31$export$47f143084f31963c);
$parcel$export(module.exports, "acceptTeamInvitation", () => $da8183fc149dba31$export$a0ce1bbc3e3f2e4d);

var $dmOdc = parcelRequire("dmOdc");

var $bGzDE = parcelRequire("bGzDE");

var $bhfHz = parcelRequire("bhfHz");
const $da8183fc149dba31$export$e4da98dc943d58c8 = (teamId, member)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        if (state.teamProfile.teamId !== teamId) return;
        const nextState = (0, $bhfHz.joinTeamState)(state, member);
        setState(nextState);
    };
const $da8183fc149dba31$export$47f143084f31963c = (teamId, originQuery, user)=>async ({ dispatch: dispatch })=>{
        const response = await (0, $dmOdc.teamsClient).selfJoinTeam(teamId, originQuery);
        const newMembership = {
            ...response,
            user: user
        };
        dispatch($da8183fc149dba31$export$e4da98dc943d58c8(teamId, newMembership));
        return response;
    };
const $da8183fc149dba31$export$a0ce1bbc3e3f2e4d = (teamId, currentUserId)=>async ({ dispatch: dispatch, getState: getState })=>{
        const response = await (0, $dmOdc.teamsClient).acceptTeamInvitation(teamId);
        const existingUser = getState().teamMembers.members.find((member)=>member.membershipId.memberId === currentUserId);
        // This membership MUST exist for the user to be able to call this function,
        // and `user` will be defined as this membership comes from the directory.
        if (!existingUser || !existingUser.user) return;
        const newMembership = {
            ...response,
            user: existingUser.user
        };
        dispatch($da8183fc149dba31$export$e4da98dc943d58c8(teamId, newMembership));
        // Don't await this, let them load afterwards
        dispatch((0, $bGzDE.getRequestingToJoinUsers)(teamId));
    };

});
parcelRegister("bGzDE", function(module, exports) {

$parcel$export(module.exports, "getRequestingToJoinUsers", () => $8d91893cb97bea35$export$eb1265581ad35874);
$parcel$export(module.exports, "declineJoinRequest", () => $8d91893cb97bea35$export$d71ce2a87bc937b0);

var $kHmnq = parcelRequire("kHmnq");
var $dmOdc = parcelRequire("dmOdc");

var $afodl = parcelRequire("afodl");

var $2bf04 = parcelRequire("2bf04");
const $8d91893cb97bea35$export$eb1265581ad35874 = (teamId)=>async ({ getState: getState, setState: setState })=>{
        const initialState = getState();
        const isOpenTeam = initialState.teamProfile.data.membershipSettings === 'OPEN';
        const membershipErrors = initialState.teamMembers.hasError;
        const hasPermissionToViewRequestingUsers = initialState.teamProfile.data.permission === 'FULL_WRITE';
        const teamChanged = initialState.teamMembers.teamId !== teamId;
        if (teamChanged || !hasPermissionToViewRequestingUsers || membershipErrors || isOpenTeam) return [];
        try {
            const requestingUsersResponse = await (0, $dmOdc.teamsClient).queryTeamMemberships(teamId, [
                'REQUESTING_TO_JOIN'
            ], {
                first: 100,
                after: initialState.teamMembers.requestingToJoinUsersPageInfo.cursor ?? undefined
            });
            const requestingUsers = (0, $afodl.isResultWithPageInfo)(requestingUsersResponse) ? requestingUsersResponse.edges : requestingUsersResponse;
            const state = getState();
            if (state.teamMembers.teamId !== teamId) return [];
            const sortedRequesters = (0, $kHmnq.sortMembersByType)(requestingUsers);
            setState({
                teamMembers: {
                    ...state.teamMembers,
                    requestingToJoinUsers: sortedRequesters
                }
            });
            return sortedRequesters;
        } catch (err) {
            (0, $2bf04.logException)(err, 'Could not load requesting-to-join users');
            return [];
        }
    };
const $8d91893cb97bea35$export$d71ce2a87bc937b0 = (teamId, memberId)=>async ({ getState: getState, setState: setState })=>{
        await (0, $dmOdc.teamsClient).declineJoinRequest(teamId, memberId);
        const state = getState();
        if (state.teamMembers.teamId !== teamId) return;
        setState({
            ...state,
            teamMembers: {
                ...state.teamMembers,
                requestingToJoinUsers: state.teamMembers.requestingToJoinUsers.filter((user)=>user.membershipId.memberId !== memberId)
            }
        });
    };

});
parcelRegister("kHmnq", function(module, exports) {

$parcel$export(module.exports, "sortMembersByType", () => $871928547f066260$export$90b27c15351f4a21);
var $871928547f066260$var$MemberType = /*#__PURE__*/ function(MemberType) {
    MemberType[MemberType["CURRENT_USER"] = 0] = "CURRENT_USER";
    MemberType[MemberType["MEMBER"] = 1] = "MEMBER";
    MemberType[MemberType["INVITED"] = 2] = "INVITED";
    MemberType[MemberType["INACTIVE"] = 3] = "INACTIVE";
    MemberType[MemberType["DELETED"] = 4] = "DELETED";
    return MemberType;
}($871928547f066260$var$MemberType || {});
const $871928547f066260$var$checkType = (member, currentAccountId)=>{
    if (member.membershipId.memberId === currentAccountId) return 0;
    else if (member && member.state === 'INVITED') return 2;
    else if (member.user?.status === 'inactive') return 3;
    else if (member.user?.status === 'closed') return 4;
    else return 1;
};
const $871928547f066260$export$90b27c15351f4a21 = (members, currentAccountId)=>{
    const newMembers = members.map((member)=>({
            member: member,
            type: $871928547f066260$var$checkType(member, currentAccountId)
        }));
    newMembers.sort(({ member: memberA, type: typeA }, { member: memberB, type: typeB })=>{
        if (typeA === typeB) return memberA.user?.fullName.localeCompare(memberB.user?.fullName || '') || 0;
        else return typeA - typeB;
    });
    return newMembers.map(({ member: member })=>member);
};

});

parcelRegister("afodl", function(module, exports) {

$parcel$export(module.exports, "isResultWithPageInfo", () => $6f07430cec62bdd2$export$7fb758c207c3ab4b);
function $6f07430cec62bdd2$export$7fb758c207c3ab4b(result) {
    return result.pageInfo !== undefined;
}

});


parcelRegister("bhfHz", function(module, exports) {

$parcel$export(module.exports, "joinTeamState", () => $57537f75a24391af$export$6842649be21ecf13);

var $kHmnq = parcelRequire("kHmnq");
const $57537f75a24391af$export$6842649be21ecf13 = (teamState, newMembership)=>{
    const { exitedTeams: exitedTeams, teamMembers: teamMembers, teamProfile: teamProfile } = teamState;
    const requestingToJoin = newMembership.state === 'REQUESTING_TO_JOIN';
    const teamId = newMembership.membershipId.teamId;
    if (requestingToJoin) return {
        ...teamState,
        myTeamMembership: {
            teamId: teamId,
            hasLoaded: true,
            membership: newMembership
        }
    };
    // If we're joining this team, remove it from the set of exited teams
    exitedTeams.delete(teamId);
    const currentUserId = newMembership.membershipId.memberId;
    const newMembers = teamMembers.members.filter((membership)=>{
        return membership.membershipId.memberId !== currentUserId;
    }).concat(newMembership);
    return {
        ...teamState,
        teamProfile: {
            teamId: teamId,
            hasLoaded: true,
            isLoading: false,
            errorType: null,
            data: {
                ...teamProfile.data,
                permission: 'FULL_WRITE'
            }
        },
        teamMembers: {
            teamId: teamId,
            hasLoaded: true,
            hasError: false,
            isLoading: false,
            isLoadingNextPage: false,
            errorType: null,
            members: (0, $kHmnq.sortMembersByType)(newMembers, currentUserId),
            requestingToJoinUsers: teamMembers.requestingToJoinUsers,
            membersPageInfo: teamMembers.membersPageInfo,
            requestingToJoinUsersPageInfo: {
                hasNextPage: false,
                cursor: null
            }
        },
        myTeamMembership: {
            teamId: teamId,
            hasLoaded: true,
            membership: newMembership
        }
    };
};

});


parcelRegister("66abk", function(module, exports) {

$parcel$export(module.exports, "approveJoinRequest", () => $a2697356b23d45a6$export$a355add01c2f52a3);

var $kHmnq = parcelRequire("kHmnq");
var $dmOdc = parcelRequire("dmOdc");
const $a2697356b23d45a6$export$a355add01c2f52a3 = (teamId, memberId, user)=>async ({ getState: getState, setState: setState })=>{
        const membership = await (0, $dmOdc.teamsClient).acceptJoinRequest(teamId, memberId);
        const state = getState();
        const { myTeamMembership: myTeamMembership, teamMembers: teamMembers, teamProfile: { teamId: currentTeamId } } = state;
        if (currentTeamId !== teamId || membership.state !== 'FULL_MEMBER') return;
        const newMembership = {
            ...membership,
            user: user
        };
        const newMembers = teamMembers.members.filter((membership)=>{
            return membership.membershipId.memberId !== memberId;
        }).concat(newMembership);
        const myMembership = myTeamMembership.membership;
        setState({
            ...state,
            teamMembers: {
                teamId: teamId,
                hasLoaded: true,
                isLoadingNextPage: false,
                hasError: false,
                isLoading: false,
                errorType: null,
                membersPageInfo: teamMembers.membersPageInfo,
                requestingToJoinUsersPageInfo: teamMembers.requestingToJoinUsersPageInfo,
                members: (0, $kHmnq.sortMembersByType)(newMembers, myMembership?.membershipId.memberId),
                requestingToJoinUsers: teamMembers.requestingToJoinUsers.filter((user)=>user.membershipId.memberId !== memberId)
            }
        });
    };

});

parcelRegister("4m5re", function(module, exports) {

$parcel$export(module.exports, "getMyTeamMembership", () => $4407dfc66ee0c8fb$export$72e6f466f46f9da0);

var $kHmnq = parcelRequire("kHmnq");
var $dmOdc = parcelRequire("dmOdc");

var $loO6b = parcelRequire("loO6b");
const $4407dfc66ee0c8fb$export$72e6f466f46f9da0 = (teamId, keepExistingData)=>async ({ getState: getState, setState: setState })=>{
        if (!keepExistingData) setState({
            myTeamMembership: {
                teamId: teamId,
                hasLoaded: false,
                membership: undefined
            }
        });
        const { myTeamMembership: myTeamMembership } = getState();
        if (myTeamMembership.teamId !== teamId) return;
        const { value: membership } = await (0, $loO6b.promiseWithDefault)((0, $dmOdc.teamsClient).getMyTeamMembership(teamId), undefined);
        const { teamMembers: teamMembers } = getState();
        const members = teamMembers.members;
        const sortedMembers = members.length > 0 && !!membership ? {
            teamMembers: {
                ...teamMembers,
                members: (0, $kHmnq.sortMembersByType)(members, membership.membershipId.memberId)
            }
        } : {};
        setState({
            myTeamMembership: {
                teamId: teamId,
                hasLoaded: true,
                membership: membership
            },
            ...sortedMembers
        });
    };

});
parcelRegister("loO6b", function(module, exports) {

$parcel$export(module.exports, "promiseWithDefault", () => $399bff40b50d1c77$export$a970b469503acdc8);
function $399bff40b50d1c77$export$a970b469503acdc8(promise, defaultValue) {
    return promise.then((value)=>({
            value: value,
            success: true
        })).catch(()=>({
            value: defaultValue,
            success: false
        }));
}

});


parcelRegister("4TUdO", function(module, exports) {

$parcel$export(module.exports, "getTeamMembers", () => $6443cbad120854eb$export$e662071d38e352a1);

var $kHmnq = parcelRequire("kHmnq");
var $dmOdc = parcelRequire("dmOdc");

var $afodl = parcelRequire("afodl");
const $6443cbad120854eb$var$combineIn = (existing, newData)=>{
    const addedMemberIds = new Set(newData.map((member)=>member.membershipId.memberId));
    return existing.filter((member)=>!addedMemberIds.has(member.membershipId.memberId)).concat(newData);
};
const $6443cbad120854eb$export$e662071d38e352a1 = (teamId, keepExistingData, first = 100)=>async ({ getState: getState, setState: setState })=>{
        if (!keepExistingData) setState({
            teamMembers: {
                teamId: teamId,
                isLoading: true,
                isLoadingNextPage: false,
                hasLoaded: false,
                hasError: false,
                errorType: null,
                members: [],
                requestingToJoinUsers: [],
                membersPageInfo: {
                    hasNextPage: false,
                    cursor: null
                },
                requestingToJoinUsersPageInfo: {
                    hasNextPage: false,
                    cursor: null
                }
            },
            teamAgents: {
                teamId: teamId,
                isLoading: true,
                isLoadingNextPage: false,
                hasLoaded: false,
                hasError: false,
                errorType: null,
                members: []
            }
        });
        const { teamMembers: teamMembers } = getState();
        if (teamMembers.teamId !== teamId) return;
        setState({
            teamMembers: {
                ...teamMembers,
                isLoadingNextPage: true
            },
            teamAgents: {
                ...teamMembers
            }
        });
        try {
            const membershipsResponse = await (0, $dmOdc.teamsClient).queryTeamMemberships(teamId, [
                'FULL_MEMBER'
            ], {
                first: first,
                after: teamMembers.membersPageInfo.cursor ?? undefined
            });
            const memberships = (0, $afodl.isResultWithPageInfo)(membershipsResponse) ? membershipsResponse.edges : membershipsResponse;
            const pageInfo = (0, $afodl.isResultWithPageInfo)(membershipsResponse) ? membershipsResponse.pageInfo : {
                hasNextPage: false,
                endCursor: null
            };
            const myMembership = getState().myTeamMembership.membership;
            const myAccountId = myMembership?.membershipId.memberId;
            const membershipsWithExisting = keepExistingData ? $6443cbad120854eb$var$combineIn(teamMembers.members, memberships) : memberships;
            const sortedMembers = (0, $kHmnq.sortMembersByType)(membershipsWithExisting, myAccountId);
            const membersWithoutAgents = sortedMembers.filter((member)=>!(member.user?.userType === 'agent'));
            const agents = sortedMembers.filter((member)=>member.user?.userType === 'agent');
            setState({
                teamMembers: {
                    teamId: teamId,
                    isLoading: false,
                    isLoadingNextPage: false,
                    hasLoaded: true,
                    hasError: false,
                    errorType: null,
                    members: membersWithoutAgents,
                    requestingToJoinUsers: [],
                    requestingToJoinUsersPageInfo: {
                        hasNextPage: false,
                        cursor: null
                    },
                    membersPageInfo: {
                        hasNextPage: pageInfo.hasNextPage,
                        cursor: pageInfo.endCursor
                    }
                },
                teamAgents: {
                    teamId: teamId,
                    isLoading: false,
                    isLoadingNextPage: false,
                    hasLoaded: true,
                    hasError: false,
                    errorType: null,
                    members: agents
                }
            });
        } catch (e) {
            if (getState().teamMembers.teamId !== teamId) return;
            setState({
                teamMembers: {
                    teamId: teamId,
                    isLoading: false,
                    isLoadingNextPage: false,
                    hasLoaded: true,
                    hasError: true,
                    errorType: e,
                    members: [],
                    requestingToJoinUsers: [],
                    membersPageInfo: {
                        hasNextPage: false,
                        cursor: null
                    },
                    requestingToJoinUsersPageInfo: {
                        hasNextPage: false,
                        cursor: null
                    }
                },
                teamAgents: {
                    teamId: teamId,
                    isLoading: false,
                    isLoadingNextPage: false,
                    hasLoaded: true,
                    hasError: true,
                    errorType: e,
                    members: []
                }
            });
        }
    };

});

parcelRegister("17Odl", function(module, exports) {

$parcel$export(module.exports, "getTeamProfile", () => $60ff1b5f1789f089$export$7a5bb1168a5e8491);

var $dmOdc = parcelRequire("dmOdc");
const $60ff1b5f1789f089$export$7a5bb1168a5e8491 = (teamId)=>async ({ setState: setState })=>{
        setState({
            teamProfile: {
                teamId: teamId,
                isLoading: true,
                hasLoaded: false,
                errorType: null,
                data: {}
            }
        });
        try {
            const team = await (0, $dmOdc.teamsClient).getTeamById(teamId);
            setState({
                teamProfile: {
                    teamId: teamId,
                    isLoading: false,
                    hasLoaded: true,
                    errorType: null,
                    data: team
                }
            });
        } catch (e) {
            setState({
                teamProfile: {
                    teamId: teamId,
                    isLoading: false,
                    hasLoaded: true,
                    errorType: e,
                    data: {}
                }
            });
        }
    };

});

parcelRegister("jDX6f", function(module, exports) {

$parcel$export(module.exports, "inviteAgentsToTeam", () => $ffc60b497b341cfc$export$8f3a722ac3583593);

var $dmOdc = parcelRequire("dmOdc");

var $2bf04 = parcelRequire("2bf04");

var $2af9Q = parcelRequire("2af9Q");

var $7J02P = parcelRequire("7J02P");
const $ffc60b497b341cfc$export$8f3a722ac3583593 = (teamId, members)=>async ({ getState: getState, setState: setState })=>{
        (0, $2af9Q.addNewMembertoTeamSubExp).addMetadata({
            apiVersion: 'v4'
        });
        const addMembershipResponse = await (0, $dmOdc.teamsClient).addUsersToTeam(teamId, members.map((member)=>({
                accountId: member.id
            })));
        const memberships = addMembershipResponse.members.reduce((acc, partial)=>{
            if (!partial.accountId) {
                (0, $2bf04.logInfoMessage)('teamInvitationInvalidResponse', {
                    message: 'Membership in response was invalid',
                    member: partial,
                    response: addMembershipResponse
                });
                return acc;
            }
            const user = members.find((member)=>member.id === partial.accountId);
            if (!user) {
                (0, $2bf04.logInfoMessage)('teamInvitationInvalidResponse', {
                    message: 'Could not find user details for this member',
                    member: partial,
                    response: addMembershipResponse
                });
                return acc;
            }
            acc.push({
                membershipId: {
                    teamId: teamId,
                    memberId: partial.accountId
                },
                // state and role are deprecated in V4, so hard code them here
                state: 'FULL_MEMBER',
                role: 'REGULAR',
                user: {
                    id: user.id,
                    fullName: user.name,
                    avatarUrl: user.avatarUrl,
                    userType: 'user'
                }
            });
            return acc;
        }, []);
        const state = getState();
        // If focused team has changed whilst invite request was resolving, abort.
        if (teamId !== state.teamMembers.teamId) return;
        // Update the state with the new members.
        const nextState = (0, $7J02P.inviteMemberState)(state, memberships);
        setState(nextState);
        return memberships;
    };

});
parcelRegister("2af9Q", function(module, exports) {

$parcel$export(module.exports, "renderTeamMemberRemoveDialogSubExp", () => $76a0c8359266acef$export$d04a4af02b71bd20);
$parcel$export(module.exports, "removeMemberFromTeamSubExp", () => $76a0c8359266acef$export$8e622ac1f6a9e9f4);
$parcel$export(module.exports, "removeMemberFromTeamExp", () => $76a0c8359266acef$export$ded699d92af3fb9e);
$parcel$export(module.exports, "teamSettingsOverallExp", () => $76a0c8359266acef$export$efd0793305afa76a);
$parcel$export(module.exports, "teamSettingsChangeTeamTypeExp", () => $76a0c8359266acef$export$fba164816385656f);
$parcel$export(module.exports, "renderTeamMemberInviteDialogSubExp", () => $76a0c8359266acef$export$568d3db878ad8d23);
$parcel$export(module.exports, "addNewMembertoTeamSubExp", () => $76a0c8359266acef$export$d691a209050136d6);
$parcel$export(module.exports, "inviteMembersToTeamExperience", () => $76a0c8359266acef$export$2bd703f1fbcc240b);

var $baNgi = parcelRequire("baNgi");

var $7Zbvr = parcelRequire("7Zbvr");
var $htAzj = parcelRequire("htAzj");
const $76a0c8359266acef$export$d04a4af02b71bd20 = new (0, $baNgi.TeamsUFOExperience)('render-team-member-remove-dialog', {
    type: (0, $7Zbvr.ExperienceTypes).Experience,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $76a0c8359266acef$export$8e622ac1f6a9e9f4 = new (0, $baNgi.TeamsUFOExperience)('remove-member-from-team-action', {
    type: (0, $7Zbvr.ExperienceTypes).Experience,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $76a0c8359266acef$var$removeMemberFromTeamSubExperiences = [
    $76a0c8359266acef$export$d04a4af02b71bd20,
    $76a0c8359266acef$export$8e622ac1f6a9e9f4
];
const $76a0c8359266acef$export$ded699d92af3fb9e = new (0, $baNgi.TeamsUFOExperience)('remove-a-member-from-team', {
    type: (0, $7Zbvr.ExperienceTypes).Experience,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).Custom,
    platform: {
        component: 'people'
    },
    until: (0, $htAzj.untilAll)($76a0c8359266acef$var$removeMemberFromTeamSubExperiences.map((experience)=>({
            experience: experience
        })))
});
const $76a0c8359266acef$export$efd0793305afa76a = new (0, $baNgi.TeamsUFOExperience)('membership-control-change', {
    type: (0, $7Zbvr.ExperienceTypes).Experience,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $76a0c8359266acef$export$a7f093db8a7d96e1 = new (0, $baNgi.TeamsUFOExperience)('membership-control-change-handle-requests', {
    type: (0, $7Zbvr.ExperienceTypes).Experience,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $76a0c8359266acef$export$fba164816385656f = new (0, $baNgi.TeamsUFOExperience)('membership-control-change-change-team-type', {
    type: (0, $7Zbvr.ExperienceTypes).Experience,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $76a0c8359266acef$export$568d3db878ad8d23 = new (0, $baNgi.TeamsUFOExperience)('render-team-member-invite-dialog', {
    type: (0, $7Zbvr.ExperienceTypes).Experience,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $76a0c8359266acef$export$d691a209050136d6 = new (0, $baNgi.TeamsUFOExperience)('add-new-member-to-team-action', {
    type: (0, $7Zbvr.ExperienceTypes).Experience,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $76a0c8359266acef$var$inviteMembersToTeamSubExperiences = [
    $76a0c8359266acef$export$568d3db878ad8d23,
    $76a0c8359266acef$export$d691a209050136d6
];
const $76a0c8359266acef$export$2bd703f1fbcc240b = new (0, $baNgi.TeamsUFOExperience)('invite-members-to-team', {
    type: (0, $7Zbvr.ExperienceTypes).Experience,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).Custom,
    platform: {
        component: 'people'
    },
    until: (0, $htAzj.untilAll)($76a0c8359266acef$var$inviteMembersToTeamSubExperiences.map((experience)=>({
            experience: experience
        })))
});

});
parcelRegister("htAzj", function(module, exports) {

$parcel$export(module.exports, "untilAll", () => $23cadaf86c4f9e9a$export$44695628831598be);

var $dCAsn = parcelRequire("dCAsn");

var $jZA09 = parcelRequire("jZA09");
const $23cadaf86c4f9e9a$var$isUntilExperience = (until)=>{
    return until.experience !== undefined;
};
const $23cadaf86c4f9e9a$var$isUntilCategory = (until)=>{
    return until.category !== undefined;
};
const $23cadaf86c4f9e9a$export$44695628831598be = (deps)=>()=>{
        const notMet = [
            ...deps
        ];
        return (data)=>{
            if (notMet.length > 0) {
                const doneIndexes = notMet.reduce((acc, dep, i)=>{
                    // validation logic
                    if ($23cadaf86c4f9e9a$var$isUntilExperience(dep) && dep.experience.uuid === data.uuid) acc.push(i);
                    else if ($23cadaf86c4f9e9a$var$isUntilCategory(dep) && dep.category === data.category) acc.push(i);
                    return acc;
                }, []);
                const priorityStateFound = data.state === (0, $jZA09.UFOExperienceState).ABORTED || data.state === (0, $jZA09.UFOExperienceState).FAILED;
                if (priorityStateFound) {
                    notMet.length = 0;
                    return {
                        done: true,
                        state: data.state
                    };
                }
                doneIndexes.reverse().forEach((i)=>{
                    notMet.splice(i, 1);
                });
                (0, $dCAsn.ufolog)('untilAll deps left:', notMet.length, notMet);
                if (notMet.length === 0) return {
                    done: true,
                    state: (0, $jZA09.UFOExperienceState).SUCCEEDED
                };
            }
            return {
                done: false
            };
        };
    };

});


parcelRegister("7J02P", function(module, exports) {

$parcel$export(module.exports, "inviteMemberState", () => $01c6d661a562432f$export$d7fb3590d40d5847);

var $kHmnq = parcelRequire("kHmnq");
const $01c6d661a562432f$export$d7fb3590d40d5847 = (teamState, newMemberships)=>{
    const { teamAgents: teamAgents } = teamState;
    const memberIds = new Set(newMemberships.map(({ membershipId: membershipId })=>membershipId.memberId));
    const existingMembers = teamAgents.members.filter((member)=>{
        return !memberIds.has(member.membershipId.memberId);
    });
    const finalMembers = (0, $kHmnq.sortMembersByType)(newMemberships.concat(existingMembers));
    return {
        ...teamState,
        teamAgents: {
            ...teamState.teamAgents,
            teamId: teamState.teamAgents.teamId,
            hasLoaded: true,
            hasError: false,
            isLoading: false,
            errorType: null,
            members: finalMembers
        }
    };
};

});


parcelRegister("3n2JP", function(module, exports) {

$parcel$export(module.exports, "inviteUsersToTeam", () => $7ed51d7ca32e6f6f$export$ac31c528ad2c8490);

var $kHmnq = parcelRequire("kHmnq");
var $dmOdc = parcelRequire("dmOdc");

var $2bf04 = parcelRequire("2bf04");

var $2af9Q = parcelRequire("2af9Q");
const $7ed51d7ca32e6f6f$export$d7fb3590d40d5847 = (teamState, newMemberships)=>{
    const { teamMembers: teamMembers } = teamState;
    const memberIds = new Set(newMemberships.map(({ membershipId: membershipId })=>membershipId.memberId));
    const existingMembers = teamMembers.members.filter((member)=>{
        return !memberIds.has(member.membershipId.memberId);
    });
    const currentUserId = teamState.myTeamMembership.membership?.membershipId.memberId;
    const finalMembers = (0, $kHmnq.sortMembersByType)(newMemberships.concat(existingMembers), currentUserId);
    return {
        ...teamState,
        teamMembers: {
            ...teamState.teamMembers,
            teamId: teamState.teamMembers.teamId,
            hasLoaded: true,
            hasError: false,
            isLoading: false,
            errorType: null,
            members: finalMembers
        }
    };
};
const $7ed51d7ca32e6f6f$var$fetchJobTitlesOfNewMembers = (teamId, unpopulatedMembers, originQuery)=>async ({ getState: getState, setState: setState })=>{
        Promise.all(unpopulatedMembers.map((membership)=>{
            return (0, $dmOdc.teamsClient).queryAGGUser(membership.membershipId.memberId).then((user)=>{
                return {
                    ...membership,
                    user: {
                        ...membership.user,
                        title: user.extendedProfile?.jobTitle
                    }
                };
            });
        })).then((memberships)=>{
            const state = getState();
            // Cancel if the data we fetched is stale
            if (state.teamMembers.teamId !== teamId) return;
            const titles = {};
            for (const member of memberships)titles[member.membershipId.memberId] = member.user.title || undefined;
            setState({
                ...state,
                teamMembers: {
                    ...state.teamMembers,
                    members: state.teamMembers.members.map(// @ts-ignore
                    (member)=>{
                        return {
                            ...member,
                            user: {
                                ...member.user,
                                title: titles[member.membershipId.memberId] || member.user.title
                            }
                        };
                    })
                }
            });
        }).catch((error)=>{
            (0, $2bf04.logException)(error, 'Could not populate new team members with titles');
        });
    };
const $7ed51d7ca32e6f6f$export$ac31c528ad2c8490 = (teamId, members, originQuery)=>async ({ dispatch: dispatch, getState: getState, setState: setState })=>{
        (0, $2af9Q.addNewMembertoTeamSubExp).addMetadata({
            apiVersion: 'v4'
        });
        const addMembershipResponse = await (0, $dmOdc.teamsClient).addUsersToTeam(teamId, members.map((member)=>({
                accountId: member.id
            })));
        const memberships = addMembershipResponse.members.reduce((acc, partial)=>{
            if (!partial.accountId) {
                (0, $2bf04.logInfoMessage)('teamInvitationInvalidResponse', {
                    message: 'Membership in response was invalid',
                    member: partial,
                    response: addMembershipResponse
                });
                return acc;
            }
            const user = members.find((member)=>member.id === partial.accountId);
            if (!user) {
                (0, $2bf04.logInfoMessage)('teamInvitationInvalidResponse', {
                    message: 'Could not find user details for this member',
                    member: partial,
                    response: addMembershipResponse
                });
                return acc;
            }
            acc.push({
                membershipId: {
                    teamId: teamId,
                    memberId: partial.accountId
                },
                // state and role are deprecated in V4, so hard code them here
                state: 'FULL_MEMBER',
                role: 'REGULAR',
                user: {
                    id: user.id,
                    fullName: user.name,
                    avatarUrl: user.avatarUrl,
                    userType: 'user'
                }
            });
            return acc;
        }, []);
        const state = getState();
        // If focused team has changed whilst invite request was resolving, abort.
        if (teamId !== state.teamMembers.teamId) return;
        // Update the state with the new members.
        const nextState = $7ed51d7ca32e6f6f$export$d7fb3590d40d5847(state, memberships);
        setState(nextState);
        // Send request to populate job titles off the main thread.
        const unpopulatedMembers = addMembershipResponse.members.map((member)=>({
                membershipId: {
                    teamId: teamId,
                    memberId: member.accountId
                },
                // state and role are deprecated in V4, so hard code them here
                state: 'FULL_MEMBER',
                role: 'REGULAR'
            }));
        dispatch($7ed51d7ca32e6f6f$var$fetchJobTitlesOfNewMembers(teamId, unpopulatedMembers, originQuery));
        return memberships;
    };

});

parcelRegister("89d9t", function(module, exports) {

$parcel$export(module.exports, "prefillTeamData", () => $531022751be5c09e$export$bc2925813ab9bc57);

var $kHmnq = parcelRequire("kHmnq");

var $4m5re = parcelRequire("4m5re");

var $4TUdO = parcelRequire("4TUdO");
const $531022751be5c09e$var$TIMEOUT_DELAY = 5000;
function $531022751be5c09e$var$membershipMaker(teamId) {
    return (user)=>{
        return {
            membershipId: {
                teamId: teamId,
                memberId: user.id
            },
            state: 'FULL_MEMBER',
            role: 'REGULAR',
            user: user
        };
    };
}
const $531022751be5c09e$export$bc2925813ab9bc57 = (teamId, teamData, members, currentUser)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const newState = {
            ...getState(),
            teamProfile: {
                teamId: teamId,
                isLoading: false,
                hasLoaded: true,
                errorType: null,
                data: teamData
            },
            teamMembers: {
                teamId: teamId,
                isLoading: false,
                isLoadingNextPage: false,
                hasLoaded: true,
                hasError: false,
                errorType: null,
                members: (0, $kHmnq.sortMembersByType)(members.map($531022751be5c09e$var$membershipMaker(teamId)), currentUser.id),
                requestingToJoinUsers: [],
                membersPageInfo: {
                    hasNextPage: false,
                    cursor: null
                },
                requestingToJoinUsersPageInfo: {
                    hasNextPage: false,
                    cursor: null
                }
            },
            myTeamMembership: {
                teamId: teamId,
                hasLoaded: true,
                membership: members.some((x)=>x.id === currentUser.id) ? $531022751be5c09e$var$membershipMaker(teamId)(currentUser) : undefined
            }
        };
        setState(newState);
        setTimeout(()=>{
            if (getState().teamProfile.teamId !== teamId) return;
            dispatch((0, $4TUdO.getTeamMembers)(teamId, true));
            dispatch((0, $4m5re.getMyTeamMembership)(teamId, true));
        }, $531022751be5c09e$var$TIMEOUT_DELAY);
    };

});

parcelRegister("fscon", function(module, exports) {

$parcel$export(module.exports, "removeTeamAgent", () => $a88ce7ec362ebcfa$export$cc0fe1b8e0afca8c);

var $dmOdc = parcelRequire("dmOdc");
const $a88ce7ec362ebcfa$export$1c43837b29355a68 = (teamState, memberId, permissions)=>{
    const { teamProfile: teamProfile, teamAgents: teamAgents } = teamState;
    const teamId = teamProfile.teamId;
    const finalAgents = {
        ...teamAgents,
        teamId: teamId,
        hasLoaded: true,
        hasError: false,
        isLoading: false,
        errorType: null,
        members: teamAgents.members.filter((agent)=>!!agent.user && agent.user.id !== memberId)
    };
    return {
        ...teamState,
        teamAgents: finalAgents
    };
};
const $a88ce7ec362ebcfa$export$cc0fe1b8e0afca8c = (teamId, agentAtlassianAccountId, permissions)=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        const removeMembershipResponse = await (0, $dmOdc.teamsClient).removeTeamMemberships(teamId, [
            {
                accountId: agentAtlassianAccountId
            }
        ]);
        // as we only removing 1 member at a time, it is safe to say task failed with even 1 error
        if (removeMembershipResponse.errors && removeMembershipResponse.errors.length) throw Error('Membership claims to be removed but was not');
        if (state.teamMembers.teamId !== teamId) return;
        const nextState = $a88ce7ec362ebcfa$export$1c43837b29355a68(state, agentAtlassianAccountId, permissions);
        setState(nextState);
    };

});

parcelRegister("j3TB6", function(module, exports) {

$parcel$export(module.exports, "removeTeamMember", () => $852cef31cf6a8b5e$export$f7c0e1c7a2575f28);

var $dmOdc = parcelRequire("dmOdc");
const $852cef31cf6a8b5e$export$87a89dfcfcd29512 = (teamState, memberId, permissions)=>{
    const { exitedTeams: exitedTeams, myTeamMembership: myTeamMembership, teamMembers: teamMembers, teamProfile: teamProfile } = teamState;
    const teamId = myTeamMembership.teamId;
    const myMembership = myTeamMembership.membership;
    const isCurrentUser = myMembership && myMembership.membershipId.memberId === memberId;
    const finalMembers = {
        ...teamMembers,
        teamId: teamId,
        hasLoaded: true,
        hasError: false,
        isLoading: false,
        errorType: null,
        members: teamMembers.members.filter((member)=>!!member.user && member.user.id !== memberId)
    };
    if (!isCurrentUser) return {
        ...teamState,
        teamMembers: finalMembers
    };
    // No longer a part of this team, hide it from search results
    exitedTeams.add(teamId);
    const currentTeam = teamProfile.data;
    /**
	 * Allow admins to manage teams after they are removed from the team
	 * If currentTeam.permission is not undefined and user is not admin, they can only view the team after removal, set permission to FULL_READ
	 * If currentTeam.permission is not undefined and user is admin, they can still manage the team after removal, set permission to FULL_WRITE
	 * If currentTeam.permission is undefined, don't override the permission
	 */ const permissionAfterRemoval = currentTeam.permission ? permissions?.canAdminTeams ? 'FULL_WRITE' : 'FULL_READ' : currentTeam.permission;
    // Nullify myMembership and change permission
    return {
        ...teamState,
        teamMembers: finalMembers,
        myTeamMembership: {
            teamId: teamId,
            hasLoaded: true,
            membership: undefined
        },
        teamProfile: {
            teamId: teamId,
            isLoading: false,
            hasLoaded: true,
            errorType: null,
            data: {
                ...currentTeam,
                permission: permissionAfterRemoval
            }
        }
    };
};
const $852cef31cf6a8b5e$export$f7c0e1c7a2575f28 = (teamId, memberId, permissions)=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        const removeMembershipResponse = await (0, $dmOdc.teamsClient).removeTeamMemberships(teamId, [
            {
                accountId: memberId
            }
        ]);
        // as we only removing 1 member at a time, it is safe to say task failed with even 1 error
        if (removeMembershipResponse.errors && removeMembershipResponse.errors.length) throw Error('Membership claims to be removed but was not');
        if (state.teamMembers.teamId !== teamId) return;
        const nextState = $852cef31cf6a8b5e$export$87a89dfcfcd29512(state, memberId, permissions);
        setState(nextState);
    };

});

parcelRegister("lwEMT", function(module, exports) {

$parcel$export(module.exports, "default", () => $b374341e43188be4$export$2e2bcd8739ae039);

var $dmOdc = parcelRequire("dmOdc");
const $b374341e43188be4$var$getAllTeams = (allTeamsQuery, keepExistingData)=>async ({ getState: getState, setState: setState })=>{
        if (!keepExistingData) setState({
            allTeamsData: {
                teams: [],
                isLoading: true,
                hasError: false,
                cursor: ''
            }
        });
        try {
            const { teams: newTeams, cursor: cursor } = await (0, $dmOdc.teamsClient).getAllTeams(allTeamsQuery);
            setState({
                allTeamsData: {
                    teams: [
                        ...getState().allTeamsData.teams,
                        ...newTeams
                    ],
                    isLoading: false,
                    hasError: false,
                    cursor: cursor
                }
            });
        } catch (e) {
            setState({
                allTeamsData: {
                    isLoading: false,
                    hasError: true,
                    teams: [],
                    cursor: '',
                    errorStatusCode: e.status
                }
            });
        }
    };
var $b374341e43188be4$export$2e2bcd8739ae039 = $b374341e43188be4$var$getAllTeams;

});


parcelRegister("levfe", function(module, exports) {

$parcel$export(module.exports, "useV3OrgIdStatus", () => $717feac4baf972fe$export$52558c271a487a01);
$parcel$export(module.exports, "verifyTeamsInSameOrgIfNeeded", () => $717feac4baf972fe$export$61f31a8e9c589b24);

var $fyzT1 = parcelRequire("fyzT1");

var $c5gm9 = parcelRequire("c5gm9");

var $a2luh = parcelRequire("a2luh");
function $717feac4baf972fe$export$52558c271a487a01() {
    const [{ orgId: orgId }] = (0, $c5gm9.useOrg)();
    return {
        orgId: orgId,
        isOrgLoading: !orgId
    };
}
function $717feac4baf972fe$export$61f31a8e9c589b24(teams, analytics, queryName, currentOrgId) {
    if (!currentOrgId) return;
    const orgARI = `ari:cloud:platform::org/${currentOrgId}`;
    const invalidTeams = teams.filter((team)=>!team.includesYou && team.orgId !== currentOrgId && team.orgId !== orgARI);
    if (invalidTeams.length) {
        const logTeamsData = invalidTeams.map((t)=>({
                teamId: t.id,
                orgId: t.orgId
            }));
        analytics.pushOperationalEvent({
            source: (0, $fyzT1.AnalyticsEventSource).CLIENT_METRICS,
            actionSubject: 'TeamOrgMismatch',
            action: (0, $fyzT1.AnalyticsEventActions).FAILED,
            attributes: {
                currentOrgId: currentOrgId,
                queryName: queryName
            }
        });
        (0, $a2luh.logErrorMessage)('TeamOrgMismatch', {
            currentOrgId: currentOrgId,
            teams: logTeamsData
        });
    }
}

});

parcelRegister("IZxaE", function(module, exports) {

$parcel$export(module.exports, "default", () => $5eda80d9671a85e6$export$2e2bcd8739ae039);

var $5cllN = parcelRequire("5cllN");
var $5eda80d9671a85e6$export$2e2bcd8739ae039 = (0, $5cllN.default)`
	query teamSearchV2(
		$first: Int
		$after: String
		$organizationId: ID!
		$query: String = ""
		$memberIds: [ID] = []
		$sortBy: [TeamSort]
		$siteId: String!
		$showEmptyTeams: Boolean = false
	) {
		team {
			teamSearch: teamSearchV2(
				first: $first
				after: $after
				organizationId: $organizationId
				filter: { query: $query, membership: { memberIds: $memberIds } }
				sortBy: $sortBy
				siteId: $siteId
				showEmptyTeams: $showEmptyTeams
			) @optIn(to: ["Team-search-v2"]) {
				nodes {
					...TeamNodeV2
				}
				pageInfo {
					hasNextPage
					endCursor
				}
			}
		}
	}

	fragment TeamNodeV2 on TeamSearchResultV2 {
		team {
			id
			organizationId
			membershipSettings
			description
			displayName
			state
			largeAvatarImageUrl
			smallAvatarImageUrl
			largeHeaderImageUrl
			smallHeaderImageUrl
			isVerified
			members {
				nodes {
					member {
						id
						accountStatus
						name
						picture
					}
				}
			}
		}
		memberCount
		includesYou
	}
`;

});

parcelRegister("cBElP", function(module, exports) {

$parcel$export(module.exports, "sortBy", () => $8f9cf413c2b990dc$export$b035e44d7bb4278f);
const $8f9cf413c2b990dc$export$b035e44d7bb4278f = [
    {
        field: 'DISPLAY_NAME',
        order: 'ASC'
    }
];

});


parcelRegister("1tSRh", function(module, exports) {

$parcel$export(module.exports, "default", () => $88d4c4aa4b3f9ebd$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $88d4c4aa4b3f9ebd$var$InfiniteScroller = ({ hasMore: hasMore, children: children, loadMore: loadMore, loader: loader, isLoading: isLoading })=>{
    const loadMoreRef = (0, $5uXOq.useRef)(null);
    const fetchMoreCallback = (0, $5uXOq.useCallback)(([loadMoreEntry])=>{
        // Automatically load more data when our invisible "load more" div is within the viewport
        if (loadMoreEntry.isIntersecting && hasMore && !isLoading) loadMore();
    }, [
        loadMore,
        hasMore,
        isLoading
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const intersectionObserver = new IntersectionObserver(fetchMoreCallback);
        if (loadMoreRef.current) intersectionObserver.observe(loadMoreRef.current);
        return ()=>{
            intersectionObserver.disconnect();
        };
    }, [
        loadMoreRef,
        fetchMoreCallback
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            children,
            hasMore && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                ref: loadMoreRef
            }),
            hasMore && loader
        ]
    });
};
var $88d4c4aa4b3f9ebd$export$2e2bcd8739ae039 = $88d4c4aa4b3f9ebd$var$InfiniteScroller;

});

parcelRegister("63MVP", function(module, exports) {

$parcel$export(module.exports, "AboutContent", () => $b61421aa0c933c13$export$8197a708459a0877);
$parcel$export(module.exports, "EmptyState", () => $b61421aa0c933c13$export$fddf379e22a74b00);
$parcel$export(module.exports, "AboutSectionTitle", () => $b61421aa0c933c13$export$c9a3ce67560199a2);
$parcel$export(module.exports, "AboutItemList", () => $b61421aa0c933c13$export$b7e7108d011c572b);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");
const $b61421aa0c933c13$export$8197a708459a0877 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1m5ose4-0"
})``;
const $b61421aa0c933c13$export$fddf379e22a74b00 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1m5ose4-1"
})`display:flex;flex-direction:column;align-items:center;width:200px;margin:${"var(--ds-space-500, 40px)"} auto ${"var(--ds-space-200, 16px)"};text-align:center;p{margin-top:${"var(--ds-space-400, 32px)"};}`;
const $b61421aa0c933c13$export$c9a3ce67560199a2 = /*#__PURE__*/ (0, $47bDC.default).h2.withConfig({
    componentId: "sc-1m5ose4-2"
})`font:${"var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};margin-top:${"var(--ds-space-300, 24px)"};margin-bottom:${"var(--ds-space-200, 16px)"};`;
const $b61421aa0c933c13$export$b7e7108d011c572b = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1m5ose4-3"
})`>:not(:last-child){margin-bottom:${"var(--ds-space-050, 4px)"};}`;

});

parcelRegister("4V0ms", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ba54ba354d50e52$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $VSDnB = parcelRequire("VSDnB");

var $f5TWP = parcelRequire("f5TWP");

var $fuhQD = parcelRequire("fuhQD");

var $dIjuX = parcelRequire("dIjuX");

var $lfJPE = parcelRequire("lfJPE");

var $i8owa = parcelRequire("i8owa");

var $2s6UE = parcelRequire("2s6UE");

var $bnMl7 = parcelRequire("bnMl7");
const $2ba54ba354d50e52$var$findMemberText = (isCurrentUser, team)=>{
    let messageData;
    if (isCurrentUser) messageData = (0, $2s6UE.messages).membersPlain;
    else messageData = team.includesYou ? (0, $2s6UE.messages).membersIncludingYou : (0, $2s6UE.messages).membersPlain;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...messageData,
        values: {
            memberCount: team.memberCount
        }
    });
};
function $2ba54ba354d50e52$export$2e2bcd8739ae039(props) {
    const { team: team, isCurrentUser: isCurrentUser, index: index, onClick: onClick } = props;
    const handleClick = (0, $5uXOq.useCallback)((e)=>{
        if (onClick) onClick(e, index);
    }, [
        index,
        onClick
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i8owa.default), {
        teamId: team.id,
        trigger: "hover",
        triggerLinkType: "none",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dIjuX.StyledOutlineLink), {
            onClick: handleClick,
            href: `team/${team.id}`,
            tabIndex: 0,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)($bnMl7.TeamsProfileItemWrapper, {
                tabIndex: -1,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)($bnMl7.TeamsProfileItemAvatar, {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lfJPE.default), {
                            teamId: team.id,
                            avatarUrl: team.smallAvatarImageUrl
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)($bnMl7.TeamsProfileItemBody, {
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $f5TWP.default), {
                                alignBlock: "center",
                                children: [
                                    /*#__PURE__*/ (0, $2OMIu.jsx)($bnMl7.TeamsProfileItemTeamName, {
                                        children: team.displayName
                                    }),
                                    team.isVerified && (0, $VSDnB.fg)('verified-icon-directory') && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fuhQD.VerifiedTeamIcon), {
                                        showTooltip: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)($bnMl7.TeamsProfileItemTeamMembers, {
                                children: $2ba54ba354d50e52$var$findMemberText(isCurrentUser, team)
                            })
                        ]
                    })
                ]
            })
        })
    });
}

});
parcelRegister("dIjuX", function(module, exports) {

$parcel$export(module.exports, "StyledOutlineLink", () => $e9005ae84efc39a3$export$2311a2c1c380abc1);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");


var $3FhRS = parcelRequire("3FhRS");
const $e9005ae84efc39a3$export$2311a2c1c380abc1 = /*#__PURE__*/ (0, $47bDC.default)((0, $3FhRS.default)).withConfig({
    componentId: "bs9apg-0"
})`display:block;background-color:${`var(--ds-surface, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`};border:none;padding:0;&:hover{background-color:${`var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`};cursor:pointer;border-radius:${"var(--ds-border-radius-100, 3px)"};}&:focus{background-color:${`var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`};outline:none;box-shadow:0 0 0 2px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`};border-radius:${"var(--ds-border-radius-100, 3px)"};transition:box-shadow 0.2s ease-in-out;}&:active{background-color:${`var(--ds-background-neutral-subtle-pressed, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`};}> *:focus{outline:none;}`;

});

parcelRegister("lfJPE", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b4e321af1c46210$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $fwSAz = parcelRequire("fwSAz");

var $jKZpe = parcelRequire("jKZpe");

var $cUZxE = parcelRequire("cUZxE");

var $bqdXp = parcelRequire("bqdXp");
const $2b4e321af1c46210$var$TeamAvatarLegacy = ({ avatarUrl: avatarUrl, teamId: teamId })=>{
    const [hasError, setError] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        setError(false);
    }, [
        avatarUrl,
        teamId
    ]);
    if (hasError) return /*#__PURE__*/ (0, $2OMIu.jsx)($bqdXp.GradientImage, {
        gradientValues: (0, $cUZxE.getColorFromString)(teamId)
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($bqdXp.Image, {
        src: avatarUrl,
        onError: ()=>setError(true),
        alt: ""
    });
};
function $2b4e321af1c46210$export$49e1e29e42184983(props) {
    if ((0, $VSDnB.fg)('enable-team-avatar-switch')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fwSAz.default), {
        src: props.avatarUrl,
        size: "small"
    });
    if ((0, $VSDnB.fg)('use_consistent_default_gradient_component')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jKZpe.TeamAvatar), {
        ...props
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($2b4e321af1c46210$var$TeamAvatarLegacy, {
        ...props
    });
}
var $2b4e321af1c46210$export$2e2bcd8739ae039 = $2b4e321af1c46210$export$49e1e29e42184983;

});
parcelRegister("jKZpe", function(module, exports) {

$parcel$export(module.exports, "TeamAvatar", () => $7ca6b55e1807b410$export$49e1e29e42184983);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $fwSAz = parcelRequire("fwSAz");

var $dNl82 = parcelRequire("dNl82");

var $lsJSD = parcelRequire("lsJSD");

var $3EjI7 = parcelRequire("3EjI7");
const $7ca6b55e1807b410$var$fallbackStyle = {
    fallbackStyle: "_2rko14q2 _1bsb1tcg _4t3i1tcg _19pkv77o _2hwxv77o _otyrv77o _18u0v77o"
};
const $7ca6b55e1807b410$export$49e1e29e42184983 = ({ avatarUrl: avatarUrl, teamId: teamId, size: size = 'small' })=>{
    const [hasError, setError] = (0, $5uXOq.useState)(false);
    const [hasLoaded, setLoaded] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        setError(false);
        setLoaded(false);
    }, [
        avatarUrl,
        teamId
    ]);
    if (hasError) return (0, $VSDnB.fg)('use_consistent_default_gradient_component') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lsJSD.FallbackGradient), {
        stringToHash: teamId,
        xcss: $7ca6b55e1807b410$var$fallbackStyle
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($3EjI7.GradientImage, {
        gradientValues: (0, $dNl82.getColorFromString)(teamId)
    });
    return (0, $VSDnB.fg)('enable-team-avatar-switch') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fwSAz.default), {
        size: size,
        src: avatarUrl
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($3EjI7.Image, {
        src: avatarUrl,
        onError: ()=>setError(true),
        onLoad: ()=>setLoaded(true),
        hasLoaded: hasLoaded,
        alt: ""
    });
};

});
parcelRegister("dNl82", function(module, exports) {

$parcel$export(module.exports, "getColorFromString", () => $4c28c89e6d57b14f$export$137ec5185b12f5a2);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
const $4c28c89e6d57b14f$var$gradients = [
    `270deg, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)} 0%, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)} 100%`,
    `270deg, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)} 0%, ${(0, $829f609a65d26a98$export$be802dd0d8b57f35)} 100%`,
    `270deg, ${(0, $829f609a65d26a98$export$363e4475840015bb)} 0%, ${(0, $829f609a65d26a98$export$4b0a4417ed59760f)} 100%`,
    `270deg, ${(0, $829f609a65d26a98$export$226de0355ed012f8)} 0%, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)} 100%`,
    `270deg, ${(0, $829f609a65d26a98$export$7a8f4d33f6f9772c)} 0%, ${(0, $829f609a65d26a98$export$776c9c497ef08533)} 100%`,
    `270deg, ${(0, $829f609a65d26a98$export$8a6341c32b6a3ee6)} 0%, ${(0, $829f609a65d26a98$export$afbce1382ec95f73)} 100%`,
    `270deg, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)} 0%, ${(0, $829f609a65d26a98$export$5aae31392d72caaa)} 100%`
];
const $4c28c89e6d57b14f$export$d41d9ab3de2def3d = (str)=>{
    let hash = 0;
    let chr;
    let i;
    for(i = 0; i < str.length; i++){
        chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
};
const $4c28c89e6d57b14f$export$1ca062359344df12 = (id)=>{
    return $4c28c89e6d57b14f$export$489ac0f4353bcbd0(id, $4c28c89e6d57b14f$var$gradients.length);
};
const $4c28c89e6d57b14f$export$489ac0f4353bcbd0 = (id, arrayLength)=>{
    if (!id) return 0;
    const ordinal = ($4c28c89e6d57b14f$export$d41d9ab3de2def3d(id) % 50).toString()// split string into character array
    .split('')// map to array of charCodes of each character
    .map((chr)=>chr.charCodeAt(0))// add up all charCodes in the array
    .reduce((a, b)=>a + b, 0);
    return ordinal % arrayLength;
};
const $4c28c89e6d57b14f$export$137ec5185b12f5a2 = (str)=>{
    const index = $4c28c89e6d57b14f$export$1ca062359344df12(str);
    return $4c28c89e6d57b14f$var$gradients[index];
};

});

parcelRegister("lsJSD", function(module, exports) {

$parcel$export(module.exports, "FallbackGradient", () => $5dec12b98688a40c$export$358466f81685c10c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $9Raxt = parcelRequire("9Raxt");
const $5dec12b98688a40c$var$CSS_VAR_GRADIENT = '--fallback-gradient-background-image-value';
const $5dec12b98688a40c$var$gradients = [
    '270deg, #DFE1E6 0%, #A5ADBA 100%',
    '270deg, #FFEBE6 0%, #FF8F73 100%',
    '270deg, #EAE6FF 0%, #C0B6F2 100%',
    '270deg, #DEEBFF 0%, #4C9AFF 100%',
    '270deg, #B3F5FF 0%, #79E2F2 100%',
    '270deg, #E3FCEF 0%, #79F2C0 100%',
    '270deg, #FFF0B3 0%, #FFC400 100%'
];
const $5dec12b98688a40c$var$styles = {
    container: "_1reo15vq _18m915vq _1bsb1osq _4t3i1osq _1lrw1dfr _ouxl1ssb _1itky1j3"
};
function $5dec12b98688a40c$export$358466f81685c10c(props) {
    const gradientIndex = (0, $5uXOq.useMemo)(()=>(0, $9Raxt.getGradientIndexByString)(props.stringToHash), [
        props.stringToHash
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            $5dec12b98688a40c$var$styles.container,
            props.xcss
        ]),
        style: {
            [$5dec12b98688a40c$var$CSS_VAR_GRADIENT]: `linear-gradient(${$5dec12b98688a40c$var$gradients[gradientIndex]})`
        },
        "data-testid": "profile-header-image-default",
        children: props.children
    });
}

});
parcelRegister("9Raxt", function(module, exports) {

$parcel$export(module.exports, "getGradientIndexByString", () => $27a708f157850eb9$export$47d4d34461987b5d);

var $3faAi = parcelRequire("3faAi");
// Code to generate index number from ids is taken from:
// src/master/src/static/gradients/README.md
/**
 * Generate 32bit integer from given string
 */ const $27a708f157850eb9$var$hashCode = (str)=>{
    let hash = 0;
    let chr;
    let i;
    for(i = 0; i < str.length; i++){
        chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
};
const $27a708f157850eb9$export$47d4d34461987b5d = (id)=>{
    if (!id) return 0;
    const ordinal = ($27a708f157850eb9$var$hashCode(id) % 50).toString()// split string into character array
    .split('')// map to array of charCodes of each character
    .map((chr)=>chr.charCodeAt(0))// add up all charCodes in the array
    .reduce((a, b)=>a + b, 0);
    return ordinal % (0, $3faAi.gradients).length;
};
const $27a708f157850eb9$export$137ec5185b12f5a2 = (str)=>{
    const index = $27a708f157850eb9$export$47d4d34461987b5d(str);
    return (0, $3faAi.gradients)[index];
};

});
parcelRegister("3faAi", function(module, exports) {

$parcel$export(module.exports, "gradients", () => $038a2a65968c6faa$export$fc5727d09955ec17);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
const $038a2a65968c6faa$export$fc5727d09955ec17 = [
    `270deg, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)} 0%, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)} 100%`,
    `270deg, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)} 0%, ${(0, $829f609a65d26a98$export$be802dd0d8b57f35)} 100%`,
    `270deg, ${(0, $829f609a65d26a98$export$363e4475840015bb)} 0%, ${(0, $829f609a65d26a98$export$4b0a4417ed59760f)} 100%`,
    `270deg, ${(0, $829f609a65d26a98$export$226de0355ed012f8)} 0%, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)} 100%`,
    `270deg, ${(0, $829f609a65d26a98$export$7a8f4d33f6f9772c)} 0%, ${(0, $829f609a65d26a98$export$776c9c497ef08533)} 100%`,
    `270deg, ${(0, $829f609a65d26a98$export$8a6341c32b6a3ee6)} 0%, ${(0, $829f609a65d26a98$export$afbce1382ec95f73)} 100%`,
    `270deg, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)} 0%, ${(0, $829f609a65d26a98$export$5aae31392d72caaa)} 100%`
];

});



parcelRegister("3EjI7", function(module, exports) {

$parcel$export(module.exports, "GradientImage", () => $03e345e45b6033d1$export$cf9c515a80d2f7a4);
$parcel$export(module.exports, "Image", () => $03e345e45b6033d1$export$3e431a229df88919);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation (causes type issues)
const $03e345e45b6033d1$var$commonCss = /*#__PURE__*/ (0, $47bDC.css)`width:24px;height:24px;border-radius:50%;margin:${"var(--ds-space-025, 2px)"};display:flex;`;
const $03e345e45b6033d1$export$cf9c515a80d2f7a4 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1vmhbf4-0"
})`${$03e345e45b6033d1$var$commonCss};background-image:linear-gradient(${(props)=>props.gradientValues});`;
const $03e345e45b6033d1$export$3e431a229df88919 = /*#__PURE__*/ (0, $47bDC.default).img.withConfig({
    componentId: "sc-1vmhbf4-1"
})`${$03e345e45b6033d1$var$commonCss};opacity:${(props)=>props.hasLoaded ? 1 : 0};`;

});


parcelRegister("cUZxE", function(module, exports) {

$parcel$export(module.exports, "getColorFromString", () => $002f08c88fb75dc0$export$137ec5185b12f5a2);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
const $002f08c88fb75dc0$var$gradients = [
    `270deg, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)} 0%, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)} 100%`,
    `270deg, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)} 0%, ${(0, $829f609a65d26a98$export$be802dd0d8b57f35)} 100%`,
    `270deg, ${(0, $829f609a65d26a98$export$363e4475840015bb)} 0%, ${(0, $829f609a65d26a98$export$4b0a4417ed59760f)} 100%`,
    `270deg, ${(0, $829f609a65d26a98$export$226de0355ed012f8)} 0%, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)} 100%`,
    `270deg, ${(0, $829f609a65d26a98$export$7a8f4d33f6f9772c)} 0%, ${(0, $829f609a65d26a98$export$776c9c497ef08533)} 100%`,
    `270deg, ${(0, $829f609a65d26a98$export$8a6341c32b6a3ee6)} 0%, ${(0, $829f609a65d26a98$export$afbce1382ec95f73)} 100%`,
    `270deg, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)} 0%, ${(0, $829f609a65d26a98$export$5aae31392d72caaa)} 100%`
];
const $002f08c88fb75dc0$export$d41d9ab3de2def3d = (str)=>{
    let hash = 0;
    let chr;
    let i;
    for(i = 0; i < str.length; i++){
        chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
};
const $002f08c88fb75dc0$export$1ca062359344df12 = (id)=>{
    if (!id) return 0;
    const ordinal = ($002f08c88fb75dc0$export$d41d9ab3de2def3d(id) % 50).toString()// split string into character array
    .split('')// map to array of charCodes of each character
    .map((chr)=>chr.charCodeAt(0))// add up all charCodes in the array
    .reduce((a, b)=>a + b, 0);
    return ordinal % $002f08c88fb75dc0$var$gradients.length;
};
const $002f08c88fb75dc0$export$137ec5185b12f5a2 = (str)=>{
    const index = $002f08c88fb75dc0$export$1ca062359344df12(str);
    return $002f08c88fb75dc0$var$gradients[index];
};

});

parcelRegister("bqdXp", function(module, exports) {

$parcel$export(module.exports, "GradientImage", () => $3ee3eead741e4383$export$cf9c515a80d2f7a4);
$parcel$export(module.exports, "Image", () => $3ee3eead741e4383$export$3e431a229df88919);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ // eslint-disable-next-line @repo/internal/styles/use-emotion, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
const $3ee3eead741e4383$var$commonCss = /*#__PURE__*/ (0, $47bDC.css)`width:24px;height:24px;border-radius:50%;margin:${"var(--ds-space-025, 2px)"};display:flex;`;
const $3ee3eead741e4383$export$cf9c515a80d2f7a4 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-3e4kix-0"
})`${$3ee3eead741e4383$var$commonCss};background-image:linear-gradient(${(props)=>props.gradientValues});`;
const $3ee3eead741e4383$export$3e431a229df88919 = /*#__PURE__*/ (0, $47bDC.default).img.withConfig({
    componentId: "sc-3e4kix-1"
})`${$3ee3eead741e4383$var$commonCss};`;

});


parcelRegister("i8owa", function(module, exports) {

$parcel$export(module.exports, "default", () => $825ddc5263532777$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $4P8xB = parcelRequire("4P8xB");

var $fff3y = parcelRequire("fff3y");
var $5WmsO = parcelRequire("5WmsO");
var $levfe = parcelRequire("levfe");

var $7qFce = parcelRequire("7qFce");

var $39CLR = parcelRequire("39CLR");

var $2FwA3 = parcelRequire("2FwA3");
var $fPHPe = parcelRequire("fPHPe");
function $825ddc5263532777$export$2e2bcd8739ae039(props) {
    const { children: children, onClick: onClick, position: position = 'bottom-start', trigger: trigger = 'hover', triggerLinkType: triggerLinkType = 'link', teamId: teamId } = props;
    const [{ cloudId: cloudId }] = (0, $5WmsO.useSite)();
    const addFlag = (0, $fPHPe.useFlags)();
    const { contextEntryPoint: contextEntryPoint, push: push } = (0, $2FwA3.useAppConfig)();
    const profileClient = (0, $7qFce.useProfileClient)();
    const [{ principalUserId: principalUserId }] = (0, $fff3y.usePrincipalUser)();
    const { orgId: orgId, isOrgLoading: isOrgLoading } = (0, $levfe.useV3OrgIdStatus)();
    const navigateToTeam = (0, $5uXOq.useCallback)(()=>push(`team/${teamId}`), [
        push,
        teamId
    ]);
    const generateUserLink = (0, $5uXOq.useCallback)((userId)=>(0, $39CLR.prefixWithContextEntryPoint)(userId, contextEntryPoint), [
        contextEntryPoint
    ]);
    const onUserClick = (0, $5uXOq.useCallback)((userId)=>push(userId), [
        push
    ]);
    if (isOrgLoading) return children;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4P8xB.default), {
        position: position,
        orgId: orgId,
        teamId: teamId,
        resourceClient: profileClient,
        viewingUserId: principalUserId,
        trigger: trigger,
        triggerLinkType: triggerLinkType,
        viewProfileLink: (0, $39CLR.prefixWithContextEntryPoint)(`team/${teamId}`, contextEntryPoint),
        viewProfileOnClick: onClick || navigateToTeam,
        generateUserLink: generateUserLink,
        onUserClick: onUserClick,
        addFlag: addFlag,
        cloudId: cloudId,
        children: children
    });
}

});
parcelRegister("4P8xB", function(module, exports) {

$parcel$export(module.exports, "default", () => $3295fbeb3692567b$export$2e2bcd8739ae039);
// Do not export TeamProfileCard here as it will break lazy-loading for the team trigger.


var $6uTwi = parcelRequire("6uTwi");
var $3295fbeb3692567b$export$2e2bcd8739ae039 = (0, $6uTwi.default);

});
parcelRegister("6uTwi", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a486335f4f64442$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $8RXs9 = parcelRequire("8RXs9");

var $cb25w = parcelRequire("cb25w");

var $adIkV = parcelRequire("adIkV");
var $gH4E9 = parcelRequire("gH4E9");

var $VSDnB = parcelRequire("VSDnB");

var $1I7E8 = parcelRequire("1I7E8");

var $dC5iT = parcelRequire("dC5iT");

var $k5uoT = parcelRequire("k5uoT");

var $4sfdL = parcelRequire("4sfdL");

var $9MMkr = parcelRequire("9MMkr");

var $ivXTE = parcelRequire("ivXTE");

var $dv9z3 = parcelRequire("dv9z3");


var $6TKEY = parcelRequire("6TKEY");

var $gMO5Q = parcelRequire("gMO5Q");

var $lpWVl = parcelRequire("lpWVl");

var $devOt = parcelRequire("devOt");
class $6a486335f4f64442$export$f811dc569217c959 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    static{
        this.defaultProps = {
            actions: [],
            trigger: 'hover',
            position: 'bottom-start',
            triggerLinkType: 'link',
            shouldRenderToParent: true
        };
    }
    componentDidMount() {
        this._isMounted = true;
    }
    componentDidUpdate(prevProps) {
        const { orgId: orgId, teamId: teamId, resourceClient: resourceClient } = this.props;
        const { visible: visible } = this.state;
        // just re-fetching data when the card opens
        if (visible && (teamId !== prevProps.teamId || orgId !== prevProps.orgId || resourceClient !== prevProps.resourceClient)) this.setState({
            isLoading: undefined
        }, this.clientFetchProfile);
    }
    componentWillUnmount() {
        this._isMounted = false;
        clearTimeout(this.showTimer);
        clearTimeout(this.hideTimer);
    }
    handleClientSuccess(team, shouldShowGiveKudos, teamCentralBaseUrl) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: false,
            data: team,
            shouldShowGiveKudos: shouldShowGiveKudos,
            teamCentralBaseUrl: teamCentralBaseUrl
        });
    }
    handleClientError(err) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: true,
            error: err
        });
    }
    filterActions() {
        const actions = (0, $4sfdL.default)(this.props.actions, this.state.data);
        if (this.state.shouldShowGiveKudos) {
            const kudosAction = {
                label: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $9MMkr.default).giveKudosButton
                }),
                id: 'give-kudos',
                callback: ()=>{
                    this.openKudosDrawer();
                },
                link: this.kudosUrl()
            };
            return actions.concat([
                kudosAction
            ]);
        }
        return actions;
    }
    renderPopup() {
        if (this.state.renderError) return this.props.children;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gMO5Q.ErrorBoundary), {
            onError: this.onErrorBoundary,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1I7E8.default), {
                isOpen: !!this.state.visible,
                onClose: this.onClose,
                placement: this.props.position,
                content: this.renderProfileCard,
                trigger: (triggerProps)=>this.renderTrigger(triggerProps),
                zIndex: (0, $k5uoT.layers).modal(),
                shouldFlip: true,
                autoFocus: this.props.trigger !== 'hover' && !this.openedByHover,
                shouldRenderToParent: (0, $VSDnB.fg)('enable_appropriate_reading_order_in_profile_card') && this.props.shouldRenderToParent
            })
        });
    }
    render() {
        if (this.props.children) return this.renderPopup();
        else throw new Error('Component "TeamProfileCardTrigger" must have "children" property');
    }
    constructor(...args){
        super(...args), this._isMounted = false, this.showTimer = 0, this.hideTimer = 0, this.openedByHover = false, this.openTime = 0, this.fireAnalytics = (payload)=>{
            // Don't fire any analytics if the component is unmounted
            if (!this._isMounted) return;
            if (this.props.createAnalyticsEvent) (0, $ivXTE.fireEvent)(this.props.createAnalyticsEvent, payload);
        }, this.fireAnalyticsWithDuration = (generator)=>{
            const event = generator((0, $6TKEY.getPageTime)() - this.openTime);
            this.fireAnalytics(event);
        }, this.hideProfilecard = (delay = 0)=>{
            clearTimeout(this.showTimer);
            clearTimeout(this.hideTimer);
            this.hideTimer = window.setTimeout(()=>{
                this.setState({
                    visible: false
                });
            }, delay);
        }, this.showProfilecard = (delay = 0)=>{
            clearTimeout(this.hideTimer);
            clearTimeout(this.showTimer);
            this.showTimer = window.setTimeout(()=>{
                if (!this.state.visible) {
                    this.clientFetchProfile();
                    this.openTime = (0, $6TKEY.getPageTime)();
                    this.setState({
                        visible: true
                    });
                }
            }, delay);
        }, this.onClick = (event)=>{
            if (this.props.triggerLinkType === 'link') // We want to prevent navigation occurring on basic click, but it's important that
            // cmd+click, ctrl+click, etc. still work as expected.
            {
                if ((0, $dv9z3.isBasicClick)(event)) event.preventDefault();
            }
            if (this.props.triggerLinkType === 'clickable-link') {
                if (this.props.viewProfileOnClick) this.props.viewProfileOnClick(event);
            }
            if (this.props.trigger !== 'hover') {
                this.openedByHover = false;
                this.showProfilecard(0);
                if (!this.state.visible) this.fireAnalytics((0, $ivXTE.cardTriggered)('team', 'click', this.props.teamId));
            }
        }, this.onMouseEnter = ()=>{
            if (this.props.trigger === 'click') return;
            if (!this.state.visible) {
                this.openedByHover = true;
                this.fireAnalytics((0, $ivXTE.cardTriggered)('team', 'hover', this.props.teamId));
            }
            this.showProfilecard((0, $e41878b3b8cab0db$export$5b956b542f1bc1b3));
        }, this.onMouseLeave = ()=>{
            if (this.props.trigger === 'click') return;
            if (this.openedByHover) this.hideProfilecard((0, $e41878b3b8cab0db$export$89a9f35a94d7f196));
        }, this.onKeyPress = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.setState({
                    isTriggeredByKeyboard: true
                });
                this.showProfilecard(0);
                if (!this.state.visible) this.fireAnalytics((0, $ivXTE.cardTriggered)('team', 'click', this.props.teamId));
            }
        }, this.onClose = ()=>{
            this.hideProfilecard();
            this.setState({
                isTriggeredByKeyboard: false
            });
        }, this.openKudosDrawer = ()=>{
            this.hideProfilecard((0, $e41878b3b8cab0db$export$89a9f35a94d7f196));
            this.setState({
                kudosDrawerOpen: true
            });
        }, this.closeKudosDrawer = ()=>{
            this.setState({
                kudosDrawerOpen: false
            });
        }, this.kudosUrl = ()=>{
            const recipientId = this.props.teamId && `&recipientId=${this.props.teamId}` || '';
            const cloudId = this.props.cloudId && `&cloudId=${this.props.cloudId}` || '';
            return `${this.state.teamCentralBaseUrl}/kudos/give?type=team${recipientId}${cloudId}`;
        }, this.stopPropagation = (event)=>{
            // We need to stop propagation when users click on the card, so that it
            // doesn't trigger any special effects that occur when clicking the trigger.
            event.stopPropagation();
        }, this.triggerListeners = {
            onClick: this.onClick,
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave
        }, this.cardListeners = {
            onClick: this.stopPropagation,
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave
        }, this.state = {
            visible: false,
            isLoading: undefined,
            hasError: false,
            error: null,
            data: null,
            shouldShowGiveKudos: false,
            teamCentralBaseUrl: undefined,
            kudosDrawerOpen: false,
            isTriggeredByKeyboard: false
        }, this.clientFetchProfile = ()=>{
            const { orgId: orgId, teamId: teamId } = this.props;
            const { isLoading: isLoading } = this.state;
            if (isLoading === true) // don't fetch data when fetching is in process
            return;
            this.setState({
                isLoading: true,
                data: null
            }, ()=>{
                const fireEvent = (event)=>{
                    this.fireAnalytics(event);
                };
                const requests = Promise.all([
                    this.props.resourceClient.getTeamProfile(teamId, orgId, fireEvent),
                    this.props.resourceClient.shouldShowGiveKudos(),
                    this.props.resourceClient.getTeamCentralBaseUrl({
                        withOrgContext: true,
                        withSiteContext: true
                    })
                ]);
                requests.then((res)=>this.handleClientSuccess(...res), (err)=>this.handleClientError(err)).catch((err)=>this.handleClientError(err));
            });
        }, this.onErrorBoundary = ()=>{
            this.fireAnalytics((0, $ivXTE.profileCardRendered)('team', 'errorBoundary', {
                duration: 0
            }));
            this.setState({
                renderError: true
            });
        }, this.renderProfileCard = ()=>{
            const { generateUserLink: generateUserLink, onUserClick: onUserClick, viewingUserId: viewingUserId, viewProfileLink: viewProfileLink, viewProfileOnClick: viewProfileOnClick } = this.props;
            const { data: data, error: error, hasError: hasError, isLoading: isLoading } = this.state;
            const newProps = {
                clientFetchProfile: this.clientFetchProfile,
                actions: this.filterActions(),
                analytics: this.fireAnalyticsWithDuration,
                team: data || undefined,
                generateUserLink: generateUserLink,
                onUserClick: onUserClick,
                viewingUserId: viewingUserId,
                viewProfileLink: viewProfileLink,
                viewProfileOnClick: viewProfileOnClick
            };
            return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                ...this.cardListeners,
                children: this.state.visible && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                    fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $devOt.default), {
                        analytics: this.fireAnalyticsWithDuration
                    }),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lpWVl.TeamProfileCardLazy), {
                        ...newProps,
                        isLoading: isLoading,
                        hasError: hasError,
                        errorType: error,
                        isTriggeredByKeyboard: this.state.isTriggeredByKeyboard
                    })
                })
            });
        }, this.renderKudosLauncher = ()=>{
            return this.state.shouldShowGiveKudos && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $adIkV.GiveKudosLauncherLazy), {
                    isOpen: this.state.kudosDrawerOpen,
                    recipient: {
                        type: (0, $gH4E9.KudosType).TEAM,
                        recipientId: this.props.teamId
                    },
                    analyticsSource: "team-profile-card",
                    teamCentralBaseUrl: this.state.teamCentralBaseUrl,
                    cloudId: this.props.cloudId || '',
                    addFlag: this.props.addFlag,
                    onClose: this.closeKudosDrawer
                })
            });
        }, this.renderTrigger = (triggerProps)=>{
            const { children: children, intl: intl, triggerLinkType: triggerLinkType, viewProfileLink: viewProfileLink } = this.props;
            if (triggerLinkType === 'none') return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    this.renderKudosLauncher(),
                    (0, $VSDnB.fg)('enable_team_profilecard_toggletip_a11y_fix') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                        as: "span",
                        role: "button",
                        testId: "team-profilecard-trigger-wrapper",
                        tabIndex: 0,
                        "aria-label": intl.formatMessage((0, $9MMkr.default).teamProfileCardAriaLabel),
                        onKeyUp: this.onKeyPress,
                        ...triggerProps,
                        ...this.triggerListeners,
                        children: children
                    }) : /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                        "data-testid": "team-profilecard-trigger-wrapper",
                        ...triggerProps,
                        ...this.triggerListeners,
                        children: children
                    })
                ]
            });
            return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    this.renderKudosLauncher(),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
                        "data-testid": "team-profilecard-trigger-wrapper",
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        style: {
                            color: 'initial',
                            textDecoration: 'none'
                        },
                        href: viewProfileLink,
                        ...triggerProps,
                        ref: triggerProps.ref,
                        ...this.triggerListeners,
                        children: children
                    })
                ]
            });
        };
    }
}
var $6a486335f4f64442$export$2e2bcd8739ae039 = (0, $cb25w.default)()((0, $8RXs9.default)($6a486335f4f64442$export$f811dc569217c959));

});
parcelRegister("9MMkr", function(module, exports) {

$parcel$export(module.exports, "default", () => $b852a44de86ce4d8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $b852a44de86ce4d8$var$messages = (0, $7VHMR.defineMessages)({
    inactiveAccountMsg: {
        id: 'pt.profile-card.inactive.account',
        defaultMessage: 'Account deactivated',
        description: 'A text in a grey lozenge shows that this user is inactive'
    },
    generalDescMsgForDisabledUser: {
        id: 'pt.profile-card.general.msg.disabled.user',
        defaultMessage: 'You can no longer collaborate with this person.',
        description: 'A first sentence of a long text explains this user is inactive/closed'
    },
    inactiveAccountDescMsgNoDate: {
        id: 'pt.profile-card.inactive.account.no.date',
        defaultMessage: 'Their account has been deactivated.',
        description: 'A long text explains this user is inactive when we do not know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateThisWeek: {
        id: 'pt.profile-card.inactive.account.has.date.this.week',
        defaultMessage: 'Their account was deactivated this week.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateThisMonth: {
        id: 'pt.profile-card.inactive.account.has.date.this.month',
        defaultMessage: 'Their account was deactivated this month.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateLastMonth: {
        id: 'pt.profile-card.inactive.account.has.date.last.month',
        defaultMessage: 'Their account was deactivated last month.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateAFewMonths: {
        id: 'pt.profile-card.inactive.account.has.date.a.few.months',
        defaultMessage: 'Their account has been deactivated for a few months.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateSeveralMonths: {
        id: 'pt.profile-card.inactive.account.has.date.several.months',
        defaultMessage: 'Their account has been deactivated for several months.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateMoreThanAYear: {
        id: 'pt.profile-card.inactive.account.has.date.more.than.a.year',
        defaultMessage: 'Their account has been deactivated for more than a year.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    closedAccountMsg: {
        id: 'pt.profile-card.closed.account',
        defaultMessage: 'Account deleted',
        description: 'A text in a grey lozenge shows that this user is closed/deleted'
    },
    closedAccountDescMsgNoDate: {
        id: 'pt.profile-card.closed.account.no.date',
        defaultMessage: 'Their account has been deleted.',
        description: 'A long text explains this user is closed when we do not know the date of starting to close'
    },
    closedAccountDescMsgHasDateThisWeek: {
        id: 'pt.profile-card.closed.account.has.date.this.week',
        defaultMessage: 'Their account was deleted this week.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateThisMonth: {
        id: 'pt.profile-card.closed.account.has.date.this.month',
        defaultMessage: 'Their account was deleted this month.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateLastMonth: {
        id: 'pt.profile-card.closed.account.has.date.last.month',
        defaultMessage: 'Their account was deleted last month.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateAFewMonths: {
        id: 'pt.profile-card.closed.account.has.date.a.few.months',
        defaultMessage: 'Their account has been deleted for a few months.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateSeveralMonths: {
        id: 'pt.profile-card.closed.account.has.date.several.months',
        defaultMessage: 'Their account has been deleted for several months.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateMoreThanAYear: {
        id: 'pt.profile-card.closed.account.has.date.more.than.a.year',
        defaultMessage: 'Their account has been deleted for more than a year.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    disabledAccountDefaultName: {
        id: 'pt.profile-card.disabled.account.default.name',
        defaultMessage: 'Former user',
        description: 'A default name when we cannot get name of an inactive or closed user'
    },
    teamViewProfile: {
        id: 'pt.team-profile-card.team.action.view-profile',
        defaultMessage: 'View profile',
        description: "Button that takes you to view this team\u2019s profile"
    },
    memberCount: {
        id: 'pt.team-profile-card.team.member.count',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}",
        description: 'Byline to show the number of members in the team'
    },
    memberCountIncludingYou: {
        id: 'pt.team-profile-card.team.member.count-including-you',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you",
        description: 'Byline to show the number of members in the team and highlight that the user is a member'
    },
    membersMoreThan50: {
        id: 'pt.team-profile-card.team.member.many',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the team has more than 50 members'
    },
    membersMoreThan50IncludingYou: {
        id: 'pt.team-profile-card.team.member.many-including-you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the team has more than 50 members and highlight that the user is a member'
    },
    teamErrorTitle: {
        id: 'pt.team-profile-card.error.title',
        defaultMessage: "We\u2019re having trouble retrieving this teams information",
        description: 'Title for an error view explaining that data for this team cannot be accessed'
    },
    teamErrorText: {
        id: 'pt.team-profile-card.error.suggestion',
        defaultMessage: 'Wait a few moments, then try again.',
        description: 'Second line suggesting how to fix the issue'
    },
    teamErrorButton: {
        id: 'pt.team-profile-card.error.refresh-button',
        defaultMessage: 'Try again',
        description: 'Text on a button that will try to get the data again when clicked'
    },
    teamForbiddenErrorStateTitle: {
        id: 'pt.team-profile-card.forbidden-error-state.title',
        defaultMessage: "We can\u2019t show you this team",
        description: 'Title for the error state that is displayed when a user lacks access to the team'
    },
    teamForbiddenErrorStateDescription: {
        id: 'pt.team-profile-card.forbidden-error-state.description',
        defaultMessage: "You don\u2019t have access to view this team.",
        description: 'Description for the error state that is displayed when a user lacks access to the team'
    },
    managerSectionHeading: {
        id: 'pt.team-profile-card.manager.heading',
        defaultMessage: 'Manager',
        description: "Title for a section on the profile card that show the user's direct manager"
    },
    directReportsSectionHeading: {
        id: 'pt.team-profile-card.directReports.heading',
        defaultMessage: 'Direct reports',
        description: "Title for a section on the profile card that show the user's direct reports"
    },
    teamProfileCardAriaLabel: {
        id: 'pt.team-profile-card.aria-label',
        defaultMessage: 'More information about this team',
        description: 'Aria label for the team profile card'
    },
    giveKudosButton: {
        id: 'pt.profile-card.give-kudos',
        defaultMessage: 'Give kudos',
        description: 'Title for the button on the profile card for a user to give a kudos'
    },
    profileCardMoreIconLabel: {
        id: 'pt.profile-card.more-icon-label',
        defaultMessage: 'More',
        description: 'Label for the meatballs icon on the profile card, which when clicked will provide more options'
    },
    profileCardMoreReportingLinesLabel: {
        id: 'pt.user-profile-card.reporting-lines.more-icon-label',
        defaultMessage: '+{count} more {count, plural, one {profile} other {profiles}}',
        description: 'Label for the "more profiles" indicator in the reporting lines section of the user profile card'
    },
    profileCardMoreMembersLabel: {
        id: 'pt.team.profile-card.members.more-icon-label',
        defaultMessage: '+{count} more {count, plural, one {members} other {members}}',
        description: 'Label for the "more members" indicator in the members section of the team profile card'
    }
});
var $b852a44de86ce4d8$export$2e2bcd8739ae039 = $b852a44de86ce4d8$var$messages;

});

parcelRegister("dv9z3", function(module, exports) {

$parcel$export(module.exports, "isBasicClick", () => $29a366424d2cda97$export$eddcd8a5b7e09991);
const $29a366424d2cda97$export$eddcd8a5b7e09991 = (event)=>{
    return !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

});

parcelRegister("gMO5Q", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $bd7ac2918bb58c89$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");
class $bd7ac2918bb58c89$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidCatch() {
        // Failure analytics here too
        this.props.onError();
    }
    render() {
        return this.props.children;
    }
}
var $bd7ac2918bb58c89$export$2e2bcd8739ae039 = $bd7ac2918bb58c89$export$e926676385687eaf;

});

parcelRegister("lpWVl", function(module, exports) {

$parcel$export(module.exports, "TeamProfileCardLazy", () => $9bee5bfea0ce3d14$export$82a49d896f41ca78);

var $5uXOq = parcelRequire("5uXOq");

const $9bee5bfea0ce3d14$export$82a49d896f41ca78 = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("05jwM")));

});
parcelRegister("05jwM", function(module, exports) {

let $00ff9d898847b4cc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $00ff9d898847b4cc$var$load("j5SdF").then(()=>parcelRequire('AF8aN'));

});


parcelRegister("devOt", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d55bb5393d16af5$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eZJjh = parcelRequire("eZJjh");

var $ev3cD = parcelRequire("ev3cD");

var $ivXTE = parcelRequire("ivXTE");
var $7d55bb5393d16af5$export$2e2bcd8739ae039 = (props)=>{
    const { analytics: analytics } = props;
    (0, $5uXOq.useEffect)(()=>{
        analytics((duration)=>(0, $ivXTE.profileCardRendered)('team', 'spinner', {
                duration: duration
            }));
    }, [
        analytics
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ev3cD.CardWrapper), {
        testId: "team-profilecard",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ev3cD.CardHeader), {
                isLoading: true
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ev3cD.CardContent), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ev3cD.LoadingWrapper), {
                    testId: "team-profilecard-spinner",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {})
                })
            })
        ]
    });
};

});
parcelRegister("ev3cD", function(module, exports) {

$parcel$export(module.exports, "CardWrapper", () => $e73aadde2fb0e9fd$export$6aa22a823032b784);
$parcel$export(module.exports, "CardHeader", () => $e73aadde2fb0e9fd$export$5665775b26e26c5d);
$parcel$export(module.exports, "CardContent", () => $e73aadde2fb0e9fd$export$64ef9b8c11710c47);
$parcel$export(module.exports, "LoadingWrapper", () => $e73aadde2fb0e9fd$export$43a792a870d28db2);
/* TeamTrigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");


var $k5uoT = parcelRequire("k5uoT");

var $huHkE = parcelRequire("huHkE");

var $lIG7l = parcelRequire("lIG7l");

var $bWGt6 = parcelRequire("bWGt6");
function $e73aadde2fb0e9fd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e73aadde2fb0e9fd$var$styles = {
    cardtriggerwrapper: "_1e0c1kw7",
    cardwrapper: "_2rkoglpi _1bsbnklw _kqswh2mm",
    cardheader: "_4t3i1qr7 _1bsb1osq",
    cardcontent: "_1e0c1txw _2lx21bp4 _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _1tke1l8a",
    loadingwrapper: "_y3gn1h6o _19pk1jfw _otyr1jfw"
};
const $e73aadde2fb0e9fd$export$a443be8291b92497 = ()=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($e73aadde2fb0e9fd$var$styles.cardtriggerwrapper)
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($e73aadde2fb0e9fd$var$CardTriggerWrapperLegacy, {}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $e73aadde2fb0e9fd$var$CardTriggerWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1mr0cum4"
})({
    name: "ck88l6",
    styles: "display:inherit"
});
const $e73aadde2fb0e9fd$export$6aa22a823032b784 = ({ testId: testId, children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($e73aadde2fb0e9fd$var$styles.cardwrapper),
        backgroundColor: "elevation.surface.overlay",
        testId: testId,
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($e73aadde2fb0e9fd$var$CardWrapperLegacy, {
        "data-testid": testId,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $e73aadde2fb0e9fd$var$CardWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1mr0cum3"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: (0, $huHkE.bgColor),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `${(0, $k5uoT.borderRadius)()}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: '320px',
    position: 'relative',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale'
});
const $e73aadde2fb0e9fd$export$5665775b26e26c5d = ({ image: image, isLoading: isLoading, label: label })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? isLoading || !image ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($e73aadde2fb0e9fd$var$styles.cardheader),
        backgroundColor: "color.background.neutral"
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lIG7l.CoverImage), {
        alt: label || '',
        src: image
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($e73aadde2fb0e9fd$var$CardHeaderLegacy, {
        image: image,
        isLoading: isLoading
    }); // eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $e73aadde2fb0e9fd$var$CardHeaderLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1mr0cum2"
})("background-color:", (props)=>props.isLoading ? `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})` : props.image ? '' : (0, $huHkE.teamHeaderBgColor), ";background-image:", (props)=>props.image ? `url(${props.image})` : '', ";background-repeat:no-repeat;background-position:center;background-size:cover;box-sizing:content-box;height:128px;");
const $e73aadde2fb0e9fd$export$64ef9b8c11710c47 = (props)=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($e73aadde2fb0e9fd$var$styles.cardcontent),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($e73aadde2fb0e9fd$var$CardContentLegacy, {
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $e73aadde2fb0e9fd$var$CardContentLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1mr0cum1"
})({
    name: "1rjz27l",
    styles: "display:flex;flex-direction:column;padding:var(--ds-space-300, 24px);min-height:104px"
});
const $e73aadde2fb0e9fd$export$43a792a870d28db2 = (props)=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($e73aadde2fb0e9fd$var$styles.loadingwrapper),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($e73aadde2fb0e9fd$var$LoadingWrapperLegacy, {
        "data-testid": props.testId,
        children: props.children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $e73aadde2fb0e9fd$var$LoadingWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1mr0cum0"
})({
    name: "o13o72",
    styles: "text-align:center;margin-top:var(--ds-space-500, 40px)"
});

});
parcelRegister("lIG7l", function(module, exports) {

$parcel$export(module.exports, "CoverImage", () => $7a600978a76aecd0$export$a65e282337ff0f53);
/* CoverImage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
const $7a600978a76aecd0$var$styles = {
    container: "_1reo15vq _18m915vq _1bsb1osq _4t3i1qr7 _kqswh2mm _13liglpi _qrwqglpi _1e0c1txw _1bah1h6o _4cvr1h6o",
    image: "_1bsbnklw _4t3i1wug"
};
const $7a600978a76aecd0$export$a65e282337ff0f53 = ({ src: src, alt: alt = '' })=>{
    const containerRef = (0, $5uXOq.useRef)(null);
    const imgRef = (0, $5uXOq.useRef)(null);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        ref: containerRef,
        xcss: $7a600978a76aecd0$var$styles.container,
        backgroundColor: "color.background.neutral",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            as: "img",
            ref: imgRef,
            src: src,
            alt: alt,
            xcss: $7a600978a76aecd0$var$styles.image
        })
    });
};

});





parcelRegister("7qFce", function(module, exports) {

$parcel$export(module.exports, "useProfileClient", () => $db3c12495af40804$export$d43dc22a8337ee9f);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $blw2B = parcelRequire("blw2B");

var $4ArtL = parcelRequire("4ArtL");

var $jCvwN = parcelRequire("jCvwN");

var $2FwA3 = parcelRequire("2FwA3");
const $db3c12495af40804$var$CACHE_MAX_AGE = 60000;
function $db3c12495af40804$var$currentClientMatchesConfig(state, enableTeamCentral, cloudId) {
    if (!state.profileClient) return false;
    return state.enableTeamCentral === enableTeamCentral && state.cloudId === cloudId;
}
const $db3c12495af40804$var$actions = {
    getClient: ()=>({ getState: getState, dispatch: dispatch })=>{
            const currentClient = getState().profileClient;
            if (currentClient) return currentClient;
            return dispatch($db3c12495af40804$var$actions.createClient());
        },
    createClient: (enableTeamCentral = false, cloudId = 'None', productName = '')=>({ getState: getState, setState: setState })=>{
            const currentState = getState();
            if ($db3c12495af40804$var$currentClientMatchesConfig(currentState, enableTeamCentral, cloudId)) return currentState.profileClient;
            // Immediately save config to avoid re-create loop
            setState({
                enableTeamCentral: enableTeamCentral,
                cloudId: cloudId
            });
            const { stargateRoot: stargateRoot } = (0, $jCvwN.getConfig)();
            const profileClient = new (0, $blw2B.default)({
                gatewayGraphqlUrl: `${stargateRoot}/graphql`,
                url: `${stargateRoot}/directory/graphql`,
                teamCentralDisabled: !enableTeamCentral,
                cacheSize: 20,
                cacheMaxAge: $db3c12495af40804$var$CACHE_MAX_AGE,
                cloudId: cloudId,
                productIdentifier: productName.toLowerCase()
            });
            setState({
                profileClient: profileClient
            });
            return profileClient;
        }
};
const $db3c12495af40804$var$ProfileClientStore = (0, $iXqE5.createStore)({
    initialState: {
        enableTeamCentral: false,
        cloudId: 'None'
    },
    actions: $db3c12495af40804$var$actions
});
const $db3c12495af40804$var$useProfileClientState = (0, $3sQ5x.createHook)($db3c12495af40804$var$ProfileClientStore);
const $db3c12495af40804$export$d43dc22a8337ee9f = ()=>{
    const [{ hasWorkspace: hasWorkspace, orgHasWorkspace: orgHasWorkspace }] = (0, $4ArtL.useTeamCentralStore)();
    const [state, { getClient: getClient, createClient: createClient }] = $db3c12495af40804$var$useProfileClientState();
    const { cloudId: cloudId, productName: productName } = (0, $2FwA3.useAppConfig)();
    const enableTeamCentral = hasWorkspace || orgHasWorkspace;
    (0, $5uXOq.useEffect)(()=>{
        if (!$db3c12495af40804$var$currentClientMatchesConfig(state, enableTeamCentral, cloudId)) // re-create the client
        createClient(enableTeamCentral, cloudId, productName);
    }, [
        createClient,
        enableTeamCentral,
        state,
        cloudId,
        productName
    ]);
    return getClient();
};

});

parcelRegister("fPHPe", function(module, exports) {

$parcel$export(module.exports, "useFlags", () => $2785bf4a0bb494c9$export$2879604e6aec4ab);

var $5uXOq = parcelRequire("5uXOq");

var $38ra6 = parcelRequire("38ra6");

var $2FwA3 = parcelRequire("2FwA3");
const $2785bf4a0bb494c9$export$2879604e6aec4ab = ()=>{
    const { addFlag: addFlag } = (0, $5uXOq.useContext)((0, $2FwA3.default));
    const analytics = (0, $38ra6.default)();
    const addFlagWithAnalytics = (flag, analyticsEvent)=>{
        if (analyticsEvent?.sendAnalytics) analytics.pushScreenEvent({
            name: analyticsEvent.name
        });
        addFlag(flag);
    };
    return addFlagWithAnalytics;
};

});


parcelRegister("2s6UE", function(module, exports) {

$parcel$export(module.exports, "messages", () => $892e0bd400d4426d$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $892e0bd400d4426d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    membersPlain: {
        id: 'ptc-directory.user-profile-page.about.teams.item.members.plain',
        defaultMessage: '{memberCount, number} {memberCount, plural, one {member} other {members}}',
        description: 'Either the number of members your team has when you are viewing your own profile, or someone elses team that you are not a member of'
    },
    membersIncludingYou: {
        id: 'ptc-directory.user-profile-page.about.teams.item.members.including.you',
        defaultMessage: '{memberCount, number} {memberCount, plural, one {member, including you} other {members, including you}}',
        description: 'The number of team members, when viewing someone elses profile and you are also a member'
    },
    createTeamLabel: {
        id: 'ptc-directory.team-profile-page.create.team.button',
        defaultMessage: 'Create a team',
        description: 'Label of the CTA to create a new team. It is located in the list of teams a user is already a member of'
    },
    createTeamLabelOtherPeople: {
        id: 'ptc-directory.team-profile-page.create.team.button.other-people',
        defaultMessage: 'Create a team together',
        description: 'Label of the CTA to create a new team with other people. It is located in the list of teams a user is already a member of'
    }
});

});

parcelRegister("bnMl7", function(module, exports) {

$parcel$export(module.exports, "OutlineLink", () => $961e84093655be74$export$5749dbf81b0a6091);
$parcel$export(module.exports, "TeamsProfileItemWrapper", () => $961e84093655be74$export$dfa3a67150a99336);
$parcel$export(module.exports, "TeamsProfileItemAvatar", () => $961e84093655be74$export$5b03fe4ece786130);
$parcel$export(module.exports, "TeamsProfileAddIcon", () => $961e84093655be74$export$e26c34d851c862e3);
$parcel$export(module.exports, "TeamsProfileItemBody", () => $961e84093655be74$export$6dae78c6213b453c);
$parcel$export(module.exports, "TeamsProfileItemTeamName", () => $961e84093655be74$export$14cef269f8b93bc1);
$parcel$export(module.exports, "TeamsProfileItemTeamMembers", () => $961e84093655be74$export$b7842987d4a39270);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");


var $dIjuX = parcelRequire("dIjuX");

var $6PHb3 = parcelRequire("6PHb3");
const $961e84093655be74$export$5749dbf81b0a6091 = (0, $dIjuX.StyledOutlineLink).withComponent('button');
const $961e84093655be74$export$dfa3a67150a99336 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-8junt6-0"
})`display:flex;flex-basis:auto;${(0, $6PHb3.ellipsisInFlexChild)} height:${"var(--ds-space-500, 40px)"};align-items:center;`;
const $961e84093655be74$export$5b03fe4ece786130 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-8junt6-1"
})`display:flex;padding-right:${"var(--ds-space-100, 8px)"};`;
const $961e84093655be74$export$99f8df7d064294cc = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-8junt6-2"
})`display:flex;padding-right:${"var(--ds-space-100, 8px)"};margin:0px ${"var(--ds-space-075, 6px)"} ${"var(--ds-space-025, 2px)"};`;
const $961e84093655be74$export$e26c34d851c862e3 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-8junt6-3"
})`display:flex;padding-right:${"var(--ds-space-100, 8px)"};margin:${"var(--ds-space-025, 2px)"};`;
const $961e84093655be74$export$6dae78c6213b453c = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-8junt6-4"
})`display:flex;flex-flow:column;flex-basis:auto;${(0, $6PHb3.ellipsisInFlexChild)};`;
const $961e84093655be74$export$14cef269f8b93bc1 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-8junt6-5"
})`font:${"var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};padding-bottom:${"var(--ds-space-025, 2px)"};flex-basis:auto;${(0, $6PHb3.ellipsisInFlexChild)} color:${`var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`};`;
const $961e84093655be74$export$b7842987d4a39270 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-8junt6-6"
})`font:${"var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};color:${`var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`};`;

});


parcelRegister("3m1cZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $96dff5f1e5e8b41a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $fyzT1 = parcelRequire("fyzT1");
var $38ra6 = parcelRequire("38ra6");
var $7m1xZ = parcelRequire("7m1xZ");

var $d7tic = parcelRequire("d7tic");
var $5hWov = parcelRequire("5hWov");

var $5hMxY = parcelRequire("5hMxY");

var $2s6UE = parcelRequire("2s6UE");

var $a8O97 = parcelRequire("a8O97");

var $bnMl7 = parcelRequire("bnMl7");
const $96dff5f1e5e8b41a$var$TeamsProfileItemButton = (props)=>{
    const analytics = (0, $38ra6.default)();
    const { openDialog: openDialog } = (0, $7m1xZ.useDialog)();
    const { proposedMembers: proposedMembers, source: source, isCurrentUser: isCurrentUser, isActiveUser: isActiveUser } = props;
    const { permissions: { canCreateTeams: canCreateTeams } } = (0, $5hWov.useTeamVisibility)();
    const [{ hasBrowseUsersPermission: hasBrowseUsersPermission }] = (0, $d7tic.useSettings)();
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        // Track where trigger button is being clicked from
        analytics.pushUIEvent({
            source: (0, $fyzT1.AnalyticsEventSource).CREATE_TEAM_MODAL,
            action: (0, $fyzT1.AnalyticsEventActions).CLICKED,
            actionSubject: 'teamCreateDialogTriggerButton',
            attributes: {
                // Record where in the UI the modal was triggered from
                trigger: source
            }
        });
        // @ts-ignore
        openDialog((0, $5hMxY.default), {
            proposedMembers: proposedMembers || []
        });
    }, [
        analytics,
        openDialog,
        proposedMembers,
        source
    ]);
    const canStartTeamWithUser = hasBrowseUsersPermission && isActiveUser && canCreateTeams;
    /**
	 * Show the button if:
	 * - it's the current user's profile page
	 * - or it's other people's profile pages and the user has permission
	 */ const showButton = isCurrentUser || !isCurrentUser && canStartTeamWithUser;
    return showButton ? /*#__PURE__*/ (0, $2OMIu.jsx)($bnMl7.OutlineLink, {
        onClick: handleClick,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)($bnMl7.TeamsProfileItemWrapper, {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)($bnMl7.TeamsProfileAddIcon, {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a8O97.TeamAddIcon), {})
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)($bnMl7.TeamsProfileItemBody, {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($bnMl7.TeamsProfileItemTeamName, {
                        children: isCurrentUser ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $2s6UE.messages).createTeamLabel
                        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $2s6UE.messages).createTeamLabelOtherPeople
                        })
                    })
                })
            ]
        })
    }) : null;
};
var $96dff5f1e5e8b41a$export$2e2bcd8739ae039 = $96dff5f1e5e8b41a$var$TeamsProfileItemButton;

});
parcelRegister("d7tic", function(module, exports) {

$parcel$export(module.exports, "useSettings", () => $2d46dae541b949a8$export$9115b42802a3e44f);
$parcel$export(module.exports, "useSettingsFeatureFlag", () => $2d46dae541b949a8$export$f2df9067cb58ea32);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $dmOdc = parcelRequire("dmOdc");

var $loO6b = parcelRequire("loO6b");

var $04Mso = parcelRequire("04Mso");
const $2d46dae541b949a8$export$28456d095a642fd = 'internal.browse-users-allowed';
const $2d46dae541b949a8$var$actions = {
    /**
	 * Fetches bup settings from pf-directory/legion service
	 * @param product - Product name.
	 * @param cloudId - Cloud Id.
	 */ getSettings: (product, cloudId)=>async ({ getState: getState, setState: setState })=>{
            if (getState().isFetching || getState().hasLoadedSettings) return;
            setState({
                isFetching: true
            });
            try {
                const directorySettingPromise = cloudId ? (0, $dmOdc.teamsClient).querySettings(cloudId, product) : Promise.resolve({
                    [$2d46dae541b949a8$export$28456d095a642fd]: true
                });
                return await (0, $loO6b.promiseWithDefault)(directorySettingPromise, {
                    [$2d46dae541b949a8$export$28456d095a642fd]: false
                }).then(({ value: browseUsersEnabled, success: settingsSuccess })=>{
                    const settingsFromRequests = {
                        // If settings cannot be accessed, default to permission denied.
                        [$2d46dae541b949a8$export$28456d095a642fd]: false,
                        ...browseUsersEnabled
                    };
                    // Fallback as needed to compute effective flag values
                    const finalSettings = {
                        ...(0, $04Mso.getSettingsFromStorage)() || {},
                        ...settingsFromRequests
                    };
                    setState({
                        hasLoadedSettings: true,
                        hasErrorOnFetchSettings: !settingsSuccess,
                        hasBrowseUsersPermission: !!finalSettings[$2d46dae541b949a8$export$28456d095a642fd],
                        settings: finalSettings
                    });
                });
            } catch  {
                setState({
                    hasErrorOnFetchSettings: true,
                    hasLoadedSettings: true
                });
            } finally{
                setState({
                    isFetching: false
                });
            }
        }
};
const $2d46dae541b949a8$var$initialState = {
    hasLoadedSettings: false,
    hasErrorOnFetchSettings: false,
    hasBrowseUsersPermission: false,
    isFetching: false,
    settings: {
        [$2d46dae541b949a8$export$28456d095a642fd]: false,
        ...(0, $04Mso.getSettingsFromStorage)() || {}
    }
};
/**
 * Manage states of settings
 */ const $2d46dae541b949a8$var$Store = (0, $iXqE5.createStore)({
    initialState: $2d46dae541b949a8$var$initialState,
    actions: $2d46dae541b949a8$var$actions,
    name: 'Settings'
});
const $2d46dae541b949a8$export$8376625f8bb18347 = (0, $gg7kZ.createContainer)($2d46dae541b949a8$var$Store, {
    onInit: ()=>({ setState: setState }, state)=>{
            setState(state);
        }
});
const $2d46dae541b949a8$export$9115b42802a3e44f = (0, $3sQ5x.createHook)($2d46dae541b949a8$var$Store);
const $2d46dae541b949a8$export$f2df9067cb58ea32 = (flagName)=>{
    const [{ settings: settings }] = $2d46dae541b949a8$export$9115b42802a3e44f();
    return settings[flagName];
};

});

parcelRegister("5hMxY", function(module, exports) {

$parcel$export(module.exports, "default", () => $44ab60233033312c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5tEry = parcelRequire("5tEry");
const $44ab60233033312c$var$TeamCreateDialogLazy = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5tEry.default), {
            ...props
        })
    });
};
var $44ab60233033312c$export$2e2bcd8739ae039 = $44ab60233033312c$var$TeamCreateDialogLazy;

});
parcelRegister("5tEry", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7a5ec9edc3f1012$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $b7a5ec9edc3f1012$var$TeamCreateDialogLazyWrapper = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("iP5mX")));
var $b7a5ec9edc3f1012$export$2e2bcd8739ae039 = $b7a5ec9edc3f1012$var$TeamCreateDialogLazyWrapper;

});
parcelRegister("iP5mX", function(module, exports) {

let $db4127a731027416$var$load = (parcelRequire("28QjX"))(4);
module.exports = $db4127a731027416$var$load("fjmP0").then(()=>parcelRequire('5iSAG'));

});



parcelRegister("a8O97", function(module, exports) {

$parcel$export(module.exports, "TeamAddIcon", () => $460f524580a2bfe3$export$6972ee87109b1a65);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $460f524580a2bfe3$export$6972ee87109b1a65 = ()=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                y: "0.5",
                width: "24",
                height: "24",
                rx: "12",
                fill: "#F1F2F4"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "16",
                height: "16",
                transform: "translate(4 4.5)",
                fill: "white",
                fillOpacity: "0.01"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.6667 11.8333V9.16667C12.6667 8.98986 12.5964 8.82029 12.4714 8.69526C12.3464 8.57024 12.1768 8.5 12 8.5C11.8232 8.5 11.6536 8.57024 11.5286 8.69526C11.4036 8.82029 11.3333 8.98986 11.3333 9.16667V11.8333H8.66667C8.48986 11.8333 8.32029 11.9036 8.19526 12.0286C8.07024 12.1536 8 12.3232 8 12.5C8 12.6768 8.07024 12.8464 8.19526 12.9714C8.32029 13.0964 8.48986 13.1667 8.66667 13.1667H11.3333V15.8333C11.3333 16.0101 11.4036 16.1797 11.5286 16.3047C11.6536 16.4298 11.8232 16.5 12 16.5C12.1768 16.5 12.3464 16.4298 12.4714 16.3047C12.5964 16.1797 12.6667 16.0101 12.6667 15.8333V13.1667H15.3333C15.5101 13.1667 15.6797 13.0964 15.8047 12.9714C15.9298 12.8464 16 12.6768 16 12.5C16 12.3232 15.9298 12.1536 15.8047 12.0286C15.6797 11.9036 15.5101 11.8333 15.3333 11.8333H12.6667Z",
                fill: "#42526E"
            })
        ]
    });
};

});


parcelRegister("bGUXq", function(module, exports) {

$parcel$export(module.exports, "AboutTeamsList", () => $196b62651b5c0289$export$f8d76b4306b647d6);
$parcel$export(module.exports, "ShowMoreButton", () => $196b62651b5c0289$export$e41c325c8b11c297);
$parcel$export(module.exports, "ErrorContainer", () => $196b62651b5c0289$export$97bdf39f6b82bb0);
$parcel$export(module.exports, "ErrorTitle", () => $196b62651b5c0289$export$b065fd053267ec81);
$parcel$export(module.exports, "ErrorMessageWrapper", () => $196b62651b5c0289$export$9e874bb1adc98a55);
$parcel$export(module.exports, "ErrorIconWrapper", () => $196b62651b5c0289$export$b2471e0920d79944);
$parcel$export(module.exports, "ErrorMessage", () => $196b62651b5c0289$export$915e9e7bd4f0f96d);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");

const $196b62651b5c0289$export$eb5006ed1ea4bea6 = /*#__PURE__*/ (0, $47bDC.default).h6.withConfig({
    componentId: "sc-11mcmk0-0"
})`color:${`var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`};margin-bottom:${"var(--ds-space-200, 16px)"};`;
const $196b62651b5c0289$export$f8d76b4306b647d6 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-11mcmk0-1"
})`display:flex;flex-direction:column;>:not(:last-child){margin-bottom:${"var(--ds-space-050, 4px)"};}`;
const $196b62651b5c0289$export$eddf54ea3db8d0f0 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-11mcmk0-2"
})`margin-right:${"var(--ds-space-100, 8px)"};`;
const $196b62651b5c0289$export$e41c325c8b11c297 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-11mcmk0-3"
})`text-align:left;padding:${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"};`;
const $196b62651b5c0289$export$97bdf39f6b82bb0 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-11mcmk0-4"
})`display:flex;`;
const $196b62651b5c0289$export$b065fd053267ec81 = /*#__PURE__*/ (0, $47bDC.default).h5.withConfig({
    componentId: "sc-11mcmk0-5"
})`color:${`var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`};`;
const $196b62651b5c0289$export$9e874bb1adc98a55 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-11mcmk0-6"
})``;
const $196b62651b5c0289$export$b2471e0920d79944 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-11mcmk0-7"
})`margin-right:${"var(--ds-space-100, 8px)"};`;
const $196b62651b5c0289$export$915e9e7bd4f0f96d = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-11mcmk0-8"
})`color:${`var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`};font:${"var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};`;

});




parcelRegister("6i45Z", function(module, exports) {

$parcel$export(module.exports, "AgentActions", () => $1ef04d2e8348086e$export$a091e6fbe251d12f);
/* AgentActions.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $eCeGD = parcelRequire("eCeGD");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");

var $h88oy = parcelRequire("h88oy");

var $kIJ8U = parcelRequire("kIJ8U");

var $38Ckm = parcelRequire("38Ckm");
const $1ef04d2e8348086e$var$styles = {
    chatToAgentButtonContainer: "_1bsb1osq",
    chatToAgentButtonWrapper: "_1e0c1txw _1bah1h6o _k48p1wq8",
    chatPillText: "_1nmz1hna _y3gn1e5h _o5721jtm",
    chatPillIconWrapper: "_1ul9gktf _4t3igktf"
};
const $1ef04d2e8348086e$export$a091e6fbe251d12f = ({ onEditAgent: onEditAgent, onDeleteAgent: onDeleteAgent, onDuplicateAgent: onDuplicateAgent, onCopyAgent: onCopyAgent, onChatClick: onChatClick, isAgentCreatedByUser: isAgentCreatedByUser, agentId: agentId, isForgeAgent: isForgeAgent, assistanceServiceParams: assistanceServiceParams })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: $1ef04d2e8348086e$var$styles.chatToAgentButtonContainer,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                    shouldFitContainer: true,
                    onClick: onChatClick,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            $1ef04d2e8348086e$var$styles.chatToAgentButtonWrapper
                        ]),
                        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                            space: "space.050",
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                                    xcss: $1ef04d2e8348086e$var$styles.chatPillIconWrapper,
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h88oy.ChatPillIcon), {})
                                }),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                                    xcss: $1ef04d2e8348086e$var$styles.chatPillText,
                                    children: formatMessage((0, $38Ckm.messages).actionChatToAgent)
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kIJ8U.AgentDropdownMenu), {
                agentId: agentId,
                isAgentCreatedByUser: isAgentCreatedByUser,
                isForgeAgent: isForgeAgent,
                onCopyAgent: onCopyAgent,
                onDeleteAgent: onDeleteAgent,
                onDuplicateAgent: onDuplicateAgent,
                onEditAgent: onEditAgent,
                loadPermissionsOnMount: true,
                assistanceServiceParams: assistanceServiceParams
            })
        ]
    });
};

});
parcelRegister("h88oy", function(module, exports) {

$parcel$export(module.exports, "ChatPillIcon", () => $222c44ccbe7ec2a4$export$38f9b635c1c454e7);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $82RQj = parcelRequire("82RQj");

var $jyBoJ = parcelRequire("jyBoJ");
const $222c44ccbe7ec2a4$export$38f9b635c1c454e7 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($82RQj))), {
        ...props,
        label: "",
        LEGACY_size: "small",
        LEGACY_fallbackIcon: (0, $jyBoJ.default)
    });

});
parcelRegister("82RQj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7997b223b163fea361e6870d11885d8e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5db846b1e6bcdc52$var$_react = $5db846b1e6bcdc52$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5db846b1e6bcdc52$var$_baseNew = $5db846b1e6bcdc52$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $5db846b1e6bcdc52$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiChat".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Rovo Chat.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5db846b1e6bcdc52$var$AiChatIcon = (props)=>/*#__PURE__*/ $5db846b1e6bcdc52$var$_react.default.createElement($5db846b1e6bcdc52$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2z" clip-rule="evenodd"/><path fill="currentcolor" d="M6 7.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$5db846b1e6bcdc52$var$AiChatIcon.displayName = 'AiChatIcon';
var $5db846b1e6bcdc52$var$_default = module.exports.default = $5db846b1e6bcdc52$var$AiChatIcon;

});

parcelRegister("jyBoJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2c3657b5b4eabc6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $c2c3657b5b4eabc6$var$ChatIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M8.00023 14.25C7.86431 14.25 7.73094 14.287 7.61439 14.3569L3.75024 16.6752V14V4.99998C3.75024 4.30963 4.30988 3.74999 5.00023 3.74998L15.0002 3.74984C15.6906 3.74984 16.2502 4.30948 16.2502 4.99984V12.9999C16.2502 13.6902 15.6906 14.2498 15.0003 14.2499L8.00023 14.25Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinejoin: "round",
                fill: "transparent"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "6",
                y: "8",
                width: "2",
                height: "2",
                rx: "1",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "9",
                y: "8",
                width: "2",
                height: "2",
                rx: "1",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "12",
                y: "8",
                width: "2",
                height: "2",
                rx: "1",
                fill: "currentColor"
            })
        ]
    });
/**
 * __ChatIcon__
 */ const $c2c3657b5b4eabc6$var$ChatIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $c2c3657b5b4eabc6$var$ChatIconGlyph
    });
var $c2c3657b5b4eabc6$export$2e2bcd8739ae039 = $c2c3657b5b4eabc6$var$ChatIcon;

});


parcelRegister("kIJ8U", function(module, exports) {

$parcel$export(module.exports, "ChatToAgentButton", () => $f60210f1f061a0e3$export$ffe1cf57f0b5db02);
$parcel$export(module.exports, "AgentDropdownMenu", () => $f60210f1f061a0e3$export$fc284fc0f7cc8f16);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $eCeGD = parcelRequire("eCeGD");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");

var $zPb6e = parcelRequire("zPb6e");
var $h88oy = parcelRequire("h88oy");

var $rW2Zz = parcelRequire("rW2Zz");

var $50xEk = parcelRequire("50xEk");
const $f60210f1f061a0e3$var$styles = {
    chatToAgentButtonContainer: "_1bsb1osq",
    chatPillButtonInline: "_18zrv77o",
    chatPillText: "_1nmz1hna _y3gn1e5h _o5721jtm",
    chatPillIconWrapper: "_1ul9gktf _4t3igktf",
    chatToAgentButtonWrapper: "_1e0c1txw _1bah1h6o _k48p1wq8"
};
const $f60210f1f061a0e3$export$ffe1cf57f0b5db02 = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $f60210f1f061a0e3$var$styles.chatToAgentButtonContainer,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
            testId: "view-agent-modal-chat-to-agent-button",
            shouldFitContainer: true,
            onClick: onClick,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: $f60210f1f061a0e3$var$styles.chatToAgentButtonWrapper,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                    space: "space.050",
                    xcss: $f60210f1f061a0e3$var$styles.chatPillButtonInline,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            xcss: $f60210f1f061a0e3$var$styles.chatPillIconWrapper,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h88oy.ChatPillIcon), {})
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            xcss: $f60210f1f061a0e3$var$styles.chatPillText,
                            children: formatMessage((0, $50xEk.default).chatToAgentButton)
                        })
                    ]
                })
            })
        })
    });
};
const $f60210f1f061a0e3$export$fc284fc0f7cc8f16 = (props)=>{
    const { refetch: refetch } = (0, $rW2Zz.useAgentPermissions)({
        agentId: props.agentId,
        enabled: false,
        assistanceServiceParams: props.assistanceServiceParams
    });
    const loadAgentPermissions = (0, $5uXOq.useCallback)(async ()=>{
        const response = await refetch();
        return {
            isEditEnabled: response?.permissions.AGENT_UPDATE?.permitted ?? false,
            isDeleteEnabled: response?.permissions.AGENT_DEACTIVATE?.permitted ?? false
        };
    }, [
        refetch
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $zPb6e.AgentDropdownMenu), {
        ...props,
        loadAgentPermissions: loadAgentPermissions
    });
};

});
parcelRegister("zPb6e", function(module, exports) {

$parcel$export(module.exports, "AgentDropdownMenu", () => $4de29d55d41f6cce$export$fc284fc0f7cc8f16);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $eCeGD = parcelRequire("eCeGD");
var $42CjB = parcelRequire("42CjB");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $bJeNF = parcelRequire("bJeNF");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");

var $h88oy = parcelRequire("h88oy");

var $ccIkk = parcelRequire("ccIkk");
const $4de29d55d41f6cce$var$styles = {
    chatToAgentButtonContainer: "_1bsb1osq",
    chatToAgentButtonWrapper: "_1e0c1txw _1bah1h6o _k48p1wq8",
    chatPillButtonInline: "_18zrv77o",
    chatPillText: "_1nmz1hna _y3gn1e5h _o5721jtm",
    chatPillIconWrapper: "_1ul9gktf _4t3igktf"
};
const $4de29d55d41f6cce$export$ffe1cf57f0b5db02 = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $4de29d55d41f6cce$var$styles.chatToAgentButtonContainer,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
            testId: "view-agent-modal-chat-to-agent-button",
            shouldFitContainer: true,
            onClick: onClick,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: $4de29d55d41f6cce$var$styles.chatToAgentButtonWrapper,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                    space: "space.050",
                    xcss: $4de29d55d41f6cce$var$styles.chatPillButtonInline,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            xcss: $4de29d55d41f6cce$var$styles.chatPillIconWrapper,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h88oy.ChatPillIcon), {})
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            xcss: $4de29d55d41f6cce$var$styles.chatPillText,
                            children: formatMessage((0, $ccIkk.default).chatToAgentButton)
                        })
                    ]
                })
            })
        })
    });
};
const $4de29d55d41f6cce$export$fc284fc0f7cc8f16 = ({ isAgentCreatedByUser: isAgentCreatedByUser, isAutodevTemplateAgent: isAutodevTemplateAgent, onEditAgent: onEditAgent, onCopyAgent: onCopyAgent, onDuplicateAgent: onDuplicateAgent, onDeleteAgent: onDeleteAgent, onViewAgentFullProfileClick: onViewAgentFullProfileClick, isForgeAgent: isForgeAgent, showViewAgentOption: showViewAgentOption = false, onViewAgentClick: onViewAgentClick, onDropdownTriggerClick: onDropdownTriggerClick, spacing: spacing, appearance: appearance, dropdownMenuTestId: dropdownMenuTestId, doesAgentHaveIdentityAccountId: doesAgentHaveIdentityAccountId, loadAgentPermissions: loadAgentPermissions, loadPermissionsOnMount: loadPermissionsOnMount, shouldTriggerStopPropagation: shouldTriggerStopPropagation })=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [hasBeenCopied, setHasBeenCopied] = (0, $5uXOq.useState)(false);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [permissions, setPermissions] = (0, $5uXOq.useState)();
    (0, $5uXOq.useEffect)(()=>{
        const fetchData = async ()=>{
            if (!loadAgentPermissions) {
                const canEditDelete = isAgentCreatedByUser && !isForgeAgent;
                setPermissions({
                    isEditEnabled: canEditDelete,
                    isDeleteEnabled: canEditDelete
                });
                return;
            }
            setIsLoading(true);
            const { isEditEnabled: isEditEnabled, isDeleteEnabled: isDeleteEnabled } = await loadAgentPermissions();
            setIsLoading(false);
            setPermissions({
                isEditEnabled: isEditEnabled,
                isDeleteEnabled: isDeleteEnabled
            });
        };
        // Only load once
        if (!permissions && (isOpen || loadPermissionsOnMount)) fetchData();
    }, [
        isAgentCreatedByUser,
        isForgeAgent,
        isOpen,
        loadAgentPermissions,
        loadPermissionsOnMount,
        permissions
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isOpen) setHasBeenCopied(false);
    }, [
        isOpen
    ]);
    const renderEditDelete = ()=>{
        if (!permissions?.isEditEnabled && !permissions?.isDeleteEnabled) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $aRoVz.default), {
            hasSeparator: true,
            children: [
                permissions.isEditEnabled && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
                    onClick: onEditAgent,
                    children: formatMessage((0, $ccIkk.default).editAgent)
                }),
                permissions.isDeleteEnabled && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
                    onClick: onDeleteAgent,
                    children: formatMessage((0, $ccIkk.default).deleteAgent)
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $BLPHT.default), {
        isLoading: isLoading,
        isOpen: isOpen,
        testId: dropdownMenuTestId,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                ...props,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))),
                label: formatMessage((0, $ccIkk.default).moreActionsLabel),
                ref: triggerRef,
                spacing: spacing,
                appearance: appearance,
                onClick: (e, analyticsEvent)=>{
                    if (onDropdownTriggerClick) onDropdownTriggerClick(e, analyticsEvent);
                    if (shouldTriggerStopPropagation) e.stopPropagation();
                    props.onClick?.(e);
                }
            }),
        onOpenChange: (args)=>{
            setIsOpen(args.isOpen);
            if (!args.isOpen) setHasBeenCopied(false);
        },
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $aRoVz.default), {
                children: [
                    showViewAgentOption && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
                        onClick: onViewAgentClick,
                        children: formatMessage((0, $ccIkk.default).viewAgent)
                    }),
                    doesAgentHaveIdentityAccountId && onViewAgentFullProfileClick && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
                        onClick: onViewAgentFullProfileClick,
                        children: formatMessage((0, $ccIkk.default).viewAgentFullProfile)
                    }),
                    !isForgeAgent && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
                        onClick: onDuplicateAgent,
                        children: isAutodevTemplateAgent ? formatMessage((0, $ccIkk.default).useTemplateButton) : formatMessage((0, $ccIkk.default).duplicateAgent)
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
                        onClick: (e)=>{
                            e.stopPropagation();
                            setHasBeenCopied(true);
                            onCopyAgent?.(e);
                        },
                        children: formatMessage(hasBeenCopied ? (0, $ccIkk.default).linkedCopiedToProfile : (0, $ccIkk.default).copyLinkToProfile)
                    })
                ]
            }),
            renderEditDelete()
        ]
    });
};

});
parcelRegister("ccIkk", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8f2564df10c4301$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b8f2564df10c4301$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    chatToAgentButton: {
        id: 'rovo-chat.view-agent.chat-to-agent-button',
        defaultMessage: 'Chat to Agent',
        description: 'Button to chat to agent'
    },
    moreActionsLabel: {
        id: 'rovo-chat.view-agent.more-actions-label',
        defaultMessage: 'More actions',
        description: 'More actions dropdown menu label'
    },
    duplicateAgent: {
        id: 'rovo-chat.view-agent.duplicate-agent',
        defaultMessage: 'Duplicate Agent',
        description: 'Button to duplicate an agent'
    },
    editAgent: {
        id: 'rovo-chat.view-agent.edit-agent',
        defaultMessage: 'Edit Agent',
        description: 'Button to edit an agent'
    },
    deleteAgent: {
        id: 'rovo-chat.view-agent.delete-agent',
        defaultMessage: 'Delete Agent',
        description: 'Button to delete an agent'
    },
    copyLinkToProfile: {
        id: 'rovo-chat.view-agent.copy-link-to-profile',
        defaultMessage: 'Copy link',
        description: 'Button to copy the link to the agent profile'
    },
    linkedCopiedToProfile: {
        id: 'rovo-chat.view-agent.link-copied-to-profile',
        defaultMessage: 'Copied URL',
        description: 'Button confirming link to agent profile is copied'
    },
    viewAgent: {
        id: 'rovo-chat.view-agents.view-agent',
        defaultMessage: 'View Agent',
        description: 'Button to view an agent'
    },
    viewAgentFullProfile: {
        id: 'rovo-chat.view-agents.view-agent-full-profile',
        defaultMessage: 'View full profile',
        description: 'Button to view an agent full profile'
    },
    useTemplateButton: {
        id: 'rovo-chat.view-agents.use-template-button',
        defaultMessage: 'Use template',
        description: 'Button to copy and use a template'
    }
});

});


parcelRegister("rW2Zz", function(module, exports) {

$parcel$export(module.exports, "useAgentPermissions", () => $db8ba39ef89917a2$export$be862330bf692bad);

var $91cKc = parcelRequire("91cKc");

var $cK3Jm = parcelRequire("cK3Jm");
var $4ojTZ = parcelRequire("4ojTZ");
const $db8ba39ef89917a2$export$be862330bf692bad = (0, $cK3Jm.createHookWithAssistanceService)(({ agentId: agentId, enabled: enabled, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker } })=>{
    const query = (0, $4ojTZ.useQuery)({
        queryKey: [
            'getAgentPermissions',
            agentId
        ],
        queryFn: async ()=>{
            experienceTracker.start({
                id: (0, $91cKc.ExperienceName).GET_AGENT_PERMISSIONS,
                name: (0, $91cKc.ExperienceName).GET_AGENT_PERMISSIONS
            });
            return await assistanceService.getAgentPermissions(agentId, {
                permission_ids: [
                    'AGENT_CREATE',
                    'AGENT_UPDATE',
                    'AGENT_DELETE',
                    'AGENT_DEACTIVATE',
                    'AGENT_READ'
                ]
            });
        },
        onSuccess: ()=>{
            experienceTracker.succeed({
                name: (0, $91cKc.ExperienceName).GET_AGENT_PERMISSIONS
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $91cKc.ExperienceName).GET_AGENT_PERMISSIONS,
                error: error
            });
        },
        enabled: enabled
    });
    return query;
});

});

parcelRegister("50xEk", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c6ebfec2843b6ed$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9c6ebfec2843b6ed$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    chatToAgentButton: {
        id: 'rovo-chat.view-agent.chat-to-agent-button',
        defaultMessage: 'Chat to Agent',
        description: 'Button to chat to agent'
    }
});

});


parcelRegister("38Ckm", function(module, exports) {

$parcel$export(module.exports, "messages", () => $aa2207130b39be99$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $aa2207130b39be99$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    actionChatToAgent: {
        id: 'ptc-directory.agent-profile.action.dropdown.chat-to-agent.nonfinal',
        defaultMessage: 'Chat to Agent',
        description: 'Text for the "chat to agent" action to chat to the agent'
    },
    actionDelete: {
        id: 'ptc-directory.agent-profile.action.dropdown.delete.nonfinal',
        defaultMessage: 'Delete Agent',
        description: 'Text for the "Delete" action to delete an agent'
    },
    actionEdit: {
        id: 'ptc-directory.agent-profile.action.dropdown.edit.nonfinal',
        defaultMessage: 'Edit Agent',
        description: 'Text for the "Edit" action to edit an agent'
    },
    actionCopyLink: {
        id: 'ptc-directory.agent-profile.action.dropdown.copy-link.nonfinal',
        defaultMessage: 'Copy link',
        description: 'Text for the Copy link of an agent'
    },
    actionDuplicate: {
        id: 'ptc-directory.agent-profile.action.dropdown.duplicate.nonfinal',
        defaultMessage: 'Duplicate Agent',
        description: 'Text for the Duplicate Agent action to create a duplicate'
    },
    agentDeletedSuccessFlagTitle: {
        id: 'ptc-directory.agent-profile.delete-agent-success-flag-title',
        defaultMessage: 'Agent deleted',
        description: 'Flag message title displayed when an agent is deleted'
    },
    agentDeletedSuccessFlagDescription: {
        id: 'ptc-directory.agent-profile.delete-agent-success-flag-description',
        defaultMessage: 'You deleted {agentName}',
        description: 'Flag message description displayed when an agent is deleted'
    },
    agentDeletedErrorFlagTitle: {
        id: 'ptc-directory.agent-profile.delete-agent-error-flag-title',
        defaultMessage: 'Failed to delete Agent',
        description: 'Flag message title displayed when there is an error deleting agent'
    },
    agentDeletedErrorFlagDescription: {
        id: 'ptc-directory.agent-profile.delete-agent-error-flag-description',
        defaultMessage: 'Something went wrong while deleting the agent. Try again in a few moments.',
        description: 'Flag message description displayed when there is an error deleting agent'
    }
});

});


parcelRegister("6eD5g", function(module, exports) {

$parcel$export(module.exports, "AgentConversationStartersSection", () => $779ac05b28e41648$export$574a87e4832466ff);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $luBm6 = parcelRequire("luBm6");

var $4ns5a = parcelRequire("4ns5a");

var $4kUAd = parcelRequire("4kUAd");
const $779ac05b28e41648$export$574a87e4832466ff = ({ isAgentDefault: isAgentDefault, onConversationStarterClick: onConversationStarterClick, userDefinedConversationStarters: userDefinedConversationStarters })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleConversationStarterClick = (conversationStarter)=>{
        onConversationStarterClick(conversationStarter);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
        space: "space.200",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4kUAd.MainContentHeaders), {
                children: formatMessage($779ac05b28e41648$var$messages.openChatLabel)
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $luBm6.default), {
                alignInline: "start",
                space: "space.100",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4ns5a.AgentConversationStarters), {
                    isAgentDefault: isAgentDefault,
                    onConversationStarterClick: handleConversationStarterClick,
                    userDefinedConversationStarters: userDefinedConversationStarters
                })
            })
        ]
    });
};
const $779ac05b28e41648$var$messages = (0, $7VHMR.defineMessages)({
    openChatLabel: {
        id: 'ptc-directory.agent-profile.conversation-starter.header',
        defaultMessage: 'Open chat',
        description: 'Label for about section of the agent'
    }
});

});
parcelRegister("4ns5a", function(module, exports) {

$parcel$export(module.exports, "getConversationStarters", () => $a3b222b85982a88a$export$c2d882153e0984c5);
$parcel$export(module.exports, "AgentConversationStarters", () => $a3b222b85982a88a$export$171adfc74aa509c3);
$parcel$export(module.exports, "ConversationStarters", () => $a3b222b85982a88a$export$ea338c37011da44c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $42CjB = parcelRequire("42CjB");

var $lzNDe = parcelRequire("lzNDe");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
var $414Wj = parcelRequire("414Wj");

var $1NZUH = parcelRequire("1NZUH");

var $52GXX = parcelRequire("52GXX");
const $a3b222b85982a88a$var$styles = {
    conversationStartersList: "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
};
const $a3b222b85982a88a$export$c2d882153e0984c5 = ({ userDefinedConversationStarters: userDefinedConversationStartersParam, isAgentDefault: isAgentDefault })=>{
    const type = 'static';
    const customAgentConversationStarters = [
        {
            message: (0, $52GXX.messages).agentEmptyStateSuggestion1,
            type: type
        },
        {
            message: (0, $52GXX.messages).agentEmptyStateSuggestion2,
            type: type
        },
        {
            message: (0, $52GXX.messages).agentEmptyStateSuggestion3,
            type: type
        }
    ];
    const userDefinedConversationStarters = userDefinedConversationStartersParam ?? [];
    const defaultAgentConversationStarters = [
        {
            message: (0, $52GXX.messages).emptyStateSuggestion1,
            type: type
        },
        {
            message: (0, $52GXX.messages).emptyStateSuggestion2,
            type: type
        },
        {
            message: (0, $52GXX.messages).emptyStateSuggestion3,
            type: type
        }
    ];
    const getCombinedConversationStarters = ()=>{
        const shouldCombine = !isAgentDefault;
        if (shouldCombine) // Return user defined suggestions + static fallback suggestions with a max of 3 suggestions (user defined taking precendence over fallback)
        return [
            ...userDefinedConversationStarters,
            ...customAgentConversationStarters
        ].slice(0, 3);
        return defaultAgentConversationStarters;
    };
    return {
        userDefinedConversationStarters: userDefinedConversationStarters,
        customAgentConversationStarters: customAgentConversationStarters,
        defaultAgentConversationStarters: defaultAgentConversationStarters,
        combinedConversationStarters: getCombinedConversationStarters()
    };
};
const $a3b222b85982a88a$export$171adfc74aa509c3 = ({ userDefinedConversationStarters: userDefinedConversationStarters, isAgentDefault: isAgentDefault, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { combinedConversationStarters: combinedConversationStarters } = (0, $5uXOq.useMemo)(()=>$a3b222b85982a88a$export$c2d882153e0984c5({
            userDefinedConversationStarters: userDefinedConversationStarters,
            isAgentDefault: isAgentDefault
        }), [
        userDefinedConversationStarters,
        isAgentDefault
    ]);
    const starters = (0, $5uXOq.useMemo)(()=>combinedConversationStarters.map((starter)=>typeof starter.message === 'string' ? {
                message: starter.message,
                type: starter.type
            } : {
                message: formatMessage(starter.message),
                type: starter.type
            }), [
        combinedConversationStarters,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($a3b222b85982a88a$export$ea338c37011da44c, {
        starters: starters,
        ...props
    });
};
const $a3b222b85982a88a$export$ea338c37011da44c = ({ starters: starters, onConversationStarterClick: onConversationStarterClick, showReloadButton: showReloadButton = false, onReloadButtonClick: onReloadButtonClick = ()=>{}, onBrowseAgentsClick: onBrowseAgentsClick })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
        as: "ul",
        space: "space.050",
        xcss: $a3b222b85982a88a$var$styles.conversationStartersList,
        children: [
            starters.map((starter, index)=>{
                const isLastStarter = index === starters.length - 1;
                const chatPill = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    as: "li",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1NZUH.ChatPill), {
                        testId: "conversation-starter",
                        onClick: ()=>onConversationStarterClick(starter),
                        children: starter.message
                    }, starter.message)
                }, starter.message);
                return isLastStarter && showReloadButton ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                    space: "space.050",
                    grow: "fill",
                    alignInline: "end",
                    children: [
                        chatPill,
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lzNDe))),
                            onClick: onReloadButtonClick,
                            appearance: "subtle",
                            label: ""
                        })
                    ]
                }, starter.message) : chatPill;
            }),
            !!onBrowseAgentsClick && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                as: "li",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1NZUH.BrowseAgentsPill), {
                    onClick: onBrowseAgentsClick
                })
            })
        ]
    });
};

});
parcelRegister("lzNDe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2b87cc7d74b53f2f9074ecfc04ea4b65>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fb535dae8e778b64$var$_react = $fb535dae8e778b64$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fb535dae8e778b64$var$_baseNew = $fb535dae8e778b64$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $fb535dae8e778b64$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Retry".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for retry.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fb535dae8e778b64$var$RetryIcon = (props)=>/*#__PURE__*/ $fb535dae8e778b64$var$_react.default.createElement($fb535dae8e778b64$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 8a7 7 0 0 1 12.5-4.33V1H15v5a.75.75 0 0 1-.75.75H9.5v-1.5h3.264a5.5 5.5 0 1 0 .665 3.63l1.482.24A7.002 7.002 0 0 1 1 8" clip-rule="evenodd"/>`
    }, props));
$fb535dae8e778b64$var$RetryIcon.displayName = 'RetryIcon';
var $fb535dae8e778b64$var$_default = module.exports.default = $fb535dae8e778b64$var$RetryIcon;

});

parcelRegister("1NZUH", function(module, exports) {

$parcel$export(module.exports, "ChatPill", () => $0fd9c621f10bd238$export$e33faa86e0996d96);
$parcel$export(module.exports, "BrowseAgentsPill", () => $0fd9c621f10bd238$export$76b47032dcd9063b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $3JT92 = parcelRequire("3JT92");

var $4V6HW = parcelRequire("4V6HW");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
var $3Lty3 = parcelRequire("3Lty3");

var $h88oy = parcelRequire("h88oy");

var $eCjlc = parcelRequire("eCjlc");
const $0fd9c621f10bd238$var$stylesCompiled = {
    pillLineHeight: "_vwz47vkz"
};
const $0fd9c621f10bd238$var$styles = {
    button: "_2rkoiti9 _11c82smr _189ee4h9 _1dqonqa1 _1h6dmuej _syaz1gjq _ca0q12x7 _u5f3utpp _n3td12x7 _19bvutpp _k48p1wq8 _1bto1l2s _o5721q9c _1o9zkb7n _bfhk1w7a _irr3166n _1di61dty",
    buttonInline: "_18zrv77o",
    queryText: "_1nmz1hna _y3gn1e5h",
    whiteSpacePreWrap: "_o5721jtm"
};
const $0fd9c621f10bd238$export$e33faa86e0996d96 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, whiteSpacePreWrap: whiteSpacePreWrap = true, renderIcon: renderIcon = true, ...props }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
        ref: ref,
        ...props,
        xcss: $0fd9c621f10bd238$var$styles.button,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $bwpsq.default)([
                $0fd9c621f10bd238$var$stylesCompiled.pillLineHeight
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                space: "space.075",
                alignBlock: "baseline",
                children: [
                    renderIcon ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h88oy.ChatPillIcon), {}) : null,
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                        xcss: (0, $3JT92.cx)($0fd9c621f10bd238$var$styles.queryText, whiteSpacePreWrap && $0fd9c621f10bd238$var$styles.whiteSpacePreWrap),
                        children: children
                    })
                ]
            })
        })
    }));
const $0fd9c621f10bd238$export$76b47032dcd9063b = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
        ref: ref,
        ...props,
        xcss: $0fd9c621f10bd238$var$styles.button,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $bwpsq.default)([
                $0fd9c621f10bd238$var$stylesCompiled.pillLineHeight
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                space: "space.050",
                xcss: $0fd9c621f10bd238$var$styles.buttonInline,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4V6HW))), {
                        color: "currentColor",
                        label: ""
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                        xcss: $0fd9c621f10bd238$var$styles.queryText,
                        children: formatMessage((0, $eCjlc.default).browseAgentsPillLabel)
                    })
                ]
            })
        })
    });
});

});
parcelRegister("4V6HW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ec2830ef4a5653740a2b8f60e21924b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3951b0552a35072b$var$_react = $3951b0552a35072b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3951b0552a35072b$var$_baseNew = $3951b0552a35072b$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3951b0552a35072b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiAgent".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Rovo Agent.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3951b0552a35072b$var$AiAgentIcon = (props)=>/*#__PURE__*/ $3951b0552a35072b$var$_react.default.createElement($3951b0552a35072b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.971.493a2 2 0 0 1 2.058 0l5 3A2 2 0 0 1 15 5.208v5.584a2 2 0 0 1-.971 1.715l-5 3a2 2 0 0 1-2.058 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .971-1.715zm1.286 1.286a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.429v5.584a.5.5 0 0 0 .243.429l1.098.66a4.25 4.25 0 1 1 8.318 0l1.098-.66a.5.5 0 0 0 .243-.429V5.208a.5.5 0 0 0-.243-.429zM8 8.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5" clip-rule="evenodd"/>`
    }, props));
$3951b0552a35072b$var$AiAgentIcon.displayName = 'AiAgentIcon';
var $3951b0552a35072b$var$_default = module.exports.default = $3951b0552a35072b$var$AiAgentIcon;

});

parcelRegister("eCjlc", function(module, exports) {

$parcel$export(module.exports, "default", () => $34bad2d4003b85e8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $34bad2d4003b85e8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    browseAgentsPillLabel: {
        id: 'ai-mate.rovo-agent-components.browse-agents-pill.label',
        defaultMessage: 'Browse Agents',
        description: 'The label displayed on the browse agents pill'
    }
});

});


parcelRegister("52GXX", function(module, exports) {

$parcel$export(module.exports, "messages", () => $53d3212f8a8a35da$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $53d3212f8a8a35da$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    emptyStateSuggestion1: {
        id: 'ai-mate.chat-history.empty-state.suggestion1',
        defaultMessage: 'Are any of my tickets overdue?',
        description: 'The first suggestion displayed in the empty state of the chat history'
    },
    emptyStateSuggestion2: {
        id: 'ai-mate.chat-history.empty-state.suggestion2',
        defaultMessage: 'What should I work on next?',
        description: 'The second suggestion displayed in the empty state of the chat history'
    },
    emptyStateSuggestion3: {
        id: 'ai-mate.chat-history.empty-state.suggestion3',
        defaultMessage: 'Write an update about my week',
        description: 'The third suggestion displayed in the empty state of the chat history'
    },
    agentEmptyStateSuggestion1: {
        id: 'ai-mate.chat-history.empty-state.agent-suggestion1',
        defaultMessage: 'Tell me about yourself',
        description: 'The first suggestion displayed in the empty state when an agent is selected'
    },
    agentEmptyStateSuggestion2: {
        id: 'ai-mate.chat-history.empty-state.agent-suggestion2',
        defaultMessage: 'What can you help me with?',
        description: 'The second suggestion displayed in the empty state when an agent is selected'
    },
    agentEmptyStateSuggestion3: {
        id: 'ai-mate.chat-history.empty-state.agent-suggestion3',
        defaultMessage: "Summarize what I'm looking at",
        description: 'The third suggestion displayed in the empty state when an agent is selected'
    }
});

});


parcelRegister("4kUAd", function(module, exports) {

$parcel$export(module.exports, "MainContentHeaders", () => $e8e70b7038ae1c5a$export$161f9e38c5e0d38e);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cgL5K = parcelRequire("cgL5K");
const $e8e70b7038ae1c5a$export$161f9e38c5e0d38e = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgL5K.default), {
        size: "large",
        color: "color.text.subtle",
        weight: "semibold",
        children: children
    });

});


parcelRegister("j9p2O", function(module, exports) {

$parcel$export(module.exports, "AgentCreator", () => $bef29a5dc839b1ea$export$d892e919a94dad49);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $77Oft = parcelRequire("77Oft");

var $hd01g = parcelRequire("hd01g");

var $7YTpJ = parcelRequire("7YTpJ");
const $bef29a5dc839b1ea$export$d892e919a94dad49 = ({ creator: creator, create_type: create_type })=>{
    const userId = create_type === 'CUSTOMER' && creator ? (0, $7YTpJ.trimUserARI)(creator) : '';
    const { isLoading: isLoading, data: data } = (0, $hd01g.useTeamsUser)(userId, !userId);
    const getCreator = ()=>{
        switch(create_type){
            case 'SYSTEM':
                return {
                    type: 'SYSTEM'
                };
            case 'THIRD_PARTY':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'FORGE':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'CUSTOMER':
                return {
                    type: 'CUSTOMER',
                    name: data?.fullName || '',
                    profileLink: data?.id ? `/people/${(0, $7YTpJ.trimUserARI)(data.id)}` : '/people/search'
                };
        }
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $77Oft.AgentProfileCreator), {
        creator: getCreator(),
        isLoading: isLoading,
        onCreatorLinkClick: ()=>{}
    });
};

});

parcelRegister("l9Oyp", function(module, exports) {

$parcel$export(module.exports, "default", () => $3376005ab09c827e$export$2e2bcd8739ae039);
/* AgentDeleteConfirmationModal.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $eCeGD = parcelRequire("eCeGD");

var $qfj8c = parcelRequire("qfj8c");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");
const $3376005ab09c827e$var$styles = {
    err: "_19pkutpp"
};
const $3376005ab09c827e$var$agentResponseMessageTemplate = {
    AGENT_DOES_NOT_EXIST: 'errorAgentNotFound',
    USER_NOT_CREATOR: 'errorIncorrectOwner',
    AGENT_HAS_CONVERSATIONS: 'errorAgentInUse',
    AGENT_DELETE_SUCCESS: 'agentDeletedSuccess'
};
const $3376005ab09c827e$export$39d869cf16a68f79 = ({ onClose: onClose, agentName: agentName, agentId: agentId, onDelete: onDelete })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [deleteError, setDeleteError] = (0, $5uXOq.useState)();
    const [isDeletePending, setIsDeletePending] = (0, $5uXOq.useState)(false);
    const handleDeleteAgent = (0, $5uXOq.useCallback)(async ()=>{
        if (agentId) {
            setIsDeletePending(true);
            try {
                await onDelete?.();
                onClose?.();
            } catch (error) {
                setDeleteError(formatMessage($3376005ab09c827e$var$messages[$3376005ab09c827e$var$agentResponseMessageTemplate[error?.message_template]]));
            } finally{
                setIsDeletePending(false);
            }
        }
    }, [
        agentId,
        formatMessage,
        onClose,
        onDelete
    ]);
    if (!agentId) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $1R1Ge.default), {
        width: "small",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jgVsb.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gofOI.default), {
                    children: formatMessage($3376005ab09c827e$var$messages.title, {
                        agentName: agentName
                    })
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7QSqG.default), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                        as: "p",
                        children: formatMessage($3376005ab09c827e$var$messages.body)
                    }),
                    deleteError && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                        xcss: $3376005ab09c827e$var$styles.err,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $qfj8c.ErrorMessage), {
                            children: deleteError
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $juxqI.default), {
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                                appearance: "subtle",
                                onClick: onClose,
                                children: formatMessage($3376005ab09c827e$var$messages.cancelText)
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                                appearance: "danger",
                                isDisabled: !!deleteError || isDeletePending,
                                onClick: (_e, _event)=>{
                                    handleDeleteAgent();
                                },
                                children: formatMessage($3376005ab09c827e$var$messages.confirmText)
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $3376005ab09c827e$export$2e2bcd8739ae039 = $3376005ab09c827e$export$39d869cf16a68f79;
const $3376005ab09c827e$var$messages = (0, $7VHMR.defineMessages)({
    cancelText: {
        id: 'ptc-directory.agent-profile.agent-delete-confirm.cancel-text',
        defaultMessage: 'Cancel'
    },
    confirmText: {
        id: 'ptc-directory.agent-profile.agent-delete-confirm.confirm-text',
        defaultMessage: 'Delete'
    },
    title: {
        id: 'ptc-directory.agent-profile.delete-agent-confirm-title',
        defaultMessage: 'Delete "{agentName}"?',
        description: 'Title text for the delete agent confirmation modal'
    },
    body: {
        id: 'ptc-directory.agent-profile.delete-agent-confirm-body',
        defaultMessage: `Are you sure you want to delete this agent? This action cannot be undone.`,
        description: 'Body text for the delete agent confirmation modal'
    },
    error: {
        id: 'ptc-directory.agent-profile.delete-agent-error',
        defaultMessage: 'Could not delete agent',
        description: 'Error message displayed when an agent cannot be deleted'
    },
    errorAgentNotFound: {
        id: 'ptc-directory.agent-profile.delete-agent-error.agent-not-found',
        defaultMessage: 'That agent could not be found.',
        description: 'Error message displayed when an agent cannot be found'
    },
    errorAgentInUse: {
        id: 'ptc-directory.agent-profile.delete-agent-error.agent-in-use',
        defaultMessage: 'Agent is currently in use. Try again later.',
        description: 'Error message displayed when an agent is in use'
    },
    errorIncorrectOwner: {
        id: 'ptc-directory.agent-profile.delete-agent-error.incorrect-owner',
        defaultMessage: 'You cannot delete agents you have not created yourself. Please contact the agent owner.',
        description: 'Error message displayed when the agent owner is incorrect'
    },
    agentDeletedSuccess: {
        id: 'ptc-directory.agent-profile.delete-agent-success',
        defaultMessage: 'Agent has been deleted!',
        description: 'Success message displayed when an agent is deleted'
    }
});

});

parcelRegister("i9EPN", function(module, exports) {

$parcel$export(module.exports, "useAgentActions", () => $4e35ca995668cf2a$export$9115df56efd01c09);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $9oBwb = parcelRequire("9oBwb");

var $5euJh = parcelRequire("5euJh");

var $bpqZM = parcelRequire("bpqZM");
var $lwQnS = parcelRequire("lwQnS");
var $2gP8c = parcelRequire("2gP8c");

var $3FH71 = parcelRequire("3FH71");

var $fyzT1 = parcelRequire("fyzT1");

var $fPHPe = parcelRequire("fPHPe");
var $75AK4 = parcelRequire("75AK4");

var $38Ckm = parcelRequire("38Ckm");
const $4e35ca995668cf2a$export$9115df56efd01c09 = ({ agentId: agentId, agentName: agentName, agentIdentityAccountId: agentIdentityAccountId, assistanceServiceParams: assistanceServiceParams })=>{
    const addFlag = (0, $fPHPe.useFlags)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { push: push } = (0, $75AK4.useRouter)();
    const { favouriteAgent: favouriteAgent, unfavouriteAgent: unfavouriteAgent } = (0, $bpqZM.useAgentFavourites)({
        assistanceServiceParams: assistanceServiceParams
    });
    const { onEditAgent: onEditAgent, onCopyAgent: onCopyAgent, onDuplicateAgent: onDuplicateAgent } = (0, $lwQnS.useAgentUrlActions)({
        siteId: assistanceServiceParams.siteId
    });
    const { deleteAgent: deleteRovoAgent } = (0, $2gP8c.useDeleteAgent)({
        assistanceServiceParams: assistanceServiceParams
    });
    const setFavouriteAgent = (0, $5uXOq.useCallback)(async (isFavourite, onSuccess)=>{
        if (!agentId) return;
        if (isFavourite) return await favouriteAgent.mutate(agentId, {
            onSuccess: onSuccess
        });
        else return await unfavouriteAgent.mutate(agentId, {
            onSuccess: onSuccess
        });
    }, [
        agentId,
        favouriteAgent,
        unfavouriteAgent
    ]);
    const { fireEvent: fireEvent } = (0, $3FH71.usePeopleTeamAnalyticsEvents)();
    const editAgent = ()=>{
        if (!agentId) return;
        fireEvent('ui.editAgent.clicked', {});
        onEditAgent(agentId);
    };
    const copyAgent = ()=>{
        if (!agentId) return;
        fireEvent('ui.copyAgent.clicked', {});
        onCopyAgent({
            agentId: agentId,
            agentIdentityAccountId: agentIdentityAccountId
        });
    };
    const duplicateAgent = ()=>{
        if (!agentId) return;
        fireEvent('ui.duplicateAgent.clicked', {});
        onDuplicateAgent(agentId, 'agentProfilePage');
    };
    const deleteAgent = ()=>{
        if (!agentId) return;
        fireEvent('ui.deleteAgent.clicked', {});
        deleteRovoAgent.mutate(agentId, {
            onSuccess: ()=>{
                addFlag({
                    title: formatMessage((0, $38Ckm.messages).agentDeletedSuccessFlagTitle),
                    description: formatMessage((0, $38Ckm.messages).agentDeletedSuccessFlagDescription, {
                        agentName: agentName
                    }),
                    type: 'success',
                    id: 'ptc-directory.agent-profile.delete-agent-success'
                }, {
                    sendAnalytics: true,
                    name: (0, $fyzT1.AnalyticsEventSource).AGENT_DELETE_SUCCESS_FLAG
                });
                setTimeout(()=>{
                    push('search');
                }, 100);
            },
            onError: ()=>{
                addFlag({
                    title: formatMessage((0, $38Ckm.messages).agentDeletedErrorFlagTitle),
                    description: formatMessage((0, $38Ckm.messages).agentDeletedErrorFlagDescription),
                    type: 'error',
                    id: 'ptc-directory.agent-profile.delete-agent-error'
                }, {
                    sendAnalytics: true,
                    name: (0, $fyzT1.AnalyticsEventSource).AGENT_DELETE_ERROR_FLAG
                });
            }
        });
    };
    const onChatWithAgent = ()=>{
        if (!agentId) return;
        fireEvent('ui.chatWithAgent.clicked', {});
        window.open((0, $9oBwb.addRovoParamsToUrl)(`${(0, $5euJh.getATLContextUrl)('home')}/chat`, {
            pathway: 'chat',
            cloudId: assistanceServiceParams.siteId,
            agentId: agentId
        }), '_blank', 'noopener, noreferrer');
    };
    const startConversation = (prompt)=>{
        if (!agentId) return;
        fireEvent('ui.startConversationWithAgent.clicked', {});
        window.open((0, $9oBwb.addRovoParamsToUrl)(`${(0, $5euJh.getATLContextUrl)('home')}/chat`, {
            pathway: 'chat',
            prompt: prompt,
            cloudId: assistanceServiceParams.siteId,
            agentId: agentId
        }), '_blank', 'noopener, noreferrer');
    };
    return {
        setFavouriteAgent: setFavouriteAgent,
        editAgent: editAgent,
        copyAgent: copyAgent,
        duplicateAgent: duplicateAgent,
        deleteAgent: deleteAgent,
        onChatWithAgent: onChatWithAgent,
        startConversation: startConversation
    };
};

});
parcelRegister("bpqZM", function(module, exports) {

$parcel$export(module.exports, "useAgentFavourites", () => $2fbe1e44fe5af5f2$export$5c4c46b1f93a6e69);

var $91cKc = parcelRequire("91cKc");

var $cK3Jm = parcelRequire("cK3Jm");
var $mNrGv = parcelRequire("mNrGv");
const $2fbe1e44fe5af5f2$export$5c4c46b1f93a6e69 = (0, $cK3Jm.createHookWithAssistanceService)(({ onError: onError, onSuccess: onSuccess, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker } })=>{
    const favouriteAgent = (0, $mNrGv.useMutation)({
        mutationFn: async (id)=>{
            experienceTracker.start({
                id: (0, $91cKc.ExperienceName).FAVOURITE_AGENT,
                name: (0, $91cKc.ExperienceName).FAVOURITE_AGENT
            });
            return await assistanceService.favouriteAgent(id);
        },
        onSuccess: async ()=>{
            experienceTracker.succeed({
                name: (0, $91cKc.ExperienceName).FAVOURITE_AGENT
            });
            onSuccess?.({
                favourite: true
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $91cKc.ExperienceName).FAVOURITE_AGENT,
                error: error
            });
            onError?.({
                favourite: true
            });
        }
    });
    const unfavouriteAgent = (0, $mNrGv.useMutation)({
        mutationFn: async (id)=>{
            experienceTracker.start({
                id: (0, $91cKc.ExperienceName).UNFAVOURITE_AGENT,
                name: (0, $91cKc.ExperienceName).UNFAVOURITE_AGENT
            });
            return await assistanceService.unfavouriteAgent(id);
        },
        onSuccess: async ()=>{
            experienceTracker.succeed({
                name: (0, $91cKc.ExperienceName).UNFAVOURITE_AGENT
            });
            onSuccess?.({
                favourite: false
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $91cKc.ExperienceName).UNFAVOURITE_AGENT,
                error: error
            });
            onError?.({
                favourite: false
            });
        }
    });
    return {
        favouriteAgent: favouriteAgent,
        unfavouriteAgent: unfavouriteAgent
    };
});

});
parcelRegister("mNrGv", function(module, exports) {

$parcel$export(module.exports, "useMutation", () => $46b29c557c6575a6$export$609860bf8b0084c);

var $5uXOq = parcelRequire("5uXOq");

var $gRLdW = parcelRequire("gRLdW");
const $46b29c557c6575a6$export$609860bf8b0084c = ({ mutationFn: mutationFn, onSuccess: onSuccess, onError: onError })=>{
    const mutationFnRef = (0, $5uXOq.useRef)(mutationFn);
    mutationFnRef.current = mutationFn;
    const onSuccessRef = (0, $5uXOq.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $5uXOq.useRef)(onError);
    onErrorRef.current = onError;
    const [data, setData] = (0, $5uXOq.useState)(null);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [isSubmitting, setIsSubmitting] = (0, $5uXOq.useState)(false);
    const mutate = (0, $5uXOq.useCallback)(async (payload, mutateCallback)=>{
        setIsSubmitting(true);
        try {
            const response = await mutationFnRef.current(payload);
            setData(response);
            onSuccessRef.current?.(response);
            mutateCallback?.onSuccess?.(response);
            return response;
        } catch (error) {
            const apiError = (0, $gRLdW.mapErrorToApiError)(error);
            setError(apiError);
            onErrorRef.current?.(apiError, payload);
            mutateCallback?.onError?.(apiError);
        } finally{
            setIsSubmitting(false);
        }
    }, []);
    return {
        data: data,
        error: error,
        isSubmitting: isSubmitting,
        mutate: mutate
    };
};

});


parcelRegister("lwQnS", function(module, exports) {

$parcel$export(module.exports, "useAgentUrlActions", () => $54c9716caa3eca00$export$56665b80ee272742);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $9oBwb = parcelRequire("9oBwb");

var $jSnf2 = parcelRequire("jSnf2");

var $dKytL = parcelRequire("dKytL");

var $coJZk = parcelRequire("coJZk");
const $54c9716caa3eca00$export$56665b80ee272742 = ({ siteId: siteId })=>{
    const { atlasURL: atlasURL } = (0, $coJZk.useAtlasURL)(siteId);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $jSnf2.useAnalytics)();
    const onEditAgent = (0, $5uXOq.useCallback)((agentId)=>{
        if ((0, $VSDnB.fg)('redirect_rovo_to_agent_studio_enabled')) window.open((0, $dKytL.getAtlassianStudioAgentEditUrl)(siteId, agentId));
        else window.open(atlasURL(`/chat/agents/${agentId}/edit`), '_blank', 'noopener, noreferrer');
    }, [
        atlasURL,
        siteId
    ]);
    const onCopyAgent = (0, $5uXOq.useCallback)(({ agentId: agentId, agentIdentityAccountId: agentIdentityAccountId })=>{
        if (agentIdentityAccountId) {
            if ((0, $VSDnB.fg)('rovo_chat_agent_url_via_atlas')) navigator.clipboard.writeText(atlasURL(`/people/agent/${agentId}`));
            else navigator.clipboard.writeText(`${window.location.origin}/people/agent/${agentId}`);
            return;
        }
        const rovoParams = (0, $9oBwb.encodeRovoParams)({
            pathway: 'chat',
            agentId: agentId
        });
        navigator.clipboard.writeText(atlasURL(`/chat?${rovoParams}`));
    }, [
        atlasURL
    ]);
    const onDuplicateAgent = (0, $5uXOq.useCallback)((agentId, source)=>{
        if ((0, $VSDnB.fg)('redirect_rovo_to_agent_studio_enabled')) window.open((0, $dKytL.getAtlassianStudioAgentDuplicateUrl)(siteId, agentId));
        else {
            const rovoParams = (0, $9oBwb.encodeRovoParams)({
                pathway: 'agents-create',
                agentId: agentId
            });
            window.open(atlasURL(`/chat/agents/new?${rovoParams}`), '_blank', 'noopener, noreferrer');
        }
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'duplicateAgentButton',
            attributes: {
                agentId: agentId,
                source: source
            }
        });
    }, [
        atlasURL,
        sendAnalyticsEvent,
        siteId
    ]);
    const onViewAgentFullProfile = (0, $5uXOq.useCallback)((agentId)=>{
        window.open(`${window.location.origin}/people/agent/${agentId}`, '_blank', 'noopener, noreferrer');
    }, []);
    const onStartNewChatWindowWithPrompt = (0, $5uXOq.useCallback)((agentId, prompt)=>{
        const rovoParams = (0, $9oBwb.encodeRovoParams)({
            pathway: 'chat',
            agentId: agentId,
            prompt: prompt
        });
        window.open(atlasURL(`/chat?${rovoParams}`), '_blank', 'noopener, noreferrer');
    }, [
        atlasURL
    ]);
    return {
        onEditAgent: onEditAgent,
        onCopyAgent: onCopyAgent,
        onDuplicateAgent: onDuplicateAgent,
        onViewAgentFullProfile: onViewAgentFullProfile,
        onStartNewChatWindowWithPrompt: onStartNewChatWindowWithPrompt
    };
};

});
parcelRegister("dKytL", function(module, exports) {

$parcel$export(module.exports, "getAtlassianStudioAgentCreateUrl", () => $0b63f22ce03bfb94$export$fe475324c26e3007);
$parcel$export(module.exports, "getAtlassianStudioAgentEditUrl", () => $0b63f22ce03bfb94$export$a20abb994c34f0a4);
$parcel$export(module.exports, "getAtlassianStudioAgentDuplicateUrl", () => $0b63f22ce03bfb94$export$36c11ab884b7b2cb);
const $0b63f22ce03bfb94$export$fe475324c26e3007 = (siteId)=>`/studio/s/${siteId}/agents/create/overview`;
// helpers to generate urls to redirect from rovo to atlassian studio using the enrichment route in studio
const $0b63f22ce03bfb94$var$getAtlassianStudioRedirectBaseUrl = (siteId, agentId)=>`/studio/s/${siteId}/agents/enrich/rovo/agents/${agentId}`;
const $0b63f22ce03bfb94$export$a20abb994c34f0a4 = (siteId, agentId)=>`${$0b63f22ce03bfb94$var$getAtlassianStudioRedirectBaseUrl(siteId, agentId)}?redirect=${encodeURIComponent('/:agentId/overview')}`;
const $0b63f22ce03bfb94$export$36c11ab884b7b2cb = (siteId, agentId)=>`${$0b63f22ce03bfb94$var$getAtlassianStudioRedirectBaseUrl(siteId, agentId)}?redirect=${encodeURIComponent('/create')}`;

});

parcelRegister("coJZk", function(module, exports) {

$parcel$export(module.exports, "useAtlasURL", () => $3fd98f43d07a6613$export$8a1abb7c176bd202);

var $5uXOq = parcelRequire("5uXOq");

var $f1tAG = parcelRequire("f1tAG");

var $g71tv = parcelRequire("g71tv");
const $3fd98f43d07a6613$export$8a1abb7c176bd202 = (siteId)=>{
    const { data: tenantData } = (0, $g71tv.useTenantDataController)(siteId);
    const atlasURL = (0, $5uXOq.useCallback)((path)=>(0, $f1tAG.getAtlasURL)(siteId, path, tenantData?.orgId), [
        siteId,
        tenantData?.orgId
    ]);
    return {
        atlasURL: atlasURL
    };
};
const $3fd98f43d07a6613$export$b61b99f9ac0264be = (siteId)=>{
    const { atlasURL: atlasURL } = $3fd98f43d07a6613$export$8a1abb7c176bd202(siteId);
    return atlasURL('/chat/agents/new');
};

});
parcelRegister("g71tv", function(module, exports) {

$parcel$export(module.exports, "useTenantDataController", () => $926b0b614556f1b8$export$b863fec6791eae25);

var $91cKc = parcelRequire("91cKc");
var $cSxED = parcelRequire("cSxED");

var $4ojTZ = parcelRequire("4ojTZ");

var $hJfuA = parcelRequire("hJfuA");
const $926b0b614556f1b8$export$b863fec6791eae25 = (siteId)=>{
    const experience = (0, $cSxED.useAIMateExperienceTracker)();
    const { data: data, isFetching: isFetching, error: error } = (0, $4ojTZ.useQuery)({
        queryKey: [
            'viewAgentTenantData',
            siteId
        ],
        queryFn: async ()=>{
            experience.start({
                id: (0, $91cKc.ExperienceName).FETCH_AGENT_TENANT_DATA,
                name: (0, $91cKc.ExperienceName).FETCH_AGENT_TENANT_DATA
            });
            const result = await (0, $hJfuA.getCloudUrlFromId)(siteId);
            return result;
        },
        onSuccess: ()=>{
            experience.succeed({
                name: (0, $91cKc.ExperienceName).FETCH_AGENT_TENANT_DATA
            });
        },
        onError: (error)=>{
            experience.fail({
                name: (0, $91cKc.ExperienceName).FETCH_AGENT_TENANT_DATA,
                error: error
            });
        }
    });
    return {
        data: data,
        isFetching: isFetching,
        error: error
    };
};

});
parcelRegister("hJfuA", function(module, exports) {

$parcel$export(module.exports, "getCloudUrlFromId", () => $155fa854340f6b93$export$d4ace54df9bd6bb1);

var $lyFsp = parcelRequire("lyFsp");
const $155fa854340f6b93$var$CloudIdLookupQuery = `
query tenantQuery($cloudIds: [ID!]) {
  tenantContexts(cloudIds: $cloudIds) {
    cloudUrl
	orgId
  }
}
`;
const $155fa854340f6b93$export$d4ace54df9bd6bb1 = async (cloudId)=>{
    const response = await (0, $lyFsp.performGqlFetch)({
        gqlQuery: $155fa854340f6b93$var$CloudIdLookupQuery,
        variables: {
            cloudIds: [
                cloudId
            ]
        }
    });
    return response.data?.tenantContexts?.[0];
};

});




parcelRegister("2gP8c", function(module, exports) {

$parcel$export(module.exports, "useDeleteAgent", () => $919aea89356508dc$export$89877d4f8d8790ca);

var $91cKc = parcelRequire("91cKc");

var $cK3Jm = parcelRequire("cK3Jm");
var $mNrGv = parcelRequire("mNrGv");
const $919aea89356508dc$export$89877d4f8d8790ca = (0, $cK3Jm.createHookWithAssistanceService)(({ onSuccess: onSuccess, onError: onError, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker }, onInit: onInit })=>{
    const deleteAgent = (0, $mNrGv.useMutation)({
        mutationFn: async (id)=>{
            experienceTracker.start({
                id: (0, $91cKc.ExperienceName).DELETE_AGENT,
                name: (0, $91cKc.ExperienceName).DELETE_AGENT
            });
            onInit?.(id);
            return await assistanceService.deleteAgent(id);
        },
        onSuccess: async (data)=>{
            experienceTracker.succeed({
                name: (0, $91cKc.ExperienceName).DELETE_AGENT
            });
            onSuccess?.();
            return data;
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $91cKc.ExperienceName).DELETE_AGENT,
                error: error
            });
            onError?.();
        }
    });
    return {
        deleteAgent: deleteAgent
    };
});

});

parcelRegister("75AK4", function(module, exports) {

$parcel$export(module.exports, "useRouter", () => $51b0842c1ce9558f$export$9a302a45f65d0572);

var $5uXOq = parcelRequire("5uXOq");

var $2FwA3 = parcelRequire("2FwA3");
const $51b0842c1ce9558f$export$9a302a45f65d0572 = ()=>{
    const { contextSpaPaths: contextSpaPaths, contextEntryPoint: contextEntryPoint, push: push, replace: replace, history: history } = (0, $5uXOq.useContext)((0, $2FwA3.default));
    return {
        contextSpaPaths: contextSpaPaths,
        contextEntryPoint: contextEntryPoint,
        push: push,
        replace: replace,
        history: history
    };
};

});



parcelRegister("kSbB7", function(module, exports) {

let $f321d8d81176fbf2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f321d8d81176fbf2$var$load("8QqdG").then(()=>parcelRequire('dtsuM'));

});


parcelRegister("gc5DR", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0e6274cdbe564c1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $65ws1 = parcelRequire("65ws1");
var $38ra6 = parcelRequire("38ra6");

var $2FwA3 = parcelRequire("2FwA3");

var $lY8FH = parcelRequire("lY8FH");
function $a0e6274cdbe564c1$var$recordPageVisitOrigin(replace) {
    const url = new URL(window.location.href);
    if (!url || !url.searchParams) return;
    // ref contains a product like confluence, jira etc.
    const ref = url.searchParams.get('ref') || '';
    // src contains a location like appswitcher, peopledrawer etc.
    const src = url.searchParams.get('src') || '';
    if (!ref && !src) return;
    // save referrer info for retrieving it in further screen events
    (0, $65ws1.default).set({
        src: src,
        ref: ref
    });
    url.searchParams.delete('ref');
    url.searchParams.delete('src');
    // replace location if it changed after removing ref and src query params
    if (replace) replace(`${url.pathname}${url.search}`);
}
function $a0e6274cdbe564c1$var$RecordTransition(props) {
    const { name: name } = props;
    const { replace: replace } = (0, $2FwA3.useAppConfig)();
    const refInitialLoadTracked = (0, $5uXOq.useRef)(false);
    const analytics = (0, $38ra6.default)();
    (0, $5uXOq.useEffect)(()=>{
        if (!refInitialLoadTracked.current) {
            refInitialLoadTracked.current = true;
            // stores referrer info
            $a0e6274cdbe564c1$var$recordPageVisitOrigin(replace);
        } else // cleanup stored referrer info on transition
        (0, $65ws1.default).cleanup();
        (0, $lY8FH.default)(name, analytics);
    }, [
        analytics,
        name,
        replace
    ]);
    return null;
}
var $a0e6274cdbe564c1$export$2e2bcd8739ae039 = $a0e6274cdbe564c1$var$RecordTransition;

});
parcelRegister("lY8FH", function(module, exports) {

$parcel$export(module.exports, "default", () => $64277dac6b18863c$export$2e2bcd8739ae039);

var $l7duG = parcelRequire("l7duG");
let $64277dac6b18863c$var$dwellHelper = null;
const $64277dac6b18863c$var$buildDwellEventData = (source)=>{
    return {
        actionSubject: 'page',
        source: source
    };
};
const $64277dac6b18863c$var$sendDwellEvent = (eventData, analyticsClient)=>{
    analyticsClient.sendTrackEvent(eventData);
};
const $64277dac6b18863c$var$initialiseDwellTime = (eventSource, analyticsClient)=>{
    if (eventSource) {
        const updatedEventData = $64277dac6b18863c$var$buildDwellEventData(eventSource);
        $64277dac6b18863c$var$dwellHelper = (0, $l7duG.default)((eventData)=>$64277dac6b18863c$var$sendDwellEvent(eventData, analyticsClient), updatedEventData);
        $64277dac6b18863c$var$dwellHelper.start();
    }
};
const $64277dac6b18863c$var$recordNewPageForDwellTime = (eventSource)=>{
    if ($64277dac6b18863c$var$dwellHelper) {
        if (eventSource) {
            const updatedEventData = $64277dac6b18863c$var$buildDwellEventData(eventSource);
            $64277dac6b18863c$var$dwellHelper.newPage(updatedEventData);
        } else // eslint-disable-next-line no-console
        console.error('Unable to record dwell time transition - missing analytics key or source mapping for route');
    } else // eslint-disable-next-line no-console
    console.error('Dwell time has not been initialised');
};
/**
 * Initialises dwell time measurement, or records a page transition if it is already initialised.
 * Note that dwell time will only be initialised on routes that have an analytics key, which should be
 * all routes except for those that result in a redirect.
 */ const $64277dac6b18863c$var$recordDwellTime = (analyticsKey, analyticsClient)=>{
    const eventName = analyticsClient.mapAnalyticsKeyToEvent(analyticsKey);
    const eventSource = eventName ? `${eventName}Screen` : null;
    if (!$64277dac6b18863c$var$dwellHelper) $64277dac6b18863c$var$initialiseDwellTime(eventSource, analyticsClient);
    else $64277dac6b18863c$var$recordNewPageForDwellTime(eventSource);
};
var $64277dac6b18863c$export$2e2bcd8739ae039 = $64277dac6b18863c$var$recordDwellTime;

});
parcelRegister("l7duG", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f6d4735f9f03b2d$export$2e2bcd8739ae039);

var $5NkCx = parcelRequire("5NkCx");
const $2f6d4735f9f03b2d$var$getDwellTimeHelper = (sendMethod, eventData)=>{
    return new (0, $5NkCx.default)(sendMethod, eventData);
};
var $2f6d4735f9f03b2d$export$2e2bcd8739ae039 = $2f6d4735f9f03b2d$var$getDwellTimeHelper;

});




parcelRegister("9ADns", function(module, exports) {

$parcel$export(module.exports, "default", () => $dadd0bb5a806c0e3$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fyzT1 = parcelRequire("fyzT1");
var $ioKz4 = parcelRequire("ioKz4");

var $kNtbp = parcelRequire("kNtbp");

var $gc5DR = parcelRequire("gc5DR");
function $dadd0bb5a806c0e3$var$hasProfileProp(state) {
    return !!state && 'profile' in state;
}
const $dadd0bb5a806c0e3$var$KudosPageRoute = ({ match: match, location: location })=>{
    const { uuid: uuid } = match.params;
    const profile = $dadd0bb5a806c0e3$var$hasProfileProp(location.state) ? location.state.profile : undefined;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gc5DR.default), {
                name: (0, $fyzT1.AnalyticsKeys).KUDOS_PAGE_VIEW
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ioKz4.default), {
                name: (0, $fyzT1.AnalyticsKeys).KUDOS_PAGE_VIEW
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kNtbp.default), {
                uuid: uuid,
                referrerProfile: profile
            })
        ]
    });
};
var $dadd0bb5a806c0e3$export$2e2bcd8739ae039 = $dadd0bb5a806c0e3$var$KudosPageRoute;

});
parcelRegister("kNtbp", function(module, exports) {

$parcel$export(module.exports, "default", () => $967c45884049b603$export$2e2bcd8739ae039);

var $4qBtX = parcelRequire("4qBtX");

const $967c45884049b603$var$LazyKudosPage = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("7bUsB")),
    loading: ()=>null
});
$967c45884049b603$var$LazyKudosPage.displayName = 'lazy(KudosPage)';
var $967c45884049b603$export$2e2bcd8739ae039 = $967c45884049b603$var$LazyKudosPage;

});
parcelRegister("7bUsB", function(module, exports) {

let $0159e491e683568e$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0159e491e683568e$var$load("ffQaD"),
    $0159e491e683568e$var$load("kvRbA"),
    $0159e491e683568e$var$load("dack6")
]).then(()=>parcelRequire('1MiwD'));

});



parcelRegister("fiymB", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc770c7507c2347f$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fyzT1 = parcelRequire("fyzT1");
var $6l1dD = parcelRequire("6l1dD");
var $38ra6 = parcelRequire("38ra6");
var $fff3y = parcelRequire("fff3y");

var $bj9AK = parcelRequire("bj9AK");
function $cc770c7507c2347f$export$2e2bcd8739ae039(props) {
    const { contextEntryPoint: contextEntryPoint, location: location } = props;
    const [{ principalUserId: principalUserId }] = (0, $fff3y.usePrincipalUser)();
    const analytics = (0, $38ra6.default)();
    const url = new URL(window.location.href);
    const ref = (0, $6l1dD.sanitiseValue)(url.searchParams.get('ref') || '', {
        shouldHaveSafeCharsOnly: true,
        shouldEncode: true
    });
    (0, $5uXOq.useEffect)(()=>{
        analytics.pushTrackEvent({
            source: (0, $fyzT1.AnalyticsEventSource).USER_PROFILE_SCREEN,
            actionSubject: 'redirectMePathToMyProfile',
            action: (0, $fyzT1.AnalyticsEventActions).REDIRECTED,
            attributes: {
                ref: ref
            }
        });
    }, [
        analytics,
        ref
    ]);
    if (!principalUserId) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bj9AK.default), {
        to: `${contextEntryPoint}/${principalUserId}${location.search}`
    });
}

});
parcelRegister("bj9AK", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c19be44686df00c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2FwA3 = parcelRequire("2FwA3");
const $0c19be44686df00c$var$Redirect = ({ to: to })=>{
    const { replace: replace } = (0, $2FwA3.useAppConfig)();
    (0, $5uXOq.useEffect)(()=>{
        replace(to);
    }, [
        replace,
        to
    ]);
    return null;
};
var $0c19be44686df00c$export$2e2bcd8739ae039 = $0c19be44686df00c$var$Redirect;

});


parcelRegister("8qmUa", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5854d2587ae32ae$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bj9AK = parcelRequire("bj9AK");
const $b5854d2587ae32ae$var$RootRedirect = ({ location: location })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $bj9AK.default), {
        to: `search${location.search}`
    });
var $b5854d2587ae32ae$export$2e2bcd8739ae039 = $b5854d2587ae32ae$var$RootRedirect;

});

parcelRegister("fj1iI", function(module, exports) {

$parcel$export(module.exports, "RouteWithOrgIdLoading", () => $1b36544f506dd491$export$ae0909755df943ac);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fCZyz = parcelRequire("fCZyz");

var $47bDC = parcelRequire("47bDC");

var $eZJjh = parcelRequire("eZJjh");

var $6laLp = parcelRequire("6laLp");

var $c5gm9 = parcelRequire("c5gm9");

var $8qmUa = parcelRequire("8qmUa");
function $1b36544f506dd491$export$ae0909755df943ac({ LoadingComponent: LoadingComponent, ...props }) {
    const [{ orgId: orgId }] = (0, $c5gm9.useOrg)();
    const [timedOut, setTimedOut] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState(false);
    const handleNoOrgId = (0, $5uXOq.useCallback)(()=>{
        (0, $6laLp.logInfoMessage)('No orgId found after 10 seconds', {
            ...props
        });
        setTimedOut(true);
    }, [
        setTimedOut,
        props
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (orgId) return;
        const timeout = setTimeout(()=>{
            if (!orgId) handleNoOrgId();
        }, 10000);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        orgId,
        handleNoOrgId
    ]);
    if (timedOut) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8qmUa.default), {
        location: {
            search: ''
        }
    });
    if (!orgId) return LoadingComponent ? /*#__PURE__*/ (0, $2OMIu.jsx)(LoadingComponent, {}) : /*#__PURE__*/ (0, $2OMIu.jsx)($1b36544f506dd491$var$DefaultLoadingWrapper, {
        "data-testid": "route-with-org-id-loading",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
            size: 'large'
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fCZyz.default), {
        ...props
    });
}
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1b36544f506dd491$var$DefaultLoadingWrapper = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1wps406-0"
})`height:100%;width:100%;padding-top:100px;display:flex;justify-content:center;align-items:center;`;

});

parcelRegister("aHh7I", function(module, exports) {

$parcel$export(module.exports, "default", () => $0038ebeff682e50e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fyzT1 = parcelRequire("fyzT1");
var $ioKz4 = parcelRequire("ioKz4");

var $gc5DR = parcelRequire("gc5DR");

var $hGR3k = parcelRequire("hGR3k");
const $0038ebeff682e50e$var$SearchPageRoute = ()=>{
    const url = new URL(window.location.href);
    const searchQuery = url.searchParams.get('q') || '';
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gc5DR.default), {
                name: (0, $fyzT1.AnalyticsKeys).PEOPLE_VIEW
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ioKz4.default), {
                name: (0, $fyzT1.AnalyticsKeys).PEOPLE_VIEW
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hGR3k.default), {
                    searchQuery: searchQuery
                })
            })
        ]
    });
};
var $0038ebeff682e50e$export$2e2bcd8739ae039 = $0038ebeff682e50e$var$SearchPageRoute;

});
parcelRegister("hGR3k", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a2a2b999f52843d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $7a2a2b999f52843d$var$LazySearchPage = (0, $5uXOq.lazy)(()=>(parcelRequire("e5LD7")));
var $7a2a2b999f52843d$export$2e2bcd8739ae039 = $7a2a2b999f52843d$var$LazySearchPage;

});
parcelRegister("e5LD7", function(module, exports) {

let $a4267aa4fe019061$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a4267aa4fe019061$var$load("iOxzO").then(()=>parcelRequire('f4P8b'));

});



parcelRegister("hEEh7", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6afa4dd7fbd8e02$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fyzT1 = parcelRequire("fyzT1");
var $ioKz4 = parcelRequire("ioKz4");

var $gc5DR = parcelRequire("gc5DR");

var $1eng9 = parcelRequire("1eng9");
const $b6afa4dd7fbd8e02$var$SearchTeamsError = ()=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gc5DR.default), {
                name: (0, $fyzT1.AnalyticsKeys).ALL_TEAMS_DISABLED
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ioKz4.default), {
                name: (0, $fyzT1.AnalyticsKeys).ALL_TEAMS_DISABLED
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1eng9.LazyTeamsDisabled), {})
        ]
    });
};
var $b6afa4dd7fbd8e02$export$2e2bcd8739ae039 = $b6afa4dd7fbd8e02$var$SearchTeamsError;

});
parcelRegister("1eng9", function(module, exports) {

$parcel$export(module.exports, "LazyTeamsDisabled", () => $bb5261a42ebcd0e1$export$f063de2a1a254e59);

var $4qBtX = parcelRequire("4qBtX");

const $bb5261a42ebcd0e1$export$f063de2a1a254e59 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("lEGCq")).then((module)=>module.TeamsDisabled),
    loading: ()=>null
});
$bb5261a42ebcd0e1$export$f063de2a1a254e59.displayName = 'lazy(TeamsDisabled)';

});
parcelRegister("lEGCq", function(module, exports) {

let $fc3e649966fffb27$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fc3e649966fffb27$var$load("9e17p").then(()=>parcelRequire('gVX14'));

});



parcelRegister("9Wt9a", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bd2ecbdb3e658af$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fyzT1 = parcelRequire("fyzT1");
var $55DQp = parcelRequire("55DQp");
var $ioKz4 = parcelRequire("ioKz4");

var $gc5DR = parcelRequire("gc5DR");

var $V3p3m = parcelRequire("V3p3m");
const $9bd2ecbdb3e658af$var$TeamProfileRoute = ({ match: match })=>{
    const { teamId: teamId } = match.params;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gc5DR.default), {
                name: (0, $fyzT1.AnalyticsKeys).TEAM_PROFILE_VIEW
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ioKz4.default), {
                name: (0, $fyzT1.AnalyticsKeys).TEAM_PROFILE_VIEW
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $55DQp.default), {
                teamId: teamId
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $V3p3m.default), {
                teamId: teamId
            })
        ]
    });
};
var $9bd2ecbdb3e658af$export$2e2bcd8739ae039 = $9bd2ecbdb3e658af$var$TeamProfileRoute;

});
parcelRegister("55DQp", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc7e64bf9ee8f352$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jZ6HJ = parcelRequire("jZ6HJ");

var $38ra6 = parcelRequire("38ra6");
function $fc7e64bf9ee8f352$export$2e2bcd8739ae039({ teamId: teamId }) {
    const analytics = (0, $38ra6.default)();
    (0, $jZ6HJ.useInjectedEventAttribute)('teamId', teamId);
    (0, $5uXOq.useEffect)(()=>{
        analytics.setTeamId(teamId);
        ()=>{
            analytics.setTeamId(undefined);
        };
    }, [
        analytics,
        teamId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {});
}

});

parcelRegister("V3p3m", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea1d11fa9f4cbcb4$export$2e2bcd8739ae039);

var $4qBtX = parcelRequire("4qBtX");

const $ea1d11fa9f4cbcb4$var$TeamProfilePage = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("clrRf")),
    loading: ()=>null
});
$ea1d11fa9f4cbcb4$var$TeamProfilePage.displayName = 'lazy(TeamProfilePage)';
var $ea1d11fa9f4cbcb4$export$2e2bcd8739ae039 = $ea1d11fa9f4cbcb4$var$TeamProfilePage;

});
parcelRegister("clrRf", function(module, exports) {

let $8fcd0e30bed91fd2$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $8fcd0e30bed91fd2$var$load("76n7a"),
    $8fcd0e30bed91fd2$var$load("l253H"),
    $8fcd0e30bed91fd2$var$load("ffQaD"),
    $8fcd0e30bed91fd2$var$load("kvRbA"),
    $8fcd0e30bed91fd2$var$load("b36pW")
]).then(()=>parcelRequire('aoGdH'));

});



parcelRegister("jM6Gv", function(module, exports) {

$parcel$export(module.exports, "default", () => $95b1d2aa4460da7f$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bj9AK = parcelRequire("bj9AK");
const $95b1d2aa4460da7f$var$TeamNoIdRedirect = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $bj9AK.default), {
        to: "/search"
    });
var $95b1d2aa4460da7f$export$2e2bcd8739ae039 = $95b1d2aa4460da7f$var$TeamNoIdRedirect;

});

parcelRegister("9jKbC", function(module, exports) {

$parcel$export(module.exports, "default", () => $26a7f016093515ae$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fyzT1 = parcelRequire("fyzT1");
var $ioKz4 = parcelRequire("ioKz4");

var $8X7rl = parcelRequire("8X7rl");

var $gc5DR = parcelRequire("gc5DR");
const $26a7f016093515ae$var$UserProfileRoute = ({ match: match })=>{
    const { userId: userId } = match.params;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gc5DR.default), {
                name: (0, $fyzT1.AnalyticsKeys).PROFILE_PAGE_VIEW
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ioKz4.default), {
                name: (0, $fyzT1.AnalyticsKeys).PROFILE_PAGE_VIEW
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8X7rl.default), {
                userId: decodeURIComponent(userId)
            })
        ]
    });
};
var $26a7f016093515ae$export$2e2bcd8739ae039 = $26a7f016093515ae$var$UserProfileRoute;

});
parcelRegister("8X7rl", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f3ecfab3910cd14$export$2e2bcd8739ae039);

var $4qBtX = parcelRequire("4qBtX");

const $8f3ecfab3910cd14$var$LazyUserProfile = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("lEB2r")),
    loading: ()=>null
});
$8f3ecfab3910cd14$var$LazyUserProfile.displayName = 'lazy(UserProfile)';
var $8f3ecfab3910cd14$export$2e2bcd8739ae039 = $8f3ecfab3910cd14$var$LazyUserProfile;

});
parcelRegister("lEB2r", function(module, exports) {

let $fc3a1073fdb1a313$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $fc3a1073fdb1a313$var$load("76n7a"),
    $fc3a1073fdb1a313$var$load("l253H"),
    $fc3a1073fdb1a313$var$load("ffQaD"),
    $fc3a1073fdb1a313$var$load("kvRbA"),
    $fc3a1073fdb1a313$var$load("1pLKW")
]).then(()=>parcelRequire('20fOf'));

});



parcelRegister("9PUJF", function(module, exports) {

$parcel$export(module.exports, "default", () => $861a59b3e7732549$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bj9AK = parcelRequire("bj9AK");
const $861a59b3e7732549$var$UserProfileUnknownRoute = ({ match: match })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $bj9AK.default), {
        to: match.params.userId
    });
var $861a59b3e7732549$export$2e2bcd8739ae039 = $861a59b3e7732549$var$UserProfileUnknownRoute;

});

parcelRegister("bVufh", function(module, exports) {

$parcel$export(module.exports, "default", () => $f219f2f7c850802c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fyzT1 = parcelRequire("fyzT1");
var $ioKz4 = parcelRequire("ioKz4");

var $gc5DR = parcelRequire("gc5DR");

var $kQx20 = parcelRequire("kQx20");
const $f219f2f7c850802c$var$UserProfileWorkedOn = ({ match: match })=>{
    const { userId: userId } = match.params;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gc5DR.default), {
                name: (0, $fyzT1.AnalyticsKeys).PROFILE_WORKED_ON_PAGE_VIEW
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ioKz4.default), {
                name: (0, $fyzT1.AnalyticsKeys).PROFILE_WORKED_ON_PAGE_VIEW
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kQx20.default), {
                userId: decodeURIComponent(userId)
            })
        ]
    });
};
var $f219f2f7c850802c$export$2e2bcd8739ae039 = $f219f2f7c850802c$var$UserProfileWorkedOn;

});
parcelRegister("kQx20", function(module, exports) {

$parcel$export(module.exports, "default", () => $9487606d10049190$export$2e2bcd8739ae039);

var $4qBtX = parcelRequire("4qBtX");

const $9487606d10049190$var$LazyUserProfileWorkedOn = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("3fWVv")),
    loading: ()=>null
});
$9487606d10049190$var$LazyUserProfileWorkedOn.displayName = 'lazy(UserProfileWorkedOn)';
var $9487606d10049190$export$2e2bcd8739ae039 = $9487606d10049190$var$LazyUserProfileWorkedOn;

});
parcelRegister("3fWVv", function(module, exports) {

let $25f07b5f1880f06c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $25f07b5f1880f06c$var$load("5NfXv").then(()=>parcelRequire('fvhIV'));

});




parcelRegister("bmfV0", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7a70e415cdb406b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $grAcD = parcelRequire("grAcD");

var $39CLR = parcelRequire("39CLR");

var $2FwA3 = parcelRequire("2FwA3");

var $1yBns = parcelRequire("1yBns");
const $f7a70e415cdb406b$var$appProductMap = {
    '': '',
    'site-directory': '',
    'confluence-directory': (0, $grAcD.ProductName).CONFLUENCE,
    'jira-directory': (0, $grAcD.ProductName).JIRA,
    'teamcentral-directory': (0, $grAcD.ProductName).ATLAS,
    'home-directory': (0, $grAcD.ProductName).HOME
};
const $f7a70e415cdb406b$var$mapAppToProduct = (app)=>{
    return $f7a70e415cdb406b$var$appProductMap[app];
};
class $f7a70e415cdb406b$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    render() {
        // This is here to let productFeatureFlags from getting updated via props
        const productFeatureFlags = {
            ...this.state.productFeatureFlags,
            ...this.props.productFeatureFlags
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2FwA3.default).Provider, {
            value: {
                ...this.props,
                ...this.state,
                productFeatureFlags: productFeatureFlags
            },
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args), this.addFlag = (props)=>{
            const { type: type, ...rest } = props;
            this.props.addFlag({
                ...rest,
                id: rest.id ? `${rest.id}.${Date.now()}` : Date.now(),
                type: type,
                appearance: 'normal',
                icon: (0, $1yBns.getTypeIcon)(type)
            });
        }, this.push = (path)=>{
            const { contextEntryPoint: contextEntryPoint } = this.props;
            const finalPath = (0, $39CLR.prefixWithContextEntryPoint)(path, contextEntryPoint);
            return this.props.push(finalPath);
        }, this.replace = (path)=>{
            const { contextEntryPoint: contextEntryPoint } = this.props;
            const finalPath = (0, $39CLR.prefixWithContextEntryPoint)(path, contextEntryPoint);
            return this.props.replace(finalPath);
        }, this.state = {
            addFlag: this.addFlag,
            push: this.push,
            replace: this.replace,
            productName: $f7a70e415cdb406b$var$mapAppToProduct(this.props.appName),
            productFeatureFlags: this.props.productFeatureFlags,
            invitePeopleHandlers: this.props.invitePeopleHandlers
        };
    }
}

});
parcelRegister("1yBns", function(module, exports) {

$parcel$export(module.exports, "getTypeIcon", () => $fcb79ae87932a669$export$672f92b0d52b7cfe);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dD7Zc = parcelRequire("dD7Zc");

var $1jWct = parcelRequire("1jWct");

var $c2i4s = parcelRequire("c2i4s");

var $bU3PY = parcelRequire("bU3PY");

const $fcb79ae87932a669$var$flagIconByType = {
    error: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        label: "error123",
        spacing: "spacious",
        color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`
    }),
    warning: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
        label: "warning123",
        spacing: "spacious",
        color: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$c6930421db9fa514)})`
    }),
    info: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1jWct))), {
        label: "info123",
        spacing: "spacious",
        color: `var(--ds-icon-information, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`
    })
};
const $fcb79ae87932a669$var$defaultIcon = /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))), {
    label: "winner123",
    spacing: "spacious",
    color: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$940e1f69e873f202)})`
});
const $fcb79ae87932a669$export$672f92b0d52b7cfe = (type = 'normal')=>$fcb79ae87932a669$var$flagIconByType[type] || $fcb79ae87932a669$var$defaultIcon;

});


parcelRegister("b8wBX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8b08eb533f61d71$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fyzT1 = parcelRequire("fyzT1");
var $iiI2P = parcelRequire("iiI2P");
var $a2luh = parcelRequire("a2luh");
class $f8b08eb533f61d71$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    componentDidCatch(error, errorInfo) {
        const { analytics: analytics, appName: appName } = this.props;
        (0, $a2luh.logException)(error, 'Caught error in ErrorBoundaryApp', {
            info: errorInfo,
            tags: {
                severity: 'high',
                boundary: 'AppRoot'
            }
        });
        analytics.pushOperationalEvent({
            source: (0, $fyzT1.AnalyticsEventSource).CLIENT_METRICS,
            actionSubject: 'errorBoundary',
            action: (0, $fyzT1.AnalyticsEventActions).TRIGGERED,
            attributes: {
                product: appName,
                boundary: 'app',
                error: error.toString()
            },
            tags: [
                'error',
                'error-boundary'
            ]
        });
    }
    render() {
        if (!this.state.hasError) return this.props.children;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iiI2P.GenericErrorPage), {
            hasSupportLink: true
        });
    }
    constructor(...args){
        super(...args), this.state = {
            hasError: false
        };
    }
}

});

parcelRegister("bCUYQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb9099bb66d2e3fe$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fyzT1 = parcelRequire("fyzT1");
var $38ra6 = parcelRequire("38ra6");
var $fff3y = parcelRequire("fff3y");
var $3HUMg = parcelRequire("3HUMg");
var $5WmsO = parcelRequire("5WmsO");

var $fjVRf = parcelRequire("fjVRf");
const $eb9099bb66d2e3fe$var$mapAppNameToProduct = {
    '': 'STANDALONE',
    'site-directory': 'STANDALONE',
    'confluence-directory': 'CONFLUENCE',
    'jira-directory': 'JIRA',
    'teamcentral-directory': 'TOWNSQUARE',
    'home-directory': 'HOME'
};
function $eb9099bb66d2e3fe$export$f07589effd6b0ff3(props) {
    const { appName: appName, children: children } = props;
    const [{ cloudId: cloudId }] = (0, $5WmsO.useSite)();
    const [{ principalUserId: principalUserId }, { getPrincipalUserInfo: getPrincipalUserInfo }] = (0, $fff3y.usePrincipalUser)();
    const analytics = (0, $38ra6.default)();
    const [{ hasLoadedSettings: hasLoadedSettings, hasErrorOnFetchSettings: hasErrorOnFetchSettings, isFetching: isFetching }, { getSettings: getSettings }] = (0, $3HUMg.useSettings)();
    (0, $5uXOq.useEffect)(()=>{
        analytics.startUIViewedEvent(principalUserId);
    }, [
        analytics,
        principalUserId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (hasLoadedSettings) analytics.pushOperationalEvent({
            action: hasErrorOnFetchSettings ? (0, $fyzT1.AnalyticsEventActions).FAILED : (0, $fyzT1.AnalyticsEventActions).SUCCEEDED,
            actionSubject: (0, $fjVRf.SliAnalytics).GetSettings,
            source: (0, $fyzT1.AnalyticsEventSource).DIRECTORY_APP
        });
    }, [
        analytics,
        hasLoadedSettings,
        hasErrorOnFetchSettings
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const product = $eb9099bb66d2e3fe$var$mapAppNameToProduct[appName];
        // currently, cloudId is a required prop of Embedded Directory
        if (!hasLoadedSettings && !isFetching && cloudId) getSettings(product, cloudId);
    }, [
        appName,
        hasLoadedSettings,
        getSettings,
        cloudId,
        isFetching
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // currently, cloudId is a required prop of Embedded Directory
        if (cloudId) getPrincipalUserInfo(cloudId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cloudId
    ]);
    return children;
}
var $eb9099bb66d2e3fe$export$2e2bcd8739ae039 = $eb9099bb66d2e3fe$export$f07589effd6b0ff3;

});
parcelRegister("3HUMg", function(module, exports) {

$parcel$export(module.exports, "useFeatureFlag", () => $3d54c792f0b0e8b2$export$61acb772777ef35d);
$parcel$export(module.exports, "useSettings", () => $3d54c792f0b0e8b2$export$9115b42802a3e44f);

var $bhBxN = parcelRequire("bhBxN");
var $d7tic = parcelRequire("d7tic");
const $3d54c792f0b0e8b2$export$c5cecc6f5d4bab3e = ()=>{
    return true;
};
const $3d54c792f0b0e8b2$export$61acb772777ef35d = (flagName)=>{
    return (0, $bhBxN.useFeatureFlag)(flagName);
};
const $3d54c792f0b0e8b2$export$9115b42802a3e44f = ()=>{
    return (0, $d7tic.useSettings)();
};

});
parcelRegister("bhBxN", function(module, exports) {

$parcel$export(module.exports, "useFeatureFlag", () => $108073b61d0286e6$export$61acb772777ef35d);

var $d7tic = parcelRequire("d7tic");

var $mw4O5 = parcelRequire("mw4O5");
const $108073b61d0286e6$export$61acb772777ef35d = (flag)=>{
    const { productFeatureFlags: productFeatureFlags } = (0, $mw4O5.useAppConfig)();
    const flagValue = (0, $d7tic.useSettingsFeatureFlag)(flag);
    if (productFeatureFlags && productFeatureFlags[flag] !== undefined) return productFeatureFlags[flag];
    return flagValue;
};
const $108073b61d0286e6$export$80200644648c0ee1 = (flagName)=>!!$108073b61d0286e6$export$61acb772777ef35d(flagName);

});


parcelRegister("fjVRf", function(module, exports) {

$parcel$export(module.exports, "SliAnalytics", () => $3f64278d3feeb44b$export$9cb5f615baf57db6);
var $3f64278d3feeb44b$export$9cb5f615baf57db6 = /*#__PURE__*/ function(SliAnalytics) {
    SliAnalytics["GetTeamProfile"] = "GetTeamProfile";
    SliAnalytics["GetTeamMembers"] = "GetTeamMembers";
    SliAnalytics["GetTeamLinks"] = "GetTeamLinks";
    SliAnalytics["TeamSearch"] = "TeamSearch";
    SliAnalytics["AccountCentricUserSearch"] = "AccountCentricUserSearch";
    SliAnalytics["LoadProfileAbout"] = "LoadProfileAbout";
    SliAnalytics["GetSettings"] = "GetSettings";
    return SliAnalytics;
}({});

});




parcelRegister("c9lD2", function(module, exports) {

$parcel$export(module.exports, "createShowFlagHandler", () => $3cf06505514424b8$export$58bf1d914631d59f);

var $5uXOq = parcelRequire("5uXOq");

var $7HGHK = parcelRequire("7HGHK");

var $fG9jT = parcelRequire("fG9jT");
const $3cf06505514424b8$var$FLAG_PTC_ID_DEFAULT = 'ptc-people-directory.flag-id';
const $3cf06505514424b8$export$58bf1d914631d59f = (showFlag, dismissFlag)=>(flagFromPTC)=>{
        const flagType = flagFromPTC.type === 'success' || flagFromPTC.type === 'error' || flagFromPTC.type === 'info' || flagFromPTC.type === 'warning' ? flagFromPTC.type : 'success';
        const flagTitle = flagFromPTC.title;
        const flagDesc = flagFromPTC.description;
        const flagActions = flagFromPTC?.actions;
        showFlag({
            render: ({ key: key })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fG9jT.default), {
                    key: key,
                    id: key || flagFromPTC.id || $3cf06505514424b8$var$FLAG_PTC_ID_DEFAULT,
                    flagType: flagType,
                    title: flagTitle != null ? flagTitle : '',
                    description: flagDesc != null ? flagDesc : '',
                    messageId: `spa-apps-people-profiles.utils.create-show-flag-handler.common-flag.showFlag.${key || flagFromPTC.id || $3cf06505514424b8$var$FLAG_PTC_ID_DEFAULT}`,
                    messageType: "transactional",
                    actions: flagActions,
                    isAutoDismiss: true,
                    onDismissed: (id)=>{
                        dismissFlag((0, $7HGHK.toFlagId)(id));
                    }
                })
        });
    };

});
parcelRegister("fG9jT", function(module, exports) {

$parcel$export(module.exports, "default", () => $874cfd4b776497f7$export$2e2bcd8739ae039);

var $3KRpp = parcelRequire("3KRpp");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$874cfd4b776497f7$export$2e2bcd8739ae039 = (0, $3KRpp.CommonFlag);

});


parcelRegister("fnaRp", function(module, exports) {

$parcel$export(module.exports, "peopleProfilesPageLoad", () => $73adf83f024db228$export$37d218590c0c9938);

var $dGrdR = parcelRequire("dGrdR");
const $73adf83f024db228$export$37d218590c0c9938 = (0, $dGrdR.metrics).pageLoad({
    key: 'people-profiles'
});

});

parcelRegister("2kVZn", function(module, exports) {

$parcel$export(module.exports, "useInvitePeopleModal", () => $19754d69292c31f8$export$b9ec44715ae5ad99);
$parcel$export(module.exports, "InvitePeopleModalContextProvider", () => $19754d69292c31f8$export$496e4f58036bb94d);

var $5uXOq = parcelRequire("5uXOq");

var $fElvF = parcelRequire("fElvF");
var $2JsdQ = parcelRequire("2JsdQ");

var $6s1PB = parcelRequire("6s1PB");

var $dNEo8 = parcelRequire("dNEo8");

var $e5wyW = parcelRequire("e5wyW");
/*
 * When we cleaning up experiment 'jira-invite-people-to-project-modal', this file should be removed.
 * Depending on the success / failure of the expirement we can replace the import of the modal context and hook
 * with the one from the invite-people package or keep using the one from jira-invite-people-modal-context.
 */ const $19754d69292c31f8$var$isJiraInvitePeopleModalEnabled = ()=>{
    const [config] = (0, $6s1PB.UNSAFE_noExposureExp)('jira-invite-people-to-project-modal');
    return config.get('isEnabled', false);
};
// this ensures we only load one instance of the hook
const $19754d69292c31f8$var$useConditionalInvitePeopleModal = (0, $e5wyW.functionWithCondition)(()=>$19754d69292c31f8$var$isJiraInvitePeopleModalEnabled(), ({ resourceAri: resourceAri, onSubmit: onSubmit, ...props })=>(0, $dNEo8.useJiraInvitePeopleModalBound)(props), (0, $2JsdQ.useInvitePeopleModal));
const $19754d69292c31f8$export$b9ec44715ae5ad99 = (props)=>{
    const [, fireExposure] = (0, $6s1PB.UNSAFE_noExposureExp)('jira-invite-people-to-project-modal');
    const { openModal: openModal } = $19754d69292c31f8$var$useConditionalInvitePeopleModal(props);
    const openModalWithExposure = (0, $5uXOq.useCallback)(()=>{
        fireExposure();
        openModal();
    }, [
        openModal,
        fireExposure
    ]);
    return {
        openModal: openModalWithExposure
    };
};
const $19754d69292c31f8$export$496e4f58036bb94d = ({ children: children })=>{
    if ($19754d69292c31f8$var$isJiraInvitePeopleModalEnabled()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dNEo8.JiraInvitePeopleModalContextProvider), {
        renderedInProjectContext: false,
        shouldDisplaySuccessModal: false
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fElvF.InvitePeopleModalContextProvider), null, children);
};

});



//# sourceMappingURL=async-people-profiles-entrypoint.33b4c50c.js.map
